var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/// <reference path="../../webresources/javascript/utils/../crp_libs/020.numeral.min.lib.ts" />
/// <reference path="../../webresources/javascript/utils/../research_portal_libs/ckeditor.d.ts" />
/// <reference path="../../webresources/javascript/generic/../crp_api/04.report.ts" />
/// <reference path="../../webresources/javascript/walletshare/10.card_view/../../crp_utils/06.analytics.ts" />
/// <reference path="../../webresources/javascript/walletshare/10.card_view/../../crp_api/04.report.ts" />
/// <reference path="../../webresources/javascript/walletshare/10.card_view/../../crp_utils/07.changes_enum.ts" />
/// <reference path="../../webresources/javascript/walletshare/12.bi_what-if-scenarios/../../crp_libs/003.highcharts.d.ts" />
/// <reference path="../../webresources/javascript/walletshare/../crp_api/04.report.ts" />
/// <reference path="../../webresources/javascript/walletshare/../crp_utils/06.analytics.ts" />
/// <reference path="../../webresources/javascript/walletshare/../crp_utils/07.changes_enum.ts" />
/// <reference path="../../webresources/javascript/walletshare/46.comp-insights/../../crp_libs/003.highcharts.d.ts" />
/// <reference path="../../webresources/javascript/walletshare/46.comp-insights/../../crp_libs/020.numeral.min.lib.ts" />
var EnvironmentUtilities;
(function (EnvironmentUtilities) {
    var EnvironmentType;
    (function (EnvironmentType) {
        EnvironmentType[EnvironmentType["DESKTOP"] = 1] = "DESKTOP";
        EnvironmentType[EnvironmentType["TABLET"] = 2] = "TABLET";
        EnvironmentType[EnvironmentType["TABLET_LANDSCAPE"] = 3] = "TABLET_LANDSCAPE";
        EnvironmentType[EnvironmentType["TABLET_PORTRAIT"] = 4] = "TABLET_PORTRAIT";
        EnvironmentType[EnvironmentType["MOBILE"] = 5] = "MOBILE";
        EnvironmentType[EnvironmentType["MOBILE_LANDSCAPE"] = 6] = "MOBILE_LANDSCAPE";
        EnvironmentType[EnvironmentType["MOBILE_PORTRAIT"] = 7] = "MOBILE_PORTRAIT";
    })(EnvironmentType || (EnvironmentType = {}));
    var BrowserDetector = (function () {
        function BrowserDetector() {
        }
        BrowserDetector.hasMatchMedia = function () {
            return window.matchMedia !== null && window.matchMedia instanceof Function;
        };
        BrowserDetector.mediaMatches = function (type) {
            if (!this.hasMatchMedia()) {
                switch (type) {
                    /**
                     * Only IE9 Doesnt not implement match media
                     */
                    case EnvironmentType.DESKTOP:
                        return true;
                    default:
                        return false;
                }
            }
            return window.matchMedia(this.getMediaQuery(type)).matches;
        };
        BrowserDetector.getMediaQuery = function (type) {
            switch (type) {
                case EnvironmentType.DESKTOP:
                    return '(min-width: 992px)';
                case EnvironmentType.TABLET:
                    return '(min-width: 768px) and (max-width: 1024px)';
                case EnvironmentType.TABLET_PORTRAIT:
                    return '(min-width: 768px) and (max-width: 1024px) and (orientation: portrait)';
                case EnvironmentType.TABLET_LANDSCAPE:
                    return '(min-width: 768px) and (max-width: 1024px) and (orientation: landscape)';
                case EnvironmentType.MOBILE:
                    return '(max-width: 767px)';
                case EnvironmentType.MOBILE_LANDSCAPE:
                    return '(min-width: 375px) and (max-width: 667px) and (orientation: landscape)';
                case EnvironmentType.MOBILE_PORTRAIT:
                    return '(min-width: 375px) and (max-width: 667px) and (orientation: portrait)';
            }
        };
        BrowserDetector.is = function (type) {
            switch (type) {
                case EnvironmentType.DESKTOP:
                case EnvironmentType.TABLET:
                case EnvironmentType.TABLET_PORTRAIT:
                case EnvironmentType.TABLET_LANDSCAPE:
                case EnvironmentType.MOBILE:
                case EnvironmentType.MOBILE_LANDSCAPE:
                case EnvironmentType.MOBILE_PORTRAIT:
                    return this.mediaMatches(type);
                default:
                    return false;
            }
        };
        BrowserDetector.isDesktop = function () {
            return this.is(EnvironmentType.DESKTOP);
        };
        BrowserDetector.isTablet = function () {
            return this.is(EnvironmentType.TABLET);
        };
        BrowserDetector.isTabletPortrait = function () {
            return this.is(EnvironmentType.TABLET_PORTRAIT);
        };
        BrowserDetector.isTabletLandscape = function () {
            return this.is(EnvironmentType.TABLET_LANDSCAPE);
        };
        BrowserDetector.isMobile = function () {
            return this.is(EnvironmentType.MOBILE);
        };
        BrowserDetector.isMobileLandscape = function () {
            return this.is(EnvironmentType.MOBILE_LANDSCAPE);
        };
        BrowserDetector.isMobilePortrait = function () {
            return this.is(EnvironmentType.MOBILE_LANDSCAPE);
        };
        return BrowserDetector;
    }());
    EnvironmentUtilities.BrowserDetector = BrowserDetector;
})(EnvironmentUtilities || (EnvironmentUtilities = {}));
var Utilities = (function () {
    function Utilities() {
    }
    Utilities.openTab = function (url) {
        window.open(url, '_blank');
    };
    Utilities.openPopup = function (url) {
        open(url, "popup");
    };
    Utilities.redirect = function (url) {
        window.location.href = url;
    };
    Utilities.redirectTop = function (url) {
        window.top.location.href = url;
    };
    Utilities.buildUrlParameters = function (urlParameters, settings) {
        var parameters = new Array();
        settings = settings || Utilities.DEFAULT_URL_PARAMETER_OPTIONS;
        for (var urlParameter in urlParameters) {
            var parameter = new Array();
            if (settings.encode) {
                parameter.push(encodeURIComponent(urlParameter));
                parameter.push(encodeURIComponent(urlParameters[urlParameter]));
            }
            else {
                parameter.push(urlParameter);
                parameter.push(urlParameters[urlParameter]);
            }
            parameters.push(parameter.join('='));
        }
        return settings.mark + parameters.join('&');
    };
    Utilities.openMailClient = function (to, subject, body) {
        var params = {};
        params[Utilities.MAIL_TO_PARAM] = to || '';
        params[Utilities.MAIL_SUBJECT_PARAM] = subject || '';
        params[Utilities.MAIL_BODY_PARAM] = body || '';
        var url = String.format(Utilities.MAIL_TO_URL_FORMAT, this.buildUrlParameters(params));
        if (EnvironmentUtilities.BrowserDetector.isDesktop()) {
            this.openPopup(url);
        }
        else {
            try {
                this.redirectTop(url);
            }
            catch (e) {
                this.redirect(url);
            }
        }
    };
    Utilities.openNewTabWithContent = function (content) {
        window.open().document.write(content);
    };
    Utilities.redirectWithPost = function (url, name, value) {
        var form = window.document.createElement("form");
        var input = window.document.createElement("input");
        input.name = name;
        input.value = value;
        form.appendChild(input);
        form.action = url;
        form.method = 'POST';
        form.setAttribute("target", "_blank");
        document.body.appendChild(form);
        form.submit();
    };
    Utilities.isEmailValid = function (text) {
        var emailValidationRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        text = (text || '').toString();
        if (text.isEmpty()) {
            return false;
        }
        return emailValidationRegex.test(text);
    };
    Utilities.MAIL_TO_URL_FORMAT = 'mailto:{0}';
    Utilities.MAIL_SUBJECT_PARAM = 'subject';
    Utilities.MAIL_BODY_PARAM = 'body';
    Utilities.MAIL_TO_PARAM = 'to';
    Utilities.DEFAULT_URL_PARAMETER_OPTIONS = {
        encode: true,
        mark: '?'
    };
    return Utilities;
}());
var LabelBuilder;
(function (LabelBuilder_1) {
    var LabelBuilder = (function () {
        function LabelBuilder(ignorePositive, ignoreNegative) {
            this.ignorePositive = ignorePositive === undefined ? true : ignorePositive;
            this.ignoreNegative = ignoreNegative === undefined ? false : ignoreNegative;
        }
        LabelBuilder.prototype.getSymbol = function (value) {
            if (value >= 0) {
                if (this.ignorePositive) {
                    return '';
                }
                return '+';
            }
            if (this.ignoreNegative) {
                return '';
            }
            return '-';
        };
        return LabelBuilder;
    }());
    LabelBuilder_1.LabelBuilder = LabelBuilder;
    var MarketShareLabelBuilder = (function (_super) {
        __extends(MarketShareLabelBuilder, _super);
        function MarketShareLabelBuilder(ignorePositive, ignoreNegative, decimalPoints, percentageSymbol) {
            _super.call(this, ignorePositive, ignoreNegative);
            this.decimalPoints = decimalPoints === undefined ? 2 : decimalPoints;
            percentageSymbol = percentageSymbol === undefined ? true : percentageSymbol;
            this.percentageSymbol = percentageSymbol ? '%' : '';
        }
        MarketShareLabelBuilder.prototype.build = function (value) {
            if (value === null)
                value = 0;
            var absValue = Math.abs(value).toFixed(this.decimalPoints) + this.percentageSymbol;
            if (value >= 0) {
                if (this.ignorePositive) {
                    return absValue;
                }
                return '+' + absValue;
            }
            if (this.ignoreNegative) {
                return absValue;
            }
            return '(' + absValue + ')';
        };
        return MarketShareLabelBuilder;
    }(LabelBuilder));
    LabelBuilder_1.MarketShareLabelBuilder = MarketShareLabelBuilder;
    var DecimalRoundIfNeededLabelBuilder = (function (_super) {
        __extends(DecimalRoundIfNeededLabelBuilder, _super);
        function DecimalRoundIfNeededLabelBuilder(ignorePositive, ignoreNegative, decimalPoints) {
            _super.call(this, ignorePositive, ignoreNegative);
            this.decimalPoints = decimalPoints === undefined ? 2 : decimalPoints;
        }
        DecimalRoundIfNeededLabelBuilder.prototype.build = function (value) {
            return this.getSymbol(value) + Number(Math.abs(value).toFixed(this.decimalPoints));
        };
        return DecimalRoundIfNeededLabelBuilder;
    }(LabelBuilder));
    LabelBuilder_1.DecimalRoundIfNeededLabelBuilder = DecimalRoundIfNeededLabelBuilder;
    var SalesLabelBuilder = (function (_super) {
        __extends(SalesLabelBuilder, _super);
        function SalesLabelBuilder(ignorePositive, ignoreNegative, maxRound) {
            _super.call(this, ignorePositive, ignoreNegative);
            this.maxRound = maxRound === undefined ? SalesLabelBuilder.roundGroups.length : maxRound;
            this.maxRound = Math.min(SalesLabelBuilder.roundGroups.length - 1, this.maxRound);
        }
        SalesLabelBuilder.prototype.build = function (value, isFromCompInsights, fixedToOneDecimal) {
            if (isFromCompInsights === void 0) { isFromCompInsights = false; }
            if (fixedToOneDecimal === void 0) { fixedToOneDecimal = false; }
            if (value === null)
                value = 0;
            var i = 0;
            // Shortens the number
            while (i < this.maxRound) {
                var needsToRound = Math.abs(value) > SalesLabelBuilder.ROUND_LIMIT;
                if (!needsToRound) {
                    break;
                }
                value = (value / SalesLabelBuilder.ROUND_LIMIT);
                i++;
            }
            var absValue;
            if (isFromCompInsights && !fixedToOneDecimal) {
                if (typeof value === 'number') {
                    absValue = Number(value.toFixed(2));
                }
            }
            else {
                // let's keep one decimal place if the round group is bigger than million
                if (i > 2) {
                    absValue = Number(value.toFixed(1));
                }
                else {
                    absValue = Math.round(value);
                }
            }
            var isNegative = value < 0;
            if (isFromCompInsights) {
                var decimalValue = fixedToOneDecimal ? Math.abs(absValue) : Math.abs(absValue).toFixed(2);
                if (this.ignoreNegative) {
                    var label = String(decimalValue).replace(SalesLabelBuilder.TRIPLE_NUMBER_MATCHER, SalesLabelBuilder.TRIPLE_NUMBER_COMMA_INSERTER);
                    return this.getSymbol(value) + SalesLabelBuilder.MONEY_SIGN + label + SalesLabelBuilder.compInsightRoundGroups[i];
                }
                else {
                    var label = String(decimalValue).replace(SalesLabelBuilder.TRIPLE_NUMBER_MATCHER, SalesLabelBuilder.TRIPLE_NUMBER_COMMA_INSERTER), lb = SalesLabelBuilder.MONEY_SIGN + label + SalesLabelBuilder.compInsightRoundGroups[i], finalLabel = isNegative ? '(' + lb + ')' : lb;
                    return finalLabel;
                }
            }
            else {
                if (this.ignoreNegative) {
                    var label = String(Math.abs(absValue)).replace(SalesLabelBuilder.TRIPLE_NUMBER_MATCHER, SalesLabelBuilder.TRIPLE_NUMBER_COMMA_INSERTER);
                    return this.getSymbol(value) + SalesLabelBuilder.MONEY_SIGN + label + SalesLabelBuilder.roundGroups[i];
                }
                else {
                    var label = String(Math.abs(absValue)).replace(SalesLabelBuilder.TRIPLE_NUMBER_MATCHER, SalesLabelBuilder.TRIPLE_NUMBER_COMMA_INSERTER), lb = SalesLabelBuilder.MONEY_SIGN + label + SalesLabelBuilder.roundGroups[i], finalLabel = isNegative ? '(' + lb + ')' : lb;
                    return finalLabel;
                }
            }
        };
        SalesLabelBuilder.setRoundGroups = function (roundGroups) {
            SalesLabelBuilder.roundGroups = roundGroups;
        };
        SalesLabelBuilder.TRIPLE_NUMBER_MATCHER = /(\d)(?=(\d\d\d)+(?!\d))/g;
        SalesLabelBuilder.TRIPLE_NUMBER_COMMA_INSERTER = "$1,";
        SalesLabelBuilder.MONEY_SIGN = "$";
        SalesLabelBuilder.roundGroups = ['', 'K', 'M', 'B', 'T'];
        SalesLabelBuilder.compInsightRoundGroups = ['', 'k', 'M', 'B', 'T'];
        SalesLabelBuilder.ROUND_LIMIT = 1000;
        return SalesLabelBuilder;
    }(LabelBuilder));
    LabelBuilder_1.SalesLabelBuilder = SalesLabelBuilder;
    // show everything in millions, requested by Diana
    var CompInsightLabelBuilder = (function (_super) {
        __extends(CompInsightLabelBuilder, _super);
        function CompInsightLabelBuilder() {
            _super.apply(this, arguments);
        }
        CompInsightLabelBuilder.prototype.build = function (value) {
            var finalLabel = "";
            if (value === null) {
                value = 0;
            }
            else {
                value /= 1000000;
                value = Number(value.toFixed(2));
                var internationalNumberFormat = new Intl.NumberFormat('en-US');
                finalLabel = internationalNumberFormat.format(value);
                finalLabel = (value < 0) ? '($' + finalLabel.substring(1) + 'M)' : '$' + finalLabel + 'M';
            }
            return finalLabel;
        };
        return CompInsightLabelBuilder;
    }(LabelBuilder));
    LabelBuilder_1.CompInsightLabelBuilder = CompInsightLabelBuilder;
    var PercentLabelBuilder = (function (_super) {
        __extends(PercentLabelBuilder, _super);
        function PercentLabelBuilder(ignorePositive, ignoreNegative, digits) {
            _super.call(this, ignorePositive, ignoreNegative);
            this.digits = digits === undefined ? 2 : digits;
        }
        PercentLabelBuilder.prototype.build = function (value) {
            var absValue;
            absValue = Number((value * 100).toFixed(this.digits));
            var isNegative = value < 0;
            if (this.ignoreNegative) {
                return this.getSymbol(value) + String(Math.abs(absValue)) + "%";
            }
            else {
                var label = String(Math.abs(absValue)) + '%', finalLabel = isNegative ? '(' + label + ')' : label;
                return finalLabel;
            }
        };
        return PercentLabelBuilder;
    }(LabelBuilder));
    LabelBuilder_1.PercentLabelBuilder = PercentLabelBuilder;
    var RoundNumberLabelBuilder = (function (_super) {
        __extends(RoundNumberLabelBuilder, _super);
        function RoundNumberLabelBuilder(ignorePositive, ignoreNegative) {
            _super.call(this, ignorePositive, ignoreNegative);
        }
        RoundNumberLabelBuilder.prototype.build = function (value) {
            return this.getSymbol(value) + Math.abs(Math.round(value));
        };
        return RoundNumberLabelBuilder;
    }(LabelBuilder));
    LabelBuilder_1.RoundNumberLabelBuilder = RoundNumberLabelBuilder;
    var FullSalesLabelWithCommasBuilder = (function (_super) {
        __extends(FullSalesLabelWithCommasBuilder, _super);
        function FullSalesLabelWithCommasBuilder(ignorePositive, ignoreNegative) {
            _super.call(this, ignorePositive, ignoreNegative);
        }
        FullSalesLabelWithCommasBuilder.prototype.build = function (value) {
            var stringValue = String(Math.abs(Math.floor(value)));
            var normalizedValue;
            var size = stringValue.length;
            for (var i = size; i > 0; i -= 3) {
                var partialNumber = stringValue.substring(i - 3, i);
                if (normalizedValue === undefined) {
                    normalizedValue = partialNumber;
                }
                else {
                    normalizedValue = partialNumber.concat(',').concat(normalizedValue);
                }
            }
            if (this.ignoreNegative) {
                return normalizedValue;
            }
            else {
                return value < 0 ? '(' + normalizedValue + ')' : normalizedValue;
            }
        };
        return FullSalesLabelWithCommasBuilder;
    }(LabelBuilder));
    LabelBuilder_1.FullSalesLabelWithCommasBuilder = FullSalesLabelWithCommasBuilder;
    var SalesBuilderWithNumeral = (function (_super) {
        __extends(SalesBuilderWithNumeral, _super);
        function SalesBuilderWithNumeral(ignorePositive, ignoreNegative, useMinusSignal) {
            _super.call(this, ignorePositive, ignoreNegative);
            this.regex = '$0.0a';
            this.useMinusSignal = false;
            this.useMinusSignal = useMinusSignal === undefined || useMinusSignal === null ? this.useMinusSignal : useMinusSignal;
        }
        SalesBuilderWithNumeral.prototype.setRegex = function (regex) {
            this.regex = regex;
        };
        SalesBuilderWithNumeral.prototype.build = function (value) {
            var normalizedValue = numeral(value).format(this.regex);
            if (this.ignoreNegative) {
                return normalizedValue;
            }
            else {
                if (value < 0 && !this.useMinusSignal) {
                    return '(' + normalizedValue.replace(/-/g, '') + ')';
                }
                else {
                    return normalizedValue;
                }
            }
        };
        return SalesBuilderWithNumeral;
    }(LabelBuilder));
    LabelBuilder_1.SalesBuilderWithNumeral = SalesBuilderWithNumeral;
})(LabelBuilder || (LabelBuilder = {}));
var ColorUtils = (function () {
    function ColorUtils() {
    }
    ColorUtils.converToNumbers = function (hex) {
        var particles = hex.match(ColorUtils.HEX_PARTICLE_SPLITTER);
        return particles.map(function (particle) { return parseInt(particle, 16); });
    };
    ColorUtils.merge = function (base, to, completed) {
        var toComplete = 1 - completed;
        var output = base * toComplete + to * completed;
        return Math.round(output);
    };
    ColorUtils.convertToHex = function (n) {
        return ('00' + n.toString(16)).substr(-2);
    };
    ColorUtils.calcColorGradient = function (base, destination, completed) {
        if (!base || base.length !== 6 ||
            !destination || destination.length !== 6 ||
            completed < 0 || completed > 1) {
            return null;
        }
        var fromParticles = this.converToNumbers(base);
        var toParticles = this.converToNumbers(destination);
        var out = '';
        for (var i = 0; i < fromParticles.length; ++i) {
            out += ColorUtils.convertToHex(ColorUtils.merge(fromParticles[i], toParticles[i], completed));
        }
        return out;
    };
    ColorUtils.hexToRGBA = function (hex, opacity) {
        if (opacity === undefined) {
            opacity = 1;
        }
        if (!hex || hex.length !== 6 || (opacity < 0 || opacity > 1)) {
            return null;
        }
        var particles = this.converToNumbers(hex);
        particles.push(opacity);
        return String.format('rgba({0})', particles.join(','));
    };
    ColorUtils.HEX_PARTICLE_SPLITTER = /.{2,2}/g;
    return ColorUtils;
}());
var WalletShareUtils;
(function (WalletShareUtils) {
    var SortableGrid = (function () {
        function SortableGrid(wrapper) {
            this.wrapper = wrapper;
            this.fullList = this.wrapper.find('.wallet-share-sortable-grid-list').first();
            this.customList = this.wrapper.find('.wallet-share-sortable-grid-list').last();
            this.showSpinner(true);
            this.addEventListener();
        }
        SortableGrid.prototype.addEventListener = function () {
            var remove = this.wrapper.find('.wallet-share-sortable-grid-remove-button');
            remove.click(function () {
                $(this).parent().prev().val('').keyup();
            });
            var lists = this.wrapper.find('.wallet-share-sortable-grid-search-input');
            this.createSearchFunctionality(this.fullList, lists.first());
            this.createSearchFunctionality(this.customList, lists.last());
        };
        SortableGrid.prototype.sortableListener = function () {
            var sortableObj = {
                containment: 'document',
                connectWith: '.wallet-share-sortable-grid-list',
                cancel: '.wallet-share-sortable-grid-spinner-list, .wallet-share-sortable-grid-list-transfer'
            };
            this.fullList.sortable(sortableObj).disableSelection();
            this.customList.sortable(sortableObj).disableSelection();
        };
        SortableGrid.prototype.createSearchFunctionality = function (list, input) {
            input.unbind();
            input.keyup(function () {
                var filter = input.val().toLowerCase();
                for (var i = 0; i < list.children().length; i++) {
                    var name = list.children().eq(i).html();
                    if (name.toLowerCase().indexOf(filter) === -1) {
                        list.children().eq(i).hide();
                    }
                    else {
                        list.children().eq(i).show();
                    }
                }
            });
        };
        SortableGrid.prototype.createSpinner = function () {
            var wrapper = jQuery('<div/>', { 'class': 'text-center' });
            var spinner = jQuery('<i/>', { 'class': 'fa fa-cog fa-spin wallet-share-sortable-grid-spinner-list' });
            return wrapper.append(spinner);
        };
        SortableGrid.prototype.showSpinner = function (isHidden) {
            if (!isHidden) {
                this.fullList.html('');
                this.customList.html('');
            }
            else {
                this.fullList.append(this.createSpinner());
                this.customList.append(this.createSpinner());
            }
        };
        SortableGrid.prototype.createOptions = function (data, selectedData) {
            var self = this;
            data.sort(function (curr, next) {
                return curr > next ? 1 : -1;
            }).forEach(function (current) {
                var transfer = jQuery('<span/>', { 'class': 'glyphicon glyphicon-transfer wallet-share-sortable-grid-list-transfer' });
                transfer.click(function () {
                    var isChildOfCustomList = self.customList.find("[data-name='" + current + "']").isEmpty();
                    if (!isChildOfCustomList) {
                        var element = self.customList.find("[data-name='" + current + "']");
                        self.fullList.prepend(element);
                    }
                    else {
                        var element = self.fullList.find("[data-name='" + current + "']");
                        self.customList.prepend(element);
                        element.hide();
                        element.fadeIn(200);
                    }
                });
                var name = jQuery('<div/>', { 'class': 'text-overflow pull-left wallet-share-sortable-grid-list-element', 'text': current, 'title': current });
                var li = jQuery('<li/>', { 'class': 'grabbable open-sans', 'data-name': current });
                self.fullList.append(li.append(name, transfer));
            });
            if (selectedData !== null) {
                selectedData.forEach(function (option) {
                    self.customList.append(self.fullList.find("[data-name='" + option + "']"));
                });
            }
            this.sortableListener();
        };
        SortableGrid.prototype.showError = function (hasError) {
            if (hasError) {
                this.customList.addClass('wallet-share-sortable-grid-error');
            }
            else {
                this.customList.removeClass('wallet-share-sortable-grid-error');
            }
        };
        SortableGrid.prototype.feed = function (data, selectedData) {
            this.showSpinner(false);
            this.createOptions(data, selectedData);
        };
        SortableGrid.prototype.getOptionsFromCustomList = function () {
            var options = new Array();
            var self = this;
            this.customList.children().each(function (k) {
                var option = self.customList.children().eq(k).data('name');
                options.push(option);
            });
            return options;
        };
        return SortableGrid;
    }());
    WalletShareUtils.SortableGrid = SortableGrid;
})(WalletShareUtils || (WalletShareUtils = {}));
var HttpRequester = (function () {
    function HttpRequester() {
    }
    HttpRequester.requestForJson = function (httpMethod, url, params) {
        var deferred = jQuery.Deferred();
        jQuery.ajax({
            'method': httpMethod,
            'url': url,
            'data': params,
            'contentType': 'application/json',
            'dataType': 'json'
        }).then(function (response) {
            deferred.resolveWith(window, [response.data]);
        }).fail(function (response) {
            deferred.reject();
        });
        return deferred.promise();
    };
    HttpRequester.requestWithJson = function (httpMethod, url, params) {
        return jQuery.ajax({
            'method': httpMethod,
            'url': url,
            'data': params,
            'contentType': 'application/json',
        })
            .promise();
    };
    HttpRequester.simplePost = function (url) {
        var deferred = jQuery.Deferred();
        jQuery.post(url)
            .then(function () {
            deferred.resolve();
        })
            .fail(function () {
            deferred.reject();
        });
        return deferred.promise();
    };
    return HttpRequester;
}());
var dimensions;
var salesDimension;
var WalletShare;
(function (WalletShare) {
    //enums for pages to go from the dashboard aka 'product groups'
    (function (LicensingProductGroup) {
        LicensingProductGroup[LicensingProductGroup["DISTRIBUTION_INTELLIGENCE"] = 1] = "DISTRIBUTION_INTELLIGENCE";
        LicensingProductGroup[LicensingProductGroup["RESEARCH"] = 2] = "RESEARCH";
        LicensingProductGroup[LicensingProductGroup["RESOURCE_CENTER"] = 3] = "RESOURCE_CENTER";
    })(WalletShare.LicensingProductGroup || (WalletShare.LicensingProductGroup = {}));
    var LicensingProductGroup = WalletShare.LicensingProductGroup;
})(WalletShare || (WalletShare = {}));
var Context;
(function (Context) {
})(Context || (Context = {}));
var SalesContext;
(function (SalesContext_1) {
    var SalesContext = (function () {
        function SalesContext() {
        }
        SalesContext.prototype.getSalesContextUrl = function () {
            return SalesContext.SALES_CONTEXT_SERVICE_URL;
        };
        SalesContext.prototype.salesContextRequest = function (payload) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var url = this.getSalesContextUrl();
            var salesContextRequest = jQuery.ajax({
                'method': 'POST',
                'url': url,
                'data': JSON.stringify(payload),
                'contentType': 'application/json',
                'dataType': 'json'
            }).then(function (response) {
                deferred.resolveWith(window, [response.data]);
            }).fail(function () {
                deferred.reject();
            });
            return promise;
        };
        SalesContext.SALES_CONTEXT_SERVICE_URL = '/contextSales';
        return SalesContext;
    }());
    SalesContext_1.SalesContext = SalesContext;
})(SalesContext || (SalesContext = {}));
var PermissionManager;
(function (PermissionManager) {
    var ProductsPermissionManager = (function () {
        function ProductsPermissionManager() {
            this.products = null;
            this.templatePermissions = null;
            this.hashProducts = {};
            this.hashTemplates = {};
        }
        ProductsPermissionManager.prototype.getPermission = function (productName) {
            if (this.products === null) {
                return false;
            }
            return this.hashProducts[productName] === undefined ? false : this.hashProducts[productName];
        };
        ProductsPermissionManager.prototype.getTemplatePermission = function (templateName) {
            if (this.templatePermissions === null) {
                return false;
            }
            return this.hashTemplates[templateName] === undefined ? false : this.hashTemplates[templateName];
        };
        ProductsPermissionManager.prototype.setProducts = function (products) {
            var _this = this;
            this.products = products;
            this.products.forEach(function (product) {
                _this.hashProducts[product] = true;
            });
        };
        ProductsPermissionManager.prototype.setTemplates = function (templates) {
            var _this = this;
            this.templatePermissions = templates;
            this.templatePermissions.forEach(function (template) {
                _this.hashTemplates[template] = true;
            });
        };
        ProductsPermissionManager.prototype.hasTemplateProduct = function (templateName) {
            return this.getTemplatePermission(templateName);
        };
        ProductsPermissionManager.prototype.hasAdvisorProduct = function () {
            return this.getPermission(ProductsPermissionManager.ADVISOR_PRODUCT_NAME);
        };
        ProductsPermissionManager.prototype.hasTeamProduct = function () {
            return this.getPermission(ProductsPermissionManager.TEAM_PRODUCT_NAME);
        };
        ProductsPermissionManager.prototype.hasDistributionIntelligenceProduct = function () {
            return this.getPermission(ProductsPermissionManager.DISTRIBUTION_INTELLIGENCE_PRODUCT_NAME);
        };
        ProductsPermissionManager.prototype.hasAltsProduct = function () {
            return this.getPermission(ProductsPermissionManager.ALTS_PRODUCT_NAME);
        };
        ProductsPermissionManager.prototype.hasAltsTemplateProduct = function () {
            return this.getTemplatePermission(ProductsPermissionManager.ALTS_PRODUCT_NAME);
        };
        ProductsPermissionManager.prototype.hasDecisionMakerProduct = function () {
            return this.getPermission(ProductsPermissionManager.DECISION_MAKER);
        };
        ProductsPermissionManager.prototype.hasAltsOnlyProduct = function () {
            return this.getPermission(ProductsPermissionManager.ALTS_ONLY_PRODUCT_NAME);
        };
        ProductsPermissionManager.prototype.hasAdvisorTeamsDeepDiveProduct = function () {
            return this.getTemplatePermission(ProductsPermissionManager.ADVISOR_TEAMS_DEEP_DIVE);
        };
        ProductsPermissionManager.prototype.hasGreenSpace3Product = function () {
            return this.getPermission(ProductsPermissionManager.GREEN_SPACE_ADMIN_3);
        };
        ProductsPermissionManager.prototype.hasGreenSpace6Product = function () {
            return this.getPermission(ProductsPermissionManager.GREEN_SPACE_ADMIN_6);
        };
        ProductsPermissionManager.prototype.hasTeamsOverviewProduct = function () {
            return this.getTemplatePermission(ProductsPermissionManager.TEAMS_OVERVIEW);
        };
        ProductsPermissionManager.prototype.hasOfficeDetailsAdvisorTeamsTabProduct = function () {
            return this.getTemplatePermission(ProductsPermissionManager.OFFICE_DETAILS_ADVISOR_TEAMS_TAB);
        };
        ProductsPermissionManager.prototype.hasTeamsInCategoryProduct = function () {
            return this.getTemplatePermission(ProductsPermissionManager.TOP_TEAMS_IN_CATEGORY);
        };
        ProductsPermissionManager.prototype.hasShowAdvisorTeamsProduct = function () {
            return this.getTemplatePermission(ProductsPermissionManager.SHOW_ADVISOR_TEAMS);
        };
        ProductsPermissionManager.prototype.hasOppScoreAdvisorTeamsProduct = function () {
            return this.getTemplatePermission(ProductsPermissionManager.OPPORTUNITY_SCORE_ADVISOR_TEAMS);
        };
        ProductsPermissionManager.prototype.hasSeismicProduct = function () {
            return this.getPermission(ProductsPermissionManager.SEISMIC_PRODUCT_NAME);
        };
        ProductsPermissionManager.prototype.hasAdvisorDeepDiveProduct = function () {
            return this.getTemplatePermission(ProductsPermissionManager.ADVISOR_DEEP_DIVE);
        };
        ProductsPermissionManager.prototype.hasAdvisorDetailProduct = function () {
            return this.getTemplatePermission(ProductsPermissionManager.ADVISOR_DETAIL);
        };
        ProductsPermissionManager.prototype.hasAdvisorFactSheetProduct = function () {
            return this.getTemplatePermission(ProductsPermissionManager.ADVISOR_FACTSHEET_PDF);
        };
        ProductsPermissionManager.prototype.hasOfficeFactSheetProduct = function () {
            return this.getTemplatePermission(ProductsPermissionManager.OFFICE_FACTSHEET_PDF);
        };
        ProductsPermissionManager.prototype.hasAdvisorTeamFactSheetProduct = function () {
            return this.getTemplatePermission(ProductsPermissionManager.ADVISOR_TEAM_FACTSHEET_PDF);
        };
        ProductsPermissionManager.PERMISSION_PARAMETER = 'PERMISSION_PARAMETER';
        ProductsPermissionManager.TEMPLATE_PERMISSION_PARAMETER = 'TEMPLATE_PERMISSION_PARAMETER';
        ProductsPermissionManager.ADVISOR_PRODUCT_NAME = 'Advisor';
        ProductsPermissionManager.TEAM_PRODUCT_NAME = 'Advisor Team';
        ProductsPermissionManager.DISTRIBUTION_INTELLIGENCE_PRODUCT_NAME = 'Distribution Intelligence';
        ProductsPermissionManager.SEISMIC_PRODUCT_NAME = 'Seismic Basic';
        ProductsPermissionManager.ALTS_PRODUCT_NAME = 'Alternatives';
        ProductsPermissionManager.ALTS_ONLY_PRODUCT_NAME = 'Alts Only';
        ProductsPermissionManager.DECISION_MAKER = 'Decision Maker';
        ProductsPermissionManager.GREEN_SPACE_ADMIN_3 = 'GS Admin (3)';
        ProductsPermissionManager.GREEN_SPACE_ADMIN_6 = 'GS Admin (6)';
        ProductsPermissionManager.SHOW_TOP_ADVISORS = 'Show Top Advisors';
        ProductsPermissionManager.ADVISOR_DETAIL = 'Advisor Detail';
        ProductsPermissionManager.CATEGORY_ADVISORS = 'Top Advisors in Category';
        ProductsPermissionManager.OPP_SCORE_ADVISORS = 'Opportunity Score - Advisors';
        ProductsPermissionManager.ADVISOR_DEEP_DIVE = 'Advisor Deep Dive';
        ProductsPermissionManager.ADVISOR_FACTSHEET_PDF = 'Advisor Fact Sheet PDF';
        ProductsPermissionManager.OFFICE_FACTSHEET_PDF = 'Office Fact Sheet PDF';
        ProductsPermissionManager.ADVISOR_TEAM_FACTSHEET_PDF = 'Advisor Teams Fact Sheet PDF';
        // Deep Dive - Advisor Teams permissions
        ProductsPermissionManager.ADVISOR_TEAMS_DEEP_DIVE = 'Advisor Teams Deep Dive';
        ProductsPermissionManager.TEAMS_OVERVIEW = 'Teams Overview';
        ProductsPermissionManager.OFFICE_DETAILS_ADVISOR_TEAMS_TAB = 'Advisor Teams';
        ProductsPermissionManager.TOP_TEAMS_IN_CATEGORY = 'Top Teams in Category';
        ProductsPermissionManager.SHOW_ADVISOR_TEAMS = 'Show Advisor Teams';
        ProductsPermissionManager.OPPORTUNITY_SCORE_ADVISOR_TEAMS = 'Opportunity Score - Advisor Teams';
        return ProductsPermissionManager;
    }());
    PermissionManager.ProductsPermissionManager = ProductsPermissionManager;
})(PermissionManager || (PermissionManager = {}));
var BrowserDetector;
(function (BrowserDetector) {
    var BrowserDetectorManager = (function () {
        function BrowserDetectorManager() {
            this.devices = [
                BrowserDetectorManager.MOBILE_DEVICE_PARAMETER,
                BrowserDetectorManager.MOBILE_DEVICE_LANDSCAPE_PARAMETER,
                BrowserDetectorManager.MOBILE_DEVICE_PORTRAIT_PARAMETER,
                BrowserDetectorManager.TABLET_DEVICE_PARAMETER,
                BrowserDetectorManager.TABLET_PORTRAIT_DEVICE_PARAMETER,
                BrowserDetectorManager.TABLET_LANDSCAPE_DEVICE_PARAMETER,
                BrowserDetectorManager.DESKTOP_DEVICE_PARAMETER
            ];
            this.devicesHash = {};
        }
        BrowserDetectorManager.prototype.getDevice = function (device) {
            return this.devicesHash[device] === undefined ? false : this.devicesHash[device];
        };
        BrowserDetectorManager.prototype.getDevices = function () {
            var _this = this;
            var devices = new Array();
            Object.keys(this.devicesHash).forEach(function (device) {
                if (_this.devicesHash[device]) {
                    devices.push(device.toLowerCase());
                }
            });
            return devices;
        };
        BrowserDetectorManager.prototype.setDevice = function (device, used) {
            if (this.devices.contains(device)) {
                this.devicesHash[device] = used;
            }
        };
        BrowserDetectorManager.prototype.isMobile = function () {
            return this.getDevice(BrowserDetectorManager.MOBILE_DEVICE_PARAMETER);
        };
        BrowserDetectorManager.prototype.isMobileLandscape = function () {
            return this.getDevice(BrowserDetectorManager.MOBILE_DEVICE_LANDSCAPE_PARAMETER);
        };
        BrowserDetectorManager.prototype.isMobilePortrait = function () {
            return this.getDevice(BrowserDetectorManager.MOBILE_DEVICE_PORTRAIT_PARAMETER);
        };
        BrowserDetectorManager.prototype.isTablet = function () {
            return this.getDevice(BrowserDetectorManager.TABLET_DEVICE_PARAMETER);
        };
        BrowserDetectorManager.prototype.isTabletPortrait = function () {
            return this.getDevice(BrowserDetectorManager.TABLET_PORTRAIT_DEVICE_PARAMETER);
        };
        BrowserDetectorManager.prototype.isTabletLandscape = function () {
            return this.getDevice(BrowserDetectorManager.TABLET_LANDSCAPE_DEVICE_PARAMETER);
        };
        BrowserDetectorManager.prototype.isDesktop = function () {
            return this.getDevice(BrowserDetectorManager.DESKTOP_DEVICE_PARAMETER);
        };
        BrowserDetectorManager.MOBILE_DEVICE_PARAMETER = 'MOBILE_DEVICE_PARAMETER';
        BrowserDetectorManager.MOBILE_DEVICE_LANDSCAPE_PARAMETER = 'MOBILE_DEVICE_LANDSCAPE_PARAMETER';
        BrowserDetectorManager.MOBILE_DEVICE_PORTRAIT_PARAMETER = 'MOBILE_DEVICE_PORTRAIT_PARAMETER';
        BrowserDetectorManager.TABLET_DEVICE_PARAMETER = 'TABLET_DEVICE_PARAMETER';
        BrowserDetectorManager.TABLET_PORTRAIT_DEVICE_PARAMETER = 'TABLET_PORTRAIT_DEVICE_PARAMETER';
        BrowserDetectorManager.TABLET_LANDSCAPE_DEVICE_PARAMETER = 'TABLET_LANDSCAPE_DEVICE_PARAMETER';
        BrowserDetectorManager.DESKTOP_DEVICE_PARAMETER = 'DESKTOP_DEVICE_PARAMETER';
        return BrowserDetectorManager;
    }());
    BrowserDetector.BrowserDetectorManager = BrowserDetectorManager;
})(BrowserDetector || (BrowserDetector = {}));
var ReportBuilder;
(function (ReportBuilder) {
    var ReportManager = (function () {
        function ReportManager() {
        }
        ReportManager.prototype.resumeAutomaticUpdatesAsync = function () {
            return this.report.resumeAutomaticUpdatesAsync();
        };
        ReportManager.prototype.pauseAutomaticUpdatesAsync = function () {
            return this.report.pauseAutomaticUpdatesAsync();
        };
        ReportManager.prototype.applyFilterAsync = function (filterName, filterOptions) {
            return this.report.applyFilterAsync(filterName, filterOptions);
        };
        ReportManager.prototype.changeParameterValueAsync = function (parameterName, pamaterValue) {
            return this.report.changeParameterValueAsync(parameterName, pamaterValue);
        };
        ReportManager.prototype.getActiveSheetName = function () {
            return this.report.getActiveSheet().getName();
        };
        ReportManager.prototype.analytics = function (handler) {
            this.report.analytics(handler);
        };
        ReportManager.prototype.onChange = function (handler) {
            this.report.onChange(function (e) {
                handler(e);
            });
        };
        return ReportManager;
    }());
})(ReportBuilder || (ReportBuilder = {}));
;
var PasswordRules;
(function (PasswordRules) {
    var Rule = (function () {
        function Rule() {
        }
        return Rule;
    }());
    PasswordRules.Rule = Rule;
    var AtLeast8Characters = (function (_super) {
        __extends(AtLeast8Characters, _super);
        function AtLeast8Characters() {
            _super.apply(this, arguments);
        }
        AtLeast8Characters.prototype.isPasswordValid = function (passwordText) {
            return passwordText.length >= 8;
        };
        return AtLeast8Characters;
    }(Rule));
    PasswordRules.AtLeast8Characters = AtLeast8Characters;
    var Numeric = (function (_super) {
        __extends(Numeric, _super);
        function Numeric() {
            _super.apply(this, arguments);
        }
        Numeric.prototype.isPasswordValid = function (passwordText) {
            return passwordText.match(".*\\d+.*") !== null;
        };
        return Numeric;
    }(Rule));
    PasswordRules.Numeric = Numeric;
    var UpperCase = (function (_super) {
        __extends(UpperCase, _super);
        function UpperCase() {
            _super.apply(this, arguments);
        }
        UpperCase.prototype.isPasswordValid = function (passwordText) {
            return passwordText.match("[A-Z]") !== null;
        };
        return UpperCase;
    }(Rule));
    PasswordRules.UpperCase = UpperCase;
    var LowerCase = (function (_super) {
        __extends(LowerCase, _super);
        function LowerCase() {
            _super.apply(this, arguments);
        }
        LowerCase.prototype.isPasswordValid = function (passwordText) {
            return passwordText.match("[a-z]") !== null;
        };
        return LowerCase;
    }(Rule));
    PasswordRules.LowerCase = LowerCase;
    var NonAlphaNumeric = (function (_super) {
        __extends(NonAlphaNumeric, _super);
        function NonAlphaNumeric() {
            _super.apply(this, arguments);
        }
        NonAlphaNumeric.prototype.isPasswordValid = function (passwordText) {
            return passwordText.match("^.*(?=[^a-zA-Z0-9 ])(?=[\u0000-\u00ff]).*$") !== null;
        };
        return NonAlphaNumeric;
    }(Rule));
    PasswordRules.NonAlphaNumeric = NonAlphaNumeric;
    var Unicode = (function (_super) {
        __extends(Unicode, _super);
        function Unicode() {
            _super.apply(this, arguments);
        }
        Unicode.prototype.isPasswordValid = function (passwordText) {
            return passwordText.match("[^\u0000-\u00ff]") !== null;
        };
        return Unicode;
    }(Rule));
    PasswordRules.Unicode = Unicode;
})(PasswordRules || (PasswordRules = {}));
var PasswordManager;
(function (PasswordManager) {
    var PasswordValidation = (function () {
        function PasswordValidation() {
            this.mandatoryRules = new Array();
            this.mandatoryRules.push(new PasswordRules.AtLeast8Characters());
            this.nonMandatoryRules = new Array();
            this.nonMandatoryRules.push(new PasswordRules.Numeric());
            this.nonMandatoryRules.push(new PasswordRules.LowerCase());
            this.nonMandatoryRules.push(new PasswordRules.UpperCase());
            this.nonMandatoryRules.push(new PasswordRules.NonAlphaNumeric());
            this.nonMandatoryRules.push(new PasswordRules.Unicode());
        }
        PasswordValidation.prototype.isPasswordValid = function (password) {
            if (!this.isMandatoryValid(password)) {
                return false;
            }
            return this.isNonMandatoryValid(password);
        };
        PasswordValidation.prototype.isMandatoryValid = function (password) {
            return this.mandatoryRules.some(function (rule) {
                return rule.isPasswordValid(password);
            });
        };
        PasswordValidation.prototype.isNonMandatoryValid = function (password) {
            var count = 0;
            this.nonMandatoryRules.forEach(function (rule) {
                if (rule.isPasswordValid(password)) {
                    count++;
                }
            });
            return count >= PasswordValidation.MINIMUM_NONMANDATORY_RULES;
        };
        PasswordValidation.MINIMUM_NONMANDATORY_RULES = 3;
        return PasswordValidation;
    }());
    PasswordManager.PasswordValidation = PasswordValidation;
})(PasswordManager || (PasswordManager = {}));
$(document).ready(function () {
    $('.logout-btn').click(function () {
        sessionStorage.removeItem('chatbotHistory');
        sessionStorage.removeItem('section');
        sessionStorage.removeItem('firmData');
        Analytics.registerLogoutEvent();
    });
});
var Dashboard;
(function (Dashboard) {
    var ArgsParser = (function () {
        function ArgsParser(vo) {
        }
        ArgsParser.prototype.parse = function (hash) {
            var matches = hash.match(ArgsParser.HASH_PATTERN);
            if (matches === null || matches.length !== ArgsParser.EXPECTED_MATCHES_SIZE) {
                return ArgsParser.DEFAULT_ARGS;
            }
            return {
                group: matches[ArgsParser.GROUP_ID_POSITION],
                sectionArgs: matches[ArgsParser.SECTION_ARGS_POSITION] || null
            };
        };
        ArgsParser.buildHashPattern = function () {
            var products = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                products[_i - 0] = arguments[_i];
            }
            // conver enum to string list
            var groups = products.map(function (product) { return WalletShare.LicensingProductGroup[product]; });
            return String.format(ArgsParser.BASE_TEMPLATE, groups.join(ArgsParser.ALTERNATIVE_MARKUP));
        };
        ArgsParser.BASE_TEMPLATE = '#{0,1}({0})(.*)';
        ArgsParser.ALTERNATIVE_MARKUP = '|';
        /**
         * If any other product groups get added, they need to be added here too
         */
        ArgsParser.HASH_PATTERN = ArgsParser.buildHashPattern(WalletShare.LicensingProductGroup.DISTRIBUTION_INTELLIGENCE, WalletShare.LicensingProductGroup.RESEARCH, WalletShare.LicensingProductGroup.RESOURCE_CENTER);
        ArgsParser.GROUP_ID_POSITION = 1;
        ArgsParser.SECTION_ARGS_POSITION = 2;
        ArgsParser.EXPECTED_MATCHES_SIZE = 3;
        ArgsParser.DEFAULT_ARGS = { group: null, sectionArgs: null };
        return ArgsParser;
    }());
    Dashboard.ArgsParser = ArgsParser;
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var DesktopTab = (function () {
        function DesktopTab(id, label) {
            this.id = id;
            this.selected = false;
            this.wrapper = jQuery('<li/>', { 'class': 'home-tab-menu-item open-sans', 'data-toggle': 'tab' });
            this.wrapper.append(jQuery('<a/>', { 'href': '#', 'text': label }));
            this.addListeners();
        }
        DesktopTab.prototype.html = function () {
            return this.wrapper;
        };
        DesktopTab.prototype.setSelected = function (selected) {
            if (selected) {
                this.wrapper.tab('show');
            }
            else {
                this.wrapper.tab('hide');
            }
        };
        DesktopTab.prototype.onShown = function (handler) {
            this.wrapper.on('shown.bs.tab', handler);
        };
        DesktopTab.prototype.onHidden = function (handler) {
            this.wrapper.on('hidden.bs.tab', handler);
        };
        DesktopTab.prototype.addListeners = function () {
            var _this = this;
            this.onShown(function () { _this.selected = true; });
            this.onHidden(function () { _this.selected = false; });
        };
        DesktopTab.prototype.getId = function () {
            return this.id;
        };
        DesktopTab.prototype.isSelected = function () {
            return this.wrapper.hasClass("active");
        };
        return DesktopTab;
    }());
    var DesktopTabManager = (function () {
        function DesktopTabManager(wrapper) {
            this.wrapper = wrapper;
            this.changeHandlers = new ListenersCollection();
            this.reselectedHandlers = new ListenersCollection();
            this.currentTab = null;
        }
        DesktopTabManager.prototype.initialize = function (vo, args, sectionsHash) {
            var _this = this;
            var tabsWrapper = this.wrapper.find('.company-product-groups-tab-wrapper');
            //determine permissioning for each group aka dist int, research portal, resource portal
            this.tabs = vo.productGroups.map(function (group) {
                if (!sectionsHash[group]) {
                    return null;
                }
                return new DesktopTab(group, vo.productGroupLabels[group]);
            }).filter(function (tab) { return tab !== null; }); //return non-null tabs
            //get label for each group
            tabsWrapper.append(this.tabs.map(function (tab) { return tab.html(); }));
            //set first group tab as the selected tab
            var selectedTab = this.tabs.single(function (tab) { return tab.getId() === args.group; }) || this.tabs.first();
            selectedTab.setSelected(true);
            //set handler for being clicked on
            this.tabs.forEach(function (tab) {
                tab.onShown(function () {
                    _this.triggerChange();
                });
            });
            //set selected tab
            this.triggerChange();
        };
        DesktopTabManager.prototype.triggerChange = function () {
            var newTab = this.tabs.single(function (tab) { return tab.isSelected(); });
            if (this.currentTab === newTab) {
                this.reselectedHandlers.execute(this, []);
            }
            else {
                this.currentTab = newTab;
                this.changeHandlers.execute(this, []);
            }
        };
        DesktopTabManager.prototype.onChange = function (handler) {
            this.changeHandlers.addEventListener(handler);
        };
        DesktopTabManager.prototype.onReselected = function (handler) {
            this.reselectedHandlers.addEventListener(handler);
        };
        DesktopTabManager.prototype.getGroup = function () {
            return this.currentTab.getId();
        };
        DesktopTabManager.prototype.setGroup = function (group) {
            var option = this.tabs.single(function (option) { return option.getId() === group; }) || null;
            if (option !== null) {
                option.setSelected(true);
                this.triggerChange();
            }
        };
        return DesktopTabManager;
    }());
    Dashboard.DesktopTabManager = DesktopTabManager;
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var MobileOption = (function () {
        function MobileOption(id, label) {
            this.id = id;
            this.label = label;
            this.selected = false;
            this.wrapper = jQuery('<li/>');
            this.wrapper.append(jQuery('<a/>', { 'href': '#', 'text': label }));
            this.selectedHandler = new ListenersCollection();
            this.addListeners();
        }
        MobileOption.prototype.addListeners = function () {
            var _this = this;
            this.wrapper.click(function () {
                _this.setSelected(true);
            });
        };
        MobileOption.prototype.html = function () {
            return this.wrapper;
        };
        MobileOption.prototype.getId = function () {
            return this.id;
        };
        MobileOption.prototype.getLabel = function () {
            return this.label;
        };
        MobileOption.prototype.onSelected = function (handler) {
            this.selectedHandler.addEventListener(handler);
        };
        MobileOption.prototype.setSelected = function (select) {
            this.selected = select;
            if (select) {
                this.selectedHandler.execute(this, []);
            }
            if (select) {
                this.wrapper.addClass(MobileOption.ACTIVE_CSS_CLASS);
            }
            else {
                this.wrapper.removeClass(MobileOption.ACTIVE_CSS_CLASS);
            }
        };
        MobileOption.prototype.isSelected = function () {
            return this.selected;
        };
        MobileOption.ACTIVE_CSS_CLASS = 'active';
        return MobileOption;
    }());
    var MobileTabManager = (function () {
        function MobileTabManager(wrapper) {
            this.wrapper = wrapper;
            this.label = wrapper.find('.company-product-dropdown-label');
            this.menu = wrapper.find('.company-product-groups-options-wrapper');
            this.changeHandlers = new ListenersCollection();
            this.reselectedHandlers = new ListenersCollection();
        }
        MobileTabManager.prototype.initialize = function (vo, args, sectionsHash) {
            this.options = vo.productGroups.map(function (group) {
                if (!sectionsHash[group]) {
                    return null;
                }
                return new MobileOption(group, vo.productGroupLabels[group]);
            }).filter(function (tab) { return tab !== null; });
            this.menu.append(this.options.map(function (option) { return option.html(); }));
            this.addEventListeners();
            var currentOption = this.options.single(function (option) { return option.getId() === args.group; }) || this.options.first();
            currentOption.setSelected(true);
        };
        MobileTabManager.prototype.addEventListeners = function () {
            var _this = this;
            this.options.forEach(function (option) {
                option.onSelected(function () {
                    _this.select(option);
                });
            });
            this.onChange(function () {
                _this.options.forEach(function (option) {
                    option.setSelected(option === _this.currentOption);
                });
            });
        };
        MobileTabManager.prototype.select = function (option) {
            if (this.currentOption === option) {
                this.reselectedHandlers.execute(this, []);
                return;
            }
            this.currentOption = option;
            // Update label
            this.label.text(this.currentOption.getLabel());
            // Execute listener
            this.changeHandlers.execute(this, []);
        };
        MobileTabManager.prototype.onChange = function (handler) {
            this.changeHandlers.addEventListener(handler);
        };
        MobileTabManager.prototype.onReselected = function (handler) {
            this.reselectedHandlers.addEventListener(handler);
        };
        MobileTabManager.prototype.getGroup = function () {
            return this.currentOption.getId();
        };
        MobileTabManager.prototype.setGroup = function (group) {
            var option = this.options.single(function (option) { return option.getId() === group; }) || null;
            this.select(option);
        };
        return MobileTabManager;
    }());
    Dashboard.MobileTabManager = MobileTabManager;
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var DashboardTabManager = (function () {
        function DashboardTabManager(wrapper) {
            this.wrapper = wrapper;
            this.desktopTabManager = new Dashboard.DesktopTabManager(wrapper);
            this.mobileTabManager = new Dashboard.MobileTabManager(wrapper);
        }
        DashboardTabManager.prototype.initialize = function (vo, args, hash) {
            this.desktopTabManager.initialize(vo, args, hash);
            this.mobileTabManager.initialize(vo, args, hash);
        };
        DashboardTabManager.prototype.onChange = function (handler) {
            var _this = this;
            this.desktopTabManager.onChange(function () {
                _this.mobileTabManager.setGroup(_this.desktopTabManager.getGroup());
                if (!_this.isMobile()) {
                    handler();
                }
            });
            this.mobileTabManager.onChange(function () {
                _this.desktopTabManager.setGroup(_this.mobileTabManager.getGroup());
                if (_this.isMobile()) {
                    handler();
                }
            });
        };
        DashboardTabManager.prototype.onReselected = function (handler) {
            var _this = this;
            this.desktopTabManager.onReselected(function () {
                if (!_this.isMobile()) {
                    handler();
                }
            });
            this.mobileTabManager.onReselected(function () {
                if (_this.isMobile()) {
                    handler();
                }
            });
        };
        DashboardTabManager.prototype.isMobile = function () {
            return EnvironmentUtilities.BrowserDetector.isMobile();
        };
        DashboardTabManager.prototype.getGroup = function () {
            if (EnvironmentUtilities.BrowserDetector.isMobile()) {
                return this.mobileTabManager.getGroup();
            }
            return this.desktopTabManager.getGroup();
        };
        DashboardTabManager.prototype.setGroup = function (group) {
            if (group === this.getGroup()) {
                return;
            }
            if (this.isMobile()) {
                this.mobileTabManager.setGroup(group);
            }
            else {
                this.desktopTabManager.setGroup(group);
            }
        };
        return DashboardTabManager;
    }());
    Dashboard.DashboardTabManager = DashboardTabManager;
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var LeftMenu = (function () {
        function LeftMenu(wrapper) {
            this.wrapper = wrapper;
            this.contentWrapper = wrapper.find(' .wallet-share-dashboard-left-menu-wrapper');
            this.contentTitle = this.contentWrapper.find('.wallet-share-dashboard-left-menu-top-title');
            this.content = this.contentWrapper.find('.wallet-share-dashboard-left-menu-content');
            this.button = wrapper.find('.wallet-share-folder-menu-slider');
            this.isOpen = true;
        }
        LeftMenu.prototype.initialize = function (elements) {
            this.heightOffsetters = elements;
            this.addEventListeners();
        };
        LeftMenu.prototype.setTitle = function (title) {
            this.contentTitle.text(title);
            this.contentTitle.attr('title', title);
        };
        LeftMenu.prototype.setContent = function (content) {
            this.content.append(content);
        };
        LeftMenu.prototype.show = function (isVisible) {
            if (isVisible) {
                this.wrapper.removeClass(LeftMenu.HIDE_CSSCLASS);
            }
            else {
                this.wrapper.addClass(LeftMenu.HIDE_CSSCLASS);
            }
        };
        LeftMenu.prototype.addEventListeners = function () {
            var _this = this;
            this.addResizeListeners();
            this.button.click(function () { _this.toggle(); });
        };
        LeftMenu.prototype.addResizeListeners = function () {
            var _this = this;
            var doc = $(document);
            setInterval(function () {
                _this.setHeight(null);
                if (_this.heightOffsetters === null || !EnvironmentUtilities.BrowserDetector.isDesktop()) {
                    return;
                }
                var offset = 0;
                for (var i = _this.heightOffsetters.length - 1; i >= 0; i--) {
                    offset += _this.heightOffsetters.eq(i).outerHeight();
                }
                _this.setHeight(doc.height() - offset - LeftMenu.BOTTOM_MARGIN);
            }, 200);
        };
        LeftMenu.prototype.setHeight = function (value) {
            this.contentWrapper.height(value === null ? '' : value);
        };
        LeftMenu.prototype.toggle = function () {
            this.isOpen = !this.isOpen;
            var CLOSED_CLOSED_CSSCLASS = LeftMenu.CLOSED_CLOSED_CSSCLASS;
            var OPENED_CLOSED_CSSCLASS = LeftMenu.OPENED_CLOSED_CSSCLASS;
            if (this.isOpen) {
                this.wrapper.removeClass(CLOSED_CLOSED_CSSCLASS).addClass(OPENED_CLOSED_CSSCLASS);
            }
            else {
                this.wrapper.removeClass(OPENED_CLOSED_CSSCLASS).addClass(CLOSED_CLOSED_CSSCLASS);
            }
        };
        LeftMenu.prototype.close = function () {
            if (this.isOpen) {
                this.toggle();
            }
        };
        LeftMenu.HIDE_CSSCLASS = "hidden";
        LeftMenu.CLOSED_CLOSED_CSSCLASS = 'closed';
        LeftMenu.OPENED_CLOSED_CSSCLASS = 'opened';
        LeftMenu.BOTTOM_MARGIN = 2;
        return LeftMenu;
    }());
    Dashboard.LeftMenu = LeftMenu;
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var LeftMenuList = (function () {
        function LeftMenuList(options, selected) {
            this.changeHandlers = new ListenersCollection();
            this.wrapper = jQuery('<div>', { 'class': 'wallet-share-dashboard-report-folders-wrapper' });
            var list = jQuery('<div>', { 'class': 'wallet-share-dashboard-report-folders-content' });
            this.options = options;
            this.optionElements = options.map(function (option) {
                return jQuery('<div/>', { 'class': 'wallet-share-dashboard-report-folders-content-option open-sans text-overflow', 'title': option.name, 'text': option.name });
            });
            list.append(this.optionElements);
            this.wrapper.append(list);
            this.addEventListeners();
            this.select(selected || null, true);
        }
        LeftMenuList.prototype.refresh = function () {
            var _this = this;
            this.optionElements.forEach(function (option, k) {
                var cssClass = _this.options[k] === _this.selected ? LeftMenuList.SELECTED_CSS_CLASS : LeftMenuList.NOT_SELECTED_CSS_CLASS;
                option
                    .removeClass(LeftMenuList.SELECTED_CSS_CLASS)
                    .removeClass(LeftMenuList.NOT_SELECTED_CSS_CLASS)
                    .addClass(cssClass);
            });
        };
        LeftMenuList.prototype.select = function (selected, triggerHandlers) {
            this.selected = selected;
            this.refresh();
            if (triggerHandlers) {
                this.changeHandlers.execute(this, []);
            }
        };
        //for resource center, changes selection to first item
        LeftMenuList.prototype.firstSelection = function () {
            this.selected = this.options[0];
            this.refresh();
        };
        LeftMenuList.prototype.triggerSelection = function (id) {
            for (var i = this.options.length - 1; i >= 0; i--) {
                if (this.options[i].id === id) {
                    break;
                }
            }
            this.select(this.options[i], true);
        };
        LeftMenuList.prototype.addEventListeners = function () {
            var _this = this;
            this.optionElements.forEach(function (option, k) {
                option.click(function () {
                    _this.select(_this.options[k], true);
                });
            });
        };
        LeftMenuList.prototype.onChange = function (handler) {
            this.changeHandlers.addEventListener(handler);
        };
        LeftMenuList.prototype.val = function () {
            return (this.selected === null) ? null : this.selected.id;
        };
        LeftMenuList.prototype.html = function () {
            return this.wrapper;
        };
        LeftMenuList.prototype.hide = function () {
            if (this.wrapper !== null) {
                this.wrapper.hide();
            }
        };
        LeftMenuList.prototype.show = function () {
            if (this.wrapper !== null) {
                this.wrapper.show();
            }
        };
        LeftMenuList.prototype.clear = function () {
            this.selected = null;
            this.refresh();
        };
        LeftMenuList.NOT_SELECTED_CSS_CLASS = 'wallet-share-dashboard-folder-not-selected';
        LeftMenuList.SELECTED_CSS_CLASS = 'wallet-share-dashboard-folder-selected';
        return LeftMenuList;
    }());
    Dashboard.LeftMenuList = LeftMenuList;
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var LeftMenuWithArchivedLinks = (function (_super) {
        __extends(LeftMenuWithArchivedLinks, _super);
        function LeftMenuWithArchivedLinks(years, options, strings, selected, resourceCenter) {
            _super.call(this, options, selected || null);
            this.resourceCenter = false;
            this.strings = strings;
            this.years = years;
            this.value = null;
            this.resourceCenter = resourceCenter === null ? false : true;
            this.archivesWrapper = jQuery('<div/>', { 'class': 'wallet-share-dashboard-left-menu-archives-wrapper' });
            this.html().append(this.archivesWrapper);
            this.overridenChangeHandlers = new ListenersCollection();
            //Archive links are different b/t Resource/Research
            if (resourceCenter) {
                this.createResourceArchiveLink();
            }
            else {
                if (this.years.isEmpty()) {
                    return;
                }
                this.createArchivedContent();
                this.addArchivedEventListeners();
            }
        }
        LeftMenuWithArchivedLinks.prototype.createResourceArchiveLink = function () {
            var _this = this;
            var content = jQuery('<div/>', { 'class': 'archives-articles-content' });
            var title = jQuery('<div/>', { 'class': 'res-archive-links', 'text': this.strings.archives, 'title': this.strings.archives });
            content.append(title);
            title.click(function () {
                _this.archive(0); //resource archive is not separated by year, input will be ignored by ResourceSection object
                _this.executeOverrideChangeListeners();
            });
            //if on Archive page, listens to left hand nav bar to detect page
            _super.prototype.onChange.call(this, function () {
                _this.emptyVal();
                _this.executeOverrideChangeListeners();
            });
            this.firstSelection();
            this.archivesWrapper.append(content);
        };
        LeftMenuWithArchivedLinks.prototype.createArchivedContent = function () {
            var content = jQuery('<div/>', { 'class': 'archives-articles-content' });
            var title = jQuery('<div/>', { 'class': 'archives-title', 'text': this.strings.archives, 'title': this.strings.archives });
            var separator = jQuery('<hr/>', { 'class': 'archives-separator' });
            var group = jQuery('<div/>', { 'class': 'archives-group' });
            this.yearsElements = this.years.map(function (year) { return jQuery('<a/>', { 'class': 'archive-links', 'text': year, 'title': year }); });
            group.append(this.yearsElements);
            content.append(title, separator, group);
            this.archivesWrapper.append(content);
        };
        LeftMenuWithArchivedLinks.prototype.addArchivedEventListeners = function () {
            var _this = this;
            this.yearsElements.forEach(function (element, k) {
                element.click(function () {
                    _this.archive(_this.years[k]);
                    _this.executeOverrideChangeListeners();
                });
            });
            _super.prototype.onChange.call(this, function () {
                _this.emptyVal();
                _this.executeOverrideChangeListeners();
            });
        };
        LeftMenuWithArchivedLinks.prototype.executeOverrideChangeListeners = function () {
            this.overridenChangeHandlers.execute(this, []);
        };
        LeftMenuWithArchivedLinks.prototype.onChange = function (handler) {
            if (this.years.isEmpty() && !this.resourceCenter) {
                _super.prototype.onChange.call(this, handler);
            }
            else {
                this.overridenChangeHandlers.addEventListener(handler);
            }
        };
        LeftMenuWithArchivedLinks.prototype.val = function () {
            return this.isArchive() ? this.value : _super.prototype.val.call(this);
        };
        LeftMenuWithArchivedLinks.prototype.isArchive = function () {
            return this.value !== null;
        };
        LeftMenuWithArchivedLinks.prototype.archive = function (year) {
            this.value = year;
            this.select(null, false);
        };
        LeftMenuWithArchivedLinks.prototype.emptyVal = function () {
            this.value = null;
        };
        return LeftMenuWithArchivedLinks;
    }(Dashboard.LeftMenuList));
    Dashboard.LeftMenuWithArchivedLinks = LeftMenuWithArchivedLinks;
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var Iframe = (function () {
        function Iframe(loading, frame) {
            this.loading = loading;
            this.frame = frame;
            this.url = null;
            this.targetWindow = null;
            this.urlChangeHandler = new ListenersCollection();
            this.loadHandler = new ListenersCollection();
        }
        Iframe.prototype.initialize = function () {
            this.frame.removeClass(Iframe.HIDDEN_CSS_CLASS);
            this.loading.addClass(Iframe.LOADING_CSS_CLASS);
            this.addEventListeners();
        };
        Iframe.prototype.resize = function () {
            if (this.targetWindow === null || this.targetWindow.$ === undefined) {
                return;
            }
            // This class needs to be present on the internal frame
            var wrapper = this.targetWindow.$('.framed-dashboard-container');
            if (wrapper.isEmpty()) {
                return;
            }
            this.frame.height(wrapper.height());
        };
        Iframe.prototype.isArticleView = function () {
            var viewArticleWrapper = jQuery(this.frame.get(0).contentWindow.document).find('.article-view-background');
            if (viewArticleWrapper.isEmpty()) {
                return false;
            }
            return true;
        };
        Iframe.prototype.addEventListeners = function () {
            var _this = this;
            this.frame.on('load', function () {
                var frames = Array.prototype.slice.call(window.frames);
                if (frames.isEmpty()) {
                    return;
                }
                var firstWindow = frames.first();
                if (firstWindow.document.readyState !== Iframe.DOCUMENT_READY_STATE || firstWindow.$ === undefined) {
                    return;
                }
                // Add loading spinner
                firstWindow.$(firstWindow).on('beforeunload', function () { _this.markAsLoading(); });
                _this.targetWindow = firstWindow;
                _this.frame.removeClass(Iframe.INVISIBLE_CSS_CLASS);
                _this.loading.removeClass(Iframe.LOADING_CSS_CLASS);
                _this.loadHandler.execute(_this, []);
            });
            // Resize
            setInterval(function () {
                _this.resize();
            }, 200);
            // Url change
            setInterval(function () {
                var url = _this.getGeneratedUrl();
                if (url === _this.url) {
                    return;
                }
                _this.url = url;
                _this.urlChangeHandler.execute(_this, [url]);
            }, 200);
            // Rotation
            $(window).on('orientationchange', function () {
                setTimeout(function () {
                    _this.frame.width($(window).width());
                    setTimeout(function () { _this.frame.width('100%'); }, 500);
                    _this.resetHeight();
                    _this.resize();
                }, 200);
            });
        };
        Iframe.prototype.resetHeight = function () {
            this.frame.height(0);
        };
        Iframe.prototype.getGeneratedUrl = function () {
            if (this.targetWindow === null || this.targetWindow.location === undefined || this.targetWindow.location === null) {
                return this.url;
            }
            return this.targetWindow.location.href;
        };
        Iframe.prototype.onUrlChange = function (handler) {
            this.urlChangeHandler.addEventListener(handler);
        };
        Iframe.prototype.load = function (url) {
            url = url.parseUrl('href');
            if (this.getGeneratedUrl() === url) {
                return;
            }
            this.url = url;
            this.targetWindow = null;
            this.markAsLoading();
        };
        Iframe.prototype.onLoad = function (handler) {
            this.loadHandler.addEventListener(handler);
        };
        Iframe.prototype.markAsLoading = function () {
            this.resetHeight();
            this.frame.attr('src', this.url);
            this.frame.addClass(Iframe.INVISIBLE_CSS_CLASS);
            this.loading.addClass(Iframe.LOADING_CSS_CLASS);
        };
        Iframe.INVISIBLE_CSS_CLASS = 'invisible';
        Iframe.LOADING_CSS_CLASS = 'loading';
        Iframe.HIDDEN_CSS_CLASS = 'hidden';
        Iframe.DOCUMENT_READY_STATE = 'complete';
        return Iframe;
    }());
    Dashboard.Iframe = Iframe;
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var Section = (function () {
        function Section(group, title, routes, strings) {
            this.changeHandlers = new ListenersCollection();
            this.routes = routes;
            this.strings = strings;
            this.group = group;
            this.title = title;
            this.renderedHtml = null;
        }
        Section.prototype.getRoutes = function () {
            return this.routes;
        };
        Section.prototype.getStrings = function () {
            return this.strings;
        };
        Section.prototype.getGroup = function () {
            return this.group;
        };
        Section.prototype.getLeftMenuTitle = function () {
            return this.title;
        };
        Section.prototype.getLeftMenuContentHtml = function () {
            if (this.renderedHtml === null) {
                this.renderedHtml = this.createLeftMenuHtml();
            }
            return this.renderedHtml;
        };
        Section.prototype.onChange = function (handler) {
            this.changeHandlers.addEventListener(handler);
        };
        Section.prototype.getBackground = function (url) {
            return '';
        };
        Section.prototype.triggerChangeHandlers = function () {
            this.changeHandlers.execute(this, []);
        };
        Section.prototype.getCamelizedGroupEnum = function () {
            /**
             * Expect this to hold a stringified enum
             */
            var group = this.getGroup();
            /**
             * Converts the enum format to camel case [in order to find them in the routes json of urls sent from the server]
             */
            var urlProp = group.substring(0, 1).toLowerCase() + group.substring(1);
            /**
             * Removes the underlines, and came cases the generated particles
             */
            return urlProp
                .split('_')
                .map(function (particle) { return particle.substring(0, 1) + particle.substring(1).toLowerCase(); })
                .join('');
        };
        Section.prototype.generateSpecificUrlTemplate = function (isTemplate) {
            var urlProp = this.getCamelizedGroupEnum();
            /**
             * Then appends the url suffix
             */
            urlProp += isTemplate ? Section.TEMPLATE_DASHBOARD_URL_SUFFIX : Section.DASHBOARD_URL_SUFFIX;
            /**
             * Trying to use the specific url
             */
            return this.routes[urlProp];
        };
        Section.prototype.generateUrlTemplate = function (isTemplate) {
            var urlTemplate = this.generateSpecificUrlTemplate(isTemplate);
            if (urlTemplate === undefined) {
                /**
                 * If that fails, use the default dashboard
                 */
                urlTemplate = isTemplate ? this.routes.defaultTemplateDashboardUrl : this.routes.defaultDashboardUrl;
            }
            return urlTemplate;
        };
        Section.prototype.displaysLeftMenu = function () {
            return false;
        };
        Section.prototype.displaysSearcher = function () {
            return false;
        };
        Section.prototype.defaultSectionArgs = function () {
            return null;
        };
        Section.prototype.generateReloadHashArgs = function (url) {
            return this.getGroup();
        };
        /**
         * Checks if the given url is valid for the given pattern
         */
        Section.prototype.matchesHashableUrl = function (url) {
            return false;
        };
        Section.NON_TEMPLATE_PREFFIX = '_';
        Section.DASHBOARD_URL_SUFFIX = 'DashboardUrl';
        Section.TEMPLATE_DASHBOARD_URL_SUFFIX = 'TemplateDashboardUrl';
        return Section;
    }());
    Dashboard.Section = Section;
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var ResearchSection = (function (_super) {
        __extends(ResearchSection, _super);
        function ResearchSection(vo, productGroupLabels, routes, strings) {
            _super.call(this, ResearchSection.GROUP_NAME, productGroupLabels[ResearchSection.GROUP_NAME].toUpperCase(), routes, strings);
            this.vo = vo;
            this.list = null;
            this.articleRoutes = routes.articleRoutes;
            this.dashboardUrlPattern = new RegExp(String.format(this.getRoutes().researchPortalShowArticlesUrl, '').parseUrl('href') + ResearchSection.POSITIVE_NUMBER_PATTERN_GROUPING);
            this.articleUrlPattern = new RegExp(routes.articleRoutes.parseUrl('href') + ResearchSection.POSITIVE_NUMBER_PATTERN_GROUPING);
            this.articleCategoryUrlPattern = new RegExp(routes.articleRoutes.parseUrl('href') + ResearchSection.POSITIVE_NUMBER_PATTERN + ResearchSection.CATEGORY_PARAMETER_PREFFIX + ResearchSection.POSITIVE_NUMBER_PATTERN_GROUPING);
            this.articleArchiveUrlPattern = new RegExp(String.format(routes.researchArchivesPageUrl.parseUrl('href'), ResearchSection.POSITIVE_NUMBER_PATTERN_GROUPING));
        }
        /**
         * Returns a numeric id from the given url. Expects the given pattern to return the id in the last match group
         */
        ResearchSection.retreiveIdFromUrl = function (url, urlPattern) {
            //  Tries to extract the matches
            var matches = url.match(urlPattern);
            // If it does NOT match, return null
            if (matches === null) {
                return null;
            }
            // A group match was found, notice that we do not validate if only one was found
            return Number(matches.last());
        };
        ResearchSection.prototype.createLeftMenuHtml = function () {
            var _this = this;
            var options = this.vo.products.map(function (product) { return { id: product.id, name: product.fullName }; });
            this.list = new Dashboard.LeftMenuWithArchivedLinks(this.vo.archivedPublishedYears, options, this.getStrings(), null, false);
            this.list.onChange(function () {
                _this.triggerChangeHandlers();
            });
            return this.list.html();
        };
        ResearchSection.prototype.displaysLeftMenu = function () {
            return true;
        };
        ResearchSection.prototype.displaysSearcher = function () {
            return true;
        };
        ResearchSection.prototype.hideLeftMenuContentHtml = function () {
            if (this.list !== null) {
                this.list.hide();
            }
        };
        ResearchSection.prototype.showLeftMenuContentHtml = function () {
            if (this.list !== null) {
                this.list.show();
            }
        };
        ResearchSection.prototype.matchesHashableUrl = function (url) {
            return this.articleArchiveUrlPattern.test(url) ||
                this.articleCategoryUrlPattern.test(url) ||
                this.articleUrlPattern.test(url) ||
                this.dashboardUrlPattern.test(url) ||
                _super.prototype.matchesHashableUrl.call(this, url);
        };
        ResearchSection.prototype.parseHashArgsAsArticleView = function (input) {
            var articleViewMatches = input.match(ResearchSection.LOAD_ARTICLE_HASH_PATTERN);
            if (articleViewMatches === null || articleViewMatches.length !== ResearchSection.ARTICLE_HASH_PATTERN_GROUPS_LENGTH) {
                return;
            }
            return {
                categoryId: Number(articleViewMatches[ResearchSection.ARTICLE_HASH_CATEGORY_ID_POSITION]),
                articleId: Number(articleViewMatches[ResearchSection.ARTICLE_HASH_ARTICLE_ID_POSITION]),
                year: null,
                searchText: null
            };
        };
        ResearchSection.prototype.parseHashArgsAsArchivedArticle = function (input) {
            var articleArchiveMatches = input.match(ResearchSection.LOAD_ARCHIVE_HASH_PATTERN);
            if (articleArchiveMatches === null || articleArchiveMatches.length !== ResearchSection.LOAD_ARCHIVE_HASH_GROUP_SIZE) {
                return null;
            }
            return {
                categoryId: null,
                articleId: null,
                year: Number(articleArchiveMatches.last()),
                searchText: null
            };
        };
        ResearchSection.prototype.parseHashArgsAsSearchView = function (input) {
            var id = this.list.val() === null ? ResearchSection.ZERO_CATEGORY_ID : this.list.val();
            if (this.list.isArchive()) {
                return {
                    categoryId: null,
                    articleId: null,
                    year: id,
                    searchText: input
                };
            }
            else {
                return {
                    categoryId: id,
                    articleId: null,
                    year: null,
                    searchText: input
                };
            }
        };
        ResearchSection.prototype.parseHashArgsAsLandingPage = function (input) {
            if (input === ResearchSection.DEFAULT_SECTION_ARG) {
                return {
                    categoryId: null,
                    articleId: null,
                    year: null,
                    searchText: null
                };
            }
        };
        ResearchSection.prototype.getBackground = function (url) {
            if (this.articleUrlPattern.test(url)) {
                return ResearchSection.WHITE_COLOR;
            }
            return _super.prototype.getBackground.call(this, url);
        };
        ResearchSection.prototype.generateUrl = function (args, search) {
            var parsedArgs = args === null ? null :
                this.parseHashArgsAsLandingPage(args) ||
                    this.parseHashArgsAsArticleView(args) ||
                    this.parseHashArgsAsArchivedArticle(args) ||
                    this.parseHashArgsAsSearchView(args);
            if (parsedArgs === null) {
                if (this.list.isArchive()) {
                    parsedArgs = {
                        categoryId: null,
                        articleId: null,
                        searchText: null,
                        year: this.list.val()
                    };
                }
                else {
                    parsedArgs = {
                        categoryId: this.list.val(),
                        articleId: ResearchSection.ZERO_ARTICLE_ID,
                        searchText: null,
                        year: null
                    };
                }
            }
            // Go to the search result page
            if (parsedArgs.searchText !== null) {
                if (this.list.isArchive()) {
                    return String.format(this.getRoutes().researchSearchArchivesUrl, parsedArgs.year, parsedArgs.searchText).parseUrl('href');
                }
                else {
                    return String.format(this.getRoutes().researchSearchArticlesUrl, parsedArgs.categoryId, parsedArgs.searchText).parseUrl('href');
                }
            }
            // Go to the archived
            if (parsedArgs.year !== null) {
                this.list.archive(parsedArgs.year);
                return String.format(this.getRoutes().researchArchivesPageUrl, parsedArgs.year).parseUrl('href');
            }
            // Update left menu
            if (parsedArgs.categoryId !== null && this.list.val() !== parsedArgs.categoryId) {
                this.list.triggerSelection(parsedArgs.categoryId);
            }
            // Go to the article
            if (parsedArgs.articleId !== null && parsedArgs.articleId > ResearchSection.ZERO_ARTICLE_ID) {
                return this.articleRoutes + parsedArgs.articleId;
            }
            // Go to Dashboard
            if (parsedArgs.categoryId !== null) {
                return String.format(this.getRoutes().researchPortalShowArticlesUrl, parsedArgs.categoryId).parseUrl('href');
            }
            // Go to the landing Page
            return this.generateUrlTemplate(false).parseUrl('href');
        };
        ResearchSection.prototype.triggerUrlChange = function (url) {
            var categoryId = this.getOpenedDashboardCategoryId(url);
            if (categoryId === null) {
                return;
            }
            // Let's move that dashboard
            this.list.triggerSelection(categoryId);
        };
        ResearchSection.prototype.refresh = function () {
            this.list.clear();
        };
        ResearchSection.prototype.defaultSectionArgs = function () {
            return ResearchSection.DEFAULT_SECTION_ARG;
        };
        /**
         * Validates the given url as being a dashboard pattern url, and retrieved the given id for that category
         */
        ResearchSection.prototype.getOpenedDashboardCategoryId = function (url) {
            return ResearchSection.retreiveIdFromUrl(url, this.dashboardUrlPattern);
        };
        /**
         * Validates the given url as being a article view pattern url, and retrieved the given id for that article
         */
        ResearchSection.prototype.getOpenedArticleViewId = function (url) {
            return ResearchSection.retreiveIdFromUrl(url, this.articleUrlPattern);
        };
        /**
         * Validates the given url as being a article view pattern url, and retrieved the given id for that article category
         */
        ResearchSection.prototype.getOpenedArticleViewCategoryId = function (url) {
            return ResearchSection.retreiveIdFromUrl(url, this.articleCategoryUrlPattern);
        };
        /**
         * This function generates the hash for any research section navigation
         */
        ResearchSection.prototype.generateReloadHashArgs = function (url) {
            var group = _super.prototype.generateReloadHashArgs.call(this, url);
            var hash = this.generateArticleDashboardUrlHash(url) || this.generateArticleViewUrlHash(url) || this.generateArchiveDashboardUrlHash(url);
            if (hash === null) {
                return group;
            }
            return group + hash;
        };
        /**
         * If the use is in the archive dash
         */
        ResearchSection.prototype.generateArchiveDashboardUrlHash = function (url) {
            var matches = url.match(this.articleArchiveUrlPattern);
            if (matches !== null && matches.length === ResearchSection.ARCHIVED_URL_SIZE_MATCH) {
                return String.format(ResearchSection.ARCHIVED_HASH_URL_TEMPLATE, matches.last());
            }
            return null;
        };
        /**
         * If the user is viewing an article
         */
        ResearchSection.prototype.generateArticleViewUrlHash = function (url) {
            var articleId = this.getOpenedArticleViewId(url);
            if (articleId === null) {
                return null;
            }
            var categoryId = this.getOpenedArticleViewCategoryId(url);
            if (categoryId === null) {
                return null;
            }
            return String.format(ResearchSection.ARTICLE_HASH_URL_TEMPLATE, categoryId, articleId);
        };
        /**
         * If the user is viewing an article
         */
        ResearchSection.prototype.generateArticleDashboardUrlHash = function (url) {
            var categoryId = this.getOpenedDashboardCategoryId(url);
            if (categoryId !== null) {
                return String.format(ResearchSection.ARTICLE_HASH_URL_TEMPLATE, categoryId, ResearchSection.ZERO_ARTICLE_ID);
            }
            return null;
        };
        ResearchSection.prototype.hasGroupPermission = function () {
            return true;
        };
        ResearchSection.WHITE_COLOR = '#fff';
        ResearchSection.DEFAULT_SECTION_ARG = 'LANDING_PAGE';
        ResearchSection.SLASH = '/';
        ResearchSection.ZERO_ARTICLE_ID = 0;
        ResearchSection.ZERO_CATEGORY_ID = 0;
        ResearchSection.POSITIVE_NUMBER_PATTERN = '[1-9]\\d*';
        ResearchSection.POSITIVE_NUMBER_PATTERN_GROUPING = '(' + ResearchSection.POSITIVE_NUMBER_PATTERN + ')';
        ResearchSection.NUMBER_PATTERN_GROUPING = '(' + '\\d+' + ')';
        /**
         * Article View
         */
        ResearchSection.CATEGORY_PARAMETER_PREFFIX = '\\?c=';
        ResearchSection.ARTICLE_HASH_TEMPLATE = 'c{0}a{1}';
        ResearchSection.ARTICLE_HASH_URL_TEMPLATE = ResearchSection.SLASH + ResearchSection.ARTICLE_HASH_TEMPLATE;
        ResearchSection.LOAD_ARTICLE_HASH_PATTERN = String.format(ResearchSection.ARTICLE_HASH_TEMPLATE, ResearchSection.POSITIVE_NUMBER_PATTERN_GROUPING, ResearchSection.NUMBER_PATTERN_GROUPING);
        ResearchSection.ARTICLE_HASH_PATTERN_GROUPS_LENGTH = 3;
        ResearchSection.ARTICLE_HASH_CATEGORY_ID_POSITION = 1;
        ResearchSection.ARTICLE_HASH_ARTICLE_ID_POSITION = 2;
        /**
         * Article archive
         */
        ResearchSection.ARCHIVED_HASH_TEMPLATE = 'y{0}';
        ResearchSection.ARCHIVED_HASH_URL_TEMPLATE = ResearchSection.SLASH + ResearchSection.ARCHIVED_HASH_TEMPLATE;
        ResearchSection.ARCHIVED_URL_SIZE_MATCH = 2;
        ResearchSection.LOAD_ARCHIVE_HASH_PATTERN = String.format(ResearchSection.ARCHIVED_HASH_TEMPLATE, ResearchSection.POSITIVE_NUMBER_PATTERN_GROUPING);
        ResearchSection.LOAD_ARCHIVE_HASH_GROUP_SIZE = 2;
        ResearchSection.GROUP_NAME = WalletShare.LicensingProductGroup[WalletShare.LicensingProductGroup.RESEARCH];
        return ResearchSection;
    }(Dashboard.Section));
    Dashboard.ResearchSection = ResearchSection;
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var IntelligenceSection = (function (_super) {
        __extends(IntelligenceSection, _super);
        function IntelligenceSection(groupId, strings, routes, templatePreffix) {
            _super.call(this, groupId, strings.folders, routes, strings);
            this.list = null;
            this.templatePreffix = templatePreffix;
            this.generatedUrls = {};
            this.permissionManager = new PermissionManager.ProductsPermissionManager();
        }
        IntelligenceSection.prototype.setPermission = function (products) {
            if (products === undefined || products === null) {
                return;
            }
            var productNames = products.map(function (product) { return product.fullName; });
            this.permissionManager.setProducts(productNames);
        };
        IntelligenceSection.prototype.createLeftMenuHtml = function () {
            var option = { id: 0, name: this.getStrings().allReports };
            this.list = new Dashboard.LeftMenuList([option], option);
            return this.list.html();
        };
        IntelligenceSection.prototype.hideLeftMenuContentHtml = function () {
            if (this.list !== null) {
                this.list.hide();
            }
        };
        IntelligenceSection.prototype.showLeftMenuContentHtml = function () {
            if (this.list !== null) {
                this.list.show();
            }
        };
        IntelligenceSection.prototype.matchesHashableUrl = function (url) {
            for (var key in this.generatedUrls) {
                if (this.generatedUrls[key] === url) {
                    return true;
                }
            }
            return _super.prototype.matchesHashableUrl.call(this, url);
        };
        IntelligenceSection.prototype.generateUrl = function (args) {
            var isTemplate = args === this.templatePreffix;
            var key = Number(isTemplate);
            if (this.generatedUrls[key] === undefined) {
                this.generatedUrls[key] = String.format(this.generateUrlTemplate(isTemplate), this.getGroup()).parseUrl('href');
            }
            return this.generatedUrls[key];
        };
        IntelligenceSection.prototype.triggerUrlChange = function (url) {
            // NOTHING
        };
        IntelligenceSection.prototype.refresh = function () {
            // NOTHING
        };
        IntelligenceSection.prototype.generateReloadHashArgs = function (url) {
            var hash = _super.prototype.generateReloadHashArgs.call(this, url);
            var templateUrl = this.generateUrl(this.templatePreffix);
            return (url === templateUrl) ? hash + this.templatePreffix : hash;
        };
        return IntelligenceSection;
    }(Dashboard.Section));
    var DistributionIntelligenceSection = (function (_super) {
        __extends(DistributionIntelligenceSection, _super);
        function DistributionIntelligenceSection(products, strings, routes, templatePreffix) {
            _super.call(this, WalletShare.LicensingProductGroup[WalletShare.LicensingProductGroup.DISTRIBUTION_INTELLIGENCE], strings, routes, templatePreffix);
            this.setPermission(products);
        }
        DistributionIntelligenceSection.prototype.hasGroupPermission = function () {
            return this.permissionManager.hasDistributionIntelligenceProduct();
        };
        DistributionIntelligenceSection.GROUP_NAME = WalletShare.LicensingProductGroup[WalletShare.LicensingProductGroup.DISTRIBUTION_INTELLIGENCE];
        return DistributionIntelligenceSection;
    }(IntelligenceSection));
    Dashboard.DistributionIntelligenceSection = DistributionIntelligenceSection;
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var Searcher = (function () {
        function Searcher(wrapper) {
            this.wrapper = wrapper;
        }
        Searcher.prototype.initialize = function () {
            this.buttonSearch = this.wrapper.find('.filters-button-search');
            this.input = this.wrapper.find('.filters-input-search');
            this.dataset = new Array();
        };
        Searcher.prototype.onSearchClick = function (handler) {
            this.buttonSearch.click(handler);
        };
        Searcher.prototype.onSearchByEnterEvent = function (handler) {
            this.input.keypress(function (e) {
                if (e.which == 13) {
                    handler();
                }
            });
        };
        Searcher.prototype.clear = function () {
            this.input.val(Searcher.EMPTY);
        };
        Searcher.prototype.show = function (isVisible) {
            if (isVisible) {
                this.wrapper.removeClass(Searcher.HIDE_CSSCLASS);
            }
            else {
                this.wrapper.addClass(Searcher.HIDE_CSSCLASS);
            }
        };
        Searcher.prototype.searchTextValid = function () {
            return !this.input.val().trim().isEmpty();
        };
        Object.defineProperty(Searcher.prototype, "searchText", {
            get: function () {
                var searchText = this.input.val();
                this.updateDataset(searchText);
                return encodeURIComponent(searchText);
            },
            enumerable: true,
            configurable: true
        });
        Searcher.prototype.updateDataset = function (searchText) {
            if (this.dataset.indexOf(searchText) < 0) {
                this.dataset.push(searchText);
                this.input.autocomplete({
                    source: this.dataset
                });
            }
        };
        Searcher.HIDE_CSSCLASS = "hidden";
        Searcher.EMPTY = "";
        return Searcher;
    }());
    Dashboard.Searcher = Searcher;
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var ResourceSection = (function (_super) {
        __extends(ResourceSection, _super);
        function ResourceSection(vo, productGroupLabels, routes, strings) {
            _super.call(this, ResourceSection.GROUP_NAME, productGroupLabels[ResourceSection.GROUP_NAME].toUpperCase(), routes, strings);
            this.vo = vo;
        }
        //route to get initial page for Resource Center
        ResourceSection.prototype.generateUrl = function (args, search) {
            var parsedArgs = args === null ? this.list.val() : null;
            if (this.list.isArchive() && args === null) {
                return "/researchPortal/resourcePortal/archive/";
            }
            if (this.list.isArchive() && search) {
                return String.format("/researchPortal/search/resource/archives?searchText={0}", args);
            }
            if (parsedArgs) {
                return "/researchPortal/dashboard/resource/" + parsedArgs;
            }
            if (!this.list.isArchive() && search) {
                return String.format("/researchPortal/search/resource/{0}/articles?searchText={1}", this.list.val(), args);
            }
            if (args === "defaultResource") {
                return "/researchPortal/resourcePortal/dashboard";
            }
            return "/researchPortal/resourcePortal/dashboard"; //return landing page if no other choices
        };
        ResourceSection.prototype.triggerUrlChange = function (url) {
            return null;
        };
        //argument string for when Resource Center first loads
        ResourceSection.prototype.defaultSectionArgs = function () {
            return "defaultResource";
        };
        ResourceSection.prototype.displaysLeftMenu = function () {
            return true;
        };
        ResourceSection.prototype.displaysSearcher = function () {
            return true;
        };
        ResourceSection.prototype.hideLeftMenuContentHtml = function () {
            if (this.list !== null) {
                this.list.clear();
                this.list.hide();
            }
        };
        ResourceSection.prototype.showLeftMenuContentHtml = function () {
            if (this.list !== null) {
                this.list.firstSelection();
                this.list.show();
            }
        };
        ResourceSection.prototype.refresh = function () {
        };
        ResourceSection.prototype.hasGroupPermission = function () {
            return true; //TODO: set permissioning for resource center
        };
        ResourceSection.prototype.createLeftMenuHtml = function () {
            var _this = this;
            //get all products aka left menu links
            var options = this.vo.products.map(function (product) { return { id: product.id, name: product.fullName }; });
            //create left sidebar menu
            this.list = new Dashboard.LeftMenuWithArchivedLinks(this.vo.archivedPublishedYears, options, this.getStrings(), options[0], true);
            this.list.onChange(function () {
                _this.triggerChangeHandlers();
            });
            return this.list.html();
        };
        ResourceSection.GROUP_NAME = "RESOURCE_CENTER";
        return ResourceSection;
    }(Dashboard.Section));
    Dashboard.ResourceSection = ResourceSection;
})(Dashboard || (Dashboard = {}));
var Dashboard;
(function (Dashboard) {
    var Manager = (function () {
        function Manager(tabsWrapper, slider, loadingWrapper, iframe) {
            this.wrapper = tabsWrapper;
            this.tabManager = new Dashboard.DashboardTabManager(tabsWrapper.find('.content-home-wrapper'));
            this.searcher = new Dashboard.Searcher(tabsWrapper.find('.wallet-share-dashboard-top-filters'));
            this.leftMenu = new Dashboard.LeftMenu(slider);
            this.iframe = new Dashboard.Iframe(loadingWrapper, iframe);
            this.section = null;
            this.hashUpdateInternal = false;
        }
        Manager.prototype.initialize = function (vo, args, offset) {
            var sections = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                sections[_i - 3] = arguments[_i];
            }
            this.sections = sections;
            this.backgroundElement = this.wrapper.find('.section-background');
            this.components = this.wrapper.find('.tabs-wrapper, .content-wrapper');
            this.leftMenu.initialize(offset);
            this.tabManager.initialize(vo, args, this.hashSectionsPermission(sections));
            this.searcher.initialize();
            this.iframe.initialize();
            if (vo.researchPortal) {
                this.tabManager.setGroup(Dashboard.ResearchSection.GROUP_NAME);
            }
            else if (vo.resourcePortal) {
                this.tabManager.setGroup(Dashboard.ResourceSection.GROUP_NAME);
            }
            this.load(this.tabManager.getGroup(), args.sectionArgs);
            this.addEventListeners();
            if (!EnvironmentUtilities.BrowserDetector.isDesktop()) {
                this.leftMenu.close();
            }
        };
        Manager.prototype.hashSectionsPermission = function (sections) {
            var hash = {};
            sections.forEach(function (section) {
                hash[section.getGroup()] = section.hasGroupPermission();
            });
            return hash;
        };
        Manager.prototype.addEventListeners = function () {
            var _this = this;
            this.sections.forEach(function (section) {
                section.onChange(function () {
                    _this.refreshFrame(section, null);
                });
            });
            this.tabManager.onChange(function () {
                _this.load(_this.tabManager.getGroup(), null);
            });
            this.tabManager.onReselected(function () {
                _this.load(_this.tabManager.getGroup(), null);
            });
            this.searcher.onSearchClick(function () {
                if (_this.searcher.searchTextValid()) {
                    _this.load(_this.tabManager.getGroup(), _this.searcher.searchText, true);
                }
            });
            this.searcher.onSearchByEnterEvent(function () {
                if (_this.searcher.searchTextValid()) {
                    _this.load(_this.tabManager.getGroup(), _this.searcher.searchText, true);
                }
            });
            this.iframe.onUrlChange(function (url) {
                var match = _this.sections.single(function (section) { return section.matchesHashableUrl(url); }) || null;
                if (match !== null) {
                }
                else {
                    if (_this.section !== null) {
                        _this.section.triggerUrlChange(url);
                    }
                    _this.updateHash();
                }
                setInterval(function () {
                    _this.refreshBackGround();
                }, 200);
            });
            this.iframe.onLoad(function () {
                _this.updateHash();
            });
            $(window).on('hashchange', function () {
                if (_this.hashUpdateInternal) {
                    return;
                }
                var hash = _this.getLocationHash();
                var newSection = hash.isEmpty() ? null : _this.sections.single(function (section) { return hash.startsWith(section.getGroup()); }) || null;
                if (newSection === null) {
                    _this.updateHash();
                    return;
                }
                var group = newSection.getGroup();
                var args = hash.substring(group.length) || null;
                // Change tab
                _this.tabManager.setGroup(group);
                // Load new settings
                _this.load(group, args);
            });
        };
        Manager.prototype.getLocationHash = function () {
            return location.hash.match(Manager.HASH_PATTERN).last();
        };
        Manager.prototype.load = function (group, sectionArgs, partialLoad) {
            var section = this.sections.single(function (section) { return section.getGroup() === group; }) || null;
            if (section === null) {
                return;
            }
            if (this.section !== section) {
                if (this.section !== null) {
                    this.section.hideLeftMenuContentHtml();
                }
                // New becomes the current section 
                this.section = section;
                this.leftMenu.setTitle(section.getLeftMenuTitle());
                this.leftMenu.setContent(section.getLeftMenuContentHtml());
                section.showLeftMenuContentHtml();
                this.refreshLeftMenu(section.displaysLeftMenu());
                this.searcher.show(section.displaysSearcher());
            }
            else if (section.getGroup() === Dashboard.ResourceSection.GROUP_NAME) {
                //ensures resource center button has the first item selected in the left menu bar
                this.section = section;
                if (!partialLoad) {
                    this.leftMenu.setTitle(section.getLeftMenuTitle());
                    this.leftMenu.setContent(section.getLeftMenuContentHtml());
                    section.showLeftMenuContentHtml();
                    this.refreshLeftMenu(section.displaysLeftMenu());
                }
            }
            if (sectionArgs === null) {
                sectionArgs = section.defaultSectionArgs();
            }
            if (!partialLoad) {
                section.refresh();
            }
            this.refreshFrame(section, sectionArgs, partialLoad);
        };
        Manager.prototype.refreshLeftMenu = function (listVisibility) {
            this.leftMenu.show(listVisibility);
            if (!listVisibility) {
                this.components.removeClass(Manager.COL_LG10_CSSCLASS).addClass(Manager.COL_LG12_CSSCLASS);
            }
            else {
                this.components.removeClass(Manager.COL_LG12_CSSCLASS).addClass(Manager.COL_LG10_CSSCLASS);
            }
        };
        Manager.prototype.updateHash = function () {
            var _this = this;
            if (this.section === null) {
                return;
            }
            var hash = this.section.generateReloadHashArgs(this.iframe.getGeneratedUrl());
            if (hash === null) {
                hash = '';
            }
            if (this.getLocationHash() === hash) {
                // Won't make any changes cause the section didn't have athe hash generator for this url
                return;
            }
            this.setHashUpdateInternal(true);
            location.hash = hash;
            setTimeout(function () {
                _this.setHashUpdateInternal(false);
            }, 0);
        };
        Manager.prototype.setHashUpdateInternal = function (value) {
            this.hashUpdateInternal = value;
        };
        Manager.prototype.getRowWrapper = function (element) {
            return element.parent();
        };
        Manager.prototype.refreshBackGround = function () {
            var backgroundWrapper = this.getRowWrapper(this.wrapper).parent();
            if (this.section !== null && this.iframe.isArticleView()) {
                backgroundWrapper.addClass(Manager.WHITE_BACKGROUND_ARTICLE_VIEW);
            }
            else {
                backgroundWrapper.removeClass(Manager.WHITE_BACKGROUND_ARTICLE_VIEW);
            }
            this.components.first().addClass(Manager.DEFAULT_BACKGROUND_ARTICLE_VIEW);
        };
        Manager.prototype.refreshFrame = function (section, sectionArgs, search) {
            var _this = this;
            setInterval(function () {
                _this.refreshBackGround();
            }, 200);
            this.searcher.clear();
            var url = section.generateUrl(sectionArgs, search);
            this.iframe.load(url);
        };
        Manager.HASH_PATTERN = /#{0,1}(.*)/;
        Manager.COL_LG10_CSSCLASS = "col-md-9 col-lg-10";
        Manager.COL_LG12_CSSCLASS = "col-md-12 col-lg-12";
        Manager.WHITE_BACKGROUND_ARTICLE_VIEW = "article-view-add-white-background";
        Manager.DEFAULT_BACKGROUND_ARTICLE_VIEW = "article-view-add-default-background";
        return Manager;
    }());
    Dashboard.Manager = Manager;
})(Dashboard || (Dashboard = {}));
//function kicks off dashboard creation
(function (vo) {
    if (vo === undefined) {
        return;
    }
    var manager = new Dashboard.Manager($('.wallet-share-dashboard-wrapper'), $('.wallet-share-dashboard-left-menu-slide-target'), $('.content'), $('.home-dashboard-iframe'));
    var parser = new Dashboard.ArgsParser(vo);
    var args = parser.parse(location.href.parseUrl('hash'));
    // Resource Center 
    var resourceSectionVO = vo.groups[Dashboard.ResourceSection.GROUP_NAME];
    var resourceSection = new Dashboard.ResourceSection(resourceSectionVO, vo.productGroupLabels, vo.routes, vo.strings);
    // Research Portal
    var researchSectionVO = vo.groups[Dashboard.ResearchSection.GROUP_NAME];
    var researchSection = new Dashboard.ResearchSection(researchSectionVO, vo.productGroupLabels, vo.routes, vo.strings);
    // Distribution Intelligence
    var distributionSectionVO = vo.companyProducts.filter(function (product) { return product.productGroup === Dashboard.DistributionIntelligenceSection.GROUP_NAME; });
    var distributionSection = new Dashboard.DistributionIntelligenceSection(distributionSectionVO, vo.strings, vo.routes, vo.templateCardType);
    if (resourceSectionVO) {
        manager.initialize(vo, args, $('#header, #footer'), resourceSection, researchSection, distributionSection);
    }
    else {
        manager.initialize(vo, args, $('#header, #footer'), researchSection, distributionSection);
    }
})(window.dashboardData);
var CardView;
(function (CardView) {
    (function (EnvironmentEnum) {
        EnvironmentEnum[EnvironmentEnum["PC"] = 1] = "PC";
        EnvironmentEnum[EnvironmentEnum["TABLET"] = 2] = "TABLET";
        EnvironmentEnum[EnvironmentEnum["MOBILE"] = 4] = "MOBILE";
    })(CardView.EnvironmentEnum || (CardView.EnvironmentEnum = {}));
    var EnvironmentEnum = CardView.EnvironmentEnum;
    (function (CardTypeEnum) {
        CardTypeEnum[CardTypeEnum["VIEW"] = 1] = "VIEW";
        CardTypeEnum[CardTypeEnum["TEMPLATE"] = 2] = "TEMPLATE";
    })(CardView.CardTypeEnum || (CardView.CardTypeEnum = {}));
    var CardTypeEnum = CardView.CardTypeEnum;
    (function (ExportType) {
        ExportType[ExportType["CSV"] = 1] = "CSV";
        ExportType[ExportType["PNG"] = 2] = "PNG";
    })(CardView.ExportType || (CardView.ExportType = {}));
    var ExportType = CardView.ExportType;
    var CardTypeUtils = (function () {
        function CardTypeUtils() {
        }
        CardTypeUtils.getType = function (type) {
            switch (type) {
                case CardTypeEnum[CardTypeEnum.VIEW]:
                    return CardTypeEnum.VIEW;
                case CardTypeEnum[CardTypeEnum.TEMPLATE]:
                    return CardTypeEnum.TEMPLATE;
            }
            return null;
        };
        CardTypeUtils.getTypeId = function (type) {
            switch (type) {
                case CardTypeEnum.VIEW:
                    return CardTypeUtils.VIEW_TYPE_ID;
                case CardTypeEnum.TEMPLATE:
                    return CardTypeUtils.TEMPLATE_TYPE_ID;
            }
            return null;
        };
        CardTypeUtils.VIEW_TYPE_ID = 'V';
        CardTypeUtils.TEMPLATE_TYPE_ID = 'T';
        return CardTypeUtils;
    }());
    CardView.CardTypeUtils = CardTypeUtils;
    var Utils = (function () {
        function Utils() {
        }
        Utils.getReportParentHeight = function () {
            var height = 
            // Parent container
            $('#wrapper').outerHeight() -
                $('#header').outerHeight() -
                $('#footer').outerHeight() -
                $('.sub-header').outerHeight() -
                // Controls above the iframe
                $('.top-controls.hidden-xs').outerHeight();
            return height;
        };
        Utils.getReportHeight = function () {
            return this.getReportParentHeight() - $('#wrapper .sheet-crumb-wrapper').outerHeight();
        };
        Utils.getReportContentHeight = function () {
            return $('.report-content').outerHeight();
        };
        return Utils;
    }());
    CardView.Utils = Utils;
    var ExpectedOrderOptions = (function () {
        function ExpectedOrderOptions() {
        }
        // Regular Filters
        ExpectedOrderOptions.getMonthOrder = function () {
            return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        };
        // Analytics Filters
        ExpectedOrderOptions.getAnalyticsCategoryMatchupOrder = function () {
            return ['Favorable', 'Neutral', 'Unfavorable', 'No Matchup Data'];
        };
        ExpectedOrderOptions.getAnalyticsUseOfNewManagersOrder = function () {
            return ['High', 'Medium', 'None', 'No Stability Score'];
        };
        ExpectedOrderOptions.getAnalyticsCategoryYearOrder = function () {
            return ['Favorable', 'Neutral', 'Unfavorable', 'No Return Data'];
        };
        // Marketing Intelligence Filter
        ExpectedOrderOptions.getWeekDayOrder = function () {
            return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        };
        return ExpectedOrderOptions;
    }());
    CardView.ExpectedOrderOptions = ExpectedOrderOptions;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var LoadInfo;
    (function (LoadInfo) {
        var SheetMetadataManager = (function () {
            function SheetMetadataManager(chartSheetName, dataTableSheetName, envType) {
                this.chartSheetName = chartSheetName;
                this.dataTableSheetName = dataTableSheetName;
                this.envType = envType;
            }
            SheetMetadataManager.prototype.getEnvironment = function () {
                return this.envType;
            };
            SheetMetadataManager.prototype.getChartSheetName = function () {
                return this.chartSheetName;
            };
            SheetMetadataManager.prototype.getDataTableSheetName = function () {
                return this.dataTableSheetName;
            };
            SheetMetadataManager.setImageExporters = function (exporters) {
                this.dataTableExportsPNG = exporters.contains(this.DATA_TABLE_SHEET_TYPE);
                this.chartExportsPNG = exporters.contains(this.CHART_SHEET_TYPE);
            };
            SheetMetadataManager.setCSVExporters = function (exporters) {
                this.dataTableExportsCSV = exporters.contains(this.DATA_TABLE_SHEET_TYPE);
                this.chartExportsCSV = exporters.contains(this.CHART_SHEET_TYPE);
            };
            SheetMetadataManager.getChartExportsPNG = function () {
                return this.chartExportsPNG;
            };
            SheetMetadataManager.getChartExportsCSV = function () {
                return this.chartExportsCSV;
            };
            SheetMetadataManager.getDatatableExportsPNG = function () {
                return this.dataTableExportsPNG;
            };
            SheetMetadataManager.getDatatableExportsCSV = function () {
                return this.dataTableExportsCSV;
            };
            SheetMetadataManager.DATA_TABLE_SHEET_TYPE = 'datatable';
            SheetMetadataManager.CHART_SHEET_TYPE = 'chart';
            SheetMetadataManager.dataTableExportsCSV = false;
            SheetMetadataManager.dataTableExportsPNG = false;
            SheetMetadataManager.chartExportsCSV = false;
            SheetMetadataManager.chartExportsPNG = false;
            return SheetMetadataManager;
        }());
        LoadInfo.SheetMetadataManager = SheetMetadataManager;
        var ReportMetadataManager = (function () {
            function ReportMetadataManager(vo) {
                SheetMetadataManager.setImageExporters(vo.imageExporters);
                SheetMetadataManager.setCSVExporters(vo.csvExporters);
                this.sheets = [new SheetMetadataManager(vo.desktopSheetName, vo.desktopDataTableSheetName, CardView.EnvironmentEnum.PC), new SheetMetadataManager(vo.tabletSheetName, vo.tabletDataTableSheetName, CardView.EnvironmentEnum.TABLET), new SheetMetadataManager(vo.mobileSheetName, vo.mobileDataTableSheetName, CardView.EnvironmentEnum.MOBILE)];
                this.reportBaseUrl = vo.reportBaseUrl;
                this.customView = vo.customView || null;
            }
            ReportMetadataManager.prototype.getReportBaseUrl = function () {
                return this.reportBaseUrl;
            };
            ReportMetadataManager.prototype.getCustomView = function () {
                return this.customView;
            };
            ReportMetadataManager.prototype.hasCustomView = function () {
                return this.getCustomView() !== null && !this.getCustomView().isEmpty();
            };
            ReportMetadataManager.prototype.getSheetByEnvironment = function (env) {
                return this.sheets.single(function (sheet) { return sheet.getEnvironment() === env; }) || null;
            };
            return ReportMetadataManager;
        }());
        var MetadataManager = (function () {
            function MetadataManager(vo) {
                this.templateId = vo.templateId;
                this.templateTitle = vo.templateTitle;
                // Report metada data, static template properties, workbooks, sheets
                this.reportMetadata = new ReportMetadataManager(vo);
                this.type = CardView.CardTypeUtils.getType(vo.type);
                this.isPublished = vo.published;
                this.isLocked = vo.locked;
                this.isShared = location.href.contains(vo.permalink);
                this.isPublishable = vo.isCompanyAdmin && vo.isAuthor && this.isView();
                this.isAuthor = vo.isAuthor;
                this.lockedId = vo.lockedId;
                this.permalink = vo.permalink;
                this.position = vo.position;
                this.backgroundColor = vo.backgroundColor;
            }
            MetadataManager.prototype.getBackgroundColor = function () {
                return this.backgroundColor;
            };
            MetadataManager.prototype.getPermalink = function () {
                return this.permalink;
            };
            MetadataManager.prototype.getTemplateTitle = function () {
                return this.templateTitle;
            };
            MetadataManager.prototype.getTemplateId = function () {
                return this.templateId;
            };
            MetadataManager.prototype.getReportMetadata = function () {
                return this.reportMetadata;
            };
            MetadataManager.prototype.isCreator = function () {
                return this.isAuthor;
            };
            MetadataManager.prototype.isTemplate = function () {
                return this.type === CardView.CardTypeEnum.TEMPLATE;
            };
            MetadataManager.prototype.isView = function () {
                return this.type === CardView.CardTypeEnum.VIEW;
            };
            MetadataManager.prototype.isSharedCard = function () {
                return this.isShared;
            };
            MetadataManager.prototype.isViewPublished = function () {
                return this.isPublished;
            };
            MetadataManager.prototype.isViewPublishable = function () {
                return this.isPublishable;
            };
            MetadataManager.prototype.getPublishedCardId = function () {
                return this.lockedId;
            };
            MetadataManager.prototype.isPublishedViewLocked = function () {
                return this.isLocked;
            };
            return MetadataManager;
        }());
        var FilterPropertiesManager = (function () {
            function FilterPropertiesManager(dimensionId, name, columnName) {
                this.dimensionId = dimensionId;
                this.name = name;
                this.columnName = columnName;
            }
            return FilterPropertiesManager;
        }());
        LoadInfo.FilterPropertiesManager = FilterPropertiesManager;
        var CardFilterPropertiesManager = (function (_super) {
            __extends(CardFilterPropertiesManager, _super);
            function CardFilterPropertiesManager(vo) {
                _super.call(this, vo.dimensionId, vo.name, vo.columnName);
                this.applyOrderChanged = false;
                this.lod = vo.useLod;
                this.applyOrder = vo.applyOrder;
                this.filterId = vo.filterId;
                this.setInitialOptions(vo.options);
            }
            CardFilterPropertiesManager.prototype.wasApplyOrderChanged = function () {
                return this.applyOrderChanged;
            };
            CardFilterPropertiesManager.prototype.useLod = function () {
                return this.lod;
            };
            CardFilterPropertiesManager.prototype.getFilterId = function () {
                return this.filterId;
            };
            CardFilterPropertiesManager.prototype.getApplyOrder = function () {
                return this.applyOrder;
            };
            CardFilterPropertiesManager.prototype.setApplyOrder = function (applyOrder) {
                if (this.applyOrder === applyOrder) {
                    return;
                }
                this.applyOrderChanged = true;
                this.applyOrder = applyOrder;
            };
            CardFilterPropertiesManager.prototype.hasApplyOrder = function () {
                return this.getApplyOrder() !== null;
            };
            CardFilterPropertiesManager.prototype.hasOptions = function () {
                return Array.isArray(this.getInitialOptions());
            };
            CardFilterPropertiesManager.prototype.getName = function () {
                return this.name;
            };
            CardFilterPropertiesManager.prototype.getColumnName = function () {
                return this.columnName;
            };
            CardFilterPropertiesManager.prototype.getInitialOptions = function () {
                return this.initialOptions;
            };
            CardFilterPropertiesManager.prototype.setInitialOptions = function (options) {
                this.initialOptions = options;
            };
            CardFilterPropertiesManager.prototype.getDimensionId = function () {
                return this.dimensionId;
            };
            return CardFilterPropertiesManager;
        }(FilterPropertiesManager));
        LoadInfo.CardFilterPropertiesManager = CardFilterPropertiesManager;
        var CardSalesFilterPropertiesManager = (function (_super) {
            __extends(CardSalesFilterPropertiesManager, _super);
            function CardSalesFilterPropertiesManager(vo) {
                _super.call(this, vo.dimensionId, vo.name, vo.columnName);
                this.filterId = vo.filterId;
                this.options = vo.options;
                this.initialApplied = vo.initialApplied;
            }
            CardSalesFilterPropertiesManager.prototype.getName = function () {
                return this.name;
            };
            CardSalesFilterPropertiesManager.prototype.getColumnName = function () {
                return this.columnName;
            };
            CardSalesFilterPropertiesManager.prototype.getDimensionId = function () {
                return this.dimensionId;
            };
            CardSalesFilterPropertiesManager.prototype.getFilterId = function () {
                return this.filterId;
            };
            CardSalesFilterPropertiesManager.prototype.getOptions = function () {
                return this.options;
            };
            CardSalesFilterPropertiesManager.prototype.getInitialApplied = function () {
                return this.initialApplied;
            };
            return CardSalesFilterPropertiesManager;
        }(FilterPropertiesManager));
        LoadInfo.CardSalesFilterPropertiesManager = CardSalesFilterPropertiesManager;
        var CardParameterProperties = (function () {
            function CardParameterProperties(vo) {
                this.allowableValues = vo.allowableValues;
                this.allowableValuesType = vo.allowableValuesType;
                this.initialValue = vo.currentValue;
                this.dataType = vo.dataType;
                this.dateStepPeriod = vo.dateStepPeriod;
                this.id = vo.parameterId;
                this.maxValue = vo.maxValue;
                this.minValue = vo.minValue;
                this.name = vo.name;
                this.stepSize = vo.stepSize;
            }
            CardParameterProperties.prototype.getAllowableValues = function () {
                return this.allowableValues;
            };
            CardParameterProperties.prototype.getAllowableValuesType = function () {
                return this.allowableValuesType;
            };
            CardParameterProperties.prototype.getInitialValue = function () {
                return this.initialValue;
            };
            CardParameterProperties.prototype.getDataType = function () {
                return this.dataType;
            };
            CardParameterProperties.prototype.getDateStepPeriod = function () {
                return this.dateStepPeriod;
            };
            CardParameterProperties.prototype.getId = function () {
                return this.id;
            };
            CardParameterProperties.prototype.getMaxValue = function () {
                return this.maxValue;
            };
            CardParameterProperties.prototype.getMinValue = function () {
                return this.minValue;
            };
            CardParameterProperties.prototype.getName = function () {
                return this.name;
            };
            CardParameterProperties.prototype.getStepSize = function () {
                return this.stepSize;
            };
            return CardParameterProperties;
        }());
        var PropertiesManager = (function () {
            function PropertiesManager(vo) {
                this.cardId = vo.cardId;
                this.setCustomView(vo.customView);
                this.title = vo.title;
                this.filters = vo.filters.map(function (filterVO) {
                    return new CardFilterPropertiesManager(filterVO);
                });
                this.salesFilter = vo.salesFilters.map(function (salesFilterVO) {
                    return new CardSalesFilterPropertiesManager(salesFilterVO);
                });
                this.focusDimension = vo.focusDimension;
                this.productsPermission = vo.productsPermission;
                this.templatePermissions = vo.templatePermissions;
                this.applyDefaultFilters(vo.defaultFilters);
                if (Array.isArray(vo.parameters)) {
                    this.parameters = vo.parameters.map(function (parameterVO) {
                        return new CardParameterProperties(parameterVO);
                    });
                }
                else {
                    this.parameters = [];
                }
            }
            PropertiesManager.prototype.applyDefaultFilters = function (defaultFilters) {
                var nonAppliedFilters = {};
                var maxOrder = 0;
                this.filters.forEach(function (filter) {
                    if (filter.hasApplyOrder()) {
                        maxOrder = Math.max(maxOrder, filter.getApplyOrder());
                    }
                    else {
                        nonAppliedFilters[filter.getName()] = filter;
                    }
                });
                Object.keys(nonAppliedFilters).forEach(function (dimensionName) {
                    var defaultOptions = defaultFilters[dimensionName] || null;
                    if (Array.isArray(defaultOptions)) {
                        var filter = nonAppliedFilters[dimensionName];
                        filter.setApplyOrder(++maxOrder);
                        filter.setInitialOptions(defaultOptions.map(function (option) { return { selected: true, formattedValue: option.formattedValue, value: option.value }; }));
                    }
                });
                return maxOrder;
            };
            PropertiesManager.prototype.setCustomView = function (customView) {
                this.customView = customView;
            };
            PropertiesManager.prototype.getCustomView = function () {
                return this.customView;
            };
            PropertiesManager.prototype.getFilters = function () {
                return this.filters;
            };
            PropertiesManager.prototype.getSalesFilters = function () {
                return this.salesFilter;
            };
            PropertiesManager.prototype.getParameters = function () {
                return this.parameters;
            };
            PropertiesManager.prototype.getProductsPermission = function () {
                return this.productsPermission;
            };
            PropertiesManager.prototype.getTemplatePermissions = function () {
                return this.templatePermissions;
            };
            PropertiesManager.prototype.getTitle = function () {
                return this.title;
            };
            PropertiesManager.prototype.getCardId = function () {
                return this.cardId;
            };
            PropertiesManager.prototype.getFocusDimension = function () {
                return this.focusDimension;
            };
            return PropertiesManager;
        }());
        LoadInfo.PropertiesManager = PropertiesManager;
        var EnvironmentalPropertiesManager = (function () {
            function EnvironmentalPropertiesManager(vo) {
                if (Utils.isMobile()) {
                    this.env = CardView.EnvironmentEnum.MOBILE;
                    return;
                }
                if (Utils.isTablet()) {
                    this.env = CardView.EnvironmentEnum.TABLET;
                    return;
                }
                this.env = CardView.EnvironmentEnum.PC;
            }
            EnvironmentalPropertiesManager.prototype.getEnvironmentType = function () {
                return this.env;
            };
            return EnvironmentalPropertiesManager;
        }());
        LoadInfo.EnvironmentalPropertiesManager = EnvironmentalPropertiesManager;
        var Strings = (function () {
            function Strings(strings) {
                this.strings = strings;
            }
            Strings.prototype.raw = function () {
                console.log('This method is deprecated, it\'s here to avoid maintenance');
                return this.strings;
            };
            Strings.prototype.getDataDisclaimer = function () {
                return this.strings['dataDisclaimer'];
            };
            Strings.prototype.getMatchesFoundPlural = function () {
                return this.strings['matchesFoundPlural'];
            };
            Strings.prototype.getMatchesFoundSingle = function () {
                return this.strings['matchesFoundSingle'];
            };
            Strings.prototype.hasDataDisclaimer = function () {
                return !this.getDataDisclaimer().isEmpty();
            };
            Strings.prototype.getErrorDeletingMessage = function () {
                return this.strings['errorDeletingMessage'];
            };
            Strings.prototype.getErrorSavingMessage = function () {
                return this.strings['errorSavingMessage'];
            };
            Strings.prototype.getSelectAllCheckboxLabel = function () {
                return this.strings['selectAllCheckboxLabel'];
            };
            Strings.prototype.getSideMenuDisabledFilterPopoverTitle = function () {
                return this.strings['sideMenuDisabledFilterPopoverTitle'];
            };
            Strings.prototype.getSideMenuDisabledFilterPopoverContent = function () {
                return this.strings['sideMenuDisabledFilterPopoverContent'];
            };
            Strings.prototype.getPlaceholder = function () {
                return this.strings['searchPlaceholder'];
            };
            Strings.prototype.getGenericErrorNoticeTitle = function () {
                return this.strings['genericErrorNoticeTitle'];
            };
            Strings.prototype.getGenericErrorNoticeSubtitle = function () {
                return this.strings['genericErrorNoticeSubtitle'];
            };
            Strings.prototype.getNoResultsSubtitle = function () {
                return this.strings['noResultsSubtitle'];
            };
            Strings.prototype.getNoResultsTitle = function () {
                return this.strings['noResultsTitle'];
            };
            Strings.prototype.getManagementOverviewMobileError = function () {
                return this.strings['managementOverviewMobileError'];
            };
            Strings.prototype.getDivisionsLabel = function () {
                return this.strings['divisionsLabel'];
            };
            Strings.prototype.getTerritoriesLabel = function () {
                return this.strings['territoriesLabel'];
            };
            Strings.prototype.getVehicleLabel = function () {
                return this.strings['vehicleLabel'];
            };
            Strings.prototype.getRelationshipLabel = function () {
                return this.strings['relationshipLabel'];
            };
            Strings.prototype.getChannelsLabel = function () {
                return this.strings['channelsLabel'];
            };
            Strings.prototype.getFirmsLabel = function () {
                return this.strings['firmsLabel'];
            };
            Strings.prototype.getCategoriesLabel = function () {
                return this.strings['categoriesLabel'];
            };
            Strings.prototype.getProductsLabel = function () {
                return this.strings['productsLabel'];
            };
            Strings.prototype.getQuartersLabel = function () {
                return this.strings['quartersLabel'];
            };
            Strings.prototype.getYearsLabel = function () {
                return this.strings['yearsLabel'];
            };
            Strings.prototype.getMonthsLabel = function () {
                return this.strings['monthsLabel'];
            };
            Strings.prototype.getStatesLabel = function () {
                return this.strings['statesLabel'];
            };
            Strings.prototype.getCitiesLabel = function () {
                return this.strings['citiesLabel'];
            };
            Strings.prototype.getMetrocodesLabel = function () {
                return this.strings['metrocodesLabel'];
            };
            Strings.prototype.getZipcodesLabel = function () {
                return this.strings['zipcodesLabel'];
            };
            Strings.prototype.getAddressesLabel = function () {
                return this.strings['addressesLabel'];
            };
            Strings.prototype.getOfficesLabel = function () {
                return this.strings['officesLabel'];
            };
            Strings.prototype.getAssetClassesLabel = function () {
                return this.strings['assetClassesLabel'];
            };
            Strings.prototype.getRangeLabel = function () {
                return this.strings['rangeLabel'];
            };
            Strings.prototype.getApplyButtonLabel = function () {
                return this.strings['applyButtonLabel'];
            };
            Strings.prototype.getClearButtonLabel = function () {
                return this.strings['clearButtonLabel'];
            };
            Strings.prototype.getNoResultsMessageLabel = function () {
                return this.strings['noResultsMessage'];
            };
            Strings.prototype.getShareMailtoSubject = function () {
                return this.strings['shareMailtoSubject'];
            };
            Strings.prototype.getShareMailtoBody = function () {
                return this.strings['shareMailtoBody'];
            };
            Strings.prototype.getShareError = function () {
                return this.strings['shareError'];
            };
            Strings.prototype.getALlLabel = function () {
                return this.strings['allLabel'];
            };
            Strings.prototype.getFocusLabel = function () {
                return this.strings['focusLabel'];
            };
            Strings.prototype.getRotationBuilderMessage = function () {
                return this.strings['rotationBuilderMessage'];
            };
            Strings.prototype.getHomeOfficeLabel = function () {
                return this.strings['homeOfficeLabel'];
            };
            Strings.prototype.getRatingMatchupLabel = function () {
                return this.strings['ratingMatchupLabel'];
            };
            Strings.prototype.getExpenseMatchupLabel = function () {
                return this.strings['expenseMatchupLabel'];
            };
            Strings.prototype.getAssetManagerStabilityScoreLabel = function () {
                return this.strings['assetManagerStabilityScoreLabel'];
            };
            Strings.prototype.getFirstYearMatchupReturnLabel = function () {
                return this.strings['firstYearMatchupReturnLabel'];
            };
            Strings.prototype.getThirdYearMatchupReturnLabel = function () {
                return this.strings['thirdYearMatchupReturnLabel'];
            };
            Strings.prototype.getFiveYearMatchupReturnLabel = function () {
                return this.strings['fiveYearMatchupReturnLabel'];
            };
            Strings.prototype.getThirdYearSharpeReturnLabel = function () {
                return this.strings['thirdYearSharpeReturnLabel'];
            };
            Strings.prototype.getIncludeLabel = function () {
                return this.strings['includeLabel'];
            };
            Strings.prototype.getMarketShareLabel = function () {
                return this.strings['marketShareLabel'];
            };
            Strings.prototype.getGrossSalesLabel = function () {
                return this.strings['grossSalesLabel'];
            };
            Strings.prototype.getIndustryGrossSalesLabel = function () {
                return this.strings['industryGrossSalesLabel'];
            };
            Strings.prototype.getNetSalesLabel = function () {
                return this.strings['netSalesLabel'];
            };
            Strings.prototype.getIndustryNetSalesLabel = function () {
                return this.strings['industryNetSalesLabel'];
            };
            Strings.prototype.getSalesFilterRangeLabel = function () {
                return this.strings['salesFilterRangeLabel'];
            };
            Strings.prototype.getSalesFilterRangeAvailabilityLabel = function () {
                return this.strings['salesFilterRangeAvailability'];
            };
            Strings.prototype.getReportRunningMessage = function () {
                return this.strings['reportRunningMessage'];
            };
            Strings.prototype.getFiltersAppliedIncluded = function () {
                return this.strings['filterAppliedIncluded'];
            };
            Strings.prototype.getFiltersAppliedNotIncluded = function () {
                return this.strings['filterAppliedNotIncluded'];
            };
            Strings.prototype.getFiltersAppliedLabel = function () {
                return this.strings['filtersAppliedLabel'];
            };
            Strings.prototype.getFilterAppliedTooManyOptions = function () {
                return this.strings['filterAppliedTooManyOptions'];
            };
            Strings.prototype.getUntitledCardTitle = function () {
                return this.strings['untitled'];
            };
            Strings.prototype.getInitialCardTitle = function () {
                return this.strings['initialCardTitle'];
            };
            return Strings;
        }());
        LoadInfo.Strings = Strings;
        var Urls = (function () {
            function Urls(urls) {
                this.templatesUrl = urls.templatesDash;
                this.userDashUrl = urls.userDash;
                this.createCard = urls.createCard;
                this.showCard = decodeURI(urls.showCard);
                this.updateCard = urls.updateCard;
                this.createShareeCard = urls.createShareeCard;
                this.deleteCard = urls.deleteCard;
                this.showPublishModal = urls.showPublishModal;
                this.publishCard = urls.publishCard;
                this.excludeFromCard = urls.excludeFromCard;
                this.sharedFocusFilters = urls.sharedFocusFilters;
                this.contextSales = urls.contextSales;
            }
            Urls.prototype.getUpdateCardUrl = function () {
                return this.updateCard;
            };
            Urls.prototype.getTemplatesDashboardUrl = function () {
                return this.templatesUrl;
            };
            Urls.prototype.getCreateCardUrl = function () {
                return this.createCard;
            };
            Urls.prototype.getDeleteCardUrl = function () {
                return this.deleteCard;
            };
            Urls.prototype.getCreateShareeCardUrl = function () {
                return this.createShareeCard;
            };
            Urls.prototype.getUserDashboardUrl = function () {
                return this.userDashUrl;
            };
            Urls.prototype.getShowCardUrl = function (id, type) {
                return this.showCard.replace('00', CardView.CardTypeUtils.getTypeId(type) + id);
            };
            Urls.prototype.getPublishCardModalUrl = function (id) {
                return this.showPublishModal.replace('0', String(id));
            };
            Urls.prototype.getPublishCardUrl = function () {
                return this.publishCard;
            };
            Urls.prototype.getExcludePublishedCardUrl = function () {
                return this.excludeFromCard;
            };
            Urls.prototype.getSharedFocusFiltersUrl = function () {
                return this.sharedFocusFilters;
            };
            Urls.prototype.getContextSalesUrl = function () {
                return this.contextSales;
            };
            return Urls;
        }());
        LoadInfo.Urls = Urls;
        var Manager = (function () {
            function Manager(vo) {
                // Card metada data
                this.cardMetadata = new MetadataManager(vo);
                this.properties = new PropertiesManager(vo);
                this.envProperties = new EnvironmentalPropertiesManager(vo);
                this.strings = new Strings(vo.strings);
                this.urls = new Urls(vo.urls);
            }
            Manager.prototype.getCardMetadata = function () {
                return this.cardMetadata;
            };
            Manager.prototype.getEnvironmentProperties = function () {
                return this.envProperties;
            };
            Manager.prototype.getProperties = function () {
                return this.properties;
            };
            Manager.prototype.getStrings = function () {
                return this.strings;
            };
            Manager.prototype.getUrls = function () {
                return this.urls;
            };
            return Manager;
        }());
        LoadInfo.Manager = Manager;
    })(LoadInfo = CardView.LoadInfo || (CardView.LoadInfo = {}));
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    (function (FilterGroupType) {
        FilterGroupType[FilterGroupType["TIMEFRAME"] = 90] = "TIMEFRAME";
        FilterGroupType[FilterGroupType["LOCATION"] = 80] = "LOCATION";
        FilterGroupType[FilterGroupType["OFFICE"] = 70] = "OFFICE";
        FilterGroupType[FilterGroupType["ADVISOR"] = 60] = "ADVISOR";
        FilterGroupType[FilterGroupType["ANALYTICS"] = 50] = "ANALYTICS";
        FilterGroupType[FilterGroupType["ALTLOCATION"] = 81] = "ALTLOCATION";
        FilterGroupType[FilterGroupType["ANALYTICS_OFFICE"] = 40] = "ANALYTICS_OFFICE";
        FilterGroupType[FilterGroupType["ANALYTICS_CATEGORY"] = 30] = "ANALYTICS_CATEGORY";
        FilterGroupType[FilterGroupType["SALES"] = 20] = "SALES";
    })(CardView.FilterGroupType || (CardView.FilterGroupType = {}));
    var FilterGroupType = CardView.FilterGroupType;
    (function (FilterRenderDepth) {
        FilterRenderDepth[FilterRenderDepth["TOP"] = 0] = "TOP";
        FilterRenderDepth[FilterRenderDepth["IN_CATEGORY"] = 1] = "IN_CATEGORY";
        FilterRenderDepth[FilterRenderDepth["IN_FILTER_GROUP"] = 2] = "IN_FILTER_GROUP";
    })(CardView.FilterRenderDepth || (CardView.FilterRenderDepth = {}));
    var FilterRenderDepth = CardView.FilterRenderDepth;
    (function (FilterLocation) {
        FilterLocation[FilterLocation["SIDE_MENU"] = 1] = "SIDE_MENU";
        FilterLocation[FilterLocation["TOP"] = 2] = "TOP";
    })(CardView.FilterLocation || (CardView.FilterLocation = {}));
    var FilterLocation = CardView.FilterLocation;
    var FilterConfigFactory = (function () {
        function FilterConfigFactory() {
            this.conf = {};
        }
        FilterConfigFactory.prototype.addConfig = function (config) {
            this.conf[this.hash(config)] = config;
        };
        FilterConfigFactory.prototype.setDefaultConfig = function (config) {
            this.default = config;
        };
        FilterConfigFactory.prototype.getConfig = function (name) {
            return jQuery.extend({}, this.default, this.conf[name]);
        };
        return FilterConfigFactory;
    }());
    CardView.FilterConfigFactory = FilterConfigFactory;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var ParameterConfigFactory = (function (_super) {
        __extends(ParameterConfigFactory, _super);
        function ParameterConfigFactory() {
            _super.apply(this, arguments);
        }
        ParameterConfigFactory.prototype.hash = function (config) {
            return config.name;
        };
        ParameterConfigFactory.getInstance = function () {
            return this.instance;
        };
        ParameterConfigFactory.instance = new ParameterConfigFactory();
        return ParameterConfigFactory;
    }(CardView.FilterConfigFactory));
    CardView.ParameterConfigFactory = ParameterConfigFactory;
    ParameterConfigFactory.getInstance().addConfig({
        name: 'Quarter',
        position: 75,
        parent: CardView.FilterGroupType.TIMEFRAME,
        id: 'ws-parameter-filter-quarter'
    });
    ParameterConfigFactory.getInstance().addConfig({
        name: 'Dimension',
        position: 50,
        location: CardView.FilterLocation.TOP,
        label: 'View By',
        parent: null,
        id: 'ws-parameter-filter-dimension'
    });
    ParameterConfigFactory.getInstance().addConfig({
        name: 'Analysis',
        position: 40,
        location: CardView.FilterLocation.TOP,
        label: 'Comparison',
        parent: null,
        id: 'ws-parameter-filter-analysis'
    });
    ParameterConfigFactory.getInstance().addConfig({
        name: 'XAxis',
        position: 40,
        location: CardView.FilterLocation.TOP,
        label: 'X Axis',
        parent: null,
        id: 'ws-parameter-filter-x-axis'
    });
    ParameterConfigFactory.getInstance().addConfig({
        name: 'YAxis',
        position: 30,
        location: CardView.FilterLocation.TOP,
        label: 'Y Axis',
        parent: null,
        id: 'ws-parameter-filter-y-axis'
    });
    ParameterConfigFactory.getInstance().addConfig({
        name: 'Analysis Q/Q',
        position: 40,
        location: CardView.FilterLocation.TOP,
        parent: null,
        id: 'ws-parameter-filter-analysis-q-q'
    });
    ParameterConfigFactory.getInstance().addConfig({
        name: 'Top/Trailing',
        position: 100,
        location: CardView.FilterLocation.SIDE_MENU,
        parent: CardView.FilterGroupType.SALES,
        id: ''
    });
    ParameterConfigFactory.getInstance().addConfig({
        name: 'Top',
        position: 105,
        location: CardView.FilterLocation.SIDE_MENU,
        parent: CardView.FilterGroupType.SALES,
        id: 'ws-parameter-filter-top'
    });
    ParameterConfigFactory.getInstance().addConfig({
        name: 'Bottom',
        position: 110,
        location: CardView.FilterLocation.SIDE_MENU,
        parent: CardView.FilterGroupType.SALES,
        id: 'ws-parameter-filter-bottom'
    });
    ParameterConfigFactory.getInstance().addConfig({
        name: 'Status',
        position: 10,
        location: CardView.FilterLocation.SIDE_MENU,
        parent: null,
        id: 'ws-parameter-filter-status'
    });
    ParameterConfigFactory.getInstance().setDefaultConfig({
        name: null,
        position: 0,
        location: CardView.FilterLocation.SIDE_MENU,
        label: null,
        parent: null,
        id: null
    });
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var CategoricalFilterConfigFactory = (function (_super) {
        __extends(CategoricalFilterConfigFactory, _super);
        function CategoricalFilterConfigFactory() {
            _super.apply(this, arguments);
        }
        CategoricalFilterConfigFactory.prototype.hash = function (config) {
            return config.name;
        };
        CategoricalFilterConfigFactory.getInstance = function () {
            return this.instance;
        };
        CategoricalFilterConfigFactory.instance = new CategoricalFilterConfigFactory();
        return CategoricalFilterConfigFactory;
    }(CardView.FilterConfigFactory));
    CardView.CategoricalFilterConfigFactory = CategoricalFilterConfigFactory;
    // Regular Filters
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Division',
        pluralNameGetter: function (strings) { return strings.getDivisionsLabel(); },
        position: 100,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.LOCATION,
        id: 'ws-categorical-filter-division'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Territory',
        pluralNameGetter: function (strings) { return strings.getTerritoriesLabel(); },
        position: 95,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.LOCATION,
        id: 'ws-categorical-filter-territory'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Channel',
        pluralNameGetter: function (strings) { return strings.getChannelsLabel(); },
        position: 90,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: null,
        id: 'ws-categorical-filter-channel'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Firm',
        pluralNameGetter: function (strings) { return strings.getFirmsLabel(); },
        position: 85,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: null,
        id: 'ws-categorical-filter-firm'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Asset Class',
        pluralNameGetter: function (strings) { return strings.getAssetClassesLabel(); },
        position: 80,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: null,
        id: 'ws-categorical-filter-asset-class'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Category',
        pluralNameGetter: function (strings) { return strings.getCategoriesLabel(); },
        position: 79,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: true,
        parent: null,
        id: 'ws-categorical-filter-category'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Product',
        pluralNameGetter: function (strings) { return strings.getProductsLabel(); },
        position: 75,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: null,
        id: 'ws-categorical-filter-product'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Quarter',
        label: 'Timeframe',
        pluralNameGetter: function (strings) { return strings.getQuartersLabel(); },
        position: 70,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.TIMEFRAME,
        id: 'ws-categorical-filter-quarter'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Year',
        pluralNameGetter: function (strings) { return strings.getYearsLabel(); },
        position: 65,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.TIMEFRAME,
        id: 'ws-categorical-filter-year'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Month',
        pluralNameGetter: function (strings) { return strings.getMonthsLabel(); },
        position: 60,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        order: function (curr, next) {
            return CardView.ExpectedOrderOptions.getMonthOrder().indexOf(curr.label) - CardView.ExpectedOrderOptions.getMonthOrder().indexOf(next.label);
        },
        parent: CardView.FilterGroupType.TIMEFRAME,
        id: 'ws-categorical-filter-month'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'State',
        pluralNameGetter: function (strings) { return strings.getStatesLabel(); },
        position: 55,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.LOCATION,
        id: 'ws-categorical-filter-state'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'City',
        pluralNameGetter: function (strings) { return strings.getCitiesLabel(); },
        position: 50,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.LOCATION,
        id: 'ws-categorical-filter-city'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Metro Code',
        pluralNameGetter: function (strings) { return strings.getMetrocodesLabel(); },
        position: 45,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.LOCATION,
        id: 'ws-categorical-filter-metro-code'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Zip Code',
        pluralNameGetter: function (strings) { return strings.getZipcodesLabel(); },
        position: 40,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.LOCATION,
        id: 'ws-categorical-filter-zip-code'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Address',
        pluralNameGetter: function (strings) { return strings.getAddressesLabel(); },
        position: 35,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.LOCATION,
        id: 'ws-categorical-filter-address'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Office',
        pluralNameGetter: function (strings) { return strings.getOfficesLabel(); },
        position: 30,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.LOCATION,
        id: 'ws-categorical-filter-office'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Vehicle',
        pluralNameGetter: function (strings) { return strings.getVehicleLabel(); },
        position: 20,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: null,
        id: 'ws-categorical-filter-vehicle'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Relationship',
        pluralNameGetter: function (strings) { return strings.getRelationshipLabel(); },
        position: 10,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: null,
        id: 'ws-categorical-filter-relationship'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'HomeOffice',
        pluralNameGetter: function (strings) { return strings.getHomeOfficeLabel(); },
        position: 5,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: null,
        id: 'ws-categorical-filter-home-office'
    });
    CategoricalFilterConfigFactory.getInstance().setDefaultConfig({
        name: null,
        position: 0,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        order: function (curr, next) {
            return curr.label > next.label ? 1 : -1;
        },
        parent: null,
        id: null
    });
    // Analytics Filters
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Rating Matchup',
        pluralNameGetter: function (strings) { return strings.getRatingMatchupLabel(); },
        position: 145,
        location: CardView.FilterLocation.SIDE_MENU,
        order: function (curr, next) {
            return CardView.ExpectedOrderOptions.getAnalyticsCategoryMatchupOrder().indexOf(curr.label) - CardView.ExpectedOrderOptions.getAnalyticsCategoryMatchupOrder().indexOf(next.label);
        },
        disclaimed: false,
        parent: CardView.FilterGroupType.ANALYTICS_CATEGORY,
        id: 'ws-categorical-filter-rating-matchup'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Expense Matchup',
        pluralNameGetter: function (strings) { return strings.getExpenseMatchupLabel(); },
        position: 140,
        location: CardView.FilterLocation.SIDE_MENU,
        order: function (curr, next) {
            return CardView.ExpectedOrderOptions.getAnalyticsCategoryMatchupOrder().indexOf(curr.label) - CardView.ExpectedOrderOptions.getAnalyticsCategoryMatchupOrder().indexOf(next.label);
        },
        disclaimed: false,
        parent: CardView.FilterGroupType.ANALYTICS_CATEGORY,
        id: 'ws-categorical-filter-expense-matchup'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Use of New Managers',
        pluralNameGetter: function (strings) { return strings.getAssetManagerStabilityScoreLabel(); },
        position: 135,
        location: CardView.FilterLocation.SIDE_MENU,
        order: function (curr, next) {
            return CardView.ExpectedOrderOptions.getAnalyticsUseOfNewManagersOrder().indexOf(curr.label) - CardView.ExpectedOrderOptions.getAnalyticsUseOfNewManagersOrder().indexOf(next.label);
        },
        disclaimed: false,
        parent: CardView.FilterGroupType.ANALYTICS_CATEGORY,
        id: 'ws-categorical-filter-use-of-new-managers'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: '1yr Return',
        pluralNameGetter: function (strings) { return strings.getFirstYearMatchupReturnLabel(); },
        position: 130,
        location: CardView.FilterLocation.SIDE_MENU,
        order: function (curr, next) {
            return CardView.ExpectedOrderOptions.getAnalyticsCategoryYearOrder().indexOf(curr.label) - CardView.ExpectedOrderOptions.getAnalyticsCategoryYearOrder().indexOf(next.label);
        },
        disclaimed: false,
        parent: CardView.FilterGroupType.ANALYTICS_CATEGORY,
        id: 'ws-categorical-filter-first-year-return'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: '3yr Return',
        pluralNameGetter: function (strings) { return strings.getThirdYearMatchupReturnLabel(); },
        position: 125,
        location: CardView.FilterLocation.SIDE_MENU,
        order: function (curr, next) {
            return CardView.ExpectedOrderOptions.getAnalyticsCategoryYearOrder().indexOf(curr.label) - CardView.ExpectedOrderOptions.getAnalyticsCategoryYearOrder().indexOf(next.label);
        },
        disclaimed: false,
        parent: CardView.FilterGroupType.ANALYTICS_CATEGORY,
        id: 'ws-categorical-filter-third-year-return'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: '5yr Return',
        pluralNameGetter: function (strings) { return strings.getFiveYearMatchupReturnLabel(); },
        position: 120,
        location: CardView.FilterLocation.SIDE_MENU,
        order: function (curr, next) {
            return CardView.ExpectedOrderOptions.getAnalyticsCategoryYearOrder().indexOf(curr.label) - CardView.ExpectedOrderOptions.getAnalyticsCategoryYearOrder().indexOf(next.label);
        },
        disclaimed: false,
        parent: CardView.FilterGroupType.ANALYTICS_CATEGORY,
        id: 'ws-categorical-filter-fifth-year-return'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: '3yr Sharpe Ratio',
        pluralNameGetter: function (strings) { return strings.getThirdYearSharpeReturnLabel(); },
        position: 115,
        location: CardView.FilterLocation.SIDE_MENU,
        order: function (curr, next) {
            return CardView.ExpectedOrderOptions.getAnalyticsCategoryYearOrder().indexOf(curr.label) - CardView.ExpectedOrderOptions.getAnalyticsCategoryYearOrder().indexOf(next.label);
        },
        disclaimed: false,
        parent: CardView.FilterGroupType.ANALYTICS_CATEGORY,
        id: 'ws-categorical-filter-third-sharpe-ratio'
    });
    // Sales Filters
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Gross Sales',
        pluralNameGetter: function (strings) { return strings.getGrossSalesLabel(); },
        position: 160,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.SALES,
        id: 'ws-categorical-filter-gross-sales',
        salesType: 'positive'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Market Share',
        pluralNameGetter: function (strings) { return strings.getMarketShareLabel(); },
        position: 155,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.SALES,
        id: 'ws-categorical-filter-market-share',
        salesType: 'percentage'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Industry Gross Sales',
        pluralNameGetter: function (strings) { return strings.getIndustryGrossSalesLabel(); },
        position: 150,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.SALES,
        id: 'ws-categorical-filter-industry-gross-sales',
        salesType: 'positive'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Net Sales',
        pluralNameGetter: function (strings) { return strings.getNetSalesLabel(); },
        position: 145,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.SALES,
        id: 'ws-categorical-filter-net-sales',
        salesType: 'negative'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Industry Net Sales',
        pluralNameGetter: function (strings) { return strings.getIndustryNetSalesLabel(); },
        position: 140,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.SALES,
        id: 'ws-categorical-filter-industry-net-sales',
        salesType: 'negative'
    });
    // Alt Filters
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Alt-Channel',
        pluralNameGetter: function (strings) { return strings.getChannelsLabel(); },
        position: 90,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: null,
        id: 'ws-alt-categorical-filter-channel'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Alt-Division',
        pluralNameGetter: function (strings) { return strings.getDivisionsLabel(); },
        position: 100,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.ALTLOCATION,
        id: 'ws-alt-categorical-filter-division'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Alt-Territory',
        pluralNameGetter: function (strings) { return strings.getTerritoriesLabel(); },
        position: 95,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.ALTLOCATION,
        id: 'ws-alt-categorical-filter-territory'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Alt-Firm',
        pluralNameGetter: function (strings) { return strings.getFirmsLabel(); },
        position: 85,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: null,
        id: 'ws-alt-categorical-filter-firm'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Alt-State',
        pluralNameGetter: function (strings) { return strings.getStatesLabel(); },
        position: 55,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.ALTLOCATION,
        id: 'ws-alt-categorical-filter-state'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Alt-City',
        pluralNameGetter: function (strings) { return strings.getCitiesLabel(); },
        position: 50,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.ALTLOCATION,
        id: 'ws-alt-categorical-filter-city'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Alt-Metro Code',
        pluralNameGetter: function (strings) { return strings.getMetrocodesLabel(); },
        position: 45,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.ALTLOCATION,
        id: 'ws-alt-categorical-filter-metro-code'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Alt-Zip Code',
        pluralNameGetter: function (strings) { return strings.getZipcodesLabel(); },
        position: 40,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.ALTLOCATION,
        id: 'ws-alt-categorical-filter-zip-code'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Alt-Address',
        pluralNameGetter: function (strings) { return strings.getAddressesLabel(); },
        position: 35,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.ALTLOCATION,
        id: 'ws-alt-categorical-filter-address'
    });
    CategoricalFilterConfigFactory.getInstance().addConfig({
        name: 'Alt-Office',
        pluralNameGetter: function (strings) { return strings.getOfficesLabel(); },
        position: 30,
        location: CardView.FilterLocation.SIDE_MENU,
        disclaimed: false,
        parent: CardView.FilterGroupType.ALTLOCATION,
        id: 'ws-alt-categorical-filter-office'
    });
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var ValueManager = (function () {
        function ValueManager(initialValue) {
            this.applied = this.clone(initialValue);
            this.reset();
        }
        ValueManager.prototype.getValue = function () {
            return this.current;
        };
        ValueManager.prototype.getAppliedValue = function () {
            return this.applied;
        };
        ValueManager.prototype.setValue = function (value) {
            this.current = value;
        };
        ValueManager.prototype.reset = function () {
            this.current = this.clone(this.applied);
        };
        ValueManager.prototype.apply = function () {
            this.applied = this.clone(this.current);
        };
        ValueManager.prototype.isApplicable = function () {
            return !this.equals(this.applied, this.current);
        };
        ValueManager.prototype.cloneValue = function () {
            return this.clone(this.current);
        };
        ValueManager.prototype.isApplied = function (other) {
            return this.equals(this.applied, other);
        };
        return ValueManager;
    }());
    CardView.ValueManager = ValueManager;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var FilterUtils = (function () {
        function FilterUtils() {
        }
        FilterUtils.isNameHidden = function (name) {
            return this.HIDE_ME_PATTERNS.some(function (pattern) { return pattern.test(name); });
        };
        FilterUtils.HIDE_ME_PATTERNS = [/_hideme_/];
        return FilterUtils;
    }());
    CardView.FilterUtils = FilterUtils;
    var Filter = (function () {
        function Filter(info, staticConfig, strings) {
            this.name = info.name;
            this.config = staticConfig;
            this.isOpen = null;
            this.disabled = false;
            this.rendered = null;
            this.renderedLabel = null;
            this.renderedIcon = null;
            this.applyButtonLabel = strings.getApplyButtonLabel();
            this.applyHandlers = new ListenersCollection();
            this.expandedHandlers = new ListenersCollection();
            this.collapseHandlers = new ListenersCollection();
        }
        Filter.prototype.getName = function () {
            return this.name;
        };
        Filter.prototype.getParentType = function () {
            return this.config.parent;
        };
        Filter.prototype.getType = function () {
            return this.getConfig().location;
        };
        Filter.prototype.getPosition = function () {
            return this.getConfig().position;
        };
        Filter.prototype.onApply = function (handler) {
            this.applyHandlers.addEventListener(handler);
        };
        Filter.prototype.apply = function () {
            this.applyHandlers.execute(window, []);
            this.triggerApplyAnalytics();
        };
        Filter.prototype.isDisabled = function () {
            return this.disabled;
        };
        Filter.prototype.isSaveable = function () {
            return true;
        };
        Filter.prototype.refreshWrapperLoading = function (obj) {
            if (obj.disabled) {
                this.rendered.addClass(Filter.PROPERTY_LOADING_CSSCLASS);
            }
            else {
                this.rendered.removeClass(Filter.PROPERTY_LOADING_CSSCLASS);
            }
        };
        Filter.prototype.disable = function () {
            this.disabled = true;
            this.setApplyButtonState(!this.disabled);
            this.refreshLinkIcon();
            this.refreshWrapperLoading({ disabled: true });
        };
        Filter.prototype.enable = function () {
            this.disabled = false;
            this.setApplyButtonState(this.isApplicable());
            this.refreshLinkIcon();
            this.refreshWrapperLoading({ disabled: false });
        };
        //Used on sales filters;
        Filter.prototype.disableInteraction = function () {
            this.disabled = true;
            this.setApplyButtonState(!this.disabled);
            this.refreshLinkIcon();
            this.refreshWrapperLoading({ disabled: true });
        };
        //Used on sales filters;
        Filter.prototype.enableInteraction = function () {
            this.disabled = false;
            this.setApplyButtonState(this.isApplicable());
            this.refreshLinkIcon();
            this.refreshWrapperLoading({ disabled: false });
        };
        Filter.prototype.getRendered = function () {
            return this.rendered;
        };
        Filter.prototype.expandable = function () {
            return this.isOpen !== true;
        };
        Filter.prototype.render = function (depth) {
            var _this = this;
            if (this.rendered !== null) {
                return this.rendered;
            }
            this.rendered = jQuery('<li/>', { 'id': this.config.id, 'class': ['property-control', this.getWrapperCssClass()].join(' ') });
            if (this.hasOptions()) {
                var link = this.renderLink(depth);
                this.contentWrapper = this.renderContentWrapper();
                this.rendered.append(link, this.contentWrapper);
                link.click(function () {
                    if (_this.isOpen === null) {
                        _this.content = _this.renderContent();
                        _this.contentWrapper.append(_this.content);
                        _this.isOpen = Boolean(_this.isOpen);
                    }
                    _this.toggle();
                });
            }
            return this.rendered;
        };
        Filter.prototype.reset = function () {
            this.setApplyButtonState(this.isApplicable());
            this.refreshLinkIcon();
        };
        Filter.prototype.addEventListeners = function () {
            var _this = this;
            this.onApplyButtonClick(function () {
                _this.apply();
            });
        };
        Filter.prototype.refreshApplyButton = function () {
            this.setApplyButtonState(this.isApplicable());
        };
        Filter.prototype.setApplyButtonState = function (state) {
            var button = this.renderApplyButton();
            button.prop(Filter.DISABLED_ATTRIBUTE, !state);
        };
        Filter.prototype.onApplyButtonClick = function (handler) {
            var button = this.renderApplyButton();
            button.click(handler);
        };
        Filter.prototype.renderFilterActionsSection = function () {
            this.filterSection = this.filterSection || jQuery('<div>', { 'class': 'filter-actions' });
            return this.filterSection;
        };
        Filter.prototype.renderApplyButton = function () {
            this.applyButton = this.applyButton || jQuery('<button>', { 'type': 'button', 'class': 'btn btn-sm btn-primary pull-right', 'text': this.applyButtonLabel });
            return this.applyButton;
        };
        Filter.prototype.getConfig = function () {
            return this.config;
        };
        Filter.prototype.getLabel = function () {
            return this.name;
        };
        Filter.prototype.refreshLabel = function () {
            if (this.renderedLabel !== null) {
                this.renderedLabel.html(' ' + this.getLabel());
            }
        };
        Filter.prototype.renderLabel = function () {
            this.renderedLabel = this.renderedLabel || jQuery('<span/>', { 'class': 'filter-label' });
            return this.renderedLabel;
        };
        Filter.prototype.getContentHeight = function () {
            this.contentHeight = this.contentHeight || this.content.innerHeight() + this.contentWrapper.innerHeight();
            return this.contentHeight;
        };
        Filter.prototype.collapse = function () {
            if (this.isOpen === true) {
                this.toggle();
            }
        };
        Filter.prototype.toggle = function () {
            var OPEN_CSSCLASS = Filter.OPEN_CSSCLASS;
            var CLOSED_CSSCLASS = Filter.CLOSED_CSSCLASS;
            this.isOpen = !this.isOpen;
            this.contentWrapper.removeClass(Filter.HIDDEN_CSSCLASS);
            if (this.isOpen) {
                this.rendered.addClass(OPEN_CSSCLASS).removeClass(CLOSED_CSSCLASS);
            }
            else {
                this.rendered.removeClass(OPEN_CSSCLASS).addClass(CLOSED_CSSCLASS);
            }
            var maxHeight = this.isOpen ? this.getContentHeight() : 0;
            this.contentWrapper.css('max-height', maxHeight);
            if (this.isOpen) {
                this.expandedHandlers.execute(window, []);
            }
            else {
                this.collapseHandlers.execute(window, []);
            }
        };
        Filter.prototype.onExpanded = function (handler) {
            this.expandedHandlers.addEventListener(handler);
        };
        Filter.prototype.onCollapse = function (handler) {
            this.collapseHandlers.addEventListener(handler);
        };
        Filter.prototype.renderContentWrapper = function () {
            return jQuery('<div/>', { 'class': Filter.HIDDEN_CSSCLASS + ' property-control-content' });
        };
        Filter.prototype.isLoading = function () {
            return this.isDisabled();
        };
        Filter.prototype.refreshLinkIcon = function () {
            var icon = this.renderLinkIcon();
            if (icon === null) {
                return;
            }
            var SPINNER_CSS_CLASS = Filter.SPINNER_CSS_CLASS;
            var ARROW_CSS_CLASS = Filter.ARROW_CSS_CLASS;
            if (this.isLoading()) {
                icon.removeClass(ARROW_CSS_CLASS).addClass(SPINNER_CSS_CLASS);
            }
            else {
                icon.removeClass(SPINNER_CSS_CLASS).addClass(ARROW_CSS_CLASS);
            }
        };
        Filter.prototype.renderLinkIcon = function () {
            this.renderedIcon = this.renderedIcon || jQuery('<div/>', { 'class': '' });
            return this.renderedIcon;
        };
        Filter.prototype.getLabelCssClass = function (depth) {
            switch (depth) {
                case CardView.FilterRenderDepth.TOP:
                    return 'side-menu-label-md';
                case CardView.FilterRenderDepth.IN_CATEGORY:
                    return 'side-menu-label-sm';
                case CardView.FilterRenderDepth.IN_FILTER_GROUP:
                    return 'side-menu-label-xs';
            }
            return null;
        };
        Filter.prototype.renderLink = function (depth) {
            if (this.renderedLink) {
                return this.renderedLink;
            }
            this.renderedLink = jQuery('<a/>', { 'class': ['side-menu-label', this.getLabelCssClass(depth)].join(' ') });
            this.renderedLink.append(this.renderLinkIcon(), this.renderLabel());
            this.refreshLinkIcon();
            this.refreshLabel();
            return this.renderedLink;
        };
        Filter.HIDDEN_CSSCLASS = 'hidden';
        Filter.DISABLED_ATTRIBUTE = 'disabled';
        Filter.DISABLED_CSSCLASS = 'disabled';
        Filter.PROPERTY_LOADING_CSSCLASS = 'loading';
        Filter.SPINNER_CSS_CLASS = 'fa fa-spin fa-refresh';
        Filter.ARROW_CSS_CLASS = 'fa fa-caret-right side-menu-arrow';
        Filter.OPEN_CSSCLASS = 'open';
        Filter.CLOSED_CSSCLASS = 'closed';
        return Filter;
    }());
    CardView.Filter = Filter;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var CardViewReportFilterSalesInfo = (function () {
        function CardViewReportFilterSalesInfo() {
        }
        return CardViewReportFilterSalesInfo;
    }());
    CardView.CardViewReportFilterSalesInfo = CardViewReportFilterSalesInfo;
    var CardViewReportFilterInfo = (function () {
        function CardViewReportFilterInfo(filter, response) {
            var _this = this;
            // Pickout selected options
            this.dimensionId = filter.getDimensionId();
            this.name = filter.getName();
            this.columnName = filter.getColumnName();
            this.filterId = filter.getFilterId();
            this.applyOrder = null;
            this.options = null;
            var selectedOptions = filter.getInitialOptions();
            var responseOptions = response.options();
            if (!Array.isArray(responseOptions)) {
                return;
            }
            var indexedSelectedOptions = {};
            if (Array.isArray(selectedOptions)) {
                selectedOptions.forEach(function (option) {
                    indexedSelectedOptions[option.formattedValue] = true;
                });
            }
            this.options = [];
            responseOptions.forEach(function (option) {
                var isSelected = selectedOptions === null || Boolean(indexedSelectedOptions[option.formattedValue]);
                _this.options.push({
                    id: option.value,
                    label: option.formattedValue,
                    selected: isSelected
                });
            });
            this.applyOrder = filter.getApplyOrder();
        }
        CardViewReportFilterInfo.prototype.getFilterId = function () {
            return this.filterId;
        };
        CardViewReportFilterInfo.prototype.getDimensionId = function () {
            return this.dimensionId;
        };
        CardViewReportFilterInfo.prototype.getSelectedOptions = function () {
            if (!Array.isArray(this.options)) {
                return null;
            }
            var options = new Array();
            this.options.forEach(function (option) {
                if (!option.selected) {
                    return;
                }
                options.push({
                    formattedValue: option.label,
                    value: option.id
                });
            });
            return options;
        };
        CardViewReportFilterInfo.prototype.getOptions = function () {
            return this.options;
        };
        CardViewReportFilterInfo.prototype.getApplyOrder = function () {
            return this.applyOrder;
        };
        return CardViewReportFilterInfo;
    }());
    CardView.CardViewReportFilterInfo = CardViewReportFilterInfo;
    var CategoricalFilterOptionsManager = (function (_super) {
        __extends(CategoricalFilterOptionsManager, _super);
        function CategoricalFilterOptionsManager() {
            _super.apply(this, arguments);
        }
        CategoricalFilterOptionsManager.sort = function (options) {
            options.sort(function (curr, next) {
                return curr.id - next.id;
            });
        };
        CategoricalFilterOptionsManager.prototype.equals = function (initial, current) {
            if (initial === current) {
                return true;
            }
            if ((initial === null) !== (current === null)) {
                return false;
            }
            if (initial.length !== current.length) {
                return false;
            }
            CategoricalFilterOptionsManager.sort(initial);
            CategoricalFilterOptionsManager.sort(current);
            for (var i = 0; i < initial.length; ++i) {
                var iOption = initial[i];
                var cOption = current[i];
                if (iOption.id !== cOption.id || iOption.label !== cOption.label || iOption.selected !== cOption.selected) {
                    return false;
                }
            }
            return true;
        };
        CategoricalFilterOptionsManager.prototype.getValue = function () {
            var value = _super.prototype.getValue.call(this);
            return Array.isArray(value) ? value.slice(0) : null;
        };
        CategoricalFilterOptionsManager.prototype.clone = function (original) {
            if (!Array.isArray(original)) {
                return null;
            }
            var copy = new Array();
            for (var i = 0; i < original.length; ++i) {
                var iOption = original[i];
                copy.push({
                    id: iOption.id,
                    label: iOption.label,
                    selected: iOption.selected
                });
            }
            return copy;
        };
        CategoricalFilterOptionsManager.prototype.getSelectedOptions = function () {
            if (!this.hasOptions()) {
                return null;
            }
            return this.getValue().filter(function (option) { return option.selected; });
        };
        CategoricalFilterOptionsManager.prototype.isEmpty = function () {
            if (!this.hasOptions()) {
                return false;
            }
            return this.getSelectedOptions().isEmpty();
        };
        CategoricalFilterOptionsManager.prototype.hasOptions = function () {
            return Array.isArray(this.getValue());
        };
        CategoricalFilterOptionsManager.prototype.getOptionsCount = function () {
            return this.hasOptions() ? this.getValue().length : null;
        };
        return CategoricalFilterOptionsManager;
    }(CardView.ValueManager));
    CardView.CategoricalFilterOptionsManager = CategoricalFilterOptionsManager;
    var SearchInput = (function () {
        function SearchInput(placeholder) {
            this.placeholder = placeholder;
            this.wrapper = null;
            this.input = null;
            this.remove = null;
            this.magnifier = null;
            this.searchHandlers = new ListenersCollection();
        }
        SearchInput.prototype.onSearch = function (handler) {
            this.searchHandlers.addEventListener(handler);
        };
        SearchInput.prototype.val = function () {
            return this.input === null ? '' : this.input.val();
        };
        SearchInput.prototype.refresh = function () {
            if (this.val().isEmpty()) {
                this.remove.hide();
                this.magnifier.show();
            }
            else {
                this.magnifier.hide();
                this.remove.show();
            }
        };
        SearchInput.prototype.triggerChange = function (val) {
            this.refresh();
            this.searchHandlers.execute(window, [val]);
        };
        SearchInput.prototype.renderAddon = function () {
            var addon = jQuery('<span>', { 'class': 'input-group-addon' });
            this.magnifier = this.magnifier || jQuery('<i/>', { 'class': 'glyphicon glyphicon-search' });
            this.remove = this.remove || jQuery('<i/>', { 'class': 'glyphicon glyphicon-remove' });
            addon.append(this.magnifier, this.remove);
            return addon;
        };
        SearchInput.prototype.clear = function () {
            this.input.val('');
            this.triggerChange('');
        };
        SearchInput.prototype.addInternalEventListeners = function () {
            var _this = this;
            var lastChangedId = null;
            this.input.keypress(function () {
                clearTimeout(lastChangedId);
                lastChangedId = setTimeout(function () {
                    _this.triggerChange(_this.val());
                }, 200);
            });
            this.input.keydown(function () {
                clearTimeout(lastChangedId);
                lastChangedId = setTimeout(function () {
                    _this.triggerChange(_this.val());
                }, 200);
            });
            this.input.keyup(function () {
                clearTimeout(lastChangedId);
                lastChangedId = setTimeout(function () {
                    _this.triggerChange(_this.val());
                }, 200);
            });
            this.remove.click(function () {
                _this.clear();
            });
        };
        SearchInput.prototype.render = function () {
            if (this.wrapper !== null) {
                return this.wrapper;
            }
            this.wrapper = jQuery('<div/>', { 'class': 'input-group' });
            var addon = this.renderAddon();
            this.input = this.input || jQuery('<input/>', { 'class': 'form-control multiselect-search', 'type': 'text', 'placeholder': this.placeholder, 'autocorrect': 'off' });
            this.wrapper.append(addon, this.input);
            this.addInternalEventListeners();
            this.refresh();
            return this.wrapper;
        };
        return SearchInput;
    }());
    CardView.SearchInput = SearchInput;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var CategoricalFilterVisualOptions;
    (function (CategoricalFilterVisualOptions) {
        var PlainOption = (function () {
            function PlainOption(label, visible) {
                this.wrapper = null;
                this.label = label;
                this.visible = visible;
            }
            PlainOption.prototype.getLabelCssClass = function () {
                return 'text-center';
            };
            PlainOption.prototype.renderLabel = function () {
                return jQuery('<label/>', { 'title': this.getLabel(), 'class': this.getLabelCssClass() });
            };
            PlainOption.prototype.getWrapper = function () {
                return this.wrapper;
            };
            PlainOption.prototype.html = function () {
                if (this.getWrapper() !== null) {
                    return this.getWrapper();
                }
                this.wrapper = jQuery('<div/>', { 'class': 'checkbox' });
                var label = this.renderLabel();
                label.append(this.getLabel());
                this.wrapper.append(label);
                this.refreshHtml();
                return this.getWrapper();
            };
            PlainOption.prototype.remove = function () {
                if (this.wrapper !== null) {
                    this.wrapper.remove();
                }
            };
            PlainOption.prototype.setVisibility = function (visible) {
                this.visible = visible;
                this.refreshHtmlVisibility();
            };
            PlainOption.prototype.isVisible = function () {
                return this.visible;
            };
            PlainOption.prototype.getLabel = function () {
                return this.aliasLabel ? this.aliasLabel : this.label;
            };
            PlainOption.prototype.setAliasLabel = function (alias) {
                this.aliasLabel = alias;
            };
            PlainOption.prototype.addClasses = function () {
                var classes = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    classes[_i - 0] = arguments[_i];
                }
                if (this.wrapper !== null) {
                    this.getWrapper().addClass(classes.join(' '));
                }
            };
            PlainOption.prototype.refreshHtmlVisibility = function () {
                var wrapper = this.wrapper;
                if (wrapper === null) {
                    return;
                }
                if (this.visible) {
                    wrapper.show();
                }
                else {
                    wrapper.hide();
                }
            };
            PlainOption.prototype.refreshHtml = function () {
                this.refreshHtmlVisibility();
            };
            PlainOption.generateUid = function () {
                return Math.random().toString(36).substring(7);
            };
            return PlainOption;
        }());
        CategoricalFilterVisualOptions.PlainOption = PlainOption;
        var CheckboxVisualOption = (function (_super) {
            __extends(CheckboxVisualOption, _super);
            function CheckboxVisualOption(option) {
                _super.call(this, option.label, true);
                this.input = null;
                this.data = option;
                this.state = true;
                this.changeHandlers = new ListenersCollection();
            }
            CheckboxVisualOption.prototype.getData = function () {
                return this.data;
            };
            CheckboxVisualOption.prototype.getLabelCssClass = function () {
                return '';
            };
            CheckboxVisualOption.prototype.isSelected = function () {
                return this.data.selected;
            };
            CheckboxVisualOption.prototype.setState = function (state) {
                this.state = state;
                this.refreshHtml();
            };
            CheckboxVisualOption.prototype.setSelection = function (selected) {
                this.data.selected = selected;
                this.refreshHtml();
            };
            CheckboxVisualOption.prototype.onChange = function (handler) {
                this.changeHandlers.addEventListener(handler);
            };
            CheckboxVisualOption.prototype.addInputEventListener = function () {
                var _this = this;
                this.input.change(function () {
                    _this.data.selected = _this.input.prop(CheckboxVisualOption.CHECKED_PROPERTY);
                    _this.refreshHtml();
                    _this.changeHandlers.execute(window, []);
                });
            };
            CheckboxVisualOption.prototype.renderLabel = function () {
                var label = _super.prototype.renderLabel.call(this);
                var uid = CheckboxVisualOption.generateUid();
                label.attr('for', String(uid));
                this.input = jQuery('<input>', { 'type': 'checkbox', 'name': uid, 'id': uid });
                this.addInputEventListener();
                label.append(this.input);
                return label;
            };
            CheckboxVisualOption.prototype.refreshHtml = function () {
                if (this.input !== null) {
                    this.input.prop(CheckboxVisualOption.CHECKED_PROPERTY, this.data.selected);
                    this.input.prop(CheckboxVisualOption.DISABLED_PROPERTY, !this.state);
                }
                var wrapper = this.getWrapper();
                if (wrapper !== null) {
                    var isSelected = this.data.selected;
                    var UNCHECKED_CSSCLASS = CheckboxVisualOption.UNCHECKED_CSSCLASS;
                    var CHECKED_CSSCLASS = CheckboxVisualOption.CHECKED_CSSCLASS;
                    wrapper
                        .removeClass(isSelected ? UNCHECKED_CSSCLASS : CHECKED_CSSCLASS)
                        .addClass(isSelected ? CHECKED_CSSCLASS : UNCHECKED_CSSCLASS);
                }
                _super.prototype.refreshHtml.call(this);
            };
            CheckboxVisualOption.CHECKED_PROPERTY = 'checked';
            CheckboxVisualOption.DISABLED_PROPERTY = 'disabled';
            CheckboxVisualOption.UNCHECKED_CSSCLASS = 'unchecked-option';
            CheckboxVisualOption.CHECKED_CSSCLASS = 'checked-option';
            return CheckboxVisualOption;
        }(PlainOption));
        CategoricalFilterVisualOptions.CheckboxVisualOption = CheckboxVisualOption;
        var FocusFilterCheckboxVisualOption = (function (_super) {
            __extends(FocusFilterCheckboxVisualOption, _super);
            function FocusFilterCheckboxVisualOption(option, isVisible) {
                _super.call(this, option.name, isVisible);
                this.input = null;
                this.data = option;
                this.state = true;
                this.changeHandlers = new ListenersCollection();
            }
            FocusFilterCheckboxVisualOption.prototype.getData = function () {
                return this.data;
            };
            FocusFilterCheckboxVisualOption.prototype.getLabelCssClass = function () {
                return '';
            };
            FocusFilterCheckboxVisualOption.prototype.isSelected = function () {
                return this.data.selected;
            };
            FocusFilterCheckboxVisualOption.prototype.setState = function (state) {
                this.state = state;
                this.refreshHtml();
            };
            FocusFilterCheckboxVisualOption.prototype.setSelection = function (selected) {
                this.data.selected = selected;
                this.refreshHtml();
            };
            FocusFilterCheckboxVisualOption.prototype.onChange = function (handler) {
                this.changeHandlers.addEventListener(handler);
            };
            FocusFilterCheckboxVisualOption.prototype.addInputEventListener = function () {
                var _this = this;
                this.input.change(function () {
                    _this.data.selected = _this.input.prop(FocusFilterCheckboxVisualOption.CHECKED_PROPERTY);
                    _this.refreshHtml();
                    _this.changeHandlers.execute(window, []);
                });
            };
            FocusFilterCheckboxVisualOption.prototype.renderLabel = function () {
                var label = _super.prototype.renderLabel.call(this);
                var uid = FocusFilterCheckboxVisualOption.generateUid();
                label.attr('for', String(uid));
                this.input = jQuery('<input>', { 'type': 'checkbox', 'name': uid, 'id': uid });
                this.addInputEventListener();
                label.append(this.input);
                return label;
            };
            FocusFilterCheckboxVisualOption.prototype.refreshHtml = function () {
                if (this.input !== null) {
                    this.input.prop(FocusFilterCheckboxVisualOption.CHECKED_PROPERTY, this.data.selected);
                    this.input.prop(FocusFilterCheckboxVisualOption.DISABLED_PROPERTY, !this.state);
                }
                var wrapper = this.getWrapper();
                if (wrapper !== null) {
                    var isSelected = this.data.selected;
                    var UNCHECKED_CSSCLASS = FocusFilterCheckboxVisualOption.UNCHECKED_CSSCLASS;
                    var CHECKED_CSSCLASS = FocusFilterCheckboxVisualOption.CHECKED_CSSCLASS;
                    wrapper
                        .removeClass(isSelected ? UNCHECKED_CSSCLASS : CHECKED_CSSCLASS)
                        .addClass(isSelected ? CHECKED_CSSCLASS : UNCHECKED_CSSCLASS);
                }
                _super.prototype.refreshHtml.call(this);
            };
            FocusFilterCheckboxVisualOption.CHECKED_PROPERTY = 'checked';
            FocusFilterCheckboxVisualOption.DISABLED_PROPERTY = 'disabled';
            FocusFilterCheckboxVisualOption.UNCHECKED_CSSCLASS = 'unchecked-option';
            FocusFilterCheckboxVisualOption.CHECKED_CSSCLASS = 'checked-option';
            return FocusFilterCheckboxVisualOption;
        }(PlainOption));
        CategoricalFilterVisualOptions.FocusFilterCheckboxVisualOption = FocusFilterCheckboxVisualOption;
        var VisualOptionsManager = (function () {
            function VisualOptionsManager(valueManager, order, focusFilter, strings) {
                this.wrapper = null;
                this.homeOffice = false;
                this.order = order;
                this.valueManager = valueManager;
                this.focusFilter = focusFilter;
                this.selectAll = new CheckboxVisualOption({ id: null, label: strings.getSelectAllCheckboxLabel(), selected: false });
                this.setState(true);
                this.strings = strings;
                this.changeHandlers = new ListenersCollection();
            }
            VisualOptionsManager.prototype.getValue = function () {
                return this.valueManager.getValue();
            };
            VisualOptionsManager.prototype.setValue = function (options) {
                this.valueManager.setValue(options);
            };
            VisualOptionsManager.prototype.sort = function (arr) {
                arr.sort(this.order);
            };
            VisualOptionsManager.prototype.triggerChange = function () {
                this.changeHandlers.execute(window, []);
            };
            VisualOptionsManager.prototype.setAliasLabel = function (alias) {
                this.aliasLabel = alias;
            };
            VisualOptionsManager.prototype.onChange = function (handler) {
                this.changeHandlers.addEventListener(handler);
            };
            VisualOptionsManager.prototype.disable = function () {
                this.setState(false);
            };
            VisualOptionsManager.prototype.enable = function () {
                this.setState(true);
            };
            VisualOptionsManager.prototype.setHomeOffice = function (homeOffice) {
                this.homeOffice = homeOffice;
            };
            VisualOptionsManager.prototype.reset = function () {
                this.valueManager.reset();
            };
            VisualOptionsManager.prototype.setState = function (state) {
                this.state = state;
                this.selectAll.setState(state);
            };
            VisualOptionsManager.prototype.getState = function () {
                return this.state;
            };
            VisualOptionsManager.prototype.renderWrapper = function () {
                this.wrapper = this.getWrapper() || jQuery('<div/>', { 'class': 'checkboxes-wrapper' });
                return this.getWrapper();
            };
            VisualOptionsManager.prototype.hasWrapper = function () {
                return this.getWrapper() !== null;
            };
            VisualOptionsManager.prototype.getWrapper = function () {
                return this.wrapper;
            };
            VisualOptionsManager.prototype.render = function () {
                var wrapper = this.renderWrapper();
                wrapper.append(this.selectAll.html());
                return wrapper;
            };
            VisualOptionsManager.prototype.setSelectAllVisibility = function (visible) {
                this.selectAll.setVisibility(visible);
            };
            VisualOptionsManager.prototype.setLabelOptionsVisibility = function (visible) {
                this.labelOptions.forEach(function (label) {
                    label.setVisibility(visible);
                });
            };
            VisualOptionsManager.prototype.refreshSelectAllSelection = function () {
                this.selectAll.setSelection(this.areAllVisibleOptionsSelected());
            };
            VisualOptionsManager.prototype.onSelectAllChange = function (handler) {
                this.selectAll.onChange(handler);
            };
            VisualOptionsManager.prototype.isSelectAllSelected = function () {
                return this.selectAll.isSelected();
            };
            VisualOptionsManager.prototype.setVisibleOptionsState = function (state) {
                this.selectAll.setSelection(state);
            };
            VisualOptionsManager.prototype.getFocusFilter = function () {
                return this.focusFilter;
            };
            VisualOptionsManager.prototype.clearVisualFocusOptions = function () {
                this.focusFilterOptions.forEach(function (focusOption) { focusOption.remove(); });
                this.labelOptions.forEach(function (labelOption) { labelOption.remove(); });
            };
            VisualOptionsManager.prototype.areAllVisibleFocusOptions = function () {
                return this.focusFilterOptions.every(function (focus) { return focus.isVisible() === true; });
            };
            VisualOptionsManager.prototype.createHashOptions = function (option) {
                var optionsValue = {};
                option.dimension.options.forEach(function (focusOption) {
                    optionsValue[focusOption.formattedValue] = true;
                });
                return optionsValue;
            };
            VisualOptionsManager.prototype.areAllFocusOptionsSelected = function (option) {
                var optionsValue = this.createHashOptions(option);
                var selectedOptions = new Array();
                this.getOptions().forEach(function (currentOption) {
                    if (optionsValue[currentOption.getLabel()]) {
                        selectedOptions.push(currentOption.getData().selected);
                    }
                });
                return selectedOptions.every(function (selectedOption) { return selectedOption === true; });
            };
            VisualOptionsManager.prototype.areAllFocusOptionsVisible = function (option) {
                var optionsValue = this.createHashOptions(option);
                var visibleOptions = new Array();
                this.getOptions().forEach(function (currentOption) {
                    if (optionsValue[currentOption.getLabel()]) {
                        visibleOptions.push(currentOption.isVisible());
                    }
                });
                return !visibleOptions.isEmpty();
            };
            VisualOptionsManager.prototype.updateOptionsWithFocusFilter = function (option) {
                var optionsValue = {};
                option.getData().dimension.options.forEach(function (focusOption) {
                    optionsValue[focusOption.formattedValue] = true;
                });
                this.getOptions().forEach(function (currentOption) {
                    if (optionsValue[currentOption.getLabel()]) {
                        currentOption.setSelection(option.getData().selected);
                    }
                });
            };
            VisualOptionsManager.prototype.refreshFocusFilter = function () {
                var _this = this;
                this.focusFilterOptions.forEach(function (focusOption) {
                    var areAllSelected = _this.areAllFocusOptionsSelected(focusOption.getData());
                    focusOption.setSelection(areAllSelected);
                });
            };
            return VisualOptionsManager;
        }());
        CategoricalFilterVisualOptions.VisualOptionsManager = VisualOptionsManager;
    })(CategoricalFilterVisualOptions = CardView.CategoricalFilterVisualOptions || (CardView.CategoricalFilterVisualOptions = {}));
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var CategoricalFilterVisualOptions;
    (function (CategoricalFilterVisualOptions) {
        var VisualCheckboxOptionsManager = (function (_super) {
            __extends(VisualCheckboxOptionsManager, _super);
            function VisualCheckboxOptionsManager(config, valueManager, focusFilter, strings) {
                _super.call(this, valueManager, config.order, focusFilter, strings);
                this.pluralName = (config.pluralNameGetter) ? config.pluralNameGetter(strings) : '';
                this.query = null;
                this.options = [];
                this.focusFilterOptions = [];
                this.labelOptions = [];
                this.noResults = new CategoricalFilterVisualOptions.PlainOption(strings.getNoResultsMessageLabel(), false);
                this.addEventListeners();
            }
            VisualCheckboxOptionsManager.prototype.getOptions = function () {
                return this.options;
            };
            VisualCheckboxOptionsManager.prototype.clearVisualOptions = function () {
                this.options.forEach(function (option) { option.remove(); });
                this.clearVisualFocusOptions();
            };
            VisualCheckboxOptionsManager.prototype.update = function () {
                var _this = this;
                this.clearVisualOptions();
                // Build options
                var options = this.getValue();
                options = Array.isArray(options) ? options : [];
                options = options.slice(0);
                this.sort(options);
                this.options = options.map(function (option) { return new CategoricalFilterVisualOptions.CheckboxVisualOption(option); });
                // Build Focus filter options
                var focusFilter = this.getFocusFilter();
                focusFilter.forEach(function (focus) {
                    focus.selected = _this.areAllFocusOptionsSelected(focus);
                });
                this.focusFilterOptions = focusFilter.map(function (focus) { return new CategoricalFilterVisualOptions.FocusFilterCheckboxVisualOption(focus, _this.areAllFocusOptionsVisible(focus)); });
                this.refreshSelectAllSelection();
                this.appendFocusFilter();
                this.appendOptions();
                this.refreshSearchResultsList();
                this.addOptionsEventListeners();
                this.addFocusFilterOptionsEventListeners();
            };
            VisualCheckboxOptionsManager.prototype.triggerChange = function () {
                this.setValue(this.options.map(function (option) { return option.getData(); }));
                _super.prototype.triggerChange.call(this);
            };
            VisualCheckboxOptionsManager.prototype.addEventListeners = function () {
                var _this = this;
                this.onSelectAllChange(function () {
                    var isSelected = _this.isSelectAllSelected();
                    _this.setVisibleOptionsState(isSelected);
                    _this.focusFilterOptions.forEach(function (option) {
                        if (option.isVisible()) {
                            option.setSelection(isSelected);
                        }
                    });
                    _this.triggerChange();
                });
            };
            VisualCheckboxOptionsManager.prototype.setVisibleOptionsState = function (state) {
                _super.prototype.setVisibleOptionsState.call(this, state);
                this.options.forEach(function (option) {
                    if (option.isVisible()) {
                        option.setSelection(state);
                    }
                });
            };
            VisualCheckboxOptionsManager.prototype.unselectAllVisibleOptions = function () {
                this.setVisibleOptionsState(false);
                this.triggerChange();
            };
            VisualCheckboxOptionsManager.prototype.areAllVisibleOptionsSelected = function () {
                return this.options.filter(function (option) { return option.isVisible(); }).every(function (option) { return option.isSelected(); });
            };
            VisualCheckboxOptionsManager.prototype.addOptionsEventListeners = function () {
                var _this = this;
                this.options.forEach(function (option) {
                    option.onChange(function () {
                        _this.refreshSelectAllSelection();
                        _this.refreshFocusFilter();
                        _this.triggerChange();
                    });
                });
            };
            VisualCheckboxOptionsManager.prototype.addFocusFilterOptionsEventListeners = function () {
                var _this = this;
                this.focusFilterOptions.forEach(function (option) {
                    option.onChange(function () {
                        _this.updateOptionsWithFocusFilter(option);
                        _this.refreshSelectAllSelection();
                        _this.refreshFocusFilter();
                        _this.triggerChange();
                    });
                });
            };
            VisualCheckboxOptionsManager.prototype.getOptionsElements = function () {
                return this.options.map(function (option) { return option.html(); });
            };
            VisualCheckboxOptionsManager.prototype.getFocusFilterElements = function () {
                return this.focusFilterOptions.map(function (focusOption) { return focusOption.html(); });
            };
            VisualCheckboxOptionsManager.prototype.appendOptions = function () {
                if (this.hasWrapper()) {
                    if (this.homeOffice) {
                        var canSelectOption = this.options.filter(function (opt) { return opt.getLabel() === VisualCheckboxOptionsManager.SELECTED_OPTION; }), mainOption = canSelectOption.first();
                        mainOption.setAliasLabel(this.strings.getIncludeLabel());
                        this.getWrapper().append(this.noResults.html());
                        this.getWrapper().append(mainOption.html());
                    }
                    else {
                        this.getWrapper().append(this.getOptionsElements());
                    }
                }
            };
            VisualCheckboxOptionsManager.prototype.appendFocusFilter = function () {
                if (this.hasWrapper()) {
                    var elements = this.getFocusFilterElements();
                    if (elements.length > 0 && this.areAllVisibleFocusOptions()) {
                        var allOptions = new CategoricalFilterVisualOptions.PlainOption(this.strings.getALlLabel() + ' ' + this.pluralName, true);
                        var focusLabel = new CategoricalFilterVisualOptions.PlainOption(this.strings.getFocusLabel() + ' ' + this.pluralName, true);
                        this.labelOptions.push(focusLabel, allOptions);
                        this.getWrapper().append(focusLabel.html());
                        this.getWrapper().append(elements);
                        this.getWrapper().append(allOptions.html());
                        // Make references labels with gray background
                        focusLabel.addClasses(VisualCheckboxOptionsManager.FOCUS_REFERENCE_LABEL_CSSCLASS);
                        allOptions.addClasses(VisualCheckboxOptionsManager.FOCUS_REFERENCE_LABEL_CSSCLASS);
                    }
                }
            };
            VisualCheckboxOptionsManager.prototype.hasHomeOfficeOptions = function () {
                var homeOfficeOption = this.filterHomeOfficeOption();
                return !(typeof homeOfficeOption === undefined) && !homeOfficeOption.isEmpty();
            };
            VisualCheckboxOptionsManager.prototype.render = function () {
                if (this.homeOffice) {
                    var wrapper = this.renderWrapper(), canSelectOption = this.filterHomeOfficeOption(), mainOption = canSelectOption.first();
                    mainOption.setAliasLabel(this.strings.getIncludeLabel());
                    wrapper.append(this.noResults.html());
                    wrapper.append(mainOption.html());
                }
                else {
                    var wrapper = _super.prototype.render.call(this);
                    this.appendFocusFilter();
                    this.appendOptions();
                }
                return wrapper;
            };
            VisualCheckboxOptionsManager.prototype.filterHomeOfficeOption = function () {
                return this.options.filter(function (opt) { return opt.getLabel() === VisualCheckboxOptionsManager.SELECTED_OPTION; });
            };
            VisualCheckboxOptionsManager.prototype.setState = function (state) {
                _super.prototype.setState.call(this, state);
                if (!Array.isArray(this.options)) {
                    return;
                }
                this.options.forEach(function (option) {
                    option.setState(state);
                });
            };
            VisualCheckboxOptionsManager.prototype.hasVisibleUnselectableOptions = function () {
                return this.getState() && this.options.filter(function (option) { return option.isVisible(); }).some(function (option) { return option.isSelected(); });
            };
            VisualCheckboxOptionsManager.prototype.refreshSearchResultsList = function () {
                var _this = this;
                if (this.query === null) {
                    return;
                }
                var isEmpty = this.query.isEmpty();
                var areAnyVisible = false;
                var areAnyFocusVisible = false;
                this.options.forEach(function (option) {
                    var isVisible = null;
                    if (isEmpty) {
                        isVisible = true;
                    }
                    else {
                        var label = (option.getLabel() || '').toLowerCase();
                        isVisible = label.contains(_this.query);
                    }
                    option.setVisibility(isVisible);
                    areAnyVisible = areAnyVisible || isVisible;
                });
                this.focusFilterOptions.forEach(function (option) {
                    var isVisible = null;
                    if (isEmpty) {
                        isVisible = true;
                    }
                    else {
                        var label = (option.getLabel() || '').toLowerCase();
                        isVisible = label.contains(_this.query);
                    }
                    option.setVisibility(isVisible);
                    areAnyFocusVisible = areAnyFocusVisible || isVisible;
                });
                this.setSelectAllVisibility(areAnyVisible);
                this.setLabelOptionsVisibility(areAnyFocusVisible);
                this.noResults.setVisibility(!areAnyVisible);
                this.refreshSelectAllSelection();
            };
            VisualCheckboxOptionsManager.prototype.filter = function (query) {
                query = query.trim().toLowerCase();
                if (this.query === query) {
                    return;
                }
                this.query = query;
                this.refreshSearchResultsList();
            };
            VisualCheckboxOptionsManager.FOCUS_REFERENCE_LABEL_CSSCLASS = 'reference-label';
            VisualCheckboxOptionsManager.SELECTED_OPTION = '1';
            return VisualCheckboxOptionsManager;
        }(CategoricalFilterVisualOptions.VisualOptionsManager));
        CategoricalFilterVisualOptions.VisualCheckboxOptionsManager = VisualCheckboxOptionsManager;
    })(CategoricalFilterVisualOptions = CardView.CategoricalFilterVisualOptions || (CardView.CategoricalFilterVisualOptions = {}));
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var CategoricalFilterVisualOptions;
    (function (CategoricalFilterVisualOptions) {
        var CategoricalFilterMobileVisualOption = (function () {
            function CategoricalFilterMobileVisualOption(data) {
                this.wrapper = null;
                this.visible = true;
                this.data = data;
                this.label = String(data.label || data.id);
            }
            CategoricalFilterMobileVisualOption.prototype.getLabel = function () {
                return this.label;
            };
            CategoricalFilterMobileVisualOption.prototype.getUILabel = function () {
                return this.aliasLabel ? this.aliasLabel : this.label;
            };
            CategoricalFilterMobileVisualOption.prototype.remove = function () {
                if (this.wrapper !== null) {
                    this.wrapper.remove();
                }
            };
            CategoricalFilterMobileVisualOption.prototype.isVisible = function () {
                return this.visible;
            };
            CategoricalFilterMobileVisualOption.prototype.setVisibility = function (visible) {
                if (this.visible === visible) {
                    return;
                }
                this.visible = visible;
                this.refreshWrapper();
            };
            CategoricalFilterMobileVisualOption.prototype.isSelected = function () {
                return this.data.selected;
            };
            CategoricalFilterMobileVisualOption.prototype.setSelection = function (selected) {
                if (this.isSelected() === selected) {
                    return;
                }
                this.data.selected = selected;
                this.refreshWrapper();
            };
            CategoricalFilterMobileVisualOption.prototype.setSingleSelection = function (selected) {
                this.data.selected = selected;
                this.refreshWrapper();
            };
            CategoricalFilterMobileVisualOption.prototype.getData = function () {
                return this.data;
            };
            CategoricalFilterMobileVisualOption.prototype.refreshWrapper = function () {
                if (this.wrapper) {
                    this.wrapper.prop('selected', this.isSelected());
                }
            };
            CategoricalFilterMobileVisualOption.prototype.renderWrapper = function () {
                return jQuery('<option/>', { 'value': this.data.label, 'label': this.getUILabel(), 'text': this.getUILabel() });
            };
            CategoricalFilterMobileVisualOption.prototype.html = function () {
                this.wrapper = this.wrapper || this.renderWrapper();
                this.refreshWrapper();
                return this.wrapper;
            };
            CategoricalFilterMobileVisualOption.prototype.setAliasLabel = function (alias) {
                this.aliasLabel = alias;
            };
            return CategoricalFilterMobileVisualOption;
        }());
        CategoricalFilterVisualOptions.CategoricalFilterMobileVisualOption = CategoricalFilterMobileVisualOption;
        var VisualMobileOptionsManager = (function (_super) {
            __extends(VisualMobileOptionsManager, _super);
            function VisualMobileOptionsManager(config, valueManager, focusFilter, strings) {
                _super.call(this, valueManager, config.order, focusFilter, strings);
                this.pluralName = (config.pluralNameGetter) ? config.pluralNameGetter(strings) : '';
                this.focusFilterOptions = [];
                this.labelOptions = [];
                this.options = [];
                this.fakeSelect = null;
                this.fakeSelectLabel = null;
                this.matchesFoundPlural = strings.getMatchesFoundPlural();
                this.matchesFoundSingular = strings.getMatchesFoundSingle();
                this.addEventListeners();
            }
            VisualMobileOptionsManager.prototype.getOptions = function () {
                return this.options;
            };
            VisualMobileOptionsManager.prototype.clearVisualOptions = function () {
                this.options.forEach(function (option) { option.remove(); });
            };
            VisualMobileOptionsManager.prototype.update = function () {
                var _this = this;
                this.clearVisualOptions();
                this.clearVisualFocusOptions();
                // Build options
                var options = this.getValue();
                options = Array.isArray(options) ? options : [];
                options = options.slice(0);
                this.sort(options);
                this.options = options.map(function (option) { return new CategoricalFilterMobileVisualOption(option); });
                // Build Focus filter options
                var focusFilter = this.getFocusFilter();
                focusFilter.forEach(function (focus) {
                    focus.selected = _this.areAllFocusOptionsSelected(focus);
                });
                this.focusFilterOptions = focusFilter.map(function (focus) { return new CategoricalFilterVisualOptions.FocusFilterCheckboxVisualOption(focus, _this.areAllFocusOptionsVisible(focus)); });
                this.refreshComponents();
            };
            VisualMobileOptionsManager.prototype.triggerChange = function () {
                this.setValue(this.options.map(function (option) { return option.getData(); }));
                this.refreshComponents();
                _super.prototype.triggerChange.call(this);
            };
            VisualMobileOptionsManager.prototype.addEventListeners = function () {
                var _this = this;
                this.onSelectAllChange(function () {
                    var isSelected = _this.isSelectAllSelected();
                    _this.setVisibleOptionsState(isSelected);
                    _this.focusFilterOptions.forEach(function (option) {
                        if (option.isVisible()) {
                            option.setSelection(isSelected);
                        }
                    });
                    _this.triggerChange();
                });
            };
            VisualMobileOptionsManager.prototype.setVisibleOptionsState = function (state) {
                _super.prototype.setVisibleOptionsState.call(this, state);
                this.options.forEach(function (option) {
                    if (option.isVisible()) {
                        option.setSelection(state);
                    }
                });
            };
            VisualMobileOptionsManager.prototype.unselectAllVisibleOptions = function () {
                this.setVisibleOptionsState(false);
                this.triggerChange();
            };
            VisualMobileOptionsManager.prototype.areAllVisibleOptionsSelected = function () {
                return Array.isArray(this.options) && this.options.filter(function (option) { return option.isVisible(); }).every(function (option) { return option.isSelected(); });
            };
            VisualMobileOptionsManager.prototype.addFocusFilterOptionsEventListeners = function () {
                var _this = this;
                this.focusFilterOptions.forEach(function (option) {
                    option.onChange(function () {
                        _this.updateOptionsWithFocusFilter(option);
                        _this.refreshSelectAllSelection();
                        _this.refreshFocusFilter();
                        _this.triggerChange();
                    });
                });
            };
            VisualMobileOptionsManager.prototype.hasVisibleUnselectableOptions = function () {
                return this.getState() && this.options.filter(function (option) { return option.isVisible(); }).some(function (option) { return option.isSelected(); });
            };
            VisualMobileOptionsManager.prototype.renderFakeSelectLabel = function () {
                this.fakeSelectLabel = this.fakeSelectLabel || jQuery('<div/>', { 'class': 'form-control' });
                return this.fakeSelectLabel;
            };
            VisualMobileOptionsManager.prototype.hasHomeOfficeOptions = function () {
                return (typeof this.options.last() !== undefined || !this.options.isEmpty());
            };
            VisualMobileOptionsManager.prototype.refreshComponents = function () {
                if (this.homeOffice) {
                    var homeOfficeOption = this.options.last();
                    if (this.fakeSelectLabel) {
                        this.fakeSelectLabel.text(String.format(this.matchesFoundSingular, '1'));
                    }
                    if (this.select) {
                        if (this.getState()) {
                            homeOfficeOption.setAliasLabel(this.strings.getIncludeLabel());
                            this.select.append(homeOfficeOption.html());
                            this.select.prop('disable', false);
                        }
                        else {
                            this.select.prop('disable', true);
                        }
                    }
                }
                else {
                    this.refreshSelectAllSelection();
                    if (this.fakeSelectLabel) {
                        var visibleOptions = this.options.filter(function (option) { return option.isVisible(); });
                        var text = (visibleOptions.length === 1) ? this.matchesFoundSingular : this.matchesFoundPlural;
                        this.fakeSelectLabel.text(String.format(text, visibleOptions.length));
                    }
                    if (this.select) {
                        if (this.getState()) {
                            this.select.append(this.getOptionsElements());
                            this.select.prop('disable', false);
                        }
                        else {
                            this.select.prop('disable', true);
                        }
                    }
                }
            };
            VisualMobileOptionsManager.prototype.appendFocusFilter = function () {
                if (this.hasWrapper()) {
                    var elements = this.getFocusFilterElements();
                    if (elements.length > 0 && this.areAllVisibleFocusOptions()) {
                        var focusLabel = new CategoricalFilterVisualOptions.PlainOption(this.strings.getFocusLabel() + ' ' + this.pluralName, true);
                        this.labelOptions.push(focusLabel);
                        this.getWrapper().append(focusLabel.html());
                        this.getWrapper().append(elements);
                        // Make focus with white background
                        focusLabel.addClasses(VisualMobileOptionsManager.FOCUS_MOBILE_LABEL_CSSCLASS);
                        this.focusFilterOptions.forEach(function (focus) { focus.addClasses(VisualMobileOptionsManager.FOCUS_MOBILE_LABEL_CSSCLASS); });
                    }
                }
            };
            VisualMobileOptionsManager.prototype.appendComponentsListeners = function () {
                var _this = this;
                this.select.change(function () {
                    var ids = _this.select.val() || [];
                    var indexedSelectedLabels = {};
                    ids.forEach(function (label) { indexedSelectedLabels[label] = true; });
                    _this.options.forEach(function (option) {
                        if (option.isVisible()) {
                            option.setSelection(indexedSelectedLabels[option.getData().label] !== undefined);
                        }
                    });
                    _this.refreshSelectAllSelection();
                    _this.refreshFocusFilter();
                    _this.triggerChange();
                });
            };
            VisualMobileOptionsManager.prototype.appendSingleComponentsListeners = function () {
                var _this = this;
                var office = this.options.first(), homeOfficeOption = this.options.last();
                this.select.change(function () {
                    var selectIds = _this.select.val() || [];
                    office.setSingleSelection(true);
                    homeOfficeOption.setSingleSelection(selectIds.length !== 0);
                    _this.triggerChange();
                });
            };
            VisualMobileOptionsManager.prototype.renderFakeSelect = function () {
                if (this.fakeSelect !== null) {
                    return this.fakeSelect;
                }
                this.fakeSelect = jQuery('<div/>', { 'class': 'multiple-select-placeholder unselectable input-group' });
                this.fakeSelect.append(this.renderFakeSelectLabel(), jQuery('<span/>', { 'class': 'input-group-addon', 'text': '...' }));
                return this.fakeSelect;
            };
            VisualMobileOptionsManager.prototype.renderSelect = function () {
                this.select = this.select || jQuery('<select/>', { 'multiple': 'true' });
                /**
                 * Fixes bug with iOS where the first option is always unselected
                 */
                this.select.append(jQuery('<optgroup>', { 'disabled': true }));
                return this.select;
            };
            VisualMobileOptionsManager.prototype.getOptionsElements = function () {
                return this.options.filter(function (option) { return option.isVisible(); }).map(function (option) { return option.html(); });
            };
            VisualMobileOptionsManager.prototype.getFocusFilterElements = function () {
                return this.focusFilterOptions.map(function (focusOption) { return focusOption.html(); });
            };
            VisualMobileOptionsManager.prototype.render = function () {
                if (this.homeOffice) {
                    var wrapper = this.renderWrapper();
                    wrapper.addClass(VisualMobileOptionsManager.WRAPPER_CSSCLASS);
                    var selectWrapper = jQuery('<div/>');
                    selectWrapper.append(this.renderFakeSelect(), this.renderSelect());
                    this.refreshComponents();
                    this.appendSingleComponentsListeners();
                    wrapper.append(selectWrapper);
                }
                else {
                    var wrapper = _super.prototype.render.call(this);
                    wrapper.addClass(VisualMobileOptionsManager.WRAPPER_CSSCLASS);
                    var selectWrapper = jQuery('<div/>');
                    selectWrapper.append(this.renderFakeSelect(), this.renderSelect());
                    this.appendFocusFilter();
                    this.refreshComponents();
                    this.appendComponentsListeners();
                    this.addFocusFilterOptionsEventListeners();
                    wrapper.append(selectWrapper);
                }
                return wrapper;
            };
            VisualMobileOptionsManager.prototype.filter = function (query) {
                query = query.trim().toLowerCase();
                var isEmpty = query.isEmpty();
                var areAnyVisible = false;
                var areAnyFocusVisible = false;
                this.options.forEach(function (option) {
                    var isVisible = null;
                    if (isEmpty) {
                        isVisible = true;
                    }
                    else {
                        var label = (option.getLabel() || '').toLowerCase();
                        isVisible = label.contains(query);
                    }
                    option.setVisibility(isVisible);
                    areAnyVisible = areAnyVisible || isVisible;
                });
                this.focusFilterOptions.forEach(function (focusOption) {
                    var isVisible = null;
                    if (isEmpty) {
                        isVisible = true;
                    }
                    else {
                        var label = (focusOption.getLabel() || '').toLowerCase();
                        isVisible = label.contains(query);
                    }
                    focusOption.setVisibility(isVisible);
                    areAnyFocusVisible = areAnyFocusVisible || isVisible;
                });
                this.clearVisualOptions();
                this.setSelectAllVisibility(areAnyVisible);
                this.setLabelOptionsVisibility(areAnyFocusVisible);
                this.refreshComponents();
            };
            VisualMobileOptionsManager.prototype.setState = function (state) {
                _super.prototype.setState.call(this, state);
                this.refreshComponents();
            };
            VisualMobileOptionsManager.WRAPPER_CSSCLASS = 'mobile-checkboxes-wrapper';
            VisualMobileOptionsManager.FOCUS_MOBILE_LABEL_CSSCLASS = 'focus-label-mobile';
            return VisualMobileOptionsManager;
        }(CategoricalFilterVisualOptions.VisualOptionsManager));
        CategoricalFilterVisualOptions.VisualMobileOptionsManager = VisualMobileOptionsManager;
    })(CategoricalFilterVisualOptions = CardView.CategoricalFilterVisualOptions || (CardView.CategoricalFilterVisualOptions = {}));
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var BaseCategoryFilter = (function () {
        function BaseCategoryFilter(info, envType, strings) {
        }
        BaseCategoryFilter.SEARCH_THRESHOLD = 10;
        BaseCategoryFilter.configInstance = CardView.CategoricalFilterConfigFactory.getInstance();
        return BaseCategoryFilter;
    }());
    CardView.BaseCategoryFilter = BaseCategoryFilter;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var BaseCategoricalFilter = (function (_super) {
        __extends(BaseCategoricalFilter, _super);
        function BaseCategoricalFilter() {
            _super.apply(this, arguments);
        }
        BaseCategoricalFilter.prototype.refreshFilterActionsSection = function () {
            this.refreshApplyButton();
            this.refreshClearButton();
        };
        BaseCategoricalFilter.prototype.refreshClearButton = function () {
            this.setClearButtonState(this.isClearable());
        };
        BaseCategoricalFilter.prototype.setClearButtonState = function (state) {
            var button = this.renderClearButton();
            button.prop(CardView.Filter.DISABLED_ATTRIBUTE, !state);
        };
        BaseCategoricalFilter.prototype.renderClearButton = function () {
            this.clearButton = this.clearButton || jQuery('<button>', { 'type': 'button', 'class': 'btn btn-sm btn-link clear-button pull-left', 'text': this.clearButtonLabel });
            return this.clearButton;
        };
        BaseCategoricalFilter.prototype.getColumnName = function () {
            return this.columnName;
        };
        BaseCategoricalFilter.prototype.getDimensionId = function () {
            return this.dimensionId;
        };
        BaseCategoricalFilter.configInstance = CardView.CategoricalFilterConfigFactory.getInstance();
        return BaseCategoricalFilter;
    }(CardView.Filter));
    CardView.BaseCategoricalFilter = BaseCategoricalFilter;
    var CategoricalFilter = (function (_super) {
        __extends(CategoricalFilter, _super);
        function CategoricalFilter(info, envType, focusFilter, strings) {
            _super.call(this, info, CategoricalFilter.configInstance.getConfig(info.name), strings);
            this.strings = strings;
            this.columnName = info.columnName;
            this.filterId = info.getFilterId();
            this.dimensionId = info.getDimensionId();
            this.initialApplyOrder = info.getApplyOrder();
            this.applyOrder = info.getApplyOrder();
            this.setContext(null);
            this.renderedHeader = null;
            var config = this.getConfig();
            var filteredFocusFilter = this.getFocusFilter(focusFilter);
            this.pluralLabel = (config.pluralNameGetter instanceof Function) ? config.pluralNameGetter(strings) : null;
            this.initialValue = info.getOptions();
            this.value = new CardView.CategoricalFilterOptionsManager(info.getOptions());
            this.options = envType === CardView.EnvironmentEnum.MOBILE ?
                new CardView.CategoricalFilterVisualOptions.VisualMobileOptionsManager(config, this.value, filteredFocusFilter, strings) :
                new CardView.CategoricalFilterVisualOptions.VisualCheckboxOptionsManager(config, this.value, filteredFocusFilter, strings);
            this.searchInput = new CardView.SearchInput(strings.getPlaceholder());
            this.disabledPopOverContent = strings.getSideMenuDisabledFilterPopoverContent();
            this.disabledPopOverTitle = strings.getSideMenuDisabledFilterPopoverTitle();
            this.popOverPosition = envType === CardView.EnvironmentEnum.MOBILE ? 'bottom' : 'right';
            this.clearButtonLabel = strings.getClearButtonLabel();
            this.resultsReturned = new ListenersCollection();
            this.contextExecuted = new ListenersCollection();
        }
        CategoricalFilter.prototype.getFocusFilter = function (focusFilter) {
            var _this = this;
            return focusFilter.filter(function (current) { return current.dimension.id === _this.dimensionId; });
        };
        CategoricalFilter.prototype.save = function () {
            this.initialValue = this.value.getAppliedValue();
            this.initialApplyOrder = this.applyOrder;
        };
        CategoricalFilter.prototype.wasInitiallyApplied = function () {
            return this.initialApplyOrder !== null;
        };
        CategoricalFilter.prototype.getInitialOptions = function () {
            return this.initialValue;
        };
        CategoricalFilter.prototype.getAppliedValue = function () {
            return this.value.getAppliedValue();
        };
        CategoricalFilter.prototype.triggerApplyAnalytics = function () {
            Analytics.registerCardFilterAppliedEvent(this.getAlternativeLabel());
        };
        CategoricalFilter.prototype.getOptionsSavePayload = function () {
            var options = new Array();
            this.getAppliedValue().forEach(function (option) {
                if (option.selected) {
                    options.push({ formattedValue: option.label, value: option.id });
                }
            });
            return options;
        };
        CategoricalFilter.prototype.getSavePayload = function () {
            if (!this.hasApplyOrder()) {
                return null;
            }
            return {
                'filterId': this.filterId,
                'options': this.getOptionsSavePayload(),
                'dimensionId': this.getDimensionId(),
                'applyOrder': this.getApplyOrder()
            };
        };
        CategoricalFilter.prototype.isSaveable = function () {
            if (!this.hasApplyOrder()) {
                return true;
            }
            return !this.value.isEmpty();
        };
        CategoricalFilter.prototype.isCustomized = function () {
            if (!this.hasApplyOrder()) {
                return false;
            }
            if (this.initialApplyOrder !== this.applyOrder) {
                return true;
            }
            return !this.value.isApplied(this.initialValue);
        };
        CategoricalFilter.prototype.setApplyOrder = function (applyOrder) {
            this.applyOrder = applyOrder;
        };
        CategoricalFilter.prototype.hasApplyOrder = function () {
            return this.getApplyOrder() !== null;
        };
        CategoricalFilter.prototype.getApplyOrder = function () {
            return this.applyOrder;
        };
        CategoricalFilter.prototype.isApplicable = function () {
            return this.value.isApplicable();
        };
        CategoricalFilter.prototype.applyValues = function () {
            this.value.apply();
        };
        CategoricalFilter.prototype.getSelectedOptionsCount = function () {
            var selectedOptions = this.value.getSelectedOptions();
            return (selectedOptions === null) ? 0 : selectedOptions.length;
        };
        CategoricalFilter.prototype.getCurrentValue = function () {
            return this.value.getValue();
        };
        CategoricalFilter.prototype.getAlternativeLabel = function () {
            return this.getConfig().label || _super.prototype.getLabel.call(this);
        };
        CategoricalFilter.prototype.getLabel = function () {
            var label = this.getAlternativeLabel();
            if (this.hasApplyOrder() || !this.isDisabled()) {
                var count = this.getSelectedOptionsCount();
                if (count > 0) {
                    label += ' (' + count + ')';
                }
            }
            if (this.hasDisclaimer()) {
                label += ' *';
            }
            return label;
        };
        CategoricalFilter.prototype.hasDisclaimer = function () {
            return this.getConfig().disclaimed;
        };
        CategoricalFilter.prototype.isClearable = function () {
            return this.options.hasVisibleUnselectableOptions();
        };
        CategoricalFilter.prototype.getWrapperCssClass = function () {
            return 'categorical-filter';
        };
        CategoricalFilter.prototype.renderHeader = function () {
            var header = jQuery('<div/>', { 'class': 'configuration-header' });
            header.append(this.searchInput.render());
            return header;
        };
        CategoricalFilter.prototype.disable = function () {
            _super.prototype.disable.call(this);
            this.refreshLabel();
            this.options.disable();
            this.refreshClearButton();
        };
        CategoricalFilter.prototype.disableOnlyFilter = function () {
            _super.prototype.disableInteraction.call(this);
            this.options.disable();
        };
        CategoricalFilter.prototype.enableOnlyFilter = function () {
            _super.prototype.enableInteraction.call(this);
            this.options.enable();
        };
        CategoricalFilter.prototype.executeContextPromise = function (promise) {
            var _this = this;
            this.contextPromise = promise;
            this.contextPromise.then(function (options) {
                if (!_this.hasApplyOrder()) {
                    _this.value.setValue(options);
                    _this.value.apply();
                    _this.options.update();
                    _this.addCategoricalFilterToSales();
                }
                _super.prototype.refreshWrapperLoading.call(_this, { disabled: false });
                _this.enableControls();
                _this.resultsReturned.execute(window, [_this.value.isEmpty()]);
            });
        };
        CategoricalFilter.prototype.addCategoricalFilterToSales = function () {
            if (this.getAppliedValue() !== null) {
                var input = {
                    id: this.dimensionId,
                    options: this.getOptionsSavePayload()
                };
                this.contextExecuted.execute(window, [input]);
            }
        };
        CategoricalFilter.prototype.isDisabled = function () {
            return _super.prototype.isDisabled.call(this);
        };
        CategoricalFilter.prototype.isLoading = function () {
            return !this.hasApplyOrder() && _super.prototype.isDisabled.call(this);
        };
        CategoricalFilter.prototype.enableControls = function () {
            this.value.apply();
            this.options.enable();
            this.refreshClearButton();
            _super.prototype.enable.call(this);
            this.refreshRendered();
        };
        CategoricalFilter.prototype.setContext = function (promise) {
            this.contextPromise = promise;
        };
        CategoricalFilter.prototype.onResultsReturned = function (handler) {
            this.resultsReturned.addEventListener(handler);
        };
        CategoricalFilter.prototype.onContextExecuted = function (handler) {
            this.contextExecuted.addEventListener(handler);
        };
        CategoricalFilter.prototype.renderContent = function () {
            var wrapper = jQuery('<div/>');
            this.renderedHeader = this.renderHeader();
            // Header
            this.refreshHeader();
            // Checkbox content
            this.options.update();
            // Bottom Section
            var actionSection = this.renderFilterActionsSection();
            actionSection.append(this.renderClearButton(), this.renderApplyButton());
            this.refreshFilterActionsSection();
            wrapper.append(this.renderedHeader, this.options.render(), actionSection);
            this.addEventListeners();
            return wrapper;
        };
        CategoricalFilter.prototype.addEventListeners = function () {
            var _this = this;
            _super.prototype.addEventListeners.call(this);
            this.options.onChange(function () {
                _this.refreshRendered();
                _this.refreshClearButton();
                _this.refreshApplyButton();
            });
            this.renderClearButton().click(function () {
                _this.options.unselectAllVisibleOptions();
            });
            this.searchInput.onSearch(function (query) {
                _this.options.filter(query);
                _this.refreshClearButton();
            });
        };
        CategoricalFilter.prototype.reset = function () {
            this.value.setValue(this.initialValue);
            this.applyOrder = this.initialApplyOrder;
            this.value.apply();
            this.options.reset();
            this.options.update();
            this.refreshRendered();
            this.refreshClearButton();
            _super.prototype.reset.call(this);
        };
        CategoricalFilter.prototype.render = function (depth) {
            var rendered = _super.prototype.render.call(this, depth);
            this.refreshRendered();
            return rendered;
        };
        CategoricalFilter.prototype.hasOptions = function () {
            return true;
        };
        CategoricalFilter.prototype.expandable = function () {
            return this.value.hasOptions() && _super.prototype.expandable.call(this);
        };
        CategoricalFilter.prototype.refreshHeader = function () {
            var renderedHeader = this.renderedHeader;
            if (renderedHeader === null) {
                return;
            }
            if (this.value.getOptionsCount() > CategoricalFilter.SEARCH_THRESHOLD) {
                renderedHeader.removeClass(CategoricalFilter.HIDDEN_CSSCLASS);
            }
            else {
                renderedHeader.addClass(CategoricalFilter.HIDDEN_CSSCLASS);
            }
        };
        CategoricalFilter.prototype.refreshRendered = function () {
            var rendered = this.getRendered();
            if (rendered !== null) {
                if (this.value.hasOptions()) {
                    rendered.removeClass(CategoricalFilter.DISABLED_CSSCLASS);
                    this.destroyPopover();
                    this.refreshHeader();
                }
                else {
                    rendered.addClass(CategoricalFilter.DISABLED_CSSCLASS);
                    this.createPopover();
                }
                this.refreshLabel();
            }
        };
        CategoricalFilter.prototype.destroyPopover = function () {
            var rendered = this.getRendered();
            rendered.popover('destroy');
        };
        CategoricalFilter.prototype.createPopover = function () {
            var rendered = this.getRendered();
            rendered.popover({
                'title': this.disabledPopOverTitle,
                'content': this.disabledPopOverContent,
                'placement': this.popOverPosition,
                'trigger': 'hover'
            });
        };
        CategoricalFilter.SEARCH_THRESHOLD = 10;
        return CategoricalFilter;
    }(BaseCategoricalFilter));
    CardView.CategoricalFilter = CategoricalFilter;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var HomeOfficeCategoricalFilter = (function (_super) {
        __extends(HomeOfficeCategoricalFilter, _super);
        function HomeOfficeCategoricalFilter() {
            _super.apply(this, arguments);
        }
        HomeOfficeCategoricalFilter.prototype.getLabel = function () {
            return this.strings.getHomeOfficeLabel();
        };
        HomeOfficeCategoricalFilter.prototype.renderContent = function () {
            var wrapper = jQuery('<div/>');
            this.renderedHeader = this.renderHeader();
            // Header
            this.refreshHeader();
            // Options
            this.options.setHomeOffice(true);
            this.options.update();
            // Bottom Section
            var actionSection = this.renderFilterActionsSection();
            actionSection.append(this.renderApplyButton());
            this.refreshFilterActionsSection();
            wrapper.append(this.renderedHeader, this.options.render(), actionSection);
            this.addEventListeners();
            return wrapper;
        };
        HomeOfficeCategoricalFilter.prototype.hasOptions = function () {
            this.options.setHomeOffice(true);
            this.options.update();
            return this.options.hasHomeOfficeOptions();
        };
        return HomeOfficeCategoricalFilter;
    }(CardView.CategoricalFilter));
    CardView.HomeOfficeCategoricalFilter = HomeOfficeCategoricalFilter;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var SalesCategoricalFilterFormatter = (function () {
        function SalesCategoricalFilterFormatter() {
        }
        SalesCategoricalFilterFormatter.formatValue = function (value, salesType) {
            var saleValue = Number(value);
            // In case of a negative sales, the app will display 0 as minimal value
            if (saleValue < 0 && salesType !== SalesCategoricalFilterFormatter.NEGATIVE_TYPE) {
                saleValue = SalesCategoricalFilterFormatter.MINIMAL_SALES;
            }
            switch (salesType) {
                case SalesCategoricalFilterFormatter.POSITIVE_TYPE:
                    return new LabelBuilder.SalesLabelBuilder(true, true).build(saleValue);
                case SalesCategoricalFilterFormatter.NEGATIVE_TYPE:
                    return new LabelBuilder.SalesLabelBuilder(true, false).build(saleValue);
                case SalesCategoricalFilterFormatter.PERCENTAGE_TYPE:
                    // In case of a market share bigger than 100%, the app will display 100% as maximal value
                    if (saleValue > 100) {
                        saleValue = SalesCategoricalFilterFormatter.MARKET_SHARE_MAXIMAL_VALUE;
                    }
                    return new LabelBuilder.MarketShareLabelBuilder(true, true, 1, true).build(saleValue);
            }
        };
        SalesCategoricalFilterFormatter.formatTooltipValue = function (value, salesType) {
            var saleValue = Number(value);
            switch (salesType) {
                case SalesCategoricalFilterFormatter.POSITIVE_TYPE:
                case SalesCategoricalFilterFormatter.NEGATIVE_TYPE:
                    return new LabelBuilder.FullSalesLabelWithCommasBuilder(true, false).build(saleValue);
                case SalesCategoricalFilterFormatter.PERCENTAGE_TYPE:
                    if (saleValue < 0) {
                        saleValue = SalesCategoricalFilterFormatter.MINIMAL_SALES;
                    }
                    return new LabelBuilder.MarketShareLabelBuilder(true, true, 2, true).build(saleValue);
            }
        };
        SalesCategoricalFilterFormatter.MINIMAL_SALES = 0;
        SalesCategoricalFilterFormatter.MARKET_SHARE_MAXIMAL_VALUE = 100;
        SalesCategoricalFilterFormatter.POSITIVE_TYPE = 'positive';
        SalesCategoricalFilterFormatter.PERCENTAGE_TYPE = 'percentage';
        SalesCategoricalFilterFormatter.NEGATIVE_TYPE = 'negative';
        SalesCategoricalFilterFormatter.NEGATIVE_MASK = '0';
        return SalesCategoricalFilterFormatter;
    }());
    CardView.SalesCategoricalFilterFormatter = SalesCategoricalFilterFormatter;
    var SalesCategoricalFilterRange = (function () {
        function SalesCategoricalFilterRange(min, max, salesType, strings) {
            this.strings = strings;
            this.salesType = salesType;
            this.wrapper = jQuery('<div/>', { class: 'metric-filter-range-display' });
            // Regular Range
            var rangeLabel = jQuery('<span/>', { 'text': this.strings.getSalesFilterRangeLabel() + ' ' });
            var delimiter = jQuery('<span/>', { 'text': ' - ' });
            this.minValue = jQuery('<span/>', { 'text': SalesCategoricalFilterFormatter.formatValue(min, salesType) });
            this.maxValue = jQuery('<span/>', { 'text': SalesCategoricalFilterFormatter.formatValue(max, salesType) });
            this.range = jQuery('<div/>');
            this.range.append(rangeLabel, this.minValue, delimiter, this.maxValue);
            // No Range
            var noRangeLabel = jQuery('<span/>', { 'text': this.strings.getSalesFilterRangeAvailabilityLabel() });
            this.noRange = jQuery('<div/>', { 'class': 'metric-filter-range-display-no-range' });
            this.noRange.append(noRangeLabel);
            // Checking range availability...
            this.isRangeAvailable = this.checkRangeAvailability(min, max);
            if (this.isRangeAvailable) {
                this.noRange.hide();
                this.range.show();
            }
            else {
                this.range.hide();
                this.noRange.show();
            }
            // Final Append
            this.wrapper.append(this.noRange, this.range);
        }
        SalesCategoricalFilterRange.prototype.checkRangeAvailability = function (min, max) {
            return !(min === null || max === null);
        };
        SalesCategoricalFilterRange.prototype.refreshRange = function (min, max) {
            this.minValue.text('');
            this.maxValue.text('');
            this.minValue.text(SalesCategoricalFilterFormatter.formatValue(min, this.salesType));
            this.maxValue.text(SalesCategoricalFilterFormatter.formatValue(max, this.salesType));
        };
        SalesCategoricalFilterRange.prototype.render = function () {
            return this.wrapper;
        };
        SalesCategoricalFilterRange.prototype.updateRangeValues = function (min, max) {
            this.isRangeAvailable = this.checkRangeAvailability(min, max);
            if (this.isRangeAvailable) {
                this.refreshRange(min, max);
                this.noRange.hide();
                this.range.show();
            }
            else {
                this.range.hide();
                this.noRange.show();
            }
        };
        SalesCategoricalFilterRange.prototype.getRangeAvailability = function () {
            return this.isRangeAvailable;
        };
        return SalesCategoricalFilterRange;
    }());
    var SalesCategoricalFilterSlider = (function () {
        function SalesCategoricalFilterSlider(data, range, salesType) {
            this.sliderChangeListener = new ListenersCollection();
            this.wrapper = jQuery('<div/>', { 'class': 'ws-card-view-sales-filter-slider-wrapper' });
            this.range = range;
            this.salesType = salesType;
            this.slider = jQuery('<div/>');
            this.wrapper.append(this.slider);
            this.min = data.min;
            this.max = data.max;
            this.initialMin = data.initialMin;
            this.initialMax = data.initialMax;
            // noUiSlider does not handle well with min === max
            // Fixing increment and decrement before slider creation
            var behaviour = 'drag-tap';
            var min = Number(this.min);
            var max = Number(this.max);
            var initialMin = Number(this.initialMin);
            var initialMax = Number(this.initialMax);
            if (initialMin === initialMax) {
                // In case of true, the slider will be blocked to move
                behaviour = 'fixed;';
                min--;
                max++;
                initialMin--;
                initialMax++;
            }
            // Slider Component
            this.slider.noUiSlider({
                'behaviour': behaviour,
                'connect': true,
                'start': [min, max],
                'range': {
                    'min': initialMin,
                    'max': initialMax
                }
            });
            // Checking range availability...
            if (this.checkRangeAvailability()) {
                this.show();
            }
            else {
                this.hide();
            }
            this.refreshTooltips();
            this.addEventListener();
        }
        SalesCategoricalFilterSlider.prototype.checkRangeAvailability = function () {
            return !(this.initialMin === null || this.initialMax === null);
        };
        SalesCategoricalFilterSlider.prototype.onSliderChange = function (handler) {
            this.sliderChangeListener.addEventListener(handler);
        };
        SalesCategoricalFilterSlider.prototype.addEventListener = function () {
            var _this = this;
            this.slider.change(function () {
                var values = _this.slider.val();
                _this.min = values.first();
                _this.max = values.last();
                _this.refreshTooltips();
                _this.range.updateRangeValues(_this.min, _this.max);
                _this.sliderChangeListener.execute(window, []);
            });
        };
        SalesCategoricalFilterSlider.prototype.refreshTooltips = function () {
            var tooltipMinValue = SalesCategoricalFilterFormatter.formatTooltipValue(this.min, this.salesType);
            var tooltipMaxValue = SalesCategoricalFilterFormatter.formatTooltipValue(this.max, this.salesType);
            this.slider.find('.noUi-handle-lower').attr('title', tooltipMinValue);
            this.slider.find('.noUi-handle-upper').attr('title', tooltipMaxValue);
        };
        SalesCategoricalFilterSlider.prototype.show = function () {
            this.wrapper.show();
        };
        SalesCategoricalFilterSlider.prototype.hide = function () {
            this.wrapper.hide();
        };
        SalesCategoricalFilterSlider.prototype.refreshSlider = function () {
            if (this.checkRangeAvailability()) {
                this.show();
                this.slider.unbind();
                this.min = this.min === null ? this.initialMin : this.min;
                this.max = this.max === null ? this.initialMax : this.max;
                // noUiSlider does not handle well with min === max
                // Fixing increment and decrement before slider update
                var behaviour = 'drag-tap';
                var min = Number(this.min);
                var max = Number(this.max);
                var initialMin = Number(this.initialMin);
                var initialMax = Number(this.initialMax);
                if (initialMin === initialMax) {
                    // In case of true, the slider will be blocked to move
                    behaviour = 'fixed;';
                    min--;
                    max++;
                    initialMin--;
                    initialMax++;
                }
                // Updating slider...
                this.slider.noUiSlider({
                    'behaviour': behaviour,
                    'start': [min, max],
                    'range': {
                        'min': initialMin,
                        'max': initialMax
                    }
                }, true);
                this.refreshTooltips();
                this.range.updateRangeValues(this.min, this.max);
                this.addEventListener();
            }
            else {
                this.hide();
            }
        };
        SalesCategoricalFilterSlider.prototype.getWrapper = function () {
            return this.wrapper;
        };
        SalesCategoricalFilterSlider.prototype.resetRange = function () {
            this.min = this.initialMin;
            this.max = this.initialMax;
            this.refreshSlider();
        };
        SalesCategoricalFilterSlider.prototype.disable = function () {
            if (this.slider !== null) {
                this.slider.attr(SalesCategoricalFilterSlider.DISABLED_ATTRIBUTE, SalesCategoricalFilterSlider.DISABLED_ATTRIBUTE);
            }
        };
        SalesCategoricalFilterSlider.prototype.enable = function () {
            if (this.slider !== null) {
                this.slider.removeAttr(SalesCategoricalFilterSlider.DISABLED_ATTRIBUTE);
            }
        };
        SalesCategoricalFilterSlider.prototype.getInitialMin = function () {
            return this.initialMin;
        };
        SalesCategoricalFilterSlider.prototype.getInitialMax = function () {
            return this.initialMax;
        };
        SalesCategoricalFilterSlider.prototype.getMin = function () {
            return this.min;
        };
        SalesCategoricalFilterSlider.prototype.getMax = function () {
            return this.max;
        };
        SalesCategoricalFilterSlider.prototype.setInitialMin = function (initialMin) {
            this.initialMin = initialMin;
        };
        SalesCategoricalFilterSlider.prototype.setInitialMax = function (initialMax) {
            this.initialMax = initialMax;
        };
        SalesCategoricalFilterSlider.prototype.setMin = function (min) {
            this.min = min;
        };
        SalesCategoricalFilterSlider.prototype.setMax = function (max) {
            this.max = max;
        };
        SalesCategoricalFilterSlider.DISABLED_ATTRIBUTE = 'disabled';
        return SalesCategoricalFilterSlider;
    }());
    var SalesCategoricalFilter = (function (_super) {
        __extends(SalesCategoricalFilter, _super);
        function SalesCategoricalFilter(info, envType, strings) {
            _super.call(this, info, CardView.CategoricalFilter.configInstance.getConfig(info.name), strings);
            this.strings = strings;
            this.columnName = info.columnName;
            this.dimensionId = info.dimensionId;
            this.filterId = info.filterId;
            this.initialApplied = info.initialApplied === null ? false : info.initialApplied;
            this.customized = this.initialApplied;
            this.initialOptions = info.options;
            this.appliedOptions = info.options;
            this.clearButtonLabel = strings.getClearButtonLabel();
            this.setSalesContext(null);
            // Sales Type
            this.salesType = this.getConfig().salesType;
            // Range Component Values
            this.range = new SalesCategoricalFilterRange(info.options.min, info.options.max, this.salesType, this.strings);
            // Slider Component
            this.salesInputs = jQuery('<div/>', { 'class': 'sales-input-box' });
            this.buildSalesFilters();
            // Event Listeners
            this.addEventListeners();
            this.addSliderEventListeners();
        }
        SalesCategoricalFilter.prototype.buildSalesFilters = function () {
            if (parseFloat(this.initialOptions.min) < 0 && this.salesType !== SalesCategoricalFilterFormatter.NEGATIVE_TYPE) {
                this.initialOptions.min = "0";
            }
            if (this.columnName === "market_share") {
                this.initialOptions.min = parseFloat(this.initialOptions.min).toFixed(1);
                if (parseFloat(this.initialOptions.max) > 100) {
                    this.initialOptions.max = "100.0";
                }
            }
            else {
                this.initialOptions.min = this.roundToThousands(parseFloat(this.initialOptions.min)).toFixed(0);
                this.initialOptions.max = this.roundToThousands(parseFloat(this.initialOptions.max)).toFixed(0);
            }
            var displayMin = this.columnName === "market_share" ? parseFloat(this.initialOptions.min).toFixed(1) : parseFloat(this.initialOptions.min) / 1000;
            var displayMax = this.columnName === "market_share" ? parseFloat(this.initialOptions.max).toFixed(1) : parseFloat(this.initialOptions.max) / 1000;
            var salesMinInputBox = jQuery('<input>', { 'type': 'text', 'class': 'sales-min-input', 'value': displayMin });
            var dash = jQuery('<p/>', { 'text': ' - ', 'class': 'sales-filter-dash' });
            var salesMaxInputBox = jQuery('<input>', { 'type': 'text', 'class': 'sales-max-input', 'value': displayMax });
            var thousandLabel = jQuery('<div/>', { 'class': 'thousand-msg', 'text': '(the higher/lower range is shown in thousands)' });
            var salesInputErrorMessage = jQuery('<div/>', { 'class': 'sales-input-error-msg', 'text': 'Please enter a valid numeric value.' });
            this.salesInputs.append(salesMinInputBox, dash, salesMaxInputBox, this.columnName === "market_share" ? jQuery() : thousandLabel, salesInputErrorMessage);
        };
        //rounds up to nearest thousand
        SalesCategoricalFilter.prototype.roundToThousands = function (value) {
            return Math.ceil(value / 1000) * 1000;
        };
        SalesCategoricalFilter.prototype.addSliderEventListeners = function () {
            var me = this;
            this.setClearButtonState(false);
            this.salesInputs.find('.sales-min-input, .sales-max-input').keyup(function () {
                var isValidNumeric = /[$0-9.,-]*$/g.test($(this).val());
                if (!isValidNumeric) {
                    $(this).addClass('sales-error-input');
                    me.salesInputs.find('.sales-input-error-msg').show();
                    me.salesInputs.parent().find('.filter-actions .btn-primary').prop('disabled', true);
                }
                else {
                    $(this).removeClass('sales-error-input');
                    me.salesInputs.find('.sales-input-error-msg').hide();
                    me.salesInputs.parent().find('.filter-actions .btn-primary').prop('disabled', false);
                }
            });
            this.salesInputs.find('.sales-min-input, .sales-max-input').change(function () {
                var isValidNumeric = /[$0-9.,-]*$/g.test($(this).val());
                var min;
                var max;
                if (!$(this).val()) {
                    $(this).val("0");
                }
                if (isValidNumeric) {
                    //turn input values into correct values
                    min = Math.round(me.salesInputs.find('.sales-min-input').val().replace(/\$|\,|\(|\)/g, ''));
                    max = Math.round(me.salesInputs.find('.sales-max-input').val().replace(/\$|\,|\(|\)/g, ''));
                    //handle invalid input
                    if (isNaN(min)) {
                        min = (me.columnName !== "market_share") ? Number(me.initialOptions.min) / 1000 : me.initialOptions.min;
                    }
                    if (isNaN(max)) {
                        max = (me.columnName !== "market_share") ? Number(me.initialOptions.max) / 1000 : me.initialOptions.max;
                    }
                    //verify endpoints conform to the initial range
                    //market share uses percentage, others use thousand as unit
                    if (me.columnName !== "market_share") {
                        if (Number(min) * 1000 < Number(me.initialOptions.min) || Number(min) * 1000 > Number(me.initialOptions.max)) {
                            min = Number(me.initialOptions.min) / 1000;
                        }
                    }
                    else {
                        var initialMin = Number(me.initialOptions.min);
                        if (initialMin != 0) {
                            initialMin = 0;
                        }
                        if (Number(min) < initialMin || Number(min) > Number(me.initialOptions.max)) {
                            min = me.initialOptions.min;
                        }
                    }
                    if (me.columnName !== "market_share") {
                        if (Number(max) * 1000 > Number(me.initialOptions.max) || Number(max) * 1000 < Number(me.initialOptions.min)) {
                            max = Number(me.initialOptions.max) / 1000;
                        }
                    }
                    else {
                        var initialMax = Number(me.initialOptions.max);
                        if (initialMax != 100) {
                            initialMax = 100;
                        }
                        if (Number(max) > initialMax || Number(max) < Number(me.initialOptions.min)) {
                            max = me.initialOptions.max;
                        }
                    }
                    me.salesInputs.find('.sales-min-input').val(min);
                    me.salesInputs.find('.sales-max-input').val(max);
                    //prep endpoints for range display
                    if (me.columnName !== "market_share") {
                        min *= 1000;
                        max *= 1000;
                    }
                    me.range.updateRangeValues(min, max);
                    me.setApplyButtonState(true);
                }
            });
        };
        SalesCategoricalFilter.prototype.checkRangeAvailability = function () {
            return !(this.getSliderMin() === null || this.getSliderMax() === null);
        };
        SalesCategoricalFilter.prototype.getSliderMin = function () {
            return (this.salesInputs.find('.sales-min-input').val());
        };
        SalesCategoricalFilter.prototype.getSliderMax = function () {
            var max = (this.salesInputs.find('.sales-max-input').val());
            if (this.salesType !== SalesCategoricalFilterFormatter.NEGATIVE_TYPE &&
                max !== null &&
                Number(this.getSliderMin()) <= 0 &&
                Number(max) <= 0) {
                return SalesCategoricalFilterFormatter.NEGATIVE_MASK;
            }
            return max;
        };
        SalesCategoricalFilter.prototype.refreshAppliedOptions = function () {
            this.appliedOptions = {
                min: (this.salesInputs.find('.sales-min-input').val()),
                max: (this.salesInputs.find('.sales-max-input').val()),
                initialMin: this.initialOptions.initialMin,
                initialMax: this.initialOptions.initialMin
            };
        };
        SalesCategoricalFilter.prototype.renderContent = function () {
            var wrapper = jQuery('<div/>', { class: 'metric-filter-wrapper open-sans' });
            // Bottom Section
            var actionSection = this.renderFilterActionsSection();
            actionSection.append(this.renderApplyButton());
            this.refreshFilterActionsSection();
            return wrapper.append(this.range.render(), this.salesInputs, actionSection);
        };
        SalesCategoricalFilter.prototype.isClearable = function () {
            return true;
        };
        SalesCategoricalFilter.prototype.getWrapperCssClass = function () {
            return 'categorical-sales-filter';
        };
        SalesCategoricalFilter.prototype.getInitialOptions = function () {
            return this.initialOptions;
        };
        SalesCategoricalFilter.prototype.setCustomized = function (customized) {
            this.customized = customized;
        };
        SalesCategoricalFilter.prototype.isApplicable = function () {
            return this.checkRangeAvailability();
        };
        SalesCategoricalFilter.prototype.isCustomized = function () {
            return this.customized;
        };
        SalesCategoricalFilter.prototype.wasInitiallyApplied = function () {
            return this.initialApplied;
        };
        SalesCategoricalFilter.prototype.save = function () { };
        SalesCategoricalFilter.prototype.setSalesContext = function (promise) {
            this.salesContextPromise = promise;
        };
        SalesCategoricalFilter.prototype.enableOnlyFilter = function () {
            this.enableControls();
        };
        SalesCategoricalFilter.prototype.disableOnly = function () {
            this.disable();
        };
        SalesCategoricalFilter.prototype.disableSalesOptions = function (disable) {
            if (disable) {
                this.salesInputs.find('input').attr('disabled', 'true');
            }
            else {
                this.salesInputs.find('input').removeAttr('disabled');
            }
        };
        SalesCategoricalFilter.prototype.disable = function () {
            this.disableSalesOptions(true);
            _super.prototype.disableInteraction.call(this);
        };
        SalesCategoricalFilter.prototype.enable = function () {
            var _this = this;
            if (this.salesContextPromise === null) {
                this.enableControls();
            }
            else {
                this.salesContextPromise.then(function (options) {
                    _this.updateOptions(options);
                    _this.resetValues();
                    _this.enableControls();
                    _this.salesContextPromise = null;
                });
            }
            if (this.range.getRangeAvailability()) {
                this.salesInputs.show();
                this.setApplyButtonState(true);
            }
            else {
                this.salesInputs.hide();
                this.setApplyButtonState(false);
            }
        };
        SalesCategoricalFilter.prototype.hasOptions = function () {
            return true;
        };
        SalesCategoricalFilter.prototype.updateOptions = function (newOptions) {
            this.salesInputs.find('.sales-min-input').val(parseFloat(newOptions.min).toFixed(1));
            this.salesInputs.find('.sales-max-input').val(parseFloat(newOptions.max).toFixed(1));
            this.range.updateRangeValues(newOptions.min, newOptions.max);
            this.refreshAppliedOptions();
        };
        SalesCategoricalFilter.prototype.resetInitialValues = function () {
            this.salesInputs.find('.sales-min-input').val(parseFloat(this.initialOptions.min).toFixed(1));
            this.salesInputs.find('.sales-max-input').val(parseFloat(this.initialOptions.max).toFixed(1));
            this.refreshAppliedOptions();
            this.range.updateRangeValues(this.appliedOptions.min, this.appliedOptions.max);
        };
        SalesCategoricalFilter.prototype.resetValues = function () {
            this.salesInputs.find('.sales-min-input').val(this.initialOptions.min);
            this.salesInputs.find('.sales-max-input').val(this.initialOptions.max);
        };
        SalesCategoricalFilter.prototype.enableControls = function () {
            this.disableSalesOptions(false);
            _super.prototype.enableInteraction.call(this);
        };
        SalesCategoricalFilter.prototype.refreshRendered = function () {
            var rendered = this.getRendered();
            rendered.removeClass(CardView.CategoricalFilter.DISABLED_CSSCLASS);
        };
        SalesCategoricalFilter.prototype.reset = function () {
            this.resetInitialValues();
            this.refreshRendered();
            this.refreshClearButton();
            _super.prototype.reset.call(this);
            if (this.range.getRangeAvailability()) {
                this.salesInputs.show();
                this.setApplyButtonState(true);
            }
            else {
                this.salesInputs.hide();
                this.setApplyButtonState(false);
            }
        };
        SalesCategoricalFilter.prototype.applyValues = function () { };
        SalesCategoricalFilter.prototype.getSavePayload = function () {
            return {
                'filterId': this.filterId,
                'options': this.appliedOptions,
                'dimensionId': this.getDimensionId(),
                'initialApplied': this.customized
            };
        };
        SalesCategoricalFilter.prototype.getFilterId = function () {
            return this.filterId;
        };
        SalesCategoricalFilter.prototype.getMinValue = function () {
            return this.getSliderMin();
        };
        SalesCategoricalFilter.prototype.getMaxValue = function () {
            return this.getSliderMax();
        };
        SalesCategoricalFilter.prototype.getSalesType = function () {
            return this.salesType;
        };
        SalesCategoricalFilter.prototype.getAlternativeLabel = function () {
            return this.getConfig().label || _super.prototype.getLabel.call(this);
        };
        SalesCategoricalFilter.prototype.triggerApplyAnalytics = function () {
            Analytics.registerCardFilterAppliedEvent(this.getAlternativeLabel());
        };
        return SalesCategoricalFilter;
    }(CardView.BaseCategoricalFilter));
    CardView.SalesCategoricalFilter = SalesCategoricalFilter;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var NumericValueManager = (function (_super) {
        __extends(NumericValueManager, _super);
        function NumericValueManager() {
            _super.apply(this, arguments);
        }
        NumericValueManager.prototype.equals = function (initial, current) {
            return initial === current;
        };
        NumericValueManager.prototype.clone = function (original) {
            return Number(original);
        };
        return NumericValueManager;
    }(CardView.ValueManager));
    CardView.NumericValueManager = NumericValueManager;
    var StringValueManager = (function (_super) {
        __extends(StringValueManager, _super);
        function StringValueManager() {
            _super.apply(this, arguments);
        }
        StringValueManager.prototype.equals = function (initial, current) {
            return initial === current;
        };
        StringValueManager.prototype.clone = function (original) {
            return String(original);
        };
        return StringValueManager;
    }(CardView.ValueManager));
    CardView.StringValueManager = StringValueManager;
    var Parameter = (function (_super) {
        __extends(Parameter, _super);
        function Parameter(info, value, staticConfig, strings) {
            _super.call(this, info, staticConfig, strings);
            this.label = staticConfig.label || info.name;
            this.info = info;
            this.value = value;
            this.overrideInitialValue();
        }
        Parameter.prototype.getSavePayload = function () {
            var info = this.info;
            return {
                parameterId: info.parameterId,
                name: this.getName(),
                allowableValues: info.allowableValues,
                dataType: info.dataType.toUpperCase(),
                allowableValuesType: info.allowableValuesType.toUpperCase(),
                minValue: info.minValue,
                maxValue: info.maxValue,
                stepSize: info.stepSize,
                currentValue: this.value.getAppliedValue(),
                dateStepPeriod: info.dateStepPeriod
            };
        };
        Parameter.prototype.getInitialValue = function () {
            return this.initialValue;
        };
        Parameter.prototype.overrideInitialValue = function () {
            this.initialValue = this.value.getAppliedValue();
        };
        Parameter.prototype.save = function () {
            this.overrideInitialValue();
        };
        Parameter.prototype.render = function (depth) {
            return _super.prototype.render.call(this, depth);
        };
        Parameter.prototype.isDisabled = function () {
            return _super.prototype.isDisabled.call(this);
        };
        Parameter.prototype.getParameterInfo = function () {
            return this.info;
        };
        Parameter.prototype.getValueManager = function () {
            return this.value;
        };
        Parameter.prototype.getLabel = function () {
            return this.label;
        };
        Parameter.prototype.isApplicable = function () {
            return this.getValueManager().isApplicable();
        };
        Parameter.prototype.getValues = function () {
            return this.info.allowableValues;
        };
        Parameter.prototype.getCurrentValue = function () {
            return this.getValueManager().getValue();
        };
        Parameter.prototype.applyValues = function () {
            this.getValueManager().apply();
        };
        Parameter.prototype.isCustomized = function () {
            return !this.value.isApplied(this.initialValue);
        };
        Parameter.prototype.reset = function () {
            this.value.setValue(this.initialValue);
            this.value.apply();
            _super.prototype.reset.call(this);
        };
        return Parameter;
    }(CardView.Filter));
    CardView.Parameter = Parameter;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var SliderParameter = (function (_super) {
        __extends(SliderParameter, _super);
        function SliderParameter(info, staticConfig, strings) {
            _super.call(this, info, new CardView.NumericValueManager(info.currentValue), staticConfig, strings);
            this.rangeLabel = strings.getRangeLabel();
            this.slider = null;
        }
        SliderParameter.prototype.getWrapperCssClass = function () {
            return 'property-control parameter range';
        };
        SliderParameter.prototype.triggerApplyAnalytics = function () {
            Analytics.registerCardParameterAppliedEvent(this.getLabel());
        };
        SliderParameter.prototype.renderContent = function () {
            var wrapper = jQuery('<div/>');
            this.slider = jQuery('<div/>');
            var label = jQuery('<span/>', { 'class': 'slider-label' });
            wrapper.append(this.slider, label);
            var info = this.getParameterInfo();
            this.slider.noUiSlider({
                'behaviour': 'snap',
                'start': this.getValueManager().getValue(),
                'step': info.stepSize,
                'range': {
                    'min': info.minValue,
                    'max': info.maxValue
                },
                'serialization': {
                    'lower': [
                        jQuery.Link({
                            'target': label,
                            'format': {
                                'prefix': this.rangeLabel,
                                'decimals': 0
                            }
                        })
                    ]
                }
            });
            var actionSection = this.renderFilterActionsSection();
            var applyButton = this.renderApplyButton();
            this.refreshApplyButton();
            actionSection.append(applyButton);
            wrapper.append(actionSection);
            this.addSliderEventListeners();
            return wrapper;
        };
        SliderParameter.prototype.disable = function () {
            if (this.slider !== null) {
                this.slider.attr(SliderParameter.DISABLED_ATTRIBUTE, SliderParameter.DISABLED_ATTRIBUTE);
            }
            _super.prototype.disable.call(this);
        };
        SliderParameter.prototype.enable = function () {
            _super.prototype.enable.call(this);
            if (this.slider !== null) {
                this.slider.attr(SliderParameter.DISABLED_ATTRIBUTE, null);
            }
        };
        SliderParameter.prototype.addSliderEventListeners = function () {
            var _this = this;
            this.slider.change(function () {
                var currentValue = Number(_this.slider.val());
                _this.getValueManager().setValue(currentValue);
                _this.refreshApplyButton();
            });
            _super.prototype.addEventListeners.call(this);
        };
        SliderParameter.prototype.reset = function () {
            _super.prototype.reset.call(this);
            if (this.slider !== null) {
                this.slider.val(this.getCurrentValue());
            }
        };
        SliderParameter.prototype.hasOptions = function () {
            return this.getParameterInfo().minValue !== null &&
                this.getParameterInfo().maxValue !== null;
        };
        return SliderParameter;
    }(CardView.Parameter));
    CardView.SliderParameter = SliderParameter;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var ListParameter = (function (_super) {
        __extends(ListParameter, _super);
        function ListParameter(info, staticConfig, strings) {
            _super.call(this, info, new CardView.StringValueManager(info.currentValue), staticConfig, strings);
            this.select = null;
        }
        ListParameter.prototype.createSelectOptions = function () {
            var values = this.getParameterInfo().allowableValues.slice(0);
            values.sort(function (curr, next) { return curr.formattedValue > next.formattedValue ? 1 : -1; });
            return values.map(function (option) {
                return jQuery('<option/>', { 'text': option.formattedValue || option.value, 'value': option.value });
            });
        };
        ListParameter.prototype.triggerApplyAnalytics = function () {
            Analytics.registerCardParameterAppliedEvent(this.getLabel(), this.getCurrentValue());
        };
        ListParameter.prototype.getSelect = function () {
            return this.select;
        };
        ListParameter.prototype.refreshSelect = function () {
            if (this.select !== null) {
                this.select.val(this.getCurrentValue());
            }
        };
        ListParameter.prototype.createSelect = function () {
            // Creating select element
            this.select = jQuery('<select/>', { 'class': this.getSelectCssClass() });
            this.select.append(this.createSelectOptions());
            this.refreshSelect();
        };
        ListParameter.prototype.hasOptions = function () {
            return !this.getParameterInfo().allowableValues.slice(0).isEmpty();
        };
        return ListParameter;
    }(CardView.Parameter));
    var SideMenuListParameter = (function (_super) {
        __extends(SideMenuListParameter, _super);
        function SideMenuListParameter(info, staticConfig, strings) {
            _super.call(this, info, staticConfig, strings);
            this.noResultsMessage = strings.getNoResultsMessageLabel();
        }
        SideMenuListParameter.prototype.getSelectCssClass = function () {
            return '';
        };
        SideMenuListParameter.prototype.getWrapperCssClass = function () {
            return 'property-control parameter list';
        };
        SideMenuListParameter.prototype.renderContent = function () {
            var wrapper = jQuery('<div/>');
            this.createSelect();
            wrapper.append(this.getSelect());
            // Calling chosen plugin
            this.getSelect()
                .chosen({
                'disable_search_threshold': SideMenuListParameter.DISABLE_SEARCH_THRESHOLD,
                'no_results_text': this.noResultsMessage,
                'width': '100%'
            });
            this.addSelectEventListeners();
            // Creating apply section
            var actionSection = this.renderFilterActionsSection();
            var applyButton = this.renderApplyButton();
            this.refreshApplyButton();
            actionSection.append(applyButton);
            wrapper.append(actionSection);
            return wrapper;
        };
        SideMenuListParameter.prototype.reset = function () {
            _super.prototype.reset.call(this);
            if (this.getSelect() !== null) {
                this.getSelect().val(this.getCurrentValue()).trigger('chosen:updated');
            }
        };
        SideMenuListParameter.prototype.addSelectEventListeners = function () {
            var _this = this;
            this.getSelect().change(function () {
                var currentValue = String(_this.getSelect().val());
                _this.getValueManager().setValue(currentValue);
                _this.refreshApplyButton();
            });
            _super.prototype.addEventListeners.call(this);
        };
        SideMenuListParameter.prototype.disable = function () {
            _super.prototype.disable.call(this);
            if (this.getSelect() !== null) {
                this.getSelect().attr(SideMenuListParameter.DISABLED_ATTRIBUTE, SideMenuListParameter.DISABLED_ATTRIBUTE);
            }
        };
        SideMenuListParameter.prototype.enable = function () {
            _super.prototype.enable.call(this);
            if (this.getSelect() !== null) {
                this.getSelect().attr(SideMenuListParameter.DISABLED_ATTRIBUTE, null);
            }
        };
        SideMenuListParameter.DISABLE_SEARCH_THRESHOLD = 20;
        return SideMenuListParameter;
    }(ListParameter));
    CardView.SideMenuListParameter = SideMenuListParameter;
    var TopListParameter = (function (_super) {
        __extends(TopListParameter, _super);
        function TopListParameter(info, staticConfig, envType, strings) {
            _super.call(this, info, staticConfig, strings);
            this.envType = envType;
        }
        TopListParameter.prototype.getWrapperCssClass = function () {
            return 'top-control ws-top-list-parameter-dropdown';
        };
        TopListParameter.prototype.getSelectCssClass = function () {
            return (this.envType === CardView.EnvironmentEnum.PC) ? 'form-control' : 'form-control wallet-share-select-tablet';
        };
        TopListParameter.prototype.renderContent = function () {
            return null;
        };
        TopListParameter.prototype.render = function (depth) {
            var wrapper = jQuery('<div/>', { 'id': this.getConfig().id, 'class': 'ws-top-list-parameter-wrapper' });
            var span = jQuery('<div/>', { 'class': 'ws-top-list-parameter-label', 'text': this.getConfig().label + ': ' });
            var dropDownWrapper = jQuery('<div/>', { 'class': this.getWrapperCssClass() });
            this.createSelect();
            dropDownWrapper.append(this.getSelect());
            this.addSelectEventListeners();
            return wrapper.append(span, dropDownWrapper);
        };
        TopListParameter.prototype.addSelectEventListeners = function () {
            var _this = this;
            this.getSelect().change(function () {
                var currentValue = String(_this.getSelect().val());
                _this.getValueManager().setValue(currentValue);
                _this.apply();
            });
            _super.prototype.addEventListeners.call(this);
        };
        TopListParameter.prototype.disable = function () {
            if (this.getSelect() !== null) {
                this.getSelect().attr(TopListParameter.DISABLED_ATTRIBUTE, TopListParameter.DISABLED_ATTRIBUTE);
            }
        };
        TopListParameter.prototype.enable = function () {
            if (this.getSelect() !== null) {
                if (!this.getSelect().hasClass(TopListParameter.KEEP_DISABLED_CLASS)) {
                    this.getSelect().attr(TopListParameter.DISABLED_ATTRIBUTE, null);
                }
            }
        };
        TopListParameter.prototype.reset = function () {
            _super.prototype.reset.call(this);
            if (this.getSelect() !== null) {
                this.getSelect().val(this.getCurrentValue());
            }
        };
        TopListParameter.KEEP_DISABLED_CLASS = 'keep-disabled';
        return TopListParameter;
    }(ListParameter));
    CardView.TopListParameter = TopListParameter;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var FilterFactory = (function () {
        function FilterFactory() {
        }
        FilterFactory.createFilter = function (filterInfo, envType, focusFilter, strings) {
            var type = filterInfo.name.toUpperCase();
            switch (type) {
                case this.HOME_OFFICE_FILTER:
                    return new CardView.HomeOfficeCategoricalFilter(filterInfo, envType, focusFilter, strings);
            }
            return new CardView.CategoricalFilter(filterInfo, envType, focusFilter, strings);
        };
        FilterFactory.HOME_OFFICE_FILTER = 'HOMEOFFICE';
        return FilterFactory;
    }());
    CardView.FilterFactory = FilterFactory;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var MetricFilterFactory = (function () {
        function MetricFilterFactory() {
        }
        MetricFilterFactory.createFilter = function (salesFilterInfo, envType, strings) {
            return new CardView.SalesCategoricalFilter(salesFilterInfo, envType, strings);
        };
        return MetricFilterFactory;
    }());
    CardView.MetricFilterFactory = MetricFilterFactory;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var ParameterFactory = (function () {
        function ParameterFactory() {
        }
        ParameterFactory.createParameter = function (info, envType, strings) {
            if (CardView.FilterUtils.isNameHidden(info.name)) {
                return null;
            }
            var configuration = CardView.ParameterConfigFactory.getInstance().getConfig(info.name);
            var type = info.allowableValuesType.toUpperCase();
            switch (type) {
                case this.LIST_PARAMETER_TYPE:
                    var location = configuration.location;
                    switch (location) {
                        case CardView.FilterLocation.TOP:
                            return new CardView.TopListParameter(info, configuration, envType, strings);
                        case CardView.FilterLocation.SIDE_MENU:
                            return new CardView.SideMenuListParameter(info, configuration, strings);
                    }
                    break;
                case this.RANGE_PARAMETER_TYPE:
                    return new CardView.SliderParameter(info, configuration, strings);
            }
            return null;
        };
        ParameterFactory.LIST_PARAMETER_TYPE = 'LIST';
        ParameterFactory.RANGE_PARAMETER_TYPE = 'RANGE';
        return ParameterFactory;
    }());
    CardView.ParameterFactory = ParameterFactory;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var CardViewTabSwitchEvent = (function () {
        function CardViewTabSwitchEvent(newSheetName, previousSheetName) {
            this.newSheetName = newSheetName;
            this.previousSheetName = previousSheetName;
        }
        CardViewTabSwitchEvent.prototype.getNewSheetName = function () {
            return this.newSheetName;
        };
        CardViewTabSwitchEvent.prototype.getPreviousSheetName = function () {
            return this.previousSheetName;
        };
        return CardViewTabSwitchEvent;
    }());
    CardView.CardViewTabSwitchEvent = CardViewTabSwitchEvent;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    (function (CardViewReportEvents) {
        CardViewReportEvents[CardViewReportEvents["IGNORING_FILTERS"] = 10] = "IGNORING_FILTERS";
        CardViewReportEvents[CardViewReportEvents["USING_FILTERS"] = 20] = "USING_FILTERS";
        CardViewReportEvents[CardViewReportEvents["REPORT_CHANGES"] = 30] = "REPORT_CHANGES";
        CardViewReportEvents[CardViewReportEvents["REPORT_REPLACED"] = 40] = "REPORT_REPLACED";
        CardViewReportEvents[CardViewReportEvents["ENABLE_CSV"] = 50] = "ENABLE_CSV";
        CardViewReportEvents[CardViewReportEvents["DISABLE_CSV"] = 60] = "DISABLE_CSV";
        CardViewReportEvents[CardViewReportEvents["SHOW_ROTATION_MESSAGE"] = 70] = "SHOW_ROTATION_MESSAGE";
        CardViewReportEvents[CardViewReportEvents["HIDE_ROTATION_MESSAGE"] = 80] = "HIDE_ROTATION_MESSAGE";
        CardViewReportEvents[CardViewReportEvents["ENABLE_ANALYSIS_PARAMETER"] = 90] = "ENABLE_ANALYSIS_PARAMETER";
        CardViewReportEvents[CardViewReportEvents["DISABLE_ANALYSIS_PARAMETER"] = 100] = "DISABLE_ANALYSIS_PARAMETER";
        CardViewReportEvents[CardViewReportEvents["TEMP_MANAGEMENT_OVERVIEW_MOBILE"] = 110] = "TEMP_MANAGEMENT_OVERVIEW_MOBILE";
        CardViewReportEvents[CardViewReportEvents["ENABLE_BREADCRUMB"] = 120] = "ENABLE_BREADCRUMB";
        CardViewReportEvents[CardViewReportEvents["DISABLE_BREADCRUMB"] = 130] = "DISABLE_BREADCRUMB";
        CardViewReportEvents[CardViewReportEvents["ENABLE_AXIS_PARAMETER"] = 140] = "ENABLE_AXIS_PARAMETER";
        CardViewReportEvents[CardViewReportEvents["DISABLE_AXIS_PARAMETER"] = 150] = "DISABLE_AXIS_PARAMETER";
        CardViewReportEvents[CardViewReportEvents["DISABLE_XAXIS_CLIENT_NET_SALES"] = 160] = "DISABLE_XAXIS_CLIENT_NET_SALES";
        CardViewReportEvents[CardViewReportEvents["DISABLE_XAXIS_CLIENT_SALES"] = 170] = "DISABLE_XAXIS_CLIENT_SALES";
        CardViewReportEvents[CardViewReportEvents["DISABLE_XAXIS_GLOBAL_NET_SALES"] = 180] = "DISABLE_XAXIS_GLOBAL_NET_SALES";
        CardViewReportEvents[CardViewReportEvents["DISABLE_XAXIS_GLOBAL_SALES"] = 190] = "DISABLE_XAXIS_GLOBAL_SALES";
        CardViewReportEvents[CardViewReportEvents["DISABLE_XAXIS_SALES_MARKET_SHARE"] = 200] = "DISABLE_XAXIS_SALES_MARKET_SHARE";
        CardViewReportEvents[CardViewReportEvents["DISABLE_XAXIS_AUM_MARKET_SHARE"] = 205] = "DISABLE_XAXIS_AUM_MARKET_SHARE";
        CardViewReportEvents[CardViewReportEvents["DISABLE_YAXIS_CLIENT_NET_SALES"] = 210] = "DISABLE_YAXIS_CLIENT_NET_SALES";
        CardViewReportEvents[CardViewReportEvents["DISABLE_YAXIS_CLIENT_SALES"] = 220] = "DISABLE_YAXIS_CLIENT_SALES";
        CardViewReportEvents[CardViewReportEvents["DISABLE_YAXIS_GLOBAL_NET_SALES"] = 230] = "DISABLE_YAXIS_GLOBAL_NET_SALES";
        CardViewReportEvents[CardViewReportEvents["DISABLE_YAXIS_GLOBAL_SALES"] = 240] = "DISABLE_YAXIS_GLOBAL_SALES";
        CardViewReportEvents[CardViewReportEvents["DISABLE_YAXIS_SALES_MARKET_SHARE"] = 250] = "DISABLE_YAXIS_SALES_MARKET_SHARE";
        CardViewReportEvents[CardViewReportEvents["DISABLE_YAXIS_AUM_MARKET_SHARE"] = 255] = "DISABLE_YAXIS_AUM_MARKET_SHARE";
        CardViewReportEvents[CardViewReportEvents["DISABLE_XAXIS_CLIENT_AUM"] = 260] = "DISABLE_XAXIS_CLIENT_AUM";
        CardViewReportEvents[CardViewReportEvents["DISABLE_XAXIS_INDUSTRY_AUM"] = 270] = "DISABLE_XAXIS_INDUSTRY_AUM";
        CardViewReportEvents[CardViewReportEvents["DISABLE_XAXIS_SALES_GREEN_SPACE"] = 280] = "DISABLE_XAXIS_SALES_GREEN_SPACE";
        CardViewReportEvents[CardViewReportEvents["DISABLE_XAXIS_AUM_GREEN_SPACE"] = 290] = "DISABLE_XAXIS_AUM_GREEN_SPACE";
        CardViewReportEvents[CardViewReportEvents["DISABLE_YAXIS_CLIENT_AUM"] = 300] = "DISABLE_YAXIS_CLIENT_AUM";
        CardViewReportEvents[CardViewReportEvents["DISABLE_YAXIS_INDUSTRY_AUM"] = 310] = "DISABLE_YAXIS_INDUSTRY_AUM";
        CardViewReportEvents[CardViewReportEvents["DISABLE_YAXIS_SALES_GREEN_SPACE"] = 320] = "DISABLE_YAXIS_SALES_GREEN_SPACE";
        CardViewReportEvents[CardViewReportEvents["DISABLE_YAXIS_AUM_GREEN_SPACE"] = 330] = "DISABLE_YAXIS_AUM_GREEN_SPACE";
        CardViewReportEvents[CardViewReportEvents["HIDE_TOP_CONTROLS"] = 340] = "HIDE_TOP_CONTROLS";
        CardViewReportEvents[CardViewReportEvents["SHOW_TOP_CONTROLS"] = 350] = "SHOW_TOP_CONTROLS";
        CardViewReportEvents[CardViewReportEvents["CHANGE_VIEWBY_TO_ASSET_CLASS"] = 360] = "CHANGE_VIEWBY_TO_ASSET_CLASS";
        CardViewReportEvents[CardViewReportEvents["CHANGE_VIEWBY_TO_CATEGORYS"] = 361] = "CHANGE_VIEWBY_TO_CATEGORYS";
        CardViewReportEvents[CardViewReportEvents["CHANGE_VIEWBY_TO_CHANNEL"] = 362] = "CHANGE_VIEWBY_TO_CHANNEL";
        CardViewReportEvents[CardViewReportEvents["CHANGE_VIEWBY_TO_DIVISION"] = 363] = "CHANGE_VIEWBY_TO_DIVISION";
        CardViewReportEvents[CardViewReportEvents["CHANGE_VIEWBY_TO_FIRM"] = 364] = "CHANGE_VIEWBY_TO_FIRM";
        CardViewReportEvents[CardViewReportEvents["CHANGE_VIEWBY_TO_TERRITORY"] = 365] = "CHANGE_VIEWBY_TO_TERRITORY";
        CardViewReportEvents[CardViewReportEvents["CHANGE_VIEWBY_TO_OFFICE"] = 366] = "CHANGE_VIEWBY_TO_OFFICE";
    })(CardView.CardViewReportEvents || (CardView.CardViewReportEvents = {}));
    var CardViewReportEvents = CardView.CardViewReportEvents;
    var CardViewReport = (function () {
        function CardViewReport(wrapper) {
            this.wrapper = wrapper;
            this.resizeHandlers = new ListenersCollection();
        }
        CardViewReport.prototype.applyCategoricalFilter = function (filterName, columnName, filterOptions) {
            var options = Array.isArray(filterOptions) ? filterOptions.filter(function (option) { return option.selected; }).map(function (option) { return option.label; }) : null;
            return this.applyFilter(filterName, columnName, options);
        };
        CardViewReport.prototype.onResize = function (handler) {
            this.resizeHandlers.addEventListener(handler);
        };
        CardViewReport.prototype.getIframe = function () {
            return this.getWrapper().find('iframe');
        };
        CardViewReport.prototype.getElements = function () {
            var iframe = this.getIframe();
            var elements = jQuery('').add(iframe).add(iframe.parent());
            return elements;
        };
        CardViewReport.prototype.getScrollbarWidth = function () {
            return (this.envProperties.getEnvironmentType() === CardView.EnvironmentEnum.PC) ? CardViewReport.DESKTOP_SCROLLBAR_WIDTH : CardViewReport.NON_DESKTOP_SCROLLBAR_WIDTH;
        };
        CardViewReport.prototype.getWrapper = function () {
            return this.wrapper;
        };
        CardViewReport.prototype.getHeight = function () {
            return CardView.Utils.getReportHeight();
        };
        CardViewReport.prototype.getWidth = function () {
            // This will prevent the report to get displayed behind the scrollbar
            return $(window).width() - this.getScrollbarWidth();
        };
        CardViewReport.prototype.updateReportSize = function () {
            var elements = this.getElements();
            // Clear previous elements
            elements.css({
                'min-height': '250px',
                'height': '0px',
                'width': '90%'
            });
            var height = this.getHeight();
            var width = this.getWidth();
            // assigning viewport height to avoid page scroll
            if (window.cardData.templateTitle === "QueryBuilder") {
                var viewport_height = this.getViewportHeight();
                elements.css({
                    'min-height': '250px',
                    'height': viewport_height + 'px',
                    'width': width + 'px',
                    'overflow': 'unset'
                });
            }
            else {
                elements.css({
                    'min-height': '250px',
                    'height': height + 'px',
                    'width': width + 'px'
                });
            }
            this.resizeHandlers.execute(window, []);
        };
        CardViewReport.prototype.setEnvironmentProperties = function (env) {
            this.envProperties = env;
        };
        // to get viewport height
        CardViewReport.prototype.getViewportHeight = function () {
            var height = $(window).outerHeight() -
                $('#header').outerHeight() -
                $('#footer').outerHeight() -
                $(".sheet-crumb-wrapper").outerHeight();
            return height;
        };
        CardViewReport.DESKTOP_SCROLLBAR_WIDTH = 17;
        CardViewReport.NON_DESKTOP_SCROLLBAR_WIDTH = 3;
        return CardViewReport;
    }());
    CardView.CardViewReport = CardViewReport;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var CRPReport = (function (_super) {
        __extends(CRPReport, _super);
        function CRPReport(wrapper, reportUrl, templateTitle, properties) {
            _super.call(this, wrapper);
            this.reportHeight = 0;
            this.templateTitle = templateTitle;
            this.internalReport = new walletShareReports.Viz(wrapper.get(0), reportUrl, { 'height': '100%', 'width': wrapper.width() }, {
                categoricalFilters: this.generateFilterArgs(properties),
                parameters: this.generateParameterArgs(properties),
                salesCategoricalFilter: this.generateSalesFilterArgs(properties)
            });
            this.changeHandlers = new ListenersCollection();
            this.errorHandlers = new ListenersCollection();
            this.addEventListeners();
        }
        CRPReport.prototype.analytics = function (handler) {
            this.internalReport.analytics(handler);
        };
        CRPReport.prototype.reset = function () {
            var deferred = jQuery.Deferred();
            deferred.resolve();
            return deferred.promise();
        };
        CRPReport.prototype.pauseUpdates = function () {
            var deferred = jQuery.Deferred();
            this.internalReport.pauseAutomaticUpdatesAsync()
                .then(function () {
                deferred.resolve();
            })
                .otherwise(function () {
                deferred.reject();
            });
            return deferred.promise();
        };
        CRPReport.prototype.resumeUpdates = function () {
            var deferred = jQuery.Deferred();
            this.internalReport.resumeAutomaticUpdatesAsync()
                .then(function () {
                deferred.resolve();
            })
                .otherwise(function () {
                deferred.reject();
            });
            return deferred.promise();
        };
        CRPReport.prototype.deleteView = function (customViewName) {
            var deferred = jQuery.Deferred();
            this.internalReport.removeCustomViewAsync(customViewName)
                .then(function () {
                deferred.resolve();
            })
                .otherwise(function () {
                deferred.reject();
            });
            return deferred.promise();
        };
        CRPReport.prototype.saveView = function (customViewName) {
            var deferred = jQuery.Deferred();
            this.internalReport.createCustomViewAsync(function () { return customViewName; })
                .then(function (customView) {
                deferred.resolveWith(window, [customView.getName()]);
            })
                .otherwise(function () {
                deferred.reject();
            });
            return deferred.promise();
        };
        CRPReport.prototype.applyParameter = function (parameterName, parameterValue) {
            var deferred = jQuery.Deferred();
            this.internalReport.changeParameterValueAsync(parameterName, parameterValue)
                .then(function () {
                deferred.resolve();
            })
                .otherwise(function () {
                deferred.reject();
            });
            return deferred.promise();
        };
        CRPReport.prototype.onChange = function (handler) {
            this.changeHandlers.addEventListener(handler);
        };
        CRPReport.prototype.onError = function (handler) {
            this.errorHandlers.addEventListener(handler);
        };
        CRPReport.prototype.applyFilter = function (filterName, columnName, filterOptions) {
            var deferred = jQuery.Deferred();
            this.internalReport.applyFilterAsync(filterName, filterOptions)
                .then(function () {
                deferred.resolve();
            })
                .otherwise(function (a) {
                deferred.reject();
            });
            return deferred.promise();
        };
        CRPReport.prototype.applySalesFilter = function (filterName, min, max) {
            var deferred = jQuery.Deferred();
            this.internalReport.applySalesFilterAsync(filterName, min, max)
                .then(function () {
                deferred.resolve();
            })
                .otherwise(function (a) {
                deferred.reject();
            });
            return deferred.promise();
        };
        CRPReport.prototype.exports = function (type) {
            switch (type) {
                case CardView.ExportType.CSV:
                    return this.internalReport.exportCSV instanceof Function;
                case undefined:
                    return true;
            }
            return false;
        };
        CRPReport.prototype.exportSheet = function (type, cardTitle) {
            var deferred = jQuery.Deferred();
            switch (type) {
                case CardView.ExportType.CSV:
                    this.internalReport.exportCSV(cardTitle);
                    break;
            }
            deferred.resolve();
            return deferred.promise();
        };
        CRPReport.prototype.getName = function () {
            return this.templateTitle;
        };
        CRPReport.prototype.ready = function (handler) {
            var _this = this;
            this.internalReport.ready(function () {
                handler.call(_this);
            });
        };
        CRPReport.prototype.onLoadError = function (handler) {
        };
        CRPReport.prototype.sheetExists = function (sheetName) {
            return this.internalReport.getPublishedSheetsInfo().some(function (sheet) { return sheet.getName() === sheetName; });
        };
        CRPReport.prototype.activateSheet = function (sheetName) {
            var deferred = jQuery.Deferred();
            this.internalReport.activateSheetAsync(sheetName)
                .then(function () {
                deferred.resolve();
            })
                .otherwise(function () {
                deferred.reject();
            });
            return deferred.promise();
        };
        CRPReport.prototype.activateBreadcrumbSheet = function (sheetName) {
            var deferred = jQuery.Deferred();
            var sheetName = (sheetName === CRPReport.OFFICE) ? CRPReport.OFFICE_DEEP_DIVE : sheetName;
            this.internalReport.activateBreadcrumbSheetAsync(sheetName)
                .then(function () {
                deferred.resolve();
            })
                .otherwise(function () {
                deferred.reject();
            });
            return deferred.promise();
        };
        CRPReport.prototype.getActiveSheetName = function () {
            var activeSheet = this.internalReport.getActiveSheet();
            return activeSheet != null ? activeSheet.getName() : null;
        };
        CRPReport.prototype.onTabSwitched = function (handler) {
            var _this = this;
            this.internalReport.addEventListener(walletShareReports.EventName.TAB_SWITCH, function (e) {
                handler.call(_this, new CardView.CardViewTabSwitchEvent(e.getNewSheetName(), e.getOldSheetName()));
            });
        };
        CRPReport.prototype.generateFilterArgs = function (properties) {
            var filters = [];
            properties.getFilters()
                .forEach(function (filter) {
                if (!filter.hasApplyOrder()) {
                    return;
                }
                var options = filter.getInitialOptions();
                if (options === null) {
                    return;
                }
                var labels = options.map(function (option) { return option.formattedValue; });
                filters.push({
                    name: filter.getName(),
                    options: labels
                });
            });
            return filters;
        };
        CRPReport.prototype.generateSalesFilterArgs = function (properties) {
            var filters = [];
            var filteredSalesFilter = properties.getSalesFilters().filter(function (salesFilter) {
                return salesFilter.getInitialApplied();
            });
            if (filteredSalesFilter.isEmpty()) {
                return filters;
            }
            filteredSalesFilter.forEach(function (salesFilter) {
                var config = CardView.CategoricalFilter.configInstance.getConfig(salesFilter.getName());
                var salesType = config.salesType;
                var min = salesFilter.getOptions().min;
                var max = salesFilter.getOptions().max;
                if (salesType !== CardView.SalesCategoricalFilterFormatter.NEGATIVE_TYPE &&
                    max !== null &&
                    Number(min) <= 0 &&
                    Number(max) <= 0) {
                    max = CardView.SalesCategoricalFilterFormatter.NEGATIVE_MASK;
                }
                filters.push({
                    name: salesFilter.getName(),
                    min: min,
                    max: max
                });
            });
            return filters;
        };
        CRPReport.prototype.generateParameterArgs = function (properties) {
            var parameters = new Array();
            // Appending saved parameters to pass to report
            properties.getParameters().forEach(function (parameter) {
                parameters.push({
                    name: parameter.getName(),
                    currentValue: parameter.getInitialValue()
                });
            });
            // Appending products permission to pass to report
            parameters.push({
                name: PermissionManager.ProductsPermissionManager.PERMISSION_PARAMETER,
                currentValue: properties.getProductsPermission()
            });
            parameters.push({
                name: PermissionManager.ProductsPermissionManager.TEMPLATE_PERMISSION_PARAMETER,
                currentValue: properties.getTemplatePermissions()
            });
            // Appending Browser Options to pass to report
            var browserOptions = this.generateBrowserOptions();
            Object.keys(browserOptions).forEach(function (browserOption) {
                parameters.push({
                    name: browserOption,
                    currentValue: browserOptions[browserOption]
                });
            });
            return parameters;
        };
        CRPReport.prototype.generateBrowserOptions = function () {
            var browserOptions = {};
            browserOptions[BrowserDetector.BrowserDetectorManager.MOBILE_DEVICE_PARAMETER] = EnvironmentUtilities.BrowserDetector.isMobile();
            browserOptions[BrowserDetector.BrowserDetectorManager.MOBILE_DEVICE_LANDSCAPE_PARAMETER] = EnvironmentUtilities.BrowserDetector.isMobileLandscape();
            browserOptions[BrowserDetector.BrowserDetectorManager.MOBILE_DEVICE_PORTRAIT_PARAMETER] = EnvironmentUtilities.BrowserDetector.isMobilePortrait();
            browserOptions[BrowserDetector.BrowserDetectorManager.TABLET_DEVICE_PARAMETER] = EnvironmentUtilities.BrowserDetector.isTablet();
            browserOptions[BrowserDetector.BrowserDetectorManager.TABLET_PORTRAIT_DEVICE_PARAMETER] = EnvironmentUtilities.BrowserDetector.isTabletPortrait();
            browserOptions[BrowserDetector.BrowserDetectorManager.TABLET_LANDSCAPE_DEVICE_PARAMETER] = EnvironmentUtilities.BrowserDetector.isTabletLandscape();
            browserOptions[BrowserDetector.BrowserDetectorManager.DESKTOP_DEVICE_PARAMETER] = EnvironmentUtilities.BrowserDetector.isDesktop();
            return browserOptions;
        };
        CRPReport.prototype.isReady = function () {
            return this.internalReport.isReady();
        };
        CRPReport.prototype.getActiveSheetMaxHeight = function () {
            return this.internalReport.getActiveSheet().getSize().maxSize.height;
        };
        CRPReport.prototype.addEventListeners = function () {
            var _this = this;
            this.internalReport.onResize(function (width, height) {
                _this.reportHeight = height;
                _this.updateReportSize();
            });
            this.internalReport.onChange(function (e) {
                var value = null;
                switch (e.changes()) {
                    case WalletShareReports.ReportChangesEnum.IGNORING_FILTERS:
                        value = CardView.CardViewReportEvents.IGNORING_FILTERS;
                        break;
                    case WalletShareReports.ReportChangesEnum.USING_FILTERS:
                        value = CardView.CardViewReportEvents.USING_FILTERS;
                        break;
                    case WalletShareReports.ReportChangesEnum.REPORT_REPLACED:
                        value = CardView.CardViewReportEvents.REPORT_REPLACED;
                        break;
                    case WalletShareReports.ReportChangesEnum.ENABLE_CSV:
                        value = CardView.CardViewReportEvents.ENABLE_CSV;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_CSV:
                        value = CardView.CardViewReportEvents.DISABLE_CSV;
                        break;
                    case WalletShareReports.ReportChangesEnum.SHOW_ROTATION_BUILDER_MESSAGE:
                        value = CardView.CardViewReportEvents.SHOW_ROTATION_MESSAGE;
                        break;
                    case WalletShareReports.ReportChangesEnum.HIDE_ROTATION_BUILDER_MESSAGE:
                        value = CardView.CardViewReportEvents.HIDE_ROTATION_MESSAGE;
                        break;
                    case WalletShareReports.ReportChangesEnum.ENABLE_ANALYSIS_PARAMETER:
                        value = CardView.CardViewReportEvents.ENABLE_ANALYSIS_PARAMETER;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_ANALYSIS_PARAMETER:
                        value = CardView.CardViewReportEvents.DISABLE_ANALYSIS_PARAMETER;
                        break;
                    case WalletShareReports.ReportChangesEnum.ENABLE_AXIS_PARAMETER:
                        value = CardView.CardViewReportEvents.ENABLE_AXIS_PARAMETER;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_AXIS_PARAMETER:
                        value = CardView.CardViewReportEvents.DISABLE_AXIS_PARAMETER;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_XAXIS_CLIENT_NET_SALES:
                        value = CardView.CardViewReportEvents.DISABLE_XAXIS_CLIENT_NET_SALES;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_XAXIS_CLIENT_SALES:
                        value = CardView.CardViewReportEvents.DISABLE_XAXIS_CLIENT_SALES;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_XAXIS_GLOBAL_NET_SALES:
                        value = CardView.CardViewReportEvents.DISABLE_XAXIS_GLOBAL_NET_SALES;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_XAXIS_GLOBAL_SALES:
                        value = CardView.CardViewReportEvents.DISABLE_XAXIS_GLOBAL_SALES;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_XAXIS_SALES_MARKET_SHARE:
                        value = CardView.CardViewReportEvents.DISABLE_XAXIS_SALES_MARKET_SHARE;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_XAXIS_AUM_MARKET_SHARE:
                        value = CardView.CardViewReportEvents.DISABLE_XAXIS_AUM_MARKET_SHARE;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_YAXIS_CLIENT_NET_SALES:
                        value = CardView.CardViewReportEvents.DISABLE_YAXIS_CLIENT_NET_SALES;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_YAXIS_CLIENT_SALES:
                        value = CardView.CardViewReportEvents.DISABLE_YAXIS_CLIENT_SALES;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_YAXIS_GLOBAL_NET_SALES:
                        value = CardView.CardViewReportEvents.DISABLE_YAXIS_GLOBAL_NET_SALES;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_YAXIS_GLOBAL_SALES:
                        value = CardView.CardViewReportEvents.DISABLE_YAXIS_GLOBAL_SALES;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_YAXIS_SALES_MARKET_SHARE:
                        value = CardView.CardViewReportEvents.DISABLE_YAXIS_SALES_MARKET_SHARE;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_YAXIS_AUM_MARKET_SHARE:
                        value = CardView.CardViewReportEvents.DISABLE_YAXIS_AUM_MARKET_SHARE;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_XAXIS_CLIENT_AUM:
                        value = CardView.CardViewReportEvents.DISABLE_XAXIS_CLIENT_AUM;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_XAXIS_INDUSTRY_AUM:
                        value = CardView.CardViewReportEvents.DISABLE_XAXIS_INDUSTRY_AUM;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_XAXIS_SALES_GREEN_SPACE:
                        value = CardView.CardViewReportEvents.DISABLE_XAXIS_SALES_GREEN_SPACE;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_XAXIS_AUM_GREEN_SPACE:
                        value = CardView.CardViewReportEvents.DISABLE_XAXIS_AUM_GREEN_SPACE;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_YAXIS_CLIENT_AUM:
                        value = CardView.CardViewReportEvents.DISABLE_YAXIS_CLIENT_AUM;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_YAXIS_INDUSTRY_AUM:
                        value = CardView.CardViewReportEvents.DISABLE_YAXIS_INDUSTRY_AUM;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_YAXIS_SALES_GREEN_SPACE:
                        value = CardView.CardViewReportEvents.DISABLE_YAXIS_SALES_GREEN_SPACE;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_YAXIS_AUM_GREEN_SPACE:
                        value = CardView.CardViewReportEvents.DISABLE_YAXIS_AUM_GREEN_SPACE;
                        break;
                    case WalletShareReports.ReportChangesEnum.TEMP_MANAGEMENT_OVERVIEW_MOBILE:
                        value = CardView.CardViewReportEvents.TEMP_MANAGEMENT_OVERVIEW_MOBILE;
                        break;
                    case WalletShareReports.ReportChangesEnum.ENABLE_BREADCRUMB:
                        value = CardView.CardViewReportEvents.ENABLE_BREADCRUMB;
                        break;
                    case WalletShareReports.ReportChangesEnum.DISABLE_BREADCRUMB:
                        value = CardView.CardViewReportEvents.DISABLE_BREADCRUMB;
                        break;
                    case WalletShareReports.ReportChangesEnum.HIDE_TOP_CONTROLS:
                        value = CardView.CardViewReportEvents.HIDE_TOP_CONTROLS;
                        break;
                    case WalletShareReports.ReportChangesEnum.SHOW_TOP_CONTROLS:
                        value = CardView.CardViewReportEvents.SHOW_TOP_CONTROLS;
                        break;
                    case WalletShareReports.ReportChangesEnum.CHANGE_VIEWBY_TO_ASSET_CLASS:
                        value = CardView.CardViewReportEvents.CHANGE_VIEWBY_TO_ASSET_CLASS;
                        break;
                    case WalletShareReports.ReportChangesEnum.CHANGE_VIEWBY_TO_CATEGORYS:
                        value = CardView.CardViewReportEvents.CHANGE_VIEWBY_TO_CATEGORYS;
                        break;
                    case WalletShareReports.ReportChangesEnum.CHANGE_VIEWBY_TO_CHANNEL:
                        value = CardView.CardViewReportEvents.CHANGE_VIEWBY_TO_CHANNEL;
                        break;
                    case WalletShareReports.ReportChangesEnum.CHANGE_VIEWBY_TO_DIVISION:
                        value = CardView.CardViewReportEvents.CHANGE_VIEWBY_TO_DIVISION;
                        break;
                    case WalletShareReports.ReportChangesEnum.CHANGE_VIEWBY_TO_FIRM:
                        value = CardView.CardViewReportEvents.CHANGE_VIEWBY_TO_FIRM;
                        break;
                    case WalletShareReports.ReportChangesEnum.CHANGE_VIEWBY_TO_TERRITORY:
                        value = CardView.CardViewReportEvents.CHANGE_VIEWBY_TO_TERRITORY;
                        break;
                    case WalletShareReports.ReportChangesEnum.CHANGE_VIEWBY_TO_OFFICE:
                        value = CardView.CardViewReportEvents.CHANGE_VIEWBY_TO_OFFICE;
                        break;
                    default:
                        value = CardView.CardViewReportEvents.REPORT_CHANGES;
                }
                _this.changeHandlers.execute(window, [value]);
            });
            this.internalReport.onError(function () {
                _this.errorHandlers.execute(window, []);
            });
            this.ready(function () {
                _this.updateReportSize();
            });
        };
        CRPReport.prototype.getHeight = function () {
            if (this.isReady()) {
                return this.reportHeight || this.getActiveSheetMaxHeight();
            }
            return _super.prototype.getHeight.call(this);
        };
        CRPReport.prototype.setHeight = function (height) {
            this.internalReport.setHeight(height);
        };
        CRPReport.prototype.setWidth = function (width) {
            this.internalReport.setWidth(width);
        };
        CRPReport.prototype.getParameters = function () {
            var _this = this;
            var deferred = jQuery.Deferred();
            this.internalReport.ready(function () {
                var promise = _this.internalReport.getParametersAsync();
                promise.then(function (parameters) {
                    var info = new Array();
                    parameters.forEach(function (parameter) {
                        var minValue = (parameter.getMinValue() !== null) ? parameter.getMinValue().value : null;
                        var maxValue = (parameter.getMaxValue() !== null) ? parameter.getMaxValue().value : null;
                        info.push({
                            parameterId: null,
                            name: parameter.getName(),
                            currentValue: parameter.getCurrentValue().value,
                            dataType: parameter.getDataType(),
                            allowableValuesType: parameter.getAllowableValuesType(),
                            allowableValues: parameter.getAllowableValues(),
                            minValue: minValue,
                            maxValue: maxValue,
                            stepSize: parameter.getStepSize(),
                            dateStepPeriod: parameter.getDateStepPeriod()
                        });
                    });
                    deferred.resolveWith(window, [info]);
                })
                    .otherwise(function () {
                    deferred.rejectWith(window, null);
                });
            });
            return deferred.promise();
        };
        CRPReport.OFFICE_DEEP_DIVE = 'OfficeDeepDive';
        CRPReport.OFFICE = 'Office';
        return CRPReport;
    }(CardView.CardViewReport));
    CardView.CRPReport = CRPReport;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var ReportView = (function () {
        function ReportView(options) {
            this.info = options.info;
            this.customized = false;
            this.background = options.background;
            this.wrapper = options.wrapper;
            this.controls = options.wrapper.find('.top-controls');
            this.topControls = options.wrapper.children('.top-controls');
            this.controlsSpinner = this.topControls.find('.top-controls-spinner');
            this.axisStatus = new Array();
            this.clickInterceptor = jQuery('<div/>', { 'class': 'interceptor' });
            this.loadingScreen = jQuery('<div/>', { 'class': 'interceptor loading-screen', 'id': 'loading-screen' }).append(jQuery('<span/>'));
            var strings = this.info.getStrings();
            this.genericErrorMessage = this.createMessageElement('error-notice', strings.getGenericErrorNoticeTitle(), strings.getGenericErrorNoticeSubtitle());
            this.emptyResultsMessage = this.createMessageElement('no-results-notice', strings.getNoResultsTitle(), strings.getNoResultsSubtitle());
            this.errorTempMessageManagementOverview = this.createMessageElement('error-notice', strings.getManagementOverviewMobileError(), null);
        }
        ReportView.prototype.setCustomized = function (state) {
            this.customized = state;
        };
        ReportView.prototype.isCustomized = function () {
            return this.customized;
        };
        ReportView.prototype.onResize = function (handler) {
            this.report.onResize(handler);
        };
        ReportView.prototype.internalHeight = function () {
            return this.getReport().getIframe().outerHeight() + this.topControls.height();
        };
        ReportView.prototype.clearHeight = function () {
            this.setIframeWrapperHeight(null);
            this.setExternalHeight(null);
        };
        ReportView.prototype.setIframeWrapperHeight = function (height) {
            this.getReport().getIframe().parent().height(height === null ? '' : height);
        };
        ReportView.prototype.setIframeHeight = function (height) {
            this.getReport().setHeight(height === null ? '' : height);
        };
        ReportView.prototype.setExternalHeight = function (height) {
            this.wrapper.height(height === null ? '' : height);
        };
        ReportView.prototype.markAsLoading = function (isLoading) {
            if (isLoading) {
                this.controlsSpinner.removeClass(ReportView.HIDDEN_CSS_CLASS);
            }
            else {
                this.controlsSpinner.addClass(ReportView.HIDDEN_CSS_CLASS);
            }
        };
        ReportView.prototype.feed = function (filters) {
            var _this = this;
            this.topControls.addClass(ReportView.ENABLED_CSSCLASS);
            if (filters === null) {
                this.markAsLoading(true);
            }
            else {
                this.filters = filters;
                this.appendFilters();
                this.markAsLoading(false);
                this.axisStatus.forEach(function (current) {
                    if (current.ready) {
                        _this.setDisableAxis(current);
                    }
                });
            }
        };
        ReportView.prototype.appendFilters = function () {
            var filterElements = this.filters.map(function (filter) { return filter.render(null); });
            var env = this.info.getEnvironmentProperties().getEnvironmentType();
            switch (env) {
                case CardView.EnvironmentEnum.MOBILE:
                    var mobileTopControls = this.topControls.eq(0);
                    mobileTopControls.append(filterElements);
                    break;
                default:
                    var desktopTopControls = this.topControls.eq(1);
                    desktopTopControls.append(filterElements);
                    break;
            }
        };
        ReportView.prototype.createMessageElement = function (cssClass, title, subtitle) {
            var env = this.info.getEnvironmentProperties().getEnvironmentType();
            var titleElementTag = (env === CardView.EnvironmentEnum.MOBILE) ? '<h6/>' : '<h1/>';
            return jQuery('<div/>', { 'class': ['interceptor', 'open-sans', cssClass].join(' ') })
                .append(jQuery(titleElementTag, { 'class': 'text-center opaque-65', 'text': title }), jQuery(titleElementTag, { 'class': 'text-center opaque-65', 'text': subtitle }));
        };
        ReportView.prototype.generateReportUrl = function () {
            var urlComponents = new Array();
            var cardMetadata = this.info.getCardMetadata();
            var reportMetadata = cardMetadata.getReportMetadata();
            var envType = this.info.getEnvironmentProperties().getEnvironmentType();
            urlComponents.push(reportMetadata.getReportBaseUrl(), reportMetadata.getSheetByEnvironment(envType).getChartSheetName());
            if (!cardMetadata.isTemplate() && reportMetadata.hasCustomView()) {
                urlComponents.push(reportMetadata.getCustomView());
            }
            return urlComponents.join(ReportView.SLASH);
        };
        ReportView.prototype.initialize = function () {
            // Load report
            var reportMetadata = this.info.getCardMetadata().getReportMetadata();
            var reportUrl = this.generateReportUrl();
            this.report = new CardView.CRPReport(this.wrapper, reportUrl, this.info.getCardMetadata().getTemplateTitle(), this.info.getProperties());
            this.showLoadingScreen();
            this.report.setEnvironmentProperties(this.info.getEnvironmentProperties());
            this.report.updateReportSize();
            this.addEventListeners();
        };
        ReportView.prototype.onChange = function (handler) {
            this.report.onChange(handler);
        };
        ReportView.prototype.getReport = function () {
            return this.report;
        };
        ReportView.prototype.setBackground = function (color) {
            this.background.css('background', '#' + color);
        };
        ReportView.prototype.addEventListeners = function () {
            var _this = this;
            $(window).on('resize', function () {
                _this.report.updateReportSize();
            });
            $(window).on('orientationchange', function () {
                var previousTimeoutId = null;
                clearTimeout(previousTimeoutId);
                previousTimeoutId = setTimeout(function () {
                    _this.report.getIframe().attr('scrolling', 'no');
                    _this.report.updateReportSize();
                    _this.report.getIframe().removeAttr('scrolling');
                }, 100);
            });
            this.report.ready(function () {
                _this.hideLoadingScreen();
            });
            this.onChange(function () {
                _this.customized = true;
            });
        };
        ReportView.prototype.attachElement = function (element) {
            this.report.getIframe().before(element);
        };
        ReportView.prototype.activateSheet = function (sheetName) {
            this.report.activateSheet(sheetName);
        };
        ReportView.prototype.dettachElement = function (element) {
            element.remove();
        };
        ReportView.prototype.showLoadingScreen = function () {
            this.attachElement(this.loadingScreen);
            this.setBackground('ffffff');
        };
        ReportView.prototype.hideLoadingScreen = function () {
            this.dettachElement(this.loadingScreen);
            this.setBackground(this.info.getCardMetadata().getBackgroundColor());
        };
        ReportView.prototype.showInterceptor = function () {
            this.attachElement(this.clickInterceptor);
        };
        ReportView.prototype.hideInterceptor = function () {
            this.dettachElement(this.clickInterceptor);
        };
        ReportView.prototype.showErrorMessage = function () {
            this.attachElement(this.genericErrorMessage);
        };
        ReportView.prototype.showErrorTempManagementReport = function () {
            this.attachElement(this.errorTempMessageManagementOverview);
        };
        ReportView.prototype.hideEmptyResultsMessage = function () {
            this.dettachElement(this.emptyResultsMessage);
        };
        ReportView.prototype.showEmptyResultsMessage = function () {
            this.attachElement(this.emptyResultsMessage);
        };
        ReportView.prototype.enableAnalysisParameter = function () {
            var analysis = this.controls.find('#ws-parameter-filter-analysis');
            var select = analysis.find('select');
            select.removeAttr(ReportView.DISABLED_PROP);
            select.removeClass(ReportView.KEEP_DISABLED_CLASS);
        };
        ReportView.prototype.disableAnalysisParameter = function () {
            var analysis = this.controls.find('#ws-parameter-filter-analysis');
            var select = analysis.find('select');
            select.attr(ReportView.DISABLED_PROP, ReportView.DISABLED_PROP);
            select.addClass(ReportView.KEEP_DISABLED_CLASS);
        };
        ReportView.prototype.hideTopControls = function () {
            this.topControls.attr(ReportView.HIDDEN_CSS_CLASS);
            this.topControls.addClass(ReportView.HIDDEN_CSS_CLASS);
        };
        ReportView.prototype.showTopControls = function () {
            this.topControls.removeAttr(ReportView.HIDDEN_CSS_CLASS);
            this.topControls.removeClass(ReportView.HIDDEN_CSS_CLASS);
        };
        ReportView.prototype.hideAxisParameter = function () {
            var xAxis = this.controls.find('#ws-parameter-filter-x-axis');
            var yAxis = this.controls.find('#ws-parameter-filter-y-axis');
            xAxis.attr(ReportView.HIDDEN_CSS_CLASS);
            xAxis.addClass(ReportView.HIDDEN_CSS_CLASS);
            yAxis.attr(ReportView.HIDDEN_CSS_CLASS);
            yAxis.addClass(ReportView.HIDDEN_CSS_CLASS);
        };
        ReportView.prototype.showAxisParameter = function () {
            var xAxis = this.controls.find('#ws-parameter-filter-x-axis');
            var yAxis = this.controls.find('#ws-parameter-filter-y-axis');
            xAxis.removeAttr(ReportView.HIDDEN_CSS_CLASS);
            xAxis.removeClass(ReportView.HIDDEN_CSS_CLASS);
            yAxis.removeAttr(ReportView.HIDDEN_CSS_CLASS);
            yAxis.removeClass(ReportView.HIDDEN_CSS_CLASS);
        };
        ReportView.prototype.changeViewByTo = function (dimensionName) {
            var viewBy = this.controls.find('#ws-parameter-filter-dimension').find('.form-control');
            viewBy.val(dimensionName).change();
        };
        ReportView.prototype.enableAxisParameter = function () {
            var xAxis = this.controls.find('#ws-parameter-filter-x-axis');
            var yAxis = this.controls.find('#ws-parameter-filter-y-axis');
            var xSelect = xAxis.find('select');
            var ySelect = yAxis.find('select');
            xSelect.removeAttr(ReportView.DISABLED_PROP);
            xSelect.removeClass(ReportView.KEEP_DISABLED_CLASS);
            ySelect.removeAttr(ReportView.DISABLED_PROP);
            ySelect.removeClass(ReportView.KEEP_DISABLED_CLASS);
        };
        ReportView.prototype.disableAxisParameter = function () {
            var xAxis = this.controls.find('#ws-parameter-filter-x-axis');
            var yAxis = this.controls.find('#ws-parameter-filter-y-axis');
            var xSelect = xAxis.find('select');
            var ySelect = yAxis.find('select');
            xSelect.attr(ReportView.DISABLED_PROP, ReportView.DISABLED_PROP);
            xSelect.addClass(ReportView.KEEP_DISABLED_CLASS);
            ySelect.attr(ReportView.DISABLED_PROP, ReportView.DISABLED_PROP);
            ySelect.addClass(ReportView.KEEP_DISABLED_CLASS);
        };
        ReportView.prototype.disableAxisOption = function (axisName, optionName) {
            var _this = this;
            if (!this.controlsSpinner.hasClass(ReportView.HIDDEN_CSS_CLASS)) {
                this.axisStatus.push({
                    ready: true,
                    axisParameterName: axisName,
                    optionName: optionName
                });
            }
            else {
                this.axisStatus.push({
                    ready: false,
                    axisParameterName: axisName,
                    optionName: optionName
                });
                this.axisStatus.forEach(function (current) {
                    _this.setDisableAxis(current);
                });
            }
        };
        ReportView.prototype.setDisableAxis = function (status) {
            var analysis = this.controls.find(status.axisParameterName);
            var select = analysis.find('select');
            var option = select.find('option');
            option.each(function () {
                var currentOption = $(this);
                if (this.text === status.optionName) {
                    currentOption.attr(ReportView.DISABLED_PROP, ReportView.DISABLED_PROP);
                    currentOption.addClass(ReportView.KEEP_DISABLED_CLASS);
                }
                else {
                    currentOption.removeAttr(ReportView.DISABLED_PROP);
                    currentOption.removeClass(ReportView.KEEP_DISABLED_CLASS);
                }
            });
        };
        ReportView.ENABLED_CSSCLASS = 'enabled';
        ReportView.HIDDEN_CSS_CLASS = 'hidden';
        ReportView.DISABLED_PROP = 'disabled';
        ReportView.KEEP_DISABLED_CLASS = 'keep-disabled';
        ReportView.SLASH = '/';
        return ReportView;
    }());
    CardView.ReportView = ReportView;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var BreadCrumb = (function () {
        function BreadCrumb(options) {
            this.info = options.info;
            this.wrapper = options.wrapper;
            this.list = this.wrapper.find('ol');
            this.handlers = [];
            this.lastSelectedCrumb = null;
            this.baseSheets = null;
            this.crumbs = null;
            this.disable();
        }
        BreadCrumb.prototype.height = function () {
            return this.wrapper.outerHeight();
        };
        BreadCrumb.prototype.getLastSelectedCrumb = function () {
            return this.lastSelectedCrumb;
        };
        BreadCrumb.prototype.click = function (handler) {
            this.handlers.push(handler);
        };
        BreadCrumb.prototype.triggerClick = function () {
            for (var i = 0; i < this.handlers.length; ++i) {
                var handler = this.handlers[i];
                handler(this.lastSelectedCrumb);
            }
        };
        BreadCrumb.prototype.generateTitle = function (crumb) {
            var parsedSheet = crumb
                .replace(/(-|[0-9])/g, ' ')
                .replace(/([a-z])([A-Z])/g, '$1 $2');
            // Bad words
            var singleWordsToExclude = BreadCrumb.BAD_WORDS;
            singleWordsToExclude.forEach(function (word) {
                parsedSheet = parsedSheet.removeIgnoringCase(word);
            });
            // Removing excess spaces
            parsedSheet = parsedSheet.replace(/\s{1,}/g, ' ').trim();
            // Normalizing uppercase
            return parsedSheet.trim()
                .replace(/\w\S*/g, function (word) { return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase(); });
        };
        BreadCrumb.prototype.renderElements = function () {
            var _this = this;
            return this.crumbs.map(function (crumb) {
                var listItem = jQuery('<li/>');
                var title = _this.generateTitle(crumb) || _this.generateTitle(_this.reportName) || crumb || _this.reportName;
                var crumb_value = crumb;
                switch (title) {
                    case BreadCrumb.OFFICE_DEEP_DIVE:
                        title = BreadCrumb.CRUMB_LIST[0];
                        break;
                    case BreadCrumb.TEAM_DEEP_DIVE:
                        title = BreadCrumb.CRUMB_LIST[1];
                        break;
                    case BreadCrumb.ADVISOR_DEEP_DIVE:
                        title = BreadCrumb.CRUMB_LIST[2];
                        break;
                    case BreadCrumb.ALTS_DEEP_DIVE:
                        title = BreadCrumb.CRUMB_LIST[6];
                        break;
                }
                if (BreadCrumb.DEEP_DIVE.contains(title) && _this.info.getCardMetadata().getTemplateTitle().toLowerCase().contains('deepdive')) {
                    title = title.toUpperCase();
                    crumb_value = crumb === BreadCrumb.CRUMB_LIST[0] ? BreadCrumb.CRUMB_LIST[3] : crumb;
                }
                if (crumb === _this.crumbs.last()) {
                    listItem.text(title);
                    listItem.addClass('active');
                }
                else {
                    var button = jQuery('<a/>', { 'text': title });
                    button.attr('href', '#');
                    button.click(function () {
                        if (_this.canSwitch) {
                            _this.lastSelectedCrumb = crumb;
                            _this.triggerClick();
                            _this.refreshInitialCrumb(crumb_value);
                        }
                    });
                    listItem.append(button);
                }
                return listItem;
            });
        };
        BreadCrumb.prototype.refresh = function () {
            this.list.children().remove();
            this.list.append(this.renderElements());
        };
        BreadCrumb.prototype.refreshInitialCrumb = function (crumb) {
            if (crumb === this.initialSheet) {
                this.crumbs = [crumb];
                this.refresh();
            }
        };
        BreadCrumb.prototype.refreshCrumbs = function (sheetName) {
            if (sheetName === null) {
                this.crumbs = [this.initialSheet];
                this.refresh();
                return;
            }
            if (this.baseSheets.contains(sheetName)) {
                return;
            }
            if (this.crumbs.contains(sheetName)) {
                this.crumbs = this.crumbs.slice(0, this.crumbs.indexOf(sheetName));
            }
            if (BreadCrumb.CRUMB_LIST.contains(sheetName) && this.info.getCardMetadata().getTemplateTitle().toLowerCase().contains('deepdive')) {
                this.crumbs = [];
            }
            this.crumbs.push(sheetName);
            this.refresh();
        };
        BreadCrumb.prototype.disable = function () {
            this.list.addClass(BreadCrumb.DISABLED_CSS_CLASS);
            this.canSwitch = false;
        };
        BreadCrumb.prototype.enable = function () {
            this.list.removeClass(BreadCrumb.DISABLED_CSS_CLASS);
            this.canSwitch = true;
        };
        BreadCrumb.prototype.initialize = function (report) {
            var _this = this;
            report.ready(function () {
                _this.reportName = report.getName() || '';
                var envType = _this.info.getEnvironmentProperties().getEnvironmentType();
                var baseSheetsPair = _this.info.getCardMetadata().getReportMetadata().getSheetByEnvironment(envType);
                _this.baseSheets = [
                    baseSheetsPair.getChartSheetName(),
                    baseSheetsPair.getDataTableSheetName(),
                ];
                _this.initialSheet = report.getActiveSheetName();
                if (_this.info.getCardMetadata().getTemplateTitle().toLowerCase().contains('deepdive') && report.getActiveSheetName() === BreadCrumb.CRUMB_LIST[0]) {
                    _this.initialSheet = BreadCrumb.CRUMB_LIST[3];
                }
                _this.crumbs = [_this.initialSheet];
                _this.wrapper.removeClass(BreadCrumb.INVISIBLE_CSS_CLASS);
                _this.refresh();
                _this.enable();
                $('.focus-group-button').click(function (e1) {
                    if (e1.target.textContent) {
                        _this.refreshCrumbs(e1.target.textContent);
                    }
                });
            });
        };
        BreadCrumb.BAD_WORDS = ['mobile', 'tablet', 'sheet'];
        BreadCrumb.INVISIBLE_CSS_CLASS = 'invisible';
        BreadCrumb.DISABLED_CSS_CLASS = 'disabled';
        BreadCrumb.CRUMB_LIST = ['Office', 'Advisor Teams', 'Advisors', 'OfficeDeepDive', 'TeamDeepDive', 'AdvisorDeepDive', 'Alternatives', 'AltsDeepDive'];
        BreadCrumb.OFFICE_DEEP_DIVE = 'Office Deep Dive';
        BreadCrumb.TEAM_DEEP_DIVE = 'Team Deep Dive';
        BreadCrumb.ADVISOR_DEEP_DIVE = 'Advisor Deep Dive';
        BreadCrumb.ALTS_DEEP_DIVE = 'Alts Deep Dive';
        BreadCrumb.DEEP_DIVE = ['Office', 'Advisor Teams', 'Advisors', 'Office Details', 'Alternatives'];
        return BreadCrumb;
    }());
    CardView.BreadCrumb = BreadCrumb;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var SideMenuGroup = (function () {
        function SideMenuGroup(wrapper, strings) {
            var _this = this;
            this.wrapper = wrapper;
            this.strings = strings;
            this.label = this.wrapper.children('a');
            this.arrow = this.label.find('.side-menu-arrow');
            this.internalList = wrapper.find('ul');
            this.loading = false;
            this.expanded = false;
            this.spinner = null;
            this.onCollapse(function () { _this.expanded = false; });
            this.onExpanded(function () { _this.expanded = true; });
        }
        SideMenuGroup.prototype.renderSpinner = function () {
            this.spinner = this.spinner || jQuery('<div/>', { 'class': 'fa fa-spin fa-refresh' });
        };
        SideMenuGroup.prototype.height = function () {
            if (this.wrapper === undefined || this.wrapper === null || this.wrapper.isEmpty()) {
                return 0;
            }
            return this.wrapper.height();
        };
        SideMenuGroup.prototype.markAsLoading = function (isLoading) {
            if (this.loading === isLoading) {
                return;
            }
            this.loading = isLoading;
            this.renderSpinner();
            if (isLoading) {
                this.arrow.replaceWith(this.spinner);
            }
            else {
                this.spinner.replaceWith(this.arrow);
            }
        };
        SideMenuGroup.prototype.isLoading = function () {
            return this.loading;
        };
        SideMenuGroup.prototype.append = function (elements) {
            this.internalList.append(elements);
        };
        SideMenuGroup.prototype.onExpanded = function (handler) {
            this.internalList.on('shown.bs.collapse', handler);
        };
        SideMenuGroup.prototype.onExpansion = function (handler) {
            this.internalList.on('show.bs.collapse', handler);
        };
        SideMenuGroup.prototype.onCollapse = function (handler) {
            this.internalList.on('hide.bs.collapse', handler);
        };
        SideMenuGroup.prototype.isVisible = function () {
            return !this.wrapper.hasClass(SideMenuGroup.HIDDEN_CSSCLASS);
        };
        SideMenuGroup.prototype.disable = function () {
            this.label.addClass(SideMenuGroup.DISABLED_CSSCLASS);
            this.label.prop(SideMenuGroup.DISABLED_PROPERTY, true);
        };
        SideMenuGroup.prototype.enable = function () {
            this.enableSideMenu();
            if (this.expanded) {
                this.collapse();
            }
        };
        SideMenuGroup.prototype.enableSideMenu = function () {
            this.label.removeClass(SideMenuGroup.DISABLED_CSSCLASS);
            this.label.prop(SideMenuGroup.DISABLED_PROPERTY, false);
        };
        SideMenuGroup.prototype.collapse = function () {
            this.internalList.collapse('hide');
        };
        SideMenuGroup.prototype.show = function () {
            this.wrapper
                .removeClass(SideMenuGroup.HIDDEN_CSSCLASS)
                .removeClass(SideMenuGroup.INVISIBLE_CSSCLASS)
                .hide().fadeIn();
        };
        SideMenuGroup.prototype.hide = function () {
            this.wrapper
                .addClass(SideMenuGroup.HIDDEN_CSSCLASS)
                .addClass(SideMenuGroup.INVISIBLE_CSSCLASS);
        };
        SideMenuGroup.prototype.showMessage = function () {
            var _this = this;
            this.label.popover({
                trigger: 'hover',
                placement: 'right',
                html: true,
                content: function () {
                    return '<div style="width: 120px"> ' + _this.strings.getRotationBuilderMessage() + '</div>';
                }
            });
        };
        SideMenuGroup.prototype.hideMessage = function () {
            if (this.label.popover) {
                this.label.popover('destroy');
            }
        };
        SideMenuGroup.INVISIBLE_CSSCLASS = 'invisible';
        SideMenuGroup.HIDDEN_CSSCLASS = 'hidden';
        SideMenuGroup.DISABLED_CSSCLASS = 'disabled';
        SideMenuGroup.DISABLED_PROPERTY = 'disabled';
        return SideMenuGroup;
    }());
    CardView.SideMenuGroup = SideMenuGroup;
    var ControlGroupButton = (function () {
        function ControlGroupButton(wrapper) {
            this.wrapper = wrapper;
            this.enabled = false;
            this.visible = false;
        }
        ControlGroupButton.prototype.refresh = function () {
            var toAdd = new Array();
            var toRemove = new Array();
            ((this.enabled) ? toRemove : toAdd).push(ControlGroupButton.DISABLED_CSSCLASS);
            ((this.visible) ? toRemove : toAdd).push(ControlGroupButton.HIDDEN_CSSCLASS);
            this.wrapper.addClass(toAdd.join(' '));
            this.wrapper.removeClass(toRemove.join(' '));
        };
        ControlGroupButton.prototype.setVisibility = function (isVisible) {
            if (this.visible === isVisible) {
                return;
            }
            this.visible = isVisible;
            this.refresh();
        };
        ControlGroupButton.prototype.setAvailability = function (isEnabled) {
            if (this.enabled === isEnabled) {
                return;
            }
            this.enabled = isEnabled;
            this.refresh();
        };
        ControlGroupButton.prototype.show = function () {
            this.setVisibility(true);
        };
        ControlGroupButton.prototype.enable = function () {
            this.setAvailability(true);
        };
        ControlGroupButton.prototype.disable = function () {
            this.setAvailability(false);
        };
        ControlGroupButton.prototype.click = function (handler) {
            var _this = this;
            this.wrapper.click(function () {
                if (_this.enabled) {
                    handler();
                }
            });
        };
        ControlGroupButton.DISABLED_CSSCLASS = 'disabled';
        ControlGroupButton.HIDDEN_CSSCLASS = 'hidden';
        return ControlGroupButton;
    }());
    var ControlsGroup = (function (_super) {
        __extends(ControlsGroup, _super);
        function ControlsGroup(wrapper, strings) {
            _super.call(this, wrapper, strings);
            this.resetButton = new ControlGroupButton(wrapper.find('.action.reset-action'));
            this.shareButton = new ControlGroupButton(wrapper.find('.action.share-action'));
            this.copyButton = new ControlGroupButton(wrapper.find('.action.copy-action'));
            this.deleteButton = new ControlGroupButton(wrapper.find('.action.delete-action'));
            this.publishCardButton = new ControlGroupButton(wrapper.find('.action.publish-card-action'));
        }
        ControlsGroup.prototype.getResetButton = function () {
            return this.resetButton;
        };
        ControlsGroup.prototype.getShareButton = function () {
            return this.shareButton;
        };
        ControlsGroup.prototype.getCopyButton = function () {
            return this.copyButton;
        };
        ControlsGroup.prototype.getDeleteButton = function () {
            return this.deleteButton;
        };
        ControlsGroup.prototype.getPublishButton = function () {
            return this.publishCardButton;
        };
        return ControlsGroup;
    }(SideMenuGroup));
    CardView.ControlsGroup = ControlsGroup;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var SideMenuFilter = (function () {
        function SideMenuFilter(filter) {
            this.filter = filter;
            this.setDepth(CardView.FilterRenderDepth.TOP);
        }
        SideMenuFilter.prototype.getPosition = function () {
            return this.filter.getPosition();
        };
        SideMenuFilter.prototype.getParentType = function () {
            return this.filter.getParentType();
        };
        SideMenuFilter.prototype.setDepth = function (depth) {
            this.depth = depth;
        };
        SideMenuFilter.prototype.render = function () {
            return this.filter.render(this.depth);
        };
        SideMenuFilter.prototype.hasContent = function () {
            return true;
        };
        SideMenuFilter.prototype.onExpanded = function (handler, extendToChildren) {
            this.filter.onExpanded(handler);
        };
        SideMenuFilter.prototype.onCollapse = function (handler, extendToChildren) {
            this.filter.onCollapse(handler);
        };
        SideMenuFilter.prototype.collapse = function () {
            this.filter.collapse();
        };
        return SideMenuFilter;
    }());
    var SideMenuFilterGroup = (function () {
        function SideMenuFilterGroup(label, id, type, parentType) {
            this.label = label;
            this.id = id;
            this.type = type;
            this.parent = null;
            this.parentType = parentType || null;
            this.groups = [];
            this.filters = [];
            this.rendered = false;
            this.isOpen = false;
            this.list = null;
            this.header = null;
            this.wrapper = null;
        }
        SideMenuFilterGroup.prototype.getPosition = function () {
            return Number(this.type);
        };
        SideMenuFilterGroup.prototype.getType = function () {
            return this.type;
        };
        SideMenuFilterGroup.prototype.hasParentType = function () {
            return this.getParentType() !== null;
        };
        SideMenuFilterGroup.prototype.getParentType = function () {
            return this.parent ? this.parent.getType() : this.parentType;
        };
        SideMenuFilterGroup.prototype.setParentGroup = function (parent) {
            this.parent = parent;
        };
        SideMenuFilterGroup.prototype.addGroup = function (group) {
            this.groups.push(group);
            group.setParentGroup(this);
        };
        SideMenuFilterGroup.prototype.addFilter = function (filter) {
            this.filters.push(filter);
            var depth = this.getParentDepth(CardView.FilterRenderDepth.TOP);
            depth++;
            filter.setDepth(depth);
        };
        SideMenuFilterGroup.prototype.hasContent = function () {
            return !this.filters.isEmpty() || this.groups.some(function (group) {
                return group.hasContent();
            });
        };
        SideMenuFilterGroup.prototype.collapse = function () {
            if (!this.isOpen) {
                return;
            }
            this.isOpen = false;
            this.wrapper.removeClass(SideMenuFilterGroup.OPEN_CSS_CLASS).addClass(SideMenuFilterGroup.CLOSED_CSS_CLASS);
            this.list.collapse('hide');
        };
        SideMenuFilterGroup.prototype.expand = function () {
            if (this.isOpen) {
                return;
            }
            this.isOpen = true;
            this.wrapper.removeClass(SideMenuFilterGroup.CLOSED_CSS_CLASS).addClass(SideMenuFilterGroup.OPEN_CSS_CLASS);
            this.list.collapse('show');
        };
        SideMenuFilterGroup.prototype.getComponents = function () {
            var components = new Array();
            components = components.concat(this.groups);
            components = components.concat(this.filters);
            components = components.filter(function (component) {
                return component.hasContent();
            });
            components.sort(function (curr, next) {
                return next.getPosition() - curr.getPosition();
            });
            return components;
        };
        SideMenuFilterGroup.prototype.getParentDepth = function (depth) {
            if (this.parent === null) {
                return depth;
            }
            return this.parent.getParentDepth(++depth);
        };
        SideMenuFilterGroup.prototype.renderWrapper = function (depth) {
            var wrapper = jQuery('<li/>', { 'id': this.id, 'class': 'closed' });
            switch (depth) {
                case CardView.FilterRenderDepth.TOP:
                    wrapper.addClass('filter-category');
                    break;
                case CardView.FilterRenderDepth.IN_CATEGORY:
                    wrapper.addClass('filter-group');
                    break;
                default:
                    return null;
            }
            return wrapper;
        };
        SideMenuFilterGroup.prototype.renderHeader = function (depth) {
            var sideMenuLabel = jQuery('<a/>', { 'class': 'side-menu-label' });
            var arrow = jQuery('<span/>', { 'class': 'fa fa-caret-right side-menu-arrow' });
            var label = jQuery('<span/>', { 'text': ' ' + this.label });
            switch (depth) {
                case CardView.FilterRenderDepth.TOP:
                    sideMenuLabel.addClass('side-menu-label-md');
                    break;
                case CardView.FilterRenderDepth.IN_CATEGORY:
                    sideMenuLabel.addClass('side-menu-label-sm');
                    break;
                default:
                    return null;
            }
            sideMenuLabel.append(arrow, label);
            return sideMenuLabel;
        };
        SideMenuFilterGroup.prototype.renderList = function (depth) {
            var _this = this;
            var list = jQuery('<ul/>', { 'class': 'collapse list-unstyled' });
            switch (depth) {
                case CardView.FilterRenderDepth.TOP:
                    list.addClass('filter-groups');
                    break;
                case CardView.FilterRenderDepth.IN_CATEGORY:
                    list.addClass('filters-list');
                    break;
                default:
                    return null;
            }
            this.getComponents().forEach(function (component) {
                list.append(component.render());
                component.onExpanded(function () {
                    _this.collapseSiblings(component);
                }, false);
            });
            return list;
        };
        SideMenuFilterGroup.prototype.collapseSiblings = function (origin) {
            this.getComponents().forEach(function (component) {
                if (component !== origin) {
                    component.collapse();
                }
            });
        };
        SideMenuFilterGroup.prototype.toggle = function () {
            if (this.isOpen) {
                this.collapse();
            }
            else {
                this.expand();
            }
        };
        SideMenuFilterGroup.prototype.addRenderedEventListeners = function () {
            var _this = this;
            this.header.click(function () {
                _this.toggle();
            });
        };
        SideMenuFilterGroup.prototype.render = function () {
            if (!this.hasContent()) {
                return null;
            }
            if (this.rendered) {
                return this.wrapper;
            }
            var depth = this.getParentDepth(CardView.FilterRenderDepth.TOP);
            this.wrapper = this.renderWrapper(depth);
            this.header = this.renderHeader(depth);
            this.list = this.renderList(depth);
            if (!this.wrapper || !this.header || !this.list) {
                return null;
            }
            this.wrapper.append(this.header, this.list);
            this.addRenderedEventListeners();
            this.rendered = true;
            return this.wrapper;
        };
        SideMenuFilterGroup.prototype.onExpanded = function (handler, extendToChildren) {
            this.list.on('show.bs.collapse', handler);
            if (extendToChildren) {
                this.getComponents().forEach(function (component) {
                    component.onExpanded(handler, true);
                });
            }
        };
        SideMenuFilterGroup.prototype.onCollapse = function (handler, extendToChildren) {
            this.list.on('hide.bs.collapse', handler);
            if (extendToChildren) {
                this.getComponents().forEach(function (component) {
                    component.onCollapse(handler, true);
                });
            }
        };
        SideMenuFilterGroup.OPEN_CSS_CLASS = 'open';
        SideMenuFilterGroup.CLOSED_CSS_CLASS = 'closed';
        return SideMenuFilterGroup;
    }());
    var FilterMenuFactory = (function () {
        function FilterMenuFactory() {
            this.groups = {};
            this.topLevelFilters = [];
        }
        FilterMenuFactory.prototype.addGroup = function (group) {
            this.groups[group.getType()] = group;
            if (group.hasParentType()) {
                var parentType = group.getParentType();
                if (this.groups[parentType]) {
                    this.groups[parentType].addGroup(group);
                }
                else {
                    console.log('Could not find parent for group', group);
                }
            }
        };
        FilterMenuFactory.prototype.addFilter = function (filter) {
            var parentType = filter.getParentType();
            var group = this.groups[parentType] || null;
            if (group === null) {
                this.topLevelFilters.push(filter);
            }
            else {
                group.addFilter(filter);
            }
        };
        FilterMenuFactory.prototype.getTopLevelGroups = function () {
            var _this = this;
            var ids = Object.keys(this.groups).map(Number);
            return ids.map(function (id) { return _this.groups[id]; }).filter(function (group) { return !group.hasParentType(); });
        };
        FilterMenuFactory.prototype.getTopLevelComponents = function () {
            var components = this.getTopLevelGroups().concat(this.topLevelFilters);
            components = components.filter(function (component) { return component.hasContent(); });
            components.sort(function (curr, next) { return next.getPosition() - curr.getPosition(); });
            return components;
        };
        return FilterMenuFactory;
    }());
    var FiltersMenuGroup = (function (_super) {
        __extends(FiltersMenuGroup, _super);
        function FiltersMenuGroup(wrapper, strings) {
            _super.call(this, wrapper, strings);
            this.resizeHandlers = new ListenersCollection();
            this.visibility = true;
            this.withMessage = false;
        }
        FiltersMenuGroup.prototype.feed = function (filters) {
            if (filters === null) {
                this.markAsLoading(true);
                this.disable();
                this.show();
            }
            else {
                this.filters = filters;
                this.createFilterComponents();
                this.appendFilters();
                this.addResizeEventListeners();
                this.addSiblingExpandEventListeners();
                this.markAsLoading(false);
                this.enable();
                this.checkSalesFilters();
            }
        };
        FiltersMenuGroup.prototype.checkSalesFilters = function () {
            if (window.cardData.templateTitle === 'Alternatives') {
                $("#ws-group-filter-sales").hide();
            }
            if (window.cardData.templateTitle === 'RotationBuilder') {
                $("#ws-categorical-filter-market-share").hide();
            }
        };
        FiltersMenuGroup.prototype.collapseSiblings = function (expanded) {
            this.components.forEach(function (component) {
                if (expanded !== component) {
                    component.collapse();
                }
            });
        };
        FiltersMenuGroup.prototype.addSiblingExpandEventListeners = function () {
            var _this = this;
            this.components.forEach(function (component) {
                component.onExpanded(function () {
                    _this.collapseSiblings(component);
                }, false);
            });
        };
        FiltersMenuGroup.prototype.addResizeEventListeners = function () {
            var _this = this;
            this.components.forEach(function (component) {
                component.onExpanded(function () {
                    _this.resizeHandlers.execute(window, []);
                }, true);
                component.onCollapse(function () {
                    _this.resizeHandlers.execute(window, []);
                }, true);
            });
        };
        FiltersMenuGroup.prototype.appendFilters = function () {
            this.append(this.components.map(function (component) { return component.render(); }));
        };
        FiltersMenuGroup.prototype.createFilterComponents = function () {
            var filterMenuFactory = new FilterMenuFactory();
            filterMenuFactory.addGroup(new SideMenuFilterGroup('Timeframe', FiltersMenuGroup.TIMEFRAME_GROUP_ID, CardView.FilterGroupType.TIMEFRAME));
            filterMenuFactory.addGroup(new SideMenuFilterGroup('Location', FiltersMenuGroup.LOCATION_GROUP_ID, CardView.FilterGroupType.LOCATION));
            filterMenuFactory.addGroup(new SideMenuFilterGroup('Analytics', FiltersMenuGroup.ANALYTICS_GROUP_ID, CardView.FilterGroupType.ANALYTICS));
            filterMenuFactory.addGroup(new SideMenuFilterGroup('Sales', FiltersMenuGroup.SALES_GROUP_ID, CardView.FilterGroupType.SALES));
            filterMenuFactory.addGroup(new SideMenuFilterGroup('Category', FiltersMenuGroup.CATEGORY_GROUP_ID, CardView.FilterGroupType.ANALYTICS_CATEGORY, CardView.FilterGroupType.ANALYTICS));
            filterMenuFactory.addGroup(new SideMenuFilterGroup('Office', FiltersMenuGroup.OFFICE_GROUP_ID, CardView.FilterGroupType.ANALYTICS_OFFICE, CardView.FilterGroupType.ANALYTICS));
            filterMenuFactory.addGroup(new SideMenuFilterGroup('Location', FiltersMenuGroup.ALT_LOCATION_GROUP_ID, CardView.FilterGroupType.ALTLOCATION));
            this.filters.forEach(function (filter) {
                filterMenuFactory.addFilter(new SideMenuFilter(filter));
            });
            this.components = filterMenuFactory.getTopLevelComponents();
        };
        FiltersMenuGroup.prototype.show = function () {
            this.refresh();
        };
        FiltersMenuGroup.prototype.hide = function () {
            this.refresh();
        };
        FiltersMenuGroup.prototype.refresh = function () {
            if (this.visibility) {
                _super.prototype.show.call(this);
                if (this.isLoading()) {
                    this.disable();
                }
                else {
                    this.enable();
                }
            }
            else {
                _super.prototype.hide.call(this);
            }
        };
        FiltersMenuGroup.prototype.overrideVisibility = function (visibility) {
            if (this.visibility === visibility) {
                return;
            }
            this.visibility = visibility;
            this.refresh();
        };
        FiltersMenuGroup.prototype.refreshMessage = function () {
            if (this.withMessage) {
                _super.prototype.showMessage.call(this);
            }
            else {
                _super.prototype.hideMessage.call(this);
            }
        };
        FiltersMenuGroup.prototype.overrideMessage = function (withMessage) {
            if (this.withMessage === withMessage) {
                return;
            }
            this.withMessage = withMessage;
            this.refreshMessage();
        };
        FiltersMenuGroup.prototype.onResize = function (handler) {
            this.resizeHandlers.addEventListener(handler);
            this.onCollapse(handler);
            this.onExpansion(handler);
        };
        FiltersMenuGroup.TIMEFRAME_GROUP_ID = 'ws-group-filter-timeframe';
        FiltersMenuGroup.LOCATION_GROUP_ID = 'ws-group-filter-location';
        FiltersMenuGroup.ANALYTICS_GROUP_ID = 'ws-group-filter-analytics';
        FiltersMenuGroup.SALES_GROUP_ID = 'ws-group-filter-sales';
        FiltersMenuGroup.CATEGORY_GROUP_ID = 'ws-group-filter-category';
        FiltersMenuGroup.OFFICE_GROUP_ID = 'ws-group-filter-office';
        FiltersMenuGroup.ALT_LOCATION_GROUP_ID = 'ws-alt-group-filter-location';
        return FiltersMenuGroup;
    }(CardView.SideMenuGroup));
    CardView.FiltersMenuGroup = FiltersMenuGroup;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var SideMenu = (function () {
        function SideMenu(options) {
            this.setOpen(false);
            this.environment = options.info.getEnvironmentProperties().getEnvironmentType();
            this.generateUiConfig();
            this.list = options.wrapper;
            this.closeButton = this.list.find('.activator.close-menu button');
            this.myViewsGroup = new CardView.SideMenuGroup(this.list.find('.side-menu-views-option'), options.strings);
            this.configGroup = new CardView.FiltersMenuGroup(this.list.find('.side-menu-properties-option'), options.strings);
            this.controlsGroup = new CardView.ControlsGroup(this.list.find('.side-menu-controls-option'), options.strings);
            this.groups = (this.environment === CardView.EnvironmentEnum.MOBILE) ? this.list : this.list.children('.group');
            this.closed = new ListenersCollection();
            this.closing = new ListenersCollection();
            this.opened = new ListenersCollection();
            this.opening = new ListenersCollection();
            this.resizeHandlers = new ListenersCollection();
            this.addEventListeners();
        }
        SideMenu.prototype.onResize = function (handler) {
            var lastTimeId = null;
            var internalHandler = function () {
                clearTimeout(lastTimeId);
                lastTimeId = setTimeout(handler, 250);
            };
            // Resize of groups
            this.resizeHandlers.addEventListener(internalHandler);
            // Resize of filters
            this.myViewsGroup.onExpansion(internalHandler);
            this.myViewsGroup.onCollapse(internalHandler);
            this.configGroup.onResize(internalHandler);
            this.configGroup.onResize(internalHandler);
            this.controlsGroup.onCollapse(internalHandler);
            this.controlsGroup.onExpansion(internalHandler);
        };
        SideMenu.prototype.height = function () {
            return this.list.outerHeight();
        };
        SideMenu.prototype.internalHeight = function () {
            return this.myViewsGroup.height() + this.configGroup.height() + this.controlsGroup.height() + SideMenu.SIDE_MENU_PADDING_SIZE;
        };
        SideMenu.prototype.isMenuOpen = function () {
            return this.isOpen;
        };
        SideMenu.prototype.clearHeight = function () {
            this.setHeight(null);
        };
        SideMenu.prototype.setHeight = function (height) {
            this.list.css('height', height === null ? '' : height);
        };
        SideMenu.prototype.generateUiConfig = function () {
            var environment = this.environment;
            var animationRange = (environment === CardView.EnvironmentEnum.MOBILE) ? $(window).width() : SideMenu.MOBILE_ANIMATION_RANGE;
            var eventName = (environment === CardView.EnvironmentEnum.PC) ? SideMenu.DESKTOP_EVENT_NAME : SideMenu.NON_DESKTOP_EVENT_NAME;
            this.uiConfig = {
                animationRange: -animationRange,
                eventName: eventName,
                timing: SideMenu.ANIMATION_TIMING
            };
        };
        SideMenu.prototype.feed = function (filters) {
            this.configGroup.feed(filters);
        };
        SideMenu.prototype.initialize = function () {
            this.list.removeClass(SideMenu.INVISIBLE_CSSCLASS).hide().fadeIn();
        };
        SideMenu.prototype.showControls = function () {
            this.controlsGroup.show();
        };
        SideMenu.prototype.toggle = function () {
            if (this.isOpen) {
                return this.close();
            }
            else {
                return this.open();
            }
        };
        SideMenu.prototype.onOpening = function (handler) {
            this.opening.addEventListener(handler);
        };
        SideMenu.prototype.onOpened = function (handler) {
            this.opened.addEventListener(handler);
        };
        SideMenu.prototype.onClosed = function (handler) {
            this.closed.addEventListener(handler);
        };
        SideMenu.prototype.onClosing = function (handler) {
            this.closing.addEventListener(handler);
        };
        SideMenu.prototype.showPropertiesGroup = function () {
            this.configGroup.show();
        };
        SideMenu.prototype.hidePropertiesGroup = function () {
            this.configGroup.hide();
        };
        SideMenu.prototype.overridePropertiesGroupVisibility = function (visibilty) {
            this.configGroup.overrideVisibility(visibilty);
        };
        SideMenu.prototype.showRotationBuilderMessage = function (visibility) {
            var _this = this;
            this.configGroup.overrideVisibility(true);
            this.configGroup.overrideMessage(visibility);
            setTimeout(function () {
                if (visibility) {
                    _this.configGroup.disable();
                    _this.configGroup.collapse();
                }
                else {
                    _this.configGroup.enableSideMenu();
                }
            }, 1500);
        };
        SideMenu.prototype.showResetButton = function () {
            this.controlsGroup.getResetButton().show();
        };
        SideMenu.prototype.enableResetButton = function () {
            this.controlsGroup.getResetButton().enable();
        };
        SideMenu.prototype.disableResetButton = function () {
            this.controlsGroup.getResetButton().disable();
        };
        SideMenu.prototype.onResetButtonClick = function (handler) {
            this.controlsGroup.getResetButton().click(handler);
        };
        SideMenu.prototype.showShareButton = function () {
            this.controlsGroup.getShareButton().show();
        };
        SideMenu.prototype.enableShareButton = function () {
            this.controlsGroup.getShareButton().enable();
        };
        SideMenu.prototype.disableShareButton = function () {
            this.controlsGroup.getShareButton().disable();
        };
        SideMenu.prototype.onShareButtonClick = function (handler) {
            this.controlsGroup.getShareButton().click(handler);
        };
        SideMenu.prototype.showCopyButton = function () {
            this.controlsGroup.getCopyButton().show();
        };
        SideMenu.prototype.enableCopyButton = function () {
            this.controlsGroup.getCopyButton().enable();
        };
        SideMenu.prototype.onCopyButtonClick = function (handler) {
            this.controlsGroup.getCopyButton().click(handler);
        };
        SideMenu.prototype.showDeleteButton = function () {
            this.controlsGroup.getDeleteButton().show();
        };
        SideMenu.prototype.enableDeleteButton = function () {
            this.controlsGroup.getDeleteButton().enable();
        };
        SideMenu.prototype.onDeleteButtonClick = function (handler) {
            this.controlsGroup.getDeleteButton().click(handler);
        };
        SideMenu.prototype.showPublishButton = function () {
            this.controlsGroup.getPublishButton().show();
        };
        SideMenu.prototype.disablePublishButton = function () {
            this.controlsGroup.getPublishButton().disable();
        };
        SideMenu.prototype.enablePublishButton = function () {
            this.controlsGroup.getPublishButton().enable();
        };
        SideMenu.prototype.onPublishButtonClick = function (handler) {
            this.controlsGroup.getPublishButton().click(handler);
        };
        SideMenu.prototype.setOpen = function (isOpen) {
            this.isOpen = isOpen;
        };
        SideMenu.prototype.close = function () {
            var _this = this;
            this.closing.execute(window, []);
            // Set timer...
            setTimeout(function () {
                _this.setOpen(false);
                // Hide components
                _this.list.addClass(SideMenu.OCULT_CSSCLASS);
                // Call handlers
                _this.closed.execute(window, []);
            }, this.uiConfig.timing);
            // Call animation
            this.hideSideMenu();
        };
        SideMenu.prototype.open = function () {
            var _this = this;
            // Call event handlers
            this.opening.execute(window, []);
            // Set timer...
            setTimeout(function () {
                _this.setOpen(true);
                // Show components
                _this.list.removeClass(SideMenu.OCULT_CSSCLASS);
                // Call event handlers
                _this.opened.execute(window, []);
            }, this.uiConfig.timing);
            // Call animation
            this.showSideMenu();
        };
        SideMenu.prototype.setSideMenuVisibility = function (isVisible) {
            this.list.css('left', isVisible ? 0 : this.uiConfig.animationRange);
        };
        SideMenu.prototype.showSideMenu = function () {
            this.setSideMenuVisibility(true);
        };
        SideMenu.prototype.hideSideMenu = function () {
            this.setSideMenuVisibility(false);
        };
        SideMenu.prototype.refreshHorizontalPosition = function () {
            if (!this.isOpen) {
                this.hideSideMenu();
            }
        };
        SideMenu.prototype.addCollapseGroupListeners = function () {
            var groups = [this.myViewsGroup, this.configGroup, this.controlsGroup];
            groups.forEach(function (group) {
                group.onExpansion(function () {
                    for (var i = 0; i < groups.length; ++i) {
                        var otherGroup = groups[i];
                        if (group !== otherGroup && otherGroup.isVisible()) {
                            otherGroup.collapse();
                        }
                    }
                });
            });
        };
        SideMenu.prototype.addEventListeners = function () {
            var _this = this;
            this.addCollapseGroupListeners();
            $(window).on('orientationchange', function () {
                _this.generateUiConfig();
                setTimeout(function () {
                    _this.refreshHorizontalPosition();
                }, 1);
                setTimeout(function () {
                    _this.refreshHorizontalPosition();
                }, 200);
            });
            $(window.document.body).on(this.uiConfig.eventName, function (event) {
                // If list is not opened, do not perform any action
                if (!_this.isOpen) {
                    return;
                }
                var source = event.target || null;
                if (source === null) {
                    return;
                }
                // Don't peform any actions if the user is clicking on or inside one of the following items
                if (!SideMenu.isOrContains(_this.closeButton, source) && SideMenu.isOrContains(_this.list, source)) {
                    return;
                }
                _this.close();
            });
            this.addAnalyticsEventListeners();
        };
        SideMenu.isOrContains = function (wrapper, element) {
            return wrapper.get(0) === element || jQuery.contains(wrapper.get(0), element);
        };
        SideMenu.prototype.addAnalyticsEventListeners = function () {
            this.myViewsGroup.onExpansion(function () {
                Analytics.registerCardViewLeftMenuMyViewSectionOpenEvent();
            });
            this.configGroup.onExpansion(function () {
                Analytics.registerCardViewLeftMenuFiltersSectionOpenEvent();
            });
            this.controlsGroup.onExpansion(function () {
                Analytics.registerCardViewLeftMenuControlsSectionOpenEvent();
            });
            this.onOpened(function () {
                Analytics.registerCardViewLeftMenuOpenEvent();
            });
        };
        SideMenu.MOBILE_ANIMATION_RANGE = 260;
        SideMenu.DESKTOP_EVENT_NAME = 'click';
        SideMenu.NON_DESKTOP_EVENT_NAME = 'touchstart';
        SideMenu.ANIMATION_TIMING = 200;
        SideMenu.SIDE_MENU_PADDING_SIZE = 80;
        SideMenu.INVISIBLE_CSSCLASS = 'invisible';
        SideMenu.OCULT_CSSCLASS = 'ocult';
        return SideMenu;
    }());
    CardView.SideMenu = SideMenu;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var ToolbarControls = (function () {
        function ToolbarControls(options) {
            this.wrapper = options.wrapper;
            this.info = options.info;
            var env = options.info.getEnvironmentProperties().getEnvironmentType();
            this.uiConfig = {
                eventName: (env === CardView.EnvironmentEnum.PC) ? ToolbarControls.PC_EVENT_NAME : ToolbarControls.NON_PC_EVENT_NAME
            };
            this.sideMenuButton = this.wrapper.find('.btn.side-menu');
            this.saveButton = this.wrapper.find('.btn.save-button');
            this.switchVisualizationButton = this.wrapper.find('.btn.switch-visualization-button');
            this.switchVisualizationChart = this.switchVisualizationButton.children('.switch-visualization-chart');
            this.switchVisualizationTable = this.switchVisualizationButton.children('.switch-visualization-table');
            this.exportMenuButton = this.wrapper.find('.btn.export-button');
            this.exportMenu = this.exportMenuButton.next();
            this.exportOptions = this.exportMenu.children();
            this.exportPNGOption = this.exportOptions.filter('*[data-exporting-format="PNG"]');
            this.exportCSVOption = this.exportOptions.filter('*[data-exporting-format="CSV"]');
            this.newButton = this.wrapper.find('.btn.new-report-button');
            this.cancelButton = this.wrapper.find('.btn.cancel-button');
        }
        ToolbarControls.displayButton = function (button) {
            var DISABLED_CSSCLASS = this.DISABLED_CSS_CLASS;
            var HIDDEN_CSSCLASS = this.HIDDEN_CSS_CLASS;
            button
                .removeClass(DISABLED_CSSCLASS)
                .removeClass(HIDDEN_CSSCLASS)
                .hide().fadeIn()
                .parent().removeClass(HIDDEN_CSSCLASS);
        };
        ToolbarControls.prototype.onSideMenuButtonTriggered = function (handler) {
            this.sideMenuButton.on(this.uiConfig.eventName, function () {
                handler();
            });
        };
        ToolbarControls.prototype.setSideMenuButtonState = function (state) {
            var ACTIVE_CSS_CLASS = ToolbarControls.ACTIVE_CSS_CLASS, sideMenuButton = this.sideMenuButton;
            if (state) {
                sideMenuButton.addClass(ACTIVE_CSS_CLASS);
            }
            else {
                sideMenuButton.removeClass(ACTIVE_CSS_CLASS);
            }
        };
        ToolbarControls.prototype.enableCancelButton = function () {
            ToolbarControls.displayButton(this.cancelButton);
        };
        ToolbarControls.prototype.onCancelButtonClick = function (handler) {
            this.cancelButton.on(this.uiConfig.eventName, handler);
        };
        ToolbarControls.prototype.onSaveButtonClick = function (handler) {
            this.saveButton.on(this.uiConfig.eventName, handler);
        };
        ToolbarControls.prototype.enableNewButton = function () {
            ToolbarControls.displayButton(this.newButton);
        };
        ToolbarControls.prototype.displaySaveButton = function () {
            ToolbarControls.displayButton(this.saveButton);
            this.disableSaveButton();
        };
        ToolbarControls.prototype.enableSaveButton = function () {
            this.saveButton.prop(ToolbarControls.DISABLED_PROP, false);
        };
        ToolbarControls.prototype.disableSaveButton = function () {
            this.saveButton.prop(ToolbarControls.DISABLED_PROP, true);
        };
        ToolbarControls.prototype.enableCSVButton = function () {
            this.exportMenuButton.prop(ToolbarControls.DISABLED_PROP, false);
            this.exportCSVOption.removeClass(ToolbarControls.DISABLED_CSS_CLASS);
            this.exportCSVOption.children().removeClass(ToolbarControls.DISABLED_CSS_CLASS);
        };
        ToolbarControls.prototype.disableCSVButton = function () {
            this.exportMenuButton.prop(ToolbarControls.DISABLED_PROP, true);
            this.exportCSVOption.addClass(ToolbarControls.DISABLED_CSS_CLASS);
            this.exportCSVOption.children().addClass(ToolbarControls.DISABLED_CSS_CLASS);
        };
        ToolbarControls.prototype.isCSVDisabled = function () {
            return this.exportCSVOption.hasClass(ToolbarControls.DISABLED_CSS_CLASS);
        };
        ToolbarControls.prototype.onNewButtonClick = function (handler) {
            this.newButton.on(this.uiConfig.eventName, handler);
        };
        ToolbarControls.prototype.enableToggleVisualizationButton = function () {
            ToolbarControls.displayButton(this.switchVisualizationButton);
        };
        ToolbarControls.prototype.onToggleVisualizationButtonClick = function (handler) {
            this.switchVisualizationButton.on(this.uiConfig.eventName, handler);
        };
        ToolbarControls.prototype.toggleVisualizationButtonIcon = function (activeSheet) {
            var env = this.info.getEnvironmentProperties().getEnvironmentType();
            var sheet = this.info.getCardMetadata().getReportMetadata().getSheetByEnvironment(env);
            var HIDDEN_CSS_CLASS = ToolbarControls.HIDDEN_CSS_CLASS;
            var switchVisualizationChart = this.switchVisualizationChart;
            var switchVisualizationTable = this.switchVisualizationTable;
            switch (activeSheet) {
                case sheet.getChartSheetName():
                    switchVisualizationChart.addClass(HIDDEN_CSS_CLASS);
                    switchVisualizationTable.removeClass(HIDDEN_CSS_CLASS);
                    break;
                case sheet.getDataTableSheetName():
                    switchVisualizationTable.addClass(HIDDEN_CSS_CLASS);
                    switchVisualizationChart.removeClass(HIDDEN_CSS_CLASS);
                    break;
            }
        };
        ToolbarControls.prototype.disableToggleVisualizationButton = function () {
            this.switchVisualizationButton.addClass(ToolbarControls.DISABLED_CSS_CLASS);
        };
        ToolbarControls.prototype.reEnableToggleVisualizationButton = function () {
            this.switchVisualizationButton.removeClass(ToolbarControls.DISABLED_CSS_CLASS);
        };
        ToolbarControls.prototype.removeToggleVisualizationButton = function () {
            this.switchVisualizationButton.remove();
        };
        ToolbarControls.prototype.removeExportMenu = function () {
            this.exportMenuButton.remove();
            this.exportMenu.remove();
        };
        ToolbarControls.prototype.enableExportMenu = function () {
            ToolbarControls.displayButton(this.exportMenuButton);
        };
        ToolbarControls.prototype.hideExportMenu = function () {
            this.exportMenuButton.hide();
        };
        ToolbarControls.prototype.removeExportCSVOption = function () {
            this.exportCSVOption.remove();
        };
        ToolbarControls.prototype.removeExportPNGOption = function () {
            this.exportPNGOption.remove();
        };
        ToolbarControls.setVisibility = function (element, visible) {
            if (visible) {
                element.removeClass(ToolbarControls.HIDDEN_CSS_CLASS);
            }
            else {
                element.addClass(ToolbarControls.HIDDEN_CSS_CLASS);
            }
        };
        ToolbarControls.prototype.setPNGExportOptionState = function (state) {
            ToolbarControls.setVisibility(this.exportPNGOption, state);
            this.refreshExportMenu();
        };
        ToolbarControls.prototype.setCSVExportOptionState = function (state) {
            ToolbarControls.setVisibility(this.exportCSVOption, state);
            this.refreshExportMenu();
        };
        ToolbarControls.prototype.refreshExportMenu = function () {
            var visibleOptions = this.exportOptions.filter(':not(.' + ToolbarControls.HIDDEN_CSS_CLASS + ')');
            if (visibleOptions.isEmpty()) {
                this.exportMenuButton.addClass(ToolbarControls.DISABLED_CSS_CLASS);
            }
            else {
                this.exportMenuButton.removeClass(ToolbarControls.DISABLED_CSS_CLASS);
            }
        };
        ToolbarControls.prototype.onCSVExportOptionSelected = function (handler) {
            this.exportCSVOption.on(this.uiConfig.eventName, handler);
        };
        ToolbarControls.prototype.onPNGExportOptionSelected = function (handler) {
            this.exportPNGOption.on(this.uiConfig.eventName, handler);
        };
        ToolbarControls.prototype.showNavbar = function () {
            this.wrapper.removeClass(ToolbarControls.HIDDEN_CSS_CLASS);
        };
        ToolbarControls.prototype.getWrapper = function () {
            return this.wrapper;
        };
        ToolbarControls.PC_EVENT_NAME = 'click';
        ToolbarControls.NON_PC_EVENT_NAME = 'touchend';
        ToolbarControls.ACTIVE_CSS_CLASS = 'active';
        ToolbarControls.HIDDEN_CSS_CLASS = 'hidden';
        ToolbarControls.DISABLED_CSS_CLASS = 'disabled';
        ToolbarControls.DISABLED_PROP = 'disabled';
        ToolbarControls.KEEP_DISABLED_CLASS = 'keep-disabled';
        return ToolbarControls;
    }());
    CardView.ToolbarControls = ToolbarControls;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var Actions;
    (function (Actions) {
        (function (ActionType) {
            ActionType[ActionType["CANCEL"] = 1] = "CANCEL";
            ActionType[ActionType["NEW"] = 2] = "NEW";
            ActionType[ActionType["TOGGLE"] = 4] = "TOGGLE";
            ActionType[ActionType["EXPORT_PNG"] = 8] = "EXPORT_PNG";
            ActionType[ActionType["EXPORT_CSV"] = 16] = "EXPORT_CSV";
            ActionType[ActionType["CRUMB_CRAWL"] = 32] = "CRUMB_CRAWL";
            ActionType[ActionType["APPLY_PARAMETER"] = 64] = "APPLY_PARAMETER";
            ActionType[ActionType["APPLY_FILTER"] = 128] = "APPLY_FILTER";
            ActionType[ActionType["RESET"] = 256] = "RESET";
            ActionType[ActionType["SAVE_TEMPLATE"] = 512] = "SAVE_TEMPLATE";
            ActionType[ActionType["SAVE_VIEW"] = 1024] = "SAVE_VIEW";
            ActionType[ActionType["SAVE_SHARED"] = 2048] = "SAVE_SHARED";
            ActionType[ActionType["SHARE"] = 4096] = "SHARE";
            ActionType[ActionType["COPY"] = 8192] = "COPY";
            ActionType[ActionType["DELETE"] = 16384] = "DELETE";
            ActionType[ActionType["PUBLISH"] = 32768] = "PUBLISH";
            ActionType[ActionType["DELETE_PUBLISHED"] = 65536] = "DELETE_PUBLISHED";
            ActionType[ActionType["APPLY_SALES_FILTER"] = 131072] = "APPLY_SALES_FILTER";
        })(Actions.ActionType || (Actions.ActionType = {}));
        var ActionType = Actions.ActionType;
    })(Actions = CardView.Actions || (CardView.Actions = {}));
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var Actions;
    (function (Actions) {
        var ShareCard = (function () {
            function ShareCard() {
                this.previousErrorMessage = null;
            }
            ShareCard.prototype.getType = function () {
                return Actions.ActionType.SHARE;
            };
            ShareCard.prototype.isAvailable = function (manager) {
                var cardData = manager.getCardMetadata();
                return cardData.isView() && !cardData.isSharedCard();
            };
            ShareCard.prototype.showErrorMessage = function (message) {
                if (this.previousErrorMessage !== null) {
                    this.previousErrorMessage.remove();
                }
                this.previousErrorMessage = Kasina.messages.get().error(message);
            };
            ShareCard.prototype.execute = function (deferred, manager, args) {
                var strings = manager.getStrings();
                var shareUrl = manager.getCardMetadata().getPermalink().parseUrl('href');
                Utilities.openMailClient(null, strings.getShareMailtoSubject(), strings.getShareMailtoBody() + ' ' + shareUrl);
                deferred.resolve();
                Analytics.registerSharedCardInViewEvent();
            };
            return ShareCard;
        }());
        Actions.ShareCard = ShareCard;
    })(Actions = CardView.Actions || (CardView.Actions = {}));
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var Actions;
    (function (Actions) {
        var SaveAction = (function () {
            function SaveAction() {
            }
            SaveAction.generateRandomCustomViewName = function () {
                return new Date().getTime() + '_' + Math.random().toString(36).substring(7);
            };
            SaveAction.prototype.createSavePayload = function (manager, args, customViewName) {
                var filtersPayLoad = args.getPropertiesSavePayload();
                return {
                    categoricalFilters: filtersPayLoad.categoricalFilters,
                    categoricalSalesFilters: filtersPayLoad.categoricalSalesFilters,
                    parameters: filtersPayLoad.parameters,
                    customViewName: customViewName,
                    title: args.title
                };
            };
            SaveAction.prototype.saveReport = function (manager, args) {
                return args.report.saveView(SaveAction.generateRandomCustomViewName());
            };
            SaveAction.prototype.showLoadingScreen = function (args) {
                args.reportView.showLoadingScreen();
            };
            SaveAction.prototype.hideLoadingScreen = function (args) {
                args.reportView.hideLoadingScreen();
            };
            SaveAction.prototype.saveCard = function (manager, args, customViewName) {
                var _this = this;
                var deferred = jQuery.Deferred();
                var payload = this.createSavePayload(manager, args, customViewName);
                jQuery.ajax({
                    'method': 'POST',
                    'url': this.getCardserviceUrl(manager),
                    'data': JSON.stringify(payload),
                    'contentType': 'application/json',
                })
                    .then(function (id) {
                    // Change custom view name
                    manager.getProperties().setCustomView(payload.customViewName);
                    deferred.resolveWith(window, [_this.parseSaveResponse(id)]);
                })
                    .fail(function () {
                    deferred.reject();
                });
                return deferred.promise();
            };
            return SaveAction;
        }());
        var CreateCardAction = (function (_super) {
            __extends(CreateCardAction, _super);
            function CreateCardAction() {
                _super.apply(this, arguments);
            }
            CreateCardAction.prototype.getCardserviceUrl = function (manager) {
                return manager.getUrls().getCreateCardUrl();
            };
            CreateCardAction.prototype.parseSaveResponse = function (content) {
                return Number(content);
            };
            CreateCardAction.prototype.createSavePayload = function (manager, args, customViewName) {
                var payload = _super.prototype.createSavePayload.call(this, manager, args, customViewName);
                return {
                    categoricalFilters: payload.categoricalFilters.map(function (fPayload) { fPayload.filterId = null; return fPayload; }),
                    categoricalSalesFilters: payload.categoricalSalesFilters.map(function (fPayload) { fPayload.filterId = null; return fPayload; }),
                    customViewName: payload.customViewName,
                    parameters: payload.parameters.map(function (pPayload) { pPayload.parameterId = null; return pPayload; }),
                    templateId: manager.getCardMetadata().getTemplateId(),
                    title: payload.title
                };
            };
            CreateCardAction.prototype.execute = function (deferred, manager, args) {
                var _this = this;
                // Attach loading screen
                this.showLoadingScreen(args);
                // Create new report custom view
                this.saveReport(manager, args)
                    .then(function (customViewName) {
                    // Call service to copy card
                    _this.saveCard(manager, args, customViewName)
                        .then(function (id) {
                        // Redirect user
                        Utils.redirect(manager.getUrls().getShowCardUrl(id, CardView.CardTypeEnum.VIEW));
                        deferred.resolve();
                    })
                        .fail(function () {
                        Kasina.messages.get().error(manager.getStrings().getErrorSavingMessage());
                        _this.hideLoadingScreen(args);
                        deferred.reject();
                    });
                })
                    .fail(function () {
                    args.reportView.showErrorMessage();
                });
                this.triggerAnalyticsEvent();
            };
            return CreateCardAction;
        }(SaveAction));
        var SaveCardTemplate = (function (_super) {
            __extends(SaveCardTemplate, _super);
            function SaveCardTemplate() {
                _super.apply(this, arguments);
            }
            SaveCardTemplate.prototype.getType = function () {
                return Actions.ActionType.SAVE_TEMPLATE;
            };
            SaveCardTemplate.prototype.isAvailable = function (manager) {
                return manager.getCardMetadata().isTemplate();
            };
            SaveCardTemplate.prototype.triggerAnalyticsEvent = function () {
                Analytics.registerNewCardSavedEvent();
            };
            return SaveCardTemplate;
        }(CreateCardAction));
        Actions.SaveCardTemplate = SaveCardTemplate;
        var CopyCard = (function (_super) {
            __extends(CopyCard, _super);
            function CopyCard() {
                _super.apply(this, arguments);
            }
            CopyCard.prototype.getType = function () {
                return Actions.ActionType.COPY;
            };
            CopyCard.prototype.isAvailable = function (manager) {
                return manager.getCardMetadata().isView();
            };
            CopyCard.prototype.triggerAnalyticsEvent = function () {
                Analytics.registerSaveACardCopyEvent();
            };
            return CopyCard;
        }(CreateCardAction));
        Actions.CopyCard = CopyCard;
        var SaveCardView = (function (_super) {
            __extends(SaveCardView, _super);
            function SaveCardView() {
                _super.apply(this, arguments);
            }
            SaveCardView.prototype.getType = function () {
                return Actions.ActionType.SAVE_VIEW;
            };
            SaveCardView.prototype.isAvailable = function (manager, args) {
                return manager.getCardMetadata().isView();
            };
            SaveCardView.prototype.parseSaveResponse = function (content) {
                return;
            };
            SaveCardView.prototype.getCardserviceUrl = function (manager) {
                return manager.getUrls().getUpdateCardUrl();
            };
            SaveCardView.prototype.createSavePayload = function (manager, args, customViewName) {
                var payload = _super.prototype.createSavePayload.call(this, manager, args, customViewName);
                return {
                    categoricalFilters: payload.categoricalFilters,
                    categoricalSalesFilters: payload.categoricalSalesFilters,
                    cardId: manager.getProperties().getCardId(),
                    customViewName: payload.customViewName || manager.getProperties().getCustomView(),
                    parameters: payload.parameters,
                    title: payload.title
                };
            };
            SaveCardView.prototype.deleteOldReport = function (args, currentCustomView, oldCustomView) {
                if (currentCustomView !== oldCustomView) {
                    return args.report.deleteView(oldCustomView);
                }
                var deferred = jQuery.Deferred();
                deferred.resolve();
                return deferred.promise();
            };
            /**
             * Creates a new report view if it has been customized, otherwise it will only use the current one
             * @param  {LoadInfo.Manager}      manager
             * @param  {ActionArgs}            args
             * @return {JQueryPromise<string>}
             */
            SaveCardView.prototype.saveReport = function (manager, args) {
                if (args.reportView.isCustomized() || args.isPropertiesManagerCustomized()) {
                    return _super.prototype.saveReport.call(this, manager, args);
                }
                var deferred = jQuery.Deferred();
                deferred.resolveWith(window, [null]);
                return deferred.promise();
            };
            SaveCardView.prototype.execute = function (deferred, manager, args) {
                var _this = this;
                // Attach loading screen
                this.showLoadingScreen(args);
                var oldCustomView = manager.getProperties().getCustomView();
                this.saveReport(manager, args)
                    .then(function (customViewName) {
                    _this.saveCard(manager, args, customViewName)
                        .then(function () {
                        // Delete old view
                        _this.deleteOldReport(args, manager.getProperties().getCustomView(), oldCustomView)
                            .fail(function () {
                            console.log('Could not delete old custom view...', oldCustomView);
                        })
                            .always(function () {
                            _this.hideLoadingScreen(args);
                            deferred.resolve();
                        });
                    })
                        .fail(function () {
                        Kasina.messages.get().error(manager.getStrings().getErrorSavingMessage());
                        _this.hideLoadingScreen(args);
                        deferred.reject();
                    });
                })
                    .fail(function () {
                    args.reportView.showErrorMessage();
                });
                this.triggerAnalyticsEvent();
            };
            SaveCardView.prototype.triggerAnalyticsEvent = function () {
                Analytics.registerEditedCardSavedEvent();
            };
            return SaveCardView;
        }(SaveAction));
        Actions.SaveCardView = SaveCardView;
        var SaveSharedCard = (function (_super) {
            __extends(SaveSharedCard, _super);
            function SaveSharedCard() {
                _super.apply(this, arguments);
            }
            SaveSharedCard.prototype.getType = function () {
                return Actions.ActionType.SAVE_SHARED;
            };
            SaveSharedCard.prototype.isAvailable = function (manager, args) {
                var cardData = manager.getCardMetadata();
                return cardData.isSharedCard() && !cardData.isCreator();
            };
            SaveSharedCard.prototype.parseSaveResponse = function (content) {
                return Number(content);
            };
            SaveSharedCard.prototype.createSavePayload = function (manager, args, customViewName) {
                var payload = _super.prototype.createSavePayload.call(this, manager, args, customViewName);
                return {
                    categoricalFilters: payload.categoricalFilters,
                    categoricalSalesFilters: payload.categoricalSalesFilters,
                    customViewName: payload.customViewName,
                    parameters: payload.parameters,
                    templateId: manager.getCardMetadata().getTemplateId(),
                    title: payload.title,
                    sharedCard: manager.getProperties().getCardId()
                };
            };
            SaveSharedCard.prototype.getCardserviceUrl = function (manager) {
                return manager.getUrls().getCreateShareeCardUrl();
            };
            SaveSharedCard.prototype.triggerAnalyticsEvent = function () {
                Analytics.registerSharedCardSavedEvent();
            };
            SaveSharedCard.prototype.execute = function (deferred, manager, args) {
                var _this = this;
                // Attach loading screen
                this.showLoadingScreen(args);
                // Create new report custom view
                this.saveReport(manager, args)
                    .then(function (customViewName) {
                    // Call service to copy card
                    _this.saveCard(manager, args, customViewName)
                        .then(function (id) {
                        // Redirect user
                        Utils.redirect(manager.getUrls().getShowCardUrl(id, CardView.CardTypeEnum.VIEW));
                        deferred.resolve();
                    })
                        .fail(function () {
                        Kasina.messages.get().error(manager.getStrings().getErrorSavingMessage());
                        _this.hideLoadingScreen(args);
                        deferred.reject();
                    });
                })
                    .fail(function () {
                    args.reportView.showErrorMessage();
                });
                this.triggerAnalyticsEvent();
            };
            return SaveSharedCard;
        }(SaveAction));
        Actions.SaveSharedCard = SaveSharedCard;
    })(Actions = CardView.Actions || (CardView.Actions = {}));
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var Actions;
    (function (Actions) {
        var DeleteCardModal = (function () {
            function DeleteCardModal(wrapper) {
                this.wrapper = wrapper;
                this.wrapper.data('backdrop', 'static');
                this.confirmationButton = this.wrapper.find('.btn.confirmation-response');
                this.state = true;
                this.addEventListeners();
            }
            DeleteCardModal.prototype.refresh = function () {
                this.confirmationButton.prop(DeleteCardModal.DISABLED_PROPERTY, !this.state);
            };
            DeleteCardModal.prototype.enableChanges = function () {
                this.state = true;
                this.refresh();
            };
            DeleteCardModal.prototype.disableChanges = function () {
                this.state = false;
                this.refresh();
            };
            DeleteCardModal.prototype.addEventListeners = function () {
                var _this = this;
                this.wrapper
                    .on('hidden.bs.modal', function () {
                    if (_this.state) {
                        _this.enableChanges();
                        _this.target.deferred.resolve();
                    }
                });
                this.confirmationButton.click(function () {
                    _this.disableChanges();
                    _this.deleteCard();
                });
            };
            DeleteCardModal.prototype.deleteCard = function () {
                var _this = this;
                jQuery.ajax({
                    'method': 'POST',
                    'url': this.target.urls.getDeleteCardUrl(),
                    'data': {
                        'id': this.target.cardId
                    }
                })
                    .then(function () {
                    Analytics.registerCardDeletionEvent();
                    _this.target.report.deleteView(_this.target.customViewName).always(function () {
                        location.href = _this.target.urls.getUserDashboardUrl();
                    });
                })
                    .fail(function () {
                    Kasina.messages.get().error(_this.target.strings.getErrorDeletingMessage());
                    _this.target.deferred.reject();
                    _this.enableChanges();
                    _this.hide();
                });
            };
            DeleteCardModal.prototype.hide = function () {
                this.wrapper.modal('hide');
            };
            DeleteCardModal.prototype.show = function (target) {
                this.target = target;
                this.wrapper.modal("show");
            };
            DeleteCardModal.DISABLED_PROPERTY = 'disabled';
            return DeleteCardModal;
        }());
        var DeleteCardView = (function () {
            function DeleteCardView() {
                this.modal = null;
            }
            DeleteCardView.prototype.getType = function () {
                return Actions.ActionType.DELETE;
            };
            DeleteCardView.prototype.isAvailable = function (manager) {
                return manager.getCardMetadata().isCreator();
            };
            DeleteCardView.prototype.initialize = function () {
                if (this.modal !== null) {
                    return;
                }
                this.modal = new DeleteCardModal($('#cardDeleteModal'));
            };
            DeleteCardView.prototype.execute = function (deferred, manager, args) {
                // Initialize  modal
                this.initialize();
                // Set target and show modal
                this.modal.show({
                    cardId: manager.getProperties().getCardId(),
                    customViewName: manager.getProperties().getCustomView(),
                    deferred: deferred,
                    report: args.report,
                    urls: manager.getUrls(),
                    strings: manager.getStrings()
                });
            };
            return DeleteCardView;
        }());
        Actions.DeleteCardView = DeleteCardView;
    })(Actions = CardView.Actions || (CardView.Actions = {}));
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var Actions;
    (function (Actions) {
        var CancelCard = (function () {
            function CancelCard() {
            }
            CancelCard.prototype.getType = function () {
                return Actions.ActionType.CANCEL;
            };
            CancelCard.prototype.isAvailable = function (manager) {
                return manager.getCardMetadata().isTemplate();
            };
            CancelCard.prototype.execute = function (deferred, manager) {
                Analytics.registerCardChangesCancellationEvent();
                Utils.redirect(manager.getUrls().getUserDashboardUrl());
            };
            return CancelCard;
        }());
        Actions.CancelCard = CancelCard;
        var NewCard = (function () {
            function NewCard() {
            }
            NewCard.prototype.getType = function () {
                return Actions.ActionType.NEW;
            };
            NewCard.prototype.isAvailable = function (manager) {
                return manager.getCardMetadata().isView() || manager.getCardMetadata().isSharedCard();
            };
            NewCard.prototype.execute = function (deferred, manager) {
                Analytics.registerCardChangesCancellationEvent();
                Utils.redirect(manager.getUrls().getTemplatesDashboardUrl());
            };
            return NewCard;
        }());
        Actions.NewCard = NewCard;
    })(Actions = CardView.Actions || (CardView.Actions = {}));
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var Actions;
    (function (Actions) {
        var ExportSheetAction = (function () {
            function ExportSheetAction() {
            }
            ExportSheetAction.prototype.isAvailable = function (manager, args) {
                return args.report.exports(this.getExportType());
            };
            ExportSheetAction.prototype.execute = function (deferred, manager, args) {
                var exportLabel = CardView.ExportType[this.getExportType()];
                args.reportView.showLoadingScreen();
                args.report.exportSheet(this.getExportType(), args.title)
                    .then(function () {
                    setTimeout(function () {
                        deferred.resolve();
                    }, 300);
                })
                    .fail(function () {
                    args.reportView.showErrorMessage();
                    setTimeout(function () {
                        deferred.reject();
                    }, 300);
                })
                    .always(function () {
                    setTimeout(function () {
                        args.reportView.hideLoadingScreen();
                        Analytics.eventDownloadReport(args.report.getName(), exportLabel);
                    }, 200);
                });
            };
            return ExportSheetAction;
        }());
        var ExportSheetPNG = (function (_super) {
            __extends(ExportSheetPNG, _super);
            function ExportSheetPNG() {
                _super.apply(this, arguments);
            }
            ExportSheetPNG.prototype.getType = function () {
                return Actions.ActionType.EXPORT_PNG;
            };
            ExportSheetPNG.prototype.getExportType = function () {
                return CardView.ExportType.PNG;
            };
            return ExportSheetPNG;
        }(ExportSheetAction));
        Actions.ExportSheetPNG = ExportSheetPNG;
        var ExportSheetCSV = (function (_super) {
            __extends(ExportSheetCSV, _super);
            function ExportSheetCSV() {
                _super.apply(this, arguments);
            }
            ExportSheetCSV.prototype.getType = function () {
                return Actions.ActionType.EXPORT_CSV;
            };
            ExportSheetCSV.prototype.getExportType = function () {
                return CardView.ExportType.CSV;
            };
            return ExportSheetCSV;
        }(ExportSheetAction));
        Actions.ExportSheetCSV = ExportSheetCSV;
    })(Actions = CardView.Actions || (CardView.Actions = {}));
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var Actions;
    (function (Actions) {
        var ToggleVisualization = (function () {
            function ToggleVisualization() {
            }
            ToggleVisualization.prototype.getType = function () {
                return Actions.ActionType.TOGGLE;
            };
            ToggleVisualization.getSheet = function (manager) {
                var env = manager.getEnvironmentProperties().getEnvironmentType();
                return manager.getCardMetadata().getReportMetadata().getSheetByEnvironment(env);
            };
            ToggleVisualization.prototype.isAvailable = function (manager, args) {
                var report = args.report;
                var sheet = ToggleVisualization.getSheet(manager);
                return report.sheetExists(sheet.getChartSheetName()) && report.sheetExists(sheet.getDataTableSheetName());
            };
            ToggleVisualization.prototype.initialize = function (manager, args) {
                this.sheet = ToggleVisualization.getSheet(manager);
                this.activeSheet = args.report.getActiveSheetName();
            };
            ToggleVisualization.prototype.execute = function (deferred, manager, args) {
                var _this = this;
                var sheet = this.sheet;
                var nextSheet = this.activeSheet === sheet.getChartSheetName() ? sheet.getDataTableSheetName() : sheet.getChartSheetName();
                args.reportView.showLoadingScreen();
                args.report.activateSheet(nextSheet)
                    .then(function () {
                    _this.activeSheet = nextSheet;
                    args.reportView.hideLoadingScreen();
                    deferred.resolve();
                })
                    .fail(function () {
                    args.reportView.showErrorMessage();
                    deferred.reject();
                });
                Analytics.registerCardToggleVisualizationEvent();
            };
            return ToggleVisualization;
        }());
        Actions.ToggleVisualization = ToggleVisualization;
    })(Actions = CardView.Actions || (CardView.Actions = {}));
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var Actions;
    (function (Actions) {
        var ResetCard = (function () {
            function ResetCard() {
            }
            ResetCard.prototype.getType = function () {
                return Actions.ActionType.RESET;
            };
            ResetCard.prototype.isAvailable = function () {
                return true;
            };
            ResetCard.prototype.applyParameter = function (report, parameterName, parameterValue) {
                return report.applyParameter(parameterName, parameterValue);
            };
            ResetCard.prototype.applyFilter = function (report, filterName, columnName, options) {
                return report.applyCategoricalFilter(filterName, columnName, options);
            };
            ResetCard.prototype.applySalesFilter = function (report, filterName, min, max) {
                return report.applySalesFilter(filterName, min, max);
            };
            ResetCard.prototype.execute = function (deferred, manager, args) {
                var _this = this;
                args.reportView.showLoadingScreen();
                args.report.pauseUpdates().then(function () {
                    var report = args.report;
                    var payload = args.getPropertiesResetPayload();
                    var parameters = payload.parameters;
                    var categoricalFilters = payload.categoricalFilters;
                    var columnFilters = payload.columnFilters;
                    var categoricalSalesFilters = payload.categoricalSalesFilters;
                    var promises = new Array();
                    // Parameters
                    Object.keys(parameters).forEach(function (parameterName) {
                        promises.push(_this.applyParameter(report, parameterName, parameters[parameterName]));
                    });
                    // Filters
                    Object.keys(categoricalFilters).forEach(function (filterName) {
                        promises.push(_this.applyFilter(report, filterName, columnFilters[filterName], categoricalFilters[filterName]));
                    });
                    // SalesFilters
                    categoricalSalesFilters.forEach(function (salesFilter) {
                        var filterName = salesFilter.getName();
                        var salesType = salesFilter.getSalesType();
                        var min = null;
                        var max = null;
                        if (salesFilter.wasInitiallyApplied()) {
                            min = salesFilter.getInitialOptions().min;
                            max = salesFilter.getInitialOptions().max;
                            if (salesType !== CardView.SalesCategoricalFilterFormatter.NEGATIVE_TYPE &&
                                max !== null &&
                                Number(min) <= 0 &&
                                Number(max) <= 0) {
                                max = CardView.SalesCategoricalFilterFormatter.NEGATIVE_MASK;
                            }
                        }
                        promises.push(_this.applySalesFilter(report, filterName, min, max));
                    });
                    if (args.reportView.isCustomized()) {
                        promises.push(args.report.reset());
                    }
                    jQuery.when.apply(promises).then(function () {
                        args.report.resumeUpdates()
                            .then(function () {
                            args.resetPropertiesManager();
                            args.resetTitle();
                            args.reportView.hideLoadingScreen();
                            deferred.resolve();
                        })
                            .fail(function () {
                            args.reportView.showErrorMessage();
                            deferred.reject();
                        });
                    })
                        .fail(function () {
                        args.reportView.showErrorMessage();
                        deferred.reject();
                    });
                })
                    .fail(function () {
                    args.reportView.showErrorMessage();
                    deferred.reject();
                });
                Analytics.registerCardResetEvent();
            };
            return ResetCard;
        }());
        Actions.ResetCard = ResetCard;
    })(Actions = CardView.Actions || (CardView.Actions = {}));
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var Actions;
    (function (Actions) {
        var BreadCrumbCrawl = (function () {
            function BreadCrumbCrawl() {
            }
            BreadCrumbCrawl.prototype.getType = function () {
                return Actions.ActionType.CRUMB_CRAWL;
            };
            BreadCrumbCrawl.prototype.isAvailable = function () {
                return true;
            };
            BreadCrumbCrawl.prototype.execute = function (deferred, manager, args) {
                args.report.activateBreadcrumbSheet(args.lastSelectedCrumb === BreadCrumbCrawl.OFFICE ? BreadCrumbCrawl.OFFICE_DEEP_DIVE : args.lastSelectedCrumb)
                    .then(function () {
                    deferred.resolve();
                })
                    .fail(function () {
                    deferred.reject();
                });
            };
            BreadCrumbCrawl.OFFICE_DEEP_DIVE = 'OfficeDeepDive';
            BreadCrumbCrawl.OFFICE = 'Office';
            return BreadCrumbCrawl;
        }());
        Actions.BreadCrumbCrawl = BreadCrumbCrawl;
    })(Actions = CardView.Actions || (CardView.Actions = {}));
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var Actions;
    (function (Actions) {
        var ApplyAction = (function () {
            function ApplyAction() {
            }
            ApplyAction.prototype.isAvailable = function () {
                return true;
            };
            ApplyAction.prototype.execute = function (deferred, manager, args) {
                var _this = this;
                args.reportView.showLoadingScreen();
                this.performApply(args.report, args.args)
                    .then(function () {
                    deferred.resolve();
                })
                    .fail(function () {
                    deferred.reject();
                })
                    .always(function () {
                    if (_this.hiddingLoadingScreen(args.args)) {
                        args.reportView.hideLoadingScreen();
                    }
                });
            };
            return ApplyAction;
        }());
        var ApplyCardParameter = (function (_super) {
            __extends(ApplyCardParameter, _super);
            function ApplyCardParameter() {
                _super.apply(this, arguments);
            }
            ApplyCardParameter.prototype.getType = function () {
                return Actions.ActionType.APPLY_PARAMETER;
            };
            ApplyCardParameter.prototype.hiddingLoadingScreen = function (args) {
                return true;
            };
            ApplyCardParameter.prototype.performApply = function (report, args) {
                var parameterName = args.first();
                var parameterValue = args.last();
                return report.applyParameter(parameterName, parameterValue);
            };
            return ApplyCardParameter;
        }(ApplyAction));
        Actions.ApplyCardParameter = ApplyCardParameter;
        var ApplyCardFilter = (function (_super) {
            __extends(ApplyCardFilter, _super);
            function ApplyCardFilter() {
                _super.apply(this, arguments);
            }
            ApplyCardFilter.prototype.getType = function () {
                return Actions.ActionType.APPLY_FILTER;
            };
            ApplyCardFilter.prototype.hiddingLoadingScreen = function (args) {
                return true;
            };
            ApplyCardFilter.prototype.performApply = function (report, args) {
                var filterName = args[0];
                var columnName = args[1];
                var filterOptions = args[2];
                return report.applyCategoricalFilter(filterName, columnName, filterOptions);
            };
            return ApplyCardFilter;
        }(ApplyAction));
        Actions.ApplyCardFilter = ApplyCardFilter;
        var ApplyCardSalesFilter = (function (_super) {
            __extends(ApplyCardSalesFilter, _super);
            function ApplyCardSalesFilter() {
                _super.apply(this, arguments);
            }
            ApplyCardSalesFilter.prototype.getType = function () {
                return Actions.ActionType.APPLY_SALES_FILTER;
            };
            ApplyCardSalesFilter.prototype.hiddingLoadingScreen = function (args) {
                var filterName = args[0], min = args[1], max = args[2];
                return filterName !== null && min !== null && max !== null;
            };
            ApplyCardSalesFilter.prototype.performApply = function (report, args) {
                var filterName = args[0], min = args[1], max = args[2];
                return report.applySalesFilter(filterName, min, max);
            };
            return ApplyCardSalesFilter;
        }(ApplyAction));
        Actions.ApplyCardSalesFilter = ApplyCardSalesFilter;
    })(Actions = CardView.Actions || (CardView.Actions = {}));
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var Actions;
    (function (Actions) {
        var PublishCardModal = (function () {
            function PublishCardModal(manager, report, deferred) {
                this.manager = manager;
                this.report = report;
                this.deferred = deferred;
                this.modalWrapper = null;
                this.isRequesting = false;
                this.progress = 0;
            }
            PublishCardModal.prototype.getCardId = function () {
                return this.manager.getProperties().getCardId();
            };
            PublishCardModal.prototype.getPublishModalHtml = function () {
                return jQuery.get(this.manager.getUrls().getPublishCardModalUrl(this.getCardId()));
            };
            PublishCardModal.prototype.show = function () {
                var _this = this;
                this.getPublishModalHtml()
                    .then(function (content) {
                    _this.modalWrapper = jQuery(content);
                    _this.lockedCheckbox = _this.modalWrapper.find('input.is-locked-checkbox');
                    _this.rolesCheckboxes = _this.modalWrapper.find('input.role-checkbox');
                    _this.modalFooter = _this.modalWrapper.find('.modal-footer');
                    _this.alert = _this.modalFooter.children('.alert');
                    _this.modalButtons = _this.modalFooter.find('button');
                    _this.confirmationButton = _this.modalButtons.filter('.confirmation-response');
                    _this.progressBarWrapper = _this.modalWrapper.find('.progress');
                    _this.progressBar = _this.progressBarWrapper.children();
                    _this.selectAllButton = _this.modalWrapper.find('.select-all');
                    _this.selectNoneButton = _this.modalWrapper.find('.select-none');
                    // Append modal to document
                    $('body').append(_this.modalWrapper);
                    _this.addEventListeners();
                    // Turn it into a functional modal (bootstrap made)
                    _this.modalWrapper.modal();
                })
                    .fail(function () {
                    _this.deferred.reject();
                });
            };
            PublishCardModal.prototype.refreshProgressBar = function () {
                this.progressBar.attr('aria-valuenow', this.progress);
                this.progressBar.css('width', this.progress + '%');
            };
            PublishCardModal.prototype.reset = function () {
                this.progressBar.removeClass(PublishCardModal.PROGRESSBAR_ERROR_CSSCLASS);
                this.alert.addClass(PublishCardModal.HIDDEN_CSS_CLASS);
            };
            PublishCardModal.prototype.refreshControlsAvailability = function () {
                var DISABLED_PROP = PublishCardModal.DISABLED_PROP;
                this.lockedCheckbox.prop(DISABLED_PROP, this.isRequesting);
                this.rolesCheckboxes.prop(DISABLED_PROP, this.isRequesting);
                this.selectAllButton.prop(DISABLED_PROP, this.isRequesting);
                this.selectNoneButton.prop(DISABLED_PROP, this.isRequesting);
            };
            PublishCardModal.prototype.getPublishCardPayLoad = function () {
                var ids = new Array();
                var checkedBoxes = this.rolesCheckboxes.filter(':checked');
                checkedBoxes.each(function (k) {
                    ids.push(checkedBoxes.eq(k).data('id'));
                });
                return {
                    cardId: this.manager.getProperties().getCardId(),
                    lock: this.lockedCheckbox.prop('checked'),
                    roles: ids
                };
            };
            ;
            PublishCardModal.prototype.persistPublishedCard = function () {
                var service = jQuery.ajax({
                    'method': 'POST',
                    'url': this.manager.getUrls().getPublishCardUrl(),
                    'data': JSON.stringify(this.getPublishCardPayLoad()),
                    'contentType': 'application/json',
                    'dataType': 'json'
                });
                return service.promise();
            };
            PublishCardModal.prototype.publishCard = function () {
                var _this = this;
                if (this.isRequesting) {
                    return;
                }
                this.isRequesting = true;
                var deferred = jQuery.Deferred();
                // Resets components previous progress
                this.progress = 40;
                this.refreshProgressBar();
                this.reset();
                // Disables all checkboxes
                this.refreshControlsAvailability();
                // Calls publish card service
                this.persistPublishedCard()
                    .always(function () {
                    _this.progress += 60;
                    _this.refreshProgressBar();
                })
                    .then(function () {
                    deferred.resolve();
                })
                    .fail(function () {
                    deferred.reject();
                });
                deferred
                    .always(function () {
                    _this.isRequesting = false;
                    _this.refreshControlsAvailability();
                })
                    .then(function () {
                    _this.modalWrapper.modal('hide');
                })
                    .fail(function () {
                    _this.alert.removeClass(PublishCardModal.HIDDEN_CSS_CLASS);
                    _this.progressBar.addClass(PublishCardModal.PROGRESSBAR_ERROR_CSSCLASS);
                });
                Analytics.registerPublishCardEvent();
            };
            PublishCardModal.prototype.addEventListeners = function () {
                var _this = this;
                this.modalWrapper.one('hidden.bs.modal', function () {
                    _this.modalWrapper.remove();
                    _this.deferred.resolve();
                });
                this.modalWrapper.one('shown.bs.modal', function () {
                    // Setting progressbar width
                    var allowedWidth = 0;
                    _this.modalButtons.each(function (k, button) { allowedWidth += _this.modalButtons.eq(k).outerWidth(); });
                    allowedWidth = _this.modalFooter.width() - PublishCardModal.FOOTER_PADDING - allowedWidth;
                    _this.progressBarWrapper.css('min-width', allowedWidth + 'px');
                });
                // Role selection helper buttons
                this.selectAllButton.click(function () { _this.setAllCheckBoxesState(true); });
                this.selectNoneButton.click(function () { _this.setAllCheckBoxesState(false); });
                this.confirmationButton.click(function () {
                    _this.publishCard();
                });
            };
            PublishCardModal.prototype.setAllCheckBoxesState = function (state) {
                this.modalWrapper.find('input.role-checkbox').prop('checked', state);
            };
            PublishCardModal.DISABLED_PROP = 'disabled';
            PublishCardModal.PROGRESSBAR_ERROR_CSSCLASS = 'progress-bar-danger';
            PublishCardModal.HIDDEN_CSS_CLASS = 'hidden';
            PublishCardModal.FOOTER_PADDING = 20;
            return PublishCardModal;
        }());
        var PublishCard = (function () {
            function PublishCard() {
            }
            PublishCard.prototype.getType = function () {
                return Actions.ActionType.PUBLISH;
            };
            PublishCard.prototype.isAvailable = function (manager) {
                return manager.getCardMetadata().isViewPublishable();
            };
            PublishCard.prototype.execute = function (deferred, manager, args) {
                var modal = new PublishCardModal(manager, args.report, deferred);
                modal.show();
            };
            return PublishCard;
        }());
        Actions.PublishCard = PublishCard;
        var DeletePublishedCard = (function () {
            function DeletePublishedCard() {
            }
            DeletePublishedCard.prototype.getType = function () {
                return Actions.ActionType.DELETE_PUBLISHED;
            };
            DeletePublishedCard.prototype.isAvailable = function (manager) {
                var data = manager.getCardMetadata();
                return data.isViewPublished() && data.isCreator() && !data.isPublishedViewLocked();
            };
            DeletePublishedCard.prototype.execute = function (deferred, manager, args) {
                var urls = manager.getUrls();
                // Deleting unlocked card
                jQuery.ajax({
                    'method': 'POST',
                    'url': urls.getExcludePublishedCardUrl(),
                    'data': JSON.stringify(manager.getCardMetadata().getPublishedCardId()),
                    'contentType': 'application/json',
                    'dataType': 'json'
                })
                    .then(function () {
                    deferred.resolve();
                    location.href = manager.getUrls().getUserDashboardUrl();
                })
                    .fail(function () {
                    deferred.reject();
                });
            };
            return DeletePublishedCard;
        }());
        Actions.DeletePublishedCard = DeletePublishedCard;
    })(Actions = CardView.Actions || (CardView.Actions = {}));
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var SalesContextManager = (function () {
        function SalesContextManager() {
            this.input = {
                focusDimension: null,
                salesDimensions: null,
                targetDimension: null
            };
            this.salesContext = new SalesContext.SalesContext();
        }
        SalesContextManager.getInstance = function () {
            if (!SalesContextManager.instance) {
                SalesContextManager.instance = new SalesContextManager();
            }
            return SalesContextManager.instance;
        };
        SalesContextManager.prototype.getSalesContext = function (input) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.setInput(input);
            this.salesContext.salesContextRequest(this.input).then(function (response) {
                deferred.resolveWith(window, [response]);
            }).fail(function () {
                deferred.reject();
            });
            return promise;
        };
        SalesContextManager.prototype.setInput = function (input) {
            var dimensions = this.getDimensionsInput();
            this.input.focusDimension = input.focusDimension;
            this.input.salesDimensions = input.salesDimensions;
            this.input.targetDimension = input.targetDimension;
            this.input.dimensions = dimensions;
            dimensions.sort(function (curr, next) { return curr.id - next.id; });
            dimensions.forEach(function (dimension) {
                if (dimension.options) {
                    dimension.options.sort(function (curr, next) { return curr.formattedValue > next.formattedValue ? 1 : -1; });
                }
            });
        };
        SalesContextManager.prototype.addDimensionInput = function (dimensionInput) {
            this.dimensions.push(dimensionInput);
        };
        SalesContextManager.prototype.clearDimensionList = function () {
            this.dimensions = new Array();
        };
        SalesContextManager.prototype.setDimensionsInput = function (dimensions) {
            this.dimensions = dimensions;
        };
        SalesContextManager.prototype.getDimensionsInput = function () {
            return this.dimensions;
        };
        return SalesContextManager;
    }());
    CardView.SalesContextManager = SalesContextManager;
    var ContextManager = (function () {
        function ContextManager() {
            this.filters = null;
            this.contextServicePromises = {};
        }
        ContextManager.getContextOptions = function (dimensions) {
            return Context.getOptionsFor({ dimensions: Context.buildDimensions(dimensions), optionsLimit: Context.CONSTANTS.SERVER_SIDE_OPTIONS_LIMIT });
        };
        ContextManager.prototype.generateSelectOptionsInput = function (filter) {
            var dimensionId = filter.getDimensionId();
            var options = filter.getAppliedValue();
            var optionsName = null;
            var selectedOptions = null;
            this.salesContextManager = SalesContextManager.getInstance();
            var cacheKey = dimensionId.toString();
            if (filter.hasApplyOrder() && Array.isArray(options)) {
                selectedOptions = [];
                optionsName = [];
                options.forEach(function (option) {
                    if (!option.selected) {
                        return;
                    }
                    selectedOptions.push({ formattedValue: option.label, value: option.id });
                    optionsName.push(option.label);
                });
                optionsName = optionsName.sort();
            }
            cacheKey += '[' + optionsName + ']';
            return {
                cacheKey: cacheKey,
                dimension: {
                    id: filter.getDimensionId(),
                    options: selectedOptions
                }
            };
        };
        ContextManager.prototype.generateContextInput = function () {
            var _this = this;
            var cacheKey = '';
            var input = new Array();
            this.filters.forEach(function (filter) {
                var optionsInput = _this.generateSelectOptionsInput(filter);
                cacheKey += optionsInput.cacheKey;
                input.push(optionsInput.dimension);
            });
            return {
                cacheKey: cacheKey,
                dimensions: input
            };
        };
        ContextManager.prototype.setFilters = function (filters) {
            this.filters = filters.slice(0).sort(function (curr, next) { return curr.getDimensionId() - next.getDimensionId(); });
        };
        ContextManager.prototype.getContext = function (dimensionId) {
            var deferred = jQuery.Deferred();
            var input = this.generateContextInput();
            this.salesContextManager.clearDimensionList();
            this.salesContextManager.setDimensionsInput(input.dimensions);
            this.contextServicePromises[input.cacheKey] = this.contextServicePromises[input.cacheKey] || ContextManager.getContextOptions(input.dimensions);
            this.contextServicePromises[input.cacheKey].success(function (response) {
                var match = response.single(function (dimension) { return dimension.id() === dimensionId; }) || null;
                if (match === null) {
                    deferred.reject();
                    return;
                }
                var rawOptions = match.options();
                var options = rawOptions === null ? null : rawOptions.map(ContextManager.toCardViewReportFilterOptionInfo);
                deferred.resolveWith(window, [options]);
            })
                .fail(function () {
                deferred.reject();
            });
            return deferred.promise();
        };
        ContextManager.toCardViewReportFilterOptionInfo = function (option) {
            return { id: option.value, label: option.formattedValue, selected: true };
        };
        return ContextManager;
    }());
    CardView.ContextManager = ContextManager;
    var HierarchicalFilterGroup = (function () {
        function HierarchicalFilterGroup(filters, permissions, templatePermissions, templateTitle) {
            var _this = this;
            this.filters = [];
            this.childGroup = null;
            this.contextualizedFilters = null;
            this.permissions = permissions;
            this.templatePermissions = templatePermissions;
            this.templateTitle = templateTitle;
            this.salesContextManager = SalesContextManager.getInstance();
            if (filters.isEmpty()) {
                return;
            }
            // Couldnt help myself :)
            var firstOrder = filters.first().getApplyOrder();
            var alliance = new Array();
            filters.forEach(function (filter) {
                if (filter.getApplyOrder() === firstOrder) {
                    _this.filters.push(filter);
                }
                else {
                    alliance.push(filter);
                }
            });
            if (alliance.isEmpty()) {
                return;
            }
            this.childGroup = new HierarchicalFilterGroup(alliance, permissions, templatePermissions, templateTitle);
        }
        HierarchicalFilterGroup.prototype.getChildGroup = function () {
            return this.childGroup;
        };
        HierarchicalFilterGroup.prototype.hasChild = function () {
            return this.getChildGroup() !== null;
        };
        HierarchicalFilterGroup.prototype.getContextualizedOptions = function () {
            var indexed = {};
            this.contextualizedFilters.forEach(function (filter) {
                indexed[filter.getDimensionId()] = filter.getSelectedOptions();
            });
            return indexed;
        };
        HierarchicalFilterGroup.prototype.bindFiltersWithResponse = function (response) {
            var _this = this;
            var indexedResponse = {};
            response.forEach(function (dimension) {
                indexedResponse[dimension.id()] = dimension;
            });
            this.contextualizedFilters = new Array();
            this.filters.forEach(function (filter) {
                if (indexedResponse[filter.getDimensionId()]) {
                    _this.contextualizedFilters.push(new CardView.CardViewReportFilterInfo(filter, indexedResponse[filter.getDimensionId()]));
                }
            });
        };
        HierarchicalFilterGroup.prototype.getContextualizedFilters = function () {
            return this.contextualizedFilters;
        };
        HierarchicalFilterGroup.prototype.retrieveContext = function (previousFilter) {
            var _this = this;
            var dimensionsInput = new Array();
            var isAltOnly = false;
            var hasAltDeepDive = false;
            var isDeepDive = false;
            if (this.permissions.contains('Alts Only')) {
                isAltOnly = true;
            }
            if (this.templatePermissions.contains('Alternatives-Deep Dive') && this.permissions.contains('Alternatives')) {
                hasAltDeepDive = true;
            }
            if (this.templateTitle === 'OfficeDeepDive') {
                isDeepDive = true;
            }
            Object.keys(previousFilter).forEach(function (key) {
                var dimensionId = Number(key);
                if (isAltOnly && previousFilter[dimensionId].isEmpty()) {
                    dimensionsInput.push({
                        id: dimensionId,
                        options: [{
                                formattedValue: '0',
                                value: 0
                            }]
                    });
                }
                else {
                    dimensionsInput.push({
                        id: dimensionId,
                        options: previousFilter[dimensionId]
                    });
                }
            });
            if (isDeepDive) {
                this.filters.forEach(function (filter) {
                    if (!hasAltDeepDive) {
                        if (!filter.getColumnName().contains('alt_')) {
                            dimensionsInput.push({
                                id: filter.getDimensionId()
                            });
                        }
                    }
                    else if (isAltOnly) {
                        if (filter.getColumnName().contains('alt_')) {
                            dimensionsInput.push({
                                id: filter.getDimensionId()
                            });
                        }
                    }
                    else {
                        dimensionsInput.push({
                            id: filter.getDimensionId()
                        });
                    }
                });
            }
            else {
                this.filters.forEach(function (filter) {
                    dimensionsInput.push({
                        id: filter.getDimensionId()
                    });
                });
            }
            var deferred = jQuery.Deferred();
            this.salesContextManager.clearDimensionList();
            this.salesContextManager.setDimensionsInput(dimensionsInput);
            ContextManager.getContextOptions(dimensionsInput).success(function (response) {
                _this.bindFiltersWithResponse(response);
                deferred.resolve();
            })
                .fail(function () {
                deferred.reject();
            });
            return deferred.promise();
        };
        return HierarchicalFilterGroup;
    }());
    CardView.HierarchicalFilterGroup = HierarchicalFilterGroup;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var PropertiesManager = (function () {
        function PropertiesManager(options) {
            this.info = options.info;
            this.categoricalFilters = [];
            this.salesCategoricalFilter = [];
            this.parameters = [];
            this.parameterApplyHandlers = new ListenersCollection();
            this.filtersApplyHandlers = new ListenersCollection();
            this.salesFiltersApplyHandlers = new ListenersCollection();
            this.errorHandlers = new ListenersCollection();
            this.resultHandlers = new ListenersCollection();
            this.contextManager = new CardView.ContextManager();
            this.salesContextManager = CardView.SalesContextManager.getInstance();
            this.reportExecuting = false;
        }
        PropertiesManager.prototype.onApplyParameter = function (handler) {
            this.parameterApplyHandlers.addEventListener(handler);
        };
        PropertiesManager.prototype.onApplyFilter = function (handler) {
            this.filtersApplyHandlers.addEventListener(handler);
        };
        PropertiesManager.prototype.onApplySalesFilter = function (handler) {
            this.salesFiltersApplyHandlers.addEventListener(handler);
        };
        PropertiesManager.prototype.onError = function (handler) {
            this.errorHandlers.addEventListener(handler);
        };
        PropertiesManager.prototype.onResultsReturned = function (handler) {
            this.resultHandlers.addEventListener(handler);
        };
        PropertiesManager.prototype.setFilterAsSaved = function () {
            this.getFilters().forEach(function (filter) {
                if (filter.isCustomized()) {
                    filter.save();
                }
            });
        };
        PropertiesManager.prototype.isCustomized = function () {
            return this.getFilters().some(function (filter) { return filter.isCustomized(); }) ||
                this.getSalesFilters().some(function (saleFilter) { return saleFilter.isCustomized(); });
        };
        PropertiesManager.prototype.isSaveable = function () {
            return this.getFilters().every(function (filter) { return filter.isSaveable(); });
        };
        PropertiesManager.prototype.getCategoricalFiltersResetPayload = function () {
            var initialPayload = {};
            this.categoricalFilters.forEach(function (filter) {
                if (filter.isCustomized()) {
                    initialPayload[filter.getName()] = filter.wasInitiallyApplied() ? filter.getInitialOptions() : null;
                }
            });
            return initialPayload;
        };
        PropertiesManager.prototype.getCategoricalSalesFiltersResetPayload = function () {
            return this.salesCategoricalFilter.filter(function (salesFilter) { return salesFilter.isCustomized(); });
        };
        PropertiesManager.prototype.getColumnFiltersName = function () {
            var initialPayload = {};
            this.categoricalFilters.forEach(function (filter) {
                if (filter.isCustomized()) {
                    initialPayload[filter.getName()] = filter.getColumnName();
                }
            });
            return initialPayload;
        };
        PropertiesManager.prototype.reset = function () {
            this.getFilters().forEach(function (filter) { filter.reset(); });
        };
        PropertiesManager.prototype.resetSalesFilter = function () {
            this.salesCategoricalFilter.forEach(function (salesFilter) { salesFilter.reset(); });
        };
        PropertiesManager.prototype.getCategoricalFiltersSavePayload = function () {
            return this.categoricalFilters
                .map(function (filter) { return filter.getSavePayload(); })
                .filter(function (fPayload) { return fPayload !== null; });
        };
        PropertiesManager.prototype.getCategoricalSalesFiltersSavePayload = function () {
            return this.salesCategoricalFilter
                .map(function (filter) { return filter.getSavePayload(); });
        };
        PropertiesManager.prototype.getParametersSavePayload = function () {
            return this.parameters
                .map(function (parameter) { return parameter.getSavePayload(); })
                .filter(function (pPayload) { return pPayload !== null; });
        };
        PropertiesManager.prototype.getParametersResetPayload = function () {
            var values = {};
            this.parameters.forEach(function (parameter) {
                if (parameter.isCustomized()) {
                    values[parameter.getName()] = parameter.getInitialValue();
                }
            });
            return values;
        };
        PropertiesManager.prototype.getParameters = function (report) {
            if (this.info.getCardMetadata().isTemplate()) {
                return report.getParameters();
            }
            var deferred = jQuery.Deferred();
            var parameters = new Array();
            this.info.getProperties().getParameters().forEach(function (parameter) {
                parameters.push({
                    parameterId: parameter.getId(),
                    allowableValues: parameter.getAllowableValues(),
                    allowableValuesType: parameter.getAllowableValuesType(),
                    currentValue: parameter.getInitialValue(),
                    dataType: parameter.getDataType(),
                    dateStepPeriod: parameter.getDateStepPeriod(),
                    maxValue: parameter.getMaxValue(),
                    minValue: parameter.getMinValue(),
                    name: parameter.getName(),
                    stepSize: parameter.getStepSize()
                });
            });
            deferred.resolveWith(window, [parameters]);
            return deferred.promise();
        };
        PropertiesManager.prototype.getCategoricalFilters = function () {
            var filters = this.info.getProperties().getFilters().slice(0);
            var permissions = this.info.getProperties().getProductsPermission();
            var templatePermissions = this.info.getProperties().getTemplatePermissions();
            var templateTitle = this.info.getCardMetadata().getTemplateTitle();
            var maxOrder = 0;
            filters.forEach(function (filter) {
                var order = filter.getApplyOrder();
                if (order !== null && order > maxOrder) {
                    maxOrder = order;
                }
                ;
            });
            filters.sort(function (curr, next) {
                var currApplyOrder = curr.getApplyOrder();
                var nextApplyOrder = next.getApplyOrder();
                currApplyOrder = currApplyOrder === null ? 0 : maxOrder - currApplyOrder + 1;
                nextApplyOrder = nextApplyOrder === null ? 0 : maxOrder - nextApplyOrder + 1;
                return nextApplyOrder - currApplyOrder;
            });
            var group = new CardView.HierarchicalFilterGroup(filters, permissions, templatePermissions, templateTitle);
            return this.combineContextWithFilters(group, {});
        };
        PropertiesManager.prototype.extractDimensionInput = function (categoricalFilters) {
            var dimensionInputs = categoricalFilters.map(function (filter) {
                var id = filter.getDimensionId(), options = new Array();
                if (filter.getInitialOptions() !== null) {
                    options = filter.getInitialOptions();
                }
                return {
                    id: filter.getDimensionId(),
                    options: options
                };
            });
            return dimensionInputs;
        };
        PropertiesManager.prototype.extractSalesDimensionInput = function (salesFilters) {
            return salesFilters.map(function (salesFilter) {
                if (salesFilter.getOptions() === null || !salesFilter.getInitialApplied()) {
                    return null;
                }
                return {
                    id: salesFilter.getDimensionId(),
                    min: salesFilter.getOptions().min,
                    max: salesFilter.getOptions().max
                };
            }).filter(function (applied) { return applied !== null; });
        };
        PropertiesManager.prototype.getSalesCategoricalFilterPromises = function (filter, salesFilter) {
            var deferred = jQuery.Deferred(), categoricalFilters = this.info.getProperties().getFilters().slice(0);
            // Sales filter to be retrieved...
            var cardViewSalesInfo = {
                filterId: filter.getFilterId(),
                dimensionId: filter.getDimensionId(),
                name: filter.getName(),
                columnName: filter.getColumnName(),
                initialApplied: filter.getInitialApplied(),
                options: null
            };
            // If options are null, it means that we do not have any data saved for this sales filter
            if (filter.getOptions() !== null) {
                cardViewSalesInfo.options = filter.getOptions();
                deferred.resolveWith(window, [cardViewSalesInfo]);
            }
            else {
                // Regular dimensions input...
                var userFilterDimensionInput = this.extractDimensionInput(categoricalFilters);
                this.salesContextManager.setDimensionsInput(userFilterDimensionInput);
                // Sales dimensions input...
                var userFilterSalesDimensionInput = this.extractSalesDimensionInput(salesFilter);
                this.salesContextManager.getSalesContext({
                    salesDimensions: userFilterSalesDimensionInput,
                    targetDimension: filter.getDimensionId(),
                    focusDimension: this.getFocusDimension()
                })
                    .then(function (response) {
                    cardViewSalesInfo.options = response;
                    deferred.resolveWith(window, [cardViewSalesInfo]);
                })
                    .fail(function () {
                    deferred.reject();
                });
            }
            return deferred.promise();
        };
        PropertiesManager.prototype.getSalesCategoricalFilters = function () {
            var _this = this;
            var deferred = jQuery.Deferred(), salesFilters = this.info.getProperties().getSalesFilters().slice(0);
            if (salesFilters.isEmpty() || this.info.getProperties().getProductsPermission().contains('Alts Only')) {
                return null;
            }
            else {
                var promises_1 = salesFilters.map(function (filter) { return _this.getSalesCategoricalFilterPromises(filter, salesFilters); });
                jQuery.when.apply(jQuery, promises_1)
                    .then(function () {
                    var cardViewSalesInfo = new Array();
                    promises_1.forEach(function (promise) {
                        promise.then(function (info) {
                            cardViewSalesInfo.push(info);
                            if (cardViewSalesInfo.length === promises_1.length) {
                                deferred.resolveWith(_this, [cardViewSalesInfo]);
                            }
                        });
                    });
                })
                    .fail(function () {
                    deferred.reject();
                });
            }
            return deferred.promise();
        };
        PropertiesManager.prototype.getCurrentSalesCategoricalFilterPromises = function (filter) {
            var deferred = jQuery.Deferred();
            this.salesContextManager.getSalesContext({
                salesDimensions: [],
                targetDimension: filter.getDimensionId(),
                focusDimension: this.getFocusDimension()
            })
                .then(function (response) {
                deferred.resolveWith(window, [{
                        filterId: filter.getFilterId(),
                        dimensionId: filter.getDimensionId(),
                        name: filter.getName(),
                        columnName: filter.getColumnName(),
                        initialApplied: filter.wasInitiallyApplied(),
                        options: response
                    }]);
            })
                .fail(function () {
                deferred.reject();
            });
            return deferred.promise();
        };
        PropertiesManager.prototype.getCurrentSalesCategoricalFilters = function () {
            var _this = this;
            var deferred = jQuery.Deferred();
            var salesFilters = this.salesCategoricalFilter;
            var promises = salesFilters.map(function (filter) { return _this.getCurrentSalesCategoricalFilterPromises(filter); });
            jQuery.when.apply(jQuery, promises)
                .then(function () {
                var cardViewSalesInfo = new Array();
                promises.forEach(function (promise) {
                    promise.then(function (info) {
                        cardViewSalesInfo.push(info);
                        if (cardViewSalesInfo.length === promises.length) {
                            deferred.resolveWith(_this, [cardViewSalesInfo]);
                        }
                    });
                });
            })
                .fail(function () {
                deferred.reject();
            });
            return deferred.promise();
        };
        PropertiesManager.prototype.getSharedFocusFilters = function () {
            var deferred = jQuery.Deferred();
            jQuery.ajax({
                'method': 'POST',
                'url': this.info.getUrls().getSharedFocusFiltersUrl(),
                'dataType': 'json'
            }).then(function (response) {
                var focusInfo = new Array();
                focusInfo = response.data;
                focusInfo.forEach(function (focus) {
                    focus.selected = null;
                });
                deferred.resolveWith(window, [focusInfo]);
            }).fail(function () {
                deferred.reject();
            });
            return deferred.promise();
        };
        PropertiesManager.prototype.combineContextWithFilters = function (group, previousFilter) {
            var _this = this;
            var deferred = jQuery.Deferred();
            group.retrieveContext(previousFilter).then(function () {
                var indexedIds = group.getContextualizedOptions();
                if (group.hasChild()) {
                    _this.combineContextWithFilters(group.getChildGroup(), jQuery.extend(previousFilter, indexedIds))
                        .then(function (filters) {
                        deferred.resolveWith(window, [group.getContextualizedFilters().concat(filters)]);
                    })
                        .fail(function () {
                        deferred.reject();
                    });
                }
                else {
                    deferred.resolveWith(window, [group.getContextualizedFilters()]);
                }
            })
                .fail(function () {
                deferred.reject();
            });
            return deferred.promise();
        };
        PropertiesManager.prototype.initialize = function (report) {
            var _this = this;
            var deferred = jQuery.Deferred();
            this.setDefaultFocusDimension();
            // Load parameters
            var parametersPromise = this.getParameters(report);
            // Load filters [always in context]
            var filtersPromise = this.getCategoricalFilters();
            // Load shared focus filter
            var focusFilterPromise = this.getSharedFocusFilters();
            // Load Sales Filter
            var salesFiltersPromise = this.getSalesCategoricalFilters();
            if (salesFiltersPromise !== null) {
                jQuery.when(parametersPromise, filtersPromise, focusFilterPromise, salesFiltersPromise)
                    .then(function (parameters, filters, focusFilter, salesFilters) {
                    _this.initializeAllFilters(parameters, filters, focusFilter, salesFilters);
                    deferred.resolve();
                })
                    .fail(function () {
                    deferred.reject();
                });
            }
            else {
                jQuery.when(parametersPromise, filtersPromise, focusFilterPromise)
                    .then(function (parameters, filters, focusFilter) {
                    _this.initializeAllFilters(parameters, filters, focusFilter);
                    deferred.resolve();
                })
                    .fail(function () {
                    deferred.reject();
                });
            }
            return deferred.promise();
        };
        PropertiesManager.prototype.extractContextDimensions = function (filters) {
            var categoricalFilters = new Array();
            filters.forEach(function (current) {
                var options = new Array();
                if (current.getOptions() !== null) {
                    current.getOptions().forEach(function (option) {
                        options.push({
                            formattedValue: option.label,
                            value: option.id,
                            selected: option.selected
                        });
                    });
                }
                categoricalFilters.push({
                    id: current.getDimensionId(),
                    options: options
                });
            });
            return categoricalFilters;
        };
        PropertiesManager.prototype.disableAllFilters = function () {
            var filters = this.getFilters();
            filters.forEach(function (filter) {
                filter.disable();
            });
        };
        PropertiesManager.prototype.disableOnlyFilters = function () {
            this.categoricalFilters.forEach(function (filter) {
                filter.disableOnlyFilter();
            });
            this.parameters.forEach(function (parameter) {
                parameter.disable();
            });
        };
        PropertiesManager.prototype.disableOnlySalesFilters = function () {
            this.salesCategoricalFilter.forEach(function (sales) {
                sales.disableOnly();
            });
        };
        PropertiesManager.prototype.disableSalesFilter = function (dimensionName) {
            var filter = this.salesCategoricalFilter.single(function (current) { return current.getName() === dimensionName; });
            filter.disable();
        };
        PropertiesManager.prototype.disableAllSalesFilters = function () {
            var filters = this.salesCategoricalFilter;
            if (filters) {
                filters.forEach(function (filter) {
                    filter.disable();
                });
            }
        };
        PropertiesManager.prototype.setReportExecuting = function (executing) {
            this.reportExecuting = executing;
        };
        PropertiesManager.prototype.setFilterAsApplied = function (filterName) {
            var filter = this.getFilters().single(function (filter) { return filter.getName() === filterName; });
            filter.applyValues();
        };
        PropertiesManager.prototype.enableOnlyFilters = function () {
            this.categoricalFilters.forEach(function (filter) {
                filter.enableOnlyFilter();
            });
            this.parameters.forEach(function (parameter) {
                parameter.enable();
            });
        };
        PropertiesManager.prototype.enableOnlySalesFilter = function () {
            var salesFilters = this.salesCategoricalFilter;
            if (salesFilters) {
                salesFilters.forEach(function (filter) {
                    filter.enableOnlyFilter();
                });
            }
        };
        PropertiesManager.prototype.enableAllFilters = function () {
            var filters = this.getFilters();
            filters.forEach(function (filter) {
                filter.enable();
            });
        };
        PropertiesManager.prototype.enableAllSalesFilters = function () {
            var salesFilters = this.salesCategoricalFilter;
            if (salesFilters) {
                salesFilters.forEach(function (filter) {
                    filter.enable();
                });
            }
        };
        PropertiesManager.prototype.addParameterChangeListeners = function () {
            var _this = this;
            this.parameters.forEach(function (parameter) {
                parameter.onApply(function () {
                    if (parameter.getName() === PropertiesManager.PARAMETER_DIMENSION_FILTER) {
                        _this.resetSalesCategoricalFilter();
                    }
                    _this.parameterApplyHandlers.execute(window, [parameter.getName(), parameter.getCurrentValue()]);
                });
            });
        };
        PropertiesManager.prototype.getNextApplyOrder = function () {
            var currentApplyOrder = this.categoricalFilters.map(function (filter) { return filter.hasApplyOrder() ? filter.getApplyOrder() : 0; }).max();
            return ++currentApplyOrder;
        };
        PropertiesManager.prototype.triggerResultsHandlers = function (isEmpty) {
            this.resultHandlers.execute(window, [isEmpty]);
        };
        PropertiesManager.prototype.triggerErrorHandlers = function () {
            this.errorHandlers.execute(window, []);
        };
        PropertiesManager.prototype.addSalesCategoricalChangeListeners = function () {
            var _this = this;
            this.salesCategoricalFilter.forEach(function (salesFilter) {
                salesFilter.onApply(function () {
                    // Set selected options as applied
                    salesFilter.refreshAppliedOptions();
                    salesFilter.setCustomized(true);
                    var filteredFilters = _this.salesCategoricalFilter.filter(function (salesFilter) { return salesFilter.isCustomized(); });
                    var salesDimensionsInput = filteredFilters.map(function (currentFilter) {
                        return {
                            id: currentFilter.getDimensionId(),
                            min: currentFilter.getMinValue(),
                            max: currentFilter.getMaxValue()
                        };
                    });
                    var otherFilters = _this.salesCategoricalFilter.filter(function (filter) { return filter.getName() !== salesFilter.getName(); });
                    otherFilters.forEach(function (otherSaleFilter) {
                        var promise = _this.salesContextManager.getSalesContext({
                            salesDimensions: salesDimensionsInput,
                            targetDimension: otherSaleFilter.getDimensionId(),
                            focusDimension: _this.getFocusDimension()
                        });
                        otherSaleFilter.setSalesContext(promise);
                    });
                    var min = salesFilter.getMinValue();
                    var max = salesFilter.getMaxValue();
                    _this.salesFiltersApplyHandlers.execute(window, [salesFilter.getName(), min, max]);
                });
            });
        };
        PropertiesManager.prototype.addCategoricalChangeListeners = function () {
            var _this = this;
            var areAnyEmpty = false;
            this.categoricalFilters.forEach(function (filter) {
                filter.onApply(function () {
                    if (_this.reportExecuting) {
                        jQuery.toaster(_this.info.getStrings().getReportRunningMessage(), '', 'warning');
                        return;
                    }
                    _this.salesCategoricalFilter.forEach(function (salesFilter) {
                        salesFilter.setCustomized(false);
                    });
                    if (!filter.hasApplyOrder()) {
                        filter.setApplyOrder(_this.getNextApplyOrder());
                    }
                    filter.applyValues();
                    // Reset empty filters controller
                    areAnyEmpty = false;
                    _this.categoricalFilters.forEach(function (filter) {
                        var promise = _this.contextManager.getContext(filter.getDimensionId());
                        promise.fail(function () {
                            _this.triggerErrorHandlers();
                        });
                        filter.executeContextPromise(promise);
                    });
                    _this.resetSalesCategoricalFilter();
                    _this.filtersApplyHandlers.execute(window, [filter.getName(), filter.getColumnName(), filter.getCurrentValue()]);
                });
                filter.onResultsReturned(function (isEmpty) {
                    if (!areAnyEmpty && isEmpty) {
                        areAnyEmpty = isEmpty;
                    }
                    if (!filter.getColumnName().contains('alt_')) {
                        _this.triggerResultsHandlers(areAnyEmpty);
                    }
                });
            });
        };
        PropertiesManager.prototype.resetSalesCategoricalFilter = function () {
            if (this.salesCategoricalFilter) {
                this.salesCategoricalFilter.forEach(function (salesFilter) {
                    salesFilter.resetValues();
                });
            }
        };
        PropertiesManager.prototype.getFilters = function () {
            var filters = new Array();
            for (var i = 0; i < this.categoricalFilters.length; ++i) {
                filters.push(this.categoricalFilters[i]);
            }
            for (var i = 0; i < this.parameters.length; ++i) {
                filters.push(this.parameters[i]);
            }
            return filters;
        };
        PropertiesManager.prototype.getAllFiltersByLocation = function (type) {
            var filters = new Array();
            for (var i = 0; i < this.categoricalFilters.length; ++i) {
                filters.push(this.categoricalFilters[i]);
            }
            for (var i = 0; i < this.salesCategoricalFilter.length; ++i) {
                filters.push(this.salesCategoricalFilter[i]);
            }
            for (var i = 0; i < this.parameters.length; ++i) {
                filters.push(this.parameters[i]);
            }
            filters = filters.filter(function (filter) { return filter.getType() === type; });
            filters.sort(function (current, next) { return next.getPosition() - current.getPosition(); });
            return filters;
        };
        PropertiesManager.prototype.getSalesFilters = function () {
            return this.salesCategoricalFilter;
        };
        PropertiesManager.prototype.updateSalesFilters = function () {
            var _this = this;
            if (this.salesCategoricalFilter) {
                jQuery.when(this.updateSalesPromise).then(function (salesFilters) {
                    _this.salesCategoricalFilter.forEach(function (sales) {
                        var newFilter = salesFilters.single(function (current) { return current.name === sales.getName(); });
                        sales.updateOptions(newFilter.options);
                        sales.resetValues();
                        sales.enable();
                    });
                });
            }
        };
        PropertiesManager.prototype.setUpdateSalesDimensionPromise = function () {
            if (this.salesCategoricalFilter) {
                this.updateSalesPromise = this.getCurrentSalesCategoricalFilters();
            }
        };
        PropertiesManager.prototype.updateFocusDimension = function (focus) {
            this.setFocusDimension(focus);
            this.setUpdateSalesDimensionPromise();
        };
        PropertiesManager.prototype.setFocusDimension = function (focus) {
            this.focusDimension = focus;
        };
        PropertiesManager.prototype.getFocusDimension = function () {
            return this.focusDimension;
        };
        PropertiesManager.prototype.setDefaultFocusDimension = function () {
            var focusDimension = this.info.getProperties().getFocusDimension();
            var parameters = this.info.getProperties().getParameters().slice(0), dimensionFilter = parameters.single(function (parameter) { return parameter.getName() === PropertiesManager.PARAMETER_DIMENSION_FILTER; });
            if (dimensionFilter) {
                focusDimension = dimensionFilter.getInitialValue();
            }
            this.setFocusDimension(focusDimension);
            return focusDimension;
        };
        PropertiesManager.prototype.initializeAllFilters = function (parameters, filters, focusFilter, salesFilters) {
            var _this = this;
            var strings = this.info.getStrings();
            var envType = this.info.getEnvironmentProperties().getEnvironmentType();
            // Parameters
            this.parameters = new Array();
            parameters.forEach(function (parameterInfo) {
                var parameter = CardView.ParameterFactory.createParameter(parameterInfo, envType, strings);
                if (parameter === null) {
                    console.log('Could not find suitable parameter type for ' + parameterInfo.name, parameterInfo);
                }
                else {
                    _this.parameters.push(parameter);
                }
            });
            this.addParameterChangeListeners();
            // Filters
            this.categoricalFilters = new Array();
            filters.forEach(function (filterInfo) {
                var selectedOptions = filterInfo.getSelectedOptions();
                if (selectedOptions !== null && selectedOptions.isEmpty() && !filterInfo.columnName.contains('alt_')) {
                    _this.triggerResultsHandlers(true);
                }
                var filter = CardView.FilterFactory.createFilter(filterInfo, envType, focusFilter, strings);
                _this.categoricalFilters.push(filter);
            });
            this.addCategoricalChangeListeners();
            this.contextManager.setFilters(this.categoricalFilters);
            // Sales Filters
            if (salesFilters) {
                this.salesCategoricalFilter = new Array();
                salesFilters.forEach(function (saleFilter) {
                    var salesFilter = CardView.MetricFilterFactory.createFilter(saleFilter, envType, strings);
                    _this.salesCategoricalFilter.push(salesFilter);
                });
                this.addSalesCategoricalChangeListeners();
            }
        };
        PropertiesManager.PARAMETER_DIMENSION_FILTER = 'Dimension';
        return PropertiesManager;
    }());
    CardView.PropertiesManager = PropertiesManager;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var FiltersApplied = (function () {
        function FiltersApplied(options) {
            this.wrapper = options.wrapper;
            this.strings = options.info.getStrings();
            this.initialFiltersApplied = {};
            this.initialSalesFiltersApplied = {};
            this.filtersApplied = {};
            this.salesFiltersApplied = {};
            this.setInitialValuesForFilters(options);
            this.setInitialValuesForSalesFilters(options);
            this.build();
        }
        FiltersApplied.prototype.setInitialValuesForFilters = function (options) {
            var _this = this;
            var initialFilters = options.info.getProperties().getFilters();
            initialFilters.sort(function (curr, next) {
                return curr.getApplyOrder() > next.getApplyOrder() ? 1 : -1;
            });
            initialFilters.forEach(function (filter) {
                if (filter.hasApplyOrder()) {
                    var filterName = filter.getName();
                    var options = new Array();
                    filter.getInitialOptions().forEach(function (initialOption) {
                        var optionName = initialOption.formattedValue;
                        options.push(optionName);
                    });
                    _this.filtersApplied[filterName] = options;
                    _this.initialFiltersApplied[filterName] = options;
                }
            });
        };
        FiltersApplied.prototype.setInitialValuesForSalesFilters = function (options) {
            var _this = this;
            var initialSalesFilters = options.info.getProperties().getSalesFilters();
            initialSalesFilters.forEach(function (filter) {
                if (filter.getInitialApplied()) {
                    var filterName = filter.getName();
                    var config = CardView.CategoricalFilter.configInstance.getConfig(filterName);
                    var salesType = config.salesType;
                    var min = filter.getOptions().min;
                    var max = filter.getOptions().max;
                    if (salesType !== CardView.SalesCategoricalFilterFormatter.NEGATIVE_TYPE &&
                        max !== null &&
                        Number(min) <= 0 &&
                        Number(max) <= 0) {
                        max = CardView.SalesCategoricalFilterFormatter.NEGATIVE_MASK;
                    }
                    var obj = {
                        min: Number(min),
                        max: Number(max)
                    };
                    _this.salesFiltersApplied[filterName] = obj;
                    _this.initialSalesFiltersApplied[filterName] = obj;
                }
            });
        };
        FiltersApplied.prototype.setFiltersName = function () {
            var _this = this;
            Object.keys(this.filtersApplied).forEach(function (key) {
                var filterName = key;
                var options = _this.filtersApplied[key];
                var size = options.length;
                // Home Office
                if (filterName === FiltersApplied.HOME_OFFICE_FILTER_NAME) {
                    if (options.length <= 1) {
                        var text = filterName;
                        var tag = jQuery('<div/>', { 'id': filterName + 'Tag', 'value': '0', 'class': 'filters-applied-option', 'text': text });
                        var value = _this.strings.getFiltersAppliedNotIncluded().slice(1, -1);
                        tag.append(jQuery('<span>', { 'class': 'number-formatting', 'text': value }));
                        _this.wrapper.append(tag);
                    }
                    else {
                        var text = filterName;
                        var tag = jQuery('<div/>', { 'id': filterName + 'Tag', 'value': '1', 'class': 'filters-applied-option', 'text': text });
                        var value = _this.strings.getFiltersAppliedIncluded().slice(1, -1);
                        tag.append(jQuery('<span>', { 'class': 'number-formatting', 'text': value }));
                        _this.wrapper.append(tag);
                    }
                }
                else {
                    var text = filterName;
                    var tag = jQuery('<div/>', {
                        'id': text.replace(' ', '') + 'Tag',
                        'value': size,
                        'class': 'filters-applied-option',
                        'data-toggle': 'popover',
                        'text': text
                    });
                    tag.append(jQuery('<span>', { 'class': 'number-formatting', 'text': size }));
                    var tooltipContent = jQuery('<div/>');
                    if (size > FiltersApplied.MAX_OPTION_TOOLTIP) {
                        var tooltipLine = jQuery('<div/>', { 'text': _this.strings.getFilterAppliedTooManyOptions() });
                        tooltipContent.append(tooltipLine);
                    }
                    else {
                        options.sort();
                        options.forEach(function (option) {
                            var tooltipLine = jQuery('<div/>', {
                                'class': 'filters-applied-wrapper-popover',
                                'text': option
                            });
                            tooltipContent.append(tooltipLine);
                        });
                    }
                    // Attaching tooltip...
                    tag.popover({
                        content: tooltipContent,
                        placement: 'bottom',
                        trigger: 'hover',
                        html: true
                    });
                    _this.wrapper.append(tag);
                }
            });
        };
        FiltersApplied.prototype.setSalesFilter = function () {
            var _this = this;
            // Sales filters...
            Object.keys(this.salesFiltersApplied).forEach(function (key) {
                var filterName = key;
                var config = CardView.CategoricalFilter.configInstance.getConfig(filterName);
                var salesFilterType = config.salesType;
                var options = _this.salesFiltersApplied[key];
                var sales_id = filterName.replace(' ', '') + 'Tag';
                var min = "";
                var max = "";
                if (salesFilterType !== CardView.SalesCategoricalFilterFormatter.NEGATIVE_TYPE) {
                    options.min = _this.updateNegativeToZero(options.min);
                    options.max = _this.updateNegativeToZero(options.max);
                }
                if (filterName == FiltersApplied.MARKET_SHARE) {
                    min = Number(options.min).toFixed(1) + "%";
                    max = Number(options.max).toFixed(1) + "%";
                }
                else {
                    //Filter values are shown in thousands
                    min = new LabelBuilder.SalesLabelBuilder().build(options.min * 1000);
                    max = new LabelBuilder.SalesLabelBuilder().build(options.max * 1000);
                }
                if (options.min == 0 && options.max == 0) {
                    var text = filterName + ' (' + min + ')';
                }
                else {
                    var text = filterName + ' (' + min + '~' + max + ')';
                }
                var option = jQuery('<div/>', { 'id': sales_id, 'class': 'filters-applied-option', 'text': text });
                _this.wrapper.append(option);
            });
        };
        FiltersApplied.prototype.updateNegativeToZero = function (value) {
            if (value < 0) {
                value = 0;
            }
            return value;
        };
        FiltersApplied.prototype.clean = function () {
            this.wrapper.html('');
        };
        FiltersApplied.prototype.build = function () {
            this.clean();
            this.setFiltersAppliedLabel();
            this.setFiltersName();
            this.setSalesFilter();
        };
        FiltersApplied.prototype.setFiltersAppliedLabel = function () {
            var hasFiltersApplied = !Object.keys(this.filtersApplied).isEmpty();
            var hasSalesFiltersApplied = !Object.keys(this.salesFiltersApplied).isEmpty();
            if (hasFiltersApplied || hasSalesFiltersApplied) {
                var text = this.strings.getFiltersAppliedLabel() + ":";
                var label = jQuery('<div/>', { 'id': 'filters-applied-label', 'class': 'filters-applied-label', 'text': text });
                this.wrapper.append(label);
            }
        };
        FiltersApplied.prototype.update = function (filterName, options) {
            // Cleaning sales filters...
            this.salesFiltersApplied = {};
            this.filtersApplied[filterName] = options;
            this.build();
        };
        FiltersApplied.prototype.remove = function (filterName) {
            // Cleaning sales filters...
            this.salesFiltersApplied = {};
            delete this.filtersApplied[filterName];
            this.build();
        };
        FiltersApplied.prototype.updateSalesFilter = function (filterName, min, max) {
            this.salesFiltersApplied[filterName] = { min: min, max: max };
            this.build();
        };
        FiltersApplied.prototype.reset = function () {
            var _this = this;
            // Cleaning...
            this.salesFiltersApplied = {};
            this.filtersApplied = {};
            Object.keys(this.initialFiltersApplied).forEach(function (key) {
                var filterName = key;
                var options = _this.initialFiltersApplied[key];
                _this.filtersApplied[filterName] = options;
            });
            Object.keys(this.initialSalesFiltersApplied).forEach(function (key) {
                var filterName = key;
                var options = _this.initialSalesFiltersApplied[key];
                _this.salesFiltersApplied[filterName] = options;
            });
            this.build();
        };
        FiltersApplied.MAX_OPTION_TOOLTIP = 10;
        FiltersApplied.HOME_OFFICE_FILTER_NAME = 'HomeOffice';
        FiltersApplied.MARKET_SHARE = "Market Share";
        return FiltersApplied;
    }());
    CardView.FiltersApplied = FiltersApplied;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var Manager = (function () {
        function Manager(options) {
            this.info = options.info;
            this.reportView = options.reportView;
            this.propertiesManager = options.propertiesManager;
            this.breadcrumb = options.breadcrumb;
            this.filtersApplied = options.filtersApplied;
            this.cardTitle = options.cardTitle;
            this.toolbar = options.toolbar;
            this.sideMenu = options.sideMenu;
            this.userSettings = options.userSettings;
            this.actions = [
                new CardView.Actions.CancelCard(), new CardView.Actions.NewCard(), new CardView.Actions.ToggleVisualization(),
                new CardView.Actions.ExportSheetPNG(), new CardView.Actions.ExportSheetCSV(), new CardView.Actions.BreadCrumbCrawl(),
                new CardView.Actions.ApplyCardParameter(), new CardView.Actions.ApplyCardFilter(), new CardView.Actions.ApplyCardSalesFilter(),
                new CardView.Actions.SaveCardTemplate(), new CardView.Actions.SaveCardView(), new CardView.Actions.ResetCard(),
                new CardView.Actions.ShareCard(), new CardView.Actions.SaveSharedCard(),
                new CardView.Actions.CopyCard(), new CardView.Actions.DeleteCardView(),
                new CardView.Actions.PublishCard(), new CardView.Actions.DeletePublishedCard()
            ];
            this.lastAction = null;
            this.beforeActionHandlers = {};
            this.afterActionHandlers = {};
            this.afterActionFailedHandlers = {};
            this.changeHandlers = new ListenersCollection();
            this.canExecuteFilters = false;
            this.canExecuteSalesFilters = false;
        }
        Manager.prototype.findAvailableAction = function (type) {
            var _this = this;
            return this.actions.single(function (action) { return action.getType() === type && action.isAvailable(_this.info, _this.createActionArgs([])); }) || null;
        };
        Manager.prototype.initialize = function () {
            var _this = this;
            // Load report
            this.reportView.initialize();
            var report = this.reportView.getReport();
            this.userSettings.initialize(report);
            this.breadcrumb.initialize(report);
            this.cardTitle.initialize();
            this.sideMenu.initialize();
            report.ready(function () {
                _this.sideMenu.showControls();
            });
            report.onChange(function (e) {
                var xAxisParameterClass = '#ws-parameter-filter-x-axis';
                var yAxisParameterClass = '#ws-parameter-filter-y-axis';
                var clientNetSalesOption = 'Client Net Sales';
                var clientSalesOption = 'Client Sales';
                var globalNetSalesOption = 'Global Net Sales';
                var globalSalesOption = 'Global Sales';
                var salesMarketShareOption = 'Sales Market Share';
                var aumMarketShareOption = 'AUM Market Share';
                var clientAumOption = 'Client AUM';
                var industryAumOption = 'Industry AUM';
                var salesGreenSpaceOption = 'Sales Green Space';
                var aumGreenSpaceOption = 'AUM Green Space';
                switch (e) {
                    case CardView.CardViewReportEvents.USING_FILTERS:
                        _this.sideMenu.overridePropertiesGroupVisibility(true);
                        break;
                    case CardView.CardViewReportEvents.IGNORING_FILTERS:
                        _this.sideMenu.overridePropertiesGroupVisibility(false);
                        break;
                    case CardView.CardViewReportEvents.ENABLE_CSV:
                        _this.toolbar.enableCSVButton();
                        break;
                    case CardView.CardViewReportEvents.DISABLE_CSV:
                        _this.toolbar.disableCSVButton();
                        break;
                    case CardView.CardViewReportEvents.SHOW_ROTATION_MESSAGE:
                        _this.sideMenu.showRotationBuilderMessage(true);
                        break;
                    case CardView.CardViewReportEvents.HIDE_ROTATION_MESSAGE:
                        _this.sideMenu.showRotationBuilderMessage(false);
                        break;
                    case CardView.CardViewReportEvents.ENABLE_ANALYSIS_PARAMETER:
                        _this.reportView.enableAnalysisParameter();
                        break;
                    case CardView.CardViewReportEvents.DISABLE_ANALYSIS_PARAMETER:
                        _this.reportView.disableAnalysisParameter();
                        break;
                    case CardView.CardViewReportEvents.HIDE_TOP_CONTROLS:
                        _this.reportView.hideTopControls();
                        break;
                    case CardView.CardViewReportEvents.SHOW_TOP_CONTROLS:
                        _this.reportView.showTopControls();
                        break;
                    case CardView.CardViewReportEvents.ENABLE_AXIS_PARAMETER:
                        _this.reportView.showAxisParameter();
                        break;
                    case CardView.CardViewReportEvents.DISABLE_AXIS_PARAMETER:
                        _this.reportView.hideAxisParameter();
                        break;
                    case CardView.CardViewReportEvents.CHANGE_VIEWBY_TO_ASSET_CLASS:
                        _this.reportView.changeViewByTo('Asset Class');
                        break;
                    case CardView.CardViewReportEvents.CHANGE_VIEWBY_TO_CATEGORYS:
                        _this.reportView.changeViewByTo('Category');
                        break;
                    case CardView.CardViewReportEvents.CHANGE_VIEWBY_TO_CHANNEL:
                        _this.reportView.changeViewByTo('Channel');
                        break;
                    case CardView.CardViewReportEvents.CHANGE_VIEWBY_TO_DIVISION:
                        _this.reportView.changeViewByTo('Division');
                        break;
                    case CardView.CardViewReportEvents.CHANGE_VIEWBY_TO_FIRM:
                        _this.reportView.changeViewByTo('Firm');
                        break;
                    case CardView.CardViewReportEvents.CHANGE_VIEWBY_TO_TERRITORY:
                        _this.reportView.changeViewByTo('Territory');
                        break;
                    case CardView.CardViewReportEvents.CHANGE_VIEWBY_TO_OFFICE:
                        _this.reportView.changeViewByTo('Office');
                        break;
                    case CardView.CardViewReportEvents.DISABLE_XAXIS_CLIENT_NET_SALES:
                        _this.reportView.disableAxisOption(xAxisParameterClass, clientNetSalesOption);
                        break;
                    case CardView.CardViewReportEvents.DISABLE_XAXIS_CLIENT_SALES:
                        _this.reportView.disableAxisOption(xAxisParameterClass, clientSalesOption);
                        break;
                    case CardView.CardViewReportEvents.DISABLE_XAXIS_GLOBAL_NET_SALES:
                        _this.reportView.disableAxisOption(xAxisParameterClass, globalNetSalesOption);
                        break;
                    case CardView.CardViewReportEvents.DISABLE_XAXIS_GLOBAL_SALES:
                        _this.reportView.disableAxisOption(xAxisParameterClass, globalSalesOption);
                        break;
                    case CardView.CardViewReportEvents.DISABLE_XAXIS_SALES_MARKET_SHARE:
                        _this.reportView.disableAxisOption(xAxisParameterClass, salesMarketShareOption);
                        break;
                    case CardView.CardViewReportEvents.DISABLE_XAXIS_AUM_MARKET_SHARE:
                        _this.reportView.disableAxisOption(xAxisParameterClass, aumMarketShareOption);
                        break;
                    case CardView.CardViewReportEvents.DISABLE_YAXIS_CLIENT_NET_SALES:
                        _this.reportView.disableAxisOption(yAxisParameterClass, clientNetSalesOption);
                        break;
                    case CardView.CardViewReportEvents.DISABLE_YAXIS_CLIENT_SALES:
                        _this.reportView.disableAxisOption(yAxisParameterClass, clientSalesOption);
                        break;
                    case CardView.CardViewReportEvents.DISABLE_YAXIS_GLOBAL_NET_SALES:
                        _this.reportView.disableAxisOption(yAxisParameterClass, globalNetSalesOption);
                        break;
                    case CardView.CardViewReportEvents.DISABLE_YAXIS_GLOBAL_SALES:
                        _this.reportView.disableAxisOption(yAxisParameterClass, globalSalesOption);
                        break;
                    case CardView.CardViewReportEvents.DISABLE_YAXIS_SALES_MARKET_SHARE:
                        _this.reportView.disableAxisOption(yAxisParameterClass, salesMarketShareOption);
                        break;
                    case CardView.CardViewReportEvents.DISABLE_YAXIS_AUM_MARKET_SHARE:
                        _this.reportView.disableAxisOption(yAxisParameterClass, aumMarketShareOption);
                        break;
                    case CardView.CardViewReportEvents.DISABLE_XAXIS_CLIENT_AUM:
                        _this.reportView.disableAxisOption(xAxisParameterClass, clientAumOption);
                        break;
                    case CardView.CardViewReportEvents.DISABLE_XAXIS_INDUSTRY_AUM:
                        _this.reportView.disableAxisOption(xAxisParameterClass, industryAumOption);
                        break;
                    case CardView.CardViewReportEvents.DISABLE_XAXIS_SALES_GREEN_SPACE:
                        _this.reportView.disableAxisOption(xAxisParameterClass, salesGreenSpaceOption);
                        break;
                    case CardView.CardViewReportEvents.DISABLE_XAXIS_AUM_GREEN_SPACE:
                        _this.reportView.disableAxisOption(xAxisParameterClass, aumGreenSpaceOption);
                        break;
                    case CardView.CardViewReportEvents.DISABLE_YAXIS_CLIENT_AUM:
                        _this.reportView.disableAxisOption(yAxisParameterClass, clientAumOption);
                        break;
                    case CardView.CardViewReportEvents.DISABLE_YAXIS_INDUSTRY_AUM:
                        _this.reportView.disableAxisOption(yAxisParameterClass, industryAumOption);
                        break;
                    case CardView.CardViewReportEvents.DISABLE_YAXIS_SALES_GREEN_SPACE:
                        _this.reportView.disableAxisOption(yAxisParameterClass, salesGreenSpaceOption);
                        break;
                    case CardView.CardViewReportEvents.DISABLE_YAXIS_AUM_GREEN_SPACE:
                        _this.reportView.disableAxisOption(yAxisParameterClass, aumGreenSpaceOption);
                        break;
                    case CardView.CardViewReportEvents.TEMP_MANAGEMENT_OVERVIEW_MOBILE:
                        _this.reportView.showErrorTempManagementReport();
                        break;
                    case CardView.CardViewReportEvents.ENABLE_BREADCRUMB:
                        _this.breadcrumb.enable();
                        break;
                    case CardView.CardViewReportEvents.DISABLE_BREADCRUMB:
                        _this.breadcrumb.disable();
                        break;
                }
            });
            report.onError(function () {
                _this.reportView.showErrorMessage();
            });
            this.propertiesManager.onResultsReturned(function (isEmpty) {
                if (isEmpty) {
                    _this.reportView.showEmptyResultsMessage();
                }
                else {
                    _this.reportView.hideEmptyResultsMessage();
                }
                _this.triggerChangeHandlers();
            });
            this.sideMenu.feed(null);
            this.reportView.feed(null);
            this.propertiesManager.initialize(report)
                .then(function () {
                var sideMenuFilters = _this.propertiesManager.getAllFiltersByLocation(CardView.FilterLocation.SIDE_MENU);
                _this.sideMenu.feed(sideMenuFilters);
                var topFilters = _this.propertiesManager.getAllFiltersByLocation(CardView.FilterLocation.TOP);
                if (report.getName() === 'OfficeDeepDive') {
                    var activeSheet = _this.reportView.getReport().getActiveSheetName();
                    if (activeSheet != null) {
                        _this.checkFiltersVisible(activeSheet);
                    }
                }
                _this.reportView.feed(topFilters);
            })
                .fail(function () {
                _this.reportView.showErrorMessage();
            });
            this.addListeners();
            this.initializeActions();
        };
        Manager.prototype.beforeAction = function (actionType, handler) {
            Manager.addActionHandler(this.beforeActionHandlers, actionType, handler);
        };
        Manager.prototype.afterAction = function (actionType, handler) {
            Manager.addActionHandler(this.afterActionHandlers, actionType, handler);
        };
        Manager.prototype.afterActionFailed = function (actionType, handler) {
            Manager.addActionHandler(this.afterActionFailedHandlers, actionType, handler);
        };
        Manager.addActionHandler = function (handlers, type, handler) {
            if (handlers[type] === undefined) {
                handlers[type] = new ListenersCollection();
            }
            handlers[type].addEventListener(handler);
        };
        Manager.prototype.initializeCancelAction = function () {
            var _this = this;
            var cancelAction = this.findAvailableAction(CardView.Actions.ActionType.CANCEL);
            if (cancelAction === null) {
                return;
            }
            this.toolbar.enableCancelButton();
            this.toolbar.onCancelButtonClick(function () {
                _this.execute(cancelAction);
            });
        };
        Manager.prototype.initializeNewAction = function () {
            var _this = this;
            var newAction = this.findAvailableAction(CardView.Actions.ActionType.NEW);
            if (newAction === null) {
                return;
            }
            this.toolbar.enableNewButton();
            this.toolbar.onNewButtonClick(function () {
                _this.execute(newAction);
            });
        };
        Manager.prototype.initializeToggleVizAction = function () {
            var _this = this;
            var report = this.reportView.getReport();
            report.ready(function () {
                var toggleAction = _this.findAvailableAction(CardView.Actions.ActionType.TOGGLE);
                if (toggleAction !== null) {
                    toggleAction.initialize(_this.info, _this.createActionArgs([]));
                    _this.toolbar.enableToggleVisualizationButton();
                    _this.toolbar.onToggleVisualizationButtonClick(function () {
                        _this.execute(toggleAction);
                        _this.toolbar.disableToggleVisualizationButton();
                    });
                    _this.afterAction(toggleAction.getType(), function (info, args) {
                        _this.toolbar.toggleVisualizationButtonIcon(args.report.getActiveSheetName());
                        _this.toolbar.reEnableToggleVisualizationButton();
                    });
                }
                else {
                    _this.toolbar.removeToggleVisualizationButton();
                }
            });
        };
        Manager.prototype.refreshExportControls = function (activeSheet, sheetInfo) {
            if (activeSheet === null) {
                return;
            }
            var SheetMetadataManager = CardView.LoadInfo.SheetMetadataManager;
            switch (activeSheet) {
                case sheetInfo.getChartSheetName():
                    this.toolbar.setPNGExportOptionState(SheetMetadataManager.getChartExportsPNG());
                    this.toolbar.setCSVExportOptionState(SheetMetadataManager.getChartExportsCSV());
                    break;
                case sheetInfo.getDataTableSheetName():
                    this.toolbar.setPNGExportOptionState(SheetMetadataManager.getDatatableExportsPNG());
                    this.toolbar.setCSVExportOptionState(SheetMetadataManager.getDatatableExportsCSV());
                    break;
            }
        };
        ;
        Manager.prototype.initializeExportsActions = function () {
            var _this = this;
            var types = CardView.Actions.ActionType;
            var report = this.reportView.getReport();
            report.ready(function () {
                var exportCSVAction = _this.findAvailableAction(types.EXPORT_CSV);
                var exportPNGAction = _this.findAvailableAction(types.EXPORT_PNG);
                if (exportCSVAction || exportPNGAction) {
                    _this.toolbar.enableExportMenu();
                    if (exportCSVAction === null) {
                        _this.toolbar.removeExportCSVOption();
                    }
                    if (exportPNGAction === null) {
                        _this.toolbar.removeExportPNGOption();
                    }
                    _this.toolbar.onCSVExportOptionSelected(function () {
                        if (_this.toolbar.isCSVDisabled()) {
                            return;
                        }
                        _this.execute(exportCSVAction);
                    });
                    _this.toolbar.onPNGExportOptionSelected(function () {
                        _this.execute(exportPNGAction);
                    });
                    var env = _this.info.getEnvironmentProperties().getEnvironmentType();
                    var sheetInfo = _this.info.getCardMetadata().getReportMetadata().getSheetByEnvironment(env);
                    var SheetMetadataManager = CardView.LoadInfo.SheetMetadataManager;
                    report.onTabSwitched(function (e) {
                        _this.refreshExportControls(e.getNewSheetName(), sheetInfo);
                    });
                    _this.refreshExportControls(report.getActiveSheetName(), sheetInfo);
                }
                else {
                    // Removing the export button and dropdown
                    _this.toolbar.removeExportMenu();
                }
            });
        };
        Manager.prototype.initializeBreadCrumbCrawls = function () {
            var _this = this;
            var crumbCrawl = this.findAvailableAction(CardView.Actions.ActionType.CRUMB_CRAWL);
            this.breadcrumb.click(function () {
                _this.execute(crumbCrawl);
            });
        };
        Manager.prototype.initializeApplyAction = function () {
            var _this = this;
            var types = CardView.Actions.ActionType;
            var applySalesFilterActionType = types.APPLY_SALES_FILTER;
            var applySalesFilterAction = this.findAvailableAction(applySalesFilterActionType);
            this.propertiesManager.onApplySalesFilter(function (filterName, min, max) {
                _this.propertiesManager.disableAllSalesFilters();
                _this.propertiesManager.disableOnlyFilters();
                _this.toolbar.displaySaveButton();
                _this.canExecuteFilters = true;
                _this.canExecuteSalesFilters = true;
                _this.filtersApplied.updateSalesFilter(filterName, min, max);
                _this.execute(applySalesFilterAction, filterName, min, max);
            });
            this.afterAction(applySalesFilterActionType, function (info, args) {
                if (_this.canExecuteSalesFilters) {
                    _this.propertiesManager.enableAllSalesFilters();
                }
                if (_this.canExecuteFilters) {
                    _this.propertiesManager.enableOnlyFilters();
                }
                _this.triggerChangeHandlers();
            });
            this.afterActionFailed(applySalesFilterActionType, function (info, args) {
                _this.reportView.showErrorMessage();
            });
            var applyParameterActionType = types.APPLY_PARAMETER;
            var applyPameterAction = this.findAvailableAction(applyParameterActionType);
            this.propertiesManager.onApplyParameter(function (parameterName, parameterValue) {
                if (parameterName === Manager.PARAMETER_DIMENSION_FILTER) {
                    _this.propertiesManager.disableAllSalesFilters();
                    _this.propertiesManager.updateFocusDimension(parameterValue);
                    _this.execute(applySalesFilterAction, null, null, null);
                }
                _this.propertiesManager.disableOnlyFilters();
                _this.toolbar.displaySaveButton();
                _this.execute(applyPameterAction, parameterName, parameterValue);
            });
            this.afterAction(applyParameterActionType, function (info, args) {
                _this.propertiesManager.setFilterAsApplied(args.args.first());
                _this.propertiesManager.enableOnlyFilters();
                if (args.args.first() === Manager.PARAMETER_DIMENSION_FILTER) {
                    _this.propertiesManager.updateSalesFilters();
                    _this.propertiesManager.enableAllSalesFilters();
                }
                _this.triggerChangeHandlers();
            });
            var applyFilterActionType = types.APPLY_FILTER;
            var applyFilterAction = this.findAvailableAction(applyFilterActionType);
            this.propertiesManager.onApplyFilter(function (filterName, columnName, options) {
                _this.propertiesManager.disableAllFilters();
                _this.propertiesManager.disableAllSalesFilters();
                _this.propertiesManager.setUpdateSalesDimensionPromise();
                _this.toolbar.displaySaveButton();
                _this.propertiesManager.setReportExecuting(true);
                _this.execute(applySalesFilterAction, null, null, null);
                var selectedOptions = Array.isArray(options) ? options.filter(function (option) { return option.selected; }).map(function (option) { return option.label; }) : null;
                _this.filtersApplied.update(filterName, selectedOptions);
                _this.execute(applyFilterAction, filterName, columnName, options);
                var name = filterName.replace(/\s/g, "-");
                if ($("#focus-filter-Group-" + name).length > 0) {
                    $("#focus-filter-Group-" + name + " label input").prop("checked", false);
                    _this.setFocusFilterTextBox();
                }
                _this.canExecuteSalesFilters = false;
                _this.canExecuteFilters = false;
                if (_this.reportView.getReport().getName() === 'OfficeDeepDive') {
                    _this.checkFiltersVisible(_this.reportView.getReport().getActiveSheetName());
                }
            });
            this.afterAction(applyFilterActionType, function (info, args) {
                _this.propertiesManager.setReportExecuting(false);
                _this.propertiesManager.enableOnlyFilters();
                _this.propertiesManager.updateSalesFilters();
                _this.triggerChangeHandlers();
            });
            this.afterActionFailed(applyFilterActionType, function (info, args) {
                _this.reportView.showErrorMessage();
            });
            this.propertiesManager.onError(function () {
                _this.reportView.showErrorMessage();
            });
        };
        Manager.prototype.triggerChangeHandlers = function () {
            var isCustomized = this.cardTitle.isCustomized() || this.reportView.isCustomized() || this.propertiesManager.isCustomized();
            this.changeHandlers.execute(window, [isCustomized]);
        };
        Manager.prototype.setFocusFilterTextBox = function () {
            var values = [];
            $("#focus-filter-option").text("");
            $("#focus-filter-checkboxes input:checked").parent("label").each(function (index, elem) {
                values.push($(elem).text());
            });
            var str = values.toString();
            $("#focus-filter-option").text(str);
            if ($('.focus-Group-filter input:checked').length == 0) {
                $("#focus-filter-option").text("Focus Filters");
            }
        };
        Manager.prototype.initializeSaveAction = function () {
            var _this = this;
            var types = CardView.Actions.ActionType;
            var saveAction = this.findAvailableAction(types.SAVE_TEMPLATE) ||
                this.findAvailableAction(types.SAVE_SHARED) ||
                this.findAvailableAction(types.SAVE_VIEW);
            if (saveAction === null) {
                return;
            }
            this.toolbar.displaySaveButton();
            if (saveAction.getType() === types.SAVE_SHARED) {
                this.reportView.getReport().ready(function () {
                    _this.triggerChangeHandlers();
                });
            }
            this.toolbar.onSaveButtonClick(function () {
                _this.toolbar.disableSaveButton();
                _this.execute(saveAction);
            });
            // Enable disable toolbar save button
            this.changeHandlers.addEventListener(function (isCustomized) {
                if ((isCustomized || saveAction.getType() === types.SAVE_SHARED) && _this.propertiesManager.isSaveable()) {
                    var excludeTitles = ['', 'Name Card Here'];
                    var title = _this.toolbar.getWrapper().find('#report-title-non-mobile-input').val();
                    if (excludeTitles.indexOf(title) === -1) {
                        _this.toolbar.enableSaveButton();
                    }
                }
                else {
                    _this.toolbar.disableSaveButton();
                }
            });
            if (saveAction.getType() !== types.SAVE_SHARED) {
                this.afterAction(saveAction.getType(), function () {
                    _this.cardTitle.saveTitle();
                    _this.propertiesManager.setFilterAsSaved();
                    _this.reportView.setCustomized(false);
                    _this.triggerChangeHandlers();
                });
            }
        };
        Manager.prototype.initializeCopyAction = function () {
            var _this = this;
            var copyAction = this.findAvailableAction(CardView.Actions.ActionType.COPY);
            if (copyAction === null) {
                return;
            }
            this.sideMenu.showCopyButton();
            this.sideMenu.enableCopyButton();
            this.sideMenu.onCopyButtonClick(function () {
                _this.execute(copyAction);
            });
        };
        Manager.prototype.initializeResetAction = function () {
            var _this = this;
            var resetAction = this.findAvailableAction(CardView.Actions.ActionType.RESET);
            if (resetAction === null) {
                return;
            }
            this.sideMenu.showResetButton();
            this.sideMenu.onResetButtonClick(function () {
                _this.filtersApplied.reset();
                _this.execute(resetAction);
            });
            // Enable disable toolbar save button
            this.changeHandlers.addEventListener(function (isCustomized) {
                if (isCustomized) {
                    _this.sideMenu.enableResetButton();
                }
                else {
                    _this.sideMenu.disableResetButton();
                }
            });
            this.afterAction(resetAction.getType(), function () {
                _this.reportView.setCustomized(false);
                _this.triggerChangeHandlers();
            });
        };
        Manager.prototype.initializeChangeActions = function () {
            var _this = this;
            this.cardTitle.onChange(function (title) {
                _this.triggerChangeHandlers();
            });
            this.afterAction(CardView.Actions.ActionType.APPLY_PARAMETER, function () {
                _this.triggerChangeHandlers();
            });
            this.afterAction(CardView.Actions.ActionType.APPLY_FILTER, function () {
                _this.triggerChangeHandlers();
            });
            this.reportView.onChange(function (e) {
                if (e === CardView.CardViewReportEvents.REPORT_CHANGES) {
                    _this.triggerChangeHandlers();
                }
            });
            this.initializeSaveAction();
            this.initializeResetAction();
            this.initializePublishAction();
        };
        Manager.prototype.initializeShareAction = function () {
            var _this = this;
            var shareActionType = CardView.Actions.ActionType.SHARE;
            var shareAction = this.findAvailableAction(shareActionType);
            if (shareAction === null) {
                return;
            }
            this.sideMenu.showShareButton();
            this.sideMenu.enableShareButton();
            this.sideMenu.onShareButtonClick(function () {
                _this.sideMenu.disableShareButton();
                _this.execute(shareAction);
            });
            this.afterAction(shareActionType, function () {
                _this.sideMenu.enableShareButton();
            });
        };
        Manager.prototype.initializeDeleteAction = function () {
            var _this = this;
            var types = CardView.Actions.ActionType;
            var deleteAction = this.findAvailableAction(types.DELETE_PUBLISHED) || this.findAvailableAction(types.DELETE);
            if (deleteAction === null) {
                return;
            }
            this.sideMenu.showDeleteButton();
            this.sideMenu.enableDeleteButton();
            this.sideMenu.onDeleteButtonClick(function () {
                _this.execute(deleteAction);
            });
        };
        Manager.prototype.initializePublishAction = function () {
            var _this = this;
            var publishAction = this.findAvailableAction(CardView.Actions.ActionType.PUBLISH);
            if (publishAction === null) {
                return;
            }
            this.sideMenu.showPublishButton();
            this.sideMenu.enablePublishButton();
            this.sideMenu.onPublishButtonClick(function () {
                _this.execute(publishAction);
            });
            // Enable disable toolbar save button
            this.changeHandlers.addEventListener(function (isCustomized) {
                if (isCustomized) {
                    _this.sideMenu.disablePublishButton();
                }
                else {
                    _this.sideMenu.enablePublishButton();
                }
            });
        };
        Manager.prototype.initializeActions = function () {
            var _this = this;
            this.reportView.getReport().onLoadError(function () {
                _this.reportView.showErrorMessage();
            });
            this.initializeCancelAction();
            this.initializeNewAction();
            this.initializeToggleVizAction();
            this.initializeExportsActions();
            this.initializeBreadCrumbCrawls();
            this.initializeApplyAction();
            this.initializeChangeActions();
            this.initializeShareAction();
            this.initializeCopyAction();
            this.initializeDeleteAction();
        };
        Manager.prototype.executeAction = function (deferred, action, args) {
            var type = action.getType();
            var beforeListeners = this.beforeActionHandlers[type];
            var afterListeners = this.afterActionHandlers[type];
            var afterFailedListeners = this.afterActionFailedHandlers[type];
            var info = this.info;
            var standardArgs = this.createActionArgs(args);
            var listenerArguments = [info, standardArgs].concat(args);
            if (beforeListeners) {
                beforeListeners.execute(window, listenerArguments);
            }
            if (afterListeners) {
                deferred.then(function () {
                    afterListeners.execute(window, listenerArguments);
                });
            }
            if (afterFailedListeners) {
                deferred.fail(function () {
                    afterFailedListeners.execute(window, listenerArguments);
                });
            }
            action.execute(deferred, info, standardArgs);
        };
        Manager.prototype.createActionArgs = function (args) {
            var _this = this;
            var titleToSave = this.cardTitle.title();
            if (titleToSave.trim().toLowerCase() === this.info.getStrings().getInitialCardTitle().toLowerCase()) {
                titleToSave = this.info.getStrings().getUntitledCardTitle();
            }
            return {
                args: args.isEmpty() ? null : args,
                reportView: this.reportView,
                report: this.reportView.getReport(),
                title: titleToSave,
                lastSelectedCrumb: this.breadcrumb.getLastSelectedCrumb(),
                getPropertiesSavePayload: function () {
                    return {
                        categoricalFilters: _this.propertiesManager.getCategoricalFiltersSavePayload(),
                        parameters: _this.propertiesManager.getParametersSavePayload(),
                        categoricalSalesFilters: _this.propertiesManager.getCategoricalSalesFiltersSavePayload()
                    };
                },
                getPropertiesResetPayload: function () {
                    return {
                        parameters: _this.propertiesManager.getParametersResetPayload(),
                        categoricalFilters: _this.propertiesManager.getCategoricalFiltersResetPayload(),
                        columnFilters: _this.propertiesManager.getColumnFiltersName(),
                        categoricalSalesFilters: _this.propertiesManager.getCategoricalSalesFiltersResetPayload()
                    };
                },
                resetPropertiesManager: function () {
                    _this.propertiesManager.reset();
                    _this.propertiesManager.resetSalesFilter();
                },
                resetTitle: function () {
                    _this.cardTitle.resetTitle();
                },
                isPropertiesManagerCustomized: function () {
                    return _this.propertiesManager.isCustomized();
                }
            };
        };
        Manager.prototype.execute = function (action) {
            var _this = this;
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            var actionDeferred = jQuery.Deferred();
            if (this.lastAction === null) {
                this.executeAction(actionDeferred, action, args);
            }
            else {
                this.lastAction.always(function () {
                    _this.executeAction(actionDeferred, action, args);
                });
            }
            this.lastAction = actionDeferred.promise();
        };
        Manager.prototype.resizeCardView = function () {
            this.sideMenu.clearHeight();
            this.reportView.clearHeight();
            var breadCrumbHeight = this.breadcrumb.height();
            var sideMenuHeight = this.sideMenu.isMenuOpen() ? this.sideMenu.height() : 0;
            var sideMenuInternalHeight = this.sideMenu.isMenuOpen() ? this.sideMenu.internalHeight() : 0;
            var reportHeight = CardView.Utils.getReportContentHeight();
            var max = Math.max(sideMenuHeight, reportHeight);
            var reportMinHeight = CardView.Utils.getReportHeight();
            // For opportunity score card, to make report iframe height and iframe parent height to be same, assign sideMenuMinHeight to iframe height
            var sideMenuMinHeight = window.cardData.templateTitle === "QueryBuilder" ? this.reportView.getReport().getIframe().height() : CardView.Utils.getReportParentHeight();
            this.sideMenu.setHeight(max < sideMenuMinHeight ? sideMenuMinHeight : max);
            this.reportView.setIframeHeight(sideMenuInternalHeight);
            this.reportView.setIframeWrapperHeight(sideMenuMinHeight);
            this.reportView.setExternalHeight(max < reportMinHeight ? reportMinHeight : max);
        };
        Manager.prototype.addListeners = function () {
            var _this = this;
            var report = this.reportView.getReport();
            report.onTabSwitched(function (e) {
                _this.breadcrumb.refreshCrumbs(e.getNewSheetName());
                _this.breadcrumb.enable();
            });
            var isSideMenuAnimating = false;
            this.toolbar.onSideMenuButtonTriggered(function () {
                if (isSideMenuAnimating) {
                    return;
                }
                _this.sideMenu.toggle();
            });
            this.sideMenu.onClosed(function () {
                isSideMenuAnimating = false;
                _this.reportView.hideInterceptor();
                _this.toolbar.setSideMenuButtonState(false);
                _this.resizeCardView();
            });
            this.sideMenu.onOpening(function () {
                isSideMenuAnimating = true;
                _this.reportView.showInterceptor();
                _this.toolbar.setSideMenuButtonState(true);
            });
            this.sideMenu.onOpened(function () {
                isSideMenuAnimating = false;
                _this.resizeCardView();
            });
            this.sideMenu.onResize(function () {
                _this.resizeCardView();
            });
            this.reportView.getReport().ready(function () {
                _this.reportView.onResize(function () {
                    _this.resizeCardView();
                });
            });
        };
        Manager.prototype.checkFiltersVisible = function (deepDive) {
            this.checkTagVisible(deepDive);
            /*if(deepDive == 'SmaDeepDive') {
                $("#ws-group-filter-timeframe").show();
                $("#ws-categorical-filter-firm").show();
                $("#ws-group-filter-location").show();
                $("#ws-categorical-filter-asset-class").show();
                $("#ws-categorical-filter-category").show();
                $("#ws-group-filter-sales").show();
                $("#ws-categorical-filter-channel").hide();
                $("#ws-categorical-filter-product").hide();
                $("#ws-group-filter-analytics").hide();
                $("#ws-categorical-filter-home-office").hide();
                $("#HomeOfficeTag").hide();
                $("#ws-alt-categorical-filter-channel").hide();
                $("#ws-alt-categorical-filter-firm").hide();
                $("#ws-alt-group-filter-location").hide();
            
            } else*/ if (deepDive == 'AltsDeepDive') {
                $("#ws-alt-categorical-filter-channel").show();
                $("#ws-alt-categorical-filter-firm").show();
                $("#ws-alt-group-filter-location").show();
                $("#ws-alt-categorical-filter-channel").find('.side-menu-label').css('border-top', 'none');
                $("#ws-categorical-filter-channel").hide();
                $("#ws-categorical-filter-firm").hide();
                $("#ws-group-filter-location").hide();
                $("#ws-group-filter-timeframe").hide();
                $("#ws-categorical-filter-asset-class").hide();
                $("#ws-categorical-filter-category").hide();
                $("#ws-categorical-filter-product").hide();
                $("#ws-group-filter-analytics").hide();
                $("#ws-group-filter-sales").hide();
                $("#ws-categorical-filter-home-office").hide();
                $("#HomeOfficeTag").hide();
            }
            else {
                $("#ws-group-filter-timeframe").show();
                $("#ws-categorical-filter-channel").show();
                $("#ws-categorical-filter-channel").find('.side-menu-label').css('border-top', '');
                $("#ws-categorical-filter-firm").show();
                $("#ws-group-filter-location").show();
                $("#ws-categorical-filter-asset-class").show();
                $("#ws-categorical-filter-category").show();
                $("#ws-categorical-filter-product").show();
                $("#ws-group-filter-analytics").show();
                $("#ws-group-filter-sales").show();
                $("#ws-categorical-filter-home-office").show();
                $("#HomeOfficeTag").show();
                $("#ws-alt-categorical-filter-channel").hide();
                $("#ws-alt-categorical-filter-firm").hide();
                $("#ws-alt-group-filter-location").hide();
            }
        };
        Manager.prototype.checkTagVisible = function (deepDive) {
            if (deepDive == 'AltsDeepDive') {
                $(".filters-applied-option").each(function () {
                    if (this.id.contains('Alt')) {
                        $('#' + this.id).show();
                    }
                    else {
                        $('#' + this.id).hide();
                    }
                });
            }
            else {
                $(".filters-applied-option").each(function () {
                    if (this.id.contains('Alt')) {
                        $('#' + this.id).hide();
                    }
                    else {
                        $('#' + this.id).show();
                    }
                });
            }
        };
        Manager.PARAMETER_DIMENSION_FILTER = 'Dimension';
        return Manager;
    }());
    CardView.Manager = Manager;
})(CardView || (CardView = {}));
var CardView;
(function (CardView) {
    var Initializer = (function () {
        function Initializer(cardData) {
            this.cardData = cardData;
        }
        Initializer.prototype.initialize = function () {
            var _this = this;
            this.loadInfo = new CardView.LoadInfo.Manager(this.cardData);
            this.reportView = new CardView.ReportView({
                info: this.loadInfo,
                wrapper: $('#report-wrapper .report-content'),
                background: $('#report-wrapper .report-content, #wrapper'),
            });
            this.cardTitle = new CardView.CardTitle({
                'cardTitleWrapper': $('#wrapper .content .toolbar'),
                'actions': {
                    attachInterceptor: function () {
                        _this.reportView.showInterceptor();
                    },
                    dettachInterceptor: function () {
                        _this.reportView.hideInterceptor();
                    }
                },
                'title': this.loadInfo.getProperties().getTitle(),
                'strings': this.loadInfo.getStrings().raw(),
                'environment': this.loadInfo.getEnvironmentProperties().getEnvironmentType()
            });
            this.propertiesManager = new CardView.PropertiesManager({
                info: this.loadInfo
            });
            var title = this.loadInfo.getCardMetadata().getTemplateTitle();
            if (title.toLowerCase().contains('deepdive')) {
                this.breadcrumb = new CardView.BreadCrumb({
                    info: this.loadInfo,
                    wrapper: $('#wrapper .content .toolbar .sheet-crumb-wrapper')
                });
            }
            else {
                this.breadcrumb = new CardView.BreadCrumb({
                    info: this.loadInfo,
                    wrapper: $('#report-wrapper .report-content .sheet-crumb-wrapper')
                });
            }
            if ($('#report-wrapper .report-content .filters-applied-wrapper').length > 0) {
                this.filtersApplied = new CardView.FiltersApplied({
                    info: this.loadInfo,
                    wrapper: $('#report-wrapper .report-content .filters-applied-wrapper')
                });
            }
            else if ($('#report-wrapper .report-content .office-filters-applied-wrapper').length > 0) {
                this.filtersApplied = new CardView.FiltersApplied({
                    info: this.loadInfo,
                    wrapper: $('#report-wrapper .report-content #office-filters-applied-criteria')
                });
            }
            else if ($('#report-wrapper .report-content .alternatives-filters-applied-wrapper').length > 0) {
                this.filtersApplied = new CardView.FiltersApplied({
                    info: this.loadInfo,
                    wrapper: $('#report-wrapper .report-content .alternatives-filters-applied-wrapper')
                });
            }
            this.userSettings = new CardView.UserSettings({
                info: this.loadInfo,
                wrapper: $('#report-wrapper .report-content #focus-filter-selection')
            });
            this.sideMenu = new CardView.SideMenu({
                info: this.loadInfo,
                wrapper: $('#report-wrapper > ul'),
                strings: this.loadInfo.getStrings()
            });
            this.toolbarControls = new CardView.ToolbarControls({
                info: this.loadInfo,
                wrapper: $('#wrapper .content .toolbar')
            });
            this.manager = new CardView.Manager({
                toolbar: this.toolbarControls,
                cardTitle: this.cardTitle,
                info: this.loadInfo,
                reportView: this.reportView,
                propertiesManager: this.propertiesManager,
                breadcrumb: this.breadcrumb,
                filtersApplied: this.filtersApplied,
                sideMenu: this.sideMenu,
                userSettings: this.userSettings
            });
            this.manager.initialize();
            this.addEventListener();
            this.showDataDisclaimer();
            this.initializeAnalytics();
            this.focusFilter = new CardView.FocusFilters({
                info: this.loadInfo,
                wrapper: $('#report-wrapper .report-content #focus-filter-selection'),
                reportView: this.reportView,
                filtersApplied: this.filtersApplied,
            });
        };
        Initializer.prototype.showDataDisclaimer = function () {
            var strings = this.loadInfo.getStrings();
            if (strings.hasDataDisclaimer()) {
                Kasina.messages.get().warning(strings.getDataDisclaimer(), true, true);
            }
        };
        Initializer.prototype.updateDocumentTitle = function () {
            if (this.cardTitle.title().trim().toLowerCase() === this.loadInfo.getStrings().getInitialCardTitle().toLowerCase()) {
                document.title = "SS&C - WalletShare";
            }
            else {
                document.title = this.cardTitle.title();
            }
        };
        Initializer.prototype.addEventListener = function () {
            var _this = this;
            // Updating the page title when the title of the cards update
            this.cardTitle.onChange(function (title) {
                _this.updateDocumentTitle();
                Analytics.registerCardTitleEvent();
            });
            this.updateDocumentTitle();
        };
        Initializer.prototype.initializeAnalytics = function () {
            var env = this.loadInfo.getEnvironmentProperties().getEnvironmentType();
            var sheetManager = this.loadInfo.getCardMetadata().getReportMetadata().getSheetByEnvironment(env);
            Analytics.setPageUrl('/card/' + sheetManager.getChartSheetName());
            Analytics.setPageTitle(this.loadInfo.getCardMetadata().getTemplateTitle());
            this.reportView.getReport().analytics(function (e) {
                var EventsEnum = ReportAnalytics.EventsEnum;
                switch (e.getEventName()) {
                    case EventsEnum.ROTATION_BUILDER_FORWARD:
                        Analytics.registerRotationBuilderNextButton();
                        break;
                    case EventsEnum.ROTATION_BUILDER_BACKWARD:
                        Analytics.registerRotationBuilderBackButton();
                        break;
                    case EventsEnum.ROTATION_BUILDER_CHANGE_TAB:
                        Analytics.registerRotationBuilderTabEvent();
                        break;
                    case EventsEnum.ROTATION_BUILDER_SLIDER_MENU_INTERACTION:
                        Analytics.registerRotationBuilderSliderMenuInteraction();
                        break;
                    case EventsEnum.ROTATION_BUILDER_BY_OFFICE_LOCATION:
                        Analytics.registerRotationBuilderByOfficeLocation();
                        break;
                    case EventsEnum.ROTATION_BUILDER_BY_OFFICE_FIRM:
                        Analytics.registerRotationBuilderByOfficeFirm();
                        break;
                    case EventsEnum.ROTATION_BUILDER_BY_OFFICE_OFFICE:
                        Analytics.registerRotationBuilderByOfficeOffice();
                        break;
                    case EventsEnum.ROTATION_BUILDER_BY_OFFICE_RADIUS:
                        Analytics.registerRotationBuilderByOfficeRadius();
                        break;
                    case EventsEnum.ROTATION_BUILDER_BY_LOCATION_TERRITORY:
                        Analytics.registerRotationBuilderByLocationTerritory();
                        break;
                    case EventsEnum.ROTATION_BUILDER_BY_LOCATION_STATE:
                        Analytics.registerRotationBuilderByLocationState();
                        break;
                    case EventsEnum.ROTATION_BUILDER_BY_LOCATION_CITY:
                        Analytics.registerRotationBuilderByLocationCity();
                        break;
                    case EventsEnum.ROTATION_BUILDER_BY_LOCATION_ZIPCODE:
                        Analytics.registerRotationBuilderByLocationZipCode();
                        break;
                    case EventsEnum.ROTATION_BUILDER_FOCUS_CHANNELS:
                        Analytics.registerRotationBuilderFocusChannels();
                        break;
                    case EventsEnum.ROTATION_BUILDER_FOCUS_FIRMS:
                        Analytics.registerRotationBuilderFocusFirms();
                        break;
                    case EventsEnum.ROTATION_BUILDER_FOCUS_PRODUCTS:
                        Analytics.registerRotationBuilderFocusProducts();
                        break;
                    case EventsEnum.ROTATION_BUILDER_SELECTION_ADD_OFFICE_BY_MENU:
                        Analytics.registerRotationBuilderSelectionAddOfficeByMenu();
                        break;
                    case EventsEnum.ROTATION_BUILDER_SELECTION_REMOVE_OFFICE_BY_MENU:
                        Analytics.registerRotationBuilderSelectionRemoveOfficeByMenu();
                        break;
                    case EventsEnum.ROTATION_BUILDER_SELECTION_FOCUS_OFFICE_BY_MENU:
                        Analytics.registerRotationBuilderSelectionFocusOfficeByMenu();
                        break;
                    case EventsEnum.ROTATION_BUILDER_SELECTION_VIEW_BY_CHANGE:
                        Analytics.registerRotationBuilderSelectionViewByChange();
                        break;
                    case EventsEnum.ROTATION_BUILDER_SELECTION_PAGINATION_CHANGE:
                        Analytics.registerRotationBuilderSelectionPaginationChange();
                        break;
                    case EventsEnum.ROTATION_BUILDER_SELECTION_ADD_OFFICE_BY_MAP:
                        Analytics.registerRotationBuilderSelectionAddOfficeByMap();
                        break;
                    case EventsEnum.ROTATION_BUILDER_SELECTION_REMOVE_OFFICE_BY_MAP:
                        Analytics.registerRotationBuilderSelectionRemoveOfficeByMap();
                        break;
                    case EventsEnum.ROTATION_BUILDER_SELECTION_EXCLUDE_OFFICE_BY_MAP:
                        Analytics.registerRotationBuilderSelectionExcludeOfficeByMap();
                        break;
                    case EventsEnum.ROTATION_BUILDER_SELECTION_FOCUS_OFFICE_BY_MAP:
                        Analytics.registerRotationBuilderSelectionFocusOfficeByMap();
                        break;
                    case EventsEnum.ROTATION_BUILDER_SELECTION_ANCHOR_POINT:
                        Analytics.registerRotationBuilderSelectionAnchorPointer();
                        break;
                    case EventsEnum.ROTATION_BUILDER_SUMMARY_SORT_OFFICES:
                        Analytics.registerRotationBuilderSummarySortOffices();
                        break;
                    case EventsEnum.ROTATION_BUILDER_SUMMARY_REMOVE_OFFICE_BY_MENU:
                        Analytics.registerRotationBuilderSummaryRemoveOffices();
                        break;
                    case EventsEnum.ROTATION_BUILDER_SUMMARY_FOCUS_OFFICE_BY_MENU:
                        Analytics.registerRotationBuilderSummaryFocusOffices();
                        break;
                    case EventsEnum.ROTATION_BUILDER_SUMMARY_FOCUS_OFFICE_BY_MAP:
                        Analytics.registerRotationBuilderSummaryFocusOfficesByMap();
                        break;
                    case EventsEnum.TARGET_MATRIX_TERRITORY_TOOLTIP_LINK:
                        Analytics.registerTargetMatrixTooltipTerritoryEvent();
                        break;
                    case EventsEnum.TARGET_MATRIX_ASSET_CLASS_TOOLTIP_LINK:
                        Analytics.registerTargetMatrixTooltipAssetClassEvent();
                        break;
                    case EventsEnum.TARGET_MATRIX_CHANNEL_TOOLTIP_LINK:
                        Analytics.registerTargetMatrixTooltipChannelEvent();
                        break;
                    case EventsEnum.TARGET_MATRIX_FIRM_TOOLTIP_LINK:
                        Analytics.registerTargetMatrixTooltipFirmEvent();
                        break;
                    case EventsEnum.TARGET_MATRIX_OFFICE_TOOLTIP_LINK:
                        Analytics.registerTargetMatrixTooltipOfficeEvent();
                        break;
                    case EventsEnum.TARGET_MATRIX_CATEGORY_TOOLTIP_LINK:
                        Analytics.registerTargetMatrixTooltipCategoryEvent();
                        break;
                    case EventsEnum.TOP_OFF_SORT_BY_SALES_AUM_GREEN_SPACE:
                        Analytics.eventOfficeDeepDiveSortByAUMGreenSpace();
                        break;
                    case EventsEnum.TOP_OFF_SORT_BY_SALES_TOTAL_AUM:
                        Analytics.eventOfficeDeepDiveSortByTotalAUM();
                        break;
                    case EventsEnum.TOP_OFF_SORT_BY_SALES_GREEN_SPACE:
                        Analytics.eventOfficeDeepDiveSortBySalesGreenSpace();
                        break;
                    case EventsEnum.TOP_OFF_SORT_BY_SALES_TOTAL_SALES:
                        Analytics.eventOfficeDeepDiveSortByTotalSales();
                        break;
                    case EventsEnum.TOP_OFF_SEE_TOP_ADVISORS:
                        Analytics.eventOfficeDeepDiveSeeTopAdvisors();
                        break;
                    case EventsEnum.TOP_OFF_SHARE_CLASS_OVERALL:
                        Analytics.eventOfficeDeepDiveFilterByShareClassOverall();
                        break;
                    case EventsEnum.TOP_OFF_SHARE_CLASS_ADVISORY:
                        Analytics.eventOfficeDeepDiveFilterByShareClassAdvisory();
                        break;
                    case EventsEnum.TOP_OFF_SHARE_CLASS_BROKERAGE:
                        Analytics.eventOfficeDeepDiveFilterByShareClassBrokerage();
                        break;
                    case EventsEnum.OFFICE_DETAILS_REPORT:
                        Analytics.registerOfficeDetailsReport();
                        break;
                    case EventsEnum.OFFICE_DETAILS_CATEGORY_PRODUCT_ANALYSIS_SUBTAB:
                        Analytics.registerOfficeDetailsCategoryProductAnalysisSubtab();
                        break;
                    case EventsEnum.OFFICE_DETAILS_CATEGORY_TOP_ADVISORS_SUBTAB:
                        Analytics.registerOfficeDetailsCategoryTopAdvisorsSubtab();
                        break;
                    case EventsEnum.OFFICE_DETAILS_CATEGORY_MENU:
                        Analytics.registerOfficeDetailsCategoryMenu(e.getArg());
                        break;
                    case EventsEnum.OFFICE_DETAILS_CATEGORY_DETAIL_MATCHUP:
                        Analytics.registerOfficeDetailsCategoryDetailMatchup(e.getArg());
                        break;
                    case EventsEnum.OFFICE_DETAILS_CATEGORY_DETAIL_TOP_ADVISORS_LIST:
                        Analytics.registerOfficeDetailsCategoryDetailTopAdvisorsList(e.getArg());
                        break;
                    case EventsEnum.OFFICE_DETAILS_TAB_CATEGORY:
                        Analytics.eventOfficeDetailsTabCategory();
                        break;
                    case EventsEnum.OFFICE_DETAILS_TAB_OFFICE_OVERVIEW:
                        Analytics.eventOfficeDetailsTabOfficeOverview();
                        break;
                    case EventsEnum.OFFICE_DETAILS_TAB_ADVISOR_DETAIL:
                        Analytics.eventOfficeDetailsTabAdvisorDetail();
                        break;
                    case EventsEnum.OFFICE_DETAILS_TIMEFRAME_PRIOR_1_MONTHS:
                        Analytics.eventOfficeDetailsFilterByTimeframePrior1Months();
                        break;
                    case EventsEnum.OFFICE_DETAILS_TIMEFRAME_PRIOR_3_MONTHS:
                        Analytics.eventOfficeDetailsFilterByTimeframePrior3Months();
                        break;
                    case EventsEnum.OFFICE_DETAILS_TIMEFRAME_PRIOR_6_MONTHS:
                        Analytics.eventOfficeDetailsFilterByTimeframePrior6Months();
                        break;
                    case EventsEnum.OFFICE_DETAILS_SHARE_CLASS_OVERALL:
                        Analytics.eventOfficeDetailsFilterByShareClassOverall();
                        break;
                    case EventsEnum.OFFICE_DETAILS_SHARE_CLASS_ADVISORY:
                        Analytics.eventOfficeDetailsFilterByShareClassAdvisory();
                        break;
                    case EventsEnum.OFFICE_DETAILS_SHARE_CLASS_BROKERAGE:
                        Analytics.eventOfficeDetailsFilterByShareClassBrokerage();
                        break;
                    case EventsEnum.OFFICE_DETAILS_ADVISOR_DETAIL_PORTFOLIO_ALLOCATION:
                        Analytics.eventOfficeDetailsAdvisorPortfolioAllocation(e.getArg());
                        break;
                    case EventsEnum.OFFICE_DETAILS_ADVISOR_DETAIL_ADVISOR_MENU:
                        Analytics.eventOfficeDetailsAdvisorMenu(e.getArg());
                        break;
                    case EventsEnum.OFFICE_DETAILS_ADVISOR_DETAIL_COMPARE_BY:
                        Analytics.eventOfficeDetailsAdvisorCompareBy(e.getArg());
                        break;
                    case EventsEnum.OFFICE_DETAILS_ADVISOR_DETAIL_MODEL_USAGE_FILTER:
                        Analytics.eventOfficeDetailsAdvisorCompareBy(e.getArg());
                        break;
                }
            });
        };
        return Initializer;
    }());
    var cardData = window.cardData || null;
    if (cardData !== null) {
        var initializer = new Initializer(cardData);
        $(document).ready(function () {
            initializer.initialize();
        });
    }
})(CardView || (CardView = {}));
///<reference path="35.properties_manager.ts"/>
///<reference path="27.toolbar.ts"/>
///<reference path="36.filters_applied.ts"/>
var CardView;
(function (CardView) {
    var FocusFilters = (function () {
        function FocusFilters(options) {
            this.GET_SHARED_FILTERS = '/focusFilter/shared';
            this.filterList = [];
            this.wrapper = options.wrapper;
            this.strings = options.info.getStrings();
            this.info = options.info;
            this.reportView = options.reportView;
            this.options = options;
            this.filtersApplied = options.filtersApplied;
            this.loadData();
        }
        FocusFilters.prototype.setFocusFilters = function () {
            var selectBoxWrapper = $('<div>', { 'class': 'multi-select-wrapper' });
            var selectBox = $('<div>', { 'class': 'focus-filter-selectBox' });
            var select = ($('<select>', { 'id': 'focus-filter-select' }));
            select.append($('<option>', { 'id': 'focus-filter-option' }).text('Focus Filters'));
            selectBox.append(select);
            selectBox.append($('<div>', { 'class': 'overSelect' }));
            selectBoxWrapper.append(selectBox);
            var checkBoxes = $('<div>', {
                'id': 'focus-filter-checkboxes',
                'class': 'focus-filter-checkboxes display-none'
            });
            selectBoxWrapper.append(checkBoxes);
            this.wrapper.append(selectBoxWrapper);
            this.shareFocusFilterList.forEach(function (focusFilter) {
                var filterData = focusFilter.dimension.filterName;
                var filterName = filterData.replace(/\s/g, "-");
                var nameData = focusFilter.name;
                var focusName = focusFilter.name.replace(/ /g, "-").toLowerCase();
                if ($("#focus-filter-Group-" + filterName).length == 0) {
                    var divGroup = $('<div>', {
                        'id': 'focus-filter-Group-' + filterName,
                        'class': 'focus-Group-filter',
                        'text': 'Focus: ' + filterData
                    });
                    var $label = $("<label>", { 'for': 'focus-' + focusName + '-criteria' }).append($('<input>', {
                        'type': 'checkbox',
                        'id': 'focus-' + focusName + '-criteria'
                    }));
                    $label.append(nameData);
                    divGroup.append($label);
                    checkBoxes.append(divGroup);
                }
                else {
                    var $label = $("<label>", { 'for': 'focus-' + focusName + '-criteria' }).append($('<input>', {
                        'type': 'checkbox',
                        'id': 'focus-' + focusName + '-criteria'
                    }));
                    $label.append(nameData);
                    $("#focus-filter-Group-" + filterName).append($label);
                }
            });
        };
        FocusFilters.prototype.showDropDownDetails = function () {
            var expanded = false;
            $('.focus-filter-selectBox').click(function (e) {
                if (!expanded) {
                    $('#focus-filter-checkboxes').removeClass('display-none');
                    expanded = true;
                }
                else {
                    $('#focus-filter-checkboxes').addClass('display-none');
                    expanded = false;
                }
            });
        };
        FocusFilters.prototype.fadeMessage = function () {
            var modal = $("#focus-filter-message");
            modal.removeClass("hidden");
            modal.fadeIn(1000, function () {
                $(this).delay(2000);
                modal.fadeOut(2000, function () {
                });
            });
        };
        FocusFilters.prototype.checkGroupPermissions = function () {
            var permissions = this.options.info.getProperties().getProductsPermission();
            var templatePermissions = this.options.info.getProperties().getTemplatePermissions();
            if (permissions.contains('Alts Only')) {
                $('.focus-group-button:nth-child(1)').hide();
                $('.focus-group-button:nth-child(2)').hide();
                $('.focus-group-button:nth-child(3)').hide();
            }
            else {
                if (!(permissions.contains("Advisor Team") && templatePermissions.contains('Advisor Teams Deep Dive'))) {
                    $('.focus-group-button:nth-child(2)').hide();
                }
                if (!permissions.contains("Advisor")) {
                    $('.focus-group-button:nth-child(3)').hide();
                }
                if (!templatePermissions.contains("Advisor Deep Dive")) {
                    $('.focus-group-button:nth-child(3)').hide();
                }
                if (!(permissions.contains('Alternatives') && templatePermissions.contains('Alternatives-Deep Dive'))) {
                    $('.focus-group-button:nth-child(4)').hide();
                }
            }
        };
        FocusFilters.prototype.selectGroups = function () {
            var that = this;
            $('.focus-group-button, .focus-group-button span').on('click', function (e) {
                $(".focus-group-button").removeClass('active');
                if (e.target.className.contains('focus-group-button')) {
                    $(e.target).addClass('active');
                }
                else {
                    $(e.target).parent('button').addClass('active');
                }
                if (($(e.target).text().trim() == 'Office')) {
                    $("#crp-deep-dive-office-grid-component", $('iframe').contents()).removeClass("hidden");
                    $("#crp-deep-dive-advisor-teams-grid-component", $('iframe').contents()).addClass("hidden");
                    $("#crp-deep-dive-advisors-grid-component", $('iframe').contents()).addClass("hidden");
                    $("#crp-deep-dive-alts-grid-component", $('iframe').contents()).addClass("hidden");
                    that.checkFiltersVisible($(e.target).text().trim());
                    that.reportView.activateSheet("OfficeDeepDive");
                }
                else if (($(e.target).text().trim() == 'Advisor Teams')) {
                    $("#crp-deep-dive-office-grid-component", $('iframe').contents()).addClass("hidden");
                    $("#crp-deep-dive-advisor-teams-grid-component", $('iframe').contents()).removeClass("hidden");
                    $("#crp-deep-dive-advisors-grid-component", $('iframe').contents()).addClass("hidden");
                    $("#crp-deep-dive-alts-grid-component", $('iframe').contents()).addClass("hidden");
                    that.checkFiltersVisible($(e.target).text().trim());
                    that.reportView.activateSheet("TeamDeepDive");
                }
                else if (($(e.target).text().trim() == 'Advisors')) {
                    $("#crp-deep-dive-office-grid-component", $('iframe').contents()).addClass("hidden");
                    $("#crp-deep-dive-advisor-teams-grid-component", $('iframe').contents()).addClass("hidden");
                    $("#crp-deep-dive-advisors-grid-component", $('iframe').contents()).removeClass("hidden");
                    $("#crp-deep-dive-alts-grid-component", $('iframe').contents()).addClass("hidden");
                    that.checkFiltersVisible($(e.target).text().trim());
                    that.reportView.activateSheet("AdvisorDeepDive");
                }
                else if (($(e.target).text().trim() == 'Alternatives')) {
                    $("#crp-deep-dive-office-grid-component", $('iframe').contents()).addClass("hidden");
                    $("#crp-deep-dive-advisor-teams-grid-component", $('iframe').contents()).addClass("hidden");
                    $("#crp-deep-dive-advisors-grid-component", $('iframe').contents()).addClass("hidden");
                    $("#crp-deep-dive-alts-grid-component", $('iframe').contents()).removeClass("hidden");
                    that.checkFiltersVisible($(e.target).text().trim());
                    that.reportView.activateSheet("AltsDeepDive");
                }
            });
        };
        FocusFilters.prototype.checkFiltersVisible = function (deepDive) {
            this.checkTagVisible(deepDive);
            if (deepDive == 'Alternatives') {
                $("#ws-categorical-filter-channel").show();
                $("#ws-categorical-filter-channel").find('.side-menu-label').css('border-top', 'none');
                $("#ws-categorical-filter-firm").show();
                $("#ws-group-filter-location").show();
                $("#ws-alt-categorical-filter-channel").show();
                $("#ws-alt-categorical-filter-firm").show();
                $("#ws-alt-group-filter-location").show();
                $("#ws-alt-categorical-filter-channel").find('.side-menu-label').css('border-top', 'none');
                $("#ws-categorical-filter-channel").hide();
                $("#ws-categorical-filter-firm").hide();
                $("#ws-group-filter-location").hide();
                $("#ws-group-filter-timeframe").hide();
                $("#ws-categorical-filter-asset-class").hide();
                $("#ws-categorical-filter-category").hide();
                $("#ws-categorical-filter-product").hide();
                $("#ws-group-filter-analytics").hide();
                $("#ws-group-filter-sales").hide();
                $("#ws-categorical-filter-home-office").hide();
                $("#HomeOfficeTag").hide();
            }
            else {
                $("#ws-group-filter-timeframe").show();
                $("#ws-categorical-filter-channel").show();
                $("#ws-categorical-filter-channel").find('.side-menu-label').css('border-top', '');
                $("#ws-categorical-filter-firm").show();
                $("#ws-group-filter-location").show();
                $("#ws-categorical-filter-asset-class").show();
                $("#ws-categorical-filter-category").show();
                $("#ws-categorical-filter-product").show();
                $("#ws-group-filter-analytics").show();
                $("#ws-group-filter-sales").show();
                $("#ws-categorical-filter-home-office").show();
                $("#HomeOfficeTag").show();
                $("#ws-alt-categorical-filter-channel").hide();
                $("#ws-alt-categorical-filter-firm").hide();
                $("#ws-alt-group-filter-location").hide();
            }
        };
        FocusFilters.prototype.checkTagVisible = function (deepDive) {
            if (deepDive == 'Alternatives') {
                $(".filters-applied-option").each(function () {
                    if (this.id.contains('Alt')) {
                        $('#' + this.id).show();
                    }
                    else {
                        $('#' + this.id).hide();
                    }
                });
            }
            else {
                $(".filters-applied-option").each(function () {
                    if (this.id.contains('Alt')) {
                        $('#' + this.id).hide();
                    }
                    else {
                        $('#' + this.id).show();
                    }
                });
            }
        };
        FocusFilters.prototype.getSharedFocusFilters = function () {
            return this.focusFilterPostCaller(this.GET_SHARED_FILTERS, 'POST', "", this.loginContentCheck);
        };
        FocusFilters.prototype.focusFilterPostCaller = function (route, method, payload, errorChecker) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            jQuery.ajax({
                'method': method,
                'url': route,
                'data': JSON.stringify(payload),
                'contentType': 'application/json'
            }).then(function (content, textStatus, xhr) {
                if (errorChecker(xhr, content)) {
                    //user needs to log in again
                    deferred.reject(303);
                }
                else {
                    deferred.resolve(content);
                }
            }).fail(function (error) {
                if (error.status == 403) {
                    //redirect window above crp iframe to the origin url
                    window.top.location.href = window.location.origin;
                }
                deferred.reject(error);
            });
            return promise;
        };
        FocusFilters.prototype.loginContentCheck = function (xhr, content) {
            return xhr.responseText === "" || xhr.responseText !== content;
        };
        FocusFilters.prototype.getAllShareFocusFilters = function () {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var results = this.getSharedFocusFilters();
            results.then(function (data) {
                var jsonData = JSON.parse(data);
                deferred.resolveWith(window, [jsonData]);
            }).fail(function (error) {
                //console.log(error);
            });
            return promise;
        };
        FocusFilters.prototype.onFocusFiltersClick = function () {
            var _this = this;
            $("#focus-filter-checkboxes input").on('click', function (e) {
                $(e.target).parent("label").siblings().find('input:checkbox').prop('checked', false);
                var values = [];
                $("#focus-filter-option").text("");
                $("#focus-filter-checkboxes input:checked").parent("label").each(function (index, elem) {
                    values.push($(elem).text());
                });
                var str = values.toString();
                $("#focus-filter-option").text(str);
                if ($('.focus-Group-filter input:checked').length == 0) {
                    $("#focus-filter-option").text("Focus Filters");
                }
                var value = $(e.target).parent("label").text();
                if ($(e.target).prop('checked') === true) {
                    _this.filterList.forEach(function (data) {
                        if (data.filterName == value) {
                            _this.filtersApplied.update(data.name, data.options);
                            _this.reportView.getReport().applyFilter(data.name, "", data.options);
                            return;
                        }
                    });
                }
                else {
                    _this.filterList.forEach(function (data) {
                        if (data.filterName == value) {
                            _this.filtersApplied.remove(data.name);
                            _this.reportView.getReport().applyFilter(data.name, "", null);
                            return;
                        }
                    });
                }
            });
        };
        FocusFilters.prototype.setFocusFilterList = function () {
            var _this = this;
            this.shareFocusFilterList.forEach(function (focusFilter) {
                var options = [];
                focusFilter.dimension.options.forEach(function (data) {
                    options.push(data.formattedValue);
                });
                var newFilterList = {
                    filterName: focusFilter.name,
                    name: focusFilter.dimension.filterName,
                    options: options
                };
                _this.filterList.push(newFilterList);
            });
        };
        FocusFilters.prototype.loadData = function () {
            var _this = this;
            var sharedFocusFilters = this.getAllShareFocusFilters();
            sharedFocusFilters.then(function (content) {
                _this.sharedFocusFilter = content;
                _this.shareFocusFilterList = _this.sharedFocusFilter.data;
                _this.setFocusFilters();
                _this.setFocusFilterList();
                _this.onFocusFiltersClick();
                _this.showDropDownDetails();
            });
            this.checkGroupPermissions();
            this.selectGroups();
        };
        return FocusFilters;
    }());
    CardView.FocusFilters = FocusFilters;
})(CardView || (CardView = {}));
///<reference path="35.properties_manager.ts"/>
///<reference path="27.toolbar.ts"/>
var CardView;
(function (CardView) {
    var UserSettings = (function () {
        function UserSettings(options) {
            this.ADD_DFAULT_PAGE = '/default/setUserSettings';
            this.GET_DEFAULT_PAGE = '/default/getUserSettings';
            this.TABS_LIST = ['Office', 'Advisor Teams', 'Advisors', 'Alternatives'];
            this.OFFICE_DEEP_DIVE = 'OfficeDeepDive';
            this.TEAMS_DEEP_DIVE = 'TeamDeepDive';
            this.ADVISOR_DEEP_DIVE = 'AdvisorDeepDive';
            //private SMA_DEEP_DIVE = 'SmaDeepDive';
            this.ALTS_DEEP_DIVE = 'AltsDeepDive';
            if (options.info.getProperties().getProductsPermission().contains('Alts Only')) {
                this.isAltsOnly = true;
            }
            else {
                this.isAltsOnly = false;
            }
            this.loadData();
        }
        UserSettings.prototype.getUserSettings = function () {
            var _this = this;
            this.result = this.getDefaultUserSettings();
            this.result.then(function (content) {
                _this.setActive(content);
            });
        };
        UserSettings.prototype.setActive = function (content) {
            var isAltsOnly = this.isAltsOnly;
            $('.focus-group-button').removeClass('active');
            $('.focus-group-button').each(function (index, item) {
                $($('.focus-group-button span')[index]).removeClass('fa fa-star set-office-default-page');
                if (isAltsOnly) {
                    if ($(this).text().trim() === 'Alternatives') {
                        $(this).addClass('active');
                        $('.default-deep-dive-set-up.open-sans').html('Current Deep Dive Default');
                        $('.current-deep-dive').removeClass('blue-text');
                        $($('.focus-group-button span')[index]).addClass('fa fa-star set-office-default-page');
                    }
                }
                else if (content.result !== null) {
                    if ($(this).text().trim() === content.result.customValue) {
                        $(this).addClass('active');
                        $('.default-deep-dive-set-up.open-sans').html('Current Deep Dive Default');
                        $('.current-deep-dive').removeClass('blue-text');
                        $($('.focus-group-button span')[index]).addClass('fa fa-star set-office-default-page');
                    }
                }
                else {
                    if ($(this).text().trim() === 'Office') {
                        $(this).addClass('active');
                        $('.default-deep-dive-set-up.open-sans').html('Current Deep Dive Default');
                        $('.current-deep-dive').removeClass('blue-text');
                        $($('.focus-group-button span')[index]).addClass('fa fa-star set-office-default-page');
                    }
                }
            });
            $('.focus-group-button').click(function (e1) {
                if (isAltsOnly) {
                    if (e1.target.textContent === 'Alternatives') {
                        $('.default-deep-dive-set-up.open-sans').html('Current Deep Dive Default');
                        $('.current-deep-dive').removeClass('blue-text');
                    }
                    else {
                        $('.default-deep-dive-set-up.open-sans').html('Set Page as Deep Dive Default');
                        $('.current-deep-dive').addClass('blue-text');
                    }
                }
                else if (content.result !== null) {
                    if (e1.target.textContent === content.result.customValue) {
                        $('.default-deep-dive-set-up.open-sans').html('Current Deep Dive Default');
                        $('.current-deep-dive').removeClass('blue-text');
                    }
                    else {
                        $('.default-deep-dive-set-up.open-sans').html('Set Page as Deep Dive Default');
                        $('.current-deep-dive').addClass('blue-text');
                    }
                }
                else {
                    if (e1.target.textContent === 'Office') {
                        $('.default-deep-dive-set-up.open-sans').html('Current Deep Dive Default');
                        $('.current-deep-dive').removeClass('blue-text');
                    }
                    else {
                        $('.default-deep-dive-set-up.open-sans').html('Set Page as Deep Dive Default');
                        $('.current-deep-dive').addClass('blue-text');
                    }
                }
            });
        };
        UserSettings.prototype.changeUserSettings = function () {
            var _this = this;
            var count = 0;
            $('.focus-group-button').click(function (e1) {
                var prevCount = count;
                count = count + 1;
                $('.default-deep-dive-set-up.open-sans').click(function (e2) {
                    if (e2.target.textContent === 'Set Page as Deep Dive Default' && (count === prevCount + 1)) {
                        _this.saveDefaultUserSettings(e1.target.textContent.trim());
                        setTimeout(function () {
                            _this.result = _this.getDefaultUserSettings();
                            _this.result.then(function (content) {
                                _this.setActive(content);
                            });
                        }, 750);
                    }
                });
            });
        };
        // Saves default tab
        UserSettings.prototype.saveDefaultUserSettings = function (setDefault) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var WsTabsViewObject = { 'customParameter': 'default_tab', 'customValue': setDefault, 'pageName': 'Deep_Dive' };
            var results = this.saveDefaultUserSettingsTab(WsTabsViewObject);
            results.then(function (data) {
                deferred.resolveWith(window, []);
            }).fail(function (error) {
                console.log(error);
            });
            return promise;
        };
        // get default tab
        UserSettings.prototype.getDefaultUserSettings = function () {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var results = this.getDefaultUserSettingsTab();
            results.then(function (data) {
                var jsonData = JSON.parse(data);
                deferred.resolveWith(window, [jsonData]);
            }).fail(function (error) {
                console.log(error);
            });
            return promise;
        };
        UserSettings.prototype.loginContentCheck = function (xhr, content) {
            return xhr.responseText === "" || xhr.responseText !== content;
        };
        UserSettings.prototype.saveDefaultUserSettingsTab = function (payload) {
            return this.tabChangePostCaller(this.ADD_DFAULT_PAGE, 'POST', payload, this.loginContentCheck);
        };
        UserSettings.prototype.getDefaultUserSettingsTab = function () {
            return this.tabChangePostCaller(this.GET_DEFAULT_PAGE + '/default_tab/Deep_Dive', 'GET', undefined, this.loginContentCheck);
        };
        UserSettings.prototype.tabChangePostCaller = function (route, method, payload, errorChecker) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            jQuery.ajax({
                'method': method,
                'url': route,
                'data': JSON.stringify(payload),
                'contentType': 'application/json'
            }).then(function (content, textStatus, xhr) {
                if (errorChecker(xhr, content)) {
                    //user needs to log in again
                    deferred.reject();
                }
                else {
                    deferred.resolve(content);
                }
            }).fail(function (error) {
                if (error.status == 403) {
                    //redirect window above crp iframe to the origin url
                    window.top.location.href = window.location.origin;
                }
                deferred.reject(error);
            });
            return promise;
        };
        UserSettings.prototype.loadData = function () {
            this.getUserSettings();
            this.changeUserSettings();
        };
        UserSettings.prototype.initialize = function (report) {
            var _this = this;
            var isAltsOnly = this.isAltsOnly;
            report.ready(function () {
                var activeSheet = report.getActiveSheetName();
                var activeTabName = '';
                switch (activeSheet) {
                    case _this.OFFICE_DEEP_DIVE:
                        activeTabName = _this.TABS_LIST[0];
                        break;
                    case _this.TEAMS_DEEP_DIVE:
                        activeTabName = _this.TABS_LIST[1];
                        break;
                    case _this.ADVISOR_DEEP_DIVE:
                        activeTabName = _this.TABS_LIST[2];
                        break;
                    /* case this.SMA_DEEP_DIVE:
                         activeTabName = this.TABS_LIST[3];
                         break;*/
                    case _this.ALTS_DEEP_DIVE:
                        activeTabName = _this.TABS_LIST[3];
                        break;
                }
                $('.focus-group-button').removeClass('active');
                $('.focus-group-button:contains(' + activeTabName + ')').addClass('active');
                try {
                    var parentDoc = window.parent.document;
                    if (parentDoc !== null)
                        _this.setTagVisible(activeSheet);
                }
                catch (e) {
                    console.log(e);
                }
                _this.result = _this.getDefaultUserSettings();
                _this.result.then(function (content) {
                    if (isAltsOnly) {
                        if (activeTabName === 'Alternatives') {
                            $('.default-deep-dive-set-up.open-sans').html('Current Deep Dive Default');
                            $('.current-deep-dive').removeClass('blue-text');
                        }
                        else {
                            $('.default-deep-dive-set-up.open-sans').html('Set Page as Deep Dive Default');
                            $('.current-deep-dive').addClass('blue-text');
                        }
                    }
                    else if (content.result !== null) {
                        if (activeTabName === content.result.customValue) {
                            $('.default-deep-dive-set-up.open-sans').html('Current Deep Dive Default');
                            $('.current-deep-dive').removeClass('blue-text');
                        }
                        else {
                            $('.default-deep-dive-set-up.open-sans').html('Set Page as Deep Dive Default');
                            $('.current-deep-dive').addClass('blue-text');
                        }
                    }
                    else {
                        if (activeTabName === 'Office') {
                            $('.default-deep-dive-set-up.open-sans').html('Current Deep Dive Default');
                            $('.current-deep-dive').removeClass('blue-text');
                        }
                        else {
                            $('.default-deep-dive-set-up.open-sans').html('Set Page as Deep Dive Default');
                            $('.current-deep-dive').addClass('blue-text');
                        }
                    }
                });
            });
        };
        UserSettings.prototype.setTagVisible = function (sheetName) {
            if (sheetName == 'AltsDeepDive') {
                $(".filters-applied-option", window.parent.document).each(function () {
                    if (this.id.contains('Alt')) {
                        $('#' + this.id, window.parent.document).show();
                    }
                    else {
                        $('#' + this.id, window.parent.document).hide();
                    }
                });
            }
            else {
                $(".filters-applied-option", window.parent.document).each(function () {
                    if (this.id.contains('Alt')) {
                        $('#' + this.id, window.parent.document).hide();
                    }
                    else {
                        $('#' + this.id, window.parent.document).show();
                    }
                });
            }
        };
        return UserSettings;
    }());
    CardView.UserSettings = UserSettings;
})(CardView || (CardView = {}));
var BiWhatIfScenarios;
(function (BiWhatIfScenarios) {
    (function (TopOfficeDateRangeEnum) {
        TopOfficeDateRangeEnum[TopOfficeDateRangeEnum["QUARTER_TYPE"] = 0] = "QUARTER_TYPE";
        TopOfficeDateRangeEnum[TopOfficeDateRangeEnum["QUARTER"] = 1] = "QUARTER";
    })(BiWhatIfScenarios.TopOfficeDateRangeEnum || (BiWhatIfScenarios.TopOfficeDateRangeEnum = {}));
    var TopOfficeDateRangeEnum = BiWhatIfScenarios.TopOfficeDateRangeEnum;
    (function (FactorTypeEnum) {
        FactorTypeEnum[FactorTypeEnum["ACTUAL"] = 0] = "ACTUAL";
        FactorTypeEnum[FactorTypeEnum["SCENARIOA"] = 1] = "SCENARIOA";
        FactorTypeEnum[FactorTypeEnum["SCENARIOB"] = 2] = "SCENARIOB";
    })(BiWhatIfScenarios.FactorTypeEnum || (BiWhatIfScenarios.FactorTypeEnum = {}));
    var FactorTypeEnum = BiWhatIfScenarios.FactorTypeEnum;
    //typescript 1.8.9 doesn't have stirng enums. Must use string literals instead
    var FactorTitleEnum = (function () {
        function FactorTitleEnum() {
        }
        FactorTitleEnum.MANAGER_TENURE = "Manager Tenure";
        FactorTitleEnum.YR1_RETURN = "1-Year Return";
        FactorTitleEnum.YR3_RETURN = "3-Year Return";
        FactorTitleEnum.YIELD_12MO = "12 Month Yield";
        FactorTitleEnum.SHARPE_1YR = "1-Year Sharpe Ratio";
        FactorTitleEnum.SHARPE_3YR = "3-Year Sharpe Ratio";
        FactorTitleEnum.NET_EXPENSE = "Net Expense Ratio (bps)";
        FactorTitleEnum.RATING = "Rating Overall";
        return FactorTitleEnum;
    }());
    BiWhatIfScenarios.FactorTitleEnum = FactorTitleEnum;
    var FactorPercentilePrefixEnum = (function () {
        function FactorPercentilePrefixEnum() {
        }
        FactorPercentilePrefixEnum.MANAGER_PERCENTILE = "ManagerTenure";
        FactorPercentilePrefixEnum.YR1_RETURN_PERCENTILE = "Return1yr";
        FactorPercentilePrefixEnum.YR3_RETURN_PERCENTILE = "Return3yr";
        FactorPercentilePrefixEnum.YIELD_12_PERCENTILE = "Yield12mo";
        FactorPercentilePrefixEnum.SHARPE_1YR_PERCENTILE = "Sharpe1yr";
        FactorPercentilePrefixEnum.SHARPE_3YR_PERCENTILE = "Sharpe3yr";
        FactorPercentilePrefixEnum.NET_EXPENSE_PRECENTILE = "NetExpenseRatio";
        return FactorPercentilePrefixEnum;
    }());
    BiWhatIfScenarios.FactorPercentilePrefixEnum = FactorPercentilePrefixEnum;
    (function (SalesDatumType) {
        SalesDatumType[SalesDatumType["ACTUAL"] = 0] = "ACTUAL";
        SalesDatumType[SalesDatumType["EXPECTED"] = 1] = "EXPECTED";
        SalesDatumType[SalesDatumType["CHANGE"] = 2] = "CHANGE";
    })(BiWhatIfScenarios.SalesDatumType || (BiWhatIfScenarios.SalesDatumType = {}));
    var SalesDatumType = BiWhatIfScenarios.SalesDatumType;
})(BiWhatIfScenarios || (BiWhatIfScenarios = {}));
var BiWhatIfScenarios;
(function (BiWhatIfScenarios) {
    var Strings = (function () {
        function Strings() {
        }
        Strings.SHARE_CLASS_TITLE = 'SHARE CLASS : ';
        Strings.SHARE_CLASS_INFO_MSG = 'The Net Expense Ratio shown is that for the share class indicated, corresponding to the share class with the most sales for this time period. The Expected Sales Model results will incorporate data across share classes.';
        Strings.SCENARIO_BOX_QUESTION_MSG = 'Enter What-If values in the open text box or use the sliders to start your What-If scenarios.';
        Strings.NET_EXP_SHARE_CLASS_INFO_MSG = 'The Net Expense Ratio shown is that for the share class indicated, corresponding to the share class with the most sales for this time period. The Net Expense Ratio Model results will incorporate data across share classes.';
        Strings.NET_EXP_BOTTOM_MSG = 'Model results predict results for trailing 12 Months Green Space, Gross Sales and Revenue.';
        Strings.SCENARIO_A_TITLE = "What-if Scenario A";
        Strings.SCENARIO_B_TITLE = "What-if Scenario B";
        Strings.ACTUAL_LABEL = "ACTUAL";
        Strings.ADD_ANOTHER_LABEL = "Add Another What-if Scenario";
        Strings.FACTOR_ERROR_MSG = "Please enter a valid numeric value.";
        Strings.DEFAULT_PERCENTAGE = "0%";
        Strings.ZERO = "0.00";
        Strings.DEFAULT_EXPT_MRKT_PERCENT = "0%";
        Strings.FACTOR_TYPE_SUFFIX_A = 'a';
        Strings.FACTOR_TYPE_SUFFIX_B = 'b';
        Strings.PERCENTAGE_SIGN = "%";
        Strings.EXPECTED_SALES_MODEL_TITLE = "Expected Sales Model Results";
        Strings.ENTER_WHAT_IF_LABEL = "ENTER WHAT-IF";
        Strings.KEY_DRIVER_TABLE_LABEL = "Key Sales Drivers";
        Strings.KEY_DRIVER_INFO_LABEL1 = "Key Sales Drivers:";
        Strings.KEY_DRIVER_INFO1 = "Key Sales Drivers are calculated for each category based on the top 8 Morningstar factors for each category. These are not product specific. The top 3 key sales drivers are shown.";
        Strings.KEY_DRIVER_INFO_LABEL2 = "Percentiles:";
        Strings.KEY_DRIVER_INFO2 = "Percentiles compare your product in the category to others to determine your product’s percentile placement. This calculation is not available for the Key Sales Driver of Morningstar Rating.";
        Strings.ACTUAL_COLUMN_LABEL = "Actual";
        Strings.SCENARIO_A_HEADER = "Scenario A";
        Strings.CHANGE_A_HEADER = "Change A";
        Strings.SCENARIO_B_HEADER = "Scenario B";
        Strings.CHANGE_B_HEADER = "Change B";
        Strings.SALES_SHARE_TABLE_LABEL = "Sales, Revenue & Market Share";
        Strings.EXPECTED_SALES_LABEL = "Expected Sales";
        Strings.EXP_SALES_MRKT_LABEL = "Expected Sales Market Share";
        Strings.REVENUE_LABEL = "Revenue (Next 12 Mos)";
        Strings.ASSET_REVENUE_LABEL = "Existing Asset Revenue";
        Strings.TOTAL_REVENUE_LABEL = "Total Revenue";
        Strings.GREEN_SPACE_TABLE_LABEL = "Green & Red Space";
        Strings.GREEN_SPACE_LABEL = "Sales Green Space";
        Strings.GREENER_LABEL = "Sales Greener Green Space (%)";
        Strings.AUM_GREEN_SPACE_LABEL = "AUM Green Space";
        Strings.GREENER_AUM_LABEL = "AUM Greener Green Space (%)";
        Strings.RED_SPACE_LABEL = "Red Space";
        Strings.SALES_TABLE_HEADER_MSG = "3 Months Sales – next quarter estimates";
        Strings.GREEN_TABLE_HEADER_MSG = "Trailing 12 Months Sales / AUM as of quarter end";
        Strings.GROSS_SALES_INFO_LABEL = "Gross Sales:";
        Strings.GROSS_SALES_INFO_MSG = "Your product’s actual 3 months gross sales for the product selected.";
        Strings.GROSS_SALES_MRKT_INFO_LABEL = "Gross Sales Market Share:";
        Strings.GROSS_SALES_MRKT_MSG = "Your product’s actual market share based on Gross Sales (3 months).";
        Strings.EXPECTED_SALES_INFO_LABEL = "Expected Sales:";
        Strings.EXPECTED_SALES_MSG = "Based on how your product performs across the key sales drivers compared to the competition. Provides insight into whether your sales are punching under or over weight and estimates the next quarter’s sales (3 months).";
        Strings.EXPECTED_SALES_MRKT_INFO_LABEL = "Expected Sales Market Share:";
        Strings.EXPECTED_SALES_MRKT_MSG = "Expected Sales/Current Total Sales in the category (3 months).";
        Strings.REVENUE_INFO_LABEL = "Revenue:";
        Strings.REVENUE_MSG = "Calculated by taking into account your sales, net expense ratio and redemption rate:";
        Strings.NET_EXPENSE_HEADER = "Net Expense Ratio 5 bps Increments";
        Strings.GROSS_SALES_LABEL = "Gross Sales";
        Strings.MARKET_SHARE_LABEL = "Market Share";
        Strings.MARKET_SHARE_RANK_LABEL = "Market Share Rank";
        Strings.NET_EXP_GREEN_SPACE_LABEL = "Green Space";
        Strings.OPTIMAL_INFO_MSG = "In this category, based on the competitive data set, you may benefit from raising the expense ratio marginally.";
        Strings.GREEN_SPACE_MSG = "Based on each category’s key sales drivers and not the custom green space factors selected each quarter for both Sales and AUM (Sales Green Space / AUM Green Space. Shows Trailing 12 Months Sales and AUM as of quarter end.";
        Strings.GREENER_GREEN_SPACE_LABEL = "Greener Green Space:";
        Strings.GREENER_GREEN_SPACE_MSG = "Incorporates additional thresholds to further target where a product has a competitive advantage (see Methodologies & Assumptions for more detail).";
        Strings.RED_SPACE_MSG = "Based on each category’s key sales drivers as shown in the model.";
        return Strings;
    }());
    BiWhatIfScenarios.Strings = Strings;
})(BiWhatIfScenarios || (BiWhatIfScenarios = {}));
var BiWhatIfScenarios;
(function (BiWhatIfScenarios) {
    var DataManager = (function () {
        function DataManager() {
            this.dropdownUrl = "/whatIf/dropdownInfo";
            this.categoryDropdownUrl = "/whatIf/categoryDropdownInfo";
            this.dateUrl = "/crp/report/data";
            this.getSavedScenariosUrl = "/getSavedBIScenarios/";
            this.getScenarioIdUrl = "/getScenarioId";
            this.saveScenarioUrl = "/saveBIScenario/";
            this.updateScenarioUrl = "/updateScenario/";
            this.deleteScenarioUrl = "/deleteScenario/";
            this.getFactorsUrl = "/getFactors";
            this.getExpectedSalesUrl = "/getWhatIfResults";
            this.getESRedSpaceUrl = "/getWhatIfRedSpaceResults";
            this.getESGreenSpaceUrl = "/getWhatIfGreenSpaceResults";
            this.getShareClassUrl = "/getShareClass";
            this.getNetExpenseGSDropURL = "/getNetExpenseGreenSpaceDrop";
            this.getNetExpenseRatioDropURL = "/getNetExpenseRatioDrop";
            this.getNetExpCategoriesURL = "/getNetExpCategories";
            this.getOptimalNetExpenseRatioDropURL = "/getOptimalNetExpenseRatioDrop";
        }
        DataManager.prototype.dropdownInfo = function (payload) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('POST', this.dropdownUrl, JSON.stringify(payload)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.categoryDropdownInfo = function (payload) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('POST', this.categoryDropdownUrl, JSON.stringify(payload)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getDates = function (payload) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('POST', this.dateUrl, JSON.stringify(payload)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getFactors = function (payload) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('POST', this.getFactorsUrl, JSON.stringify(payload)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getExpectedSalesData = function (input) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('POST', this.getExpectedSalesUrl, JSON.stringify(input)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getESRedSpaceData = function (input) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('POST', this.getESRedSpaceUrl, JSON.stringify(input)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getESGreenSpace = function (input) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('POST', this.getESGreenSpaceUrl, JSON.stringify(input)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getSavedBIScenarios = function (scenarioType) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('GET', this.getSavedScenariosUrl + scenarioType, "").then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getScenarioId = function (scenarioName) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('POST', this.getScenarioIdUrl, JSON.stringify(scenarioName)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.saveBIScenario = function (scenario, scenarioType) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('POST', this.saveScenarioUrl + scenarioType, JSON.stringify(scenario)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.updateScenario = function (scenario, scenarioId) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('POST', this.updateScenarioUrl + scenarioId, JSON.stringify(scenario)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.deleteScenario = function (scenarioId) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('POST', this.deleteScenarioUrl + scenarioId, JSON.stringify(scenarioId)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getShareClass = function (payload) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('POST', this.getShareClassUrl, JSON.stringify(payload)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getNetExpenseGreenSpaceDrop = function (payload) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('POST', this.getNetExpenseGSDropURL, JSON.stringify(payload)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getNetExpenseRatioDrop = function (payload) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('POST', this.getNetExpenseRatioDropURL, JSON.stringify(payload)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getOptimalNetExpenseRatioDrop = function (payload) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('POST', this.getOptimalNetExpenseRatioDropURL, JSON.stringify(payload)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getNetExpCategories = function () {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('GET', this.getNetExpCategoriesURL, '').then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.baseAjax = function (method, url, data) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            jQuery.ajax({
                'method': method,
                'url': url,
                'data': data,
                'contentType': 'application/json',
                'dataType': 'json'
            }).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        return DataManager;
    }());
    BiWhatIfScenarios.DataManager = DataManager;
})(BiWhatIfScenarios || (BiWhatIfScenarios = {}));
///<reference path="00.data_type.ts" />
///<reference path="02.data.ts" />
///<reference path="04.parser.ts" />
var BiWhatIfScenarios;
(function (BiWhatIfScenarios) {
    var Service = (function () {
        function Service() {
            this.data = new BiWhatIfScenarios.DataManager();
            this.parser = new BiWhatIfScenarios.Parser();
            this.topFirmName = "WHAT_IF_FIRMS";
            this.firmChannelName = "WHAT_IF_FIRMS_CHANNEL";
            this.channelName = "WHAT_IF_CHANNELS";
            this.product = "WHAT_IF_PRODUCTS";
            this.category = "WHAT_IF_CATEGORIES";
        }
        Service.prototype.getProducts = function () {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                dropdownName: this.product,
                input: []
            };
            this.data.dropdownInfo(payload).then(function (result) {
                deferred.resolveWith(window, [_this.parser.getProducts(result)]);
            });
            return promise;
        };
        Service.prototype.getCategories = function () {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                dropdownName: this.category,
                input: []
            };
            this.data.dropdownInfo(payload).then(function (result) {
                deferred.resolveWith(window, [_this.parser.getCategories(result)]);
            });
            return promise;
        };
        Service.prototype.getCategoriesByProduct = function (productName) {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                productName: productName
            };
            this.data.categoryDropdownInfo(payload).then(function (result) {
                deferred.resolveWith(window, [_this.parser.getCategoriesByProduct(result)]);
            });
            return promise;
        };
        Service.prototype.getChannels = function () {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                dropdownName: this.channelName,
                input: []
            };
            this.data.dropdownInfo(payload)
                .then(function (result) {
                deferred.resolveWith(window, [_this.parser.getChannels(result)]);
            });
            return promise;
        };
        Service.prototype.getFirms = function () {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                dropdownName: this.topFirmName,
                input: []
            };
            this.data.dropdownInfo(payload).then(function (result) {
                deferred.resolveWith(window, [_this.parser.getSortedFirms(result)]);
            });
            return promise;
        };
        Service.prototype.getFirmsByChannel = function (channelIds) {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                dropdownName: this.firmChannelName,
                input: channelIds
            };
            this.data.dropdownInfo(payload).then(function (result) {
                deferred.resolveWith(window, [_this.parser.getSortedFirms(result)]);
            });
            return promise;
        };
        Service.prototype.getTransactionDates = function () {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                dimensions: { HomeOffice: ["0"] },
                parameters: { salesValue: 0, shareClassValue: 0, modelUsageValue: 0, deepDiveType: "Office" },
                salesDimensions: {},
                sqlName: "DEEPDIVEDATES"
            };
            this.data.getDates(payload).then(function (result) {
                deferred.resolveWith(window, [_this.parser.getDateList(result)]);
            });
            return promise;
        };
        Service.prototype.getFactors = function (category, product, model) {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                category: category,
                product: product,
                model: model
            };
            this.data.getFactors(payload).then(function (result) {
                if (model === 'expected sales model') {
                    deferred.resolveWith(window, [_this.parser.getFactors(result)]);
                }
                else {
                    deferred.resolveWith(window, [_this.parser.getFactorsArray(result)]);
                }
            });
            return promise;
        };
        Service.prototype.getExpectedSalesData = function (input) {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.data.getExpectedSalesData(input).then(function (result) {
                deferred.resolveWith(window, [_this.parser.getExpectedSalesData(result)]);
            });
            return promise;
        };
        Service.prototype.getESRedSpaceData = function (input) {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.data.getESRedSpaceData(input).then(function (result) {
                deferred.resolveWith(window, [_this.parser.getESRedSpaceData(result)]);
            });
            return promise;
        };
        Service.prototype.getESGreenSpace = function (input) {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.data.getESGreenSpace(input).then(function (result) {
                deferred.resolveWith(window, [_this.parser.getGreenSpaceData(result)]);
            });
            return promise;
        };
        Service.prototype.getSavedBIScenarios = function (scenarioType) {
            return this.data.getSavedBIScenarios(scenarioType);
        };
        Service.prototype.getScenarioId = function (scenarioName) {
            var namePayload = { name: scenarioName };
            return this.data.getScenarioId(namePayload);
        };
        Service.prototype.saveBIScenario = function (scenario, scenarioType) {
            return this.data.saveBIScenario(scenario, scenarioType);
        };
        Service.prototype.updateScenario = function (scenario, scenarioId) {
            return this.data.updateScenario(scenario, scenarioId);
        };
        Service.prototype.deleteScenario = function (scenarioId) {
            return this.data.deleteScenario(scenarioId);
        };
        Service.prototype.getShareClass = function (productPortfolio) {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                productPortfolio: productPortfolio
            };
            this.data.getShareClass(payload).then(function (result) {
                deferred.resolveWith(window, [_this.parser.getShareClass(result)]);
            });
            return promise;
        };
        Service.prototype.getNetExpenseGreenSpaceDrop = function (productPortfolio, factors, bpsValue, firms) {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                productPortfolio: productPortfolio,
                factors: factors,
                bpsValue: bpsValue,
                firms: firms
            };
            this.data.getNetExpenseGreenSpaceDrop(payload).then(function (result) {
                deferred.resolveWith(window, [_this.parser.getNetExpenseGreenSpaceDrop(result)]);
            });
            return promise;
        };
        Service.prototype.getNetExpenseRatioDrop = function (productPortfolio, category, firms) {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                productPortfolio: productPortfolio,
                category: category,
                firms: firms
            };
            this.data.getNetExpenseRatioDrop(payload).then(function (result) {
                deferred.resolveWith(window, [_this.parser.getNetExpenseRatioDrop(result)]);
            });
            return promise;
        };
        Service.prototype.getOptimalNetExpenseRatioDrop = function (productPortfolio, category, firms) {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                productPortfolio: productPortfolio,
                category: category,
                firms: firms
            };
            this.data.getOptimalNetExpenseRatioDrop(payload).then(function (result) {
                deferred.resolveWith(window, [_this.parser.getOptimalNetExpenseRatioDrop(result)]);
            });
            return promise;
        };
        Service.prototype.getNetExpCategories = function () {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.data.getNetExpCategories().then(function (result) {
                deferred.resolveWith(window, [_this.parser.getCategories(result)]);
            });
            return promise;
        };
        return Service;
    }());
    BiWhatIfScenarios.Service = Service;
})(BiWhatIfScenarios || (BiWhatIfScenarios = {}));
///<reference path="../../reports/06.utils.ts" />
var BiWhatIfScenarios;
(function (BiWhatIfScenarios) {
    var Parser = (function () {
        function Parser() {
        }
        Parser.prototype.getProducts = function (result) {
            var columns = result.cols;
            var rows = result.rows;
            var productNameIndex = columns.indexOf(Parser.PRODUCT_NAME);
            var categoryNameIndex = columns.indexOf(Parser.CATEGORY);
            var results = [];
            rows.forEach(function (row) {
                var product_category = {
                    categoryName: row[categoryNameIndex],
                    productName: row[productNameIndex]
                };
                results.push(product_category);
            });
            return results;
        };
        Parser.prototype.getCategories = function (result) {
            var columns = result.cols;
            var rows = result.rows;
            var catNameIndex = columns.indexOf(Parser.CATEGORY);
            var results = [];
            rows.forEach(function (row) {
                results.push(row[catNameIndex]);
            });
            return results;
        };
        Parser.prototype.getCategoriesByProduct = function (result) {
            var columns = result.cols;
            var rows = result.rows;
            var categoryNameIndex = columns.indexOf(Parser.CATEGORY);
            var productNameIndex = columns.indexOf(Parser.PRODUCT_PORTFOLIO);
            var defaultCategoryIndex = columns.indexOf(Parser.DEFAULT_CATEGORY);
            var results = [];
            rows.forEach(function (entry) {
                var category = {
                    productName: entry[productNameIndex],
                    categoryName: entry[categoryNameIndex],
                    defaultCategory: entry[defaultCategoryIndex]
                };
                results.push(category);
            });
            return results;
        };
        Parser.prototype.getChannels = function (result) {
            var columns = result.cols;
            var rows = result.rows;
            var channelNameIndex = columns.indexOf(Parser.CHANNEL_NAME);
            var channelIdIndex = columns.indexOf(Parser.CHANNEL_ID);
            var results = [];
            rows.forEach(function (entry) {
                var product = {
                    channelName: entry[channelNameIndex],
                    channelId: entry[channelIdIndex]
                };
                results.push(product);
            });
            return results;
        };
        Parser.prototype.getSortedFirms = function (result) {
            var filterdItems = [];
            var columns = result.cols;
            var rows = result.rows;
            var firmNameIndex = columns.indexOf(Parser.FIRM_NAME);
            var firmIdIndex = columns.indexOf(Parser.FIRM_ID);
            var channelIdIndex = columns.indexOf(Parser.CHANNEL_ID);
            for (var i = 0; i < rows.length; i++) {
                var entry = rows[i];
                var firmName = entry[firmNameIndex];
                var firmId = entry[firmIdIndex];
                var channelId = entry[channelIdIndex];
                if (filterdItems.length === 0) {
                    var newFilteredEntry = {};
                    newFilteredEntry.firmName = firmName;
                    newFilteredEntry.firmId = firmId;
                    newFilteredEntry.channelIds = [];
                    newFilteredEntry.channelIds.push(channelId);
                    filterdItems.push(newFilteredEntry);
                }
                else {
                    var foundEntry = false;
                    filterdItems.forEach(function (value) {
                        if (firmName === value.firmName) {
                            value.channelIds.push(channelId);
                            foundEntry = true;
                        }
                    });
                    if (!foundEntry) {
                        var newFilteredEntry = {};
                        newFilteredEntry.firmName = firmName;
                        newFilteredEntry.firmId = firmId;
                        newFilteredEntry.channelIds = [];
                        newFilteredEntry.channelIds.push(channelId);
                        filterdItems.push(newFilteredEntry);
                        foundEntry = false;
                    }
                }
            }
            return filterdItems;
        };
        Parser.prototype.getDateList = function (result) {
            var quarters = {
                dayAum: null,
                monthAum: null,
                yearAum: null,
                filteredQuarters: []
            };
            result.data.rows.forEach(function (row) {
                var quarterType = row[BiWhatIfScenarios.TopOfficeDateRangeEnum.QUARTER_TYPE];
                var quarter = row[BiWhatIfScenarios.TopOfficeDateRangeEnum.QUARTER];
                if (Parser.QUARTER_TYPE_AUM === quarterType) {
                    if (quarter !== null && quarter !== '') {
                        var date = Parser.getLastDayOfQuarter(quarter);
                        quarters.dayAum = date.getDate();
                        quarters.monthAum = date.getMonth() + 1;
                        quarters.yearAum = date.getFullYear();
                    }
                }
                else {
                    quarters.filteredQuarters.push(quarter);
                }
            });
            return quarters;
        };
        Parser.prototype.getFactors = function (result) {
            var columns = result.cols;
            var rows = result.rows;
            var factors = [];
            var factorTitle = columns.indexOf(Parser.TITLE);
            var min = columns.indexOf(Parser.MIN);
            var max = columns.indexOf(Parser.MAX);
            var initialValue = columns.indexOf(Parser.INIT);
            var isWholeNumber = columns.indexOf(Parser.TYPE);
            rows.forEach(function (entry) {
                var factor = {
                    title: entry[factorTitle],
                    minimum: entry[min],
                    maximum: entry[max],
                    initial: entry[initialValue],
                    isWholeNumber: (entry[isWholeNumber] === "1")
                };
                factor.initial = factor.initial > factor.maximum ? factor.maximum : factor.initial;
                factor.initial = factor.initial < factor.minimum ? factor.minimum : factor.initial;
                if (factor.title === Parser.EXP_TITLE) {
                    //convert from decimal to bps (count of .01)
                    factor.initial = Math.round(parseFloat(factor.initial.toFixed(2)) * 100);
                    factor.minimum = Math.round(parseFloat(factor.minimum.toFixed(2)) * 100);
                    factor.maximum = Math.round(parseFloat(factor.maximum.toFixed(2)) * 100);
                }
                else if (factor.title === Parser.RATING_TITLE) {
                    factor.initial = Math.round(factor.initial);
                    factor.minimum = 1;
                    factor.maximum = 5;
                }
                else {
                    factor.initial = factor.isWholeNumber ? Math.round(factor.initial) : parseFloat(factor.initial.toFixed(1));
                }
                factors.push(factor);
            });
            return factors;
        };
        Parser.prototype.getFactorsArray = function (result) {
            var columns = result.cols;
            var rows = result.rows;
            var row = rows[0];
            var factors = [];
            factors.push(row[columns.indexOf(Parser.FACTOR1)]);
            factors.push(row[columns.indexOf(Parser.FACTOR2)]);
            factors.push(row[columns.indexOf(Parser.FACTOR3)]);
            return factors;
        };
        Parser.prototype.getExpectedSalesData = function (result) {
            var columns = result.cols;
            var rows = result.rows;
            var entry = rows[0];
            var data = {
                product: entry ? entry[columns.indexOf(Parser.PRODUCT_PORTFOLIO)] : null,
                category: entry ? entry[columns.indexOf(Parser.CATEGORY)] : null,
                actualClientGrossSales: entry ? entry[columns.indexOf(Parser.ACTUAL_GROSS_SALES)] : 0,
                actualClientGrossRedemptions: entry ? entry[columns.indexOf(Parser.ACTUAL_GROSS_REDEMPTIONS)] : 0,
                actualClientGrossAum: entry ? entry[columns.indexOf(Parser.ACTUAL_GROSS_AUM)] : 0,
                actualCategoryGlobalSales: entry ? entry[columns.indexOf(Parser.ACTUAL_CATEGORY_SALES)] : 0,
                actualMarketShare: entry ? entry[columns.indexOf(Parser.ACTUAL_MARKET_SHARE)] : 0,
                actualExpectedSales: Math.round(Number(entry ? entry[columns.indexOf(Parser.ACTUAL_EXPECTED_SALES)] : 0) / 1000) * 1000,
                actualExpectedMarketShare: entry ? entry[columns.indexOf(Parser.ACTUAL_EXPECTED_MARKET_SHARE)] : 0,
                actualExpectedRevenue: Math.round(Number(entry ? entry[columns.indexOf(Parser.ACTUAL_EXPECTED_REVENUE)] : 0) / 1000) * 1000,
                actualReturn3yrPercent: entry ? entry[columns.indexOf(Parser.ACTUAL_RETURN_3YR)] : 0,
                actualReturn1yrPercent: entry ? entry[columns.indexOf(Parser.ACTUAL_RETURN_1YR)] : 0,
                actualSharpe3yrPercent: entry ? entry[columns.indexOf(Parser.ACTUAL_SHARPE_3YR)] : 0,
                actualSharpe1yrPercent: entry ? entry[columns.indexOf(Parser.ACTUAL_SHARPE_1YR)] : 0,
                actualNetExpenseRatioPercent: entry ? entry[columns.indexOf(Parser.ACTUAL_NET_EXP_RATIO)] : 0,
                actualManagerTenurePercent: entry ? entry[columns.indexOf(Parser.ACTUAL_MANAGER)] : 0,
                actualYield12moPercent: entry ? entry[columns.indexOf(Parser.ACTUAL_YIELD_12MO)] : 0,
                expectedSales: Math.round(Number(entry ? entry[columns.indexOf(Parser.EXPECTED_SALES)] : 0) / 1000) * 1000,
                expectedMarketShare: entry ? entry[columns.indexOf(Parser.EXPECTED_MARKET_SHARE)] : 0,
                expectedRevenue: Math.round(Number(entry ? entry[columns.indexOf(Parser.EXPECTED_REVENUE)] : 0) / 1000) * 1000,
                expectedReturn3yrPercent: entry ? entry[columns.indexOf(Parser.EXPECTED_RETURN_3YR)] : 0,
                expectedReturn1yrPercent: entry ? entry[columns.indexOf(Parser.EXPECTED_RETURN_1YR)] : 0,
                expectedSharpe3yrPercent: entry ? entry[columns.indexOf(Parser.EXPECTED_SHARPE_3YR)] : 0,
                expectedSharpe1yrPercent: entry ? entry[columns.indexOf(Parser.EXPECTED_SHARPE_1YR)] : 0,
                expectedNetExpenseRatioPercent: entry ? entry[columns.indexOf(Parser.EXPECTED_NET_EXP_RATIO)] : 0,
                expectedManagerTenurePercent: entry ? entry[columns.indexOf(Parser.EXPECTED_MANAGER_TENURE)] : 0,
                expectedYield12moPercent: entry ? entry[columns.indexOf(Parser.EXPECTED_YIELD_12MO)] : 0,
                changeExpectedSales: Math.round(Number(entry ? entry[columns.indexOf(Parser.CHANGE_EXPECTED_SALES)] : 0) / 1000) * 1000,
                changeMarketShare: entry ? entry[columns.indexOf(Parser.CHANGE_MARKET_SHARE)] : 0,
                changeRevenue: Math.round(Number(entry ? entry[columns.indexOf(Parser.CHANGE_EXPECTED_REVENUE)] : 0) / 1000) * 1000,
                changeReturn3yrPercent: entry ? entry[columns.indexOf(Parser.CHANGE_RETURN_3YR)] : 0,
                changeReturn1yrPercent: entry ? entry[columns.indexOf(Parser.CHANGE_RETURN_1YR)] : 0,
                changeSharpe3yrPercent: entry ? entry[columns.indexOf(Parser.CHANGE_SHARPE_3YR)] : 0,
                changeSharpe1yrPercent: entry ? entry[columns.indexOf(Parser.CHANGE_SHARPE_1YR)] : 0,
                changeNetExpenseRatioPercent: entry ? entry[columns.indexOf(Parser.CHANGE_NET_EXP_RATIO)] : 0,
                changeManagerTenurePercent: entry ? entry[columns.indexOf(Parser.CHANGE_MANAGER_TENURE)] : 0,
                changeYield12moPercent: entry ? entry[columns.indexOf(Parser.CHANGE_YIELD_12_MO)] : 0
            };
            return data;
        };
        Parser.prototype.getESRedSpaceData = function (result) {
            var columns = result.cols;
            var rows = result.rows;
            var entry = rows[0];
            if (entry) {
                var data = {
                    productPortfolio: entry[columns.indexOf(Parser.PRODUCT_PORTFOLIO)],
                    redSpace: Math.round(Number(entry[columns.indexOf(Parser.RED_SPACE)]) / 1000) * 1000,
                    actualRedSpace: Math.round(Number(entry[columns.indexOf(Parser.ACTUAL_RED_SPACE)]) / 1000) * 1000,
                    changeRedSpace: Math.round(Number(entry[columns.indexOf(Parser.CHANGE_RED_SPACE)]) / 1000) * 1000
                };
                return data;
            }
            else {
                return null;
            }
        };
        Parser.prototype.getGreenSpaceData = function (result) {
            var columns = result.cols;
            var rows = result.rows;
            var entry = rows[0];
            if (entry) {
                var data = {
                    category: entry[columns.indexOf(Parser.CATEGORY)],
                    salesGreenSpace: Math.round(Number(entry[columns.indexOf(Parser.SALES_GREEN_SPACE)]) / 1000) * 1000,
                    newGreenSpace: Math.round(Number(entry[columns.indexOf(Parser.NEW_SALES_GREEN_SPACE)]) / 1000) * 1000,
                    greenerGreenSpace: Number(entry[columns.indexOf(Parser.GREENER_SALES_GS)]),
                    aumGreenSpace: Math.round(Number(entry[columns.indexOf(Parser.AUM_GREEN_SPACE)]) / 1000) * 1000,
                    newAumGreenSpace: Math.round(Number(entry[columns.indexOf(Parser.NEW_AUM_GREEN_SPACE)]) / 1000) * 1000,
                    greenerAumSpace: Number(entry[columns.indexOf(Parser.GREENER_AUM_GS)]),
                };
                return data;
            }
            else {
                return null;
            }
        };
        Parser.getLastDayOfQuarter = function (quarter) {
            var SLASH = '/';
            var HYPHEN = '-';
            var QUARTER_PREFIX = 'Q';
            var MONTHS_ON_A_QUARTER = 3;
            if (quarter == null || quarter === '') {
                return null;
            }
            var separator = quarter.contains(SLASH) ? SLASH : HYPHEN;
            var parameters = quarter.split(separator);
            var parsedYear = parameters[0];
            var parsedQuarter = parameters[1];
            var currentQuarter = parseInt(parsedQuarter.replace(QUARTER_PREFIX, ''));
            var lastMonthOfQuarter = new Date(parseInt(parsedYear), (currentQuarter * MONTHS_ON_A_QUARTER) - 1);
            var lastDayOfQuarter = moment(lastMonthOfQuarter).endOf("month").toDate();
            return lastDayOfQuarter;
        };
        Parser.prototype.getShareClass = function (result) {
            var columns = result.cols;
            var rows = result.rows;
            var shareClassIndex = columns.indexOf(Parser.SHARE_CLASS);
            var results = '';
            rows.forEach(function (row) {
                results = row[shareClassIndex];
            });
            return results;
        };
        Parser.prototype.getNetExpenseGreenSpaceDrop = function (result) {
            var columns = result.cols;
            var rows = result.rows;
            var row = rows[0];
            var netExpGSBpsIndex = columns.indexOf(Parser.GREEN_SPACE);
            var netExpGS5BpsIndex = columns.indexOf(Parser.GREEN_SPACE_5);
            var netExpGS10BpsIndex = columns.indexOf(Parser.GREEN_SPACE_10);
            var netExpGS15BpsIndex = columns.indexOf(Parser.GREEN_SPACE_15);
            var netExpGS20BpsIndex = columns.indexOf(Parser.GREEN_SPACE_20);
            var netExpGS25BpsIndex = columns.indexOf(Parser.GREEN_SPACE_25);
            var netExpOptimalIndex = columns.indexOf(Parser.OPTIMAL_GS);
            var results = {
                // Dividing and multiplying a number with 1000 to round a number to nearest thousand
                greenSpaceBps: Math.round(Number(row ? row[netExpGSBpsIndex] : 0) / 1000) * 1000,
                greenSpace5Bps: Math.round(Number(row ? row[netExpGS5BpsIndex] : 0) / 1000) * 1000,
                greenSpace10Bps: Math.round(Number(row ? row[netExpGS10BpsIndex] : 0) / 1000) * 1000,
                greenSpace15Bps: Math.round(Number(row ? row[netExpGS15BpsIndex] : 0) / 1000) * 1000,
                greenSpace20Bps: Math.round(Number(row ? row[netExpGS20BpsIndex] : 0) / 1000) * 1000,
                greenSpace25Bps: Math.round(Number(row ? row[netExpGS25BpsIndex] : 0) / 1000) * 1000,
                greenSpaceOptimal: Math.round(Number(row ? row[netExpOptimalIndex] : 0) / 1000) * 1000
            };
            return results;
        };
        Parser.prototype.getNetExpenseRatioDrop = function (result) {
            var columns = result.cols;
            var rows = result.rows;
            var row = rows[0];
            var results = {
                // Dividing and multiplying a number with 1000 to round a number to nearest thousand
                exp: Math.round(100 * Number(row ? row[columns.indexOf(Parser.EXP)] : 0)),
                grossSales: Math.round(Number(row ? row[columns.indexOf(Parser.GROSS_SALES)] : 0) / 1000) * 1000,
                grossSales5: Math.round(Number(row ? row[columns.indexOf(Parser.GROSS_SALES_5)] : 0) / 1000) * 1000,
                grossSales10: Math.round(Number(row ? row[columns.indexOf(Parser.GROSS_SALES_10)] : 0) / 1000) * 1000,
                grossSales15: Math.round(Number(row ? row[columns.indexOf(Parser.GROSS_SALES_15)] : 0) / 1000) * 1000,
                grossSales20: Math.round(Number(row ? row[columns.indexOf(Parser.GROSS_SALES_20)] : 0) / 1000) * 1000,
                grossSales25: Math.round(Number(row ? row[columns.indexOf(Parser.GROSS_SALES_25)] : 0) / 1000) * 1000,
                marketShare: Number(row ? row[columns.indexOf(Parser.MARKET_SHARE)] : 0).toFixed(2),
                marketShare5: Number(row ? row[columns.indexOf(Parser.MARKET_SHARE_5)] : 0).toFixed(2),
                marketShare10: Number(row ? row[columns.indexOf(Parser.MARKET_SHARE_10)] : 0).toFixed(2),
                marketShare15: Number(row ? row[columns.indexOf(Parser.MARKET_SHARE_15)] : 0).toFixed(2),
                marketShare20: Number(row ? row[columns.indexOf(Parser.MARKET_SHARE_20)] : 0).toFixed(2),
                marketShare25: Number(row ? row[columns.indexOf(Parser.MARKET_SHARE_25)] : 0).toFixed(2),
                marketShareRank: Number(row ? row[columns.indexOf(Parser.MARKET_SHARE_RANK)] : 0),
                marketShareRank5: Number(row ? row[columns.indexOf(Parser.MARKET_SHARE_RANK_5)] : 0),
                marketShareRank10: Number(row ? row[columns.indexOf(Parser.MARKET_SHARE_RANK_10)] : 0),
                marketShareRank15: Number(row ? row[columns.indexOf(Parser.MARKET_SHARE_RANK_15)] : 0),
                marketShareRank20: Number(row ? row[columns.indexOf(Parser.MARKET_SHARE_RANK_20)] : 0),
                marketShareRank25: Number(row ? row[columns.indexOf(Parser.MARKET_SHARE_RANK_25)] : 0),
                revenue: Math.round(Number(row ? row[columns.indexOf(Parser.REVENUE)] : 0) / 1000) * 1000,
                revenue5: Math.round(Number(row ? row[columns.indexOf(Parser.REVENUE_5)] : 0) / 1000) * 1000,
                revenue10: Math.round(Number(row ? row[columns.indexOf(Parser.REVENUE_10)] : 0) / 1000) * 1000,
                revenue15: Math.round(Number(row ? row[columns.indexOf(Parser.REVENUE_15)] : 0) / 1000) * 1000,
                revenue20: Math.round(Number(row ? row[columns.indexOf(Parser.REVENUE_20)] : 0) / 1000) * 1000,
                revenue25: Math.round(Number(row ? row[columns.indexOf(Parser.REVENUE_25)] : 0) / 1000) * 1000,
                assetRevenue: Math.round(Number(row ? row[columns.indexOf(Parser.ASSET_REVENUE)] : 0) / 1000) * 1000,
                assetRevenue5: Math.round(Number(row ? row[columns.indexOf(Parser.ASSET_REVENUE_5)] : 0) / 1000) * 1000,
                assetRevenue10: Math.round(Number(row ? row[columns.indexOf(Parser.ASSET_REVENUE_10)] : 0) / 1000) * 1000,
                assetRevenue15: Math.round(Number(row ? row[columns.indexOf(Parser.ASSET_REVENUE_15)] : 0) / 1000) * 1000,
                assetRevenue20: Math.round(Number(row ? row[columns.indexOf(Parser.ASSET_REVENUE_20)] : 0) / 1000) * 1000,
                assetRevenue25: Math.round(Number(row ? row[columns.indexOf(Parser.ASSET_REVENUE_25)] : 0) / 1000) * 1000,
                totalRevenue: 0,
                totalRevenue5: 0,
                totalRevenue10: 0,
                totalRevenue15: 0,
                totalRevenue20: 0,
                totalRevenue25: 0
            };
            results.totalRevenue = results.revenue + results.assetRevenue;
            results.totalRevenue5 = results.revenue5 + results.assetRevenue5;
            results.totalRevenue10 = results.revenue10 + results.assetRevenue10;
            results.totalRevenue15 = results.revenue15 + results.assetRevenue15;
            results.totalRevenue20 = results.revenue20 + results.assetRevenue20;
            results.totalRevenue25 = results.revenue25 + results.assetRevenue25;
            return results;
        };
        Parser.prototype.getOptimalNetExpenseRatioDrop = function (result) {
            var columns = result.cols;
            var rows = result.rows;
            var row = rows[0];
            var results = {
                // Dividing and multiplying a number with 1000 to round a number to nearest thousand
                optimalExpRatio: Math.round(100 * Number(row ? row[columns.indexOf(Parser.EXP_OPTIMAL)] : 0)),
                optimalGrossSales: Math.round(Number(row ? row[columns.indexOf(Parser.OPTIMAL_GROSS_SALES)] : 0) / 1000) * 1000,
                optimalMarketShare: Number(row ? row[columns.indexOf(Parser.OPTIMAL_MARKET_SHARE)] : 0).toFixed(2),
                optimalMarketShareRank: Number(row ? row[columns.indexOf(Parser.OPTIMAL_MARKET_SHARE_RANK)] : 0),
                optimalRevenue: Math.round(Number(row ? row[columns.indexOf(Parser.OPTIMAL_REVENUE)] : 0) / 1000) * 1000,
                optimalAssetRevenue: Math.round(Number(row ? row[columns.indexOf(Parser.OPTIMAL_ASSET_REVENUE)] : 0) / 1000) * 1000,
                optimalTotalRevenue: 0,
                optimalBpsValue: row ? row[columns.indexOf(Parser.OPTIMAL_BPS_VALUE)] : 0
            };
            results.optimalTotalRevenue = results.optimalRevenue + results.optimalAssetRevenue;
            return results;
        };
        Parser.QUARTER_TYPE_AUM = 'aum';
        Parser.PRODUCT_NAME = "product_name";
        Parser.CATEGORY = "morningstar_product_category";
        Parser.DEFAULT_CATEGORY = "default_category";
        Parser.CHANNEL_NAME = "channel_name";
        Parser.CHANNEL_ID = "channel_id";
        Parser.FIRM_NAME = "firm_name";
        Parser.FIRM_ID = "firm_id";
        Parser.SHARE_CLASS = "product_share_class";
        Parser.TITLE = "title";
        Parser.MIN = "minimum";
        Parser.MAX = "maximum";
        Parser.INIT = "initial_value";
        Parser.TYPE = "is_whole_number";
        Parser.FACTOR1 = "factor1";
        Parser.FACTOR2 = "factor2";
        Parser.FACTOR3 = "factor3";
        Parser.EXP_TITLE = "Net Expense Ratio (bps)";
        Parser.RATING_TITLE = "Rating Overall";
        Parser.PRODUCT_PORTFOLIO = "product_portfolio";
        Parser.ACTUAL_GROSS_SALES = "actual_client_gross_sales";
        Parser.ACTUAL_GROSS_REDEMPTIONS = "actual_client_gross_redemptions";
        Parser.ACTUAL_GROSS_AUM = "actual_client_gross_aum";
        Parser.ACTUAL_CATEGORY_SALES = "actual_category_global_sales";
        Parser.ACTUAL_MARKET_SHARE = "actual_market_share";
        Parser.ACTUAL_EXPECTED_SALES = "actual_expected_sales";
        Parser.ACTUAL_EXPECTED_MARKET_SHARE = "actual_expected_market_share";
        Parser.ACTUAL_EXPECTED_REVENUE = "actual_expected_revenue";
        Parser.ACTUAL_RETURN_3YR = "actual_return_3yr_percentile";
        Parser.ACTUAL_RETURN_1YR = "actual_return_1yr_percentile";
        Parser.ACTUAL_SHARPE_3YR = "actual_sharpe_ratio_3yr_percentile";
        Parser.ACTUAL_SHARPE_1YR = "actual_sharpe_ratio_1yr_percentile";
        Parser.ACTUAL_NET_EXP_RATIO = "actual_net_expense_ratio_percentile";
        Parser.ACTUAL_MANAGER = "actual_manager_tenure_percentile";
        Parser.ACTUAL_YIELD_12MO = "actual_yield_12_mo_percentile";
        Parser.EXPECTED_SALES = "expected_sales";
        Parser.EXPECTED_MARKET_SHARE = "expected_market_share";
        Parser.EXPECTED_REVENUE = "expected_revenue";
        Parser.EXPECTED_RETURN_3YR = "expected_return_3yr_percentile";
        Parser.EXPECTED_RETURN_1YR = "expected_return_1yr_percentile";
        Parser.EXPECTED_SHARPE_3YR = "expected_sharpe_ratio_3yr_percentile";
        Parser.EXPECTED_SHARPE_1YR = "expected_sharpe_ratio_1yr_percentile";
        Parser.EXPECTED_NET_EXP_RATIO = "expected_net_expense_ratio_percentile";
        Parser.EXPECTED_MANAGER_TENURE = "expected_manager_tenure_percentile";
        Parser.EXPECTED_YIELD_12MO = "expected_yield_12_mo_percentile";
        Parser.CHANGE_EXPECTED_SALES = "change_expected_sales";
        Parser.CHANGE_MARKET_SHARE = "change_expected_market_share";
        Parser.CHANGE_EXPECTED_REVENUE = "change_expected_revenue";
        Parser.CHANGE_RETURN_3YR = "change_return_3yr_percentile";
        Parser.CHANGE_RETURN_1YR = "change_return_1yr_percentile";
        Parser.CHANGE_SHARPE_3YR = "change_sharpe_ratio_3yr_percentile";
        Parser.CHANGE_SHARPE_1YR = "change_sharpe_ratio_1yr_percentile";
        Parser.CHANGE_NET_EXP_RATIO = "change_net_expense_ratio_percentile";
        Parser.CHANGE_MANAGER_TENURE = "change_manager_tenure_percentile";
        Parser.CHANGE_YIELD_12_MO = "change_yield_12_mo_percentile";
        Parser.RED_SPACE = "red_space";
        Parser.ACTUAL_RED_SPACE = "actual_red_space";
        Parser.CHANGE_RED_SPACE = "change_red_space";
        Parser.SALES_GREEN_SPACE = "sales_green_space";
        Parser.NEW_SALES_GREEN_SPACE = "new_sales_green_space";
        Parser.GREENER_SALES_GS = "greener_sales_green_space";
        Parser.AUM_GREEN_SPACE = "aum_green_space";
        Parser.NEW_AUM_GREEN_SPACE = "new_aum_green_space";
        Parser.GREENER_AUM_GS = "greener_aum_green_space";
        Parser.NET_EXP_BPS = "annual_report_net_expense_ratio";
        Parser.EXP = "exp";
        Parser.GREEN_SPACE = "green_space";
        Parser.GREEN_SPACE_5 = "green_space_5";
        Parser.GREEN_SPACE_10 = "green_space_10";
        Parser.GREEN_SPACE_15 = "green_space_15";
        Parser.GREEN_SPACE_20 = "green_space_20";
        Parser.GREEN_SPACE_25 = "green_space_25";
        Parser.REVENUE = "rev";
        Parser.REVENUE_5 = "exp_rev_5";
        Parser.REVENUE_10 = "exp_rev_10";
        Parser.REVENUE_15 = "exp_rev_15";
        Parser.REVENUE_20 = "exp_rev_20";
        Parser.REVENUE_25 = "exp_rev_25";
        Parser.ASSET_REVENUE = "asset_rev";
        Parser.ASSET_REVENUE_5 = "exp_asset_rev_5";
        Parser.ASSET_REVENUE_10 = "exp_asset_rev_10";
        Parser.ASSET_REVENUE_15 = "exp_asset_rev_15";
        Parser.ASSET_REVENUE_20 = "exp_asset_rev_20";
        Parser.ASSET_REVENUE_25 = "exp_asset_rev_25";
        Parser.TOTAL_REVENUE = "total_rev";
        Parser.TOTAL_REVENUE_5 = "total_rev_5";
        Parser.TOTAL_REVENUE_10 = "total_rev_10";
        Parser.TOTAL_REVENUE_15 = "total_rev_15";
        Parser.TOTAL_REVENUE_20 = "total_rev_20";
        Parser.TOTAL_REVENUE_25 = "total_rev_25";
        Parser.MARKET_SHARE = "market_share";
        Parser.MARKET_SHARE_5 = "market_share_5";
        Parser.MARKET_SHARE_10 = "market_share_10";
        Parser.MARKET_SHARE_15 = "market_share_15";
        Parser.MARKET_SHARE_20 = "market_share_20";
        Parser.MARKET_SHARE_25 = "market_share_25";
        Parser.MARKET_SHARE_RANK = "market_share_rank";
        Parser.MARKET_SHARE_RANK_5 = "market_share_rank_5";
        Parser.MARKET_SHARE_RANK_10 = "market_share_rank_10";
        Parser.MARKET_SHARE_RANK_15 = "market_share_rank_15";
        Parser.MARKET_SHARE_RANK_20 = "market_share_rank_20";
        Parser.MARKET_SHARE_RANK_25 = "market_share_rank_25";
        Parser.GROSS_SALES = "sales";
        Parser.GROSS_SALES_5 = "expected_sales_5";
        Parser.GROSS_SALES_10 = "expected_sales_10";
        Parser.GROSS_SALES_15 = "expected_sales_15";
        Parser.GROSS_SALES_20 = "expected_sales_20";
        Parser.GROSS_SALES_25 = "expected_sales_25";
        Parser.EXP_OPTIMAL = "expense_ratio_optimal";
        Parser.OPTIMAL_GROSS_SALES = "expected_sales_optimal";
        Parser.OPTIMAL_REVENUE = "rev_optimal";
        Parser.OPTIMAL_ASSET_REVENUE = "asset_rev_optimal";
        Parser.OPTIMAL_TOTAL_REVENUE = "total_optimal_rev";
        Parser.OPTIMAL_MARKET_SHARE = "market_share_optimal";
        Parser.OPTIMAL_MARKET_SHARE_RANK = "market_share_rank_optimal";
        Parser.OPTIMAL_BPS_VALUE = "bps_value";
        Parser.OPTIMAL_GS = "optimal_green_space";
        return Parser;
    }());
    BiWhatIfScenarios.Parser = Parser;
})(BiWhatIfScenarios || (BiWhatIfScenarios = {}));
///<reference path="00.data_type.ts" />
///<reference path="03.service.ts" />
var BiWhatIfScenarios;
(function (BiWhatIfScenarios) {
    var ProductSelection = (function () {
        function ProductSelection(wrapper) {
            this.channalValues = [];
            this.service = new BiWhatIfScenarios.Service();
            this.wrapper = wrapper;
            this.productDropdown = this.wrapper.find("#product-dropdown");
            this.categoryDropdown = this.wrapper.find("#category-dropdown");
            // this.channelDropdownButton = this.wrapper.find("#fake-channel-selector");
            this.channelDropdown = this.wrapper.find("#channel-dropdown");
            // this.firmDropdownButton = this.wrapper.find("#fake-firm-selector");
            this.firmDropdown = this.wrapper.find("#firm-dropdown");
            this.aumDate = this.wrapper.find("#what-if-aum-as-of-date");
            this.salesQuarters = this.wrapper.find("#what-if-transaction-period");
            this.wrapper.find("#firm-wait-icon").hide();
            this.loadDropdowns();
            this.loadChannels();
            this.loadFirms();
            this.loadDates();
            this.setProductAndCategoryLogic();
        }
        ProductSelection.prototype.loadDropdowns = function () {
            var _this = this;
            this.service.getProducts().then(function (data) {
                _this.allProductCategories = data;
                //in comp-insights, check if the tile selected exsists in the dropdown, if not, add it to the dropdown
                var selectedProduct = $("#selected_product").text();
                var selectedCategory = $("#selected_product").attr('value');
                var selectedProductExists = false;
                for (var i = 0; i < data.length; i++) {
                    if (data[i].productName === selectedProduct) {
                        selectedProductExists = true;
                        break;
                    }
                }
                if (!selectedProductExists && selectedProduct != "") {
                    var product_category = {
                        categoryName: selectedCategory,
                        productName: selectedProduct
                    };
                    data.push(product_category);
                }
                data.sort(function (a, b) { return (a.productName > b.productName ? 1 : -1); });
                var defaultOption = jQuery('<option/>', { 'value': '', 'text': 'Select' });
                _this.productDropdown.append(defaultOption.clone());
                _this.categoryDropdown.append(defaultOption.clone());
                data.forEach(function (result) {
                    var option = jQuery('<option/>', { 'value': result.categoryName, 'text': result.productName });
                    _this.productDropdown.append(option);
                });
                var categories = data.map(function (row) { return row.categoryName; }).filter(function (value, index, self) { return self.indexOf(value) == index; }).sort();
                categories.forEach(function (categoryName) {
                    var categoryOption = jQuery('<option/>', { 'value': categoryName, 'text': categoryName });
                    _this.categoryDropdown.append(categoryOption);
                });
                // comp-insghts-set data
                if (selectedProduct != "") {
                    _this.productDropdown.val('');
                    $("#product-dropdown option:contains(" + selectedProduct + ")").prop('selected', true);
                    _this.productDropdown.change();
                }
                else {
                    _this.productDropdown.removeAttr('title');
                    _this.categoryDropdown.removeAttr('title');
                }
            });
        };
        ProductSelection.prototype.onApplyChannels = function (firms) {
            var _this = this;
            var newChannalValues = this.channelDropdown.val();
            var channelChanged = true;
            if (this.channalValues !== null && newChannalValues !== null && newChannalValues.length === this.channalValues.length) {
                var count_1 = 0;
                newChannalValues.forEach(function (channel) {
                    if (_this.channalValues.contains(channel)) {
                        count_1++;
                    }
                });
                if (count_1 === newChannalValues.length) {
                    channelChanged = false;
                }
            }
            this.channalValues = newChannalValues;
            if (newChannalValues === null || newChannalValues.length === 0) {
                var select = new Array();
                var deselect = new Array();
                deselect = this.firmDropdown.val();
                this.firmDropdown.multiselect('select', select);
                this.firmDropdown.multiselect('deselect', deselect);
                this.firmDropdown.multiselect('rebuild');
                this.firmDropdown.multiselect('updateButtonText');
            }
            else if (newChannalValues.length > 0 && (channelChanged === true)) {
                this.wrapper.find("#firm-wait-icon").show();
                this.service.getFirmsByChannel(this.channelDropdown.val()).then(function (data) {
                    _this.firstFirmLoad = false;
                    _this.firmData = data;
                    setTimeout(function () {
                        _this.wrapper.find("#firm-wait-icon").hide();
                        var dataList = data.map(function (firmInnfo) {
                            return {
                                label: firmInnfo.firmName,
                                title: firmInnfo.firmName,
                                value: firmInnfo.firmName
                            };
                        });
                        _this.firmDropdown.multiselect('dataprovider', dataList);
                        if (firms) {
                            _this.firmDropdown.multiselect('select', firms);
                        }
                        else {
                            _this.firmDropdown.multiselect('selectAll', false);
                        }
                        _this.firmDropdown.multiselect('rebuild');
                        _this.firmDropdown.multiselect('updateButtonText');
                    }, 50);
                });
            }
        };
        ProductSelection.prototype.resetFirms = function () {
            var _this = this;
            this.wrapper.find("#firm-wait-icon").show();
            this.service.getFirms().then(function (data) {
                _this.firstFirmLoad = false;
                _this.firmData = data;
                setTimeout(function () {
                    _this.wrapper.find("#firm-wait-icon").hide();
                    var dataList = data.map(function (firmInnfo) {
                        return {
                            label: firmInnfo.firmName,
                            title: firmInnfo.firmName,
                            value: firmInnfo.firmName
                        };
                    });
                    _this.firmDropdown.multiselect('dataprovider', dataList);
                    _this.firmDropdown.multiselect('selectAll', true);
                    _this.firmDropdown.multiselect('rebuild');
                    _this.setFirmDropdown();
                    setTimeout(function () {
                        _this.onFirmsApply();
                    }, 700);
                }, 500);
            });
        };
        ProductSelection.prototype.getChannelNameById = function (id) {
            var channelName = '';
            for (var i = 0; i < this.channelData.length; i++) {
                if (this.channelData[i].channelId === id) {
                    return this.channelData[i].channelName;
                }
            }
            return channelName;
        };
        ProductSelection.prototype.channelLabels = function () {
            var channelIds = this.channelDropdown.val();
            if (channelIds !== null && channelIds !== undefined && channelIds.length > 0) {
                if (channelIds.length === 1) {
                    var name_1 = this.getChannelNameById(parseInt(channelIds[0]));
                    if (name_1.length > 31) {
                        return name_1.substring(0, 31);
                    }
                    else
                        return name_1;
                }
                else {
                    return channelIds.length + ' Channels Selected';
                }
            }
            else {
                return 'All Channels';
            }
        };
        ProductSelection.prototype.firmLabels = function () {
            var text = this.firmDropdown.val();
            if (text !== null && text !== undefined && text.length > 0) {
                if (text.length === 1) {
                    if (text[0].length > 31) {
                        return text[0].substring(0, 31);
                    }
                    else
                        return text[0];
                }
                else {
                    return text.length + ' Firms Selected';
                }
            }
            else {
                return 'All Firms';
            }
        };
        ProductSelection.prototype.onFirmsApply = function () {
            var select = new Array();
            var deselect = new Array();
            var channelIdSet = [];
            var firms = this.firmDropdown.val();
            if (firms !== null && firms !== undefined && firms.length > 0) {
                for (var i = 0; i < firms.length; i++) {
                    var channelIds = this.getChannelIdByFirmName(firms[i]);
                    if (channelIds !== null) {
                        channelIds.forEach(function (channelId) {
                            if (channelIdSet.indexOf(channelId) < 0) {
                                channelIdSet.push(channelId);
                            }
                        });
                    }
                }
            }
            this.channelData.forEach(function (channel) {
                if (channelIdSet.indexOf(channel.channelId) < 0) {
                    deselect.push(channel.channelId + '');
                }
                else {
                    select.push(channel.channelId + '');
                }
            });
            this.channelDropdown.multiselect('select', select);
            this.channelDropdown.multiselect('deselect', deselect);
            this.channelDropdown.multiselect('rebuild');
            this.channelDropdown.multiselect('updateButtonText');
            this.channalValues = this.channelDropdown.val();
        };
        ProductSelection.prototype.getChannelIdByFirmName = function (name) {
            for (var i = 0; i < this.firmData.length; i++) {
                if (name === this.firmData[i].firmName) {
                    return this.firmData[i].channelIds;
                }
            }
            return null;
        };
        ProductSelection.prototype.loadChannels = function () {
            var _this = this;
            var self = this;
            var multiSelectOptions = {
                nonSelectedText: 'All Channels',
                includeSelectAllOption: false,
                numberDisplayed: 1,
                maxHeight: 200,
                enableFiltering: false,
                enableCaseInsensitiveFiltering: false
            };
            multiSelectOptions.buttonText = function () {
                return self.channelLabels();
            };
            multiSelectOptions.onDropdownHidden = function () {
                self.onApplyChannels();
            };
            this.channelDropdown.multiselect(multiSelectOptions);
            this.service.getChannels().then(function (data) {
                var dataList = data.map(function (channelInfo) {
                    return {
                        label: channelInfo.channelName,
                        title: channelInfo.channelName,
                        value: channelInfo.channelId
                    };
                });
                _this.channelDropdown.multiselect('dataprovider', dataList);
                _this.channelData = data;
                //this.channelDropdown.multiselect('selectAll', false);
                //this.channelDropdown.multiselect('rebuild');
                _this.channalValues = _this.channelDropdown.val();
            });
        };
        ProductSelection.prototype.loadFirms = function () {
            var _this = this;
            var self = this;
            this.firmDropdown.multiselect({
                nonSelectedText: 'All Firms',
                includeSelectAllOption: true,
                numberDisplayed: 1,
                maxHeight: 200,
                enableFiltering: false,
                enableCaseInsensitiveFiltering: false,
                buttonText: function () {
                    return self.firmLabels();
                },
                onDropdownHidden: function () {
                    self.onFirmsApply();
                }
            });
            this.service.getFirms().then(function (data) {
                _this.firstFirmLoad = true;
                var dataList = data.map(function (firmInnfo) {
                    return {
                        label: firmInnfo.firmName,
                        title: firmInnfo.firmName,
                        value: firmInnfo.firmName
                    };
                });
                _this.firmDropdown.multiselect('dataprovider', dataList);
                //this.firmDropdown.multiselect('selectAll', false);
                //this.firmDropdown.multiselect('rebuild');
                _this.firmData = data;
            });
        };
        ProductSelection.prototype.loadDates = function () {
            var _this = this;
            this.service.getTransactionDates().then(function (data) {
                _this.aumDate.text(data.monthAum + "/" + data.dayAum + "/" + data.yearAum);
                _this.salesQuarters.text(data.filteredQuarters.first() + " - " + data.filteredQuarters.last());
                _this.latestQuarter = data.filteredQuarters.last();
            });
        };
        ProductSelection.prototype.getLatestQuarter = function () {
            return this.latestQuarter;
        };
        ProductSelection.prototype.setProductAndCategoryLogic = function () {
            var _this = this;
            this.categoryDropdown.change(function (e) {
                var selectedCategory = $(e.target).find(":selected").val();
                _this.productDropdown.val(selectedCategory).change();
            });
            this.productDropdown.change(function (e) {
                var selectedCategory = $(e.target).find(":selected").val();
                var selectedProduct = $(e.target).find(":selected").text();
                if (selectedCategory === "") {
                    _this.categoryDropdown.val(selectedCategory).removeAttr('title');
                    _this.productDropdown.removeAttr('title');
                }
                else {
                    _this.categoryDropdown.val(selectedCategory).attr('title', selectedCategory);
                    _this.productDropdown.attr('title', selectedProduct);
                }
            });
        };
        ProductSelection.prototype.resetCategoryDropdown = function () {
            this.categoryDropdown.empty();
            this.categoryDropdown.removeAttr('title');
            var option = jQuery('<option/>', { 'value': '', 'text': 'Select' });
            this.categoryDropdown.append(option);
        };
        ProductSelection.prototype.resetFirmDropdown = function () {
            this.firmDropdown.empty();
            this.firmDropdown.removeAttr('title');
            var option = jQuery('<option/>', { 'class': 'all-option', 'value': '-1', 'text': 'All Firms' });
            this.firmDropdown.append(option);
            this.firmDropdown.attr('disabled', 'true');
        };
        ProductSelection.prototype.addAllOption = function (text, dropdown) {
            var all = jQuery('<option/>', { 'class': 'all-option', 'value': -1, 'text': text });
            all.mousedown(function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                dropdown.find('option').prop('selected', false);
                $(e.target).toggleClass('selected');
                $(e.target).prop('selected', !$(e.target).prop('selected'));
                dropdown.children().show();
                return false;
            });
            dropdown.append(all);
        };
        ProductSelection.prototype.getChannelNames = function () {
            var _this = this;
            var names = [];
            var ids = this.channelDropdown.val();
            if (ids !== null) {
                ids.forEach(function (id) {
                    for (var i = 0; i < _this.channelData.length; i++) {
                        if (_this.channelData[i].channelId === parseInt(id)) {
                            names.push(_this.channelData[i].channelName);
                            break;
                        }
                    }
                });
            }
            return names;
        };
        ProductSelection.prototype.getFirmIds = function () {
            var _this = this;
            var ids = [];
            var names = this.firmDropdown.val();
            if (names !== null) {
                names.forEach(function (id) {
                    for (var i = 0; i < _this.firmData.length; i++) {
                        if (_this.firmData[i].firm_name === names[i]) {
                            ids.push(_this.firmData[i].firm_id);
                            break;
                        }
                    }
                });
            }
            return ids;
        };
        ProductSelection.prototype.getDropdownInfo = function () {
            var values = {
                category: this.categoryDropdown.find("option:selected").text(),
                categoryId: this.categoryDropdown.val(),
                product: this.productDropdown.find("option:selected").text(),
                productId: this.productDropdown.val(),
                channels: this.getChannelNames(),
                channelIds: this.channelDropdown.val(),
                firms: this.firmDropdown.val(),
                firmIds: this.getFirmIds()
            };
            return values;
        };
        ProductSelection.prototype.setFirmDropdown = function () {
            var _this = this;
            var ci_firmname = $('#comp-insights-firmname');
            if (ci_firmname.length > 0) {
                var select = new Array();
                var deselect = new Array();
                select.push(ci_firmname.text());
                deselect = this.firmDropdown.val();
                this.firmDropdown.multiselect('deselect', deselect);
                setTimeout(function () {
                    _this.firmDropdown.multiselect('select', select);
                }, 600);
                this.firmDropdown.multiselect('rebuild');
                this.firmDropdown.multiselect('updateButtonText');
            }
        };
        return ProductSelection;
    }());
    BiWhatIfScenarios.ProductSelection = ProductSelection;
})(BiWhatIfScenarios || (BiWhatIfScenarios = {}));
///<reference path="00.data_type.ts" />
///<reference path="03.service.ts" />
///<reference path="01.strings.ts" />
var BiWhatIfScenarios;
(function (BiWhatIfScenarios) {
    var ActualValues = (function () {
        function ActualValues() {
        }
        return ActualValues;
    }());
    BiWhatIfScenarios.ActualValues = ActualValues;
    var ExpectedSales = (function () {
        function ExpectedSales(wrapper, service, values, factors, shareClass) {
            this.isFromSavedScenario = false;
            this.isUpdateable = false;
            this.actualValues = null;
            this.timeOut = 500; //in milliseconds
            this.wrapper = wrapper.find("#expected-model-info");
            this.service = service;
            this.values = values;
            this.factors = factors;
            this.shareClass = shareClass.toUpperCase();
            this.buildModelUi();
            this.wrapper.removeClass('hidden');
            this.getExpectedSalesData(BiWhatIfScenarios.FactorTypeEnum.ACTUAL, this.factors, this.displayTables); //Initial data call and table creation
        }
        ExpectedSales.prototype.buildModelUi = function () {
            this.buildShareClassWrapper();
            this.buildScenarioBox(BiWhatIfScenarios.Strings.SCENARIO_A_TITLE, false);
            this.buildScenarioBox(BiWhatIfScenarios.Strings.SCENARIO_B_TITLE, true);
            this.addScenarioButton();
        };
        ExpectedSales.prototype.buildShareClassWrapper = function () {
            var keySalesDriver = jQuery('<div>', { 'class': 'share-class-subheader', 'text': BiWhatIfScenarios.Strings.KEY_DRIVER_TABLE_LABEL + ' | ' });
            var shareClassTitle = jQuery('<div>', { 'class': 'share-class-title', 'html': BiWhatIfScenarios.Strings.SHARE_CLASS_TITLE + ' ' + this.shareClass + '&nbsp;' });
            var shareClassInfoWrapper = jQuery('<div>', { 'class': 'share-class-info-wrapper' });
            var shareClassInfoIcon = jQuery('<span>', { 'class': 'glyphicon glyphicon-info-sign share-class-info-icon' });
            var shareClassInfoMsg = jQuery('<div>', { 'class': 'share-class-info-msg', 'text': BiWhatIfScenarios.Strings.SHARE_CLASS_INFO_MSG });
            shareClassInfoWrapper.append(shareClassInfoIcon, shareClassInfoMsg);
            this.wrapper.append(keySalesDriver, shareClassTitle, shareClassInfoWrapper);
        };
        ExpectedSales.prototype.buildQuestionIcon = function (isScenarioB) {
            var iconWrapper = jQuery('<div>', { 'class': 'share-class-info-wrapper question-key-driver' });
            var questionInfoIcon = jQuery('<span>', { 'class': 'glyphicon glyphicon-question-sign share-class-info-icon question-mark-icon' });
            var questionMsg = jQuery('<div>', { 'class': 'share-class-info-msg question-mark-msg', 'text': BiWhatIfScenarios.Strings.SCENARIO_BOX_QUESTION_MSG });
            if (isScenarioB) {
                questionMsg.removeClass('question-mark-msg').addClass('question-mark-msg-2');
            }
            return iconWrapper.append(questionInfoIcon, questionMsg);
        };
        ExpectedSales.prototype.buildScenarioBox = function (title, closeable) {
            var _this = this;
            var factorEnum = title === BiWhatIfScenarios.Strings.SCENARIO_A_TITLE ? BiWhatIfScenarios.FactorTypeEnum.SCENARIOA : BiWhatIfScenarios.FactorTypeEnum.SCENARIOB;
            var scenarioBox = jQuery('<div/>', { 'class': 'what-if-scenario-div' });
            scenarioBox.append(jQuery('<div/>', { 'class': 'what-if-scenario-title', 'text': title }).append(this.buildQuestionIcon(closeable)));
            if (closeable) {
                scenarioBox.addClass('scenario-b-margin-bottom');
                var closeBox = jQuery('<div/>', { 'class': 'close-scenario-box glyphicon glyphicon-remove' });
                closeBox.click(function (e) {
                    scenarioBox.hide();
                    $(".green-space-div-table, .key-driver-div-table, .sales-share-div-table").removeClass("max-width").addClass("fixed-width");
                    _this.wrapper.find('.add-scenario-div').show();
                    _this.wrapper.find('.scen-b').hide();
                    _this.wrapper.find('.scenario-b-margin-bottom').find(".slider-changed").removeClass("slider-changed");
                    $(".table-header-message").removeClass("table-header-message-adjustment");
                    $(".key-driver-table-msg-adj").addClass("key-driver-table-msg").removeClass("key-driver-table-msg-adj");
                    $(".sales-table-msg-adj").addClass("sales-table-msg").removeClass("sales-table-msg-adj");
                    $(".green-table-msg-adj").addClass("green-table-msg").removeClass("green-table-msg-adj");
                    _this.resetScenarioB();
                    _this.toggleScenarioAWaitIcon(false);
                    if (_this.isFromSavedScenario) {
                        $(".save-button-wrapper").show();
                    }
                    var scenario = $("#what-if-scenario-input").data('scenarioInfo');
                    if (scenario && scenario.scenario.factorDetails[1]) {
                        $("#what-if-scenario-input").addClass('updateable-scenario');
                        jQuery(".save-scenario").show();
                    }
                    $('.scenario-header-label, .sales-border-div, .gs-border-div').removeClass('expected-sales-border-right');
                    $('.scenario-header-label').not(':hidden').last().addClass('expected-sales-border-right');
                    $('.sales-border-div').not(':hidden').last().addClass('expected-sales-border-right');
                    $('.gs-border-div').not(':hidden').last().addClass('expected-sales-border-right');
                });
                scenarioBox.append(closeBox);
            }
            var factorDiv = jQuery('<div/>', { 'class': 'factor-div-row' });
            this.factors.forEach(function (factor) {
                var factorBox = jQuery('<div/>', { 'class': 'factor-box' });
                factorBox.data("isWholeNumber", factor.isWholeNumber);
                var factorTitle = jQuery('<div/>', { 'class': 'factor-box-title' });
                factorTitle.append(jQuery('<div/>', { 'class': 'factor-title-div', 'text': factor.title }));
                factorTitle.append(jQuery('<div/>', { 'class': 'factor-error-msg', 'text': BiWhatIfScenarios.Strings.FACTOR_ERROR_MSG, 'style': "display: none" }));
                factorBox.append(factorTitle);
                var adjuster = jQuery('<div/>', { 'class': 'factor-box-adjuster' });
                var actualValueDiv = jQuery('<div/>', { 'class': 'factor-current-adjustment' });
                actualValueDiv.append(jQuery('<div/>', { 'class': 'actual-factor-label', 'text': BiWhatIfScenarios.Strings.ACTUAL_LABEL }));
                actualValueDiv.append(jQuery('<div/>', { 'id': 'first-factor', 'class': 'selected-factor', 'text': factor.initial }));
                adjuster.append(actualValueDiv, _this.createSlideBarDiv(factor, factorTitle, factorEnum));
                factorBox.append(adjuster);
                factorDiv.append(factorBox);
            });
            scenarioBox.append(factorDiv);
            if (closeable) {
                scenarioBox.hide();
            }
            this.wrapper.append(scenarioBox);
        };
        ExpectedSales.prototype.addScenarioButton = function () {
            var _this = this;
            var addScenarioDiv = jQuery('<div/>', { 'class': 'add-scenario-div' });
            addScenarioDiv.append(jQuery('<img/>', { 'src': '/assets/img/add-scenario-icon.svg' }));
            addScenarioDiv.append(jQuery('<div/>', { 'class': 'add-scenario-label', 'text': BiWhatIfScenarios.Strings.ADD_ANOTHER_LABEL }));
            addScenarioDiv.click(function (e) {
                $(".add-scenario-div").hide();
                $(_this.wrapper.find(".what-if-scenario-div").get(1)).show();
                _this.wrapper.find(".scen-b").show();
                _this.toggleScenarioAWaitIcon(true);
                $(".green-space-div-table, .key-driver-div-table, .sales-share-div-table").addClass("max-width").removeClass("fixed-width");
                $(".table-header-message").addClass("table-header-message-adjustment");
                $(".key-driver-table-msg").addClass("key-driver-table-msg-adj").removeClass("key-driver-table-msg");
                $(".sales-table-msg").addClass("sales-table-msg-adj").removeClass("sales-table-msg");
                $(".green-table-msg").addClass("green-table-msg-adj").removeClass("green-table-msg");
                if (_this.isFromSavedScenario) {
                    $(".save-button-wrapper").show();
                }
                var scenario = $("#what-if-scenario-input").data('scenarioInfo');
                if (scenario && !scenario.scenario.factorDetails[1]) {
                    $("#what-if-scenario-input").addClass('updateable-scenario');
                    jQuery(".save-scenario").show();
                }
                $('.scenario-header-label, .sales-border-div, .gs-border-div').removeClass('expected-sales-border-right');
                $('.scenario-header-label').not(':hidden').last().addClass('expected-sales-border-right');
                $('.sales-border-div').not(':hidden').last().addClass('expected-sales-border-right');
                $('.gs-border-div').not(':hidden').last().addClass('expected-sales-border-right');
            });
            this.wrapper.append(addScenarioDiv);
        };
        ExpectedSales.prototype.createSlideBarDiv = function (factor, factorTitle, factorEnum) {
            var _this = this;
            var that = this;
            var slideBarHoverTextWrapper = jQuery('<div/>', { 'class': 'factor-slide-bar-hover-text-wrapper' });
            var sliderHoverText = jQuery("<div/>", { 'class': 'factor-slide-bar-hover-text' });
            var sliderHoverTextValue = jQuery("<div/>", { 'class': 'factor-slide-bar-hover-text-value' });
            var slideBar = jQuery('<div/>', { 'class': 'factor-slide-bar' });
            var input = this.createSlideBarInput(factor);
            var rightSideDiv = jQuery("<div/>", { 'class': 'factor-slide-bar-right-div' });
            var bottomRange = jQuery("<div/>", { 'class': 'factor-slide-bar-bottom-range' });
            var bottomRangeValue = jQuery("<div/>", { 'class': 'factor-slide-bar-bottom-range-value' });
            var minRange = jQuery("<div/>", { "text": factor.minimum.toFixed(0) });
            var maxRange = jQuery("<div/>", { "text": factor.maximum.toFixed(0) });
            bottomRangeValue.append(minRange, maxRange);
            var rightSideInput = jQuery("<input/>", { "type": "text" });
            rightSideDiv.append(rightSideInput);
            bottomRange.append(bottomRangeValue);
            sliderHoverText.append(sliderHoverTextValue);
            slideBarHoverTextWrapper.append(sliderHoverText);
            var timeOut = 0;
            //slider
            input.change(function (e) {
                clearTimeout(timeOut);
                timeOut = setTimeout(function (e) {
                    var newInput = input.val();
                    newInput = newInput > factor.maximum ? factor.maximum : newInput;
                    if (parseInt(newInput) !== factor.initial) {
                        slideBar.parent('.factor-box-adjuster').addClass('slider-changed');
                        rightSideInput.val(newInput);
                        rightSideInput.prop("placeholder", newInput);
                    }
                    else {
                        slideBar.parent('.factor-box-adjuster').removeClass('slider-changed');
                        rightSideInput.val('');
                        rightSideInput.prop("placeholder", '');
                    }
                    input.val(newInput);
                    factorTitle.find(".factor-error-msg").hide();
                    bottomRangeValue.prop("placeholder", newInput);
                    sliderHoverTextValue.prop("placeholder", newInput);
                    bottomRangeValue.val(newInput);
                    sliderHoverTextValue.text(newInput);
                    sliderHoverText.css("left", that.getSliderTooltipValue(parseFloat(newInput), Math.round(factor.maximum), Math.round(factor.minimum)));
                    sliderHoverText.show();
                    that.toggleWaitingOverlays(factorEnum, true);
                    that.toggleKeyDriverDisable(factorEnum, true);
                    if (that.isFromSavedScenario) {
                        $(".save-button-wrapper").show();
                        that.isUpdateable = true;
                    }
                    else {
                        sliderHoverText.hide();
                        that.getExpectedSalesData(factorEnum, that.getSliderValues(factorEnum, false), that.updateTables);
                    }
                }, _this.timeOut);
            });
            input.hover(function (e) {
                if (sliderHoverTextValue.text() == '') {
                    sliderHoverTextValue.text(input.val());
                }
                sliderHoverText.css("left", that.getSliderTooltipValue(parseFloat(input.val()), Math.round(factor.maximum), Math.round(factor.minimum)));
                if (e.type === "mouseenter") {
                    sliderHoverText.show();
                }
                else {
                    sliderHoverText.hide();
                }
            });
            input.get(0).oninput = function (e) {
                var newInput = $(e.target).val();
                newInput = newInput > factor.maximum ? factor.maximum : newInput;
                sliderHoverTextValue.text(newInput);
                sliderHoverText.css("left", that.getSliderTooltipValue(parseFloat(newInput), Math.round(factor.maximum), Math.round(factor.minimum)));
                sliderHoverText.show();
                $(e.target).css("background", that.getGradientCssString(newInput, Math.round(factor.maximum), Math.round(factor.minimum)));
            };
            //slider call purely to update UI, calling the change function will also call the getExpectedSalesData function again
            input.on('update-slider', function (event, newValue) {
                newValue = newValue > factor.maximum ? factor.maximum : newValue;
                input.val(newValue);
                sliderHoverTextValue.text(newValue);
                sliderHoverText.css("left", that.getSliderTooltipValue(parseFloat(newValue), Math.round(factor.maximum), Math.round(factor.minimum)));
                // sliderHoverText.show();
                input.css("background", that.getGradientCssString(parseFloat(newValue), Math.round(factor.maximum), Math.round(factor.minimum)));
            });
            //text box
            rightSideInput.change(function (e) {
                clearTimeout(timeOut);
                timeOut = setTimeout(function (e) {
                    var valueEntered = rightSideInput.val();
                    valueEntered = valueEntered > factor.maximum ? factor.maximum : valueEntered;
                    if (parseFloat(valueEntered) !== factor.initial) {
                        slideBar.parent('.factor-box-adjuster').addClass('slider-changed');
                        rightSideInput.val(valueEntered);
                    }
                    else {
                        slideBar.parent('.factor-box-adjuster').removeClass('slider-changed');
                        rightSideInput.val('');
                        rightSideInput.prop("placeholder", '');
                    }
                    if (isNaN(valueEntered)) {
                        factorTitle.find(".factor-error-msg").show();
                    }
                    else {
                        factorTitle.find(".factor-error-msg").hide();
                        input.val(valueEntered).trigger('update-slider', [valueEntered]);
                        that.toggleWaitingOverlays(factorEnum, true);
                        that.toggleKeyDriverDisable(factorEnum, true);
                        if (that.isFromSavedScenario) {
                            $(".save-button-wrapper").show();
                            that.isUpdateable = true;
                        }
                        else {
                            that.getExpectedSalesData(factorEnum, that.getSliderValues(factorEnum, false), that.updateTables);
                        }
                    }
                }, _this.timeOut);
            });
            var rightSliderTitle = jQuery("<div/>", { 'text': BiWhatIfScenarios.Strings.ENTER_WHAT_IF_LABEL, 'class': 'factor-slide-bar-title' });
            var inputDiv = jQuery('<div/>', { 'class': 'factor-input-div' });
            inputDiv.append(rightSliderTitle, rightSideDiv, slideBarHoverTextWrapper, input);
            return slideBar.append(inputDiv, bottomRange);
        };
        //each possible factor have a different method for rounding the 
        //  endpoints as well as the step value needed for the slide bar.
        //This method builds the right kind of slide bar based on the title of the factor
        ExpectedSales.prototype.createSlideBarInput = function (factor) {
            var step = 0;
            if (factor.isWholeNumber) {
                step = 1;
            }
            else {
                step = .1;
            }
            //create a gradient that goes to the initial value on the slidebar
            var slideBar = jQuery("<input/>", { "type": "range", "max": Math.round(factor.maximum), "min": Math.round(factor.minimum), "step": step, "value": factor.initial, "class": "factor-slider" });
            // var slideBarHoverTextWrapper = jQuery('<output/>', {'class': 'factor-slide-bar-hover-text-wrapper'});
            // slideBar.append(slideBarHoverTextWrapper)
            slideBar.css("background", this.getGradientCssString(factor.initial, Math.round(factor.maximum), Math.round(factor.minimum)));
            return slideBar;
        };
        ExpectedSales.prototype.getGradientCssString = function (newValue, max, min) {
            var backgroundValue = (newValue - Math.round(min)) / (Math.round(max) - Math.round(min)) * 100;
            return 'linear-gradient(to right, #337ab7 0%, #337ab7 ' + backgroundValue + '%, #b6b6b6 ' + backgroundValue + '%, #b6b6b6 100%)';
        };
        ExpectedSales.prototype.getSliderTooltipValue = function (newValue, max, min) {
            var backgroundValue = Number(newValue - min) * 100 / (max - min);
            var sliderShiftValue = "calc(" + backgroundValue + "% + (" + (backgroundValue * .33 + 8) + "px))";
            return "" + sliderShiftValue;
        };
        ExpectedSales.prototype.toggleKeyDriverDisable = function (factorEnum, disable) {
            var keyDriverBox = factorEnum === BiWhatIfScenarios.FactorTypeEnum.SCENARIOA ? this.wrapper.find('.what-if-scenario-div').get(0) : this.wrapper.find('.what-if-scenario-div').get(1);
            var sliderInputs = $(keyDriverBox).find('.factor-slider');
            var rightInputs = $(keyDriverBox).find(".factor-slide-bar-right-div > input");
            sliderInputs.toArray().forEach(function (input) {
                $(input).prop("disabled", disable);
            });
            rightInputs.toArray().forEach(function (input) {
                $(input).prop("disabled", disable);
            });
            $('.add-scenario-div').click(disable);
        };
        ExpectedSales.showUpdateableNameCss = function () {
            $(".scenario-name-error-msg").hide();
            $(".save-scenario").show();
            $("#what-if-scenario-input").addClass("updateable-scenario");
            $("#what-if-scenario-input").data('originalName', $("#what-if-scenario-input").val().trimLeft());
        };
        ExpectedSales.prototype.getExpectedSalesData = function (factorEnum, factors, doneFunction, isFromSavedScenario, scenario) {
            if (isFromSavedScenario === void 0) { isFromSavedScenario = false; }
            var that = this;
            this.isFromSavedScenario = isFromSavedScenario;
            if (this.isFromSavedScenario) {
                var salesData = factorEnum === BiWhatIfScenarios.FactorTypeEnum.SCENARIOA ? scenario.salesDataA : scenario.salesDataB;
                var greenSpaceData = factorEnum === BiWhatIfScenarios.FactorTypeEnum.SCENARIOA ? scenario.greenSpaceDataA : scenario.greenSpaceDataB;
                var redSpaceData = factorEnum === BiWhatIfScenarios.FactorTypeEnum.SCENARIOA ? scenario.redSpaceDataA : scenario.redSpaceDataB;
                this.updateTables(factors, factorEnum, salesData, redSpaceData, greenSpaceData, this);
                this.setData(greenSpaceData, redSpaceData, salesData, factorEnum);
            }
            else {
                $.when(that.service.getExpectedSalesData(that.getScenarioInfo(factorEnum)), that.service.getESRedSpaceData(that.getScenarioInfo(factorEnum)), that.service.getESGreenSpace(that.getScenarioInfo(factorEnum)))
                    .done(function (sales, red, green) {
                    doneFunction(factors, factorEnum, sales, red, green, that);
                    that.setData(green, red, sales, factorEnum);
                    if (doneFunction === that.displayTables) {
                        that.actualSalesData = sales;
                        that.actualGreenSpaceData = green;
                        that.actualRedSpaceData = red;
                        that.actualValues = { salesShareData: sales, greenSalesData: green, redSalesData: red };
                    }
                    if (that.isUpdateable && !that.isFromSavedScenario) {
                        ExpectedSales.showUpdateableNameCss();
                    }
                });
            }
        };
        ExpectedSales.prototype.displaySalesTable = function (factors, factortype, salesData, that, tableDiv) {
            var formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0, minimumFractionDigits: 0 });
            var keyDriverTable = jQuery("<div/>", { "class": "key-driver-div-table", "id": "keyDriverTable" });
            var keyDriverHeader = jQuery("<div/>", { "class": "key-driver-div-table-header what-if-row what-if-header" });
            var keyDriverTitle = jQuery("<div/>", { "class": "factor-header-label" });
            keyDriverTitle.append(jQuery("<div/>", { "text": BiWhatIfScenarios.Strings.KEY_DRIVER_TABLE_LABEL }));
            keyDriverTitle.append(this.createTableIcon(1));
            keyDriverHeader.append(keyDriverTitle);
            keyDriverHeader.append(jQuery("<div/>", { "class": "actual-header-label", "text": BiWhatIfScenarios.Strings.ACTUAL_COLUMN_LABEL }));
            keyDriverHeader.append(jQuery("<div/>", { "class": "scenario-header-label", "text": BiWhatIfScenarios.Strings.SCENARIO_A_HEADER }));
            keyDriverHeader.append(jQuery("<div/>", { "class": "scenario-header-label expected-sales-border-right", "text": BiWhatIfScenarios.Strings.CHANGE_A_HEADER }));
            keyDriverHeader.append(jQuery("<div/>", { "class": "scenario-header-label scen-b", "text": BiWhatIfScenarios.Strings.SCENARIO_B_HEADER, "style": "display: none" }));
            keyDriverHeader.append(jQuery("<div/>", { "class": "scenario-header-label scen-b", "text": BiWhatIfScenarios.Strings.CHANGE_B_HEADER, "style": "display: none" }));
            keyDriverTable.append(keyDriverHeader);
            factors.forEach(function (factor) {
                var nameCell = jQuery("<div/>", { "text": factor.title });
                var actualCell = jQuery("<div/>", { "text": factor.initial });
                var scenACell = jQuery("<div/>", { "class": "no-overlay scen-a kda-" + factor.title.replace(/\s|(\(|\))/g, ""), "text": factor.initial });
                var changeACell = jQuery("<div/>", { "class": "no-overlay scen-a kdac-" + factor.title.replace(/\s|(\(|\))/g, ""), "text": "0" });
                var scenBCell = jQuery("<div/>", { "class": "scen-b kdb-" + factor.title.replace(/\s|(\(|\))/g, ""), "text": factor.initial, "style": "display: none" });
                var changeBCell = jQuery("<div/>", { "class": "scen-b kdbc-" + factor.title.replace(/\s|(\(|\))/g, ""), "text": "0", "style": "display: none" });
                var factorRow = jQuery("<div/>", { "class": "key-driver-row what-if-row" });
                factorRow.append(nameCell, actualCell, scenACell, changeACell, scenBCell, changeBCell);
                keyDriverTable.append(factorRow);
                if (factor.title !== BiWhatIfScenarios.FactorTitleEnum.RATING) {
                    var factorRowPercentile = jQuery("<div/>", { "class": "key-driver-row what-if-row" });
                    factorRowPercentile.append(jQuery("<div/>", { "text": factor.title + " (percentile)" }));
                    factorRowPercentile.append(jQuery("<div/>", { "text": ExpectedSales.getFactorPercentile(factor.title, salesData, BiWhatIfScenarios.SalesDatumType.ACTUAL) + "%" }));
                    factorRowPercentile.append(jQuery("<div/>", { "class": "no-overlay scen-a kdap-" + factor.title.replace(/\s|(\(|\))/g, ""), "text": ExpectedSales.getFactorPercentile(factor.title, salesData, BiWhatIfScenarios.SalesDatumType.ACTUAL) + "%" }));
                    factorRowPercentile.append(jQuery("<div/>", { "class": "no-overlay scen-a kdapc-" + factor.title.replace(/\s|(\(|\))/g, ""), "text": BiWhatIfScenarios.Strings.DEFAULT_PERCENTAGE }));
                    factorRowPercentile.append(jQuery("<div/>", { "class": "scen-b kdbp-" + factor.title.replace(/\s|(\(|\))/g, ""), "text": ExpectedSales.getFactorPercentile(factor.title, salesData, BiWhatIfScenarios.SalesDatumType.ACTUAL) + "%", "style": "display: none" }));
                    factorRowPercentile.append(jQuery("<div/>", { "class": "scen-b kdbpc-" + factor.title.replace(/\s|(\(|\))/g, ""), "text": BiWhatIfScenarios.Strings.DEFAULT_PERCENTAGE, "style": "display: none" }));
                    keyDriverTable.append(factorRowPercentile);
                }
            });
            var factorLoader = jQuery('<img/>', { 'src': '/assets/img/wheel.gif', 'class': 'waiting-icon waiting-icon-a' });
            var factorLoaderB = jQuery('<img/>', { 'src': '/assets/img/wheel.gif', 'class': 'waiting-icon waiting-icon-b' });
            if (factors.length === 1) {
                factorLoader.addClass("one-row-factor");
                factorLoaderB.addClass("one-row-factor");
            }
            else if (factors.length === 2) {
                factorLoader.addClass("two-row-factor");
                factorLoaderB.addClass("two-row-factor");
            }
            else {
                factorLoader.addClass("regular-loader");
                factorLoaderB.addClass("regular-loader");
            }
            //Sales, Revenue, & Market Share
            var salesShareTable = jQuery("<div/>", { "class": "sales-share-div-table", "id": "salesShareTable" });
            var salesShareHeader = jQuery("<div/>", { "class": "sales-share-div-table-header what-if-row what-if-header" });
            var salesTitle = jQuery("<div/>", { "class": "factor-header-label" });
            salesTitle.append(jQuery("<div/>", { "text": BiWhatIfScenarios.Strings.SALES_SHARE_TABLE_LABEL }), this.createTableIcon(2));
            salesTitle.append(jQuery("<span/>", { 'class': 'table-header-message', 'text': BiWhatIfScenarios.Strings.SALES_TABLE_HEADER_MSG }));
            salesShareHeader.append(salesTitle);
            salesShareHeader.append(jQuery("<div/>"), jQuery("<div/>"), jQuery("<div/>", { "class": "sales-border-div expected-sales-border-right" }), jQuery("<div/>", { "class": "scen-b blank-header", "style": "display: none" }), jQuery("<div/>", { "class": "scen-b blank-header sales-border-div", "style": "display: none" })); //filler cells
            var grossSalesRow = jQuery("<div/>", { "class": "sales-share-row what-if-row" });
            grossSalesRow.append(jQuery("<div/>", { "text": "Gross Sales" }));
            grossSalesRow.append(jQuery("<div/>", { "text": formatter.format(salesData.actualClientGrossSales) }));
            grossSalesRow.append(jQuery("<div/>", { "class": "blank-sales-share-cell" }));
            grossSalesRow.append(jQuery("<div/>", { "class": "blank-sales-share-cell" }));
            grossSalesRow.append(jQuery("<div/>", { "class": "blank-sales-share-cell scen-b", "style": "display: none" }));
            grossSalesRow.append(jQuery("<div/>", { "class": "blank-sales-share-cell scen-b", "style": "display: none" }));
            var grossMrktRow = jQuery("<div/>", { "class": "sales-share-row what-if-row" });
            grossMrktRow.append(jQuery("<div/>", { "text": "Gross Sales Market Share" }));
            grossMrktRow.append(jQuery("<div/>", { "text": (salesData.actualMarketShare).toFixed(2) + "%" }));
            grossMrktRow.append(jQuery("<div/>", { "class": "blank-sales-share-cell" }));
            grossMrktRow.append(jQuery("<div/>", { "class": "blank-sales-share-cell" }));
            grossMrktRow.append(jQuery("<div/>", { "class": "blank-sales-share-cell scen-b", "style": "display: none" }));
            grossMrktRow.append(jQuery("<div/>", { "class": "blank-sales-share-cell scen-b", "style": "display: none" }));
            var expSalesRow = that.createRow(BiWhatIfScenarios.Strings.EXPECTED_SALES_LABEL, "sales-share-row", "es", salesData.actualExpectedSales, formatter.format(salesData.expectedSales), formatter.format(salesData.changeExpectedSales));
            var expMrktSalesRow = that.createRow(BiWhatIfScenarios.Strings.EXP_SALES_MRKT_LABEL, "sales-share-row", "em", salesData.actualMarketShare, (salesData.expectedMarketShare).toFixed(2) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN, BiWhatIfScenarios.Strings.DEFAULT_EXPT_MRKT_PERCENT);
            var revenueRow = that.createRow(BiWhatIfScenarios.Strings.REVENUE_LABEL, "sales-share-row", "r", salesData.actualExpectedRevenue, formatter.format(salesData.expectedRevenue), formatter.format(0));
            salesShareTable.append(salesShareHeader, grossSalesRow, grossMrktRow, expSalesRow, expMrktSalesRow, revenueRow);
            var salesLoader = jQuery('<img/>', { 'src': '/assets/img/wheel.gif', 'class': 'waiting-icon waiting-icon-a regular-loader' });
            var salesLoaderB = jQuery('<img/>', { 'src': '/assets/img/wheel.gif', 'class': 'waiting-icon waiting-icon-b regular-loader' });
            if (tableDiv.children().length > 0) {
                tableDiv.empty();
            }
            tableDiv.append(keyDriverTable, factorLoader, factorLoaderB, salesShareTable, salesLoader, salesLoaderB);
        };
        ExpectedSales.prototype.displayGreenSpaceTable = function (factors, factortype, redSpaceData, greenSpaceData, that, tableDiv) {
            var formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
            //Green Space
            var greenSpaceTable = jQuery("<div/>", { "class": "green-space-div-table", "id": "greenSpaceTable" });
            var greenSpaceHeader = jQuery("<div/>", { "class": "green-space-div-table-header what-if-row what-if-header" });
            var greenSpaceTitle = jQuery("<div/>", { "class": "factor-header-label" });
            greenSpaceTitle.append(jQuery("<div/>", { "text": BiWhatIfScenarios.Strings.GREEN_SPACE_TABLE_LABEL }), this.createTableIcon(3));
            greenSpaceTitle.append(jQuery("<span/>", { 'class': 'table-header-message', 'text': BiWhatIfScenarios.Strings.GREEN_TABLE_HEADER_MSG }));
            greenSpaceHeader.append(greenSpaceTitle);
            greenSpaceHeader.append(jQuery("<div/>"), jQuery("<div/>"), jQuery("<div/>", { "class": "gs-border-div expected-sales-border-right" }), jQuery("<div/>", { "class": "scen-b", "style": "display: none" }), jQuery("<div/>", { "class": "scen-b gs-border-div", "style": "display: none" })); //filler cells
            var salesGSrow = that.createRow(BiWhatIfScenarios.Strings.GREEN_SPACE_LABEL, "green-space-row", "gs", greenSpaceData.salesGreenSpace, formatter.format(greenSpaceData.salesGreenSpace), formatter.format(0));
            var greenerDefaultValue = (greenSpaceData.greenerGreenSpace / greenSpaceData.salesGreenSpace) * 100;
            greenerDefaultValue = isFinite(greenerDefaultValue) ? greenerDefaultValue.toFixed(2) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN : BiWhatIfScenarios.Strings.DEFAULT_PERCENTAGE;
            var greenerRow = that.createRow(BiWhatIfScenarios.Strings.GREENER_LABEL, "green-space-row", "grnr", greenSpaceData.greenerGreenSpace, greenerDefaultValue, BiWhatIfScenarios.Strings.DEFAULT_PERCENTAGE);
            var aumGreenSpaceRow = that.createRow(BiWhatIfScenarios.Strings.AUM_GREEN_SPACE_LABEL, "green-space-row", "ags", greenSpaceData.aumGreenSpace, formatter.format(greenSpaceData.aumGreenSpace), formatter.format(0));
            var aumGreenerDefaultValue = (greenSpaceData.greenerAumSpace / greenSpaceData.aumGreenSpace) * 100;
            aumGreenerDefaultValue = isFinite(aumGreenerDefaultValue) ? aumGreenerDefaultValue.toFixed(2) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN : BiWhatIfScenarios.Strings.DEFAULT_PERCENTAGE;
            var aumGreenerRow = that.createRow(BiWhatIfScenarios.Strings.GREENER_AUM_LABEL, "green-space-row", "agrnr", greenSpaceData.greenerAumSpace, aumGreenerDefaultValue, BiWhatIfScenarios.Strings.DEFAULT_PERCENTAGE);
            var redSpaceRow = that.createRow(BiWhatIfScenarios.Strings.RED_SPACE_LABEL, "green-space-row", "rs", redSpaceData.actualRedSpace, formatter.format(redSpaceData.redSpace), formatter.format(0));
            greenSpaceTable.append(greenSpaceHeader, salesGSrow, greenerRow, aumGreenSpaceRow, aumGreenerRow, redSpaceRow);
            var greenLoader = jQuery('<img/>', { 'src': '/assets/img/wheel.gif', 'class': 'waiting-icon waiting-icon-a regular-loader' });
            var greenLoaderB = jQuery('<img/>', { 'src': '/assets/img/wheel.gif', 'class': 'waiting-icon waiting-icon-b regular-loader' });
            tableDiv.append(greenSpaceTable, greenLoader, greenLoaderB);
        };
        ExpectedSales.prototype.displayTables = function (factors, factortype, salesData, redSpaceData, greenSpaceData, that) {
            var tableTitle = jQuery("<div/>", { "class": "expected-sales-table-title", "text": BiWhatIfScenarios.Strings.EXPECTED_SALES_MODEL_TITLE });
            var tableDiv = jQuery("<div/>", { "class": "master-table-div" });
            that.actualSalesData = salesData;
            that.salesDataScenA = salesData;
            that.salesDataScenB = salesData;
            that.displaySalesTable(factors, factortype, salesData, that, tableDiv);
            that.wrapper.append(tableTitle, tableDiv);
            that.actualGreenSpaceData = greenSpaceData;
            that.greenSpaceScenA = greenSpaceData;
            that.greenSpaceScenB = greenSpaceData;
            that.actualRedSpaceData = redSpaceData;
            that.redSpaceScenA = redSpaceData;
            that.redSpaceScenB = redSpaceData;
            that.displayGreenSpaceTable(factors, factortype, redSpaceData, greenSpaceData, that, tableDiv);
            $(".wait-factors").hide();
        };
        ExpectedSales.prototype.createTableIcon = function (table) {
            var iconWrapper = jQuery('<div>', { 'class': 'share-class-info-wrapper' });
            var infoIcon = jQuery('<span>', { 'class': 'glyphicon glyphicon-info-sign share-class-info-icon table-info-icon' });
            switch (table) {
                case (1):
                    //key driver info bubble
                    var infoMsg = jQuery('<div>', { 'class': 'share-class-info-msg key-driver-table-msg' });
                    infoMsg.append(jQuery('<p/>', { 'class': 'info-msg-subheader', 'text': BiWhatIfScenarios.Strings.KEY_DRIVER_INFO_LABEL1 }));
                    infoMsg.append(jQuery('<p/>', { 'class': 'info-msg-text', 'text': BiWhatIfScenarios.Strings.KEY_DRIVER_INFO1 }));
                    infoMsg.append(jQuery('<p/>', { 'class': 'info-msg-subheader', 'text': BiWhatIfScenarios.Strings.KEY_DRIVER_INFO_LABEL2 }));
                    infoMsg.append(jQuery('<p/>', { 'class': 'info-msg-text', 'text': BiWhatIfScenarios.Strings.KEY_DRIVER_INFO2 }));
                    iconWrapper.append(infoIcon, infoMsg);
                    break;
                case (2):
                    //sales info bubble
                    var infoMsg = jQuery('<div>', { 'class': 'share-class-info-msg sales-table-msg' });
                    infoMsg.append(jQuery('<p/>', { 'class': 'info-msg-subheader', 'text': BiWhatIfScenarios.Strings.SALES_SHARE_TABLE_LABEL }));
                    var grossSales = jQuery('<div/>', { 'class': 'info-msg-div' });
                    grossSales.append(jQuery('<p/>', { 'class': 'info-msg-subheader', 'text': BiWhatIfScenarios.Strings.GROSS_SALES_INFO_LABEL }));
                    grossSales.append(jQuery('<p/>', { 'class': 'info-msg-text', 'text': BiWhatIfScenarios.Strings.GROSS_SALES_INFO_MSG }));
                    infoMsg.append(grossSales);
                    var grossSalesMrktShare = jQuery('<div/>', { 'class': 'info-msg-div' });
                    grossSalesMrktShare.append(jQuery('<p/>', { 'class': 'info-msg-subheader', 'text': BiWhatIfScenarios.Strings.GROSS_SALES_MRKT_INFO_LABEL }));
                    grossSalesMrktShare.append(jQuery('<p/>', { 'class': 'info-msg-text', 'text': BiWhatIfScenarios.Strings.GROSS_SALES_MRKT_MSG }));
                    infoMsg.append(grossSalesMrktShare);
                    var expSales = jQuery('<div/>', { 'class': 'info-msg-div' });
                    expSales.append(jQuery('<p/>', { 'class': 'info-msg-subheader', 'text': BiWhatIfScenarios.Strings.EXPECTED_SALES_INFO_LABEL }));
                    expSales.append(jQuery('<p/>', { 'class': 'info-msg-text', 'text': BiWhatIfScenarios.Strings.EXPECTED_SALES_MSG }));
                    infoMsg.append(expSales);
                    var expMrktSales = jQuery('<div/>', { 'class': 'info-msg-div' });
                    expMrktSales.append(jQuery('<p/>', { 'class': 'info-msg-subheader', 'text': BiWhatIfScenarios.Strings.EXPECTED_SALES_MRKT_INFO_LABEL }));
                    expMrktSales.append(jQuery('<p/>', { 'class': 'info-msg-text', 'text': BiWhatIfScenarios.Strings.EXPECTED_SALES_MRKT_MSG }));
                    infoMsg.append(expMrktSales);
                    var revenue = jQuery('<div/>', { 'class': 'info-msg-div' });
                    revenue.append(jQuery('<p/>', { 'class': 'info-msg-subheader', 'text': BiWhatIfScenarios.Strings.REVENUE_INFO_LABEL }));
                    revenue.append(jQuery('<p/>', { 'class': 'info-msg-text', 'text': BiWhatIfScenarios.Strings.REVENUE_MSG }));
                    var revEquation = jQuery('<div/>', { 'class': 'equation-div' });
                    revEquation.append(jQuery('<div/>', { 'text': 'Gross Sales - ', 'class': 'left-equation' }));
                    var parenthesis = jQuery('<div/>', { 'class': 'sales-equation' });
                    parenthesis.append(jQuery('<div/>', { 'text': '(1 - Redemption Rate) x bps', 'class': 'top-dividend' }));
                    parenthesis.append(jQuery('<div/>', { 'text': '100', 'class': 'bottom-divisor' }));
                    revEquation.append(parenthesis);
                    infoMsg.append(revenue, revEquation);
                    iconWrapper.append(infoIcon, infoMsg);
                    break;
                case (3):
                    //green/red space info bubble
                    var infoMsg = jQuery('<div>', { 'class': 'share-class-info-msg green-table-msg' });
                    infoMsg.append(jQuery('<p/>', { 'class': 'info-msg-subheader', 'text': BiWhatIfScenarios.Strings.GREEN_SPACE_TABLE_LABEL }));
                    var greenSpace = jQuery('<div/>', { 'class': 'info-msg-div' });
                    greenSpace.append(jQuery('<p/>', { 'class': 'info-msg-subheader', 'text': BiWhatIfScenarios.Strings.NET_EXP_GREEN_SPACE_LABEL + ":" }));
                    greenSpace.append(jQuery('<p/>', { 'class': 'info-msg-text', 'text': BiWhatIfScenarios.Strings.GREEN_SPACE_MSG }));
                    infoMsg.append(greenSpace);
                    var greener = jQuery('<div/>', { 'class': 'info-msg-div' });
                    greener.append(jQuery('<p/>', { 'class': 'info-msg-subheader', 'text': BiWhatIfScenarios.Strings.GREENER_GREEN_SPACE_LABEL }));
                    greener.append(jQuery('<p/>', { 'class': 'info-msg-text', 'text': BiWhatIfScenarios.Strings.GREENER_GREEN_SPACE_MSG }));
                    infoMsg.append(greener);
                    var redSpace = jQuery('<div/>', { 'class': 'info-msg-div' });
                    redSpace.append(jQuery('<p/>', { 'class': 'info-msg-subheader', 'text': BiWhatIfScenarios.Strings.RED_SPACE_LABEL + ":" }));
                    redSpace.append(jQuery('<p/>', { 'class': 'info-msg-text', 'text': BiWhatIfScenarios.Strings.RED_SPACE_MSG }));
                    infoMsg.append(redSpace);
                    iconWrapper.append(infoIcon, infoMsg);
                    break;
                default:
                    return;
            }
            return iconWrapper;
        };
        ExpectedSales.prototype.setData = function (greenSpaceData, redSpaceData, salesData, factorType) {
            if (factorType === BiWhatIfScenarios.FactorTypeEnum.SCENARIOA) {
                this.salesDataScenA = salesData;
                this.greenSpaceScenA = greenSpaceData;
                this.redSpaceScenA = redSpaceData;
            }
            else {
                this.salesDataScenB = salesData;
                this.greenSpaceScenB = greenSpaceData;
                this.redSpaceScenB = redSpaceData;
            }
        };
        ExpectedSales.prototype.createRow = function (rowLabel, rowClass, baseRowPrefix, actualValue, scenarioValue, changeValue) {
            var row = jQuery("<div/>", { "class": rowClass + " what-if-row" });
            row.append(jQuery("<div/>", { "text": rowLabel }));
            row.append(jQuery("<div/>", { "text": scenarioValue }));
            row.append(jQuery("<div/>", { "class": "no-overlay scen-a " + baseRowPrefix + "a", "text": scenarioValue }));
            row.append(jQuery("<div/>", { "class": "no-overlay scen-a " + baseRowPrefix + "ac", "text": changeValue }));
            row.append(jQuery("<div/>", { "class": baseRowPrefix + "b scen-b", "text": scenarioValue, "style": "display: none" }));
            row.append(jQuery("<div/>", { "class": baseRowPrefix + "bc scen-b", "text": changeValue, "style": "display: none" }));
            row.data("actual", actualValue);
            return row;
        };
        ExpectedSales.prototype.updateSalesTable = function (factors, scenarioChar, salesData, that, wrapper) {
            var formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
            //update key driver table
            var keyDriverTable = wrapper.find("#keyDriverTable");
            factors.forEach(function (factor) {
                keyDriverTable.find(".kd" + scenarioChar + "-" + factor.title.replace(/\s|(\(|\))/g, "")).text(factor.currentValue);
                if (factor.title === BiWhatIfScenarios.FactorTitleEnum.RATING) {
                    keyDriverTable.find(".kd" + scenarioChar + "c-" + factor.title.replace(/\s|(\(|\))/g, "")).text(parseFloat(factor.difference).toFixed(0));
                }
                else {
                    keyDriverTable.find(".kd" + scenarioChar + "c-" + factor.title.replace(/\s|(\(|\))/g, "")).text(parseFloat(factor.difference));
                    keyDriverTable.find(".kd" + scenarioChar + "p-" + factor.title.replace(/\s|(\(|\))/g, "")).text(ExpectedSales.getFactorPercentile(factor.title, salesData, BiWhatIfScenarios.SalesDatumType.EXPECTED) + "%");
                    keyDriverTable.find(".kd" + scenarioChar + "pc-" + factor.title.replace(/\s|(\(|\))/g, "")).text(ExpectedSales.getFactorPercentile(factor.title, salesData, BiWhatIfScenarios.SalesDatumType.CHANGE) + "%");
                }
            });
            //update sales share table
            var salesShareTable = wrapper.find("#salesShareTable");
            that.updateRow(salesShareTable, "es", scenarioChar, formatter.format(salesData.expectedSales), formatter.format(salesData.changeExpectedSales));
            that.updateRow(salesShareTable, "em", scenarioChar, salesData.expectedMarketShare.toFixed(2) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN, salesData.changeMarketShare.toFixed(2) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN);
            that.updateRow(salesShareTable, "r", scenarioChar, formatter.format(salesData.expectedRevenue), formatter.format(salesData.changeRevenue));
        };
        ExpectedSales.prototype.updateGreenSpaceTable = function (factors, scenarioChar, greenSpaceData, redSpaceData, that, wrapper) {
            var formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
            //update green space table
            var greenSpaceTable = wrapper.find("#greenSpaceTable");
            var salesGsActual = parseFloat(greenSpaceTable.find(".gs" + scenarioChar).parent().data("actual"));
            that.updateRow(greenSpaceTable, "gs", scenarioChar, formatter.format(greenSpaceData.newGreenSpace), formatter.format(that.findDifference(greenSpaceData.salesGreenSpace, greenSpaceData.newGreenSpace)));
            var greenerActual = parseFloat(greenSpaceTable.find(".grnr" + scenarioChar).parent().data("actual"));
            var actualGreenSpaceResult = salesGsActual === 0 ? 0 : (greenerActual / salesGsActual) * 100;
            var currGreenSpaceResult = (greenSpaceData.greenerGreenSpace / greenSpaceData.newGreenSpace) * 100;
            currGreenSpaceResult = isFinite(currGreenSpaceResult) ? currGreenSpaceResult : 0;
            currGreenSpaceResult = currGreenSpaceResult ? currGreenSpaceResult : 0;
            that.updateRow(greenSpaceTable, "grnr", scenarioChar, (currGreenSpaceResult).toFixed(2) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN, that.findDifference(actualGreenSpaceResult, currGreenSpaceResult).toFixed(2) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN);
            var aumGsActual = parseFloat(greenSpaceTable.find(".ags" + scenarioChar).parent().data("actual"));
            that.updateRow(greenSpaceTable, "ags", scenarioChar, formatter.format(greenSpaceData.newAumGreenSpace), formatter.format(that.findDifference(greenSpaceData.aumGreenSpace, greenSpaceData.newAumGreenSpace)));
            var greenerAumActual = parseFloat(greenSpaceTable.find(".agrnr" + scenarioChar).parent().data("actual"));
            var actualAumResult = aumGsActual === 0 ? 0 : (greenerAumActual / aumGsActual) * 100;
            var currAumResult = (greenSpaceData.greenerAumSpace / greenSpaceData.newAumGreenSpace) * 100;
            currAumResult = isFinite(currAumResult) ? currAumResult : 0;
            currAumResult = currAumResult ? currAumResult : 0;
            that.updateRow(greenSpaceTable, "agrnr", scenarioChar, (currAumResult).toFixed(2) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN, that.findDifference(actualAumResult, currAumResult).toFixed(2) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN);
            that.updateRow(greenSpaceTable, "rs", scenarioChar, formatter.format(redSpaceData.redSpace), formatter.format(redSpaceData.changeRedSpace));
        };
        ExpectedSales.prototype.updateTables = function (factors, factortype, salesData, redSpaceData, greenSpaceData, that) {
            var wrapper = $(document.getElementById("expected-model-info")).find(".master-table-div");
            var scenarioChar = factortype === BiWhatIfScenarios.FactorTypeEnum.SCENARIOA ? BiWhatIfScenarios.Strings.FACTOR_TYPE_SUFFIX_A : BiWhatIfScenarios.Strings.FACTOR_TYPE_SUFFIX_B;
            that.updateSalesTable(factors, scenarioChar, salesData, that, wrapper);
            that.updateGreenSpaceTable(factors, scenarioChar, greenSpaceData, redSpaceData, that, wrapper);
            that.toggleKeyDriverDisable(factortype, false);
            that.toggleWaitingOverlays(factortype, false);
        };
        ExpectedSales.prototype.updateRow = function (table, baseRowPrefix, scenarioChar, updateText, updateChangeText) {
            table.find("." + baseRowPrefix + scenarioChar).text(updateText);
            table.find("." + baseRowPrefix + scenarioChar + "c").text(updateChangeText);
        };
        //will retrieve either the current slider values, or the actual values of the sliders
        ExpectedSales.prototype.getSliderValues = function (factorEnum, actual) {
            var _this = this;
            var factors = [];
            var scenarios = this.wrapper.find(".what-if-scenario-div");
            var scenarioBox = factorEnum === BiWhatIfScenarios.FactorTypeEnum.SCENARIOA ? $(scenarios.get(0)) : $(scenarios.get(1));
            var sliderBoxes = scenarioBox.find(".factor-box");
            sliderBoxes.toArray().forEach(function (box) {
                var initial = parseFloat($(box).find("#first-factor").text().replace("%", ""));
                var max = parseFloat($(box).find(".factor-slider").attr("max"));
                var newFactor = {
                    title: $(box).find(".factor-box-title .factor-title-div").text(),
                    difference: actual ? "0.00" : _this.findDifference(initial, $(box).find(".factor-slider").val()).toFixed(2),
                    currentValue: actual ? initial : $(box).find(".factor-slider").val(),
                    percentile: actual ? (initial / (max === 0 ? null : max)) : ($(box).find(".factor-slider").val() / (max === 0 ? null : max)),
                    isWholeNumber: $(box).data("isWholeNumber"),
                    actualValue: initial,
                    maximum: max
                };
                if ($(box).find(".factor-slide-bar-bottom-range-value > div:nth-child(1)").text() ===
                    $(box).find(".factor-slide-bar-bottom-range-value > div:nth-child(2)").text()) {
                    newFactor['currentValue'] = initial;
                    newFactor['difference'] = '0.00';
                }
                factors.push(newFactor);
            });
            return factors;
        };
        ExpectedSales.prototype.getFactorDetails = function () {
            var factorDetails = [];
            factorDetails.push(this.getSliderValues(BiWhatIfScenarios.FactorTypeEnum.SCENARIOA, false));
            if (this.wrapper.find('.scenario-b-margin-bottom').is(':visible')) {
                factorDetails.push(this.getSliderValues(BiWhatIfScenarios.FactorTypeEnum.SCENARIOB, false));
            }
            return factorDetails;
        };
        //returns factor info for expected sales data call
        ExpectedSales.prototype.getScenarioInfo = function (factorEnum) {
            var _this = this;
            var scenarios = this.wrapper.find(".what-if-scenario-div");
            var scenarioInfo = {
                product: "",
                category: "",
                firms: [],
                factorDiffMap: {}
            };
            scenarioInfo.product = this.values.product;
            scenarioInfo.category = this.values.category;
            scenarioInfo.firms = this.values.firms;
            switch (factorEnum) {
                case (BiWhatIfScenarios.FactorTypeEnum.ACTUAL):
                    this.factors.forEach(function (factor) {
                        scenarioInfo.factorDiffMap[factor.title] = Number(factor.initial - factor.initial).toFixed(2); //difference should be zero on startup
                    });
                    break;
                case (BiWhatIfScenarios.FactorTypeEnum.SCENARIOA):
                    var scenarioBoxA = $(scenarios.get(0));
                    var sliderBoxes = scenarioBoxA.find(".factor-box");
                    sliderBoxes.toArray().forEach(function (box) {
                        var factorTitle = $(box).find(".factor-box-title .factor-title-div").text();
                        var initial = parseFloat($(box).find("#first-factor").text().replace("%", ""));
                        var currValue = $(box).find(".factor-slider").val();
                        if (factorTitle === BiWhatIfScenarios.FactorTitleEnum.NET_EXPENSE) {
                            scenarioInfo.factorDiffMap[factorTitle] = (_this.findDifference(initial, currValue) / 100).toFixed(2);
                        }
                        else {
                            //if range max and min are the same, use initial value as extrema are rounded and may produce a different difference
                            if ($(box).find(".factor-slide-bar-bottom-range-value > div:nth-child(1)").text() ===
                                $(box).find(".factor-slide-bar-bottom-range-value > div:nth-child(2)").text()) {
                                scenarioInfo.factorDiffMap[factorTitle] = _this.findDifference(initial, initial).toFixed(2);
                            }
                            else {
                                scenarioInfo.factorDiffMap[factorTitle] = _this.findDifference(initial, currValue).toFixed(2);
                            }
                        }
                    });
                    break;
                case (BiWhatIfScenarios.FactorTypeEnum.SCENARIOB):
                    var scenarioBoxB = $(scenarios.get(1));
                    var sliderBoxes = scenarioBoxB.find(".factor-box");
                    sliderBoxes.toArray().forEach(function (box) {
                        var factorTitle = $(box).find(".factor-box-title .factor-title-div").text();
                        var initial = parseFloat($(box).find("#first-factor").text().replace("%", ""));
                        var currValue = $(box).find(".factor-slider").val();
                        if (factorTitle === BiWhatIfScenarios.FactorTitleEnum.NET_EXPENSE) {
                            scenarioInfo.factorDiffMap[factorTitle] = (_this.findDifference(initial, currValue) / 100).toFixed(2);
                        }
                        else {
                            //if range max and min are the same, use initial value as extrema are rounded and may produce a different difference
                            if ($(box).find(".factor-slide-bar-bottom-range-value > div:nth-child(1)").text() ===
                                $(box).find(".factor-slide-bar-bottom-range-value > div:nth-child(2)").text()) {
                                scenarioInfo.factorDiffMap[factorTitle] = _this.findDifference(initial, initial).toFixed(2);
                            }
                            else {
                                scenarioInfo.factorDiffMap[factorTitle] = _this.findDifference(initial, currValue).toFixed(2);
                            }
                        }
                    });
                    break;
            }
            return scenarioInfo;
        };
        ExpectedSales.prototype.toggleWaitingOverlays = function (factorEnum, display) {
            var scenarioDivs;
            var className = "";
            if (factorEnum === BiWhatIfScenarios.FactorTypeEnum.SCENARIOA) {
                scenarioDivs = this.wrapper.find(".scen-a");
                className = "waiting-icon-a";
            }
            else {
                scenarioDivs = this.wrapper.find(".scen-b").not(".scenario-header-label, .blank-sales-share-cell");
                className = "waiting-icon-b";
            }
            if (display) {
                scenarioDivs.removeClass("no-overlay").addClass("wait-overlay");
                this.wrapper.find("." + className).show();
            }
            else {
                scenarioDivs.removeClass("wait-overlay").addClass("no-overlay");
                this.wrapper.find("." + className).hide();
            }
        };
        ExpectedSales.prototype.resetScenarioB = function () {
            var _this = this;
            var scenarios = this.wrapper.find(".what-if-scenario-div");
            var scenarioBoxB = $(scenarios.get(1));
            scenarioBoxB.find(".factor-box-adjuster").toArray().forEach(function (sliderBox) {
                var actual = $(sliderBox).find(".selected-factor").text();
                $(sliderBox).find(".factor-slider").val(actual);
                var max = $(sliderBox).find(".factor-slider").attr('max');
                var min = $(sliderBox).find(".factor-slider").attr('min');
                $(sliderBox).find(".factor-slider").css("background", "");
                $(sliderBox).find(".factor-slider").css("background", _this.getGradientCssString(+actual, +max, +min).toString());
                $(sliderBox).find(".factor-slide-bar-hover-text").val(actual);
                $(sliderBox).find(".factor-slide-bar-hover-text-value").text(actual);
                $(sliderBox).find(".factor-slide-bar-right-div > input").removeAttr('placeholder');
                $(sliderBox).find(".factor-slide-bar-right-div > input").val('');
            });
            this.setData(this.actualValues.greenSalesData, this.actualValues.redSalesData, this.actualValues.salesShareData, BiWhatIfScenarios.FactorTypeEnum.SCENARIOB);
            this.updateTables(this.getSliderValues(BiWhatIfScenarios.FactorTypeEnum.SCENARIOB, true), BiWhatIfScenarios.FactorTypeEnum.SCENARIOB, this.actualValues.salesShareData, this.actualValues.redSalesData, this.actualValues.greenSalesData, this);
        };
        //Moves the wait icon for scenario A. Used when scenario B is made visible
        ExpectedSales.prototype.toggleScenarioAWaitIcon = function (addToRightValue) {
            if (addToRightValue) {
                this.wrapper.find(".waiting-icon-a").addClass("no-scen-b");
            }
            else {
                this.wrapper.find(".waiting-icon-a").removeClass("no-scen-b");
            }
        };
        ExpectedSales.prototype.findDifference = function (value1, value2) {
            return value2 - value1;
        };
        ExpectedSales.prototype.getSalesData = function () {
            return this.actualValues.salesShareData;
        };
        ExpectedSales.prototype.getGreenSpaceData = function () {
            return this.actualValues.greenSalesData;
        };
        ExpectedSales.prototype.getRedSpaceData = function () {
            return this.actualValues.redSalesData;
        };
        ExpectedSales.prototype.getSalesDataByScenario = function (factorType) {
            if (factorType === BiWhatIfScenarios.FactorTypeEnum.SCENARIOA) {
                return this.salesDataScenA;
            }
            else {
                return this.salesDataScenB;
            }
        };
        ExpectedSales.prototype.getGreenSpaceDataByScenario = function (factorType) {
            if (factorType === BiWhatIfScenarios.FactorTypeEnum.SCENARIOA) {
                return this.greenSpaceScenA;
            }
            else {
                return this.greenSpaceScenB;
            }
        };
        ExpectedSales.prototype.getRedSpaceDataByScenario = function (factorType) {
            if (factorType === BiWhatIfScenarios.FactorTypeEnum.SCENARIOA) {
                return this.redSpaceScenA;
            }
            else {
                return this.redSpaceScenB;
            }
        };
        ExpectedSales.getFactorPercentile = function (factorTitle, salesData, type) {
            var propertyName = "";
            switch (factorTitle) {
                case (BiWhatIfScenarios.FactorTitleEnum.MANAGER_TENURE):
                    propertyName = BiWhatIfScenarios.FactorPercentilePrefixEnum.MANAGER_PERCENTILE;
                    break;
                case (BiWhatIfScenarios.FactorTitleEnum.YR1_RETURN):
                    propertyName = BiWhatIfScenarios.FactorPercentilePrefixEnum.YR1_RETURN_PERCENTILE;
                    break;
                case (BiWhatIfScenarios.FactorTitleEnum.YR3_RETURN):
                    propertyName = BiWhatIfScenarios.FactorPercentilePrefixEnum.YR3_RETURN_PERCENTILE;
                    break;
                case (BiWhatIfScenarios.FactorTitleEnum.YIELD_12MO):
                    propertyName = BiWhatIfScenarios.FactorPercentilePrefixEnum.YIELD_12_PERCENTILE;
                    break;
                case (BiWhatIfScenarios.FactorTitleEnum.SHARPE_1YR):
                    propertyName = BiWhatIfScenarios.FactorPercentilePrefixEnum.SHARPE_1YR_PERCENTILE;
                    break;
                case (BiWhatIfScenarios.FactorTitleEnum.SHARPE_3YR):
                    propertyName = BiWhatIfScenarios.FactorPercentilePrefixEnum.SHARPE_3YR_PERCENTILE;
                    break;
                case (BiWhatIfScenarios.FactorTitleEnum.NET_EXPENSE):
                    propertyName = BiWhatIfScenarios.FactorPercentilePrefixEnum.NET_EXPENSE_PRECENTILE;
                    break;
            }
            switch (type) {
                case (BiWhatIfScenarios.SalesDatumType.ACTUAL):
                    propertyName = "actual" + propertyName;
                    break;
                case (BiWhatIfScenarios.SalesDatumType.EXPECTED):
                    propertyName = "expected" + propertyName;
                    break;
                case (BiWhatIfScenarios.SalesDatumType.CHANGE):
                    propertyName = "change" + propertyName;
                    break;
            }
            propertyName = propertyName + "Percent";
            return salesData[propertyName];
        };
        ExpectedSales.prototype.toggleIsFromSavedScenario = function () {
            this.isFromSavedScenario = !this.isFromSavedScenario;
        };
        ExpectedSales.prototype.setUpdateable = function () {
            this.isUpdateable = true;
        };
        return ExpectedSales;
    }());
    BiWhatIfScenarios.ExpectedSales = ExpectedSales;
})(BiWhatIfScenarios || (BiWhatIfScenarios = {}));
///<reference path="00.data_type.ts" />
///<reference path="03.service.ts" />
///<reference path="01.strings.ts" />
var BiWhatIfScenarios;
(function (BiWhatIfScenarios) {
    var NetExpense = (function () {
        function NetExpense(wrapper, service, values, shareClass, factors) {
            this.wrapper = wrapper;
            this.service = service;
            this.values = values;
            this.shareClass = shareClass.toUpperCase();
            this.factors = factors.filter(function (factor) { return !factor.isEmpty(); });
            this.wrapper.empty();
            this.buildHeader();
            this.getNetExpRatioData();
        }
        NetExpense.prototype.buildHeader = function () {
            var netExpenseHeader = $('<div />', { 'class': 'net-expense-header', 'text': BiWhatIfScenarios.Strings.NET_EXPENSE_HEADER });
            var shareClass = $('<div />', { 'class': 'net-expense-share-class' });
            var shareClassText = $('<div />', { 'html': BiWhatIfScenarios.Strings.SHARE_CLASS_TITLE + ' ' + this.shareClass + '&nbsp;' });
            var shareClasInfoWrapper = jQuery('<div>');
            var shareClassInfoIcon = jQuery('<span>', { 'class': 'glyphicon glyphicon-info-sign share-class-info-icon' });
            var shareClassInfoMsg = jQuery('<div>', { 'class': 'net-exp-share-class-info-msg', 'text': BiWhatIfScenarios.Strings.NET_EXP_SHARE_CLASS_INFO_MSG });
            shareClasInfoWrapper.append(shareClassInfoIcon, shareClassInfoMsg);
            shareClass.append(shareClassText, shareClasInfoWrapper);
            this.wrapper.append(netExpenseHeader, shareClass);
        };
        NetExpense.prototype.getNetExpRatioData = function () {
            var _this = this;
            var product = this.values.product;
            var category = this.values.category;
            var firms = this.values.firms;
            $.when(this.service.getNetExpenseRatioDrop(product, category, firms), this.service.getOptimalNetExpenseRatioDrop(product, category, firms)).done(function (netExpRatioDropData, optimalNetExpData) {
                _this.service.getNetExpenseGreenSpaceDrop(product, _this.factors, optimalNetExpData.optimalBpsValue, firms).then(function (netExpGSDropData) {
                    _this.netExpBps = netExpRatioDropData.exp;
                    _this.netExpGSDrop = netExpGSDropData;
                    _this.netExpDrop = netExpRatioDropData;
                    _this.optimalNetExpDrop = optimalNetExpData;
                    _this.buildNetExpTable(netExpGSDropData, netExpRatioDropData, optimalNetExpData);
                    $(".wait-factors").hide();
                    _this.wrapper.removeClass('hidden');
                });
            }).fail(function (error) {
                console.log(error);
            });
        };
        NetExpense.prototype.buildNetExpTable = function (netExpGSDropData, netExpRatioDropData, optimalNetExpData) {
            var formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
            var netExpense = $('<div />', { 'class': 'net-exp-table' });
            var netExpTableWrapper = $('<div />', { 'class': 'net-exp-table-wrapper' });
            var netExpBps = netExpRatioDropData.exp;
            // Table header
            var netExpTableHeader = $('<div />', { 'class': 'net-exp-table-header' });
            var netExpFactorHeader = $('<div />', { 'class': 'net-exp-factor', 'html': '&nbsp;' });
            var currentBpsheader = $('<div />', { 'class': 'current-bps-header' });
            var currentLabel = $('<div />', { 'class': 'current-bps-label', 'text': 'CURRENT' });
            var netExpBpsHeader = $('<div />', { 'class': 'net-exp-bps', 'text': netExpBps + ' bps' });
            currentBpsheader.append(currentLabel, netExpBpsHeader);
            var netExp5BpsHeader = $('<div />', { 'class': 'net-exp-bps', 'text': (netExpBps - 5) + ' bps' });
            var netExp10BpsHeader = $('<div />', { 'class': 'net-exp-bps', 'text': (netExpBps - 10) + ' bps' });
            var netExp15BpsHeader = $('<div />', { 'class': 'net-exp-bps', 'text': (netExpBps - 15) + ' bps' });
            var netExp20BpsHeader = $('<div />', { 'class': 'net-exp-bps', 'text': (netExpBps - 20) + ' bps' });
            var netExp25BpsHeader = $('<div />', { 'class': 'net-exp-bps', 'text': (netExpBps - 25) + ' bps' });
            netExpTableHeader.append(netExpFactorHeader, currentBpsheader, netExp5BpsHeader, netExp10BpsHeader, netExp15BpsHeader, netExp20BpsHeader, netExp25BpsHeader);
            netExpTableWrapper.append(netExpTableHeader);
            // Revenue table row
            var netExpRevenueRow = $('<div />', { 'class': 'net-exp-table-row' });
            var netExpRevenueFactor = $('<div />', { 'class': 'net-exp-factor', 'text': BiWhatIfScenarios.Strings.REVENUE_LABEL });
            var netExpRevenueBps = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(netExpRatioDropData.revenue) });
            var netExpRevenue5Bps = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(netExpRatioDropData.revenue5) });
            var netExpRevenue10Bps = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(netExpRatioDropData.revenue10) });
            var netExpRevenue15Bps = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(netExpRatioDropData.revenue15) });
            var netExpRevenue20Bps = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(netExpRatioDropData.revenue20) });
            var netExpRevenue25Bps = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(netExpRatioDropData.revenue25) });
            netExpRevenueRow.append(netExpRevenueFactor, netExpRevenueBps, netExpRevenue5Bps, netExpRevenue10Bps, netExpRevenue15Bps, netExpRevenue20Bps, netExpRevenue25Bps);
            // AssetRevenue table row
            var netExpAssetRevenueRow = $('<div />', { 'class': 'net-exp-table-row' });
            var netExpAssetRevenueFactor = $('<div />', { 'class': 'net-exp-factor', 'text': BiWhatIfScenarios.Strings.ASSET_REVENUE_LABEL });
            var netExpAssetRevenueBps = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(netExpRatioDropData.assetRevenue) });
            var netExpAssetRevenue5Bps = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(netExpRatioDropData.assetRevenue5) });
            var netExpAssetRevenue10Bps = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(netExpRatioDropData.assetRevenue10) });
            var netExpAssetRevenue15Bps = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(netExpRatioDropData.assetRevenue15) });
            var netExpAssetRevenue20Bps = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(netExpRatioDropData.assetRevenue20) });
            var netExpAssetRevenue25Bps = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(netExpRatioDropData.assetRevenue25) });
            netExpAssetRevenueRow.append(netExpAssetRevenueFactor, netExpAssetRevenueBps, netExpAssetRevenue5Bps, netExpAssetRevenue10Bps, netExpAssetRevenue15Bps, netExpAssetRevenue20Bps, netExpAssetRevenue25Bps);
            // TotalRevenue table row
            var netExpTotalRevenueRow = $('<div />', { 'class': 'net-exp-table-row' });
            var netExpTotalRevenueFactor = $('<div />', { 'class': 'net-exp-factor', 'text': BiWhatIfScenarios.Strings.TOTAL_REVENUE_LABEL });
            var netExpTotalRevenueBps = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(netExpRatioDropData.totalRevenue) });
            var netExpTotalRevenue5Bps = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(netExpRatioDropData.totalRevenue5) });
            var netExpTotalRevenue10Bps = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(netExpRatioDropData.totalRevenue10) });
            var netExpTotalRevenue15Bps = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(netExpRatioDropData.totalRevenue15) });
            var netExpTotalRevenue20Bps = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(netExpRatioDropData.totalRevenue20) });
            var netExpTotalRevenue25Bps = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(netExpRatioDropData.totalRevenue25) });
            netExpTotalRevenueRow.append(netExpTotalRevenueFactor, netExpTotalRevenueBps, netExpTotalRevenue5Bps, netExpTotalRevenue10Bps, netExpTotalRevenue15Bps, netExpTotalRevenue20Bps, netExpTotalRevenue25Bps);
            // Gross Sales table row
            var netExpGrossSalesRow = $('<div />', { 'class': 'net-exp-table-row' });
            var netExpGrossSalesFactor = $('<div />', { 'class': 'net-exp-factor', 'text': BiWhatIfScenarios.Strings.GROSS_SALES_LABEL });
            var netExpGrossSalesBps = $('<div />', { 'class': 'net-exp-bps', 'html': formatter.format(netExpRatioDropData.grossSales) });
            var netExpGrossSales5Bps = $('<div />', { 'class': 'net-exp-bps', 'html': formatter.format(netExpRatioDropData.grossSales5) });
            var netExpGrossSales10Bps = $('<div />', { 'class': 'net-exp-bps', 'html': formatter.format(netExpRatioDropData.grossSales10) });
            var netExpGrossSales15Bps = $('<div />', { 'class': 'net-exp-bps', 'html': formatter.format(netExpRatioDropData.grossSales15) });
            var netExpGrossSales20Bps = $('<div />', { 'class': 'net-exp-bps', 'html': formatter.format(netExpRatioDropData.grossSales20) });
            var netExpGrossSales25Bps = $('<div />', { 'class': 'net-exp-bps', 'html': formatter.format(netExpRatioDropData.grossSales25) });
            netExpGrossSalesRow.append(netExpGrossSalesFactor, netExpGrossSalesBps, netExpGrossSales5Bps, netExpGrossSales10Bps, netExpGrossSales15Bps, netExpGrossSales20Bps, netExpGrossSales25Bps);
            // Market Share table row
            var netExpMktShareRow = $('<div />', { 'class': 'net-exp-table-row' });
            var netExpMktShareFactor = $('<div />', { 'class': 'net-exp-factor', 'text': BiWhatIfScenarios.Strings.MARKET_SHARE_LABEL });
            var netExpMktShareBps = $('<div />', { 'class': 'net-exp-bps', 'text': netExpRatioDropData.marketShare + '%' });
            var netExpMktShare5Bps = $('<div />', { 'class': 'net-exp-bps', 'text': netExpRatioDropData.marketShare5 + '%' });
            var netExpMktShare10Bps = $('<div />', { 'class': 'net-exp-bps', 'text': netExpRatioDropData.marketShare10 + '%' });
            var netExpMktShare15Bps = $('<div />', { 'class': 'net-exp-bps', 'text': netExpRatioDropData.marketShare15 + '%' });
            var netExpMktShare20Bps = $('<div />', { 'class': 'net-exp-bps', 'text': netExpRatioDropData.marketShare20 + '%' });
            var netExpMktShare25Bps = $('<div />', { 'class': 'net-exp-bps', 'text': netExpRatioDropData.marketShare25 + '%' });
            netExpMktShareRow.append(netExpMktShareFactor, netExpMktShareBps, netExpMktShare5Bps, netExpMktShare10Bps, netExpMktShare15Bps, netExpMktShare20Bps, netExpMktShare25Bps);
            // Market Share Rank table row
            var netExpMktShareRankRow = $('<div />', { 'class': 'net-exp-table-row' });
            var netExpMktShareRankFactor = $('<div />', { 'class': 'net-exp-factor', 'text': BiWhatIfScenarios.Strings.MARKET_SHARE_RANK_LABEL });
            var netExpMktShareRankBps = $('<div />', { 'class': 'net-exp-bps', 'text': netExpRatioDropData.marketShareRank });
            var netExpMktShareRank5Bps = $('<div />', { 'class': 'net-exp-bps', 'text': netExpRatioDropData.marketShareRank5 });
            var netExpMktShareRank10Bps = $('<div />', { 'class': 'net-exp-bps', 'text': netExpRatioDropData.marketShareRank10 });
            var netExpMktShareRank15Bps = $('<div />', { 'class': 'net-exp-bps', 'text': netExpRatioDropData.marketShareRank15 });
            var netExpMktShareRank20Bps = $('<div />', { 'class': 'net-exp-bps', 'text': netExpRatioDropData.marketShareRank20 });
            var netExpMktShareRank25Bps = $('<div />', { 'class': 'net-exp-bps', 'text': netExpRatioDropData.marketShareRank25 });
            netExpMktShareRankRow.append(netExpMktShareRankFactor, netExpMktShareRankBps, netExpMktShareRank5Bps, netExpMktShareRank10Bps, netExpMktShareRank15Bps, netExpMktShareRank20Bps, netExpMktShareRank25Bps);
            // Green Space table row
            var netExpGSRow = $('<div />', { 'class': 'net-exp-table-row' });
            var netExpGSFactor = $('<div />', { 'class': 'net-exp-factor', 'text': BiWhatIfScenarios.Strings.NET_EXP_GREEN_SPACE_LABEL });
            var netExpGSBps = $('<div />', { 'class': 'net-exp-bps', 'html': formatter.format(netExpGSDropData.greenSpaceBps) });
            var netExpGS5Bps = $('<div />', { 'class': 'net-exp-bps', 'html': formatter.format(netExpGSDropData.greenSpace5Bps) });
            var netExpGS10Bps = $('<div />', { 'class': 'net-exp-bps', 'html': formatter.format(netExpGSDropData.greenSpace10Bps) });
            var netExpGS15Bps = $('<div />', { 'class': 'net-exp-bps', 'html': formatter.format(netExpGSDropData.greenSpace15Bps) });
            var netExpGS20Bps = $('<div />', { 'class': 'net-exp-bps', 'html': formatter.format(netExpGSDropData.greenSpace20Bps) });
            var netExpGS25Bps = $('<div />', { 'class': 'net-exp-bps', 'html': formatter.format(netExpGSDropData.greenSpace25Bps) });
            netExpGSRow.append(netExpGSFactor, netExpGSBps, netExpGS5Bps, netExpGS10Bps, netExpGS15Bps, netExpGS20Bps, netExpGS25Bps);
            netExpTableWrapper.append(netExpRevenueRow, netExpAssetRevenueRow, netExpTotalRevenueRow, netExpGrossSalesRow, netExpMktShareRow, netExpMktShareRankRow, netExpGSRow);
            var isOptimalRequired = netExpBps > optimalNetExpData.optimalExpRatio;
            //Optimal values table
            var optimalTableWrapper = $('<div />', { 'class': 'optimal-table-wrapper' });
            var optimalBpsheader = $('<div />', { 'class': 'optimal-bps-header' });
            var optimalLabel = $('<div />', { 'class': 'optimal-bps-label', 'text': 'OPTIMAL' });
            var optimalBps = $('<div />', { 'class': 'net-exp-bps', 'text': optimalNetExpData.optimalExpRatio + ' bps' });
            if (isOptimalRequired) {
                optimalBpsheader.append(optimalLabel, optimalBps);
                var optimalRevenue = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(optimalNetExpData.optimalRevenue) });
                var optimalAssetRevenue = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(optimalNetExpData.optimalAssetRevenue) });
                var optimalTotalRevenue = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(optimalNetExpData.optimalTotalRevenue) });
                var optimalGrossSales = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(optimalNetExpData.optimalGrossSales) });
                var optimalMarketShare = $('<div />', { 'class': 'net-exp-bps', 'text': optimalNetExpData.optimalMarketShare + "%" });
                var optimalMarketShareRank = $('<div />', { 'class': 'net-exp-bps', 'text': optimalNetExpData.optimalMarketShareRank });
                var optimalGreenSpace = $('<div />', { 'class': 'net-exp-bps', 'text': formatter.format(netExpGSDropData.greenSpaceOptimal) });
                optimalTableWrapper.append(optimalBpsheader, optimalRevenue, optimalAssetRevenue, optimalTotalRevenue, optimalGrossSales, optimalMarketShare, optimalMarketShareRank, optimalGreenSpace);
            }
            else {
                optimalBpsheader.append(optimalLabel);
                var optimalInfoMsg = $('<div />', { 'class': 'optimal-info-msg', 'text': BiWhatIfScenarios.Strings.OPTIMAL_INFO_MSG });
                optimalTableWrapper.append(optimalBpsheader, optimalInfoMsg);
            }
            netExpTableHeader.find('.net-exp-bps').each(function () {
                var bps = $(this).text().split(' ');
                if (Number(bps[0]) === optimalNetExpData.optimalExpRatio) {
                    $(this).addClass('optimal-bps-text-header');
                }
            });
            netExpense.append(netExpTableWrapper, optimalTableWrapper);
            this.wrapper.append(netExpense);
            this.wrapper.append(jQuery('<div/>', { 'class': 'net-expense-bottom-msg', 'text': BiWhatIfScenarios.Strings.NET_EXP_BOTTOM_MSG }));
            this.buildNetExpRatioChart();
        };
        NetExpense.prototype.buildNetExpRatioChart = function () {
            var formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
            var chartWrapper = $('<div/>', { 'id': 'net-exp-ratio-chart' });
            this.wrapper.append(chartWrapper);
            var xAxisData = [this.netExpBps + ' bps',
                (this.netExpBps - 5) + ' bps',
                (this.netExpBps - 10) + ' bps',
                (this.netExpBps - 15) + ' bps',
                (this.netExpBps - 20) + ' bps',
                (this.netExpBps - 25) + ' bps'];
            var expectedSalesData = [this.netExpDrop.grossSales,
                this.netExpDrop.grossSales5,
                this.netExpDrop.grossSales10,
                this.netExpDrop.grossSales15,
                this.netExpDrop.grossSales20,
                this.netExpDrop.grossSales25];
            var revenueData = [this.netExpDrop.totalRevenue,
                this.netExpDrop.totalRevenue5,
                this.netExpDrop.totalRevenue10,
                this.netExpDrop.totalRevenue15,
                this.netExpDrop.totalRevenue20,
                this.netExpDrop.totalRevenue25];
            // Display optimal details only when the current exp ratio is greater than optimal exp ratio
            if (this.netExpBps > this.optimalNetExpDrop.optimalExpRatio) {
                xAxisData.push(this.optimalNetExpDrop.optimalExpRatio + ' bps <br />(Optimal)');
                expectedSalesData.push(this.optimalNetExpDrop.optimalGrossSales);
                revenueData.push(this.optimalNetExpDrop.optimalRevenue);
            }
            new Highcharts.Chart({
                chart: {
                    renderTo: chartWrapper.get(0),
                    type: 'column',
                    zoomType: 'xy',
                    style: {
                        fontFamily: '\'Open Sans\',sans-serif !important',
                        fontSize: '18px',
                        fontWeight: '600'
                    },
                    height: 500
                },
                tooltip: {
                    formatter: function () {
                        return this.x.replace('<br />', '') + '<br>' + this.series.name + ': ' + formatter.format(this.y);
                    }
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: ''
                },
                legend: {
                    layout: 'vertical',
                    itemStyle: {
                        cursor: 'default',
                        color: '#333 !important',
                        fontSize: '22px',
                        fontWeight: '600'
                    },
                    symbolRadius: 0,
                    symbolWidth: 20,
                    symbolHeight: 20
                },
                plotOptions: {
                    series: {
                        marker: {
                            enabled: false
                        },
                        events: {
                            legendItemClick: function () {
                                return false;
                            }
                        }
                    }
                },
                xAxis: [{
                        title: {
                            text: ''
                        },
                        categories: xAxisData,
                        labels: {
                            style: {
                                color: '#333 !important',
                                fontSize: '18px'
                            }
                        },
                        lineWidth: 2,
                        lineColor: '#B7B7B7'
                    }],
                yAxis: [
                    {
                        title: {
                            text: 'Estimated Total Revenue ($mm)',
                            style: {
                                color: '#333',
                                fontSize: '24px'
                            }
                        },
                        lineWidth: 2,
                        lineColor: '#B7B7B7',
                        gridLineWidth: 0,
                        labels: {
                            style: {
                                color: '#333 !important',
                                fontSize: '15px'
                            },
                            formatter: function () {
                                return new LabelBuilder.SalesLabelBuilder(true, false).build(this.value);
                            }
                        },
                        tickWidth: 2,
                        tickLength: 10,
                        tickColor: '#B7B7B7',
                        tickAmount: 6
                    },
                    {
                        title: {
                            text: 'Expected Sales ($mm)',
                            style: {
                                color: '#333',
                                fontSize: '24px'
                            }
                        },
                        lineWidth: 2,
                        lineColor: '#B7B7B7',
                        gridLineWidth: 0,
                        labels: {
                            style: {
                                color: '#333 !important',
                                fontSize: '15px'
                            },
                            formatter: function () {
                                return new LabelBuilder.SalesLabelBuilder(true, false).build(this.value);
                            }
                        },
                        tickWidth: 2,
                        tickLength: 10,
                        tickColor: '#B7B7B7',
                        tickAmount: 6,
                        opposite: true
                    }
                ],
                series: [{
                        xAxis: 0,
                        yAxis: 0,
                        color: '#00B1F1',
                        data: revenueData,
                        name: 'Estimated Total Revenue'
                    }, {
                        xAxis: 0,
                        yAxis: 1,
                        color: '#008D90',
                        data: expectedSalesData,
                        name: 'Expected Sales'
                    }]
            });
        };
        NetExpense.prototype.getCurrentExpBps = function () {
            return this.netExpBps;
        };
        NetExpense.prototype.getNetExpGSBps = function () {
            return this.netExpGSDrop;
        };
        NetExpense.prototype.getNetExpDropBps = function () {
            return this.netExpDrop;
        };
        NetExpense.prototype.getOptimalNetExpDropBps = function () {
            return this.optimalNetExpDrop;
        };
        return NetExpense;
    }());
    BiWhatIfScenarios.NetExpense = NetExpense;
})(BiWhatIfScenarios || (BiWhatIfScenarios = {}));
///<reference path="00.data_type.ts" />
///<reference path="06.expected_sales.ts" />
var BiWhatIfScenarios;
(function (BiWhatIfScenarios) {
    var FileCreator = (function () {
        function FileCreator() {
        }
        FileCreator.createExpectedSalesCsv = function (scenario) {
            var file = this.getExpSalesModelInfo(scenario);
            file += this.getValues(scenario);
            return file;
        };
        FileCreator.getExpSalesModelInfo = function (scenario) {
            var length = scenario.factorDetails.length;
            var modelInfo = this.columnLine + (length > 1 ? this.comma + "Scenario B,Scenario B Changes" + this.newLine : this.newLine);
            modelInfo += "Product," + scenario.product + this.comma + scenario.product + this.comma + scenario.product + this.getScenarioBIfExists(length, scenario.product, scenario.product)
                + "Category," + scenario.category + this.comma + scenario.category + this.comma + scenario.category + this.getScenarioBIfExists(length, scenario.category, scenario.category);
            modelInfo += this.getKeyDrivers(scenario);
            modelInfo += "Gross Sales Actual," + scenario.salesData.actualClientGrossSales + this.comma + "," + this.getScenarioBIfExists(length, ",");
            modelInfo += "Gross Market Share Actual," + scenario.salesData.actualMarketShare + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN + this.comma + "," + this.getScenarioBIfExists(length, ",");
            return modelInfo;
        };
        FileCreator.getKeyDrivers = function (scenario) {
            var _this = this;
            var keyDriverString = "";
            var length = scenario.factorDetails.length;
            scenario.factorDetails[0].forEach(function (slider, index) {
                keyDriverString += slider.title + _this.comma + slider.actualValue + _this.comma + scenario.factorDetails[0][index].currentValue + _this.comma + scenario.factorDetails[0][index].difference +
                    _this.getScenarioBIfExists(length, scenario.factorDetails[1] ? scenario.factorDetails[1][index].currentValue + _this.comma + scenario.factorDetails[1][index].difference : _this.comma);
                if (slider.title !== "Rating Overall") {
                    keyDriverString += slider.title + " Percentile," + BiWhatIfScenarios.ExpectedSales.getFactorPercentile(slider.title, scenario.salesData, BiWhatIfScenarios.SalesDatumType.ACTUAL)
                        + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN + _this.comma + BiWhatIfScenarios.ExpectedSales.getFactorPercentile(slider.title, scenario.salesDataA, BiWhatIfScenarios.SalesDatumType.EXPECTED) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN +
                        _this.comma + BiWhatIfScenarios.ExpectedSales.getFactorPercentile(slider.title, scenario.salesDataA, BiWhatIfScenarios.SalesDatumType.CHANGE) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN +
                        _this.getScenarioBIfExists(length, BiWhatIfScenarios.ExpectedSales.getFactorPercentile(slider.title, scenario.salesDataB, BiWhatIfScenarios.SalesDatumType.EXPECTED) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN + _this.comma +
                            BiWhatIfScenarios.ExpectedSales.getFactorPercentile(slider.title, scenario.salesDataB, BiWhatIfScenarios.SalesDatumType.CHANGE) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN);
                }
            });
            return keyDriverString;
        };
        FileCreator.getValues = function (scenario) {
            var length = scenario.factorDetails.length;
            var values = "Expected Sales," + scenario.salesData.actualExpectedSales + this.comma + scenario.salesDataA.expectedSales + this.comma + scenario.salesDataA.changeExpectedSales +
                this.getScenarioBIfExists(length, scenario.salesDataB.expectedSales + this.comma + scenario.salesDataB.changeExpectedSales);
            values += "Expected Sales Market Share," + scenario.salesData.actualExpectedMarketShare + this.comma + scenario.salesDataA.expectedMarketShare + this.comma + scenario.salesDataA.changeMarketShare +
                this.getScenarioBIfExists(length, scenario.salesDataB.expectedMarketShare + this.comma + scenario.salesDataB.changeMarketShare);
            values += "Revenue," + scenario.salesData.actualExpectedRevenue + this.comma + scenario.salesDataA.expectedRevenue + this.comma + scenario.salesDataA.changeRevenue +
                this.getScenarioBIfExists(length, scenario.salesDataB.expectedRevenue + this.comma + scenario.salesDataB.changeRevenue);
            values += "Sales Green Space," + scenario.greenSpaceData.salesGreenSpace + this.comma + scenario.greenSpaceDataA.newGreenSpace + this.comma +
                this.findDifference(scenario.greenSpaceDataA.newGreenSpace, scenario.greenSpaceDataA.salesGreenSpace) +
                this.getScenarioBIfExists(length, scenario.greenSpaceDataB.newGreenSpace + this.comma +
                    this.findDifference(scenario.greenSpaceDataB.newGreenSpace, scenario.greenSpaceDataB.salesGreenSpace));
            values += "Sales Greener Green Space %," + this.getGreenerSpace(scenario.greenSpaceData.greenerGreenSpace, scenario.greenSpaceData.newGreenSpace) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN +
                this.comma + this.getGreenerSpace(scenario.greenSpaceDataA.greenerGreenSpace, scenario.greenSpaceDataA.newGreenSpace) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN +
                this.comma + this.findDifference(this.getGreenerSpace(scenario.greenSpaceDataA.greenerGreenSpace, scenario.greenSpaceDataA.newGreenSpace), this.getGreenerSpace(scenario.greenSpaceData.greenerGreenSpace, scenario.greenSpaceData.salesGreenSpace)) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN +
                this.getScenarioBIfExists(length, this.getGreenerSpace(scenario.greenSpaceDataB.greenerGreenSpace, scenario.greenSpaceDataB.newGreenSpace) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN, this.findDifference(this.getGreenerSpace(scenario.greenSpaceDataB.greenerGreenSpace, scenario.greenSpaceDataB.newGreenSpace), this.getGreenerSpace(scenario.greenSpaceData.greenerGreenSpace, scenario.greenSpaceData.salesGreenSpace)) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN);
            values += "AUM Green Space," + scenario.greenSpaceData.aumGreenSpace + this.comma + scenario.greenSpaceDataA.newAumGreenSpace + this.comma +
                this.findDifference(scenario.greenSpaceDataA.newAumGreenSpace, scenario.greenSpaceDataA.aumGreenSpace) +
                this.getScenarioBIfExists(length, scenario.greenSpaceDataB.newAumGreenSpace, this.findDifference(scenario.greenSpaceDataB.newAumGreenSpace, scenario.greenSpaceDataB.aumGreenSpace));
            values += "AUM Greener Green Space %," + this.getGreenerSpace(scenario.greenSpaceData.greenerAumSpace, scenario.greenSpaceData.newAumGreenSpace) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN +
                this.comma + this.getGreenerSpace(scenario.greenSpaceDataA.greenerAumSpace, scenario.greenSpaceDataA.newAumGreenSpace) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN + this.comma +
                this.findDifference(this.getGreenerSpace(scenario.greenSpaceDataA.greenerAumSpace, scenario.greenSpaceDataA.newAumGreenSpace), this.getGreenerSpace(scenario.greenSpaceData.greenerAumSpace, scenario.greenSpaceData.aumGreenSpace)).toFixed(2) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN +
                this.getScenarioBIfExists(length, this.getGreenerSpace(scenario.greenSpaceDataB.greenerAumSpace, scenario.greenSpaceDataB.newAumGreenSpace) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN, this.findDifference(this.getGreenerSpace(scenario.greenSpaceDataB.greenerAumSpace, scenario.greenSpaceDataB.newAumGreenSpace), this.getGreenerSpace(scenario.greenSpaceData.greenerAumSpace, scenario.greenSpaceData.aumGreenSpace)).toFixed(2) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN);
            values += "Red Space," + scenario.redSpaceData.redSpace + this.comma + scenario.redSpaceDataA.redSpace + this.comma + scenario.redSpaceDataA.changeRedSpace +
                this.getScenarioBIfExists(length, scenario.redSpaceDataB.redSpace + this.comma + scenario.redSpaceDataB.changeRedSpace);
            return values;
        };
        FileCreator.getScenarioBIfExists = function (factorDeatilsLength, scenarioBValue, scenarioChange) {
            if (scenarioChange === void 0) { scenarioChange = ""; }
            return (factorDeatilsLength > 1 ? this.comma + scenarioBValue + this.comma + scenarioChange + this.newLine : this.newLine);
        };
        FileCreator.getChangedKeyDrivers = function (scenario) {
            var _this = this;
            var changedKeyDriver = "";
            var length = scenario.factorDetails.length;
            scenario.factorDetails[0].forEach(function (slider, index) {
                changedKeyDriver += slider.title + " Change" + _this.comma + _this.findDifference(slider.actualValue, slider.actualValue) + _this.comma + scenario.factorDetails[0][index].difference +
                    _this.getScenarioBIfExists(length, scenario.factorDetails[1] ? scenario.factorDetails[1][index].difference : null);
                if (slider.title !== "Rating Overall") {
                    changedKeyDriver += slider.title + " Percentile Change," + "0" + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN + _this.comma +
                        BiWhatIfScenarios.ExpectedSales.getFactorPercentile(slider.title, scenario.salesDataA, BiWhatIfScenarios.SalesDatumType.CHANGE) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN +
                        _this.getScenarioBIfExists(length, BiWhatIfScenarios.ExpectedSales.getFactorPercentile(slider.title, scenario.salesDataB, BiWhatIfScenarios.SalesDatumType.CHANGE) + BiWhatIfScenarios.Strings.PERCENTAGE_SIGN);
                }
            });
            return changedKeyDriver;
        };
        FileCreator.getGreenerSpace = function (greenerSpace, greenSpace) {
            var greenerValue = (greenerSpace / greenSpace) * 100;
            greenerValue = isFinite(greenerValue) ? greenerValue.toFixed(2) : BiWhatIfScenarios.Strings.ZERO;
            return greenerValue;
        };
        FileCreator.findDifference = function (currentValue, initialValue) {
            return currentValue - initialValue;
        };
        FileCreator.createNetExpenseRatioCsv = function (scenario) {
            var file = this.netExpenseRatioTitle + this.newLine;
            file += this.getNetExpenseRatioHeader(scenario);
            file += this.getNetExpenseRatioContent(scenario);
            return file;
        };
        FileCreator.getNetExpenseRatioHeader = function (scenario) {
            var header = this.quote + "Product - " + scenario.product + this.newLine + "Category - " + scenario.category + this.newLine
                + "Channel - " + scenario.channels + this.newLine + "Firm - " + scenario.firms + this.quote + this.comma;
            header += "Current " + scenario.currentNetExpRatioBPS + this.bpsLabel + (scenario.currentNetExpRatioBPS - 5) + this.bpsLabel
                + (scenario.currentNetExpRatioBPS - 10) + this.bpsLabel + (scenario.currentNetExpRatioBPS - 15) + this.bpsLabel
                + (scenario.currentNetExpRatioBPS - 20) + this.bpsLabel + (scenario.currentNetExpRatioBPS - 25) + this.bpsLabel;
            if (scenario.currentNetExpRatioBPS > scenario.optimalNetExpRatioDrop.optimalExpRatio) {
                header += "Optimal " + scenario.optimalNetExpRatioDrop.optimalExpRatio + this.bpsLabel;
            }
            header += this.newLine;
            return header;
        };
        //Quotes are used to escape the commas in the dollar amounts
        FileCreator.getNetExpenseRatioContent = function (scenario) {
            var formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
            var isOptimalRequired = scenario.currentNetExpRatioBPS > scenario.optimalNetExpRatioDrop.optimalExpRatio;
            var content = 'Revenue (Next 12 Mos)' + this.comma + this.quote + formatter.format(scenario.netExpRatioDrop.revenue) + this.quote + this.comma + this.quote +
                formatter.format(scenario.netExpRatioDrop.revenue5) + this.quote + this.comma + this.quote + formatter.format(scenario.netExpRatioDrop.revenue10) + this.quote +
                this.comma + this.quote + formatter.format(scenario.netExpRatioDrop.revenue15) + this.quote + this.comma + this.quote + formatter.format(scenario.netExpRatioDrop.revenue20) +
                this.quote + this.comma + this.quote + formatter.format(scenario.netExpRatioDrop.revenue25) + this.quote;
            content += isOptimalRequired ? this.comma + this.quote + formatter.format(scenario.optimalNetExpRatioDrop.optimalRevenue) + this.quote + this.newLine : this.newLine;
            content += 'Existing Asset Revenue' + this.comma + this.quote + formatter.format(scenario.netExpRatioDrop.assetRevenue) + this.quote + this.comma + this.quote +
                formatter.format(scenario.netExpRatioDrop.assetRevenue5) + this.quote + this.comma + this.quote + formatter.format(scenario.netExpRatioDrop.assetRevenue10) + this.quote +
                this.comma + this.quote + formatter.format(scenario.netExpRatioDrop.assetRevenue15) + this.quote + this.comma + this.quote + formatter.format(scenario.netExpRatioDrop.assetRevenue20) +
                this.quote + this.comma + this.quote + formatter.format(scenario.netExpRatioDrop.assetRevenue25) + this.quote;
            content += isOptimalRequired ? this.comma + this.quote + formatter.format(scenario.optimalNetExpRatioDrop.optimalAssetRevenue) + this.quote + this.newLine : this.newLine;
            content += 'Total Revenue' + this.comma + this.quote + formatter.format(scenario.netExpRatioDrop.totalRevenue) + this.quote + this.comma + this.quote +
                formatter.format(scenario.netExpRatioDrop.totalRevenue5) + this.quote + this.comma + this.quote + formatter.format(scenario.netExpRatioDrop.totalRevenue10) + this.quote +
                this.comma + this.quote + formatter.format(scenario.netExpRatioDrop.totalRevenue15) + this.quote + this.comma + this.quote + formatter.format(scenario.netExpRatioDrop.totalRevenue20) +
                this.quote + this.comma + this.quote + formatter.format(scenario.netExpRatioDrop.totalRevenue25) + this.quote;
            content += isOptimalRequired ? this.comma + this.quote + formatter.format(scenario.optimalNetExpRatioDrop.optimalTotalRevenue) + this.quote + this.newLine : this.newLine;
            content += "Gross Sales" + this.comma + this.quote + formatter.format(scenario.netExpRatioDrop.grossSales) + this.quote + this.comma + this.quote +
                formatter.format(scenario.netExpRatioDrop.grossSales5) + this.quote + this.comma + this.quote + formatter.format(scenario.netExpRatioDrop.grossSales10) +
                this.quote + this.comma + this.quote + formatter.format(scenario.netExpRatioDrop.grossSales15) + this.quote +
                this.comma + this.quote + formatter.format(scenario.netExpRatioDrop.grossSales20) + this.quote + this.comma + this.quote + formatter.format(scenario.netExpRatioDrop.grossSales25) + this.quote;
            content += isOptimalRequired ? this.comma + this.quote + formatter.format(scenario.optimalNetExpRatioDrop.optimalGrossSales) + this.quote + this.newLine : this.newLine;
            content += "Market Share" + this.comma + scenario.netExpRatioDrop.marketShare + this.percentSign + this.comma + scenario.netExpRatioDrop.marketShare5 +
                this.percentSign + this.comma + scenario.netExpRatioDrop.marketShare10 + this.percentSign + this.comma + scenario.netExpRatioDrop.marketShare15 +
                this.percentSign + this.comma + scenario.netExpRatioDrop.marketShare20 + this.percentSign + this.comma + scenario.netExpRatioDrop.marketShare25 + this.percentSign;
            content += isOptimalRequired ? this.comma + scenario.optimalNetExpRatioDrop.optimalMarketShare + this.percentSign + this.newLine : this.newLine;
            content += "Market Share Rank" + this.comma + scenario.netExpRatioDrop.marketShareRank + this.comma + scenario.netExpRatioDrop.marketShareRank5 +
                this.comma + scenario.netExpRatioDrop.marketShareRank10 + this.comma + scenario.netExpRatioDrop.marketShareRank15 + this.comma +
                scenario.netExpRatioDrop.marketShareRank20 + this.comma + scenario.netExpRatioDrop.marketShareRank25;
            content += isOptimalRequired ? this.comma + scenario.optimalNetExpRatioDrop.optimalMarketShareRank + this.newLine : this.newLine;
            content += "Green Space" + this.comma + this.quote + formatter.format(scenario.netExpGreenSpaceDrop.greenSpaceBps) + this.quote + this.comma + this.quote +
                formatter.format(scenario.netExpGreenSpaceDrop.greenSpace5Bps) + this.quote + this.comma + this.quote + formatter.format(scenario.netExpGreenSpaceDrop.greenSpace10Bps) +
                this.quote + this.comma + this.quote + formatter.format(scenario.netExpGreenSpaceDrop.greenSpace15Bps) + this.quote + this.comma +
                this.quote + formatter.format(scenario.netExpGreenSpaceDrop.greenSpace20Bps) + this.quote + this.comma + this.quote +
                formatter.format(scenario.netExpGreenSpaceDrop.greenSpace25Bps) + this.quote;
            content += isOptimalRequired ? this.comma + this.quote + formatter.format(scenario.netExpGreenSpaceDrop.greenSpaceOptimal) + this.quote + this.newLine : this.newLine;
            return content;
        };
        FileCreator.scenarioAChar = "A";
        FileCreator.scenarioBChar = "B";
        FileCreator.newLine = "\r\n";
        FileCreator.comma = ",";
        FileCreator.percentSign = "%";
        FileCreator.quote = '"';
        FileCreator.columnLine = "Datapoint,Actual,Scenario A,Scenario A Change";
        FileCreator.netExpenseRatioTitle = "Net Expense Ratio 5 bps Increments,";
        FileCreator.bpsLabel = "bps,";
        return FileCreator;
    }());
    BiWhatIfScenarios.FileCreator = FileCreator;
})(BiWhatIfScenarios || (BiWhatIfScenarios = {}));
///<reference path="../../libs/jquery.d.ts"/>
///<reference path="00.data_type.ts" />
///<reference path="03.service.ts" />
///<reference path="05.product_selection.ts" />
///<reference path="06.expected_sales.ts" />
///<reference path="07.net_expense.ts" />
///<reference path="08.file.ts" />
var BiWhatIfScenarios;
(function (BiWhatIfScenarios) {
    var ProductPage = (function () {
        function ProductPage(wrapper) {
            this.downloadClosure = false;
            this.wrapper = wrapper;
            this.service = new BiWhatIfScenarios.Service();
            this.savedScenariosList = [];
            this.savedScenarioNames = [];
            this.scenarioType = 'What-if';
            this.productSelectors = new BiWhatIfScenarios.ProductSelection(this.wrapper);
            jQuery('.saved-scenarios-wrapper').hide();
            this.stylizeParentWrapper();
            this.initializeProductPageEvents();
            this.getSavedScenarios();
            this.getNetExpCategories();
        }
        ProductPage.getInstance = function (wrapper) {
            if (ProductPage._instance) {
                return ProductPage._instance;
            }
            else {
                ProductPage._instance = new ProductPage(wrapper);
                return ProductPage._instance;
            }
        };
        ProductPage.prototype.stylizeParentWrapper = function () {
            var contentDiv = this.wrapper.parent();
            contentDiv.addClass("adjust-content-div");
        };
        ProductPage.prototype.initializeProductPageEvents = function () {
            var _this = this;
            var current_tab, next_tab, previous_tab; //tabs
            var me = this;
            jQuery(".next-button").click(function (e) {
                //get info from dropdowns
                var values = me.productSelectors.getDropdownInfo();
                current_tab = jQuery(this).closest('.tab');
                next_tab = current_tab.next();
                var current_index = jQuery(".tab").index(current_tab);
                me.buildGreyWrapperWithProductPageSelections(values, current_index);
                if (current_index == 0) {
                    var isModelAvailable = me.validateNetExpModelAvailability(values.category);
                    if (isModelAvailable) {
                        $('#expense-ratio-model').removeAttr('disabled');
                    }
                    else {
                        $('#expense-ratio-model').attr('disabled', 'true');
                    }
                }
                else if (current_index == 1) {
                    var model_name_1 = jQuery(this).attr("id").replace(/-/g, " ");
                    jQuery("#selected-model-name").text(model_name_1);
                    var shareClass_1 = me.service.getShareClass(values.product);
                    me.service.getFactors(values.category, values.product, model_name_1).then(function (data) {
                        shareClass_1.then(function (shareClassName) {
                            $("#scenario-name-quotes-error-msg, #scenario-name-length-error-msg, #scenario-name-not-unique-msg").hide();
                            $("#scenarioName-quotes-error-msg, #scenarioName-length-error-msg, #scenarioName-not-unique-msg").hide();
                            if (model_name_1 === "expected sales model") {
                                me.currentExpModel = new BiWhatIfScenarios.ExpectedSales(me.wrapper, me.service, values, data, shareClassName);
                            }
                            else {
                                me.currentNetExpModel = new BiWhatIfScenarios.NetExpense(me.wrapper.find("#net-expense-model-info"), me.service, values, shareClassName, data);
                            }
                        });
                    });
                }
                //activate next step on horizontal-stepper using the index of next_tab
                jQuery(".horizontal-stepper li").eq(current_index + 1).addClass("active");
                jQuery(".horizontal-stepper li").eq(current_index).removeClass("active").addClass("done").find(".step-num").html("&#10004;");
                next_tab.show();
                current_tab.hide();
            });
            jQuery(".back-button").click(function (e) {
                current_tab = jQuery(this).closest('.tab');
                previous_tab = current_tab.prev();
                var current_index = jQuery(".tab").index(current_tab);
                if (current_index !== 2 || (me.checkScenarioSaved() && !$("#what-if-scenario-input").hasClass("updateable-scenario"))) {
                    //de-activate current step on horizontal-stepper
                    jQuery(".horizontal-stepper li").eq(current_index).removeClass("active");
                    jQuery(".horizontal-stepper li").eq(current_index - 1).removeClass("done").addClass("active").find(".step-num").text(current_index);
                    previous_tab.show();
                    current_tab.hide();
                    $("#what-if-scenario-input").removeClass('updateable-scenario');
                    $("#what-if-scenario-input").removeData();
                }
                else {
                    me.popupParentWindow = 'back';
                    me.validateScenarioName();
                }
            });
            jQuery(".new-scenario-button").click(function () {
                _this.popupParentWindow = 'new-scenario';
                _this.validateScenarioName();
            });
            jQuery("#product-dropdown, #category-dropdown").change(function () {
                _this.checkNextButtonStatus();
            });
            //main scenario name input box
            jQuery("#what-if-scenario-input").keyup(function () {
                var scenarioName = jQuery("#what-if-scenario-input").val().trimLeft();
                jQuery("#what-if-scenario-input").val(scenarioName);
                $("#scenario-name-quotes-error-msg, #scenario-name-length-error-msg, #scenario-name-not-unique-msg").hide();
                if ((scenarioName && _this.isScenarioNameValid(scenarioName))) {
                    jQuery(".save-button-wrapper").show();
                }
                else {
                    if (!_this.noSpecialCharacters(scenarioName)) {
                        $("#scenario-name-quotes-error-msg").show();
                    }
                    if (!_this.smallEnough(scenarioName)) {
                        $("#scenario-name-length-error-msg").show();
                    }
                    if (!_this.isScenarioNameUnique(scenarioName) && scenarioName !== $("#what-if-scenario-input").data('originalName')) {
                        $("#scenario-name-not-unique-msg").show();
                    }
                }
                if (scenarioName !== $("#what-if-scenario-input").data('originalName') && !$("#net-expense-model-info")) {
                    $("#what-if-scenario-input").addClass('updateable-scenario');
                }
                else {
                    $("#what-if-scenario-input").removeClass('updateable-scenario');
                }
            });
            //modal scenario name input box
            jQuery("#save-scenario-name").keyup(function () {
                var scenarioName = jQuery("#save-scenario-name").val().trimLeft();
                jQuery("#save-scenario-name").val(scenarioName);
                $("#scenarioName-quotes-error-msg, #scenarioName-length-error-msg, #scenarioName-not-unique-msg").hide();
                if ((scenarioName && _this.isScenarioNameValid(scenarioName))) {
                    jQuery(".what-if-save-button").removeAttr('disabled');
                }
                else {
                    jQuery(".what-if-save-button").attr('disabled', 'true');
                    if (!_this.noSpecialCharacters(scenarioName)) {
                        $("#scenarioName-quotes-error-msg").show();
                    }
                    if (!_this.smallEnough(scenarioName)) {
                        $("#scenarioName-length-error-msg").show();
                    }
                    if (!_this.isScenarioNameUnique(scenarioName) && scenarioName !== $("#what-if-scenario-input").data('originalName')) {
                        $("#scenarioName-not-unique-msg").show();
                    }
                }
            });
            jQuery("#confirmation-dialog").on('show.bs.modal', function (event) {
                if ($('#save-scenario-name').data('name')) {
                    $('#save-scenario-name').val($('#save-scenario-name').data('name'));
                    $(".what-if-save-button").removeAttr('disabled');
                    $('#save-scenario-name').removeData();
                }
                else {
                    $('#save-scenario-name').val('');
                }
            });
            //main save button
            jQuery(".save-scenario").click(function () {
                var scenarioName = jQuery("#what-if-scenario-input").val().trim();
                if ($("#what-if-scenario-input").hasClass("updateable-scenario")) {
                    _this.updateScenario(scenarioName);
                    $("#what-if-scenario-input").data('scenarioInfo', _this.getScenarioInfo(scenarioName));
                }
                else if (scenarioName && _this.isScenarioNameValid(scenarioName)) {
                    _this.saveWhatIfScenario(scenarioName);
                    var model = _this.wrapper.find("#selected-model-name").text();
                    if (model === "expected sales model") {
                        _this.currentExpModel.setUpdateable();
                    }
                    $("#what-if-scenario-input").data('scenarioInfo', _this.getScenarioInfo(scenarioName));
                }
                else {
                    if (!_this.noSpecialCharacters(scenarioName)) {
                        $("#scenario-name-quotes-error-msg").show();
                    }
                    if (!_this.smallEnough(scenarioName)) {
                        $("#scenario-name-length-error-msg").show();
                    }
                    if (!_this.isScenarioNameUnique(scenarioName) && scenarioName !== $("#what-if-scenario-input").data('originalName')) {
                        $("#scenarioName-not-unique-msg").show();
                    }
                }
            });
            //modal save button
            jQuery(".what-if-save-button").click(function () {
                var scenarioName = jQuery("#save-scenario-name").val().trim();
                if ($("#save-scenario-name").hasClass("updateable-scenario") && scenarioName === $("#what-if-scenario-input").data('originalName')) {
                    $("#save-scenario-name").removeClass("updateable-scenario");
                    $("#save-scenario-name").val('');
                    _this.updateScenario(scenarioName);
                }
                else {
                    $("#what-if-scenario-input").data('originalName', scenarioName);
                    $("#what-if-scenario-input").removeClass("updateable-scenario");
                    _this.saveWhatIfScenario(scenarioName);
                    var model = _this.wrapper.find("#selected-model-name").text();
                    if (model === "expected sales model") {
                        _this.currentExpModel.setUpdateable();
                    }
                }
                $("#what-if-scenario-input").data('scenarioInfo', _this.getScenarioInfo(scenarioName));
                if (_this.downloadClosure) {
                    var scenarioInfo = _this.getScenarioInfo(scenarioName);
                    _this.getScenarioCsv(scenarioInfo.scenario, scenarioInfo.scenario.model);
                    _this.downloadClosure = false;
                }
            });
            jQuery(".download-wrapper").click(function () {
                var scenarioName = jQuery("#what-if-scenario-input").val().trim();
                if (scenarioName && !$("#what-if-scenario-input").hasClass("updateable-scenario")) {
                    var scenarioInfo = _this.getScenarioInfo(scenarioName);
                    var savedInfo = _this.savedScenariosList.filter(function (scenario) {
                        return scenario.scenarioName == scenarioName;
                    })[0];
                    delete savedInfo['scenarioId'];
                    delete savedInfo['lastUpdated'];
                    delete scenarioInfo.scenario['lastUpdated'];
                    if (scenarioInfo.scenario.model === "expected sales model") {
                        // To validate if there is any change for the saved scenario
                        if (JSON.stringify(scenarioInfo.scenario) === JSON.stringify(savedInfo)) {
                            _this.getScenarioCsv(savedInfo, scenarioInfo.scenario.model);
                        }
                        else {
                            _this.popupParentWindow = 'back';
                            jQuery("#confirmation-dialog").modal({ 'backdrop': 'static', 'show': true });
                        }
                    }
                    else {
                        _this.getScenarioCsv(savedInfo, scenarioInfo.scenario.model);
                    }
                }
                else {
                    _this.popupParentWindow = 'back';
                    _this.downloadClosure = true;
                    if ($("#what-if-scenario-input").hasClass("updateable-scenario")) {
                        $("#save-scenario-name").addClass("updateable-scenario");
                        $("#save-scenario-name").ready(function () {
                            $("#save-scenario-name").data('name', scenarioName);
                        });
                    }
                    jQuery("#confirmation-dialog").modal({ 'backdrop': 'static', 'show': true });
                }
            });
            jQuery("#delete-confirmation-dialog").on('show.bs.modal', function (event) {
                _this.deleteScenarioId = $(event.relatedTarget).data('scenarioid');
            });
            jQuery("#yesDelete").click(function () {
                _this.deleteScenarioById();
            });
            jQuery(".dont-save-button").click(function () {
                _this.dontSaveScenario();
            });
            jQuery('#what-if-scenario-input, #save-scenario-name').on('empty-input', function (event) {
                jQuery('#what-if-scenario-input, #save-scenario-name').val('');
            });
            jQuery('#methodology-span').click(function () {
                $('#methodology-pdf-wrapper').append(jQuery('<embed/>', {
                    'type': 'application/pdf',
                    'class': 'methodology-file',
                    'src': 'assets/pdfs/WalletShare What-If Methodologies.pdf'
                }));
            });
            jQuery('#methodology-close-btn').click(function () {
                $('#methodology-pdf-wrapper').empty();
            });
        };
        ProductPage.prototype.validateScenarioName = function () {
            var scenarioName = jQuery("#what-if-scenario-input").val().trim();
            if (scenarioName && !$("#what-if-scenario-input").hasClass("updateable-scenario")) {
                var scenarioInfo = this.getScenarioInfo(scenarioName);
                this.loadSavedScenarios();
                var savedInfoList = this.savedScenariosList.filter(function (scenario) {
                    return scenario.scenarioName == scenarioName;
                });
                if (savedInfoList.length < 1 && scenarioInfo.scenario.model === "expected sales model" && scenarioName.length > 0) {
                    jQuery("#confirmation-dialog").modal({ 'backdrop': 'static', 'show': true });
                    return;
                }
                delete savedInfoList[0]['scenarioId'];
                delete savedInfoList[0]['lastUpdated'];
                delete scenarioInfo.scenario['lastUpdated'];
                if (scenarioInfo.scenario.model === "expected sales model") {
                    // To validate if there is any change for the saved scenario
                    if (JSON.stringify(scenarioInfo.scenario) === JSON.stringify(savedInfoList[0])) {
                        this.dontSaveScenario();
                    }
                    else {
                        jQuery("#confirmation-dialog").modal({ 'backdrop': 'static', 'show': true });
                    }
                }
                else {
                    this.dontSaveScenario();
                }
            }
            else {
                $('#save-scenario-name').val('');
                if ($("#what-if-scenario-input").hasClass("updateable-scenario")) {
                    $("#save-scenario-name").addClass("updateable-scenario");
                    $("#save-scenario-name").ready(function () {
                        $("#save-scenario-name").data('name', scenarioName);
                    });
                }
                jQuery("#confirmation-dialog").modal({ 'backdrop': 'static', 'show': true });
            }
        };
        ProductPage.prototype.dontSaveScenario = function () {
            if (this.popupParentWindow === 'back') {
                jQuery(".horizontal-stepper li").eq(2).removeClass("active");
                jQuery(".horizontal-stepper li").eq(1).removeClass("done").addClass("active").find(".step-num").text(2);
                jQuery(".tab").eq(2).hide();
                jQuery(".tab").eq(1).show();
                jQuery('#what-if-scenario-input, #save-scenario-name').trigger('empty-input');
                jQuery("#expected-model-info").children().remove();
                jQuery("#bi-wait-icon").show();
                jQuery("#net-expense-model-info").empty();
            }
            else {
                this.resetWhatIfPage();
            }
            $("#what-if-scenario-input").removeClass('updateable-scenario');
            $("#what-if-scenario-input").removeData();
        };
        ProductPage.prototype.resetWhatIfPage = function () {
            $("#scenario-name-quotes-error-msg, #scenario-name-length-error-msg, #scenario-name-not-unique-msg").hide();
            $("#scenarioName-quotes-error-msg, #scenarioName-length-error-msg, #scenarioName-not-unique-msg").hide();
            jQuery(".horizontal-stepper li").removeClass("active").removeClass("done");
            jQuery(".horizontal-stepper li").eq(0).addClass("active").find(".step-num").text(1);
            jQuery(".horizontal-stepper li").eq(1).find(".step-num").text(2);
            jQuery(".horizontal-stepper li").eq(2).find(".step-num").text(3);
            jQuery(".tab").hide();
            jQuery(".tab").eq(0).show();
            jQuery(".dropdown-margin-div .dropdown-wrapper select").val('');
            jQuery("#channel-dropdown").multiselect('selectAll', true);
            jQuery("#channel-dropdown").multiselect('rebuild');
            this.productSelectors.resetFirms();
            jQuery("#product-page-next-button").attr('disabled', 'true');
            jQuery('#what-if-scenario-input, #save-scenario-name').val('').keyup();
            jQuery("#expected-model-info").children().remove();
            jQuery("#bi-wait-icon").show();
            jQuery("#net-expense-model-info").empty();
            jQuery("#product-dropdown, #category-dropdown").empty();
            this.productSelectors.loadDropdowns();
        };
        ProductPage.prototype.getSavedScenarios = function () {
            var _this = this;
            this.service.getSavedBIScenarios(this.scenarioType).then(function (result) {
                _this.savedScenariosList = [];
                _this.savedScenarioNames = [];
                result.forEach(function (row) {
                    var parsedResult = JSON.parse(row.scenario);
                    parsedResult.scenarioId = row.scenarioId;
                    _this.savedScenariosList.push(parsedResult);
                    if (_this.savedScenarioNames.indexOf(parsedResult.scenarioName) === -1) {
                        _this.savedScenarioNames.push(parsedResult.scenarioName);
                    }
                });
                _this.loadSavedScenarios();
            });
        };
        ProductPage.prototype.loadSavedScenarios = function () {
            var _this = this;
            var saved_scenarios_table = jQuery(".saved-scenarios-table");
            jQuery(".saved-scenarios-table-row").remove();
            this.savedScenariosList.forEach(function (scenario) {
                var modelTypeIcon = scenario.model === 'expected sales model' ? 'expected_model.png' : 'net_expense_model.png';
                var table_row = jQuery('<div>', {
                    'class': 'saved-scenarios-table-row',
                    'id': 'saved-scenario' + scenario.scenarioId
                });
                var name = jQuery('<div>', {
                    'class': 'saved-scenarios-name',
                    'html': '<img src="/assets/img/' + modelTypeIcon + '" alt="model type" />&nbsp;<span>' + scenario.scenarioName + '</span>'
                });
                var product = jQuery('<div>', { 'class': 'saved-scenarios-product', 'text': scenario.product });
                var category = jQuery('<div>', { 'class': 'saved-scenarios-category', 'text': scenario.category });
                var channel = jQuery('<div>', { 'class': 'saved-scenarios-channel', 'text': 'All Channels' });
                if ((scenario.channels !== null) && (scenario.channels.length > 0)) {
                    channel = jQuery('<div>', {
                        'class': 'saved-scenarios-channel blue-color',
                        'text': scenario.channels
                    });
                    channel.attr('title', channel.text());
                }
                var firm = jQuery('<div>', { 'class': 'saved-scenarios-firm', 'text': 'All Firms' });
                if ((scenario.firms !== null) && (scenario.firms.length > 0)) {
                    firm = jQuery('<div>', { 'class': 'saved-scenarios-firm blue-color', 'text': scenario.firms });
                    firm.attr('title', firm.text());
                }
                var dataAsOf = jQuery('<div>', { 'class': 'saved-scenarios-data-as-of', 'text': scenario.dataAsOf });
                var lastUpdated = jQuery('<div>', {
                    'class': 'saved-scenarios-last-updated',
                    'text': scenario.lastUpdated
                });
                var scenario_buttons = jQuery('<div>', {
                    'class': 'saved-scenarios-buttons',
                    'html': '<i class="fa fa-cloud-download" aria-hidden="true"></i><i class="fa fa-times" data-toggle="modal" data-target="#delete-confirmation-dialog" data-scenarioId="' + scenario.scenarioId + '" data-backdrop="static" aria-hidden="true"></i>'
                });
                name.click(function () {
                    _this.navigateToSavedScenario(scenario);
                });
                scenario_buttons.children().first().click(function () {
                    _this.getScenarioCsv(scenario, scenario.model);
                });
                table_row.append(name, product, category, channel, firm, dataAsOf, lastUpdated, scenario_buttons);
                if (scenario.scenarioName.length !== 0) {
                    saved_scenarios_table.append(table_row);
                }
            });
            if (this.savedScenariosList.length === 0) {
                jQuery('.saved-scenarios-wrapper').hide();
            }
            else {
                jQuery('.saved-scenarios-wrapper').show();
            }
            jQuery(".saved-scenarios-channel, .saved-scenarios-firm").each(function () {
                var $this = $(this);
                if (this.offsetWidth < this.scrollWidth) {
                    $this.addClass('blue-color');
                    $this.attr('title', $this.text());
                }
            });
        };
        ProductPage.prototype.getNetExpCategories = function () {
            var _this = this;
            this.service.getNetExpCategories().then(function (result) {
                _this.netExpCategories = result;
            });
        };
        ProductPage.prototype.validateNetExpModelAvailability = function (category) {
            return ($.inArray(category, this.netExpCategories) != -1);
        };
        ProductPage.prototype.navigateToSavedScenario = function (scenario) {
            var _this = this;
            this.wrapper.find("#product-dropdown option:contains(" + scenario.product + ")").prop('selected', true);
            this.wrapper.find("#product-dropdown").change();
            this.wrapper.find("#channel-dropdown").multiselect("select", scenario.channelIds);
            this.wrapper.find("#channel-dropdown").multiselect("rebuild");
            this.productSelectors.onApplyChannels(scenario.firms);
            setTimeout(function () {
                _this.wrapper.find("#product-page-next-button").click();
                if (scenario.model === "expected sales model") {
                    _this.wrapper.find('#expected-sales-model').click();
                    _this.buildChannelModel(scenario.channels, 1);
                    _this.buildFirmModel(scenario.firms, 1);
                    var factorDetails_1 = scenario.factorDetails;
                    var expectedSalesIntervalId = window.setInterval(function () {
                        if (_this.wrapper.find("#bi-wait-icon").css('display') === 'none') {
                            _this.currentExpModel.toggleIsFromSavedScenario();
                            _this.currentExpModel.setUpdateable();
                            window.clearInterval(expectedSalesIntervalId); // clear interval once what-if page loaded
                            factorDetails_1.forEach(function (scenarioBox, index) {
                                if (index === 1) {
                                    _this.wrapper.find('.add-scenario-div').click();
                                }
                                scenarioBox.forEach(function (slider, sliderIndex) {
                                    _this.wrapper.find('.what-if-scenario-div').eq(index).find('.factor-slide-bar-right-div input').eq(sliderIndex).val(slider.currentValue.toString()).change();
                                });
                            });
                            setTimeout(function () {
                                _this.currentExpModel.toggleWaitingOverlays(BiWhatIfScenarios.FactorTypeEnum.SCENARIOA, true);
                                _this.currentExpModel.getExpectedSalesData(BiWhatIfScenarios.FactorTypeEnum.SCENARIOA, _this.currentExpModel.getSliderValues(BiWhatIfScenarios.FactorTypeEnum.SCENARIOA, false), _this.currentExpModel.updateTables, true, scenario);
                                if (factorDetails_1.length === 2) {
                                    _this.currentExpModel.toggleWaitingOverlays(BiWhatIfScenarios.FactorTypeEnum.SCENARIOB, true);
                                    _this.currentExpModel.getExpectedSalesData(BiWhatIfScenarios.FactorTypeEnum.SCENARIOB, _this.currentExpModel.getSliderValues(BiWhatIfScenarios.FactorTypeEnum.SCENARIOB, false), _this.currentExpModel.updateTables, true, scenario);
                                }
                                _this.currentExpModel.toggleIsFromSavedScenario();
                                $("#what-if-scenario-input").data('originalName', scenario.scenarioName);
                                $("#what-if-scenario-input").data('scenarioInfo', _this.getScenarioInfo(scenario.scenarioName));
                            }, 1000);
                        }
                    }, 500);
                }
                else {
                    _this.wrapper.find('#expense-ratio-model').click();
                    _this.buildChannelModel(scenario.channels, 1);
                    _this.buildFirmModel(scenario.firms, 1);
                }
                _this.wrapper.find("#what-if-scenario-input").val(scenario.scenarioName);
            }, 500);
        };
        ProductPage.prototype.getScenarioCsv = function (scenario, model) {
            var fileContents = model === 'expected sales model' ? BiWhatIfScenarios.FileCreator.createExpectedSalesCsv(scenario) : BiWhatIfScenarios.FileCreator.createNetExpenseRatioCsv(scenario);
            var fileName = this.getFileName(scenario) + ".csv";
            var blob = new Blob([fileContents], { type: "text/plain" });
            //create temp link to send file to for dl                                                    
            var a = document.createElement("a");
            a.href = window.URL.createObjectURL(blob);
            a.setAttribute("download", fileName);
            a.setAttribute('target', '_blank');
            a.setAttribute('style', 'display:none');
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
        };
        ProductPage.prototype.getFileName = function (scenario) {
            return scenario.product + "_" + scenario.scenarioName + "_" + scenario.dataAsOf.slice(0, 2) + scenario.dataAsOf.slice(-2);
        };
        ProductPage.prototype.getProductPageNextButtonStatus = function () {
            return this.wrapper.find("#product-page-next-button").is(":disabled");
        };
        ProductPage.prototype.deleteScenarioById = function () {
            var _this = this;
            var deleteScenario = this.service.deleteScenario(this.deleteScenarioId);
            deleteScenario.then(function (result) {
                _this.getSavedScenarios();
            });
        };
        ProductPage.prototype.checkNextButtonStatus = function () {
            var product_val = jQuery("#product-dropdown").val();
            var category_val = jQuery("#category-dropdown").val();
            if (product_val !== "" && category_val !== "" && !jQuery("#category-dropdown").attr("disabled")) {
                jQuery("#product-page-next-button").removeAttr("disabled");
            }
            else {
                jQuery("#product-page-next-button").attr('disabled', 'true');
            }
        };
        ProductPage.prototype.buildGreyWrapperWithProductPageSelections = function (values, current_index) {
            jQuery(".model-product-value").text(values.product);
            jQuery(".model-category-value").text(values.category);
            this.buildChannelModel(values.channels, current_index);
            this.buildFirmModel(values.firms, current_index);
        };
        ProductPage.prototype.buildChannelModel = function (channels, current_index) {
            var modelChannelWrapper = this.wrapper.find('#channelNames' + current_index);
            modelChannelWrapper.empty();
            var showHideChannel = this.wrapper.find("#show-hide-channel" + current_index);
            showHideChannel.empty();
            if (channels && channels.length > 0) {
                if (channels.length > 1) {
                    var showChannelIcon_1 = jQuery('<span/>', { 'class': 'glyphicon glyphicon-chevron-down' });
                    var hideChannelIcon_1 = jQuery('<span/>', { 'class': 'glyphicon glyphicon-chevron-up' });
                    showHideChannel.append(showChannelIcon_1);
                    showHideChannel.append(hideChannelIcon_1);
                    var listChannelsDesc = jQuery('<span/>', { 'text': channels.length + ' Channels' });
                    modelChannelWrapper.append(listChannelsDesc);
                    var channelwrapper_1 = jQuery('<div/>', { 'class': 'channel-names-wrapper' });
                    var channelCloseIcon = jQuery('<div/>', { 'class': 'channel-firm-close-icon glyphicon glyphicon-remove' });
                    channelwrapper_1.append(channelCloseIcon);
                    channels.forEach(function (channel) {
                        channelwrapper_1.append(jQuery('<li/>', { 'text': channel }));
                    });
                    modelChannelWrapper.append(channelwrapper_1);
                    channelwrapper_1.hide();
                    hideChannelIcon_1.hide();
                    showChannelIcon_1.show();
                    showChannelIcon_1.click(function () {
                        channelwrapper_1.show();
                        hideChannelIcon_1.show();
                        showChannelIcon_1.hide();
                    });
                    hideChannelIcon_1.click(function () {
                        channelwrapper_1.hide();
                        showChannelIcon_1.show();
                        hideChannelIcon_1.hide();
                    });
                    channelCloseIcon.click(function () {
                        channelwrapper_1.hide();
                        showChannelIcon_1.show();
                        hideChannelIcon_1.hide();
                    });
                }
                else {
                    modelChannelWrapper.append(jQuery('<div/>', { 'text': channels[0] }));
                }
            }
            else {
                modelChannelWrapper.append(jQuery('<div/>', { 'text': 'All Channels' }));
            }
        };
        ProductPage.prototype.buildFirmModel = function (firms, current_index) {
            var modelFirmWrapper = this.wrapper.find('#firmNames' + current_index);
            modelFirmWrapper.empty();
            var showHideFirm = this.wrapper.find("#show-hide-firm" + current_index);
            showHideFirm.empty();
            if (firms && firms.length > 0) {
                if (firms.length > 1) {
                    var showFirmIcon_1 = jQuery('<span/>', {
                        'class': 'glyphicon glyphicon-chevron-down',
                        'id': 'showFirms'
                    });
                    var hideFirmIcon_1 = jQuery('<span/>', {
                        'class': 'glyphicon glyphicon-chevron-up',
                        'id': 'hideFirms'
                    });
                    showHideFirm.append(showFirmIcon_1);
                    showHideFirm.append(hideFirmIcon_1);
                    var listFirmsDesc = jQuery('<span/>', { 'text': firms.length + ' Firms' });
                    modelFirmWrapper.append(listFirmsDesc);
                    var firmwrapper_1 = jQuery('<div/>', { 'class': 'firm-names-wrapper' });
                    var firmCloseIcon = jQuery('<div/>', { 'class': 'channel-firm-close-icon glyphicon glyphicon-remove' });
                    firmwrapper_1.append(firmCloseIcon);
                    firms.forEach(function (firm) {
                        firmwrapper_1.append(jQuery('<li/>', { 'text': firm }));
                    });
                    modelFirmWrapper.append(firmwrapper_1);
                    firmwrapper_1.hide();
                    hideFirmIcon_1.hide();
                    showFirmIcon_1.show();
                    showFirmIcon_1.click(function () {
                        firmwrapper_1.show();
                        hideFirmIcon_1.show();
                        showFirmIcon_1.hide();
                    });
                    hideFirmIcon_1.click(function () {
                        firmwrapper_1.hide();
                        showFirmIcon_1.show();
                        hideFirmIcon_1.hide();
                    });
                    firmCloseIcon.click(function () {
                        firmwrapper_1.hide();
                        showFirmIcon_1.show();
                        hideFirmIcon_1.hide();
                    });
                }
                else {
                    modelFirmWrapper.append(jQuery('<div/>', { 'text': firms[0] }));
                }
            }
            else {
                modelFirmWrapper.append(jQuery('<div/>', { 'text': 'All Firms' }));
            }
        };
        ProductPage.prototype.saveWhatIfScenario = function (scenarioName) {
            var _this = this;
            if (scenarioName.length === 0) {
                return; //no saving scenarios with empty names
            }
            var scenario = this.getScenarioInfo(scenarioName);
            this.service.saveBIScenario(scenario, this.scenarioType).then(function (result) {
                _this.showSuccessMsg("#successMsg");
                _this.savedScenarioNames.push(scenarioName);
                _this.wrapper.find("#what-if-scenario-input").val(scenarioName);
                $("#scenario-name-quotes-error-msg, #scenario-name-length-error-msg, #scenario-name-not-unique-msg").hide();
                $("#what-if-scenario-input").removeClass("updateable-scenario");
                $(".save-button-wrapper").show();
                _this.getSavedScenarios();
                //update name to help input keyup function recognize new name changes
                if ($("#what-if-scenario-input").data('originalName')) {
                    $("#what-if-scenario-input").data('originalName', scenarioName);
                }
            });
        };
        ProductPage.prototype.updateScenario = function (scenarioName) {
            var _this = this;
            var scenario = this.getScenarioInfo(scenarioName);
            var scenarioIdObj = this.savedScenariosList.filter(function (scenario) {
                return scenario.scenarioName == scenarioName;
            })[0];
            if (scenarioIdObj == undefined) {
                this.saveWhatIfScenario(scenarioName);
            }
            else if (scenarioIdObj.hasOwnProperty('scenarioId')) {
                this.sendUpdate(scenario, scenarioName, scenarioIdObj.scenarioId);
            }
            else {
                this.service.getScenarioId(scenarioName).then(function (id) {
                    _this.sendUpdate(scenario, scenarioName, id);
                });
            }
        };
        ProductPage.prototype.sendUpdate = function (scenario, scenarioName, scenarioId) {
            var _this = this;
            this.service.updateScenario(scenario, scenarioId).then(function (result) {
                //display update message
                _this.showSuccessMsg("#updateMsg");
                $("#what-if-scenario-input").removeClass('updateable-scenario');
                //update saved scenarios list
                _this.savedScenariosList.forEach(function (scenarioSaved, index) {
                    if (scenarioSaved.scenarioName === scenarioName) {
                        result['scenarioId'] = scenarioId;
                        _this.savedScenariosList[index] = result;
                    }
                });
                _this.getSavedScenarios();
            });
        };
        ProductPage.prototype.checkScenarioSaved = function () {
            var scenarioName = jQuery("#what-if-scenario-input").val().trim();
            var currentScenario = this.getScenarioInfo(scenarioName).scenario;
            delete currentScenario['lastUpdated'];
            var foundSavedScenario = this.savedScenariosList.filter(function (scenario) {
                return scenario === currentScenario;
            })[0];
            if (foundSavedScenario) {
                return true;
            }
            else {
                return false;
            }
        };
        ProductPage.prototype.getScenarioInfo = function (scenarioName) {
            var factorDetails = [];
            var values = this.productSelectors.getDropdownInfo();
            var model = this.wrapper.find("#selected-model-name").text();
            var latestQ = this.productSelectors.getLatestQuarter();
            var dataAsOf = '';
            if (latestQ) {
                var latestQurter = this.productSelectors.getLatestQuarter().split('/');
                dataAsOf = latestQurter[1] + ' ' + latestQurter[0];
            }
            var currentDate = this.getCurrentDate();
            var scenarioDetails = {
                product: values.product,
                productId: values.productId,
                category: values.category,
                categoryId: values.categoryId,
                channels: values.channels,
                channelIds: values.channelIds,
                firms: values.firms,
                firmIds: values.firmIds,
                model: model,
                scenarioName: scenarioName,
                dataAsOf: dataAsOf,
                lastUpdated: currentDate,
            };
            if (model === "expected sales model") {
                factorDetails = this.currentExpModel.getFactorDetails();
                scenarioDetails.factorDetails = factorDetails;
                scenarioDetails.salesData = this.currentExpModel.getSalesData();
                scenarioDetails.greenSpaceData = this.currentExpModel.getGreenSpaceData();
                scenarioDetails.redSpaceData = this.currentExpModel.getRedSpaceData();
                scenarioDetails.salesDataA = this.currentExpModel.getSalesDataByScenario(BiWhatIfScenarios.FactorTypeEnum.SCENARIOA);
                scenarioDetails.greenSpaceDataA = this.currentExpModel.getGreenSpaceDataByScenario(BiWhatIfScenarios.FactorTypeEnum.SCENARIOA);
                scenarioDetails.redSpaceDataA = this.currentExpModel.getRedSpaceDataByScenario(BiWhatIfScenarios.FactorTypeEnum.SCENARIOA);
                scenarioDetails.salesDataB = this.currentExpModel.getSalesDataByScenario(BiWhatIfScenarios.FactorTypeEnum.SCENARIOB);
                scenarioDetails.greenSpaceDataB = this.currentExpModel.getGreenSpaceDataByScenario(BiWhatIfScenarios.FactorTypeEnum.SCENARIOB);
                scenarioDetails.redSpaceDataB = this.currentExpModel.getRedSpaceDataByScenario(BiWhatIfScenarios.FactorTypeEnum.SCENARIOB);
            }
            else {
                scenarioDetails.currentNetExpRatioBPS = this.currentNetExpModel.getCurrentExpBps();
                scenarioDetails.netExpGreenSpaceDrop = this.currentNetExpModel.getNetExpGSBps();
                scenarioDetails.netExpRatioDrop = this.currentNetExpModel.getNetExpDropBps();
                scenarioDetails.optimalNetExpRatioDrop = this.currentNetExpModel.getOptimalNetExpDropBps();
            }
            return { scenario: scenarioDetails };
        };
        ProductPage.prototype.showSuccessMsg = function (idString) {
            var modal = $(idString);
            modal.fadeIn(1000, function () {
                $(this).delay(2000);
                modal.fadeOut(2000, function () {
                });
            });
        };
        ProductPage.prototype.getCurrentDate = function () {
            var date = new Date();
            return this.formatMonthDate(date.getMonth() + 1) + '/' + this.formatMonthDate(date.getDate()) + '/' + date.getFullYear();
        };
        ProductPage.prototype.formatMonthDate = function (value) {
            return value.toString().length < 2 ? '0' + value : value.toString();
        };
        ProductPage.prototype.isScenarioNameValid = function (scenarioName) {
            return this.isScenarioNameUnique(scenarioName)
                && this.noSpecialCharacters(scenarioName)
                && this.smallEnough(scenarioName)
                && this.longEnough(scenarioName);
        };
        ProductPage.prototype.isScenarioNameUnique = function (scenarioName) {
            return ($.inArray(scenarioName.trim(), this.savedScenarioNames) === -1);
        };
        ProductPage.prototype.noSpecialCharacters = function (scenarioName) {
            return /^[\w\d\s\-]*$/.test(scenarioName);
        };
        ProductPage.prototype.smallEnough = function (scenarioName) {
            return scenarioName.length <= 75;
        };
        ProductPage.prototype.longEnough = function (scenarioName) {
            return scenarioName.length > 0;
        };
        return ProductPage;
    }());
    BiWhatIfScenarios.ProductPage = ProductPage;
})(BiWhatIfScenarios || (BiWhatIfScenarios = {}));
var productPage = null;
$(document).ready(function () {
    var wrapper = $(".what-if-scenario-outer-wrapper");
    if (wrapper.isEmpty()) {
        return;
    }
    if (productPage == null) {
        productPage = BiWhatIfScenarios.ProductPage.getInstance(wrapper);
        ;
    }
});
/// <reference path="27.user-reports/02.service.ts"/>
/// <reference path="27.user-reports/03.data.ts"/>
var UserManagement;
(function (UserManagement) {
    var NotificationEmail = (function () {
        function NotificationEmail(icon) {
            this.icon = icon;
            this.addEventListener();
        }
        NotificationEmail.prototype.addEventListener = function () {
            var defaultPassword = companyData.companyName + '_' + companyData.companyFamilyId;
            var content = jQuery('<p/>', {
                class: 'ws-role-management-email-notification-tooltip',
                text: String.format(strings.registerUserNotificationEmail, defaultPassword)
            }).html();
            this.icon.popover({
                html: true,
                trigger: 'hover',
                content: function () {
                    return content;
                },
                placement: 'right'
            });
        };
        return NotificationEmail;
    }());
    var ProgressBar = (function () {
        function ProgressBar(progressBarWrapper) {
            this.progressBarWrapper = progressBarWrapper;
            this.progressBar = this.progressBarWrapper.find('.ws-role-management-progress-bar');
        }
        ProgressBar.prototype.getProgress = function () {
            return Math.round((100 * parseInt(this.progressBar.css('width'))) /
                parseInt(this.progressBarWrapper.css('width')));
        };
        ProgressBar.prototype.setProgress = function (progress) {
            progress = Math.round(progress);
            this.progressBar.css('width', Math.min(progress, 100) + '%');
        };
        ProgressBar.prototype.addProgress = function (progress) {
            this.setProgress(this.getProgress() + progress);
        };
        ProgressBar.prototype.startFakeProgress = function () {
            var _this = this;
            this.setProgress(0);
            var intervalId = setInterval(function () {
                if (_this.getProgress() > 75) {
                    window.clearInterval(intervalId);
                }
                _this.addProgress(25);
            }, 5);
        };
        ProgressBar.prototype.finishFakeProgress = function () {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.setProgress(100);
            setTimeout(function () {
                deferred.resolve();
            }, 300);
            return promise;
        };
        ProgressBar.prototype.showProgressBar = function () {
            this.setProgress(0);
            this.progressBarWrapper.removeClass(ProgressBar.HIDDEN_CSS_CLASS);
        };
        ProgressBar.prototype.hideProgressBar = function () {
            this.setProgress(0);
            this.progressBarWrapper.addClass(ProgressBar.HIDDEN_CSS_CLASS);
        };
        ProgressBar.HIDDEN_CSS_CLASS = 'hidden';
        return ProgressBar;
    }());
    var UserCreationForm = (function () {
        function UserCreationForm(modalWrapper) {
            this.modalWrapper = modalWrapper;
            this.nameInput = this.modalWrapper.find('.ws-role-management-name-input');
            this.emailInput = this.modalWrapper.find('.ws-role-management-email-input');
            this.ssoInput = this.modalWrapper.find('.ws-role-management-sso-input');
            this.defaultPasswordInput = this.modalWrapper.find('.ws-role-management-default-password-input');
            this.hasCrmAccess = this.modalWrapper.find('.ws-role-management-has-crm-access-input');
            this.roleInput = this.modalWrapper.find('.ws-role-management-roles-dropdown-wrapper');
            this.mandatoryInputs = [this.nameInput, this.emailInput, this.roleInput];
            if (this.ssoInput.length > 0) {
                this.mandatoryInputs.push(this.ssoInput);
            }
            this.notificationEmail = new NotificationEmail(this.modalWrapper.find('.ws-role-management-email-notification-icon'));
            this.progressBar = new ProgressBar(this.modalWrapper.find('.ws-role-management-progress-bar-wrapper'));
            this.saveButton = this.modalWrapper.find('.confirmation-response');
            this.addEventListener();
        }
        UserCreationForm.prototype.addEventListener = function () {
            var _this = this;
            this.modalWrapper.on('hidden.bs.modal', function () {
                _this.clearInputs();
            });
            // notification email popover on hover...
            this.notificationEmail.addEventListener();
            // removing errors on mandatory inputs...
            this.mandatoryInputs.forEach(function (input) {
                input.keydown(function () {
                    _this.hideInputError(input);
                });
            });
            // registering new user...
            this.saveButton.click(function () {
                if (_this.areInputsValid() && _this.isEmailValid()) {
                    _this.disableSaveButton();
                    _this.progressBar.showProgressBar();
                    _this.progressBar.startFakeProgress();
                    _this.request()
                        .then(function () {
                        _this.progressBar.finishFakeProgress().always(function () {
                            location.reload();
                        });
                    })
                        .fail(function (response) {
                        _this.progressBar.finishFakeProgress().always(function () {
                            _this.progressBar.hideProgressBar();
                            var errorStatus = JSON.parse(response.responseText).errors.first();
                            var email = _this.emailInput.val();
                            if (errorStatus === UserCreationForm.EMAIL_ALREADY_IN_USE_ERROR) {
                                jQuery.toaster(String.format(strings.registerUserEmailError, email), strings.registerUserEmailErrorLabel, 'danger');
                            }
                            else {
                                jQuery.toaster(String.format(strings.registerUserGenericError, email), '', 'danger');
                            }
                        });
                    }).always(function () {
                        _this.enableSaveButton();
                    });
                }
            });
        };
        UserCreationForm.prototype.clearInputs = function () {
            var _this = this;
            this.nameInput.val('');
            this.emailInput.val('');
            if (this.ssoInput.length > 0) {
                this.ssoInput.val('');
            }
            this.defaultPasswordInput.prop('checked', 'checked');
            this.hasCrmAccess.prop('checked', false);
            this.roleInput.val(this.roleInput.find('option:first').val());
            this.mandatoryInputs.forEach(function (input) {
                _this.hideInputError(input);
            });
        };
        UserCreationForm.prototype.areInputsValid = function () {
            var _this = this;
            return this.mandatoryInputs.map(function (input) {
                return _this.isInputValid(input);
            }).every(function (current) { return current; });
        };
        UserCreationForm.prototype.isInputValid = function (input) {
            var value = input.val();
            if (value.isEmpty()) {
                this.showInputError(input);
            }
            return !value.isEmpty();
        };
        UserCreationForm.prototype.isEmailValid = function () {
            var value = this.emailInput.val();
            var valid = Utilities.isEmailValid(value);
            if (!valid) {
                this.showInputError(this.emailInput);
            }
            return valid;
        };
        UserCreationForm.prototype.showInputError = function (input) {
            input.parent().addClass(UserCreationForm.HAS_ERROR_CSS_CLASS);
            input.parent().addClass(UserCreationForm.HAS_FEEDBACK_CSS_CLASS);
            input.next().removeClass(UserCreationForm.HIDDEN_CSS_CLASS);
        };
        UserCreationForm.prototype.hideInputError = function (input) {
            input.parent().removeClass(UserCreationForm.HAS_ERROR_CSS_CLASS);
            input.parent().removeClass(UserCreationForm.HAS_FEEDBACK_CSS_CLASS);
            input.next().addClass(UserCreationForm.HIDDEN_CSS_CLASS);
        };
        UserCreationForm.prototype.disableSaveButton = function () {
            this.saveButton.addClass(UserCreationForm.DISABLED_CSS_CLASS);
            this.saveButton.attr(UserCreationForm.DISABLED_CSS_CLASS, UserCreationForm.DISABLED_CSS_CLASS);
        };
        UserCreationForm.prototype.enableSaveButton = function () {
            this.saveButton.removeClass(UserCreationForm.DISABLED_CSS_CLASS);
            this.saveButton.removeAttr(UserCreationForm.DISABLED_CSS_CLASS);
        };
        UserCreationForm.prototype.request = function () {
            var email = this.emailInput.val();
            var input = {
                email: email,
                name: this.nameInput.val(),
                ssoId: this.ssoInput.val(),
                defaultPassword: this.defaultPasswordInput.is(':checked'),
                hasCrmAccess: this.hasCrmAccess.is(':checked'),
                roleId: this.roleInput.find('option:selected').data('role-id')
            };
            return jQuery.ajax({
                'method': 'POST',
                'url': registerUserUrl,
                'data': JSON.stringify(input),
                'contentType': 'application/json'
            });
        };
        UserCreationForm.prototype.show = function () {
            this.modalWrapper.modal('show');
        };
        UserCreationForm.HAS_ERROR_CSS_CLASS = 'has-error';
        UserCreationForm.HAS_FEEDBACK_CSS_CLASS = 'has-feedback';
        UserCreationForm.HIDDEN_CSS_CLASS = 'hidden';
        UserCreationForm.DISABLED_CSS_CLASS = 'disabled';
        UserCreationForm.EMAIL_ALREADY_IN_USE_ERROR = 4001;
        return UserCreationForm;
    }());
    var Manager = (function () {
        function Manager(wrapper) {
            this.newUserButton = wrapper.find('.ws-company-admin-user-management-new-user');
            this.userCreationForm = new UserCreationForm(wrapper.find('#userManagementCreationModal'));
            this.deleteUserButtons = wrapper.find('.ws-company-admin-user-management-delete-user');
            this.deleteUserConfirmationModal = wrapper.find('#userManagementDeletionModal');
            this.userToBeDeleted = null;
            this.salesforceToggleButtons = wrapper.find('.ws-company-admin-user-management-sales-force-enabling-button');
            this.exportUserRoleTerritoryButton = wrapper.find('#export-user-roles-territory');
            this.exportUserExportedDataButton = wrapper.find('#export-user-exported-data');
            this.exportUserSessionAndPageView = wrapper.find('#export-user-session-and-pageview');
            this.addEventListener();
            this.tabSelect();
        }
        Manager.prototype.refreshButton = function (button, sfdata) {
            var ON_CLASSES = 'fa-toggle-on on';
            var OFF_CLASSES = 'fa-toggle-off off';
            button
                .removeClass(sfdata.isAllowed ? OFF_CLASSES : ON_CLASSES)
                .addClass(sfdata.isAllowed ? ON_CLASSES : OFF_CLASSES);
        };
        Manager.prototype.requestPermissionChange = function (data) {
            var deferred = jQuery.Deferred();
            salesForcePermissionServiceUrl = salesForcePermissionServiceUrl.replace(/userEmail/, '{0}').replace(/true$/, '{1}');
            jQuery.post(String.format(salesForcePermissionServiceUrl, data.email, String(!data.isAllowed)))
                .then(function () {
                deferred.resolve();
            })
                .fail(function () {
                deferred.reject();
            });
            return deferred.promise();
        };
        Manager.prototype.addEventListener = function () {
            var _this = this;
            this.newUserButton.click(function () {
                _this.userCreationForm.show();
            });
            if (!this.salesforceToggleButtons.isEmpty()) {
                this.salesforceToggleButtons.each(function (currentButton) {
                    var $currentButton = _this.salesforceToggleButtons.eq(currentButton);
                    var LOADING_CLASS = 'fa fa-cog fa-spin disabled';
                    var data = {
                        isAllowed: $currentButton.data('user-sf-enabled'),
                        email: $currentButton.data('user-email')
                    };
                    var isRequesting = false;
                    $currentButton.click(function () {
                        if (isRequesting) {
                            return;
                        }
                        isRequesting = true;
                        var cssClass = $currentButton.attr('class');
                        $currentButton.attr('class', LOADING_CLASS);
                        if (salesForcePermissionServiceUrl !== undefined) {
                            _this.requestPermissionChange(data).then(function () {
                                data.isAllowed = !data.isAllowed;
                            }).always(function () {
                                $currentButton.attr('class', cssClass);
                                _this.refreshButton($currentButton, data);
                                isRequesting = false;
                            });
                        }
                    });
                    _this.refreshButton($currentButton, data);
                });
            }
            this.deleteUserButtons.each(function (currentButton) {
                var button = _this.deleteUserButtons.eq(currentButton);
                button.click(function () {
                    _this.userToBeDeleted = button.data('user-email');
                    _this.deleteUserConfirmationModal.find('.ws-company-admin-user-management-user-to-be-deleted').text(_this.userToBeDeleted);
                    _this.deleteUserConfirmationModal.modal('show');
                });
            });
            this.deleteUserConfirmationModal.find('.confirmation-response').click(function () {
                _this.deleteUser();
            });
            this.exportUserRoleTerritoryButton.each(function (currentButton) {
                var button = _this.exportUserRoleTerritoryButton.eq(currentButton);
                button.click(function () {
                    _this.getUserRolesAndTerritoriesCSV();
                });
            });
            this.exportUserExportedDataButton.each(function (currentButton) {
                var button = _this.exportUserExportedDataButton.eq(currentButton);
                button.click(function () {
                    _this.getUserExportedDataCSV();
                });
            });
            this.exportUserSessionAndPageView.each(function (currentButton) {
                var button = _this.exportUserSessionAndPageView.eq(currentButton);
                button.click(function () {
                    _this.getUserSessionAndPageViewCSV();
                });
            });
        };
        Manager.prototype.tabSelect = function () {
            $('.user-management-tab').on('click', function (e) {
                $(".user-management-tab").removeClass('active');
                $(e.target).addClass('active');
                if (($(e.target).text().trim() == 'Settings')) {
                    $(".user-management-reports-wrapper").addClass("hidden");
                    $(".user-management-users-wrapper").removeClass("hidden");
                }
                if (($(e.target).text().trim() == 'Reports')) {
                    $(".user-management-reports-wrapper").removeClass("hidden");
                    $(".user-management-users-wrapper").addClass("hidden");
                }
            });
        };
        Manager.prototype.deleteUser = function () {
            var _this = this;
            if (this.userToBeDeleted === null || this.userToBeDeleted === undefined) {
                return;
            }
            jQuery.ajax({
                'method': 'POST',
                'url': deleteUserUrl,
                'data': JSON.stringify(this.userToBeDeleted),
                'contentType': 'application/json'
            }).then(function () {
                location.reload();
            }).fail(function () {
                _this.deleteUserConfirmationModal.modal('hide');
                jQuery.toaster(strings.deleteUserError, '', 'danger');
            });
        };
        Manager.prototype.getUserRolesAndTerritoriesCSV = function () {
            var _this = this;
            new UserManagement.Service().getRolesAndTerritory().then(function (data) {
                var fileContents = _this.createUserRolesAndTerritoriesCSVContent(data);
                var fileName = 'WalletShare User Roles & Territories for ' + companyData.companyName + ' as of ' + new Date().toISOString().split('T')[0] + '.csv';
                var blob = new Blob([fileContents], { type: "text/plain" });
                //create temp link to send file to for dl
                var a = document.createElement("a");
                a.href = window.URL.createObjectURL(blob);
                a.setAttribute("download", fileName);
                a.setAttribute('target', '_blank');
                a.setAttribute('style', 'display:none');
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(a.href);
                document.body.removeChild(a);
            });
        };
        Manager.prototype.createUserRolesAndTerritoriesCSVContent = function (data) {
            // let csvContent = Strings.territoryRolesHeader.join(",") + "\r\n";
            var csvContent = this.getTerritoryHeader(data);
            data.forEach(function (rowArray) {
                var row = rowArray.join(",");
                csvContent += row + "\r\n";
            });
            return csvContent;
        };
        Manager.prototype.getTerritoryHeader = function (data) {
            var header = UserManagement.Strings.territoryRolesHeader.join(",");
            var maxLength = 0;
            data.forEach(function (rowArray) {
                if (rowArray.length >= maxLength)
                    maxLength = rowArray.length;
            });
            var maxTerritoryAmount = maxLength - UserManagement.Strings.territoryRolesHeader.length;
            for (var i = 1; i <= maxTerritoryAmount; i++) {
                header += ',Territory ' + i;
            }
            header += '\r\n';
            return header;
        };
        Manager.prototype.getUserExportedDataCSV = function () {
            var _this = this;
            new UserManagement.Service().getUserExportedData().then(function (data) {
                var fileContents = _this.createExportedDataCSVContent(data);
                var fileName = 'WalletShare exported data for ' + companyData.companyName + ' as of ' + new Date().toISOString().split('T')[0] + '.csv';
                var blob = new Blob([fileContents], { type: "text/plain" });
                //create temp link to send file to for dl
                var a = document.createElement("a");
                a.href = window.URL.createObjectURL(blob);
                a.setAttribute("download", fileName);
                a.setAttribute('target', '_blank');
                a.setAttribute('style', 'display:none');
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(a.href);
                document.body.removeChild(a);
            });
        };
        Manager.prototype.createExportedDataCSVContent = function (data) {
            // let csvContent = Strings.territoryRolesHeader.join(",") + "\r\n";
            var csvContent = this.getUserExportedDataHeader(data);
            data.forEach(function (rowArray) {
                var row = rowArray.join(",");
                csvContent += row + "\r\n";
            });
            return csvContent;
        };
        Manager.prototype.getUserExportedDataHeader = function (data) {
            var header = UserManagement.Strings.exportedDataHeader.join(",");
            var maxLength = 0;
            maxLength = data[0].length;
            if (maxLength > 8) {
                var maxTerritoryAmount = maxLength - UserManagement.Strings.exportedDataHeader.length + 1;
                var territoryHeader = '';
                for (var i = 1; i <= maxTerritoryAmount; i++) {
                    territoryHeader += ',Territory ' + i;
                }
                header = header.replace(",Territories", territoryHeader);
            }
            header += '\r\n';
            return header;
        };
        Manager.prototype.getUserSessionAndPageViewCSV = function () {
            var _this = this;
            new UserManagement.Service().getUserSessionAndPageView().then(function (data) {
                var fileContents = _this.createSessionAndPageViewDataCSVContent(data);
                var fileName = 'WalletShare user sessions and pageviews for ' + companyData.companyName + ' as of ' + new Date().toISOString().split('T')[0] + '.csv';
                var blob = new Blob([fileContents], { type: "text/plain" });
                //create temp link to send file to for dl
                var a = document.createElement("a");
                a.href = window.URL.createObjectURL(blob);
                a.setAttribute("download", fileName);
                a.setAttribute('target', '_blank');
                a.setAttribute('style', 'display:none');
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(a.href);
                document.body.removeChild(a);
            });
        };
        Manager.prototype.createSessionAndPageViewDataCSVContent = function (data) {
            // let csvContent = Strings.territoryRolesHeader.join(",") + "\r\n";
            var csvContent = UserManagement.Strings.userSessionAndPageViewHeader.join(",") + "\r\n";
            data.forEach(function (rowArray) {
                var row = rowArray.join(",");
                csvContent += row + "\r\n";
            });
            return csvContent;
        };
        return Manager;
    }());
    UserManagement.Manager = Manager;
})(UserManagement || (UserManagement = {}));
(function (wrapper) {
    if (wrapper.isEmpty()) {
        return;
    }
    new UserManagement.Manager(wrapper);
})($('.ws-company-admin-user-management-wrapper'));
var Analytics = (function () {
    function Analytics() {
    }
    Analytics.sendPageView = function () {
        var page = Analytics.pageUrl || location.pathname;
        var title = Analytics.pageTitle || document.title;
        var company = Analytics.company || 'company1';
        var role = Analytics.role || 'role1';
        var username = Analytics.username;
        ga('set', 'page', page);
        ga('set', 'title', title);
        ga('send', 'pageview');
        gtag('set', { 'page': page });
        gtag('set', { 'title': title });
        gtag('event', 'pageview', { 'debug_mode': true, 'page': page, 'title': title, 'company': company, 'role': role, 'username': username });
    };
    Analytics.initialize = function (key, dimensionsKeys) {
        Analytics.dimensionsKeys = dimensionsKeys;
        ga('create', key, 'auto');
    };
    Analytics.setPageUrl = function (pageUrl) {
        Analytics.pageUrl = pageUrl;
    };
    Analytics.setPageTitle = function (pageTitle) {
        Analytics.pageTitle = pageTitle;
    };
    Analytics.setRole = function (role) {
        ga('set', Analytics.dimensionsKeys.role, role);
        gtag('set', 'user_properties', { 'role': role });
        Analytics.role = role;
    };
    Analytics.setCompany = function (company) {
        ga('set', Analytics.dimensionsKeys.company, company);
        gtag('set', 'user_properties', { 'company': company });
        Analytics.company = company;
    };
    Analytics.setUser = function (user) {
        ga('set', Analytics.dimensionsKeys.user, user);
        gtag('set', { 'user': user });
        Analytics.username = user;
    };
    Analytics.event = function (category, action, label, value) {
        value = value || 1;
        ga('send', 'event', category, action, label, value);
    };
    Analytics.registerChatBotRequest = function () {
        Analytics.event(Analytics.DIVA_CATEGORY, 'click', 'User Request in chatbot');
    };
    Analytics.registerChatBotIntent = function (intent, results) {
        Analytics.event(Analytics.DIVA_CATEGORY, 'LexResult', intent, results);
    };
    Analytics.registerChatbotVoiceClicked = function () {
        Analytics.event(Analytics.DIVA_CATEGORY, 'click', 'Voice recorder used');
    };
    Analytics.registerSharedCardEvent = function () {
        Analytics.event(Analytics.CARD_MANAGEMENT_CATEGORY, 'click', 'Card view shared');
    };
    Analytics.registerRenamedCardEvent = function () {
        Analytics.event(Analytics.CARD_MANAGEMENT_CATEGORY, 'click', 'Card view renamed');
    };
    Analytics.registerCardTitleEvent = function () {
        Analytics.event(Analytics.CARD_MANAGEMENT_CATEGORY, 'keydown', 'Card renamed');
    };
    Analytics.registerCardViewLeftMenuOpenEvent = function () {
        Analytics.event(Analytics.CARD_MANAGEMENT_CATEGORY, 'click', 'Opened left menu');
    };
    Analytics.registerCardViewLeftMenuControlsSectionOpenEvent = function () {
        Analytics.event(Analytics.FILTER_CATEGORY, 'click', 'Opened controls menu');
    };
    Analytics.registerCardViewLeftMenuFiltersSectionOpenEvent = function () {
        Analytics.event(Analytics.FILTER_CATEGORY, 'click', 'Opened filters menu');
    };
    Analytics.registerCardViewLeftMenuMyViewSectionOpenEvent = function () {
        Analytics.event(Analytics.FILTER_CATEGORY, 'click', 'Opened my views menu');
    };
    Analytics.registerCardFilterAppliedEvent = function (filterName) {
        Analytics.event(Analytics.FILTER_CATEGORY, 'click', 'Filtered ' + filterName);
    };
    Analytics.registerCardParameterAppliedEvent = function (parameterName, parameterValue) {
        var label = 'Filtered ' + parameterName + ' parameter';
        if (parameterValue) {
            label += ' to ' + parameterValue;
        }
        Analytics.event(Analytics.FILTER_CATEGORY, 'click', label);
    };
    Analytics.registerCardResetEvent = function () {
        Analytics.event(Analytics.CARD_MANAGEMENT_CATEGORY, 'click', 'Card reset');
    };
    Analytics.registerCardToggleVisualizationEvent = function () {
        Analytics.event(Analytics.CARD_MANAGEMENT_CATEGORY, 'click', 'Toggle visualization');
    };
    Analytics.registerSharedCardInViewEvent = function () {
        Analytics.event(Analytics.CARD_MANAGEMENT_CATEGORY, 'click', 'Card shared in view');
    };
    Analytics.registerPublishCardEvent = function () {
        Analytics.event(Analytics.CARD_MANAGEMENT_CATEGORY, 'click', 'Card published');
    };
    Analytics.registerSaveACardCopyEvent = function () {
        Analytics.event(Analytics.CARD_MANAGEMENT_CATEGORY, 'click', 'Card copied');
    };
    Analytics.registerCardDeletionEvent = function () {
        Analytics.event(Analytics.CARD_MANAGEMENT_CATEGORY, 'click', 'Card deleted');
    };
    Analytics.registerEditedCardSavedEvent = function () {
        Analytics.event(Analytics.CARD_MANAGEMENT_CATEGORY, 'click', 'Edited card saved');
    };
    Analytics.registerNewCardSavedEvent = function () {
        Analytics.event(Analytics.CARD_MANAGEMENT_CATEGORY, 'click', 'New card saved');
    };
    Analytics.registerSharedCardSavedEvent = function () {
        Analytics.event(Analytics.CARD_MANAGEMENT_CATEGORY, 'click', 'Shared card saved');
    };
    Analytics.registerCardChangesCancellationEvent = function () {
        Analytics.event(Analytics.CARD_MANAGEMENT_CATEGORY, 'click', 'Card save changes cancellation');
    };
    Analytics.registerCardDeletionDashboard = function (cardTemplate) {
        Analytics.event(Analytics.CARD_PLACE_HOLDER_CATEGORY, 'click', cardTemplate + ' card deleted on dashboard');
    };
    Analytics.registerOpenDashBoardCardEvent = function () {
        Analytics.event(Analytics.CARD_PLACE_HOLDER_CATEGORY, 'click', 'Opened card');
    };
    Analytics.registerOpenDashBoardCardMenuEvent = function () {
        Analytics.event(Analytics.CARD_PLACE_HOLDER_CATEGORY, 'click', 'Opened card menu');
    };
    Analytics.registerLoginEvent = function () {
        Analytics.event(Analytics.GENERIC_CATEGORY, 'click', 'Login');
    };
    Analytics.registerLogoutEvent = function () {
        Analytics.event(Analytics.GENERIC_CATEGORY, 'click', 'Logout');
    };
    Analytics.registerFocusFilterUsedEvent = function () {
        Analytics.event(Analytics.FOCUS_FILTER_CATEGORY, 'click', 'Focus filter used');
    };
    Analytics.registerReorderCardEvent = function () {
        Analytics.event(Analytics.CARD_PLACE_HOLDER_CATEGORY, 'Drag and Drop', 'Reorder card');
    };
    Analytics.eventDownloadReport = function (templateName, type) {
        Analytics.event(templateName, 'Download', type);
    };
    /* Rotation Builder Events */
    Analytics.registerRotationBuilderTabEvent = function () {
        Analytics.event(Analytics.CARD_LOOP_GENERIC_CATEGORY, 'click', 'User Change tab');
    };
    Analytics.registerRotationBuilderNextButton = function () {
        Analytics.event(Analytics.CARD_LOOP_GENERIC_CATEGORY, 'click', 'User Click on next Button');
    };
    Analytics.registerRotationBuilderBackButton = function () {
        Analytics.event(Analytics.CARD_LOOP_GENERIC_CATEGORY, 'click', 'User Click on back Button');
    };
    Analytics.registerRotationBuilderSliderMenuInteraction = function () {
        Analytics.event(Analytics.CARD_LOOP_GENERIC_CATEGORY, 'click', 'User Open Slider Menu');
    };
    Analytics.registerRotationBuilderByOfficeLocation = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_1_CATEGORY, 'click', 'User selected location in by office option');
    };
    Analytics.registerRotationBuilderByOfficeFirm = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_1_CATEGORY, 'click', 'User selected firm in by office option');
    };
    Analytics.registerRotationBuilderByOfficeOffice = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_1_CATEGORY, 'click', 'User selected office in by office option');
    };
    Analytics.registerRotationBuilderByOfficeRadius = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_1_CATEGORY, 'click', 'User selected radius in by office option');
    };
    Analytics.registerRotationBuilderByLocationTerritory = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_1_CATEGORY, 'click', 'User selected territory in by location option');
    };
    Analytics.registerRotationBuilderByLocationState = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_1_CATEGORY, 'click', 'User selected state in by location option');
    };
    Analytics.registerRotationBuilderByLocationCity = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_1_CATEGORY, 'click', 'User selected city in by location option');
    };
    Analytics.registerRotationBuilderByLocationZipCode = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_1_CATEGORY, 'click', 'User selected zip code in by location option');
    };
    Analytics.registerRotationBuilderFocusChannels = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_2_CATEGORY, 'click', 'User selected channels focus');
    };
    Analytics.registerRotationBuilderFocusFirms = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_2_CATEGORY, 'click', 'User selected firms focus');
    };
    Analytics.registerRotationBuilderFocusProducts = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_2_CATEGORY, 'click', 'User selected products focus');
    };
    Analytics.registerRotationBuilderSelectionAddOfficeByMenu = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_3_CATEGORY, 'click', 'User add office by slider menu');
    };
    Analytics.registerRotationBuilderSelectionRemoveOfficeByMenu = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_3_CATEGORY, 'click', 'User remove office by slider menu');
    };
    Analytics.registerRotationBuilderSelectionFocusOfficeByMenu = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_3_CATEGORY, 'click', 'User focus office by slider menu');
    };
    Analytics.registerRotationBuilderSelectionViewByChange = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_3_CATEGORY, 'click', 'User change view by on selection step');
    };
    Analytics.registerRotationBuilderSelectionPaginationChange = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_3_CATEGORY, 'click', 'User change page on menu pagination in selection step');
    };
    Analytics.registerRotationBuilderSelectionAddOfficeByMap = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_3_CATEGORY, 'click', 'User add office by map');
    };
    Analytics.registerRotationBuilderSelectionRemoveOfficeByMap = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_3_CATEGORY, 'click', 'User remove office by map');
    };
    Analytics.registerRotationBuilderSelectionExcludeOfficeByMap = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_3_CATEGORY, 'click', 'User exclude office by map');
    };
    Analytics.registerRotationBuilderSelectionFocusOfficeByMap = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_3_CATEGORY, 'click', 'User focus office by map');
    };
    Analytics.registerRotationBuilderSelectionAnchorPointer = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_3_CATEGORY, 'click', 'User Click on Anchor Pointer');
    };
    Analytics.registerRotationBuilderSummarySortOffices = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_4_CATEGORY, 'click', 'User change the offices route');
    };
    Analytics.registerRotationBuilderSummaryRemoveOffices = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_4_CATEGORY, 'click', 'User remove office by menu on summary');
    };
    Analytics.registerRotationBuilderSummaryFocusOffices = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_4_CATEGORY, 'click', 'User focus route by menu on summary');
    };
    Analytics.registerRotationBuilderSummaryFocusOfficesByMap = function () {
        Analytics.event(Analytics.CARD_LOOP_STEP_4_CATEGORY, 'click', 'User focus office by map on summary');
    };
    /* Target Matrix */
    Analytics.registerTargetMatrixTooltipTerritoryEvent = function () {
        Analytics.event(Analytics.TARGET_MATRIX_REPORT, 'tooltip', 'User clicked on territory link tooltip');
    };
    Analytics.registerTargetMatrixTooltipAssetClassEvent = function () {
        Analytics.event(Analytics.TARGET_MATRIX_REPORT, 'tooltip', 'User clicked on asset class link tooltip');
    };
    Analytics.registerTargetMatrixTooltipChannelEvent = function () {
        Analytics.event(Analytics.TARGET_MATRIX_REPORT, 'tooltip', 'User clicked on channel link tooltip');
    };
    Analytics.registerTargetMatrixTooltipFirmEvent = function () {
        Analytics.event(Analytics.TARGET_MATRIX_REPORT, 'tooltip', 'User clicked on firm link tooltip');
    };
    Analytics.registerTargetMatrixTooltipOfficeEvent = function () {
        Analytics.event(Analytics.TARGET_MATRIX_REPORT, 'tooltip', 'User clicked on office link tooltip');
    };
    Analytics.registerTargetMatrixTooltipCategoryEvent = function () {
        Analytics.event(Analytics.TARGET_MATRIX_REPORT, 'tooltip', 'User clicked on category link tooltip');
    };
    /* Office Deep Dive Report */
    Analytics.eventOfficeDeepDiveSortByAUMGreenSpace = function () {
        Analytics.event(Analytics.OFFICE_DEEP_DIVE, 'Sort By Sales', 'AUM Green Space');
    };
    Analytics.eventOfficeDeepDiveSortByTotalAUM = function () {
        Analytics.event(Analytics.OFFICE_DEEP_DIVE, 'Sort By Sales', 'Total AUM');
    };
    Analytics.eventOfficeDeepDiveSortBySalesGreenSpace = function () {
        Analytics.event(Analytics.OFFICE_DEEP_DIVE, 'Sort By Sales', 'Sales Green Space');
    };
    Analytics.eventOfficeDeepDiveSortByTotalSales = function () {
        Analytics.event(Analytics.OFFICE_DEEP_DIVE, 'Sort By Sales', 'Total Sales');
    };
    Analytics.eventOfficeDeepDiveSeeTopAdvisors = function () {
        Analytics.event(Analytics.OFFICE_DEEP_DIVE, 'See Top Advisors', 'Advisor at this office');
    };
    Analytics.eventOfficeDeepDiveFilterByShareClassOverall = function () {
        Analytics.event(Analytics.OFFICE_DEEP_DIVE, 'Filter By Share Class', 'Overall');
    };
    Analytics.eventOfficeDeepDiveFilterByShareClassAdvisory = function () {
        Analytics.event(Analytics.OFFICE_DEEP_DIVE, 'Filter By Share Class', 'Advisory');
    };
    Analytics.eventOfficeDeepDiveFilterByShareClassBrokerage = function () {
        Analytics.event(Analytics.OFFICE_DEEP_DIVE, 'Filter By Share Class', 'Brokerage');
    };
    /* Advisor Deep Dive Report */
    Analytics.eventAdvisorDeepDiveSortByAUMGreenSpace = function () {
        Analytics.event(Analytics.ADVISOR_DEEP_DIVE, 'Sort By Sales', 'AUM Green Space');
    };
    Analytics.eventAdvisorDeepDiveSortBySalesGreenSpace = function () {
        Analytics.event(Analytics.ADVISOR_DEEP_DIVE, 'Sort By Sales', 'Sales Green Space');
    };
    Analytics.eventAdvisorDeepDiveFilterByShareClassOverall = function () {
        Analytics.event(Analytics.ADVISOR_DEEP_DIVE, 'Filter By Share Class', 'Overall');
    };
    Analytics.eventAdvisorDeepDiveFilterByShareClassAdvisory = function () {
        Analytics.event(Analytics.ADVISOR_DEEP_DIVE, 'Filter By Share Class', 'Advisory');
    };
    Analytics.eventAdvisorDeepDiveFilterByShareClassBrokerage = function () {
        Analytics.event(Analytics.ADVISOR_DEEP_DIVE, 'Filter By Share Class', 'Brokerage');
    };
    /* Office Details */
    Analytics.registerOfficeDetailsReport = function () {
        Analytics.event(Analytics.OFFICE_DETAILS, 'click', 'User open Office Details Page');
    };
    Analytics.registerOfficeDetailsCategoryProductAnalysisSubtab = function () {
        Analytics.event(Analytics.OFFICE_DETAILS_CATEGORY_TAB, 'click', 'User click on Product Analysis subtab');
    };
    Analytics.registerOfficeDetailsCategoryTopAdvisorsSubtab = function () {
        Analytics.event(Analytics.OFFICE_DETAILS_CATEGORY_TAB, 'click', 'User click on Top Advisors subtab');
    };
    Analytics.registerOfficeDetailsCategoryMenu = function (category) {
        Analytics.event(Analytics.OFFICE_DETAILS_CATEGORY_TAB, 'click', 'User change the category menu for ' + category);
    };
    Analytics.registerOfficeDetailsCategoryDetailMatchup = function (metricName) {
        Analytics.event(Analytics.OFFICE_DETAILS_CATEGORY_TAB, 'click', 'User expanded ' + metricName + ' matchup line');
    };
    Analytics.registerOfficeDetailsCategoryDetailTopAdvisorsList = function (advisorName) {
        Analytics.event(Analytics.OFFICE_DETAILS_CATEGORY_TAB, 'click', 'User expanded ' + advisorName + ' details');
    };
    Analytics.eventOfficeDetailsTabCategory = function () {
        Analytics.event(Analytics.OFFICE_DETAILS, 'Navigate to Tab', 'Category Detail');
    };
    Analytics.eventOfficeDetailsTabOfficeOverview = function () {
        Analytics.event(Analytics.OFFICE_DETAILS, 'Navigate to Tab', 'Office Overview');
    };
    Analytics.eventOfficeDetailsTabAdvisorDetail = function () {
        Analytics.event(Analytics.OFFICE_DETAILS, 'Navigate to Tab', 'Advisor Detail');
    };
    Analytics.eventOfficeDetailsFilterByTimeframePrior1Months = function () {
        Analytics.event(Analytics.OFFICE_DETAILS_OVERVIEW_TAB, 'Filter By Timeframe', 'Prior 1 months');
    };
    Analytics.eventOfficeDetailsFilterByTimeframePrior3Months = function () {
        Analytics.event(Analytics.OFFICE_DETAILS_OVERVIEW_TAB, 'Filter By Timeframe', 'Prior 3 months');
    };
    Analytics.eventOfficeDetailsFilterByTimeframePrior6Months = function () {
        Analytics.event(Analytics.OFFICE_DETAILS_OVERVIEW_TAB, 'Filter By Timeframe', 'Prior 6 months');
    };
    Analytics.eventOfficeDetailsFilterByShareClassOverall = function () {
        Analytics.event(Analytics.OFFICE_DETAILS_OVERVIEW_TAB, 'Filter By Share Class', 'Overall');
    };
    Analytics.eventOfficeDetailsFilterByShareClassAdvisory = function () {
        Analytics.event(Analytics.OFFICE_DETAILS_OVERVIEW_TAB, 'Filter By Share Class', 'Advisory');
    };
    Analytics.eventOfficeDetailsFilterByShareClassBrokerage = function () {
        Analytics.event(Analytics.OFFICE_DETAILS, 'Filter By Share Class', 'Brokerage');
    };
    Analytics.eventOfficeDetailsAdvisorPortfolioAllocation = function (category) {
        Analytics.event(Analytics.OFFICE_DETAILS, 'Open Portfolio Allocation on Advisor Detail', category);
    };
    Analytics.eventOfficeDetailsAdvisorMenu = function (advisor) {
        Analytics.event(Analytics.OFFICE_DETAILS, 'Open Advisor Detail', advisor);
    };
    Analytics.eventOfficeDetailsAdvisorCompareBy = function (compareByOption) {
        Analytics.event(Analytics.OFFICE_DETAILS, 'Change Advisor Compare By', compareByOption);
    };
    Analytics.eventOfficeDetailsAdvisorModelUsage = function (modelUsageOption) {
        Analytics.event(Analytics.OFFICE_DETAILS, 'Change Model Usage Filter', modelUsageOption);
    };
    Analytics.dimensionsKeys = null;
    Analytics.pageUrl = null;
    Analytics.pageTitle = null;
    Analytics.company = null;
    Analytics.role = null;
    Analytics.username = null;
    Analytics.GENERIC_CATEGORY = 'Generic';
    Analytics.FILTER_CATEGORY = 'Filter';
    Analytics.DOWNLOAD_CATEGORY = 'Download';
    Analytics.CARD_MANAGEMENT_CATEGORY = 'CardManagement';
    Analytics.CARD_PLACE_HOLDER_CATEGORY = 'CardPlaceholder';
    Analytics.CARD_LOOP_GENERIC_CATEGORY = 'CardLoopGeneric';
    Analytics.CARD_LOOP_STEP_1_CATEGORY = 'CardLoopStep1';
    Analytics.CARD_LOOP_STEP_2_CATEGORY = 'CardLoopStep2';
    Analytics.CARD_LOOP_STEP_3_CATEGORY = 'CardLoopStep3';
    Analytics.CARD_LOOP_STEP_4_CATEGORY = 'CardLoopStep4';
    Analytics.TARGET_MATRIX_REPORT = 'TargetMatrixReport';
    Analytics.FOCUS_FILTER_CATEGORY = 'FocusFilter';
    Analytics.OFFICE_DEEP_DIVE = 'Office Deep Dive';
    Analytics.ADVISOR_DEEP_DIVE = 'Advisor Deep Dive';
    Analytics.OFFICE_DETAILS = 'Office Details';
    Analytics.OFFICE_DETAILS_OVERVIEW_TAB = 'Office Details Overview Tab';
    Analytics.OFFICE_DETAILS_CATEGORY_TAB = 'Office Details Category Tab';
    Analytics.DIVA_CATEGORY = 'Diva Chat Bot';
    return Analytics;
}());
var UserManagement;
(function (UserManagement) {
    ;
    ;
    ;
})(UserManagement || (UserManagement = {}));
var UserManagement;
(function (UserManagement) {
    var Strings = (function () {
        function Strings() {
        }
        Strings.territoryRolesHeader = ['User Name', 'Email', 'Role', 'Created On', 'Last Login' /*,'Territory 1', 'Territory 2', 'Territory 3', 'Territory 4', 'Territory 5', 'Territory Six'*/];
        Strings.exportedDataHeader = ['User Name', 'Email Address', 'Role', 'Territories', 'Report Exported', 'Report name', 'Date Exported', 'Number of Rows'];
        Strings.userSessionAndPageViewHeader = ['Month / Year', 'Firm', 'User name', 'WalletShare Sessions', 'Walletshare Report Views', 'CRM Sessions', 'CRM Report Views'];
        return Strings;
    }());
    UserManagement.Strings = Strings;
})(UserManagement || (UserManagement = {}));
///<reference path="00.data_type.ts" />
///<reference path="03.data.ts" />
///<reference path="04.parser.ts" />
var UserManagement;
(function (UserManagement) {
    var Service = (function () {
        function Service() {
            this.data = new UserManagement.DataManager();
            this.parser = new UserManagement.Parser();
            this.placeHolderUserExportedData = [
                ['nonadmin T rowe', 'nonadmintrowe@123.com', 'Unassigned', 'BD Field Florida Central', 'BD Field Colorado', 'Deep Dive', 'Report name', '7/7/2021  9:57:48 AM', '100'],
                ['test account', 'test@tt.com', 'Unassigned', 'BD Field Florida Central', 'BD Field Colorado', 'Deep Dive', 'Rotation Builder', '7/10/2022  9:23:22 AM', '120'],
                ['T rowe non admin', 'Trowenonadmin@123.com', 'Unassigned', 'BD Field Florida Central', 'BD Field Colorado', 'Deep Dive', 'Report name', '9/7/2022  2:42:00 PM', '100'],
            ];
            this.placeHolderUserSessionsAndPageViews = [
                ['Jan 2023', 'T Rowe Price', 'nonadmintrowe@123.com', 10, 15, 3, 5,],
                ['Apr 2022', 'T Rowe Price', 'test@tt.com', 7, 15, 4, 10],
                ['May 2022', 'T Rowe Price', 'Trowenonadmin@123.com', 2, 4, 1, 2],
            ];
        }
        Service.prototype.getRolesAndTerritory = function () {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.data.getRolesAndTerritory().then(function (result) {
                deferred.resolveWith(window, [_this.parser.getRolesAndTerritory(result)]);
            });
            return promise;
        };
        Service.prototype.getUserExportedData = function () {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.data.getUserExportedData().then(function (result) {
                deferred.resolveWith(window, [_this.parser.getUserExportedData(result)]);
            });
            // deferred.resolve(this.placeHolderUserExportedData);
            return promise;
        };
        Service.prototype.getUserSessionAndPageView = function () {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.data.getUserSessionAndPageView().then(function (result) {
                deferred.resolveWith(window, [_this.parser.getUserSessionAndPageView(result)]);
            });
            // deferred.resolve(this.placeHolderUserSessionsAndPageViews);
            return promise;
        };
        return Service;
    }());
    UserManagement.Service = Service;
})(UserManagement || (UserManagement = {}));
var UserManagement;
(function (UserManagement) {
    var DataManager = (function () {
        function DataManager() {
            this.GET_ROLES_AND_TERRITORY = '/companyAdmin/getUserTerritories';
            this.GET_USER_EXPORTED_DATA = '/companyAdmin/getUserExportedData';
            this.GET_USER_SESSION_AND_PAGEVIEW = '/companyAdmin/getUserSessionAndPageViews';
        }
        DataManager.prototype.getRolesAndTerritory = function () {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('GET', this.GET_ROLES_AND_TERRITORY, null).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getUserExportedData = function () {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('GET', this.GET_USER_EXPORTED_DATA, null).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getUserSessionAndPageView = function () {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('GET', this.GET_USER_SESSION_AND_PAGEVIEW, null).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.baseAjax = function (method, url, data) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            jQuery.ajax({
                'method': method,
                'url': url,
                'data': data,
                'contentType': 'application/json',
                'dataType': 'json'
            }).then(function (data) {
                deferred.resolveWith(window, [data]);
            }, (function (error) {
                deferred.reject(window, [error]);
            }));
            return promise;
        };
        return DataManager;
    }());
    UserManagement.DataManager = DataManager;
})(UserManagement || (UserManagement = {}));
///<reference path="00.data_type.ts" />
var UserManagement;
(function (UserManagement) {
    var Parser = (function () {
        function Parser() {
        }
        Parser.prototype.getRolesAndTerritory = function (result) {
            var userRoleTerritoryList = [];
            var data = [];
            var maxTerritoryCount = 0;
            if (result.statusCode == 200) {
                var rows = result.data;
                rows.forEach(function (row) {
                    //userRoleTerritoryList.push(<UserRoleTerritory>row);
                    var territories = row.territories;
                    if ((territories != null) && (territories.length > maxTerritoryCount))
                        maxTerritoryCount = territories.length;
                });
                var cnt_1 = 0;
                rows.forEach(function (row) {
                    var territories = row.territories;
                    var info = [];
                    info[0] = row.userName;
                    info[1] = row.email;
                    info[2] = row.role;
                    info[3] = row.createdOn;
                    info[4] = row.lastLogonDate;
                    if (territories != null) {
                        for (var i = 0; i < maxTerritoryCount; i++) {
                            if (i < territories.length)
                                info[i + 5] = territories[i];
                            else
                                info[i + 5] = '';
                        }
                    }
                    else {
                        for (var i = 0; i < maxTerritoryCount; i++) {
                            info[i + 5] = '';
                        }
                    }
                    data[cnt_1] = info;
                    cnt_1++;
                });
            }
            return data;
        };
        Parser.prototype.getUserExportedData = function (result) {
            var userExportedDataList = [];
            var data = [];
            var maxTerritoryCount = 0;
            if (result.statusCode == 200) {
                var rows = result.data;
                rows.forEach(function (row) {
                    var territories = row.territories;
                    if ((territories != null) && (territories.length > maxTerritoryCount))
                        maxTerritoryCount = territories.length;
                });
                var cnt_2 = 0;
                rows.forEach(function (row) {
                    var territories = row.territories;
                    var info = [];
                    info[0] = row.userName;
                    info[1] = row.email;
                    info[2] = row.role;
                    var i = 0;
                    if (maxTerritoryCount > 0) {
                        if (territories != null) {
                            for (; i < maxTerritoryCount; i++) {
                                if (i < territories.length)
                                    info[i + 3] = territories[i];
                                else
                                    info[i + 3] = '';
                            }
                        }
                        else {
                            for (; i < maxTerritoryCount; i++) {
                                info[i + 3] = '';
                            }
                        }
                    }
                    else {
                        info[i + 3] = '';
                        i++;
                    }
                    info[i + 3] = row.reportTemplate;
                    info[i + 4] = row.reportName;
                    info[i + 5] = row.exportDate;
                    info[i + 6] = row.rows;
                    data[cnt_2] = info;
                    cnt_2++;
                });
            }
            return data;
        };
        Parser.prototype.getUserSessionAndPageView = function (result) {
            // let data: UserSessionAndPageViewData[] = []; 
            var data = [];
            if (result.statusCode == 200) {
                var rows = result.data;
                var cnt_3 = 0;
                rows.forEach(function (row) {
                    var info = [];
                    info[0] = row.monthYear;
                    info[1] = row.firm;
                    info[2] = row.userName;
                    info[3] = row.wsSessionCount;
                    info[4] = row.wsPageViewCount;
                    info[5] = row.crmSessionCount;
                    info[6] = row.crmPageViewCount;
                    data[cnt_3] = info;
                    cnt_3++;
                });
            }
            return data;
        };
        return Parser;
    }());
    UserManagement.Parser = Parser;
})(UserManagement || (UserManagement = {}));
var RoleFeatures;
(function (RoleFeatures) {
    var BaseFeaturesManager = (function () {
        function BaseFeaturesManager(wrapper) {
            this.wrapper = wrapper;
            this.saveButton = this.wrapper.find('.wallet-share-feature-save');
            this.addSaveButtonListener();
        }
        BaseFeaturesManager.prototype.addSaveButtonListener = function () {
            var _this = this;
            this.saveButton.click(function () {
                _this.clearErrors();
                if (_this.hasErrors()) {
                    _this.showErrors();
                    return;
                }
                _this.saveButton.addClass(BaseFeaturesManager.DISABLED_CSS_CLASS);
                _this.saveButton.attr(BaseFeaturesManager.DISABLED_CSS_CLASS, BaseFeaturesManager.DISABLED_CSS_CLASS);
                _this.sendSaveRequest()
                    .then(function () {
                    Kasina.messages.get().success(_this.saveButton.data('success'));
                })
                    .fail(function () {
                    Kasina.messages.get().error(_this.saveButton.data('error'));
                })
                    .always(function () {
                    _this.saveButton.removeClass(BaseFeaturesManager.DISABLED_CSS_CLASS);
                    _this.saveButton.removeAttr(BaseFeaturesManager.DISABLED_CSS_CLASS);
                });
            });
        };
        BaseFeaturesManager.prototype.sendSaveRequest = function () {
            var request = jQuery.ajax({
                'method': 'POST',
                'url': this.persistenceServiceUrl(),
                'data': JSON.stringify(this.val()),
                'contentType': 'application/json'
            });
            var deferred = jQuery.Deferred();
            request
                .then(function (response) {
                deferred.resolveWith(window, [JSON.parse(response).data]);
            })
                .fail(function () {
                deferred.reject();
            });
            return deferred.promise();
        };
        BaseFeaturesManager.DISABLED_CSS_CLASS = 'disabled';
        return BaseFeaturesManager;
    }());
    var UserFeaturesManager = (function (_super) {
        __extends(UserFeaturesManager, _super);
        function UserFeaturesManager(wrapper) {
            _super.call(this, wrapper);
        }
        UserFeaturesManager.prototype.initializeSections = function () {
            var _this = this;
            var userFilterSection = this.wrapper.find('.wallet-share-user-filter-section');
            this.userFilters = new RoleFeatures.UserFilterSection(userFilterSection);
            this.userFilters.onContextChange(function (status) {
                if (status) {
                    _this.saveButton.addClass(BaseFeaturesManager.DISABLED_CSS_CLASS);
                    _this.saveButton.attr(BaseFeaturesManager.DISABLED_CSS_CLASS, BaseFeaturesManager.DISABLED_CSS_CLASS);
                }
                else {
                    _this.saveButton.removeClass(BaseFeaturesManager.DISABLED_CSS_CLASS);
                    _this.saveButton.removeAttr(BaseFeaturesManager.DISABLED_CSS_CLASS);
                }
            });
        };
        UserFeaturesManager.prototype.persistenceServiceUrl = function () {
            return urls.saveFeatures.replace(/0/, roleFeaturesVO.userEmail);
        };
        UserFeaturesManager.prototype.clearErrors = function () {
            this.userFilters.clearError();
        };
        UserFeaturesManager.prototype.showErrors = function () {
            this.userFilters.showError();
        };
        UserFeaturesManager.prototype.hasErrors = function () {
            return this.userFilters.hasErrors();
        };
        UserFeaturesManager.prototype.val = function () {
            return {
                dimensions: this.userFilters.val()
            };
        };
        return UserFeaturesManager;
    }(BaseFeaturesManager));
    RoleFeatures.UserFeaturesManager = UserFeaturesManager;
    var UserRoleFeaturesManager = (function (_super) {
        __extends(UserRoleFeaturesManager, _super);
        function UserRoleFeaturesManager(wrapper) {
            _super.call(this, wrapper);
        }
        UserRoleFeaturesManager.prototype.initializeSections = function () {
            _super.prototype.initializeSections.call(this);
            var titleSection = this.wrapper.find('.wallet-share-role-name-form');
            var templateSection = this.wrapper.find('.wallet-share-template-section');
            var ProductSection = this.wrapper.find('.wallet-share-product-section');
            var advisorSection = this.wrapper.find('.wallet-share-advisor-template-section');
            var advisorTeamSection = this.wrapper.find('.wallet-share-advisor-team-template-section');
            var alternativesSection = this.wrapper.find('.wallet-share-alternatives-template-section');
            var biPlatformSection = this.wrapper.find('.wallet-share-bi-platform-template-section');
            this.title = new RoleFeatures.RoleTitle(titleSection);
            this.templates = new RoleFeatures.TemplateSection(templateSection);
            this.products = new RoleFeatures.ProductSection($(ProductSection.get(0)), false);
            this.resProducts = new RoleFeatures.ProductSection($(ProductSection.get(1)), true);
            this.advisorTemplate = new RoleFeatures.AdvisorTemplateSection(advisorSection);
            this.advisorTeamTemplate = new RoleFeatures.AdvisorTeamTemplateSection(advisorTeamSection);
            this.alternativesTemplate = new RoleFeatures.AlternativesTemplateSection(alternativesSection);
            this.biPlatformTemplate = new RoleFeatures.BiPlatformTemplateSection(biPlatformSection);
        };
        UserRoleFeaturesManager.prototype.clearErrors = function () {
            _super.prototype.clearErrors.call(this);
            this.templates.clearError();
            this.title.clearError();
            this.products.clearError();
        };
        UserRoleFeaturesManager.prototype.showErrors = function () {
            _super.prototype.showErrors.call(this);
            this.templates.showError();
            this.title.showError();
            this.products.showError();
        };
        UserRoleFeaturesManager.prototype.hasErrors = function () {
            return _super.prototype.hasErrors.call(this) || this.title.hasErrors() || this.templates.hasErrors() || this.products.hasErrors();
        };
        UserRoleFeaturesManager.prototype.val = function () {
            var val = _super.prototype.val.call(this);
            var tempVal = this.templates.val();
            val.roleName = this.title.val();
            val.templatesIds = tempVal.template;
            var checkIndex = val.templatesIds.indexOf(Number($('.wallet-share-template-section-list .hidden input').prop('value')));
            if (checkIndex !== -1) {
                if ($('.wallet-share-alternatives-template-section-list input').prop('checked')) {
                    $('.wallet-share-template-section-list .hidden input').prop('checked', true);
                }
                else {
                    $('.wallet-share-template-section-list .hidden input').prop('checked', false);
                    if ($('.wallet-share-alternatives-template-section-list input').prop('checked', false)) {
                        val.templatesIds.splice(checkIndex, 1);
                    }
                }
            }
            else {
                if ($('.wallet-share-alternatives-template-section-list input').prop('checked')) {
                    val.templatesIds.push(Number($('.wallet-share-template-section-list .hidden input').prop('value')));
                }
            }
            val.productsIds = this.products.val();
            val.resProductIds = this.resProducts.val(true);
            val.otherTemplateIds = this.advisorTemplate.val().concat(this.advisorTeamTemplate.val());
            val.otherTemplateIds = val.otherTemplateIds.concat(this.alternativesTemplate.val());
            val.otherTemplateIds = val.otherTemplateIds.concat(this.biPlatformTemplate.val());
            val.otherTemplateIds = val.otherTemplateIds.concat(tempVal.otherTempates);
            return val;
        };
        UserRoleFeaturesManager.prototype.persistenceServiceUrl = function () {
            return urls.saveFeatures.replace(/0/, String(roleFeaturesVO.roleId));
        };
        return UserRoleFeaturesManager;
    }(UserFeaturesManager));
    RoleFeatures.UserRoleFeaturesManager = UserRoleFeaturesManager;
})(RoleFeatures || (RoleFeatures = {}));
$(document).ready(function () {
    var featuresManager = null;
    var wrapper = null;
    wrapper = $('.wallet-share-feature-wrapper-userrole');
    if (!wrapper.isEmpty()) {
        featuresManager = new RoleFeatures.UserRoleFeaturesManager(wrapper);
    }
    wrapper = $('.wallet-share-feature-wrapper-user');
    if (!wrapper.isEmpty()) {
        featuresManager = new RoleFeatures.UserFeaturesManager(wrapper);
    }
    if (featuresManager !== null) {
        featuresManager.initializeSections();
    }
});
var RoleFeatures;
(function (RoleFeatures) {
    var UserFilterSection = (function () {
        function UserFilterSection(userFilterSection) {
            this.userFilterSection = userFilterSection;
            this.dimensionsFiltered = new Array();
            this.appliedFilterManager = new RoleFeatures.AppliedFilters(this.userFilterSection.find('.wallet-share-applied-user-filter'));
            this.dimensionDropdown = this.userFilterSection.find('.wallet-share-user-filter-dropdown');
            this.fullDimensionList = this.userFilterSection.find('.wallet-share-user-filter-dimension-list-full');
            this.customDimensionList = this.userFilterSection.find('.wallet-share-user-filter-dimension-list-custom');
            this.applyButton = this.userFilterSection.find('.wallet-share-user-filter-apply');
            this.resetButton = this.userFilterSection.find('.wallet-share-user-filter-reset');
            this.addRemoveButtonListener();
            this.addEditButtonListener();
            this.addAplyButtonListener();
            this.addResetButtonListener();
            this.creatingSortableFunctionality();
            this.createRemoveSearchInput();
            this.onContextChangeListeners = new Array();
            this.fullDimensionListArray = [];
            this.customDimensionListArray = [];
            this.workArround = true;
            this.initialLoad();
        }
        UserFilterSection.prototype.changeDropdown = function (id) {
            this.dimensionDropdown.val(String(id));
            this.dimensionDropdown.change();
        };
        UserFilterSection.prototype.createSpinner = function () {
            var wrapper = jQuery('<div/>', { 'class': 'text-center' });
            var spinner = jQuery('<i/>', { 'class': 'fa fa-cog fa-spin wallet-share-sortable-grid-spinner-list' });
            return wrapper.append(spinner);
        };
        UserFilterSection.prototype.hideDimensionLists = function (isHidden) {
            var listWrapper = this.userFilterSection.find('.wallet-share-user-filter-list');
            if (isHidden) {
                listWrapper.addClass(UserFilterSection.HIDDEN_CSS_CLASS);
            }
            else {
                listWrapper.removeClass(UserFilterSection.HIDDEN_CSS_CLASS);
            }
        };
        UserFilterSection.prototype.showSpinner = function (isHidden) {
            if (!isHidden) {
                this.dimensionDropdown.removeAttr(UserFilterSection.DISABLED_ATTR);
                this.fullDimensionList.html('');
                this.customDimensionList.html('');
            }
            else {
                this.dimensionDropdown.attr(UserFilterSection.DISABLED_ATTR, UserFilterSection.DISABLED_ATTR);
                this.fullDimensionList.append(this.createSpinner());
                this.customDimensionList.append(this.createSpinner());
            }
        };
        UserFilterSection.prototype.cleanLists = function () {
            this.fullDimensionList.html('');
            this.customDimensionList.html('');
            this.fullDimensionListArray = new Array();
            this.customDimensionListArray = new Array();
        };
        UserFilterSection.prototype.createRemoveSearchInput = function () {
            var fullSearchRemove = this.userFilterSection.find('.wallet-share-full-remove-search-user-filter');
            var customSearchRemove = this.userFilterSection.find('.wallet-share-custom-remove-search-user-filter');
            var fullInput = this.userFilterSection.find('.wallet-share-user-filter-search-full');
            var customInput = this.userFilterSection.find('.wallet-share-user-filter-search-custom');
            fullSearchRemove.click(function () {
                fullInput.val("").keyup();
            });
            customSearchRemove.click(function () {
                customInput.val("").keyup();
            });
        };
        UserFilterSection.prototype.createSearchFunctionality = function (list, optionsArray, input) {
            var _this = this;
            input.unbind();
            input.keyup(function () {
                var optionsToSearch = optionsArray;
                var filter = input.val().toLowerCase();
                optionsToSearch = optionsToSearch.filter(function (option) {
                    var name = option.formattedValue;
                    return (name.toLowerCase().indexOf(filter) !== -1);
                });
                list.html('');
                optionsToSearch.forEach(function (row) {
                    var transfer = jQuery('<span/>', { 'class': 'glyphicon glyphicon-transfer wallet-share-sortable-grid-list-transfer' });
                    transfer.click(function () {
                        _this.applyButton.removeClass(UserFilterSection.HIDDEN_CSS_CLASS);
                        var isChildOfCustomList = _this.customDimensionList.find("[data-name='" + row.formattedValue + "']").isEmpty();
                        if (!isChildOfCustomList) {
                            var element = _this.customDimensionList.find("[data-name='" + row.formattedValue + "']");
                            _this.fullDimensionList.prepend(element);
                            _this.fullDimensionList.find("[data-name='" + row.formattedValue + "']").show();
                        }
                        else {
                            var element = _this.fullDimensionList.find("[data-name='" + row.formattedValue + "']");
                            _this.customDimensionList.prepend(element);
                            _this.customDimensionListArray.push({
                                formattedValue: row.formattedValue,
                                value: row.value,
                                selected: row.selected
                            });
                            element.hide();
                            element.fadeIn(200);
                        }
                    });
                    var name = jQuery('<div/>', { 'class': 'text-overflow pull-left wallet-share-sortable-grid-list-element', 'text': row.formattedValue, 'title': row.formattedValue });
                    var li = jQuery('<li/>', { 'class': 'grabbable open-sans', 'data-id': row.value, 'data-name': row.formattedValue });
                    list.append(li.append(name, transfer));
                });
                if (!_this.customDimensionList.isEmpty()) {
                    _this.customDimensionListArray.forEach(function (customOption) {
                        _this.fullDimensionList.find("[data-name='" + customOption.formattedValue + "']").hide();
                    });
                }
            });
        };
        UserFilterSection.prototype.creatingSortableFunctionality = function () {
            var _this = this;
            var fullDimensionListSearch = this.userFilterSection.find('.wallet-share-user-filter-search-full');
            var customDimensionListSearch = this.userFilterSection.find('.wallet-share-user-filter-search-custom');
            var sortableObj = {
                containment: 'document',
                connectWith: '.wallet-share-sortable-grid-list',
                cancel: '.wallet-share-sortable-grid-spinner-list',
                update: function () {
                    _this.applyButton.removeClass(UserFilterSection.HIDDEN_CSS_CLASS);
                    _this.createSearchFunctionality(_this.fullDimensionList, _this.fullDimensionListArray, fullDimensionListSearch);
                    _this.createSearchFunctionality(_this.customDimensionList, _this.customDimensionListArray, customDimensionListSearch);
                }
            };
            this.fullDimensionList.sortable(sortableObj).disableSelection();
            this.customDimensionList.sortable(sortableObj).disableSelection();
        };
        UserFilterSection.prototype.addEditButtonListener = function () {
            var _this = this;
            this.appliedFilterManager.onEditChange(function (dimensionId) {
                _this.changeDropdown(dimensionId);
            });
        };
        UserFilterSection.prototype.addRemoveButtonListener = function () {
            var _this = this;
            this.appliedFilterManager.onRemoveChange(function (dimensionId) {
                _this.changeDropdown(UserFilterSection.DEFAULT_DROPDOWN_VALUE);
                _this.refreshDimensionOptions(dimensionId, true);
                // If an user exclude the last applied dimension, erase dimensionsFiltered and build it again [Reset behavior]
                if (_this.appliedFilterManager.isEmpty()) {
                    _this.resetButton.addClass(UserFilterSection.HIDDEN_CSS_CLASS);
                    roleFeaturesVO.savedDimensions = null;
                }
            });
        };
        UserFilterSection.prototype.addDimensionDropdownListener = function (dimensionDropdown) {
            var _this = this;
            this.dimensionDropdown.change(function () {
                // Hidden apply button
                _this.applyButton.addClass(UserFilterSection.HIDDEN_CSS_CLASS);
                var value = Number(dimensionDropdown.val());
                var text = dimensionDropdown.children(UserFilterSection.SELECTED_PROP).text();
                if (value === UserFilterSection.DEFAULT_DROPDOWN_VALUE) {
                    _this.cleanLists();
                    _this.hideDimensionLists(true);
                }
                else {
                    _this.dimensionSelected = {
                        id: value,
                        filterName: text
                    };
                    _this.buildingDimensionList(value);
                    _this.hideDimensionLists(false);
                }
            });
        };
        UserFilterSection.prototype.addAplyButtonListener = function () {
            var _this = this;
            this.applyButton.click(function () {
                _this.applyButton.addClass(UserFilterSection.HIDDEN_CSS_CLASS);
                var selectedOptions = _this.getOptionsfromList(_this.customDimensionList);
                var dimensionToAdd = {
                    dimensionId: _this.dimensionSelected.id,
                    dimensionName: _this.dimensionSelected.filterName,
                    options: selectedOptions
                };
                _this.appliedFilterManager.add(dimensionToAdd);
                // If an user exclude the last applied dimension, erase dimensionsFiltered and build it again [Reset behavior]
                if (_this.appliedFilterManager.isEmpty()) {
                    _this.resetButton.addClass(UserFilterSection.HIDDEN_CSS_CLASS);
                    roleFeaturesVO.savedDimensions = null;
                }
                else {
                    //this.refreshFilteredDimensionView();
                    _this.refreshDOM(null, true);
                }
            });
        };
        UserFilterSection.prototype.addResetButtonListener = function () {
            var _this = this;
            this.resetButton.click(function () {
                _this.resetButton.addClass(UserFilterSection.HIDDEN_CSS_CLASS);
                // Deleting all things related with applied dimension
                _this.appliedFilterManager.deleteAll();
                roleFeaturesVO.savedDimensions = null;
                /*this.getContext().success((dimensions: Array<Context.DimensionResponse>) => {
                    this.dimensionsFiltered = [];
                    this.setInitialFilteredDimension(dimensions);
                    this.buildingDimensionDropdown(dimensions);
                });*/
                _this.changeDropdown(UserFilterSection.DEFAULT_DROPDOWN_VALUE);
            });
        };
        UserFilterSection.prototype.getOptionsfromList = function (list) {
            var options = new Array();
            list.children().each(function (k, element) {
                var obj = {
                    value: Number(list.children().eq(k).data('id')),
                    formattedValue: list.children().eq(k).data('name')
                };
                options.push(obj);
            });
            return options;
        };
        UserFilterSection.prototype.creatingOptions = function (list, isCustom) {
            var currentArray = new Array();
            list.children().each(function (k, element) {
                var value = list.children().eq(k).data('id');
                var formattedValue = list.children().eq(k).data('name');
                var selected = isCustom;
                var obj = {
                    value: value,
                    formattedValue: formattedValue,
                    selected: selected
                };
                currentArray.push(obj);
            });
            return currentArray;
        };
        UserFilterSection.prototype.refreshDimensionOptions = function (dimensionId, isSelected) {
            this.dimensionsFiltered.forEach(function (dimensionFiltered) {
                if (dimensionFiltered.id === dimensionId) {
                    dimensionFiltered.options.forEach(function (currentOption) {
                        currentOption.selected = isSelected;
                    });
                }
            });
        };
        UserFilterSection.prototype.refreshFilteredDimensionData = function (dimensionResponse, selected) {
            var indexed = {};
            dimensionResponse.forEach(function (dimension) {
                var allOptions = dimension.options();
                if (dimension.isLimited()) {
                    allOptions = null;
                }
                else {
                    allOptions.forEach(function (option) {
                        option.selected = selected;
                    });
                }
                indexed[dimension.id()] = allOptions;
            });
            this.dimensionsFiltered.forEach(function (dimensionFiltered) {
                if (dimensionFiltered.options === null) {
                    dimensionFiltered.options = indexed[dimensionFiltered.id];
                }
            });
        };
        UserFilterSection.prototype.refreshFilteredDimensionView = function () {
            var _this = this;
            var currentDimensionId = this.dimensionSelected.id;
            var fullArray = this.creatingOptions(this.fullDimensionList, false);
            var customArray = this.creatingOptions(this.customDimensionList, true);
            // Not EVER replace for what's showing on the view, just replace the boolean field
            // [dimensionsFiltered] must have all Context Data, including this boolean field
            // If no options is selected, data context options must have TRUE as selected option (DEFAULT)
            if (customArray.length === 0) {
                this.refreshDimensionOptions(this.dimensionSelected.id, true);
            }
            else {
                var grouped = {};
                fullArray.forEach(function (current) {
                    var hash = currentDimensionId + current.formattedValue;
                    grouped[hash] = false;
                });
                customArray.forEach(function (current) {
                    var hash = currentDimensionId + current.formattedValue;
                    grouped[hash] = true;
                });
                this.dimensionsFiltered.forEach(function (dimensionFiltered) {
                    if (dimensionFiltered.id === _this.dimensionSelected.id) {
                        dimensionFiltered.options.forEach(function (currentOption) {
                            var hash = currentDimensionId + currentOption.formattedValue;
                            currentOption.selected = (grouped[hash]) ? true : false;
                        });
                    }
                });
            }
        };
        UserFilterSection.prototype.setInitialFilteredDimension = function (dimensionResponse) {
            var _this = this;
            var optionsGrouped = {};
            if (roleFeaturesVO.savedDimensions !== null) {
                allDimensions.forEach(function (dimension) {
                    if (roleFeaturesVO.savedDimensions[dimension.id] !== undefined) {
                        var dimensionName = dimension.filterName, dimensionId = dimension.id, savedOptions = JSON.parse(roleFeaturesVO.savedDimensions[dimensionId]);
                        var savedObj = {
                            id: dimensionId,
                            filterName: dimensionName,
                            options: savedOptions
                        };
                        optionsGrouped[dimensionId] = savedObj;
                    }
                });
            }
            dimensionResponse.forEach(function (dimension) {
                var allOptions = dimension.options();
                var index = {};
                if (optionsGrouped[dimension.id()] !== undefined) {
                    var savedDimension = optionsGrouped[dimension.id()];
                    savedDimension.options.forEach(function (current) {
                        index[dimension.id() + current.formattedValue] = true;
                    });
                    /*			if (dimension.isLimited()) {
                                    allOptions = null;
                                } else {*/
                    allOptions.forEach(function (option) {
                        option.selected = index[dimension.id() + option.formattedValue] ? true : false;
                    });
                    //}
                    // Add this dimensions as tracked
                    var dimensionToAdd = {
                        dimensionId: savedDimension.id,
                        dimensionName: savedDimension.filterName,
                        options: savedDimension.options
                    };
                    _this.appliedFilterManager.add(dimensionToAdd);
                }
                else {
                    /*if (dimension.isLimited()) {
                        allOptions = null;
                    } else {*/
                    allOptions.forEach(function (option) {
                        option.selected = true;
                    });
                }
                var obj = {
                    id: dimension.id(),
                    options: allOptions
                };
                _this.dimensionsFiltered.push(obj);
            });
        };
        UserFilterSection.prototype.getContext = function () {
            var dimensionMapped = this.dimensionsFiltered.map(function (dimension) {
                if (dimension.options) {
                    var selectedOptions = dimension.options.filter(function (options) { return options.selected; });
                    if (selectedOptions.isEmpty()) {
                        return { id: dimension.id };
                    }
                    else {
                        return {
                            id: dimension.id,
                            options: selectedOptions
                        };
                    }
                }
            });
            return Context.getOptionsFor({
                dimensions: Context.buildDimensions(dimensionMapped),
                optionsLimit: 0,
                creating: true
            });
        };
        UserFilterSection.prototype.getContextWithAllDimensions = function () {
            return Context.getOptionsFor({
                dimensions: Context.buildDimensions(allDimensions),
                optionsLimit: 0,
                creating: true
            });
        };
        UserFilterSection.prototype.buildingDimensionList = function (dimensionId) {
            var _this = this;
            this.cleanLists();
            this.showSpinner(true);
            var dimension;
            this.getContext().success(function (dimensions) {
                _this.showSpinner(false);
                dimensions.forEach(function (curr) {
                    if (curr.id() === dimensionId) {
                        dimension = curr;
                        return;
                    }
                });
                dimension.options().sort(function (curr, next) {
                    return curr.formattedValue > next.formattedValue ? 1 : -1;
                })
                    .forEach(function (row) {
                    var transfer = jQuery('<span/>', { 'class': 'glyphicon glyphicon-transfer wallet-share-sortable-grid-list-transfer' });
                    transfer.click(function () {
                        _this.applyButton.removeClass(UserFilterSection.HIDDEN_CSS_CLASS);
                        var isChildOfCustomList = _this.customDimensionList.find("[data-name='" + row.formattedValue + "']").isEmpty();
                        if (!isChildOfCustomList) {
                            var element = _this.customDimensionList.find("[data-name='" + row.formattedValue + "']");
                            _this.fullDimensionList.prepend(element);
                        }
                        else {
                            var element = _this.fullDimensionList.find("[data-name='" + row.formattedValue + "']");
                            _this.customDimensionList.prepend(element);
                            element.hide();
                            element.fadeIn(200);
                        }
                    });
                    var name = jQuery('<div/>', { 'class': 'text-overflow pull-left wallet-share-sortable-grid-list-element', 'text': row.formattedValue, 'title': row.formattedValue });
                    var li = jQuery('<li/>', { 'class': 'grabbable open-sans', 'data-id': row.value, 'data-name': row.formattedValue });
                    _this.fullDimensionList.append(li.append(name, transfer));
                    _this.fullDimensionListArray.push({
                        formattedValue: row.formattedValue,
                        value: row.value,
                        selected: row.selected
                    });
                });
                // Showing data from applied elements
                var obj = _this.appliedFilterManager.get(dimensionId);
                if (obj !== undefined) {
                    obj.options.forEach(function (option) {
                        _this.customDimensionList.append(_this.fullDimensionList.find("[data-name='" + option.formattedValue + "']"));
                        _this.customDimensionListArray.push({
                            formattedValue: option.formattedValue,
                            value: option.value,
                            selected: option.selected
                        });
                    });
                }
            });
            this.createSearchFunctionality(this.fullDimensionList, this.fullDimensionListArray, this.userFilterSection.find('.wallet-share-user-filter-search-full'));
            this.createSearchFunctionality(this.customDimensionList, this.customDimensionListArray, this.userFilterSection.find('.wallet-share-user-filter-search-custom'));
        };
        UserFilterSection.prototype.buildingDimensionDropdown = function (dimensionResponse) {
            var _this = this;
            // Cleaning...
            this.dimensionDropdown.html('');
            // Default option into select
            var defaultOption = jQuery('<option/>', { 'value': UserFilterSection.DEFAULT_DROPDOWN_VALUE, 'text': strings['selectDimensions'] });
            this.dimensionDropdown.append(defaultOption);
            var indexed = {};
            allDimensions.forEach(function (dimension) {
                indexed[dimension.id] = dimension.filterName;
            });
            dimensionResponse.forEach(function (dimension) {
                //if (!dimension.isLimited()) {
                var dimensionOption = jQuery('<option/>', { 'value': dimension.id(), 'text': indexed[dimension.id()] });
                _this.dimensionDropdown.append(dimensionOption);
                //}
            });
            if (this.workArround) {
                this.addDimensionDropdownListener(this.dimensionDropdown);
                this.workArround = false;
            }
            this.dimensionDropdown.removeAttr(UserFilterSection.DISABLED_ATTR);
        };
        UserFilterSection.prototype.refreshDOM = function (dimensionsResponse, selected) {
            var _this = this;
            this.userFilterSection.find('.wallet-share-user-filter-initial-spinner').show();
            this.dimensionDropdown.attr(UserFilterSection.DISABLED_ATTR, UserFilterSection.DISABLED_ATTR);
            this.resetButton.addClass(UserFilterSection.HIDDEN_CSS_CLASS);
            this.applyButton.addClass(UserFilterSection.HIDDEN_CSS_CLASS);
            this.hideDimensionLists(true);
            this.triggerContextChange(true);
            if (dimensionsResponse === null) {
                this.getContext().success(function (dimensions) {
                    _this.refreshDimensions(dimensions, selected);
                });
            }
            else {
                this.refreshDimensions(dimensionsResponse, selected);
            }
        };
        UserFilterSection.prototype.refreshDimensions = function (dimensions, selected) {
            var _this = this;
            this.triggerContextChange(false);
            // Context Result Set could contains different elements from applied dimension, so a refresh is necessary
            dimensions.forEach(function (dimension) {
                var dimensionId = dimension.id();
                var options = dimension.options();
                _this.appliedFilterManager.refresh(dimensionId, options);
            });
            this.refreshFilteredDimensionData(dimensions, selected);
            this.buildingDimensionDropdown(dimensions);
            this.userFilterSection.find('.wallet-share-user-filter-initial-spinner').hide();
            this.dimensionDropdown.removeAttr(UserFilterSection.DISABLED_ATTR);
            if (!this.dimensionSelected === undefined) {
                this.hideDimensionLists(false);
            }
            if (this.appliedFilterManager.isEmpty()) {
                this.resetButton.addClass(UserFilterSection.HIDDEN_CSS_CLASS);
            }
            else {
                this.resetButton.removeClass(UserFilterSection.HIDDEN_CSS_CLASS);
            }
        };
        UserFilterSection.prototype.initialLoad = function () {
            var _this = this;
            this.getContextWithAllDimensions().success(function (dimensions) {
                _this.setInitialFilteredDimension(dimensions);
                _this.refreshDOM(dimensions, false);
            });
        };
        UserFilterSection.prototype.val = function () {
            return this.appliedFilterManager.val();
        };
        UserFilterSection.prototype.hasErrors = function () {
            return false;
        };
        UserFilterSection.prototype.clearError = function () { };
        UserFilterSection.prototype.showError = function () { };
        UserFilterSection.prototype.onContextChange = function (changeHandler) {
            this.onContextChangeListeners.push(changeHandler);
        };
        UserFilterSection.prototype.triggerContextChange = function (status) {
            for (var i = 0; i < this.onContextChangeListeners.length; i++) {
                this.onContextChangeListeners[i].call(this, status);
            }
        };
        UserFilterSection.DEFAULT_DROPDOWN_VALUE = 0;
        UserFilterSection.HIDDEN_CSS_CLASS = 'hidden';
        UserFilterSection.DISABLED_ATTR = 'disabled';
        UserFilterSection.SELECTED_ATTR = 'selected';
        UserFilterSection.SELECTED_PROP = ':selected';
        return UserFilterSection;
    }());
    RoleFeatures.UserFilterSection = UserFilterSection;
})(RoleFeatures || (RoleFeatures = {}));
var RoleFeatures;
(function (RoleFeatures) {
    var DataType;
    (function (DataType) {
        DataType[DataType["TEMPLATE"] = 0] = "TEMPLATE";
    })(DataType || (DataType = {}));
    var TemplateSection = (function () {
        function TemplateSection(templateSection) {
            this.templateSection = templateSection;
            this.templatesCheckBoxes = new Array();
            this.buildersTemplatesCheckBoxes = new Array();
            this.factSheetPDFCheckBoxes = new Array();
            this.initializeDOM();
        }
        TemplateSection.prototype.initializeDOM = function () {
            var self = this;
            var columnsArray = new Array();
            var totalElements = Object.keys(roleFeaturesVO.templates).length;
            var factSheetPDF = Object.keys(roleFeaturesVO.officeFactSheetTemplate).length;
            totalElements += factSheetPDF;
            var columnSize = Math.ceil(totalElements / TemplateSection.COLUMN_ELEMENTS_SIZE);
            for (var i = 0; i < columnSize; i++) {
                columnsArray.push(jQuery('<div/>', { 'class': 'col-md-3' }));
            }
            var insertedControlObj = {
                insertedControl: 0,
                indexColumnPosition: 0
            };
            var templataData = {
                fullData: roleFeaturesVO.templates,
                savedData: roleFeaturesVO.savedTemplates,
                savedOtherTemplates: roleFeaturesVO.savedOtherTemplateProducts
            };
            var officeFactSheetData = roleFeaturesVO.officeFactSheetTemplate;
            insertedControlObj = this.createCheckbox(templataData, columnsArray, insertedControlObj, officeFactSheetData);
            columnsArray.forEach(function (current) {
                self.templateSection.find('.wallet-share-template-section-list').append(current);
            });
            this.addButtonsEventListener();
        };
        TemplateSection.prototype.createCheckbox = function (data, columnsArray, control, officeFactSheetData) {
            var self = this;
            var indexed = {};
            var othertemplateIndexed = {};
            data.savedData.forEach(function (curr) {
                indexed[curr] = true;
            });
            data.savedOtherTemplates.forEach(function (curr) {
                othertemplateIndexed[curr] = true;
            });
            Object.keys(data.fullData).forEach(function (index) {
                var i = Number(index);
                var checked = Boolean(indexed[i]);
                var checkbox = jQuery('<input/>', {
                    'type': 'checkbox',
                    'name': TemplateSection.CHECKBOX_TEMPLATE_NAME,
                    'value': index,
                    'checked': checked
                });
                var label = jQuery('<span/>', { 'text': " " + data.fullData[i], 'title': data.fullData[i] });
                var br = jQuery('<br>');
                label.click(function () {
                    checkbox.prop(TemplateSection.CHECKED_ATTR, !checkbox.prop(TemplateSection.CHECKED_ATTR));
                }).disableSelection();
                var elementWrapper = jQuery('<div/>', { 'class': 'text-overflow' });
                elementWrapper.append(checkbox, label, br);
                if (data.fullData[i] === 'Alternatives') {
                    elementWrapper.addClass('hidden');
                }
                columnsArray[control.indexColumnPosition].append(elementWrapper);
                control.insertedControl++;
                if (control.insertedControl === TemplateSection.COLUMN_ELEMENTS_SIZE) {
                    control.insertedControl = 0;
                    control.indexColumnPosition++;
                }
                self.templatesCheckBoxes.push(checkbox);
            });
            //insert office fact sheet PDF checkbox
            var currentId = officeFactSheetData[0].templateProductId;
            var checked = Boolean(othertemplateIndexed[currentId]);
            var checkbox = jQuery('<input/>', {
                'type': 'checkbox',
                'name': TemplateSection.CHECKBOX_TEMPLATE_NAME,
                'value': currentId,
                'checked': checked
            });
            var label = jQuery('<span/>', {
                'text': " " + officeFactSheetData[0].name,
                'title': officeFactSheetData[0].name
            });
            var br = jQuery('<br>');
            label.click(function () {
                checkbox.prop(TemplateSection.CHECKED_ATTR, !checkbox.prop(TemplateSection.CHECKED_ATTR));
            }).disableSelection();
            var elementWrapper = jQuery('<div/>', { 'class': 'text-overflow' });
            elementWrapper.append(checkbox, label, br);
            columnsArray[control.indexColumnPosition - 1].append(elementWrapper);
            self.factSheetPDFCheckBoxes.push(checkbox);
            return control;
        };
        TemplateSection.prototype.addButtonsEventListener = function () {
            var selectAll = this.templateSection.find('.wallet-share-select-all-custom');
            var selectNone = this.templateSection.find('.wallet-share-select-none-custom');
            var self = this;
            selectAll.click(function () {
                self.templatesCheckBoxes.forEach(function (checkbox) {
                    checkbox.prop(TemplateSection.CHECKED_ATTR, true);
                });
                self.factSheetPDFCheckBoxes.forEach(function (checkbox) {
                    checkbox.prop(TemplateSection.CHECKED_ATTR, true);
                });
            });
            selectNone.click(function () {
                self.templatesCheckBoxes.forEach(function (checkbox) {
                    checkbox.prop(TemplateSection.CHECKED_ATTR, false);
                });
                self.factSheetPDFCheckBoxes.forEach(function (checkbox) {
                    checkbox.prop(TemplateSection.CHECKED_ATTR, false);
                });
            });
        };
        TemplateSection.prototype.singleVal = function (checkboxes) {
            var checkboxArray = new Array();
            checkboxes.forEach(function (checkbox) {
                if (checkbox.is(TemplateSection.CHECKED_PROP)) {
                    checkboxArray.push(Number(checkbox.val()));
                }
            });
            return checkboxArray;
        };
        TemplateSection.prototype.val = function () {
            var arrayToSave = {
                template: null,
                otherTempates: null
            };
            arrayToSave.template = this.singleVal(this.templatesCheckBoxes);
            arrayToSave.otherTempates = new Array();
            this.factSheetPDFCheckBoxes.forEach(function (checkbox, index) {
                if (checkbox.is(TemplateSection.NOT_CHECKED_PROP)) {
                    var arrayValtoSave = new Array();
                    //add product name to sub array
                    var productName = checkbox.siblings('span').text().trim();
                    arrayValtoSave.push(productName);
                    //add to return array
                    arrayToSave.otherTempates.push(arrayValtoSave);
                }
            });
            return arrayToSave;
        };
        TemplateSection.prototype.hasErrors = function () {
            return false;
        };
        TemplateSection.prototype.clearError = function () {
        };
        TemplateSection.prototype.showError = function () {
        };
        TemplateSection.COLUMN_ELEMENTS_SIZE = 4;
        TemplateSection.CHECKBOX_TEMPLATE_NAME = "template";
        TemplateSection.CHECKED_ATTR = 'checked';
        TemplateSection.CHECKED_PROP = ':checked';
        TemplateSection.NOT_CHECKED_PROP = ':not(:checked)';
        return TemplateSection;
    }());
    RoleFeatures.TemplateSection = TemplateSection;
})(RoleFeatures || (RoleFeatures = {}));
var RoleFeatures;
(function (RoleFeatures) {
    var ProductOption = (function () {
        function ProductOption() {
        }
        return ProductOption;
    }());
    RoleFeatures.ProductOption = ProductOption;
    var ProductSection = (function () {
        function ProductSection(ProductSection, resProducts) {
            this.COLUMN_ELEMENTS_SIZE = 2;
            this.CHECKED_ATTR = 'checked';
            this.CHECKED_PROP = ':checked';
            this.productSection = ProductSection;
            this.checkBoxes = new Array();
            this.initializeDOM(resProducts);
        }
        //creates all checkboxes needed for the research/resource centers role permission, based on what's available to the user's company
        ProductSection.prototype.initializeDOM = function (resProducts) {
            var _this = this;
            var products = [];
            //separate objects for resource center permissions
            if (resProducts) {
                products = roleFeaturesVO.resProducts;
            }
            else {
                products = roleFeaturesVO.products;
            }
            var self = this, columnsArray = new Array(), columnSize = Math.ceil(products.length / this.COLUMN_ELEMENTS_SIZE);
            for (var i = 0; i < columnSize; i++) {
                columnsArray.push(jQuery('<div/>', { 'class': 'col-md-3' }));
            }
            var control = 0, indexColumnPosition = 0, indexed = {};
            if (resProducts && roleFeaturesVO.savedResProducts) {
                roleFeaturesVO.savedResProducts.forEach(function (curr) {
                    indexed[curr] = true;
                });
            }
            else {
                roleFeaturesVO.savedProducts.forEach(function (curr) {
                    indexed[curr] = true;
                });
            }
            this.productOptions = new Array();
            products.forEach(function (current, index) {
                var currentId = current.id;
                var currentName = resProducts ? current.name : current.fullName;
                //create product checkboxes
                var checked = indexed[currentId] ? true : false, checkbox = jQuery('<input/>', {
                    'type': 'checkbox',
                    'name': 'product',
                    'value': currentId,
                    'checked': checked
                }), productLabel = jQuery('<span/>', { 'text': " " + currentName, 'title': currentName }), br = jQuery('<br>'), elementWrapper = jQuery('<div/>', { 'class': 'text-overflow', 'id': 'products_' + currentId });
                //append allProduct
                elementWrapper.append(checkbox, productLabel, br);
                if (!resProducts) {
                    var radiosWrapper = jQuery('<div/>', { 'class': 'products-options', 'id': 'products_' + currentId }), radios = new Array(), saverPermissionProduct = roleFeaturesVO.savedPermissionProducts[currentId] ? true : false, selectedRadioId = productPermissionDefault;
                    if (saverPermissionProduct) {
                        selectedRadioId = roleFeaturesVO.savedPermissionProducts[currentId];
                    }
                    //create article permission checkboxes
                    roleFeaturesVO.articlePermissions.forEach(function (currentPermission) {
                        var checkedRadio = false;
                        if (selectedRadioId === currentPermission.id) {
                            checkedRadio = true;
                        }
                        var inputRadio = jQuery('<input/>', {
                            'type': 'radio',
                            'name': currentId,
                            'class': 'radio-button-margin',
                            'value': currentPermission.id,
                            'checked': checkedRadio
                        });
                        radiosWrapper.append(inputRadio);
                        radiosWrapper.append(jQuery('<span/>', {
                            'text': ' ' + currentPermission.permissionRoleName,
                            'title': currentPermission.permissionRoleName
                        }));
                        radiosWrapper.append(jQuery('<br>'));
                        radios.push(inputRadio);
                    });
                    if (!checked) {
                        _this.updateProductsOptionsVisibility(radiosWrapper, checked);
                    }
                }
                //append Product Option
                elementWrapper.append(radiosWrapper);
                columnsArray[indexColumnPosition].append(elementWrapper);
                control++;
                if (control === self.COLUMN_ELEMENTS_SIZE) {
                    control = 0;
                    indexColumnPosition++;
                }
                var currentProductOption = new ProductOption();
                currentProductOption.productId = currentId;
                currentProductOption.option = radios;
                self.productOptions.push(currentProductOption);
                self.checkBoxes.push(checkbox);
            });
            columnsArray.forEach(function (current) {
                self.productSection.find('.wallet-share-product-section-list').append(current);
            });
            this.addButtonsEventListener();
        };
        ProductSection.prototype.addButtonsEventListener = function () {
            var _this = this;
            var selectAll = this.productSection.find('.wallet-share-select-all-custom'), selectNone = this.productSection.find('.wallet-share-select-none-custom');
            var self = this;
            selectAll.click(function () {
                self.checkBoxes.forEach(function (checkbox) {
                    checkbox.prop('checked', true);
                    checkbox.change();
                });
            });
            selectNone.click(function () {
                self.checkBoxes.forEach(function (checkbox) {
                    checkbox.prop('checked', false);
                    checkbox.change();
                });
            });
            self.checkBoxes.forEach(function (checkbox) {
                checkbox.change(function (checkboxId) {
                    var checkboxSelected = _this.productSection.find('#products_' + checkbox.prop('value') + ' .products-options ');
                    _this.updateProductsOptionsVisibility(checkboxSelected, checkbox.prop('checked'));
                });
            });
        };
        ProductSection.prototype.updateProductsOptionsVisibility = function (divOptions, checked) {
            if (checked) {
                divOptions.removeClass('hidden');
            }
            else {
                divOptions.addClass(' hidden');
            }
        };
        //returns array of each research/resource product selected and what articles user has access to
        ProductSection.prototype.val = function (resProducts) {
            var self = this;
            var arrayToSave = new Array();
            if (resProducts) {
                this.checkBoxes.forEach(function (checkbox, index) {
                    //if resource product is selected
                    if (checkbox.is(self.CHECKED_PROP)) {
                        var arrayValtoSave = new Array();
                        //add product name to sub array
                        var productName = checkbox.siblings('span').text().trim();
                        arrayValtoSave.push(productName);
                        //add to return array
                        arrayToSave.push(arrayValtoSave);
                    }
                });
            }
            else {
                this.checkBoxes.forEach(function (checkbox, index) {
                    if (checkbox.is(self.CHECKED_PROP)) {
                        var arrayValtoSave = new Array();
                        //add product id to sub array
                        arrayValtoSave.push(Number(checkbox.val()));
                        //add article permission value to sub array
                        self.productOptions[index].option.forEach(function (radio) {
                            if (radio.is(self.CHECKED_PROP)) {
                                arrayValtoSave.push(Number(radio.val()));
                            }
                        });
                        arrayToSave.push(arrayValtoSave);
                    }
                });
            }
            return arrayToSave;
        };
        ProductSection.prototype.hasErrors = function () {
            return false;
        };
        ProductSection.prototype.clearError = function () {
        };
        ProductSection.prototype.showError = function () {
        };
        return ProductSection;
    }());
    RoleFeatures.ProductSection = ProductSection;
})(RoleFeatures || (RoleFeatures = {}));
var RoleFeatures;
(function (RoleFeatures) {
    var AppliedFilters = (function () {
        function AppliedFilters(appliedFilterSection) {
            this.appliedFilterSection = appliedFilterSection;
            this.appliedElements = new Array();
            this.onRemoveChangeListeners = new ListenersCollection();
            this.onEditChangeListeners = new ListenersCollection();
        }
        AppliedFilters.prototype.addEditButtonListerner = function (editIcon, dimensionId) {
            var _this = this;
            editIcon.click(function () {
                _this.triggerEditChange(dimensionId);
            });
        };
        AppliedFilters.prototype.addRemoveButtonListerner = function (removeIcon, dimensionId) {
            var _this = this;
            removeIcon.click(function () {
                _this.delete(dimensionId);
                _this.createBoxes();
                _this.triggerRemoveChange(dimensionId);
            });
        };
        AppliedFilters.prototype.createBoxes = function () {
            var self = this;
            // Cleaning...
            this.appliedFilterSection.html('');
            // Sorting...
            this.appliedElements.sort(function (a, b) {
                return (a.dimensionId > b.dimensionId) ? 1 : -1;
            });
            this.appliedElements.forEach(function (element) {
                var wrapper = jQuery('<div/>', { 'class': 'col-md-3 col-sm-3' });
                var ul = jQuery('<ul/>', { 'class': 'wallet-share-applied-box' });
                var removeIcon = jQuery('<span/>', { 'class': 'glyphicon glyphicon-remove wallet-share-applied-element-remove' });
                var editIcon = jQuery('<span/>', { 'class': 'glyphicon glyphicon-pencil wallet-share-applied-element-edit' });
                var dimensionName = jQuery('<b/>', { 'text': element.dimensionName });
                var dimensionNameWrapper = jQuery('<span/>', { 'class': '' });
                var optionsLength = jQuery('<span/>', { 'class': '', 'text': element.options.length + ' ' + strings['optionsLabel'] });
                var firstLine = jQuery('<div/>', { 'class': 'wallet-share-applied-first' });
                var secondLine = jQuery('<div/>', { 'class': 'wallet-share-applied-second' });
                firstLine.append(dimensionNameWrapper.append(dimensionName), removeIcon);
                secondLine.append(optionsLength, editIcon);
                ul.append(firstLine, secondLine);
                self.addRemoveButtonListerner(removeIcon, element.dimensionId);
                self.addEditButtonListerner(editIcon, element.dimensionId);
                self.appliedFilterSection.append(wrapper.append(ul));
            });
        };
        AppliedFilters.prototype.delete = function (dimensionId) {
            this.appliedElements.remove(function (element) {
                return element.dimensionId === dimensionId;
            });
        };
        AppliedFilters.prototype.deleteAll = function () {
            this.appliedElements = new Array();
            this.createBoxes();
        };
        AppliedFilters.prototype.exists = function (dimensionId) {
            return this.appliedElements.some(function (curr) {
                return curr.dimensionId === dimensionId;
            });
        };
        AppliedFilters.prototype.get = function (dimensionId) {
            var elementObj;
            this.appliedElements.forEach(function (element) {
                if (element.dimensionId === dimensionId) {
                    elementObj = element;
                }
            });
            return elementObj;
        };
        AppliedFilters.prototype.refresh = function (dimensionId, options) {
            if (!this.exists(dimensionId)) {
                return;
            }
            // For security, do not change all options, applied dimension must have ONLY the options chosen or less.
            var indexed = {};
            var optionsToRefresh = this.get(dimensionId).options;
            optionsToRefresh.forEach(function (option) {
                indexed[option.formattedValue] = true;
            });
            this.appliedElements.forEach(function (element) {
                if (element.dimensionId === dimensionId) {
                    var optionsToReplace = [];
                    options.forEach(function (option) {
                        if (indexed[option.formattedValue] !== undefined) {
                            optionsToReplace.push(option);
                        }
                    });
                    element.options = optionsToReplace;
                }
            });
            this.createBoxes();
        };
        AppliedFilters.prototype.add = function (dimension) {
            var self = this;
            var elements = dimension.options;
            if (dimension.options.isEmpty()) {
                if (this.exists(dimension.dimensionId)) {
                    self.delete(dimension.dimensionId);
                }
            }
            else {
                // If already exists, replace the elements, if not, create a new one
                if (this.exists(dimension.dimensionId)) {
                    this.appliedElements.forEach(function (element) {
                        if (element.dimensionId === dimension.dimensionId) {
                            element.options = dimension.options;
                        }
                    });
                }
                else {
                    this.appliedElements.push(dimension);
                }
            }
            this.createBoxes();
        };
        AppliedFilters.prototype.val = function () {
            var arrayToSave = new Array();
            this.appliedElements.forEach(function (element) {
                var dimensionObj = {
                    id: element.dimensionId,
                    options: element.options
                };
                arrayToSave.push(dimensionObj);
            });
            return arrayToSave;
        };
        AppliedFilters.prototype.size = function () {
            return this.appliedElements.length;
        };
        AppliedFilters.prototype.isEmpty = function () {
            return this.appliedElements.isEmpty();
        };
        AppliedFilters.prototype.onRemoveChange = function (changeHandler) {
            this.onRemoveChangeListeners.addEventListener(changeHandler);
        };
        AppliedFilters.prototype.triggerRemoveChange = function (dimensionId) {
            this.onRemoveChangeListeners.execute(this, [dimensionId]);
        };
        AppliedFilters.prototype.onEditChange = function (changeHandler) {
            this.onEditChangeListeners.addEventListener(changeHandler);
        };
        AppliedFilters.prototype.triggerEditChange = function (dimensionId) {
            this.onEditChangeListeners.execute(this, [dimensionId]);
        };
        return AppliedFilters;
    }());
    RoleFeatures.AppliedFilters = AppliedFilters;
})(RoleFeatures || (RoleFeatures = {}));
var RoleFeatures;
(function (RoleFeatures) {
    var RoleTitle = (function () {
        function RoleTitle(titleForm) {
            this.titleForm = titleForm;
            this.titleInput = titleForm.find('.wallet-share-role-name-input');
        }
        RoleTitle.prototype.val = function () {
            var title = this.titleInput.val();
            title = title.trim();
            if (title.isEmpty()) {
                return null;
            }
            return title;
        };
        RoleTitle.prototype.hasErrors = function () {
            return this.val() === null;
        };
        RoleTitle.prototype.clearError = function () {
            this.titleForm.removeClass(RoleTitle.ERROR_CSSCLASS);
        };
        RoleTitle.prototype.showError = function () {
            if (this.hasErrors()) {
                this.titleForm.addClass(RoleTitle.ERROR_CSSCLASS);
            }
        };
        RoleTitle.ERROR_CSSCLASS = 'has-error';
        return RoleTitle;
    }());
    RoleFeatures.RoleTitle = RoleTitle;
})(RoleFeatures || (RoleFeatures = {}));
var TerritoryDivision;
(function (TerritoryDivision) {
    var DELETED = 'PROCESSING_TO_REMOVE';
    var TerritoryDivisionManager = (function () {
        function TerritoryDivisionManager(wrapper) {
            this.HAS_ERROR_CSS_CLASS = 'has-error';
            this.HIDDEN_CSS_CLASS = 'hidden';
            this.DISABLED_ATTR = 'disabled';
            this.INVALID_TITLE_ERROR = 1001;
            this.wrapper = wrapper;
            this.inputName = this.wrapper.find('.wallet-share-territory-division-input-name');
            this.cancelButton = this.wrapper.find('.wallet-share-territory-division-cancel');
            this.saveButton = this.wrapper.find('.wallet-share-territory-division-save');
            this.deleteModal = this.wrapper.find('#divisionDeleteModal');
            this.divisionIdDeletionTrack = 0;
            this.divisionIdCreationTrack = 0;
            this.sortableGrid = new WalletShareUtils.SortableGrid(this.wrapper.find('.wallet-share-territory-division-sortable-grid'));
            this.initialize();
            this.addEventListener();
        }
        TerritoryDivisionManager.prototype.validateData = function (data) {
            this.sortableGrid.showError(false);
            this.inputName.parent().removeClass(this.HAS_ERROR_CSS_CLASS);
            if (data.divisionName === '') {
                this.inputName.parent().addClass(this.HAS_ERROR_CSS_CLASS);
            }
            if (data.options.isEmpty()) {
                this.sortableGrid.showError(true);
            }
            if (data.divisionName === '' || data.options.isEmpty()) {
                return false;
            }
            return true;
        };
        TerritoryDivisionManager.prototype.addEventListener = function () {
            var self = this;
            // Save event
            this.saveButton.click(function () {
                var data = {
                    divisionName: self.inputName.val(),
                    divisionId: self.divisionIdCreationTrack,
                    options: self.sortableGrid.getOptionsFromCustomList(),
                };
                if (!self.validateData(data)) {
                    return;
                }
                self.saveButton.attr(self.DISABLED_ATTR, self.DISABLED_ATTR);
                jQuery.ajax({
                    'method': 'POST',
                    'url': urls.persist,
                    'data': JSON.stringify(data),
                    'contentType': 'application/json'
                }).then(function (result) {
                    location.href = urls.divisionPage;
                }).fail(function (response) {
                    var codeError = JSON.parse(response.responseText).errors.first();
                    if (codeError === self.INVALID_TITLE_ERROR) {
                        Kasina.messages.get().error(self.saveButton.data('error-duplicated-name'));
                    }
                    else {
                        Kasina.messages.get().error(self.saveButton.data('error'));
                    }
                    self.saveButton.removeAttr(self.DISABLED_ATTR);
                });
            });
            // New Button Event
            this.cancelButton.click(function () {
                self.cancelButton.addClass(self.HIDDEN_CSS_CLASS);
                self.divisionIdCreationTrack = 0;
                self.inputName.val('');
                self.availableTerritoriesRequest().then(function (result) {
                    self.sortableGrid.feed(result, null);
                });
            });
            // Delete Modal Event
            var modalButton = this.deleteModal.find('.confirmation-response');
            modalButton.click(function () {
                jQuery.ajax({
                    'method': 'POST',
                    'url': urls.deleteDivision.replace('0', String(self.divisionIdDeletionTrack)),
                }).then(function () {
                    location.href = urls.divisionPage;
                });
            });
        };
        TerritoryDivisionManager.prototype.deleteListener = function (deleteIcon, divisionId) {
            var self = this;
            deleteIcon.click(function () {
                self.deleteModal.modal('show');
                self.divisionIdDeletionTrack = divisionId;
            });
        };
        TerritoryDivisionManager.prototype.editListener = function (editIcon, divisionId, divisionName, options) {
            var self = this;
            editIcon.click(function () {
                self.cancelButton.removeClass(self.HIDDEN_CSS_CLASS);
                self.divisionIdCreationTrack = divisionId;
                self.inputName.val(divisionName);
                self.availableTerritoriesRequest().then(function (result) {
                    self.sortableGrid.feed(result, options);
                });
            });
        };
        TerritoryDivisionManager.prototype.availableTerritoriesRequest = function () {
            var deferred = jQuery.Deferred();
            var self = this;
            jQuery.ajax({
                'method': 'POST',
                'url': urls.availableTerritories.replace('0', String(self.divisionIdCreationTrack)),
            }).then(function (result) {
                deferred.resolveWith(window, [result]);
            });
            return deferred.promise();
        };
        TerritoryDivisionManager.prototype.initializeCreatedDivisions = function () {
            var createdWrapper = this.wrapper.find('.wallet-share-territory-division-created-divisions');
            var self = this;
            createdDivisions.forEach(function (currentDivision) {
                var options = JSON.parse(currentDivision.options);
                if (currentDivision.status !== DELETED) {
                    var box = jQuery('<div/>', { 'class': 'col-md-4 col-sm-4' });
                    var ul = jQuery('<ul/>', { 'class': 'wallet-share-territory-division-created-divisions-box' });
                    var firstLine = jQuery('<div/>', { 'class': 'wallet-share-territory-division-created-divisions-box-first' });
                    var fisrtSpan = jQuery('<span/>', { 'class': 'wallet-share-territory-division-created-divisions-box-name', 'text': currentDivision.name });
                    var deleteIcon = jQuery('<span/>', { 'class': 'wallet-share-territory-division-created-divisions-box-cursor glyphicon glyphicon-remove pull-right' });
                    firstLine.append(fisrtSpan, deleteIcon);
                    var secondLine = jQuery('<div/>', { 'class': '' });
                    var secondSpan = jQuery('<span/>', { 'text': options.length + ' ' + strings['optionsLabel'] });
                    var editIcon = jQuery('<span/>', { 'class': 'wallet-share-territory-division-created-divisions-box-cursor glyphicon glyphicon-pencil pull-right' });
                    secondLine.append(secondSpan, editIcon);
                    var statusLine = jQuery('<div/>', { 'class': 'wallet-share-territory-division-created-divisions-box-status' });
                    var statusSpan = jQuery('<span/>', { 'text': strings[currentDivision.status] });
                    statusLine.append(statusSpan);
                    ul.append(firstLine, secondLine, statusLine);
                    box.append(ul);
                    createdWrapper.append(box);
                    self.deleteListener(deleteIcon, currentDivision.divisionId);
                    self.editListener(editIcon, currentDivision.divisionId, currentDivision.name, options);
                }
            });
        };
        TerritoryDivisionManager.prototype.initialize = function () {
            var self = this;
            this.availableTerritoriesRequest().then(function (result) {
                self.sortableGrid.feed(result, null);
                self.initializeCreatedDivisions();
            });
        };
        return TerritoryDivisionManager;
    }());
    TerritoryDivision.TerritoryDivisionManager = TerritoryDivisionManager;
})(TerritoryDivision || (TerritoryDivision = {}));
$(document).ready(function () {
    var wrapper = $('.wallet-share-territory-division-wrapper');
    if (wrapper.isEmpty()) {
        return;
    }
    new TerritoryDivision.TerritoryDivisionManager(wrapper);
});
var TemplatesManagement;
(function (TemplatesManagement) {
    var DimensionCheckbox = (function () {
        function DimensionCheckbox(name, id, selected) {
            this.name = name;
            this.id = id;
            this.selected = selected;
            this.initialize();
            this.addEventListeners();
        }
        DimensionCheckbox.prototype.initialize = function () {
            this.element = jQuery('<div/>', { 'class': 'text-overflow' });
            this.checkbox = jQuery('<input/>', { 'type': 'checkbox', 'id': 'dimension' + this.id, 'value': this.id, 'checked': this.selected });
            this.label = jQuery('<span/>', { 'text': " " + this.name, 'title': this.name, 'for': 'dimension' + this.id });
            this.element.append(this.checkbox, this.label);
        };
        DimensionCheckbox.prototype.addEventListeners = function () {
            var _this = this;
            this.label.click(function () {
                _this.selected = !_this.selected;
                _this.checkbox.prop(DimensionCheckbox.CHECKED_ATTR, !_this.checkbox.prop(DimensionCheckbox.CHECKED_ATTR));
            }).disableSelection();
            this.checkbox.change(function () {
                _this.selected = !_this.selected;
            });
        };
        DimensionCheckbox.prototype.getElement = function () {
            return this.element;
        };
        DimensionCheckbox.prototype.getId = function () {
            return this.id;
        };
        DimensionCheckbox.prototype.isSelected = function () {
            return this.selected;
        };
        DimensionCheckbox.CHECKED_ATTR = 'checked';
        return DimensionCheckbox;
    }());
    var TemplateManager = (function () {
        function TemplateManager(wrapper) {
            this.wrapper = wrapper;
            this.dimensionSection = this.wrapper.find('.wallet-share-template-management-list-dimensions');
            this.metricDimensionSection = this.wrapper.find('.wallet-share-template-management-list-metric-dimensions');
            this.saveButton = this.wrapper.find('.wallet-share-template-management-save');
            this.dimensionCheckboxes = new Array();
            this.metricDimensionCheckboxes = new Array();
            this.initializeDOM();
            this.addEventListeners();
        }
        TemplateManager.prototype.initializeDOM = function () {
            var _this = this;
            var dimensionColumnsArray = new Array();
            var metricDimensionColumnsArray = new Array();
            var totalElements = dimensionsVO.length;
            var columnSize = Math.ceil(totalElements / TemplateManager.COLUMN_ELEMENTS_SIZE);
            for (var i = 0; i < columnSize; i++) {
                dimensionColumnsArray.push(jQuery('<div/>', { 'class': 'col-xs-6 col-sm-3 col-md-3 col-lg-3 ws-template-management-columns-wrapper' }));
            }
            for (var i = 0; i < columnSize; i++) {
                metricDimensionColumnsArray.push(jQuery('<div/>', { 'class': 'col-xs-6 col-sm-3 col-md-3 col-lg-3 ws-template-management-columns-wrapper' }));
            }
            var dimensionInsertedControl = {
                insertedControl: 0,
                indexColumnPosition: 0
            };
            var metricDimensionInsertedControl = {
                insertedControl: 0,
                indexColumnPosition: 0
            };
            this.createDimensionsCheckboxes(dimensionColumnsArray, dimensionInsertedControl);
            this.createMetricDimensionsCheckboxes(metricDimensionColumnsArray, metricDimensionInsertedControl);
            dimensionColumnsArray.forEach(function (current) {
                _this.dimensionSection.append(current);
            });
            metricDimensionColumnsArray.forEach(function (current) {
                _this.metricDimensionSection.append(current);
            });
        };
        TemplateManager.prototype.createDimensionsCheckboxes = function (columnsArray, control) {
            var _this = this;
            dimensionsVO.forEach(function (dimension, index) {
                var checkbox = new DimensionCheckbox(dimension.name, dimension.id, dimension.selected);
                columnsArray[control.indexColumnPosition].append(checkbox.getElement());
                control.insertedControl++;
                if (control.insertedControl === TemplateManager.COLUMN_ELEMENTS_SIZE) {
                    control.insertedControl = 0;
                    control.indexColumnPosition++;
                }
                _this.dimensionCheckboxes.push(checkbox);
            });
        };
        TemplateManager.prototype.createMetricDimensionsCheckboxes = function (columnsArray, control) {
            var _this = this;
            metricDimensionsVO.forEach(function (dimension, index) {
                var checkbox = new DimensionCheckbox(dimension.name, dimension.id, dimension.selected);
                columnsArray[control.indexColumnPosition].append(checkbox.getElement());
                control.insertedControl++;
                if (control.insertedControl === TemplateManager.COLUMN_ELEMENTS_SIZE) {
                    control.insertedControl = 0;
                    control.indexColumnPosition++;
                }
                _this.metricDimensionCheckboxes.push(checkbox);
            });
        };
        TemplateManager.prototype.addEventListeners = function () {
            var _this = this;
            this.saveButton.click(function () {
                _this.saveButton.addClass(TemplateManager.DISABLED_CSS_CLASS);
                _this.saveButton.attr(TemplateManager.DISABLED_CSS_CLASS, TemplateManager.DISABLED_CSS_CLASS);
                var payload = {
                    dimensions: null,
                    metricDimensions: null
                };
                payload.dimensions = _this.dimensionCheckboxes.filter(function (checkbox) { return checkbox.isSelected(); }).map(function (checkbox) { return checkbox.getId(); });
                payload.metricDimensions = _this.metricDimensionCheckboxes.filter(function (checkbox) { return checkbox.isSelected(); }).map(function (checkbox) { return checkbox.getId(); });
                jQuery.ajax({
                    'method': 'POST',
                    'url': urls.saveRequest,
                    'data': JSON.stringify(payload),
                    'contentType': 'application/json'
                }).then(function (result) {
                    Kasina.messages.get().success(strings.saveSuccess);
                }).fail(function (response) {
                    Kasina.messages.get().error(strings.saveError);
                }).always(function () {
                    _this.saveButton.removeClass(TemplateManager.DISABLED_CSS_CLASS);
                    _this.saveButton.removeAttr(TemplateManager.DISABLED_CSS_CLASS);
                });
            });
        };
        TemplateManager.DISABLED_CSS_CLASS = 'disabled';
        TemplateManager.COLUMN_ELEMENTS_SIZE = 6;
        return TemplateManager;
    }());
    TemplatesManagement.TemplateManager = TemplateManager;
    var TemplatesDropdown = (function () {
        function TemplatesDropdown(wrapper) {
            this.wrapper = wrapper;
            this.dropdown = this.wrapper.find('.wallet-share-templates-management-dropdown');
            this.nextButton = this.wrapper.find('.wallet-share-templates-management-next-button');
            this.addEventListener();
        }
        TemplatesDropdown.prototype.addEventListener = function () {
            var _this = this;
            this.dropdown.change(function () {
                var id = _this.dropdown.val();
                if (id === TemplatesDropdown.DEFAULT_SELECT_VALUE) {
                    _this.nextButton.addClass(TemplatesDropdown.DISABLED);
                }
                else {
                    _this.nextButton.removeClass(TemplatesDropdown.DISABLED);
                }
            });
            this.nextButton.click(function () {
                var id = _this.dropdown.val();
                if (id === TemplatesDropdown.DEFAULT_SELECT_VALUE) {
                    return;
                }
                location.href = urls.manageTemplatePage.replace(TemplatesDropdown.DEFAULT_SELECT_VALUE, id);
            });
        };
        TemplatesDropdown.DEFAULT_SELECT_VALUE = '0';
        TemplatesDropdown.DISABLED = 'disabled';
        return TemplatesDropdown;
    }());
    TemplatesManagement.TemplatesDropdown = TemplatesDropdown;
})(TemplatesManagement || (TemplatesManagement = {}));
$(document).ready(function () {
    var wrapper = null;
    wrapper = $('.wallet-share-templates-management-wrapper');
    if (!wrapper.isEmpty()) {
        new TemplatesManagement.TemplatesDropdown(wrapper);
        return;
    }
    wrapper = $('.wallet-share-template-management-wrapper');
    if (!wrapper.isEmpty()) {
        new TemplatesManagement.TemplateManager(wrapper);
        return;
    }
});
var ReportViewModule;
(function (ReportViewModule) {
    var SimpleReport = (function () {
        function SimpleReport(wrapper, url) {
            this.reportWrapper = wrapper;
            this.reportUrl = url;
        }
        SimpleReport.prototype.buildReport = function () {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.reportViz = new walletShareReports.Viz(this.reportWrapper.get(0), this.reportUrl, { 'height': '100%', 'width': '100%' }, {
                categoricalFilters: [],
                parameters: this.generateParameterArgs(),
                salesCategoricalFilter: []
            });
            this.reportIframe = this.reportWrapper.find('iframe');
            this.reportIframeWrapper = this.reportIframe.parent();
            this.addEventListener();
            this.reportViz.ready(function () {
                deferred.resolve();
            });
            return promise;
        };
        SimpleReport.prototype.addEventListener = function () {
            var _this = this;
            this.reportViz.onResize(function (width, height) {
                _this.reportIframeWrapper.css({
                    'height': height + 'px',
                    'width': 100 + '%'
                });
                _this.reportIframe.css({
                    'height': height + 'px',
                    'width': 100 + '%'
                });
            });
            $(window).on('orientationchange', function () {
                var width = $(window).width();
                _this.reportIframeWrapper.css({ 'width': width });
                _this.reportIframe.css({ 'width': width });
            });
            $(window).resize(function () {
                $('html').height(_this.reportWrapper.height());
            });
            this.reportViz.analytics(function (e) {
                var EventsEnum = ReportAnalytics.EventsEnum;
                switch (e.getEventName()) {
                    case EventsEnum.OFFICE_DETAILS_REPORT:
                        Analytics.registerOfficeDetailsReport();
                        break;
                    case EventsEnum.OFFICE_DETAILS_CATEGORY_PRODUCT_ANALYSIS_SUBTAB:
                        Analytics.registerOfficeDetailsCategoryProductAnalysisSubtab();
                        break;
                    case EventsEnum.OFFICE_DETAILS_CATEGORY_TOP_ADVISORS_SUBTAB:
                        Analytics.registerOfficeDetailsCategoryTopAdvisorsSubtab();
                        break;
                    case EventsEnum.OFFICE_DETAILS_CATEGORY_MENU:
                        Analytics.registerOfficeDetailsCategoryMenu(e.getArg());
                        break;
                    case EventsEnum.OFFICE_DETAILS_CATEGORY_DETAIL_MATCHUP:
                        Analytics.registerOfficeDetailsCategoryDetailMatchup(e.getArg());
                        break;
                    case EventsEnum.OFFICE_DETAILS_CATEGORY_DETAIL_TOP_ADVISORS_LIST:
                        Analytics.registerOfficeDetailsCategoryDetailTopAdvisorsList(e.getArg());
                        break;
                    case EventsEnum.OFFICE_DETAILS_TAB_CATEGORY:
                        Analytics.eventOfficeDetailsTabCategory();
                        break;
                    case EventsEnum.OFFICE_DETAILS_TAB_OFFICE_OVERVIEW:
                        Analytics.eventOfficeDetailsTabOfficeOverview();
                        break;
                    case EventsEnum.OFFICE_DETAILS_TAB_ADVISOR_DETAIL:
                        Analytics.eventOfficeDetailsTabAdvisorDetail();
                        break;
                    case EventsEnum.OFFICE_DETAILS_TIMEFRAME_PRIOR_1_MONTHS:
                        Analytics.eventOfficeDetailsFilterByTimeframePrior1Months();
                        break;
                    case EventsEnum.OFFICE_DETAILS_TIMEFRAME_PRIOR_3_MONTHS:
                        Analytics.eventOfficeDetailsFilterByTimeframePrior3Months();
                        break;
                    case EventsEnum.OFFICE_DETAILS_TIMEFRAME_PRIOR_6_MONTHS:
                        Analytics.eventOfficeDetailsFilterByTimeframePrior6Months();
                        break;
                    case EventsEnum.OFFICE_DETAILS_SHARE_CLASS_OVERALL:
                        Analytics.eventOfficeDetailsFilterByShareClassOverall();
                        break;
                    case EventsEnum.OFFICE_DETAILS_SHARE_CLASS_ADVISORY:
                        Analytics.eventOfficeDetailsFilterByShareClassAdvisory();
                        break;
                    case EventsEnum.OFFICE_DETAILS_SHARE_CLASS_BROKERAGE:
                        Analytics.eventOfficeDetailsFilterByShareClassBrokerage();
                        break;
                }
            });
        };
        SimpleReport.prototype.showReport = function (office, firmName, territoryName) {
            var _this = this;
            this.reportViz.pauseAutomaticUpdatesAsync().then(function () {
                _this.reportViz.applyFilterAsync(dimensions.address, [office]);
                _this.reportViz.applyFilterAsync(dimensions.firm, [firmName]);
                _this.reportViz.applyFilterAsync(dimensions.territory, [territoryName]);
                if (officeDetailsDimensions !== null) {
                    var advisorName = officeDetailsDimensions.advisorName;
                    if (advisorName !== null && advisorName !== undefined && !advisorName.isEmpty()) {
                        _this.reportViz.applyFilterAsync(dimensions.advisor, [advisorName]);
                    }
                    var categoryName = officeDetailsDimensions.categoryName;
                    if (categoryName !== null && categoryName !== undefined && !categoryName.isEmpty()) {
                        _this.reportViz.applyFilterAsync(dimensions.category, [categoryName]);
                    }
                    var advisorTeamName = officeDetailsDimensions.advisorTeamName;
                    if (advisorTeamName !== null && advisorTeamName !== undefined && !advisorTeamName.isEmpty()) {
                        _this.reportViz.applyFilterAsync(dimensions.advisorTeam, [advisorTeamName]);
                    }
                }
                _this.reportViz.resumeAutomaticUpdatesAsync();
            });
        };
        SimpleReport.prototype.generateParameterArgs = function () {
            var parameters = new Array();
            // Appending browser options to pass to report
            var browserOptions = this.generateBrowserOptions();
            Object.keys(browserOptions).forEach(function (browserOption) {
                parameters.push({
                    name: browserOption,
                    currentValue: browserOptions[browserOption]
                });
            });
            // Appending products permission to pass to report
            parameters.push({
                name: PermissionManager.ProductsPermissionManager.PERMISSION_PARAMETER,
                currentValue: productsPermission
            });
            parameters.push({
                name: PermissionManager.ProductsPermissionManager.TEMPLATE_PERMISSION_PARAMETER,
                currentValue: templatePermission
            });
            return parameters;
        };
        SimpleReport.prototype.generateBrowserOptions = function () {
            var browserOptions = {};
            browserOptions[BrowserDetector.BrowserDetectorManager.MOBILE_DEVICE_PARAMETER] = EnvironmentUtilities.BrowserDetector.isMobile();
            browserOptions[BrowserDetector.BrowserDetectorManager.MOBILE_DEVICE_LANDSCAPE_PARAMETER] = EnvironmentUtilities.BrowserDetector.isMobileLandscape();
            browserOptions[BrowserDetector.BrowserDetectorManager.TABLET_DEVICE_PARAMETER] = EnvironmentUtilities.BrowserDetector.isTablet();
            browserOptions[BrowserDetector.BrowserDetectorManager.TABLET_PORTRAIT_DEVICE_PARAMETER] = EnvironmentUtilities.BrowserDetector.isTabletPortrait();
            browserOptions[BrowserDetector.BrowserDetectorManager.TABLET_LANDSCAPE_DEVICE_PARAMETER] = EnvironmentUtilities.BrowserDetector.isTabletLandscape();
            browserOptions[BrowserDetector.BrowserDetectorManager.DESKTOP_DEVICE_PARAMETER] = EnvironmentUtilities.BrowserDetector.isDesktop();
            return browserOptions;
        };
        return SimpleReport;
    }());
    ReportViewModule.SimpleReport = SimpleReport;
    var ReportView = (function () {
        function ReportView(wrapper) {
            var _this = this;
            this.wrapper = wrapper;
            this.createFakeSpinner();
            setTimeout(function () {
                _this.initilize();
            }, 500);
        }
        ReportView.prototype.initilize = function () {
            var permissionManager = new PermissionManager.ProductsPermissionManager();
            permissionManager.setProducts(productsPermission);
            permissionManager.setTemplates(templatePermission);
            if (!permissionManager.hasDistributionIntelligenceProduct()) {
                this.createErrorMessage(messages.permissionError);
                return;
            }
            this.createRequest();
        };
        ReportView.prototype.createFakeSpinner = function () {
            var spinnerWrapper = jQuery('<div/>', { 'class': 'ws-report-view-message-wrapper container' });
            var spinnerColumn = jQuery('<div/>', { 'class': 'col-xs-12' });
            var spinner = jQuery('<div/>', { 'class': 'ws-report-view-message' }).append(jQuery('<i/>', { 'class': 'fa fa-spinner fa-spin' }));
            spinnerWrapper.append(spinnerColumn.append(spinner));
            this.wrapper.append(spinnerWrapper);
        };
        ReportView.prototype.createRequest = function () {
            var _this = this;
            var promise = jQuery.ajax({
                'method': 'GET',
                'url': urls.retrieveOfficeName,
                'contentType': 'application/json'
            });
            promise.then(function (response) {
                if (response) {
                    if (response.error === "") {
                        var data = response.data;
                        _this.createReport(data.officeName, data.firmName, data.territoryName);
                    }
                    else {
                        _this.createErrorMessage(response.error);
                    }
                }
                else {
                    _this.createErrorMessage(messages.dataError);
                }
            }).fail(function (response) {
                _this.createErrorMessage(messages.dataError);
            });
        };
        ReportView.prototype.createReport = function (officeName, firmName, territoryName) {
            var _this = this;
            // Cleaning...
            this.wrapper.html('');
            if (officeName === null || firmName === null || territoryName === null) {
                this.createErrorMessage(messages.dataError);
                return;
            }
            this.report = new SimpleReport(this.wrapper, reportVO.url);
            this.report.buildReport()
                .then(function () {
                _this.report.showReport(officeName, firmName, territoryName);
            })
                .fail(function () {
                _this.createErrorMessage(messages.dataError);
            });
        };
        ReportView.prototype.createErrorMessage = function (message) {
            // Cleaning...
            this.wrapper.html('');
            var errorWrapper = jQuery('<div/>', { 'class': 'ws-report-view-message-wrapper container' });
            var errorColumn = jQuery('<div/>', { 'class': 'col-xs-12' });
            var errorMessage = jQuery('<div/>', { 'class': 'ws-report-view-message open-sans', 'text': message });
            errorWrapper.append(errorColumn.append(errorMessage));
            this.wrapper.append(errorWrapper);
        };
        return ReportView;
    }());
    ReportViewModule.ReportView = ReportView;
})(ReportViewModule || (ReportViewModule = {}));
(function (wrapper) {
    if (wrapper.isEmpty()) {
        return;
    }
    new ReportViewModule.ReportView(wrapper);
})($('.ws-report-view-wrapper'));
var AltsReportViewModule;
(function (AltsReportViewModule) {
    var SimpleReport = (function () {
        function SimpleReport(wrapper, url) {
            this.reportWrapper = wrapper;
            this.reportUrl = url;
        }
        SimpleReport.prototype.buildReport = function (data) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.reportViz = new walletShareReports.Viz(this.reportWrapper.get(0), this.reportUrl, {
                'height': '100%',
                'width': '100%'
            }, {
                categoricalFilters: this.generateCategoricalFilters(data),
                parameters: this.generateParameterArgs(),
                salesCategoricalFilter: []
            });
            this.reportIframe = this.reportWrapper.find('iframe');
            this.reportIframeWrapper = this.reportIframe.parent();
            this.addEventListener();
            this.reportViz.ready(function () {
                deferred.resolve();
            });
            return promise;
        };
        SimpleReport.prototype.addEventListener = function () {
            var _this = this;
            this.reportViz.onResize(function (width, height) {
                _this.reportIframeWrapper.css({
                    'height': height + 'px',
                    'width': 100 + '%'
                });
                _this.reportIframe.css({
                    'height': height + 'px',
                    'width': 100 + '%'
                });
            });
            $(window).on('orientationchange', function () {
                var width = $(window).width();
                _this.reportIframeWrapper.css({ 'width': width });
                _this.reportIframe.css({ 'width': width });
            });
            $(window).resize(function () {
                $('html').height(_this.reportWrapper.height());
            });
            this.reportViz.analytics(function (e) {
                var EventsEnum = ReportAnalytics.EventsEnum;
                switch (e.getEventName()) {
                    case EventsEnum.OFFICE_DETAILS_REPORT:
                        Analytics.registerOfficeDetailsReport();
                        break;
                    case EventsEnum.OFFICE_DETAILS_CATEGORY_PRODUCT_ANALYSIS_SUBTAB:
                        Analytics.registerOfficeDetailsCategoryProductAnalysisSubtab();
                        break;
                    case EventsEnum.OFFICE_DETAILS_CATEGORY_TOP_ADVISORS_SUBTAB:
                        Analytics.registerOfficeDetailsCategoryTopAdvisorsSubtab();
                        break;
                    case EventsEnum.OFFICE_DETAILS_CATEGORY_MENU:
                        Analytics.registerOfficeDetailsCategoryMenu(e.getArg());
                        break;
                    case EventsEnum.OFFICE_DETAILS_CATEGORY_DETAIL_MATCHUP:
                        Analytics.registerOfficeDetailsCategoryDetailMatchup(e.getArg());
                        break;
                    case EventsEnum.OFFICE_DETAILS_CATEGORY_DETAIL_TOP_ADVISORS_LIST:
                        Analytics.registerOfficeDetailsCategoryDetailTopAdvisorsList(e.getArg());
                        break;
                    case EventsEnum.OFFICE_DETAILS_TAB_CATEGORY:
                        Analytics.eventOfficeDetailsTabCategory();
                        break;
                    case EventsEnum.OFFICE_DETAILS_TAB_OFFICE_OVERVIEW:
                        Analytics.eventOfficeDetailsTabOfficeOverview();
                        break;
                    case EventsEnum.OFFICE_DETAILS_TAB_ADVISOR_DETAIL:
                        Analytics.eventOfficeDetailsTabAdvisorDetail();
                        break;
                    case EventsEnum.OFFICE_DETAILS_TIMEFRAME_PRIOR_1_MONTHS:
                        Analytics.eventOfficeDetailsFilterByTimeframePrior1Months();
                        break;
                    case EventsEnum.OFFICE_DETAILS_TIMEFRAME_PRIOR_3_MONTHS:
                        Analytics.eventOfficeDetailsFilterByTimeframePrior3Months();
                        break;
                    case EventsEnum.OFFICE_DETAILS_TIMEFRAME_PRIOR_6_MONTHS:
                        Analytics.eventOfficeDetailsFilterByTimeframePrior6Months();
                        break;
                    case EventsEnum.OFFICE_DETAILS_SHARE_CLASS_OVERALL:
                        Analytics.eventOfficeDetailsFilterByShareClassOverall();
                        break;
                    case EventsEnum.OFFICE_DETAILS_SHARE_CLASS_ADVISORY:
                        Analytics.eventOfficeDetailsFilterByShareClassAdvisory();
                        break;
                    case EventsEnum.OFFICE_DETAILS_SHARE_CLASS_BROKERAGE:
                        Analytics.eventOfficeDetailsFilterByShareClassBrokerage();
                        break;
                }
            });
        };
        SimpleReport.prototype.showReport = function (office, firmName, territoryName, advisorName) {
            var _this = this;
            this.reportViz.pauseAutomaticUpdatesAsync().then(function () {
                _this.reportViz.resumeAutomaticUpdatesAsync();
            });
        };
        SimpleReport.prototype.generateCategoricalFilters = function (data) {
            var dimensions = [];
            var officeDimension = {
                name: 'Alt-Address',
                options: [data.officeName]
            };
            var firmDimension = {
                name: 'Alt-Firm',
                options: [data.firmName]
            };
            var territoryDimension = {
                name: 'Alt-Territory',
                options: [data.territoryName]
            };
            var advDimension = {
                name: 'Alt-Advisor',
                options: [data.advisorName]
            };
            dimensions.push(officeDimension);
            dimensions.push(firmDimension);
            if (data.territoryName != "") {
                dimensions.push(territoryDimension);
            }
            if (data.advisorName != "") {
                dimensions.push(advDimension);
            }
            return dimensions;
        };
        SimpleReport.prototype.generateParameterArgs = function () {
            var parameters = new Array();
            // Appending browser options to pass to report
            var browserOptions = this.generateBrowserOptions();
            Object.keys(browserOptions).forEach(function (browserOption) {
                parameters.push({
                    name: browserOption,
                    currentValue: browserOptions[browserOption]
                });
            });
            // Appending products permission to pass to report
            parameters.push({
                name: PermissionManager.ProductsPermissionManager.PERMISSION_PARAMETER,
                currentValue: productsPermission
            });
            parameters.push({
                name: PermissionManager.ProductsPermissionManager.TEMPLATE_PERMISSION_PARAMETER,
                currentValue: templatePermission
            });
            return parameters;
        };
        SimpleReport.prototype.generateBrowserOptions = function () {
            var browserOptions = {};
            browserOptions[BrowserDetector.BrowserDetectorManager.MOBILE_DEVICE_PARAMETER] = EnvironmentUtilities.BrowserDetector.isMobile();
            browserOptions[BrowserDetector.BrowserDetectorManager.MOBILE_DEVICE_LANDSCAPE_PARAMETER] = EnvironmentUtilities.BrowserDetector.isMobileLandscape();
            browserOptions[BrowserDetector.BrowserDetectorManager.TABLET_DEVICE_PARAMETER] = EnvironmentUtilities.BrowserDetector.isTablet();
            browserOptions[BrowserDetector.BrowserDetectorManager.TABLET_PORTRAIT_DEVICE_PARAMETER] = EnvironmentUtilities.BrowserDetector.isTabletPortrait();
            browserOptions[BrowserDetector.BrowserDetectorManager.TABLET_LANDSCAPE_DEVICE_PARAMETER] = EnvironmentUtilities.BrowserDetector.isTabletLandscape();
            browserOptions[BrowserDetector.BrowserDetectorManager.DESKTOP_DEVICE_PARAMETER] = EnvironmentUtilities.BrowserDetector.isDesktop();
            return browserOptions;
        };
        return SimpleReport;
    }());
    AltsReportViewModule.SimpleReport = SimpleReport;
    var ReportView = (function () {
        function ReportView(wrapper) {
            var _this = this;
            this.wrapper = wrapper;
            this.createFakeSpinner();
            setTimeout(function () {
                _this.initilize();
            }, 500);
        }
        ReportView.prototype.initilize = function () {
            var permissionManager = new PermissionManager.ProductsPermissionManager();
            permissionManager.setProducts(productsPermission);
            permissionManager.setTemplates(templatePermission);
            if (!permissionManager.hasDistributionIntelligenceProduct()) {
                this.createErrorMessage(messages.permissionError);
                return;
            }
            this.createRequest();
        };
        ReportView.prototype.createFakeSpinner = function () {
            var spinnerWrapper = jQuery('<div/>', { 'class': 'ws-report-view-message-wrapper container' });
            var spinnerColumn = jQuery('<div/>', { 'class': 'col-xs-12' });
            var spinner = jQuery('<div/>', { 'class': 'ws-report-view-message' }).append(jQuery('<i/>', { 'class': 'fa fa-spinner fa-spin' }));
            spinnerWrapper.append(spinnerColumn.append(spinner));
            this.wrapper.append(spinnerWrapper);
        };
        ReportView.prototype.createRequest = function () {
            var _this = this;
            var promise = jQuery.ajax({
                'method': 'GET',
                'url': urls.retrieveAlts,
                'contentType': 'application/json'
            });
            promise.then(function (response) {
                if (response) {
                    if (response.error === "") {
                        var data = response.data;
                        _this.createReport(data);
                    }
                    else {
                        _this.createErrorMessage(response.error);
                    }
                }
                else {
                    _this.createErrorMessage(messages.dataError);
                }
            }).fail(function (response) {
                _this.createErrorMessage(messages.dataError);
            });
        };
        ReportView.prototype.createReport = function (data) {
            var _this = this;
            // Cleaning...
            this.wrapper.html('');
            if (data.officeName === null || data.firmName === null || data.territoryName === null) {
                this.createErrorMessage(messages.dataError);
                return;
            }
            this.report = new SimpleReport(this.wrapper, reportVO.url);
            this.report.buildReport(data)
                .then(function () {
                _this.report.showReport(data.officeName, data.firmName, data.territoryName, data.advisorName);
            })
                .fail(function () {
                _this.createErrorMessage(messages.dataError);
            });
        };
        ReportView.prototype.createErrorMessage = function (message) {
            // Cleaning...
            this.wrapper.html('');
            var errorWrapper = jQuery('<div/>', { 'class': 'ws-report-view-message-wrapper container' });
            var errorColumn = jQuery('<div/>', { 'class': 'col-xs-12' });
            var errorMessage = jQuery('<div/>', { 'class': 'ws-report-view-message open-sans', 'text': message });
            errorWrapper.append(errorColumn.append(errorMessage));
            this.wrapper.append(errorWrapper);
        };
        return ReportView;
    }());
    AltsReportViewModule.ReportView = ReportView;
})(AltsReportViewModule || (AltsReportViewModule = {}));
(function (wrapper) {
    if (wrapper.isEmpty()) {
        return;
    }
    new AltsReportViewModule.ReportView(wrapper);
})($('.ws-alts-report-view-wrapper'));
var GreenSpaceSettings;
(function (GreenSpaceSettings) {
    var saveGreenSpaceSettingReq = (function () {
        function saveGreenSpaceSettingReq() {
        }
        return saveGreenSpaceSettingReq;
    }());
    GreenSpaceSettings.saveGreenSpaceSettingReq = saveGreenSpaceSettingReq;
    var saveGreenSpaceSettingRow = (function () {
        function saveGreenSpaceSettingRow() {
        }
        return saveGreenSpaceSettingRow;
    }());
    GreenSpaceSettings.saveGreenSpaceSettingRow = saveGreenSpaceSettingRow;
    var saveGreenSpaceSettingRowMetrics = (function () {
        function saveGreenSpaceSettingRowMetrics() {
        }
        return saveGreenSpaceSettingRowMetrics;
    }());
    GreenSpaceSettings.saveGreenSpaceSettingRowMetrics = saveGreenSpaceSettingRowMetrics;
    var submitGreenSpaceSettingsFlagData = (function () {
        function submitGreenSpaceSettingsFlagData() {
        }
        return submitGreenSpaceSettingsFlagData;
    }());
    GreenSpaceSettings.submitGreenSpaceSettingsFlagData = submitGreenSpaceSettingsFlagData;
    var ProductMetrics = (function () {
        function ProductMetrics() {
        }
        return ProductMetrics;
    }());
    GreenSpaceSettings.ProductMetrics = ProductMetrics;
})(GreenSpaceSettings || (GreenSpaceSettings = {}));
var GreenSpaceSettings;
(function (GreenSpaceSettings) {
    var Strings = (function () {
        function Strings() {
        }
        Strings.GREEN_SPACE_3_EXPORT_HEADER = ["Month", "Morningstar Category", "Product", "Metric 1", "And/Or", "Metric 2", "And/Or", "Metric 3"];
        Strings.GREEN_SPACE_EXPORT_HEADER = ["Month", "Morningstar Category", "Product", "Metric 1", "And/Or", "Metric 2", "And/Or", "Metric 3", "And/Or", "Metric 4", "And/Or", "Metric 5", "And/Or", "Metric 6"];
        Strings.GREEN_SPACE_HEADER = "SS&C | WalletShare";
        Strings.CUSTOM_GREEN_SPACE = "- Custom Green Space Settings";
        return Strings;
    }());
    GreenSpaceSettings.Strings = Strings;
})(GreenSpaceSettings || (GreenSpaceSettings = {}));
///<reference path="00.data_type.ts" />
///<reference path="03.data.ts" />
///<reference path="04.parser.ts" />
var GreenSpaceSettings;
(function (GreenSpaceSettings) {
    var Service = (function () {
        function Service() {
            this.data = new GreenSpaceSettings.DataManager();
            this.parser = new GreenSpaceSettings.Parser();
        }
        Service.prototype.getGSProducts = function () {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.data.getGSProducts().then(function (result) {
                deferred.resolveWith(window, [_this.parser.getGSProducts(result)]);
            });
            return promise;
        };
        Service.prototype.getGSRules = function () {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.data.getGSRules().then(function (result) {
                deferred.resolveWith(window, [_this.parser.getGSRules(result)]);
            });
            return promise;
        };
        Service.prototype.getGSMetrics = function () {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.data.getGSMetrics().then(function (result) {
                deferred.resolveWith(window, [_this.parser.getGSMetrics(result)]);
            });
            return promise;
        };
        Service.prototype.getGSProductMetrics = function () {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.data.getGSProductMetrics().then(function (result) {
                deferred.resolveWith(window, [_this.parser.getGSProductMetrics(result)]);
            });
            return promise;
        };
        Service.prototype.getMorningStarCategory = function () {
            return this.data.getMorningStarCategory();
        };
        Service.prototype.exportGSRules = function () {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.data.exportGSRules().then(function (result) {
                deferred.resolveWith(window, [_this.parser.exportGSRules(result)]);
            });
            return promise;
        };
        Service.prototype.saveMorningStarSettings = function (payload) {
            return this.data.saveMorningStarSettings(payload);
        };
        Service.prototype.getGSSubmitDetails = function () {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.data.getGSSubmitDetails().then(function (result) {
                deferred.resolveWith(window, [result]);
            });
            return promise;
        };
        Service.prototype.submitGreenspaceDetails = function (payload) {
            return this.data.submitGreenspaceDetails(payload);
        };
        return Service;
    }());
    GreenSpaceSettings.Service = Service;
})(GreenSpaceSettings || (GreenSpaceSettings = {}));
var GreenSpaceSettings;
(function (GreenSpaceSettings) {
    var DataManager = (function () {
        function DataManager() {
            this.GET_GREEN_SPACE_PRODUCTS_URL = '/companyAdmin/getGSProducts';
            this.GET_GREEN_SPACE_RULES_URL = '/companyAdmin/getGreenSpaceRules';
            this.morningStarCategoryUrl = '/companyAdmin/greenSpaceMorningStarCategories';
            this.GET_GREEN_SPACE_METRICS_URL = '/companyAdmin/getGSMetrics';
            this.GET_GREEN_SPACE_PRODUCT_METRICS_URL = '/companyAdmin/getGSProductMetrics';
            this.EXPORT_GREEN_SPACE_RULES_URL = '/companyAdmin/exportGreenSpaceRules';
            this.SAVE_GREEN_SPACE_SETTINGS_URL = '/companyAdmin/saveGreenSpaceSetting';
            this.GET_GREEN_SPACE_SETTINGS_SUBMIT_DATA = '/companyAdmin/getSubmitDetails';
            this.SUBMIT_GREEN_SPACE_DETAILS = '/companyAdmin/submitGSDetails';
        }
        DataManager.prototype.getMorningStarCategory = function () {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('GET', this.morningStarCategoryUrl, null).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getGSProducts = function () {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('GET', this.GET_GREEN_SPACE_PRODUCTS_URL, '').then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getGSRules = function () {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('GET', this.GET_GREEN_SPACE_RULES_URL, '').then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.exportGSRules = function () {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('GET', this.EXPORT_GREEN_SPACE_RULES_URL, '').then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getGSSubmitDetails = function () {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('GET', this.GET_GREEN_SPACE_SETTINGS_SUBMIT_DATA, '').then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.submitGreenspaceDetails = function (payload) {
            return this.baseAjax('POST', this.SUBMIT_GREEN_SPACE_DETAILS, JSON.stringify(payload));
        };
        DataManager.prototype.getGSMetrics = function () {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('GET', this.GET_GREEN_SPACE_METRICS_URL, '').then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getGSProductMetrics = function () {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('GET', this.GET_GREEN_SPACE_PRODUCT_METRICS_URL, '').then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.saveMorningStarSettings = function (payload) {
            return this.baseAjax('POST', this.SAVE_GREEN_SPACE_SETTINGS_URL, JSON.stringify(payload));
        };
        DataManager.prototype.baseAjax = function (method, url, data) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            jQuery.ajax({
                'method': method,
                'url': url,
                'data': data,
                'contentType': 'application/json',
                'dataType': 'json'
            }).then(function (data) {
                deferred.resolveWith(window, [data]);
            }, (function (error) {
                deferred.reject(window, [error]);
            }));
            return promise;
        };
        return DataManager;
    }());
    GreenSpaceSettings.DataManager = DataManager;
    var MockData = (function () {
        function MockData() {
            this.greenSpaceMockDataMetric = [
                "ratingoverall",
                "return1yr",
                "return3yr",
                "return5yr",
                "return10yr",
                "yield12mo",
                "sharpe3yr",
                "annualreportnetexpenseratio"
            ];
            this.greenSpaceMockDataBooleanOperator = ["AND", "OR"];
        }
        MockData.prototype.getGreenSpaceMockDataMetric = function () {
            return this.greenSpaceMockDataMetric;
        };
        MockData.prototype.getGreenSpaceMockDataBooleanOperator = function () {
            return this.greenSpaceMockDataBooleanOperator;
        };
        return MockData;
    }());
    GreenSpaceSettings.MockData = MockData;
})(GreenSpaceSettings || (GreenSpaceSettings = {}));
///<reference path="00.data_type.ts" />
var GreenSpaceSettings;
(function (GreenSpaceSettings) {
    var Parser = (function () {
        function Parser() {
        }
        Parser.prototype.getGSProducts = function (result) {
            var columns = result.cols;
            var rows = result.rows;
            var productIndex = columns.indexOf(Parser.PRODUCT);
            var fundIdIndex = columns.indexOf(Parser.FUNDID);
            var results = [];
            rows.forEach(function (row) {
                var result = {
                    product: row[productIndex],
                    fundId: row[fundIdIndex]
                };
                results.push(result);
            });
            return results;
        };
        Parser.prototype.getGSMetrics = function (result) {
            var columns = result.cols;
            var rows = result.rows;
            var dataPointIndex = columns.indexOf(Parser.DATA_POINT);
            var metricsIndex = columns.indexOf(Parser.METRIC_NAME);
            var portalOrderIndex = columns.indexOf(Parser.PORTAL_ORDER);
            var metricTypeIndex = columns.indexOf(Parser.METRIC_TYPE);
            var UnitsIndex = columns.indexOf(Parser.UNITS);
            var comparatorIndex = columns.indexOf(Parser.COMPARATOR);
            var results = [];
            rows.forEach(function (row) {
                var metricList = {
                    dataPoint: row[dataPointIndex],
                    metricName: row[metricsIndex],
                    portalOrder: row[portalOrderIndex],
                    metricType: row[metricTypeIndex],
                    units: row[UnitsIndex],
                    comparator: row[comparatorIndex]
                };
                results.push(metricList);
            });
            return results;
        };
        Parser.prototype.getGSProductMetrics = function (result) {
            var metricsDataList = [];
            result.forEach(function (row) {
                var metricsData = {
                    product: row.product,
                    fundId: row.fundId,
                    metricsList: row.metricsList
                };
                metricsDataList.push(metricsData);
            });
            return metricsDataList;
        };
        Parser.prototype.getGSRules = function (result) {
            var columns = result.cols;
            var rows = result.rows;
            var monthIndex = columns.indexOf(Parser.MONTH);
            var categoryIndex = columns.indexOf(Parser.CATEGORY);
            var productIndex = columns.indexOf(Parser.PRODUCT_PORTFOLIO);
            var metric1Index = columns.indexOf(Parser.METRIC_1);
            var booleanOperator1Index = columns.indexOf(Parser.BOOLEAN_OPERATOR_1);
            var metric2Index = columns.indexOf(Parser.METRIC_2);
            var booleanOperator2Index = columns.indexOf(Parser.BOOLEAN_OPERATOR_2);
            var metric3Index = columns.indexOf(Parser.METRIC_3);
            var booleanOperator3Index = columns.indexOf(Parser.BOOLEAN_OPERATOR_3);
            var metric4Index = columns.indexOf(Parser.METRIC_4);
            var booleanOperator4Index = columns.indexOf(Parser.BOOLEAN_OPERATOR_4);
            var metric5Index = columns.indexOf(Parser.METRIC_5);
            var booleanOperator5Index = columns.indexOf(Parser.BOOLEAN_OPERATOR_5);
            var metric6Index = columns.indexOf(Parser.METRIC_6);
            var results = [];
            rows.forEach(function (row) {
                var gsRule = {
                    month: row[monthIndex],
                    category: row[categoryIndex],
                    product: row[productIndex],
                    metric1: row[metric1Index],
                    booleanOperator1: row[booleanOperator1Index],
                    metric2: row[metric2Index],
                    booleanOperator2: row[booleanOperator2Index],
                    metric3: row[metric3Index],
                    booleanOperator3: row[booleanOperator3Index],
                    metric4: row[metric4Index],
                    booleanOperator4: row[booleanOperator4Index],
                    metric5: row[metric5Index],
                    booleanOperator5: row[booleanOperator5Index],
                    metric6: row[metric6Index]
                };
                results.push(gsRule);
            });
            return results;
        };
        Parser.prototype.exportGSRules = function (result) {
            var productFamilyName = result.productFamilyName;
            var columns = result.cols;
            var rows = result.rows;
            /* let productFamilyNameIndex = columns.indexOf(Parser.PRODUCT_FAMILY_NAME);*/
            var monthIndex = columns.indexOf(Parser.MONTH);
            var categoryIndex = columns.indexOf(Parser.CATEGORY);
            var productIndex = columns.indexOf(Parser.PRODUCT_PORTFOLIO);
            var fundIdIndex = columns.indexOf(Parser.FUNDID);
            var metric1Index = columns.indexOf(Parser.METRIC_1);
            var comparator1Index = columns.indexOf(Parser.COMPARATOR_1);
            var booleanOperator1Index = columns.indexOf(Parser.BOOLEAN_OPERATOR_1);
            var metric2Index = columns.indexOf(Parser.METRIC_2);
            var comparator2Index = columns.indexOf(Parser.COMPARATOR_2);
            var booleanOperator2Index = columns.indexOf(Parser.BOOLEAN_OPERATOR_2);
            var metric3Index = columns.indexOf(Parser.METRIC_3);
            var comparator3Index = columns.indexOf(Parser.COMPARATOR_3);
            var booleanOperator3Index = columns.indexOf(Parser.BOOLEAN_OPERATOR_3);
            var metric4Index = columns.indexOf(Parser.METRIC_4);
            var comparator4Index = columns.indexOf(Parser.COMPARATOR_4);
            var booleanOperator4Index = columns.indexOf(Parser.BOOLEAN_OPERATOR_4);
            var metric5Index = columns.indexOf(Parser.METRIC_5);
            var comparator5Index = columns.indexOf(Parser.COMPARATOR_5);
            var booleanOperator5Index = columns.indexOf(Parser.BOOLEAN_OPERATOR_5);
            var metric6Index = columns.indexOf(Parser.METRIC_6);
            var comparator6Index = columns.indexOf(Parser.COMPARATOR_6);
            var results = [];
            rows.forEach(function (row) {
                var gsRule = {
                    productFamilyName: productFamilyName,
                    month: row[monthIndex],
                    category: row[categoryIndex],
                    product: row[productIndex],
                    fundId: row[fundIdIndex],
                    metric1: row[metric1Index],
                    comparator1: row[comparator1Index],
                    booleanOperator1: row[booleanOperator1Index],
                    metric2: row[metric2Index],
                    comparator2: row[comparator2Index],
                    booleanOperator2: row[booleanOperator2Index],
                    metric3: row[metric3Index],
                    comparator3: row[comparator3Index],
                    booleanOperator3: row[booleanOperator3Index],
                    metric4: row[metric4Index],
                    comparator4: row[comparator4Index],
                    booleanOperator4: row[booleanOperator4Index],
                    metric5: row[metric5Index],
                    comparator5: row[comparator5Index],
                    booleanOperator5: row[booleanOperator5Index],
                    metric6: row[metric6Index],
                    comparator6: row[comparator6Index]
                };
                results.push(gsRule);
            });
            return results;
        };
        Parser.PRODUCT = 'portfolioname';
        Parser.FUNDID = 'fund_id';
        Parser.MONTH = 'year_month';
        Parser.CATEGORY = 'morningstar_product_category';
        Parser.PRODUCT_PORTFOLIO = 'product_portfolio';
        Parser.METRIC_1 = 'factor_1_client_data_point';
        Parser.COMPARATOR_1 = 'factor_1_comparison';
        Parser.BOOLEAN_OPERATOR_1 = 'boolean_operator_1';
        Parser.METRIC_2 = 'factor_2_client_data_point';
        Parser.COMPARATOR_2 = 'factor_2_comparison';
        Parser.BOOLEAN_OPERATOR_2 = 'boolean_operator_2';
        Parser.METRIC_3 = 'factor_3_client_data_point';
        Parser.COMPARATOR_3 = 'factor_3_comparison';
        Parser.BOOLEAN_OPERATOR_3 = 'boolean_operator_3';
        Parser.METRIC_4 = 'factor_4_client_data_point';
        Parser.COMPARATOR_4 = 'factor_4_comparison';
        Parser.BOOLEAN_OPERATOR_4 = 'boolean_operator_4';
        Parser.METRIC_5 = 'factor_5_client_data_point';
        Parser.COMPARATOR_5 = 'factor_5_comparison';
        Parser.BOOLEAN_OPERATOR_5 = 'boolean_operator_5';
        Parser.METRIC_6 = 'factor_6_client_data_point';
        Parser.COMPARATOR_6 = 'factor_6_comparison';
        Parser.PRODUCT_FAMILY_NAME = 'product_family_name';
        Parser.METRIC_NAME = 'metric_name';
        Parser.DATA_POINT = 'data_point';
        Parser.PORTAL_ORDER = 'portal_order';
        Parser.METRIC_TYPE = 'metric_type';
        Parser.UNITS = 'units';
        Parser.COMPARATOR = 'comparator';
        return Parser;
    }());
    GreenSpaceSettings.Parser = Parser;
})(GreenSpaceSettings || (GreenSpaceSettings = {}));
///<reference path="02.service.ts"/>
///<reference path="03.data.ts"/>
///<reference path="01.strings.ts" />
var GreenSpaceSettings;
(function (GreenSpaceSettings) {
    var GreenSpace = (function () {
        function GreenSpace(wrapper) {
            this.gsRules = [];
            this.currentMonthGSRules = [];
            this.nextMonthGSRules = [];
            this.currentMonthGS3Rules = [];
            this.nextMonthGS3Rules = [];
            this.metricListMap = {};
            this.metricMapExclusion = ['ratingoverall', 'average_eff_duration', 'modified_duration'];
            this.metricGS3Exclusion = ['booleanOperator3', 'booleanOperator4', 'booleanOperator5',
                'comparator4', 'comparator5', 'comparator6', 'metric4', 'metric5', 'metric6'];
            this.productMetricsFound = true;
            this.productPortfolioMaxLength = 0;
            this.wrapper = wrapper;
            this.service = new GreenSpaceSettings.Service();
            this.mockDataManager = new GreenSpaceSettings.MockData();
            this.update();
        }
        GreenSpace.prototype.update = function () {
            var _this = this;
            $.when(this.service.getMorningStarCategory(), this.service.getGSProducts(), this.service.getGSMetrics(), this.service.exportGSRules(), this.service.getGSSubmitDetails(), this.service.getGSProductMetrics())
                .done(function (categories, products, metricList, exportGSRules, submitDetails, productMetricsList) {
                _this.categoryList = categories;
                _this.products = products;
                _this.metricList = metricList;
                metricList.forEach(function (metric) {
                    if (metric.metricName.contains(">") || metric.metricName.contains("<")) {
                        _this.metricListMap[metric.dataPoint + metric.comparator] = metric;
                    }
                    else {
                        _this.metricListMap[metric.dataPoint] = metric;
                    }
                });
                _this.exportGSRules = exportGSRules;
                _this.productMetricsList = productMetricsList;
                _this.setExportDropdownValues();
                _this.setMonthDetails();
                _this.generateTableHtml();
                _this.wrapper.find('#green-space-spinner').hide();
                _this.triggerExportEvents();
                _this.setSubmitIcon(submitDetails);
                _this.setMetricsOnLoad();
                _this.updateGSHighLights();
                _this.setSaveButton();
                _this.dropDownEventChanges();
            });
        };
        GreenSpace.prototype.setMonthDetails = function () {
            var _this = this;
            if (this.exportGSRules.length) {
                this.nextMonthGSRules.splice(0, this.nextMonthGSRules.length);
                this.currentMonthGSRules.splice(0, this.currentMonthGSRules.length);
                this.gsRules.splice(0, this.gsRules.length);
                var month_1 = this.exportGSRules[0].month;
                var gsRulesList = JSON.parse(JSON.stringify(this.exportGSRules));
                var gsRules = JSON.parse(JSON.stringify(this.exportGSRules));
                gsRules.forEach(function (rule) {
                    if (rule.month === month_1) {
                        var row = [];
                        for (var key in rule) {
                            row.push(rule[key]);
                        }
                        _this.gsRules.push(rule);
                    }
                });
                gsRulesList.forEach(function (a) {
                    delete a.productFamilyName;
                    delete a.fundId;
                });
                gsRulesList.forEach(function (gsRule) {
                    if (gsRule.month === month_1) {
                        var row = [];
                        for (var key in gsRule) {
                            if (isGSAdmin6Enabled == 'false' && isGSAdmin3Enabled == 'true' && _this.metricGS3Exclusion.indexOf(key) !== -1) {
                            }
                            else if (key.contains('metric') && _this.metricMapExclusion.indexOf(gsRule[key]) !== -1) {
                                var num = key.charAt(key.length - 1);
                                row.push(gsRule[key] + gsRule[("comparator" + num)]);
                            }
                            else if (!key.contains('comparator')) {
                                row.push(gsRule[key]);
                            }
                        }
                        _this.nextMonthGSRules.push(row);
                    }
                    else {
                        var row = [];
                        for (var key in gsRule) {
                            if (isGSAdmin6Enabled == 'false' && isGSAdmin3Enabled == 'true' && _this.metricGS3Exclusion.indexOf(key) !== -1) {
                            }
                            else if (key.contains('metric') && _this.metricMapExclusion.indexOf(gsRule[key]) !== -1) {
                                var num = key.charAt(key.length - 1);
                                row.push(gsRule[key] + gsRule[("comparator" + num)]);
                            }
                            else if (!key.contains('comparator')) {
                                row.push(gsRule[key]);
                            }
                        }
                        _this.currentMonthGSRules.push(row);
                    }
                });
            }
        };
        GreenSpace.prototype.createCurrentMonthContent = function (month) {
            var metricMap = this.metricListMap;
            var countHeader = this.checkHeaderList(this.currentMonthGSRules);
            var count = Math.max.apply(Math, countHeader);
            var csvHeader = this.getHeaderList(count).join(",") + "\r\n";
            var csvContent = GreenSpaceSettings.Strings.GREEN_SPACE_HEADER + "\r\n";
            var date = month + " Market Share " + "\r\n";
            var productFamilyName = (this.exportGSRules[0].productFamilyName).replace(/\s+/g, '');
            var clientName = productFamilyName + " " + GreenSpaceSettings.Strings.CUSTOM_GREEN_SPACE + "\r\n";
            csvContent = csvContent + date + clientName + "\r\n" + csvHeader;
            this.currentMonthGSRules.forEach(function (rowArray) {
                for (var j = 0; j < rowArray.length; j++) {
                    if (rowArray[j] !== null && rowArray[j].contains(',')) {
                        rowArray[j] = '"' + rowArray[j] + '"';
                    }
                }
                for (var i = 1; i <= 6; i++) {
                    var index = i * 2 + 1;
                    if (metricMap[rowArray[index]]) {
                        rowArray[index] = metricMap[rowArray[index]].metricName;
                    }
                }
                var row = rowArray.join(",");
                csvContent += row + "\r\n";
            });
            return csvContent;
        };
        GreenSpace.prototype.getHeaderList = function (limit) {
            var headerList = [];
            for (var _i = 0, _a = GreenSpaceSettings.Strings.GREEN_SPACE_EXPORT_HEADER; _i < _a.length; _i++) {
                var item = _a[_i];
                if (headerList.length < limit) {
                    headerList.push(item);
                }
            }
            return headerList;
        };
        GreenSpace.prototype.checkHeaderList = function (dataList) {
            var arrayCount = [];
            dataList.forEach(function (data) {
                var count = 0;
                for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                    var ele = data_1[_i];
                    if (!ele.isEmpty()) {
                        count++;
                    }
                }
                arrayCount.push(count);
            });
            return arrayCount;
        };
        GreenSpace.prototype.createNextMonthContent = function (month) {
            var metricMap = this.metricListMap;
            var countHeader = this.checkHeaderList(this.nextMonthGSRules);
            var count = Math.max.apply(Math, countHeader);
            var csvHeader = this.getHeaderList(count).join(",") + "\r\n";
            var csvContent = GreenSpaceSettings.Strings.GREEN_SPACE_HEADER + "\r\n";
            var date = month + " Market Share " + "\r\n";
            var productFamilyName = (this.exportGSRules[0].productFamilyName).replace(/\s+/g, '');
            var clientName = productFamilyName + " " + GreenSpaceSettings.Strings.CUSTOM_GREEN_SPACE + "\r\n";
            csvContent = csvContent + date + clientName + "\r\n" + csvHeader;
            this.nextMonthGSRules.forEach(function (rowArray) {
                for (var j = 0; j < rowArray.length; j++) {
                    if (rowArray[j] !== null && rowArray[j].contains(',')) {
                        rowArray[j] = '"' + rowArray[j] + '"';
                    }
                }
                for (var i = 1; i <= 6; i++) {
                    var index = i * 2 + 1;
                    if (metricMap[rowArray[index]]) {
                        rowArray[index] = metricMap[rowArray[index]].metricName;
                    }
                }
                var row = rowArray.join(",");
                csvContent += row + "\r\n";
            });
            return csvContent;
        };
        GreenSpace.prototype.getFileName = function (month) {
            var productFamilyName = (this.exportGSRules[0].productFamilyName).replace(/\s+/g, '');
            return month + "_WalletShare_" + productFamilyName + "_GreenSpaceSetting";
        };
        GreenSpace.prototype.getCurrentMonthCsv = function () {
            var month = this.currentMonthGSRules[0][0];
            var fileContents = this.createCurrentMonthContent(month);
            var fileName = this.getFileName(month) + ".csv";
            var blob = new Blob([fileContents], { type: "text/plain" });
            //create temp link to send file to for dl
            var a = document.createElement("a");
            a.href = window.URL.createObjectURL(blob);
            a.setAttribute("download", fileName);
            a.setAttribute('target', '_blank');
            a.setAttribute('style', 'display:none');
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
        };
        GreenSpace.prototype.getNextMonthCsv = function () {
            var month = this.nextMonthGSRules[0][0];
            var fileContents = this.createNextMonthContent(month);
            var fileName = this.getFileName(month) + ".csv";
            var blob = new Blob([fileContents], { type: "text/plain" });
            //create temp link to send file to for dl
            var a = document.createElement("a");
            a.href = window.URL.createObjectURL(blob);
            a.setAttribute("download", fileName);
            a.setAttribute('target', '_blank');
            a.setAttribute('style', 'display:none');
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
        };
        GreenSpace.prototype.triggerExportEvents = function () {
            var _this = this;
            jQuery("#currMonth, #nextMonth").click(function (e) {
                $(".green-space-waiting-icon-wrapper").show();
                _this.service.exportGSRules().then(function (result) {
                    _this.exportGSRules = result;
                    _this.setMonthDetails();
                    $(".green-space-waiting-icon-wrapper").hide();
                    $(e.target).parent().parent().attr('id') === 'currMonth' ? _this.getCurrentMonthCsv() : _this.getNextMonthCsv();
                });
            });
        };
        GreenSpace.prototype.generateTableHtml = function () {
            var _this = this;
            var wrapper = jQuery(".ws-company-admin-table-wrapper");
            wrapper.html("");
            var tableWrapper = $("<div>", {
                'id': "green-space-table-wrapper", 'class': "ws-company-admin-green-space-table-wrapper"
            });
            var fieldsetWrapper = $("<fieldset>", {
                'id': "green-space-fieldset-wrapper", 'class': "green-space-fieldset-wrapper"
            });
            var greenSpaceTable = $("<table>", {
                'class': 'green-space-table'
            });
            wrapper.append(tableWrapper);
            tableWrapper.append(fieldsetWrapper);
            var tbody = $('<tbody>');
            var thead = $('<thead>');
            var tableHeader1 = $('<tr>');
            tableHeader1.append($('<th>', {
                'class': 'greenspace-header greenspace_table_morningstar_product_category_column fixed-header',
                'rowspan': '2'
            }).text("Morningstar Category"));
            tableHeader1.append($('<th>', {
                'class': 'greenspace-header greenspace_table_product_portfolio_column fixed-header',
                'rowspan': '2'
            }).text("Product"));
            tableHeader1.append($('<th>', {
                'class': 'greenspace-settings-header greenspace_table_green_space_settings fixed-header-greenspace',
                'colspan': '11'
            }).text("Green Space Settings"));
            tableHeader1.appendTo(thead);
            var tableHeader = $('<tr>');
            tableHeader.append($('<th>', { 'class': 'green-space-header' }).text("Metric 1"));
            tableHeader.append($('<th>', { 'class': 'green-space-header' }).text("And/Or"));
            tableHeader.append($('<th>', { 'class': 'green-space-header' }).text("Metric 2"));
            tableHeader.append($('<th>', { 'class': 'green-space-header' }).text("And/Or"));
            tableHeader.append($('<th>', { 'class': 'green-space-header' }).text("Metric 3"));
            if (isGSAdmin6Enabled == 'true') {
                tableHeader.append($('<th>', { 'class': 'green-space-header' }).text("And/Or"));
                tableHeader.append($('<th>', { 'class': 'green-space-header' }).text("Metric 4"));
                tableHeader.append($('<th>', { 'class': 'green-space-header' }).text("And/Or"));
                tableHeader.append($('<th>', { 'class': 'green-space-header' }).text("Metric 5"));
                tableHeader.append($('<th>', { 'class': 'green-space-header' }).text("And/Or"));
                tableHeader.append($('<th>', { 'class': 'green-space-header' }).text("Metric 6"));
            }
            tableHeader.appendTo(thead);
            thead.appendTo(greenSpaceTable);
            var placeHolderBooleanOperator = this.mockDataManager.getGreenSpaceMockDataBooleanOperator();
            this.categoryList.forEach(function (category) {
                var tableRow = $('<tr>', { 'id': "" + category });
                tableRow.append($('<td>', { 'class': 'greenspace_table_morningstar_product_category_column' }).text(category));
                tableRow.append(_this.generateTdHtml(_this.products, "product_portfolio"));
                tableRow.append(_this.generateTdHtml("", "metric1"));
                tableRow.append(_this.generateTdHtml(placeHolderBooleanOperator, "boolean_operator1"));
                tableRow.append(_this.generateTdHtml("", "metric2"));
                tableRow.append(_this.generateTdHtml(placeHolderBooleanOperator, "boolean_operator2"));
                tableRow.append(_this.generateTdHtml("", "metric3"));
                if (isGSAdmin6Enabled == 'true') {
                    tableRow.append(_this.generateTdHtml(placeHolderBooleanOperator, "boolean_operator3"));
                    tableRow.append(_this.generateTdHtml("", "metric4"));
                    tableRow.append(_this.generateTdHtml(placeHolderBooleanOperator, "boolean_operator4"));
                    tableRow.append(_this.generateTdHtml("", "metric5"));
                    tableRow.append(_this.generateTdHtml(placeHolderBooleanOperator, "boolean_operator5"));
                    tableRow.append(_this.generateTdHtml("", "metric6"));
                }
                tableRow.appendTo(tbody);
                _this.prePopulateHistoryValues(category, tableRow);
            });
            greenSpaceTable.append(tbody);
            fieldsetWrapper.append(greenSpaceTable);
            $(".ws-company-admin-green-space-wrapper").append(tableWrapper);
            this.setProductPortfolioWidth();
        };
        GreenSpace.prototype.generateTdHtml = function (optionList, value) {
            var _this = this;
            var tableRow;
            var select;
            if (value == 'product_portfolio') {
                select = $("<select>", {
                    'class': 'form-control select_' + value + ' product_portfolio_dropdown'
                });
            }
            else {
                select = $("<select>", {
                    'class': 'form-control select_' + value
                });
            }
            var _option = $("<option></option>");
            _option.val('');
            _option.text('None');
            select.append(_option);
            if (optionList != "") {
                optionList.forEach(function (option) {
                    var _option = $("<option></option>");
                    if (value == 'product_portfolio') {
                        _option.val(option.fundId);
                        _option.text(option.product);
                        if (_this.productPortfolioMaxLength < option.product.length) {
                            _this.productPortfolioMaxLength = option.product.length;
                        }
                    }
                    else {
                        _option.val(option);
                        _option.text(option);
                    }
                    select.append(_option);
                });
            }
            if (value.contains('metric')) {
                tableRow = $('<td>', { 'class': 'greenspace_table_' + value + '_column greenspace_table_metric_column' }).append(select);
            }
            else if (value.contains('boolean_operator')) {
                tableRow = $('<td>', { 'class': 'greenspace_table_' + value + '_column greenspace_table_boolean_operator_column' }).append(select);
            }
            else {
                tableRow = $('<td>', { 'class': 'greenspace_table_' + value + '_column' }).append(select);
            }
            return tableRow;
        };
        GreenSpace.prototype.setMetricsOnLoad = function () {
            this.setMetricsList();
            this.prePopulateMetricsHistoryData();
        };
        GreenSpace.prototype.prePopulateMetricsHistoryData = function () {
            var _this = this;
            this.categoryList.forEach(function (category) {
                var greenSpaceRule = _this.gsRules.filter(function (gsRule) {
                    if (gsRule.category === category)
                        return gsRule;
                });
                if (greenSpaceRule.length) {
                    var rule_1 = greenSpaceRule[0];
                    for (var i = 1; i <= 5; i++) {
                        if (_this.metricMapExclusion.indexOf(rule_1[("metric" + i)]) !== -1) {
                            rule_1[("metric" + i)] = rule_1[("metric" + i)] + rule_1[("comparator" + i)];
                        }
                    }
                    rule_1 = Object.keys(rule_1).reduce(function (acc, key) {
                        acc[key] = rule_1[key] === null ? '' :
                            rule_1[key];
                        return acc;
                    }, {});
                    var metrics_1_Ele = $("[id='" + category + "']").find('.select_metric1');
                    var metrics_2_Ele = $("[id='" + category + "']").find('.select_metric2');
                    var metrics_3_Ele = $("[id='" + category + "']").find('.select_metric3');
                    var metrics_4_Ele = $("[id='" + category + "']").find('.select_metric4');
                    var metrics_5_Ele = $("[id='" + category + "']").find('.select_metric5');
                    var metrics_6_Ele = $("[id='" + category + "']").find('.select_metric6');
                    var found = true;
                    if (!(metrics_1_Ele.find("option[value='" + rule_1.metric1 + "']").length == 0)) {
                        metrics_1_Ele.val(rule_1.metric1);
                    }
                    else {
                        found = false;
                    }
                    if (!(metrics_2_Ele.find("option[value='" + rule_1.metric2 + "']").length == 0)) {
                        metrics_2_Ele.val(rule_1.metric2);
                    }
                    else {
                        found = false;
                    }
                    if (!(metrics_3_Ele.find("option[value='" + rule_1.metric3 + "']").length == 0)) {
                        metrics_3_Ele.val(rule_1.metric3);
                    }
                    else {
                        found = false;
                    }
                    if (isGSAdmin6Enabled == 'true') {
                        if (!(metrics_4_Ele.find("option[value='" + rule_1.metric4 + "']").length == 0)) {
                            metrics_4_Ele.val(rule_1.metric4);
                        }
                        else {
                            found = false;
                        }
                        if (!(metrics_5_Ele.find("option[value='" + rule_1.metric5 + "']").length == 0)) {
                            metrics_5_Ele.val(rule_1.metric5);
                        }
                        else {
                            found = false;
                        }
                        if (!(metrics_6_Ele.find("option[value='" + rule_1.metric6 + "']").length == 0)) {
                            metrics_6_Ele.val(rule_1.metric6);
                        }
                        else {
                            found = false;
                        }
                    }
                    if (!found) {
                        $("[id='" + category + "']").children('.greenspace_table_product_portfolio_column').siblings().children().val('').change();
                        $("[id='" + category + "']").children('.greenspace_table_product_portfolio_column').children().css("color", "red");
                    }
                    if (!found) {
                        _this.productMetricsFound = false;
                    }
                }
            });
            if (!this.productMetricsFound) {
                $('#green-space-save-warning').show();
                // $("#nextMonth").hide();
                $('#submit-button').prop('disabled', true);
                $('#save-button').prop('disabled', true);
            }
            else {
                $('#green-space-save-warning').hide();
            }
        };
        GreenSpace.prototype.setMetricsList = function () {
            var _this = this;
            $('.green-space-table > tbody  > tr .product_portfolio_dropdown').each(function (index, productRow) {
                var productMetric = _this.productMetricsList.filter(function (productMetric) {
                    return productMetric.fundId === $(productRow).val();
                });
                var tempList = productMetric.map(function (_a) {
                    var metricsList = _a.metricsList;
                    return metricsList;
                });
                if (tempList != 0) {
                    var metricData = JSON.parse(JSON.stringify(tempList[0]));
                    var _loop_1 = function(i) {
                        var select = $(productRow).parent().siblings(".greenspace_table_metric_column").children("select")[i];
                        metricData.forEach(function (data) {
                            var _option = $("<option></option>");
                            if (_this.metricMapExclusion.indexOf(data.dataPoint) !== -1) {
                                _option.val(data.dataPoint + data.comparator);
                                _option.text(data.metricName);
                                $(select).append(_option);
                            }
                            else {
                                _option.val(data.dataPoint);
                                _option.text(data.metricName);
                                $(select).append(_option);
                            }
                        });
                    };
                    for (var i = 0; i <= 5; i++) {
                        _loop_1(i);
                    }
                }
            });
        };
        GreenSpace.prototype.setSubmitIcon = function (submitDetails) {
            var _this = this;
            var submitIcon = $('#submit-button');
            var confirmCancelBtn = $("#cancelButton");
            var confirmSubmitBtn = $("#submitButton");
            this.setGreenspaceTable(submitDetails);
            confirmSubmitBtn.prop("disabled", false);
            submitIcon.click(function () {
                $("#submitReportModal").css("display", "block");
            });
            confirmCancelBtn.click(function () {
                $("#submitReportModal").css("display", "none");
                $(".green-space-save-msg p").hide();
                $('#green-space-submit-cancel').show();
            });
            confirmSubmitBtn.click(function () {
                if (submitDetails == null) {
                    _this.saveAndSubmitLogic(_this);
                    confirmSubmitBtn.prop("disabled", true);
                }
                else {
                    $("#submitReportModal").css("display", "none");
                    $(".green-space-save-msg p").hide();
                }
            });
        };
        GreenSpace.prototype.setGreenspaceTable = function (submitDetails) {
            var productFamilyName = (this.exportGSRules[0].productFamilyName);
            if (submitDetails != null && submitDetails.productFamilyName == productFamilyName) {
                $("#green-space-fieldset-wrapper").prop("disabled", true);
                $('#submit-button').prop("disabled", true);
                $('#save-button').prop("disabled", true);
            }
            else {
                $("#green-space-fieldset-wrapper").prop("disabled", false);
                $('#submit-button').prop("disabled", false);
                $('#save-button').prop("disabled", false);
            }
        };
        GreenSpace.prototype.submitGreenspaceDetails = function () {
            var productFamilyName = (this.exportGSRules[0].productFamilyName);
            var submitDetails = {
                productFamilyId: "",
                productFamilyName: productFamilyName,
                userEmail: ""
            };
            try {
                $("#submitReportModal").css("display", "none");
                $(".green-space-save-msg p").hide();
                this.service.submitGreenspaceDetails(submitDetails).then(function (submitData) {
                    $("#green-space-submit-success").show();
                    $("#green-space-fieldset-wrapper").prop("disabled", true);
                    $('#submit-button').prop("disabled", true);
                }).fail(function () {
                    $('#green-space-submit-fail').show();
                });
            }
            catch (error) {
                $('#green-space-submit-fail').show();
            }
        };
        GreenSpace.prototype.dropDownEventChanges = function () {
            this.disableSelection();
            this.disableSelectOnChange();
            this.initialSelection();
            this.triggerFilterEvent();
        };
        GreenSpace.prototype.disableSelection = function () {
            $(".product_portfolio_dropdown").each(function (i) {
                var $productPortfolio = $($(".product_portfolio_dropdown")[i]);
                if ($productPortfolio.val() == '') {
                    $productPortfolio.parent().siblings().children().prop("disabled", true);
                }
                else {
                    $productPortfolio.parent().siblings().children().each(function (j) {
                        if ($($productPortfolio.parent().siblings().children()[j]).val() == '') {
                            $($productPortfolio.parent().siblings().children()[j + 1]).prop("disabled", true);
                        }
                    });
                }
            });
        };
        GreenSpace.prototype.disableSelectOnChange = function () {
            $('select').change(function (e) {
                if ($(e.currentTarget).parent().next().children().length > 0 && $(e.currentTarget).val() != '') {
                    $(e.currentTarget).parent().next().children().prop("disabled", false);
                    return false;
                }
                else if ($(e.currentTarget).val() == '') {
                    $(e.currentTarget).parent().next().children().prop("disabled", true);
                }
            });
        };
        GreenSpace.prototype.initialSelection = function () {
            var self = this;
            $('.green-space-table > tbody  > tr').each(function (index, tr) {
                var _this = this;
                var arrayList = [];
                if ($(this).find(".select_boolean_operator1").val() != '') {
                    var boolean_value = $(this).find(".select_boolean_operator1").val() === 'AND' ? 'OR' : 'AND';
                    $(this).find(".select_boolean_operator1").parent().siblings().children().find('option[value=' + '"' + boolean_value + '"]').attr('disabled', 'disabled');
                    $(this).find(".select_boolean_operator1").parent().siblings(".greenspace_table_boolean_operator_column").find("select:enabled").each(function (i) {
                        var enabledBoolean = $(_this).find(".select_boolean_operator1").parent().siblings(".greenspace_table_boolean_operator_column").find("select:enabled")[i];
                        if ($(enabledBoolean).val() != '') {
                            $(enabledBoolean).val($(_this).find(".select_boolean_operator1").val());
                        }
                    });
                }
                $(this).children(".greenspace_table_product_portfolio_column").nextAll('td').find(":selected").each(function (i) {
                    var selected = $(_this).children(".greenspace_table_product_portfolio_column").nextAll('td').find(":selected")[i];
                    $(_this).children(".greenspace_table_product_portfolio_column").nextAll('td').find('option[value=""]').attr('disabled', 'disabled');
                    $(selected).val() === '' ? 0 : arrayList.push($(selected).val());
                    if ($(selected).val() !== '') {
                        self.setInitSelection($(_this), selected);
                    }
                });
                if (arrayList.length !== 0) {
                    arrayList.length % 2 == 0 ? $(this).find(".select_boolean_operator" + (arrayList.length / 2)).find('option[value=""]').removeAttr('disabled') :
                        $(this).find(".select_metric" + ((arrayList.length + 1) / 2)).find('option[value=""]').removeAttr('disabled');
                }
            });
        };
        GreenSpace.prototype.setInitSelection = function (_this, selected) {
            for (var i = 1; i <= 6; i++) {
                var selectedMetrics = _this.find(".select_metric" + i);
                if (selectedMetrics.val() !== $(selected).val()) {
                    selectedMetrics.find('option[value=' + '"' + $(selected).val() + '"]').attr('disabled', 'disabled');
                }
            }
            this.setMetricExclusions(_this);
        };
        GreenSpace.prototype.setMetricExclusions = function (_this) {
            for (var i = 1; i <= 6; i++) {
                var selectedMetrics = _this.find(".select_metric" + i);
                if (selectedMetrics.val() != null && this.metricMapExclusion.indexOf(selectedMetrics.val().replace('>', '').replace('<', '').replace('=', '')) !== -1) {
                    var metricOption = '';
                    if (selectedMetrics.val().contains('ratingoverall')) {
                        if (selectedMetrics.val().contains('=')) {
                            metricOption = selectedMetrics.val().slice(0, -1);
                        }
                        else {
                            metricOption = selectedMetrics.val() + '=';
                        }
                    }
                    else {
                        if (selectedMetrics.val().contains('>')) {
                            metricOption = selectedMetrics.val().slice(0, -1) + '<';
                        }
                        else {
                            metricOption = selectedMetrics.val().slice(0, -1) + '>';
                        }
                    }
                    selectedMetrics.parent("td").siblings().find('option[value=' + '"' + metricOption + '"]').attr('disabled', 'disabled');
                }
            }
            if (_this.find(".select_metric2").val() != null && _this.find(".select_metric2").val().contains("ratingoverall")) {
                var comparator = _this.find(".select_metric2").val().substring(13, _this.find(".select_metric2").val().length) == ">" ? ">=" : ">";
                var ratingOption = "ratingoverall" + comparator;
                _this.find(".select_metric2").parent("td").siblings().find('option[value=' + '"' + ratingOption + '"]').attr('disabled', 'disabled');
            }
            if (_this.find(".select_metric3").val() != null && _this.find(".select_metric3").val().contains("ratingoverall")) {
                var comparator = _this.find(".select_metric3").val().substring(13, _this.find(".select_metric3").val().length) == ">" ? ">=" : ">";
                var ratingOption = "ratingoverall" + comparator;
                _this.find(".select_metric3").parent("td").siblings().find('option[value=' + '"' + ratingOption + '"]').attr('disabled', 'disabled');
            }
            if (_this.find(".select_metric4").val() != null && _this.find(".select_metric4").val().contains("ratingoverall")) {
                var comparator = _this.find(".select_metric4").val().substring(13, _this.find(".select_metric4").val().length) == ">" ? ">=" : ">";
                var ratingOption = "ratingoverall" + comparator;
                _this.find(".select_metric4").parent("td").siblings().find('option[value=' + '"' + ratingOption + '"]').attr('disabled', 'disabled');
            }
            if (_this.find(".select_metric5").val() != null && _this.find(".select_metric5").val().contains("ratingoverall")) {
                var comparator = _this.find(".select_metric5").val().substring(13, _this.find(".select_metric5").val().length) == ">" ? ">=" : ">";
                var ratingOption = "ratingoverall" + comparator;
                _this.find(".select_metric5").parent("td").siblings().find('option[value=' + '"' + ratingOption + '"]').attr('disabled', 'disabled');
            }
            if (_this.find(".select_metric6").val() != null && _this.find(".select_metric6").val().contains("ratingoverall")) {
                var comparator = _this.find(".select_metric6").val().substring(13, _this.find(".select_metric6").val().length) == ">" ? ">=" : ">";
                var ratingOption = "ratingoverall" + comparator;
                _this.find(".select_metric6").parent("td").siblings().find('option[value=' + '"' + ratingOption + '"]').attr('disabled', 'disabled');
            }
        };
        GreenSpace.prototype.triggerFilterEvent = function () {
            var _this = this;
            jQuery(".greenspace_table_metric_column select, .greenspace_table_boolean_operator_column select").change(function (e) {
                var arrayList = [];
                var arrayClassList = [];
                $(e.currentTarget).parent().parent("tr").children(".greenspace_table_product_portfolio_column").nextAll('td').find("option").removeAttr('disabled');
                $(e.currentTarget).parent().parent("tr").children(".greenspace_table_product_portfolio_column").nextAll('td').find('option[value=""]').attr('disabled', 'disabled');
                $(e.currentTarget).parent().parent("tr").children(".greenspace_table_product_portfolio_column").nextAll('td').find(":selected").each(function (i) {
                    var selected = $(e.currentTarget).parent().parent("tr").children(".greenspace_table_product_portfolio_column").nextAll('td').find(":selected")[i];
                    var selectedClass = $($(e.currentTarget).parent().parent("tr").children(".greenspace_table_product_portfolio_column").nextAll('td').find(":selected")[i]).parent().attr('class');
                    var className = selectedClass.split(" ");
                    if ($(selected).val() !== '') {
                        arrayList.push($(selected).val());
                        arrayClassList.push(className[1]);
                    }
                    _this.setInitSelection($(e.currentTarget).parent().parent("tr"), selected);
                });
                var trId = $(e.currentTarget).parent().parent("tr").attr("id");
                if (!_this.checkBooleanDisableSaveByCategory(trId)) {
                    $('#save-button').prop('disabled', true);
                    $('#submit-button').prop('disabled', true);
                    $('#green-space-save-warning').show();
                }
                if (arrayList.length !== 0) {
                    arrayList.length % 2 == 0 ? $(e.currentTarget).parent().parent("tr").find(".select_boolean_operator" + (arrayList.length / 2)).find('option[value=""]').removeAttr('disabled') :
                        $(e.currentTarget).parent().parent("tr").find(".select_metric" + ((arrayList.length + 1) / 2)).find('option[value=""]').removeAttr('disabled');
                }
                if (arrayClassList.length != 0 && arrayClassList[arrayList.length - 1].contains("select_boolean_operator") && $(e.currentTarget).val() == null) {
                    $(e.currentTarget).parent().prev().children().val("").change();
                }
                if ($(e.currentTarget).parent().parent("tr").find(".select_boolean_operator1").val() != '') {
                    var boolean_value = $(e.currentTarget).parent().parent("tr").find(".select_boolean_operator1").val() === 'AND' ? 'OR' : 'AND';
                    $(e.currentTarget).parent().parent("tr").find(".select_boolean_operator1").parent().siblings().children().find('option[value=' + '"' + boolean_value + '"]').attr('disabled', 'disabled');
                    $(e.currentTarget).parent().parent("tr").find(".select_boolean_operator1").parent().siblings(".greenspace_table_boolean_operator_column").find("select:enabled").each(function (i) {
                        var enabledBoolean = $(e.currentTarget).parent().parent("tr").find(".select_boolean_operator1").parent().siblings(".greenspace_table_boolean_operator_column").find("select:enabled")[i];
                        if ($(enabledBoolean).find("option:selected").text() != "None") {
                            $(enabledBoolean).val($(e.currentTarget).parent().parent("tr").find(".select_boolean_operator1").val());
                        }
                    });
                }
                if (!_this.checkMetricsDisableSaveByCategory(trId)) {
                    $('#save-button').prop('disabled', true);
                    $('#submit-button').prop('disabled', true);
                    $('#green-space-save-warning').show();
                }
            });
            this.productChange();
        };
        GreenSpace.prototype.productChange = function () {
            var _this = this;
            jQuery(".product_portfolio_dropdown").change(function (e) {
                $(e.currentTarget).parent().siblings().children().val('').change();
                $(e.currentTarget).parent().siblings().children().prop("disabled", true);
                $(e.currentTarget).parent().siblings().children().css("color", "#555");
                if ($(e.currentTarget).val() != '') {
                    _this.productMetricsChange(e);
                    $(e.currentTarget).parent().next().children().removeAttr('disabled');
                }
                else {
                    $('#submit-button').prop('disabled', false);
                    $('#save-button').prop('disabled', false);
                    $('#green-space-save-warning').hide();
                }
                if ($(e.currentTarget).parent().next().children().val() == null && !$(e.currentTarget).parent().next().children().prop("disabled")) {
                    $('#submit-button').prop('disabled', true);
                    $('#save-button').prop('disabled', true);
                    $('#green-space-save-warning').show();
                }
            });
        };
        GreenSpace.prototype.productMetricsChange = function (e) {
            var _this = this;
            var productMetric = this.productMetricsList.filter(function (productMetric) {
                return productMetric.fundId === $(e.currentTarget).val();
            });
            var tempList = productMetric.map(function (_a) {
                var metricsList = _a.metricsList;
                return metricsList;
            });
            if (tempList != 0) {
                var metricData = JSON.parse(JSON.stringify(tempList[0]));
                var _loop_2 = function(i) {
                    var select = $(e.currentTarget).parent().siblings(".greenspace_table_metric_column").children("select")[i];
                    $(select).find('option').remove().end().append('<option value="">None</option>');
                    metricData.forEach(function (data) {
                        var _option = $("<option></option>");
                        if (_this.metricMapExclusion.indexOf(data.dataPoint) !== -1) {
                            _option.val(data.dataPoint + data.comparator);
                            _option.text(data.metricName);
                            $(select).append(_option);
                        }
                        else {
                            _option.val(data.dataPoint);
                            _option.text(data.metricName);
                            $(select).append(_option);
                        }
                        $(select).append(_option);
                    });
                };
                for (var i = 0; i <= 5; i++) {
                    _loop_2(i);
                }
            }
        };
        GreenSpace.prototype.prePopulateHistoryValues = function (category, tableRow) {
            var greenSpaceRule = this.gsRules.filter(function (gsRule) {
                if (gsRule.category === category)
                    return gsRule;
            });
            if (greenSpaceRule.length) {
                var rule = greenSpaceRule[0];
                for (var i = 1; i <= 5; i++) {
                    if (this.metricMapExclusion.indexOf(rule[("metric" + i)]) !== -1) {
                        rule[("metric" + i)] = rule[("metric" + i)] + rule[("comparator" + i)];
                    }
                }
                if (tableRow.find('.select_product_portfolio').find("option[value='" + rule.fundId + "']").length != 0) {
                    tableRow.find('.select_product_portfolio').val(rule.fundId);
                }
                else {
                    $("[id='" + category + "']").children('.greenspace_table_product_portfolio_column').children().val('').change();
                    $("[id='" + category + "']").children('.greenspace_table_product_portfolio_column').children().css("color", "red");
                    //$("#nextMonth").hide();
                    $('#submit-button').prop('disabled', true);
                    $('#save-button').prop('disabled', true);
                }
                tableRow.find('.select_boolean_operator1').val(rule.booleanOperator1);
                tableRow.find('.select_boolean_operator2').val(rule.booleanOperator2);
                tableRow.find('.select_boolean_operator3').val(rule.booleanOperator3);
                tableRow.find('.select_boolean_operator4').val(rule.booleanOperator4);
                tableRow.find('.select_boolean_operator5').val(rule.booleanOperator5);
            }
        };
        GreenSpace.prototype.setExportDropdownValues = function () {
            if (this.exportGSRules.length != 0) {
                var uniqueList = this.exportGSRules.map(function (rule) { return rule.month; })
                    .filter(function (value, index, self) { return self.indexOf(value) === index; });
                var nextMonth = uniqueList[0].split('-')[1].toUpperCase();
                var nextYear = uniqueList[0].split('-')[0];
                $("#nextMonth span").text(nextYear + "-" + nextMonth);
                if (uniqueList.length === 1) {
                    $("#currMonth").css("display", "none");
                }
                else {
                    var currentMonth = uniqueList[1].split('-')[1].toUpperCase();
                    var currentYear = uniqueList[1].split('-')[0];
                    $("#currMonth span").text(currentYear + "-" + currentMonth);
                    $("#currMonth").css("display", "block");
                }
            }
            else {
                $(".green-space-export-dropdown").css("display", "none");
            }
        };
        GreenSpace.prototype.setSaveButton = function () {
            var current = this;
            var exportButton = $(".green-space-export-button");
            var saveButton = $('#save-button');
            var submitButton = $('#submit-button');
            $('#green-space-table-wrapper').find('.green-space-table').find('tbody').find('select').each(function () {
                {
                    $(this).on('change', function () {
                        $(this).css('color', 'green');
                        $(this).find('option').css('color', '');
                        $(this).find('option:selected').css('color', 'green');
                        $('#green-space-save-success').hide();
                        $('#green-space-save-fail').hide();
                        if (current.checkMetricsDisableSave()) {
                            saveButton.prop('disabled', false);
                            submitButton.prop('disabled', false);
                            $('#green-space-save-warning').hide();
                        }
                        else {
                            saveButton.prop('disabled', true);
                            submitButton.prop('disabled', true);
                            $('#green-space-save-warning').show();
                        }
                    });
                }
            });
            saveButton.click(function () {
                saveButton.prop('disabled', true);
                exportButton.prop('disabled', true);
                $(".green-space-waiting-icon-wrapper").show();
                var requestBody = {
                    greenSpaceSettingsInput: []
                };
                var rows = $('.green-space-table > tbody > tr');
                rows.each(function (index, element) {
                    var productPortfolio = $(this).find('.select_product_portfolio option:selected').text();
                    var fundId = $(this).find('.select_product_portfolio option:selected').val();
                    if (productPortfolio !== 'None') {
                        var morningstarProductCategory = $(this).find('.greenspace_table_morningstar_product_category_column').text();
                        var metrics = [];
                        var _loop_3 = function(i) {
                            var factorClientDatapoint = $(this_1).find(".select_metric" + i + " option:selected").val() || '';
                            var factorComparison = '';
                            if (factorClientDatapoint.includes('>=')) {
                                factorClientDatapoint = factorClientDatapoint.replace('>=', '');
                                factorComparison = '>=';
                            }
                            else if (factorClientDatapoint.includes('>')) {
                                factorClientDatapoint = factorClientDatapoint.replace('>', '');
                                factorComparison = '>';
                            }
                            else if (factorClientDatapoint.includes('<')) {
                                factorClientDatapoint = factorClientDatapoint.replace('<', '');
                                factorComparison = '<';
                            }
                            else {
                                current.metricList.forEach(function (metric) {
                                    if (metric['dataPoint'] === factorClientDatapoint) {
                                        factorComparison = metric['comparator'] || '';
                                    }
                                });
                            }
                            var factorOverallDataPoint = factorClientDatapoint;
                            var booleanOperator = $(this_1).find(".select_boolean_operator" + i + " option:selected").val() || '';
                            metrics.push({
                                factorClientDatapoint: factorClientDatapoint,
                                factorComparison: factorComparison,
                                factorOverallDataPoint: factorOverallDataPoint,
                                booleanOperator: booleanOperator
                            });
                        };
                        var this_1 = this;
                        for (var i = 1; i <= 6; i++) {
                            _loop_3(i);
                        }
                        var requestBodyRow = {
                            morningstarProductCategory: morningstarProductCategory,
                            productPortfolio: productPortfolio,
                            metrics: metrics,
                            fundId: fundId
                        };
                        requestBody.greenSpaceSettingsInput.push(requestBodyRow);
                    }
                });
                try {
                    current.service.saveMorningStarSettings(requestBody).then(function (res) {
                        $('#green-space-save-success').show();
                        current.updateGSHighLights();
                        saveButton.prop('disabled', true);
                        $(".green-space-waiting-icon-wrapper").hide();
                        exportButton.prop('disabled', false);
                        $("#nextMonth").show();
                    }).fail(function () {
                        $('#green-space-save-fail').show();
                    });
                }
                catch (error) {
                    $('#green-space-save-fail').show();
                }
            });
        };
        GreenSpace.prototype.saveAndSubmitLogic = function (current) {
            var exportButton = $(".green-space-export-button");
            var saveButton = $('#save-button');
            var submitButton = $('#submit-button');
            saveButton.prop('disabled', true);
            submitButton.prop('disabled', true);
            exportButton.prop('disabled', true);
            $(".green-space-waiting-icon-wrapper").show();
            var requestBody = {
                greenSpaceSettingsInput: []
            };
            var rows = $('.green-space-table > tbody > tr');
            rows.each(function (index, element) {
                var productPortfolio = $(this).find('.select_product_portfolio option:selected').text();
                var fundId = $(this).find('.select_product_portfolio option:selected').val();
                if (productPortfolio !== 'None') {
                    var morningstarProductCategory = $(this).find('.greenspace_table_morningstar_product_category_column').text();
                    var metrics = [];
                    var _loop_4 = function(i) {
                        var factorClientDatapoint = $(this_2).find(".select_metric" + i + " option:selected").val() || '';
                        var factorComparison = '';
                        if (factorClientDatapoint.includes('>=')) {
                            factorClientDatapoint = factorClientDatapoint.replace('>=', '');
                            factorComparison = '>=';
                        }
                        else if (factorClientDatapoint.includes('>')) {
                            factorClientDatapoint = factorClientDatapoint.replace('>', '');
                            factorComparison = '>';
                        }
                        else if (factorClientDatapoint.includes('<')) {
                            factorClientDatapoint = factorClientDatapoint.replace('<', '');
                            factorComparison = '<';
                        }
                        else {
                            current.metricList.forEach(function (metric) {
                                if (metric['dataPoint'] === factorClientDatapoint) {
                                    factorComparison = metric['comparator'] || '';
                                }
                            });
                        }
                        var factorOverallDataPoint = factorClientDatapoint; //$(this).find(`.select_metric${i} option:selected`).val() || ''
                        var booleanOperator = $(this_2).find(".select_boolean_operator" + i + " option:selected").val() || '';
                        metrics.push({
                            factorClientDatapoint: factorClientDatapoint,
                            factorComparison: factorComparison,
                            factorOverallDataPoint: factorOverallDataPoint,
                            booleanOperator: booleanOperator
                        });
                    };
                    var this_2 = this;
                    for (var i = 1; i <= 6; i++) {
                        _loop_4(i);
                    }
                    var requestBodyRow = {
                        morningstarProductCategory: morningstarProductCategory,
                        productPortfolio: productPortfolio,
                        metrics: metrics,
                        fundId: fundId
                    };
                    requestBody.greenSpaceSettingsInput.push(requestBodyRow);
                }
            });
            try {
                current.service.saveMorningStarSettings(requestBody).then(function (res) {
                    current.updateGSHighLights();
                    saveButton.prop('disabled', true);
                    $(".green-space-waiting-icon-wrapper").hide();
                    exportButton.prop('disabled', false);
                    current.submitGreenspaceDetails();
                    $("#nextMonth").show();
                }).fail(function () {
                    $('#green-space-save-fail').show();
                });
            }
            catch (error) {
                $('#green-space-save-fail').show();
            }
        };
        GreenSpace.prototype.updateGSHighLights = function () {
            var currentMonthGSRules = this.currentMonthGSRules;
            this.categoryList.forEach(function (category) {
                var currentRow = $("[id = \"" + category + "\"]");
                var currentMonthGS = currentMonthGSRules.find(function (element, i) {
                    if (element[1] === category)
                        return element;
                });
                var currentProductCell = currentRow.find('.greenspace_table_product_portfolio_column');
                if (currentMonthGS) {
                    if (currentProductCell.find('select option:selected').text() !== currentMonthGS[2]) {
                        currentProductCell.find('select').css('color', 'blue');
                        currentProductCell.find('select option').css('color', '');
                        currentProductCell.find('select option:selected').css('color', 'blue');
                    }
                    for (var i = 1; i <= 6; i++) {
                        var offset = (i * 2) + 1;
                        var currentMetricCell = currentRow.find(".greenspace_table_metric" + i + "_column");
                        var currentOperatorCell = currentRow.find(".greenspace_table_boolean_operator" + i + "_column");
                        if (currentMetricCell.find('select option:selected').val() !== (currentMonthGS[offset] || "")) {
                            currentMetricCell.find('select').css('color', 'blue');
                            currentMetricCell.find('select option').css('color', '');
                            currentMetricCell.find('select option:selected').css('color', 'blue');
                        }
                        if (currentOperatorCell.find('select option:selected').val() !== (currentMonthGS[offset + 1] || "") && i < 6) {
                            currentOperatorCell.find('select').css('color', 'blue');
                            currentOperatorCell.find('select option').css('color', '');
                            currentOperatorCell.find('select option:selected').css('color', 'blue');
                        }
                    }
                }
                else {
                    if (currentProductCell.find('select option:selected').val()) {
                        currentProductCell.find('select').css('color', 'blue');
                        currentProductCell.find('select option').css('color', '');
                        currentProductCell.find('select option:selected').css('color', 'blue');
                    }
                    for (var i = 1; i <= 6; i++) {
                        var currentMetricCell = currentRow.find(".greenspace_table_metric" + i + "_column");
                        var currentOperatorCell = currentRow.find(".greenspace_table_boolean_operator" + i + "_column");
                        if (currentMetricCell.find('select option:selected').val()) {
                            currentMetricCell.find('select').css('color', 'blue');
                            currentMetricCell.find('select option').css('color', '');
                            currentMetricCell.find('select option:selected').css('color', 'blue');
                        }
                        if (currentOperatorCell.find('select option:selected').val()) {
                            currentOperatorCell.find('select').css('color', 'blue');
                            currentOperatorCell.find('select option').css('color', '');
                            currentOperatorCell.find('select option:selected').css('color', 'blue');
                        }
                    }
                }
            });
        };
        GreenSpace.prototype.checkMetricsDisableSave = function () {
            var buttonEnabled = true;
            this.categoryList.forEach(function (category) {
                var currentRow = $("[id = \"" + category + "\"]");
                if (currentRow.find('.greenspace_table_product_portfolio_column').find('select option:selected').val()) {
                    if (!(currentRow.find('.greenspace_table_metric1_column').find('select option:selected').val())) {
                        buttonEnabled = false;
                    }
                }
            });
            return buttonEnabled;
        };
        GreenSpace.prototype.checkMetricsDisableSaveByCategory = function (category) {
            var buttonEnabled = true;
            var currentRow = $("[id = \"" + category + "\"]");
            if (currentRow.find('.greenspace_table_product_portfolio_column').find('select option:selected').val()) {
                if (!(currentRow.find('.greenspace_table_metric1_column').find('select option:selected').val())) {
                    buttonEnabled = false;
                }
            }
            return buttonEnabled;
        };
        GreenSpace.prototype.checkBooleanDisableSaveByCategory = function (category) {
            var buttonEnabled = true;
            var currentRow = $("[id = \"" + category + "\"]");
            if (currentRow.find('.greenspace_table_product_portfolio_column').find('select option:selected').val()) {
                currentRow.find(".greenspace_table_boolean_operator_column").find("select:enabled").each(function (i) {
                    var booleanLength = currentRow.find(".greenspace_table_boolean_operator_column").find("select:enabled").length;
                    var booleanEle = $(currentRow.find(".greenspace_table_boolean_operator_column").find("select:enabled")[booleanLength - 1]).val();
                    var metricValue = $(currentRow.find(".greenspace_table_metric_column").find("select:enabled")[booleanLength]).val();
                    if (booleanEle && !metricValue) {
                        buttonEnabled = false;
                    }
                });
            }
            ;
            /*this.categoryList.forEach(function (category: any) {
                let currentRow = $(`[id = "${category}"]`)

                if (currentRow.find('.greenspace_table_product_portfolio_column').find('select option:selected').val()) {
                    currentRow.find(".greenspace_table_boolean_operator_column").find("select:enabled").each((i: any) => {
                        let booleanLength = currentRow.find(".greenspace_table_boolean_operator_column").find("select:enabled").length;
                        let booleanEle = $(currentRow.find(".greenspace_table_boolean_operator_column").find("select:enabled")[booleanLength - 1]).val();
                        if (booleanEle) {
                            buttonEnabled = false;
                        }
                    });
                }
            });
            */
            return buttonEnabled;
        };
        GreenSpace.prototype.setProductPortfolioWidth = function () {
            var width = $(".greenspace_table_morningstar_product_category_column").width() + 16;
            // $('.greenspace_table_product_portfolio_column').attr('style', 'left:' + width + 'px');
            $('.greenspace_table_product_portfolio_column').css({
                'left': width + 'px',
            });
            $('.select_product_portfolio').css({
                'width': (this.productPortfolioMaxLength + 6) + 'ch'
            });
        };
        return GreenSpace;
    }());
    GreenSpaceSettings.GreenSpace = GreenSpace;
})(GreenSpaceSettings || (GreenSpaceSettings = {}));
$(document).ready(function () {
    var wrapper = $(".green-space-page-layout");
    if (wrapper.isEmpty()) {
        return;
    }
    new GreenSpaceSettings.GreenSpace(wrapper);
});
var ServiceStatus;
(function (ServiceStatus_1) {
    var HealthEnum;
    (function (HealthEnum) {
        HealthEnum[HealthEnum["GREEN"] = 0] = "GREEN";
        HealthEnum[HealthEnum["YELLOW"] = 1] = "YELLOW";
        HealthEnum[HealthEnum["RED"] = 2] = "RED";
    })(HealthEnum || (HealthEnum = {}));
    var ServiceStatus = (function () {
        function ServiceStatus(wrapper) {
            var statusWrapper = wrapper.find('.ws-service-status-wrapper');
            var elasticName = jQuery('<span/>', { 'class': 'ws-service-status-card-name', 'text': elasticVO.serviceName });
            var elasticInfo = jQuery('<div/>');
            this.build(statusWrapper, elasticName, elasticInfo);
            this.buildElasticSection(elasticInfo);
        }
        ServiceStatus.prototype.build = function (wrapper, name, info) {
            var card = jQuery('<div/>', { 'class': 'col-xs-5 ws-service-status-card' });
            var content = jQuery('<div/>', { 'class': 'ws-service-status-card-content' });
            var top = jQuery('<div/>', { 'class': 'ws-service-status-card-top' });
            var bottom = jQuery('<div/>', { 'class': 'ws-service-status-card-bottom' });
            top.append(name);
            bottom.append(info);
            content.append(top, bottom);
            card.append(content);
            wrapper.append(card);
        };
        ServiceStatus.prototype.buildElasticSection = function (info) {
            elasticVO.status.sort(function (curr, next) { return curr.name < next.name ? 1 : -1; });
            elasticVO.status.forEach(function (indexData) {
                var row = jQuery('<div/>', { 'class': 'ws-service-status-index' });
                var left = jQuery('<span/>');
                var icon = jQuery('<span/>');
                var indexName = jQuery('<span/>', { 'text': indexData.name });
                switch (indexData.health) {
                    case HealthEnum.GREEN:
                        icon.addClass('ws-service-status-index-online');
                        icon.append(jQuery('<span/>', { 'class': 'glyphicon glyphicon-ok' }));
                        break;
                    case HealthEnum.YELLOW:
                        icon.addClass('ws-service-status-index-warn');
                        icon.append(jQuery('<span/>', { 'class': 'glyphicon glyphicon-warning-sign' }));
                        break;
                    case HealthEnum.RED:
                        icon.addClass('ws-service-status-index-off');
                        icon.append(jQuery('<span/>', { 'class': 'glyphicon glyphicon-remove' }));
                        break;
                }
                left.append(icon, indexName);
                var right = jQuery('<span/>', { 'class': 'pull-right' });
                var documentCount = jQuery('<span/>', { 'class': 'semi-bold', 'text': strings.documentsLabel + ' ' });
                var documentCountValue = jQuery('<span/>', { 'text': indexData.documentCount });
                right.append(documentCount, documentCountValue);
                row.append(left, right);
                info.append(row);
            });
        };
        return ServiceStatus;
    }());
    ServiceStatus_1.ServiceStatus = ServiceStatus;
})(ServiceStatus || (ServiceStatus = {}));
(function (wrapper) {
    if (wrapper.isEmpty()) {
        return;
    }
    new ServiceStatus.ServiceStatus(wrapper);
})($('.ws-service-status-wrapper-container'));
var RoleFeatures;
(function (RoleFeatures) {
    var AdvisorTemplateSection = (function () {
        function AdvisorTemplateSection(AdvisorTemplateSection) {
            this.COLUMN_ELEMENTS_SIZE = 3;
            this.AdvisorTemplateSection = AdvisorTemplateSection;
            this.advisorCheckBoxes = new Array();
            this.buildersTemplatesCheckBoxes = new Array();
            this.initializeDOM();
        }
        AdvisorTemplateSection.prototype.initializeDOM = function () {
            var self = this;
            var columnsArray = new Array();
            var totalElements = roleFeaturesVO.advisorTemplate.length;
            var columnSize = Math.ceil(totalElements / this.COLUMN_ELEMENTS_SIZE);
            for (var i = 0; i < columnSize; i++) {
                columnsArray.push(jQuery('<div/>', { 'class': 'col-md-3' }));
            }
            var control = 0, indexColumnPosition = 0, indexed = {};
            roleFeaturesVO.savedOtherTemplateProducts.forEach(function (curr) {
                indexed[curr] = true;
            });
            var advisorData = roleFeaturesVO.advisorTemplate;
            advisorData.forEach(function (current, index) {
                var currentId = current.templateProductId;
                var checked = Boolean(indexed[currentId]);
                var checkbox = jQuery('<input/>', {
                    'type': 'checkbox',
                    'name': 'advisorProduct',
                    'value': currentId,
                    'checked': checked
                });
                var label = jQuery('<span/>', { 'text': " " + current.name, 'title': current.name });
                var br = jQuery('<br>');
                label.click(function () {
                    checkbox.prop(AdvisorTemplateSection.CHECKED_ATTR, !checkbox.prop(AdvisorTemplateSection.CHECKED_ATTR));
                }).disableSelection();
                var elementWrapper = jQuery('<div/>', { 'class': 'text-overflow' });
                elementWrapper.append(checkbox, label, br);
                columnsArray[indexColumnPosition].append(elementWrapper);
                control++;
                if (control === self.COLUMN_ELEMENTS_SIZE) {
                    control = 0;
                    indexColumnPosition++;
                }
                self.advisorCheckBoxes.push(checkbox);
            });
            columnsArray.forEach(function (current) {
                self.AdvisorTemplateSection.find('.wallet-share-advisor-template-section-list').append(current);
            });
            this.addButtonsEventListener();
        };
        AdvisorTemplateSection.prototype.addButtonsEventListener = function () {
            var selectAll = this.AdvisorTemplateSection.find('.wallet-share-select-all-custom');
            var selectNone = this.AdvisorTemplateSection.find('.wallet-share-select-none-custom');
            var self = this;
            selectAll.click(function () {
                self.advisorCheckBoxes.forEach(function (checkbox) {
                    checkbox.prop(AdvisorTemplateSection.CHECKED_ATTR, true);
                });
            });
            selectNone.click(function () {
                self.advisorCheckBoxes.forEach(function (checkbox) {
                    checkbox.prop(AdvisorTemplateSection.CHECKED_ATTR, false);
                });
            });
        };
        AdvisorTemplateSection.prototype.updateProductsOptionsVisibility = function (divOptions, checked) {
            if (checked) {
                divOptions.removeClass('hidden');
            }
            else {
                divOptions.addClass(' hidden');
            }
        };
        AdvisorTemplateSection.prototype.hasErrors = function () {
            return false;
        };
        AdvisorTemplateSection.prototype.clearError = function () {
        };
        AdvisorTemplateSection.prototype.showError = function () {
        };
        AdvisorTemplateSection.prototype.val = function () {
            var self = this;
            var arrayToSave = new Array();
            this.advisorCheckBoxes.forEach(function (checkbox, index) {
                if (checkbox.is(AdvisorTemplateSection.NOT_CHECKED_PROP)) {
                    var arrayValtoSave = new Array();
                    //add product name to sub array
                    var productName = checkbox.siblings('span').text().trim();
                    arrayValtoSave.push(productName);
                    //add to return array
                    arrayToSave.push(arrayValtoSave);
                }
            });
            return arrayToSave;
        };
        AdvisorTemplateSection.CHECKED_ATTR = 'checked';
        AdvisorTemplateSection.NOT_CHECKED_PROP = ':not(:checked)';
        return AdvisorTemplateSection;
    }());
    RoleFeatures.AdvisorTemplateSection = AdvisorTemplateSection;
})(RoleFeatures || (RoleFeatures = {}));
var RoleFeatures;
(function (RoleFeatures) {
    var AdvisorTeamTemplateSection = (function () {
        function AdvisorTeamTemplateSection(AdvisorTemplateSection) {
            this.COLUMN_ELEMENTS_SIZE = 3;
            this.AdvisorTeamTemplateSection = AdvisorTemplateSection;
            this.advisorTeamCheckBoxes = new Array();
            this.buildersTemplatesCheckBoxes = new Array();
            this.initializeDOM();
        }
        AdvisorTeamTemplateSection.prototype.initializeDOM = function () {
            var self = this;
            var columnsArray = new Array();
            var totalElements = roleFeaturesVO.advisorTeamTemplate.length;
            var columnSize = Math.ceil(totalElements / this.COLUMN_ELEMENTS_SIZE);
            for (var i = 0; i < columnSize; i++) {
                columnsArray.push(jQuery('<div/>', { 'class': 'col-md-3' }));
            }
            var control = 0, indexColumnPosition = 0, indexed = {};
            roleFeaturesVO.savedOtherTemplateProducts.forEach(function (curr) {
                indexed[curr] = true;
            });
            var advisorData = roleFeaturesVO.advisorTeamTemplate;
            advisorData.forEach(function (current, index) {
                var currentId = current.templateProductId;
                var checked = Boolean(indexed[currentId]);
                var checkbox = jQuery('<input/>', {
                    'type': 'checkbox',
                    'name': 'advisorTeamProduct',
                    'value': currentId,
                    'checked': checked
                });
                var label = jQuery('<span/>', { 'text': " " + current.name, 'title': current.name });
                var br = jQuery('<br>');
                label.click(function () {
                    checkbox.prop(AdvisorTeamTemplateSection.CHECKED_ATTR, !checkbox.prop(AdvisorTeamTemplateSection.CHECKED_ATTR));
                }).disableSelection();
                var elementWrapper = jQuery('<div/>', { 'class': 'text-overflow' });
                elementWrapper.append(checkbox, label, br);
                columnsArray[indexColumnPosition].append(elementWrapper);
                control++;
                if (control === self.COLUMN_ELEMENTS_SIZE) {
                    control = 0;
                    indexColumnPosition++;
                }
                self.advisorTeamCheckBoxes.push(checkbox);
            });
            columnsArray.forEach(function (current) {
                self.AdvisorTeamTemplateSection.find('.wallet-share-advisor-team-template-section-list').append(current);
            });
            this.addButtonsEventListener();
        };
        AdvisorTeamTemplateSection.prototype.addButtonsEventListener = function () {
            var selectAll = this.AdvisorTeamTemplateSection.find('.wallet-share-select-all-custom');
            var selectNone = this.AdvisorTeamTemplateSection.find('.wallet-share-select-none-custom');
            var self = this;
            selectAll.click(function () {
                self.advisorTeamCheckBoxes.forEach(function (checkbox) {
                    checkbox.prop(AdvisorTeamTemplateSection.CHECKED_ATTR, true);
                });
            });
            selectNone.click(function () {
                self.advisorTeamCheckBoxes.forEach(function (checkbox) {
                    checkbox.prop(AdvisorTeamTemplateSection.CHECKED_ATTR, false);
                });
            });
        };
        AdvisorTeamTemplateSection.prototype.updateProductsOptionsVisibility = function (divOptions, checked) {
            if (checked) {
                divOptions.removeClass('hidden');
            }
            else {
                divOptions.addClass(' hidden');
            }
        };
        AdvisorTeamTemplateSection.prototype.hasErrors = function () {
            return false;
        };
        AdvisorTeamTemplateSection.prototype.clearError = function () {
        };
        AdvisorTeamTemplateSection.prototype.showError = function () {
        };
        AdvisorTeamTemplateSection.prototype.val = function () {
            var self = this;
            var arrayToSave = new Array();
            this.advisorTeamCheckBoxes.forEach(function (checkbox, index) {
                if (checkbox.is(AdvisorTeamTemplateSection.NOT_CHECKED_PROP)) {
                    var arrayValtoSave = new Array();
                    //add product name to sub array
                    var productName = checkbox.siblings('span').text().trim();
                    arrayValtoSave.push(productName);
                    //add to return array
                    arrayToSave.push(arrayValtoSave);
                }
            });
            return arrayToSave;
        };
        AdvisorTeamTemplateSection.CHECKED_ATTR = 'checked';
        AdvisorTeamTemplateSection.NOT_CHECKED_PROP = ':not(:checked)';
        return AdvisorTeamTemplateSection;
    }());
    RoleFeatures.AdvisorTeamTemplateSection = AdvisorTeamTemplateSection;
})(RoleFeatures || (RoleFeatures = {}));
var RoleFeatures;
(function (RoleFeatures) {
    var AlternativesTemplateSection = (function () {
        function AlternativesTemplateSection(AlternativesTemplateSection) {
            this.COLUMN_ELEMENTS_SIZE = 3;
            this.AlternativesTemplateSection = AlternativesTemplateSection;
            this.alternativesCheckBoxes = new Array();
            this.buildersTemplatesCheckBoxes = new Array();
            this.initializeDOM();
        }
        AlternativesTemplateSection.prototype.initializeDOM = function () {
            var self = this;
            var columnsArray = new Array();
            var totalElements = roleFeaturesVO.alternativesTemplate.length;
            var columnSize = Math.ceil(totalElements / this.COLUMN_ELEMENTS_SIZE);
            for (var i = 0; i < columnSize; i++) {
                columnsArray.push(jQuery('<div/>', { 'class': 'col-md-3' }));
            }
            var control = 0, indexColumnPosition = 0, indexed = {};
            roleFeaturesVO.savedOtherTemplateProducts.forEach(function (curr) {
                indexed[curr] = true;
            });
            var alternativesData = roleFeaturesVO.alternativesTemplate;
            alternativesData.forEach(function (current, index) {
                var currentId = current.templateProductId;
                var checked = Boolean(indexed[currentId]);
                var checkbox = jQuery('<input/>', {
                    'type': 'checkbox',
                    'name': 'alternativesProduct',
                    'value': currentId,
                    'checked': checked
                });
                var label = jQuery('<span/>', { 'text': " " + current.name, 'title': current.name });
                var br = jQuery('<br>');
                label.click(function () {
                    checkbox.prop(AlternativesTemplateSection.CHECKED_ATTR, !checkbox.prop(AlternativesTemplateSection.CHECKED_ATTR));
                }).disableSelection();
                var elementWrapper = jQuery('<div/>', { 'class': 'text-overflow' });
                elementWrapper.append(checkbox, label, br);
                columnsArray[indexColumnPosition].append(elementWrapper);
                control++;
                if (control === self.COLUMN_ELEMENTS_SIZE) {
                    control = 0;
                    indexColumnPosition++;
                }
                self.alternativesCheckBoxes.push(checkbox);
            });
            columnsArray.forEach(function (current) {
                self.AlternativesTemplateSection.find('.wallet-share-alternatives-template-section-list').append(current);
            });
            this.addButtonsEventListener();
        };
        AlternativesTemplateSection.prototype.addButtonsEventListener = function () {
            var selectAll = this.AlternativesTemplateSection.find('.wallet-share-select-all-custom');
            var selectNone = this.AlternativesTemplateSection.find('.wallet-share-select-none-custom');
            var self = this;
            selectAll.click(function () {
                self.alternativesCheckBoxes.forEach(function (checkbox) {
                    checkbox.prop(AlternativesTemplateSection.CHECKED_ATTR, true);
                });
            });
            selectNone.click(function () {
                self.alternativesCheckBoxes.forEach(function (checkbox) {
                    checkbox.prop(AlternativesTemplateSection.CHECKED_ATTR, false);
                });
            });
        };
        AlternativesTemplateSection.prototype.updateProductsOptionsVisibility = function (divOptions, checked) {
            if (checked) {
                divOptions.removeClass('hidden');
            }
            else {
                divOptions.addClass(' hidden');
            }
        };
        AlternativesTemplateSection.prototype.hasErrors = function () {
            return false;
        };
        AlternativesTemplateSection.prototype.clearError = function () {
        };
        AlternativesTemplateSection.prototype.showError = function () {
        };
        AlternativesTemplateSection.prototype.val = function () {
            var self = this;
            var arrayToSave = new Array();
            this.alternativesCheckBoxes.forEach(function (checkbox, index) {
                if (checkbox.is(AlternativesTemplateSection.NOT_CHECKED_PROP)) {
                    var arrayValtoSave = new Array();
                    //add product name to sub array
                    var productName = checkbox.siblings('span').text().trim();
                    arrayValtoSave.push(productName);
                    //add to return array
                    arrayToSave.push(arrayValtoSave);
                }
            });
            return arrayToSave;
        };
        AlternativesTemplateSection.CHECKED_ATTR = 'checked';
        AlternativesTemplateSection.NOT_CHECKED_PROP = ':not(:checked)';
        return AlternativesTemplateSection;
    }());
    RoleFeatures.AlternativesTemplateSection = AlternativesTemplateSection;
})(RoleFeatures || (RoleFeatures = {}));
var RoleFeatures;
(function (RoleFeatures) {
    var BiPlatformTemplateSection = (function () {
        function BiPlatformTemplateSection(BiPlatformTemplateSection) {
            this.COLUMN_ELEMENTS_SIZE = 3;
            this.BiPlatformTemplateSection = BiPlatformTemplateSection;
            this.biPlatformCheckBoxes = new Array();
            this.buildersTemplatesCheckBoxes = new Array();
            this.initializeDOM();
        }
        BiPlatformTemplateSection.prototype.initializeDOM = function () {
            var self = this;
            var columnsArray = new Array();
            var totalElements = roleFeaturesVO.biPlatformTemplate.length;
            var columnSize = Math.ceil(totalElements / this.COLUMN_ELEMENTS_SIZE);
            for (var i = 0; i < columnSize; i++) {
                columnsArray.push(jQuery('<div/>', { 'class': 'col-md-3' }));
            }
            var control = 0, indexColumnPosition = 0, indexed = {};
            roleFeaturesVO.savedOtherTemplateProducts.forEach(function (curr) {
                indexed[curr] = true;
            });
            var biPlatformData = roleFeaturesVO.biPlatformTemplate;
            biPlatformData.forEach(function (current, index) {
                var currentId = current.templateProductId;
                var checked = Boolean(indexed[currentId]);
                var checkbox = jQuery('<input/>', {
                    'type': 'checkbox',
                    'name': 'biPlatformProduct',
                    'value': currentId,
                    'checked': checked
                });
                var label = jQuery('<span/>', { 'text': " " + current.name, 'title': current.name });
                var br = jQuery('<br>');
                label.click(function () {
                    checkbox.prop(BiPlatformTemplateSection.CHECKED_ATTR, !checkbox.prop(BiPlatformTemplateSection.CHECKED_ATTR));
                }).disableSelection();
                var elementWrapper = jQuery('<div/>', { 'class': 'text-overflow' });
                elementWrapper.append(checkbox, label, br);
                columnsArray[indexColumnPosition].append(elementWrapper);
                control++;
                if (control === self.COLUMN_ELEMENTS_SIZE) {
                    control = 0;
                    indexColumnPosition++;
                }
                self.biPlatformCheckBoxes.push(checkbox);
            });
            columnsArray.forEach(function (current) {
                self.BiPlatformTemplateSection.find('.wallet-share-bi-platform-template-section-list').append(current);
            });
            this.addButtonsEventListener();
        };
        BiPlatformTemplateSection.prototype.addButtonsEventListener = function () {
            var selectAll = this.BiPlatformTemplateSection.find('.wallet-share-select-all-custom');
            var selectNone = this.BiPlatformTemplateSection.find('.wallet-share-select-none-custom');
            var self = this;
            selectAll.click(function () {
                self.biPlatformCheckBoxes.forEach(function (checkbox) {
                    checkbox.prop(BiPlatformTemplateSection.CHECKED_ATTR, true);
                });
            });
            selectNone.click(function () {
                self.biPlatformCheckBoxes.forEach(function (checkbox) {
                    checkbox.prop(BiPlatformTemplateSection.CHECKED_ATTR, false);
                });
            });
        };
        BiPlatformTemplateSection.prototype.updateProductsOptionsVisibility = function (divOptions, checked) {
            if (checked) {
                divOptions.removeClass('hidden');
            }
            else {
                divOptions.addClass(' hidden');
            }
        };
        BiPlatformTemplateSection.prototype.hasErrors = function () {
            return false;
        };
        BiPlatformTemplateSection.prototype.clearError = function () {
        };
        BiPlatformTemplateSection.prototype.showError = function () {
        };
        BiPlatformTemplateSection.prototype.val = function () {
            var self = this;
            var arrayToSave = new Array();
            this.biPlatformCheckBoxes.forEach(function (checkbox, index) {
                if (checkbox.is(BiPlatformTemplateSection.NOT_CHECKED_PROP)) {
                    var arrayValtoSave = new Array();
                    //add product name to sub array
                    var productName = checkbox.siblings('span').text().trim();
                    arrayValtoSave.push(productName);
                    //add to return array
                    arrayToSave.push(arrayValtoSave);
                }
            });
            return arrayToSave;
        };
        BiPlatformTemplateSection.CHECKED_ATTR = 'checked';
        BiPlatformTemplateSection.NOT_CHECKED_PROP = ':not(:checked)';
        return BiPlatformTemplateSection;
    }());
    RoleFeatures.BiPlatformTemplateSection = BiPlatformTemplateSection;
})(RoleFeatures || (RoleFeatures = {}));
var CompInsights;
(function (CompInsights) {
    var Strings = (function () {
        function Strings() {
        }
        //info icon
        Strings.COMP_INSIGHT_ICON_MSG_P1 = 'The Opportunity Scores within the grid are calculated using the Morningstar metrics and corresponding metrics shown below, looking to determine where your product’s performance has a competitive advantage. Sales Green Space and AUM Green Space, with higher competitive sales and assets identify areas of opportunity. For Merrill Lynch, the scoring has been modified as assets data is not available. For this firm only, assets are not included in the Opportunity scoring mechanism.';
        Strings.COMP_INSIGHT_ICON_MSG_P2 = 'Risk Scores are calculated to show where assets are at risk based on areas where your product has a higher market share but less competitive advantage and where managers may be open to new funds.';
        Strings.COMP_INSIGHT_ICON_MSG_P3 = 'See details below:';
        Strings.COMP_INSIGHT_METHODOLOGIES_MSG_P4 = 'Platform Code data is currently available for Morgan Stanley, LPL and Ameriprise, when data is provided during the quarterly submission process. If you would like to see Platform Code data, please contact the WalletShare team for more information.';
        Strings.COMP_INSIGHT_METHODOLOGIES_MSG_P5 = 'Certain information on this site is © 2022 Morningstar. All Rights Reserved. The information contained herein: (1) is proprietary to Morningstar and/or its content providers; (2) may not be copied or distributed; and (3) is not warranted to be accurate, complete or timely. Neither Morningstar nor its content providers are responsible for any damages or losses arising from any use of this information. Past performance is no guarantee of future results.';
        Strings.COMP_INSIGHT_ICON_MSGS = [Strings.COMP_INSIGHT_ICON_MSG_P1, Strings.COMP_INSIGHT_ICON_MSG_P2, Strings.COMP_INSIGHT_ICON_MSG_P3];
        Strings.OPPORTUNITY_SCORE_METRICS = 'Opportunity Score Metrics';
        Strings.RISK_SCORE_METRICS = 'Risk Score Metrics';
        Strings.SALES_MARKET_SHARE = 'Sales Market Share';
        Strings.COMPETITIVE_SALES = 'Competitive Sales';
        Strings.AUM_MARKET_SHARE = 'AUM Market Share';
        Strings.COMPETITIVE_ASSETS = 'Competitive Assets';
        Strings.RED_SPACE = 'Red Space';
        Strings.MARKET_SHARE_LOWER_IS_BETTER = 'Market Share (lower is better)';
        Strings.SALES_GREEN_SPACE_LOWER_IS_BETTER = 'Sales Green Space (lower is better)';
        Strings.NEW_MANAGER_RECEPTIVITY = 'New Manager Receptivity';
        Strings.LABEL_10_PERCENT = '10%';
        Strings.LABEL_15_PERCENT = '15%';
        Strings.LABEL_20_PERCENT = '20%';
        Strings.LABEL_25_PERCENT = '25%';
        Strings.INFO_SALES_GREEN_SPACE = 'Green Space within the Platform Breakdown tab is calculated using the Morningstar metrics that are the Key Sales Drivers for this category. See the Key Sales Drivers tab for more information on this category.';
        Strings.INFO_AUM_GREEN_SPACE = 'AUM Green Space within the Platform Breakdown tab is calculated using the Morningstar metrics that are the Key Sales Drivers for this category. See the Key Sales Drivers tab for more information on this category.';
        Strings.INFO_RED_SPACE_MSG = 'What is Red Space?';
        Strings.INFO_RED_SPACE_1 = 'Asset rating and expense - unfavorable matchups against the competition';
        Strings.INFO_RED_SPACE_2 = 'Client assets vs. competitive sales';
        Strings.INFO_RED_SPACE_3 = 'Potential redemption warning';
        Strings.INFO_RED_SPACE_4 = 'Matchups are based on Morningstar metrics that are key sales drivers for the category (see Key Sales Drivers tab for more information on this category)';
        //Grid
        Strings.HIGHEST = "Highest";
        Strings.HIGH = "High";
        Strings.LOWEST = "Lowest";
        Strings.LOW = "Low";
        Strings.OPPORTUNITY = "Opportunity";
        Strings.RISK = "Risk";
        Strings.FIRM = "Firm";
        Strings.PRODUCT = "Product";
        //Ranking 
        Strings.GROSSALESRANK = "Gross Sales Rank";
        Strings.NETSALESRANK = "Net Sales Rank";
        Strings.AUMRANK = "AUM Rank";
        Strings.RANKING_TRENDS = 'Ranking Trends';
        Strings.ASSET_MANAGER = 'Asset <br /> Manager';
        Strings.HEADERS = [{ label: Strings.GROSSALESRANK, value: 'grossSalesRank' }, { label: Strings.NETSALESRANK, value: 'netSalesRank' }, { label: Strings.AUMRANK, value: 'aumRank' }];
        //Key Sales Drivers
        Strings.KEY_SALES_DRIVERS = "Key Sales Drivers";
        Strings.KEY_DRIVERS = "Key Drivers";
        Strings.LARGEST_ADVANTAGE = "Largest Advantage";
        Strings.ANALYTICS_MATCHUPS = "Analytics Matchups";
        Strings.METRIC = "Metric";
        Strings.YOUR_FUND = "Your Fund";
        Strings.COMPETITIVE_FUNDS = "Competitive Funds";
        Strings.COMPETITIVE = "Competitive";
        Strings.FUNDS = "Funds";
        Strings.DIFFERENCE = "Difference";
        Strings.PERCENT_DIFFERENCE = "Percent Difference";
        Strings.PERCENT = "Percent";
        Strings.PERCENTILE = "Percentile";
        Strings.NO_KEY_SALES_DRIVERS_DATA_NOTE = "Due to the size of this category (number of products / number of transactions), calculating Key Sales Drivers was not possible.";
        //platform breakdown
        Strings.PLATFORM_GLOBAL = 'Global';
        Strings.PLATFORM_CLIENT = 'Client';
        Strings.PLATFORM_SALES = 'Sales';
        Strings.PLATFORM_GROSS = "Gross";
        Strings.PLATFORM_NET = "Net";
        Strings.PLATFORM_AUM = "AUM";
        Strings.PLATFORM_CHART_TITLE = "Sales Breakdown by Platform Type";
        Strings.PLATFORM_AUM_CHART_TITLE = "AUM Breakdown by Platform Type";
        Strings.PLATFORM_BREAKDOWN = "Platform Breakdown";
        Strings.PLATFORM_TITLE = "Gross, Net & AUM by Platform Name";
        Strings.PLATFORM_TYPE = "Platform Type";
        Strings.PLATFORM_CLIENT_SALES = "Client Sales ($M)";
        Strings.PLATFORM_GLOBAL_SALES = "Global Sales ($M)";
        Strings.PLATFORM_SALES_TH = "Sales";
        Strings.PLATFORM_DOLLAR_M = "($M)";
        Strings.PLATFORM_MARKET_SHARE = "Market Share (%)";
        Strings.PLATFORM_SALES_GREEN_SPACE = "Sales Green Space";
        Strings.PLATFORM_RANK = "Rank";
        Strings.PLATFORM_PREVIOUS_RANK = "Previous Rank";
        Strings.PLATFORM_PRODUCTS = "Products";
        Strings.PLATFORM_CLIENT_NET_SALES = "Client Net Sales ($M)";
        Strings.PLATFORM_GLOBAL_NET_SALES = "Global Net Sales ($M)";
        Strings.PLATFORM_CLIENT_AUM = "Client AUM ($M)";
        Strings.PLATFORM_GLOBAL_AUM = "Global AUM ($M)";
        Strings.PLATFORM_AUM_GREEN_SPACE = "AUM Green Space";
        Strings.COMP_SALES_WITHOUT_ADV_LABEL = "Competitive Sales without Advantages";
        Strings.COMP_ASSETS_WITHOUT_ADV_LABEL = "Competitive Assets without Advantages";
        Strings.GREEN_SPACE_COMP_SALES_WITH_ADV_LABEL = "Sales Green Space (Transactions where your products have a competitive advantage)";
        Strings.RED_SPACE_COMP_SALES_WITH_ADV_LABEL = "Sales Red Space (Transactions at risk when compared to competitive products)";
        Strings.GREEN_SPACE_COMP_ASSETS_WITH_ADV_LABEL = "AUM Green Space (Assets where your products have a competitive advantage)";
        Strings.RED_SPACE_COMP_ASSETS_WITH_ADV_LABEL = "AUM Red Space (Assets at risk when compared to competitive products)";
        Strings.AVERAGE_LABEL = "Average: {0}";
        Strings.REVIEW_FILTERS_TITLE = 'Your search did not return any results.';
        Strings.REVIEW_FILTERS_SUBTITLE = 'Please review the filter selections and try again.';
        //opportunties
        Strings.EXPORT_BUTTON_READY_TEXT = "Select Territories to export";
        Strings.EXPORT_BUTTON_UNREADY_TEXT = "Export Territories";
        Strings.TERRITORY = "Territory";
        Strings.MARKET_SHARE_DIFF = "% Difference<br>from Avg<br>Market Share";
        Strings.DIFF_EXPECTED_SALES = "% Difference<br>Expected Sales";
        Strings.EXPECTED_SALES = "Expected Sales";
        Strings.ACTUAL_SALES = "Actual Sales";
        Strings.INDUSTRY_GROSS_SALES = "Industry Sales";
        Strings.MARKET_SHARE = "Avg Market Share";
        Strings.GREEN_SPACE = "Sales<br>Green Space";
        Strings.NET_SALES = "Net<br>Sales";
        Strings.INDUSTRY_NET_SALES = "Industry<br>Net Sales";
        Strings.SCATTERPLOT_CLIENT_SALES = "Client Net Sales";
        Strings.SCATTERPLOT_EXPECTED_SALES = "Expected Sales";
        Strings.NOT_AVAILABLE = "NA";
        Strings.CLIENT_GROSS_SALES_LABEL = "Client Sales";
        Strings.EXPECTED_SALES_LABEL = "Expected Sales";
        Strings.GLOBAL_GROSS_SALES_LABEL = "Global Sales";
        Strings.MARKET_SHARE_LABEL = "Market Share";
        Strings.SALES_GREEN_SPACE_LABEL = "Sales Green Space";
        Strings.CLIENT_NET_SALES_LABEL = "Client Net Sales";
        Strings.GLOBAL_NET_SALES_LABEL = "Global Net Sales";
        Strings.CLIENT_AUM_LABEL = "Client AUM";
        Strings.INDUSTRY_AUM_LABEL = "Industry AUM";
        Strings.AUM_GREEN_SPACE_LABEL = "AUM Green Space";
        Strings.ADDRESS = "Address";
        Strings.OFFICE = "Office";
        Strings.CLIENT_SALES_HEADER = "Client Net<br>Sales";
        Strings.EXPECTED_SALES_HEADER = "Expected<br>Sales";
        Strings.CLIENT_GROSS_SALES_HEADER = "Client Sales";
        Strings.GLOBAL_GROSS_SALES_HEADER = "Global Sales";
        Strings.MARKET_SHARE_HEADER = "Market Share";
        Strings.SALES_GREEN_SPACE_HEADER = "Sales Green<br>Space";
        Strings.CLIENT_NET_SALES_HEADER = "Client Net Sales";
        Strings.GLOBAL_NET_SALES_HEADER = "Global Net<br>Sales";
        Strings.CLIENT_AUM_HEADER = "Client AUM";
        Strings.INDUSTRY_AUM_HEADER = "Industry AUM";
        Strings.AUM_GREEN_SPACE_HEADER = "AUM Green<br>Space";
        Strings.DIFF_EXPECTED_SALES_HEADER = "% Difference<br>Expected Sales";
        Strings.DOLLAR_DIFFERENCE_HEADER = "$ Difference";
        //analycisc
        Strings.DOLLAR_DIFFERENCE_LABEL = "$ Difference";
        Strings.CATEGORY_LABEL = "Category";
        Strings.GLOBAL_SALES_LABEL = "Global Sales";
        Strings.EXPECTED_SALES_ANALYTICS_HEADER = "Expected Sales";
        Strings.ACTUAL_SALES_ANALYTICS_HEADER = "Actual Sales";
        Strings.GLOBAL_GROSS_SALES_ANALYTICS_HEADER = "Global Sales";
        Strings.MARKET_SHARE_ANALYTICS_HEADER = "Market Share";
        Strings.SALES_GREEN_SPACE_ANALYTICS_HEADER = "Sales Green Space";
        Strings.AUM_GREEN_SPACE_ANALYTICS_HEADER = "AUM Green Space";
        Strings.DIFF_EXPECTED_SALES_ANALYTICS_HEADER = "% Difference Expected Sales";
        //pdfmakeHeading
        Strings.PERCENT_DIFF_PDF = "% Difference from \nAvg Market Share";
        Strings.DIFF_EXPECTED_SALES_PDF = "% Difference\n Expected Sales";
        Strings.EXPECTED_SALES_PDF = "Expected\n Sales";
        Strings.ACTUAL_SALES_PDF = "Actual\n Sales";
        Strings.INDUSTRY_GROSS_SALES_PDF = "Industry \n Gross Sales";
        Strings.GREEN_SPACE_PDF = "Sales \n Green Space";
        Strings.NET_SALES_PDF = "Net \n Sales";
        Strings.INDUSTRY_NET_SALES_PDF = "Industry \n Net Sales";
        Strings.MARKET_SHARE_PDF = "Market\n Share";
        //Sales Trends
        Strings.SALES_TRENDS_HEADER = [{ label: 'Industry Sales', value: 'industrySales' }, { label: 'Market Share', value: 'marketShare' }];
        Strings.SALES_CONCENTRATION_TRENDS_HEADER = [{ label: "Total Sales", value: 'totalSales' }, { label: "% Total Sales", value: 'percentTotalSales' },
            { label: "Net Sales", value: 'netSales' }, { label: "Total AUM", value: 'totalAum' }, { label: "% AUM", value: 'percentAum' }];
        return Strings;
    }());
    CompInsights.Strings = Strings;
})(CompInsights || (CompInsights = {}));
var CompInsights;
(function (CompInsights) {
    var DataManager = (function () {
        function DataManager() {
            this.opportunityScoresUrl = '/getCompInsightsOpportunityScores';
            this.salesTrendsUrl = '/getCompSalesTrends';
            this.getRanksByQuarterURL = '/getCompRanksByQuarter';
            this.getQuarterInfoURL = '/getQuarterInfo';
            this.getAssetManagerRanksByTypeURL = '/getAssetManagerRanksByType';
            this.keySalesdriversUrl = '/getCompKeySalesDrivers';
            this.opportunitiesUrl = '/getCompOpportunitiesUrl';
            this.getAnalyticsUrl = '/getCompAnalyticsUrl';
            this.platformBreakdownUrl = '/getCompPlatformBreakdown';
            this.getPlatformCodesURL = '/getPlatformCodes';
            this.getZippedExcelFileURL = '/getZippedExcelFile';
            this.getScatterPlotTerritoryUrl = '/getScatterPlotTerritoryData';
            this.getPDFLogoUrl = '/getPDFLogoData';
            this.getScatterPlotOfficeUrl = '/getScatterPlotOfficeData';
            this.getCompInsightsTabInfoUrl = '/getCompInsightsTabInfo';
            this.getProductsAndFirmsCountUrl = '/getProductsAndFirmsCount';
        }
        DataManager.prototype.baseAjax = function (method, url, data) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            jQuery.ajax({
                'method': method,
                'url': url,
                'data': data,
                'contentType': 'application/json',
                'dataType': 'json'
            }).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getZippedExcelFile = function (firmName, category, territories, exportCategory, exportType, exportNumber) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                "firmName": firmName,
                "category": category,
                "territories": territories,
                "exportCategory": exportCategory,
                "exportType": exportType,
                "exportNumber": exportNumber
            };
            this.baseAjax('POST', this.getZippedExcelFileURL, JSON.stringify(payload)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getOpportunityScores = function (firmPageNumber, productPageNumber) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                "firmPageNumber": firmPageNumber,
                "productPageNumber": productPageNumber
            };
            this.baseAjax('POST', this.opportunityScoresUrl, JSON.stringify(payload)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getProductsAndFirmsCount = function () {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('GET', this.getProductsAndFirmsCountUrl, null).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getSalesTrends = function (firmName, category, portfolio) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                "firmName": firmName,
                "category": category,
                "portfolio": portfolio
            };
            this.baseAjax('POST', this.salesTrendsUrl, JSON.stringify(payload)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getKeySalesDrivers = function (firmName, category, portfolio) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                "firmName": firmName,
                "category": category,
                "portfolio": portfolio
            };
            this.baseAjax('POST', this.keySalesdriversUrl, JSON.stringify(payload)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getOpportunities = function (firmName, category, portfolio) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                "firmName": firmName,
                "category": category,
                "portfolio": portfolio
            };
            this.baseAjax('POST', this.opportunitiesUrl, JSON.stringify(payload)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getPlatformBreakdown = function (firmName, category, portfolio) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                "firmName": firmName,
                "category": category,
                "portfolio": portfolio
            };
            this.baseAjax('POST', this.platformBreakdownUrl, JSON.stringify(payload)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getRanksByQuarter = function (payload) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('POST', this.getRanksByQuarterURL, JSON.stringify(payload)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getQuarterInfo = function () {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('POST', this.getQuarterInfoURL, JSON.stringify({})).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getAssetManagerRanksByType = function (payload) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('POST', this.getAssetManagerRanksByTypeURL, JSON.stringify(payload)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getPlatformCodes = function (payload) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('POST', this.getPlatformCodesURL, JSON.stringify(payload)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getCompInsightsTabInfo = function (payload) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('POST', this.getCompInsightsTabInfoUrl, JSON.stringify(payload)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getScatterPlotTerritoryData = function (payload) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('POST', this.getScatterPlotTerritoryUrl, JSON.stringify(payload)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getPDFLogoData = function () {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = "";
            this.baseAjax('POST', this.getPDFLogoUrl, JSON.stringify(payload)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getScatterPlotOfficeData = function (payload) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.baseAjax('POST', this.getScatterPlotOfficeUrl, JSON.stringify(payload)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        DataManager.prototype.getAnalyticsData = function (firmName, category, portfolio) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                "firmName": firmName,
                "category": category,
                "portfolio": portfolio
            };
            this.baseAjax('POST', this.getAnalyticsUrl, JSON.stringify(payload)).then(function (data) {
                deferred.resolveWith(window, [data]);
            });
            return promise;
        };
        return DataManager;
    }());
    CompInsights.DataManager = DataManager;
})(CompInsights || (CompInsights = {}));
var CompInsights;
(function (CompInsights) {
    var MockData = (function () {
        function MockData() {
            this.mockDataAnalytics1 = [
                "BD Field Connecticut",
                "BD Field Mid-America",
                "BD Field Metro Chicago",
                "BD Field Texas North",
                "BD Field Metro DC",
                "BD Field Ohio North",
                "BD Field New Jersey South",
                "BD Field Long Island",
                "RRB Team West",
                "RRB Team Great Plains",
                "BD Field Michigan West",
                "BD Field Metro LA",
                "BD Field Chicago West",
                "BD Field San Diego",
                "RRB Team New York Metro",
                "BD Field Virginia",
                "RRB Team Midwest",
                "BD Field Carolina West",
                "BD Field Twin Cities",
                "BD Field LA North",
                "BD Field Wisconsin East",
                "BD Field California North",
                "BD Field Mountain West",
                "BD Field West Central",
                "BD Field Indiana",
                "RRB Team Great Lakes",
                "BD Field New Jersey North",
                "BD Field New York Upstate",
                "BD Field Florida South",
                "BD Field Orange County",
                "BD Field Ohio South",
                "BD Field Gulf Coast",
                "BD Field Metro Boston",
                "BD Field South Atlantic",
                "BD Field Pennsylvania West",
                "BD Field Metro Detroit",
                "BD Field Pacific Northwest",
                "BD Field South Central",
                "BD Field Colorado",
                "BD Field Greater Baltimore",
                "BD Field Texas West",
                "BD Field Metro Atlanta",
                "UNKNOWN",
                "BD Field Texas South",
                "BD Field New England North",
                "BD Field Metro Seattle",
                "RRB Team Southeast",
                "BD Field St. Louis",
                "BD Field Southwest",
                "BD Field Upper Plains"
            ];
            this.mockDataAnalytics2 = {
                data4: [
                    {
                        "color": "#ea8d6f",
                        "y": -1.854145894626157
                    },
                    {
                        "color": "#ea9073",
                        "y": -1.7949713834768617
                    },
                    {
                        "color": "#ea9478",
                        "y": -1.729054926680086
                    },
                    {
                        "color": "#ea9479",
                        "y": -1.7137763849478165
                    },
                    {
                        "color": "#ea967b",
                        "y": -1.6834365340509403
                    },
                    {
                        "color": "#eb9e86",
                        "y": -1.5200420721473602
                    },
                    {
                        "color": "#eba48d",
                        "y": -1.418890237297333
                    },
                    {
                        "color": "#eba892",
                        "y": -1.3408539906876502
                    },
                    {
                        "color": "#eba893",
                        "y": -1.3355545199323045
                    },
                    {
                        "color": "#ebaa94",
                        "y": -1.3075753319198888
                    },
                    {
                        "color": "#ebaa95",
                        "y": -1.299881029077035
                    },
                    {
                        "color": "#ebab96",
                        "y": -1.2797971898497718
                    },
                    {
                        "color": "#ebac98",
                        "y": -1.2529219709392043
                    },
                    {
                        "color": "#ebae9a",
                        "y": -1.2297619064731187
                    },
                    {
                        "color": "#ebb09d",
                        "y": -1.1874544646556178
                    },
                    {
                        "color": "#ebb09d",
                        "y": -1.1853775990193771
                    },
                    {
                        "color": "#ebb19e",
                        "y": -1.1681208731413593
                    },
                    {
                        "color": "#ecb2a0",
                        "y": -1.1394437165929396
                    },
                    {
                        "color": "#ecb9a9",
                        "y": -1.0059134673551933
                    },
                    {
                        "color": "#ecbdae",
                        "y": -0.9364888859048541
                    },
                    {
                        "color": "#ecbfb0",
                        "y": -0.9010808963999901
                    },
                    {
                        "color": "#ecbfb0",
                        "y": -0.8998406870900011
                    },
                    {
                        "color": "#ecc1b3",
                        "y": -0.8628997473056197
                    },
                    {
                        "color": "#edcfc5",
                        "y": -0.6004662236513019
                    },
                    {
                        "color": "#edd0c6",
                        "y": -0.5767869211197771
                    },
                    {
                        "color": "#edd1c8",
                        "y": -0.5590326923353421
                    },
                    {
                        "color": "#edd2ca",
                        "y": -0.5279403263400653
                    },
                    {
                        "color": "#edd3cb",
                        "y": -0.5083836710197032
                    },
                    {
                        "color": "#eddbd5",
                        "y": -0.3636362580800663
                    },
                    {
                        "color": "#ede0db",
                        "y": -0.270787883144866
                    },
                    {
                        "color": "#eee6e3",
                        "y": -0.15664915043675265
                    },
                    {
                        "color": "#eee6e4",
                        "y": -0.15008684070352007
                    },
                    {
                        "color": "#eee8e6",
                        "y": -0.11125295104263078
                    },
                    {
                        "color": "#eee9e8",
                        "y": -0.09009674285924874
                    },
                    {
                        "color": "#eceded",
                        "y": 0.20016652618749742
                    },
                    {
                        "color": "#e9ebec",
                        "y": 0.37999855425837126
                    },
                    {
                        "color": "#e9ebec",
                        "y": 0.3835856694322546
                    },
                    {
                        "color": "#e6e9eb",
                        "y": 0.6545499255366183
                    },
                    {
                        "color": "#e3e8ea",
                        "y": 0.9183128949882979
                    },
                    {
                        "color": "#e2e7e9",
                        "y": 1.0277453683894322
                    },
                    {
                        "color": "#e0e6e9",
                        "y": 1.1360693960527826
                    },
                    {
                        "color": "#d5dfe4",
                        "y": 2.1267656183075676
                    },
                    {
                        "color": "#d2dee3",
                        "y": 2.345091804907841
                    },
                    {
                        "color": "#d0dde3",
                        "y": 2.4751732259173753
                    },
                    {
                        "color": "#cedbe2",
                        "y": 2.6991995508030415
                    },
                    {
                        "color": "#cddbe2",
                        "y": 2.7341907157686434
                    },
                    {
                        "color": "#cddbe1",
                        "y": 2.762293490410145
                    },
                    {
                        "color": "#c9d8e0",
                        "y": 3.106519136917135
                    },
                    {
                        "color": "#c1d4dd",
                        "y": 3.7336643141647654
                    },
                    {
                        "color": "#97bbcd",
                        "y": 7.279077178261988
                    }
                ],
                data2: [
                    {
                        "color": "#ea8d6f",
                        "y": -27568601.22459999
                    },
                    {
                        "color": "#ea8f72",
                        "y": -26926495.35459999
                    },
                    {
                        "color": "#ea967a",
                        "y": -25077614.254599992
                    },
                    {
                        "color": "#eb9a7f",
                        "y": -24007642.26459999
                    },
                    {
                        "color": "#eba994",
                        "y": -19625274.234599993
                    },
                    {
                        "color": "#ebad99",
                        "y": -18371129.144599993
                    },
                    {
                        "color": "#ebae9a",
                        "y": -18321493.794599995
                    },
                    {
                        "color": "#ebb19e",
                        "y": -17277053.514599994
                    },
                    {
                        "color": "#ecb5a3",
                        "y": -16293459.954599991
                    },
                    {
                        "color": "#ecbdad",
                        "y": -14012919.53459999
                    },
                    {
                        "color": "#ecbfb0",
                        "y": -13474120.934599992
                    },
                    {
                        "color": "#ecc1b3",
                        "y": -12828652.844599992
                    },
                    {
                        "color": "#ecc4b8",
                        "y": -11806160.514599994
                    },
                    {
                        "color": "#ecc7bb",
                        "y": -10982029.224599991
                    },
                    {
                        "color": "#ecc9be",
                        "y": -10468318.004599996
                    },
                    {
                        "color": "#edcabf",
                        "y": -10205941.894599989
                    },
                    {
                        "color": "#edccc1",
                        "y": -9746206.144599989
                    },
                    {
                        "color": "#edcec4",
                        "y": -9190950.614599992
                    },
                    {
                        "color": "#edd5cd",
                        "y": -7137163.144599993
                    },
                    {
                        "color": "#edd5cd",
                        "y": -7098426.594599992
                    },
                    {
                        "color": "#edd7d0",
                        "y": -6470342.004599996
                    },
                    {
                        "color": "#eddad4",
                        "y": -5674807.454599991
                    },
                    {
                        "color": "#eddfdb",
                        "y": -4177119.794599995
                    },
                    {
                        "color": "#eee4e1",
                        "y": -2740322.4645999894
                    },
                    {
                        "color": "#eee5e2",
                        "y": -2522843.4945999905
                    },
                    {
                        "color": "#eee8e6",
                        "y": -1748156.3645999879
                    },
                    {
                        "color": "#eeeae9",
                        "y": -1011990.6745999902
                    },
                    {
                        "color": "#eeeeee",
                        "y": 128083.01540000737
                    },
                    {
                        "color": "#ededee",
                        "y": 659239.4454000071
                    },
                    {
                        "color": "#eceded",
                        "y": 1406057.8254000098
                    },
                    {
                        "color": "#ebeced",
                        "y": 2027585.64540001
                    },
                    {
                        "color": "#eaecec",
                        "y": 2432950.6754000112
                    },
                    {
                        "color": "#eaebec",
                        "y": 2708854.5954000056
                    },
                    {
                        "color": "#e9ebec",
                        "y": 3134704.585400015
                    },
                    {
                        "color": "#e7eaeb",
                        "y": 4434438.4454000145
                    },
                    {
                        "color": "#e6e9eb",
                        "y": 4702183.615400009
                    },
                    {
                        "color": "#e2e7e9",
                        "y": 7268429.695400007
                    },
                    {
                        "color": "#dfe5e8",
                        "y": 9223240.145400003
                    },
                    {
                        "color": "#dde4e8",
                        "y": 10349386.725400008
                    },
                    {
                        "color": "#d9e1e6",
                        "y": 12937006.475400008
                    },
                    {
                        "color": "#d8e1e6",
                        "y": 13227718.975400008
                    },
                    {
                        "color": "#d6e0e5",
                        "y": 14331767.115400009
                    },
                    {
                        "color": "#d1dde3",
                        "y": 17385572.85540001
                    },
                    {
                        "color": "#cad9e0",
                        "y": 21614959.71540001
                    },
                    {
                        "color": "#c5d6de",
                        "y": 25057010.445400007
                    },
                    {
                        "color": "#bfd2dc",
                        "y": 28620032.99540001
                    },
                    {
                        "color": "#bacfda",
                        "y": 31627732.675400004
                    },
                    {
                        "color": "#bacfda",
                        "y": 31710071.425400004
                    },
                    {
                        "color": "#b1cad7",
                        "y": 37173028.76540001
                    },
                    {
                        "color": "#97bbcd",
                        "y": 52605179.585400015
                    }
                ]
            };
            this.mockData = {
                "statusCode": 200,
                "data": [{
                        "firmName": "LPL Financial LLC",
                        "clientSalesData": [{
                                "clientSales": 446958752,
                                "category": "Large Growth",
                                "productPortfolio": "T. Rowe Price Blue Chip Growth Fund",
                                "opportunity": 73,
                                "risk": 54
                            }, {
                                "clientSales": 1197873152,
                                "category": "Allocation--50% to 70% Equity",
                                "productPortfolio": "T. Rowe Price Capital Appreciation Fund",
                                "opportunity": 76,
                                "risk": 27
                            }, {
                                "clientSales": 315781696,
                                "category": "Large Blend",
                                "productPortfolio": "T. Rowe Price Dividend Growth Fund",
                                "opportunity": 80,
                                "risk": 38
                            }, {
                                "clientSales": 174822608,
                                "category": "World Large-Stock Growth",
                                "productPortfolio": "T. Rowe Price Global Stock Fund",
                                "opportunity": 69,
                                "risk": 49
                            }, {
                                "clientSales": 127570592,
                                "category": "Large Growth",
                                "productPortfolio": "T. Rowe Price Growth Stock Fund",
                                "opportunity": 88,
                                "risk": 57
                            }, {
                                "clientSales": 90709680,
                                "category": "Health",
                                "productPortfolio": "T. Rowe Price Health Sciences Fund",
                                "opportunity": 72,
                                "risk": 27
                            }, {
                                "clientSales": 7219677,
                                "category": "Bank Loan",
                                "productPortfolio": "T. Rowe Price Institutional Floating Rate Fund",
                                "opportunity": 56,
                                "risk": 15
                            }, {
                                "clientSales": 70141992,
                                "category": "Muni National Interm",
                                "productPortfolio": "T. Rowe Price Summit Municipal Intermediate Fund",
                                "opportunity": 68,
                                "risk": 26
                            }, {
                                "clientSales": 30122194,
                                "category": "Large Blend",
                                "productPortfolio": "T. Rowe Price U.S. Equity Research Fund",
                                "opportunity": 74,
                                "risk": 64
                            }, {
                                "clientSales": 114100944,
                                "category": "Ultrashort Bond",
                                "productPortfolio": "T. Rowe Price Ultra Short-Term Bond Fund",
                                "opportunity": 73,
                                "risk": 25
                            }],
                        "industrySalesData": null
                    }, {
                        "firmName": "Edward Jones",
                        "clientSalesData": [{
                                "clientSales": 1006641280,
                                "category": "Large Growth",
                                "productPortfolio": "T. Rowe Price Blue Chip Growth Fund",
                                "opportunity": 85,
                                "risk": 79
                            }, {
                                "clientSales": 278247,
                                "category": "Allocation--50% to 70% Equity",
                                "productPortfolio": "T. Rowe Price Capital Appreciation Fund",
                                "opportunity": 21,
                                "risk": 19
                            }, {
                                "clientSales": 441895872,
                                "category": "Large Blend",
                                "productPortfolio": "T. Rowe Price Dividend Growth Fund",
                                "opportunity": 93,
                                "risk": 77
                            }, {
                                "clientSales": 216809488,
                                "category": "World Large-Stock Growth",
                                "productPortfolio": "T. Rowe Price Global Stock Fund",
                                "opportunity": 68,
                                "risk": 51
                            }, {
                                "clientSales": 5799,
                                "category": "Large Growth",
                                "productPortfolio": "T. Rowe Price Growth Stock Fund",
                                "opportunity": 21,
                                "risk": 21
                            }, {
                                "clientSales": 11000,
                                "category": "Health",
                                "productPortfolio": "T. Rowe Price Health Sciences Fund",
                                "opportunity": 22,
                                "risk": 17
                            }, {
                                "clientSales": 0,
                                "category": "Bank Loan",
                                "productPortfolio": "T. Rowe Price Institutional Floating Rate Fund",
                                "opportunity": 8,
                                "risk": 22
                            }, {
                                "clientSales": 260649664,
                                "category": "Muni National Interm",
                                "productPortfolio": "T. Rowe Price Summit Municipal Intermediate Fund",
                                "opportunity": 70,
                                "risk": 26
                            }, {
                                "clientSales": 0,
                                "category": "Large Blend",
                                "productPortfolio": "T. Rowe Price U.S. Equity Research Fund",
                                "opportunity": 24,
                                "risk": 16
                            }, {
                                "clientSales": 0,
                                "category": "Ultrashort Bond",
                                "productPortfolio": "T. Rowe Price Ultra Short-Term Bond Fund",
                                "opportunity": 8,
                                "risk": 18
                            }],
                        "industrySalesData": null
                    }, {
                        "firmName": "Wells Fargo Advisors LLC (PCG)",
                        "clientSalesData": [{
                                "clientSales": 485628576,
                                "category": "Large Growth",
                                "productPortfolio": "T. Rowe Price Blue Chip Growth Fund",
                                "opportunity": 91,
                                "risk": 71
                            }, {
                                "clientSales": 24224602,
                                "category": "Allocation--50% to 70% Equity",
                                "productPortfolio": "T. Rowe Price Capital Appreciation Fund",
                                "opportunity": 64,
                                "risk": 11
                            }, {
                                "clientSales": 43086884,
                                "category": "Large Blend",
                                "productPortfolio": "T. Rowe Price Dividend Growth Fund",
                                "opportunity": 69,
                                "risk": 27
                            }, {
                                "clientSales": 40649132,
                                "category": "World Large-Stock Growth",
                                "productPortfolio": "T. Rowe Price Global Stock Fund",
                                "opportunity": 64,
                                "risk": 20
                            }, {
                                "clientSales": 7592837,
                                "category": "Large Growth",
                                "productPortfolio": "T. Rowe Price Growth Stock Fund",
                                "opportunity": 61,
                                "risk": 34
                            }, {
                                "clientSales": 21481278,
                                "category": "Health",
                                "productPortfolio": "T. Rowe Price Health Sciences Fund",
                                "opportunity": 67,
                                "risk": 15
                            }, {
                                "clientSales": 0,
                                "category": "Bank Loan",
                                "productPortfolio": "T. Rowe Price Institutional Floating Rate Fund",
                                "opportunity": 34,
                                "risk": 15
                            }, {
                                "clientSales": 98325800,
                                "category": "Muni National Interm",
                                "productPortfolio": "T. Rowe Price Summit Municipal Intermediate Fund",
                                "opportunity": 75,
                                "risk": 25
                            }, {
                                "clientSales": 33598616,
                                "category": "Large Blend",
                                "productPortfolio": "T. Rowe Price U.S. Equity Research Fund",
                                "opportunity": 83,
                                "risk": 52
                            }, {
                                "clientSales": 0,
                                "category": "Ultrashort Bond",
                                "productPortfolio": "T. Rowe Price Ultra Short-Term Bond Fund",
                                "opportunity": 7,
                                "risk": 17
                            }],
                        "industrySalesData": null
                    }, {
                        "firmName": "Morgan Stanley",
                        "clientSalesData": [{
                                "clientSales": 379039776,
                                "category": "Large Growth",
                                "productPortfolio": "T. Rowe Price Blue Chip Growth Fund",
                                "opportunity": 83,
                                "risk": 16
                            }, {
                                "clientSales": 51899104,
                                "category": "Allocation--50% to 70% Equity",
                                "productPortfolio": "T. Rowe Price Capital Appreciation Fund",
                                "opportunity": 73,
                                "risk": 5
                            }, {
                                "clientSales": 89040496,
                                "category": "Large Blend",
                                "productPortfolio": "T. Rowe Price Dividend Growth Fund",
                                "opportunity": 89,
                                "risk": 46
                            }, {
                                "clientSales": 182666544,
                                "category": "World Large-Stock Growth",
                                "productPortfolio": "T. Rowe Price Global Stock Fund",
                                "opportunity": 75,
                                "risk": 21
                            }, {
                                "clientSales": 26359972,
                                "category": "Large Growth",
                                "productPortfolio": "T. Rowe Price Growth Stock Fund",
                                "opportunity": 85,
                                "risk": 19
                            }, {
                                "clientSales": 46231580,
                                "category": "Health",
                                "productPortfolio": "T. Rowe Price Health Sciences Fund",
                                "opportunity": 75,
                                "risk": 18
                            }, {
                                "clientSales": 0,
                                "category": "Bank Loan",
                                "productPortfolio": "T. Rowe Price Institutional Floating Rate Fund",
                                "opportunity": 44,
                                "risk": 5
                            }, {
                                "clientSales": 101538,
                                "category": "Muni National Interm",
                                "productPortfolio": "T. Rowe Price Summit Municipal Intermediate Fund",
                                "opportunity": 50,
                                "risk": 5
                            }, {
                                "clientSales": 53970,
                                "category": "Large Blend",
                                "productPortfolio": "T. Rowe Price U.S. Equity Research Fund",
                                "opportunity": 49,
                                "risk": 6
                            }, {
                                "clientSales": 0,
                                "category": "Ultrashort Bond",
                                "productPortfolio": "T. Rowe Price Ultra Short-Term Bond Fund",
                                "opportunity": 0,
                                "risk": 0
                            }],
                        "industrySalesData": null
                    }, {
                        "firmName": "Merrill Lynch Pierce Fenner & Smith",
                        "clientSalesData": [{
                                "clientSales": 246394288,
                                "category": "Large Growth",
                                "productPortfolio": "T. Rowe Price Blue Chip Growth Fund",
                                "opportunity": 42,
                                "risk": 27
                            }, {
                                "clientSales": 18782090,
                                "category": "Allocation--50% to 70% Equity",
                                "productPortfolio": "T. Rowe Price Capital Appreciation Fund",
                                "opportunity": 29,
                                "risk": 20
                            }, {
                                "clientSales": 124512416,
                                "category": "Large Blend",
                                "productPortfolio": "T. Rowe Price Dividend Growth Fund",
                                "opportunity": 47,
                                "risk": 29
                            }, {
                                "clientSales": 19162810,
                                "category": "World Large-Stock Growth",
                                "productPortfolio": "T. Rowe Price Global Stock Fund",
                                "opportunity": 29,
                                "risk": 16
                            }, {
                                "clientSales": 22254554,
                                "category": "Large Growth",
                                "productPortfolio": "T. Rowe Price Growth Stock Fund",
                                "opportunity": 47,
                                "risk": 31
                            }, {
                                "clientSales": 59817380,
                                "category": "Health",
                                "productPortfolio": "T. Rowe Price Health Sciences Fund",
                                "opportunity": 37,
                                "risk": 22
                            }, {
                                "clientSales": 0,
                                "category": "Bank Loan",
                                "productPortfolio": "T. Rowe Price Institutional Floating Rate Fund",
                                "opportunity": 0,
                                "risk": 0
                            }, {
                                "clientSales": 50213332,
                                "category": "Muni National Interm",
                                "productPortfolio": "T. Rowe Price Summit Municipal Intermediate Fund",
                                "opportunity": 35,
                                "risk": 21
                            }, {
                                "clientSales": 6018575,
                                "category": "Large Blend",
                                "productPortfolio": "T. Rowe Price U.S. Equity Research Fund",
                                "opportunity": 40,
                                "risk": 22
                            }, {
                                "clientSales": 0,
                                "category": "Ultrashort Bond",
                                "productPortfolio": "T. Rowe Price Ultra Short-Term Bond Fund",
                                "opportunity": 0,
                                "risk": 0
                            }],
                        "industrySalesData": null
                    }, {
                        "firmName": "Raymond James Financial Services",
                        "clientSalesData": [{
                                "clientSales": 155573376,
                                "category": "Large Growth",
                                "productPortfolio": "T. Rowe Price Blue Chip Growth Fund",
                                "opportunity": 68,
                                "risk": 36
                            }, {
                                "clientSales": 34164552,
                                "category": "Allocation--50% to 70% Equity",
                                "productPortfolio": "T. Rowe Price Capital Appreciation Fund",
                                "opportunity": 58,
                                "risk": 10
                            }, {
                                "clientSales": 87047288,
                                "category": "Large Blend",
                                "productPortfolio": "T. Rowe Price Dividend Growth Fund",
                                "opportunity": 64,
                                "risk": 31
                            }, {
                                "clientSales": 51833680,
                                "category": "World Large-Stock Growth",
                                "productPortfolio": "T. Rowe Price Global Stock Fund",
                                "opportunity": 56,
                                "risk": 25
                            }, {
                                "clientSales": 7703708,
                                "category": "Large Growth",
                                "productPortfolio": "T. Rowe Price Growth Stock Fund",
                                "opportunity": 60,
                                "risk": 43
                            }, {
                                "clientSales": 33807260,
                                "category": "Health",
                                "productPortfolio": "T. Rowe Price Health Sciences Fund",
                                "opportunity": 61,
                                "risk": 27
                            }, {
                                "clientSales": 0,
                                "category": "Bank Loan",
                                "productPortfolio": "T. Rowe Price Institutional Floating Rate Fund",
                                "opportunity": 21,
                                "risk": 18
                            }, {
                                "clientSales": 9543913,
                                "category": "Muni National Interm",
                                "productPortfolio": "T. Rowe Price Summit Municipal Intermediate Fund",
                                "opportunity": 59,
                                "risk": 21
                            }, {
                                "clientSales": 356982208,
                                "category": "Large Blend",
                                "productPortfolio": "T. Rowe Price U.S. Equity Research Fund",
                                "opportunity": 94,
                                "risk": 53
                            }, {
                                "clientSales": 91433000,
                                "category": "Ultrashort Bond",
                                "productPortfolio": "T. Rowe Price Ultra Short-Term Bond Fund",
                                "opportunity": 68,
                                "risk": 28
                            }],
                        "industrySalesData": null
                    }, {
                        "firmName": "Commonwealth Financial Network",
                        "clientSalesData": [{
                                "clientSales": 90294160,
                                "category": "Large Growth",
                                "productPortfolio": "T. Rowe Price Blue Chip Growth Fund",
                                "opportunity": 55,
                                "risk": 36
                            }, {
                                "clientSales": 195860528,
                                "category": "Allocation--50% to 70% Equity",
                                "productPortfolio": "T. Rowe Price Capital Appreciation Fund",
                                "opportunity": 74,
                                "risk": 27
                            }, {
                                "clientSales": 109354640,
                                "category": "Large Blend",
                                "productPortfolio": "T. Rowe Price Dividend Growth Fund",
                                "opportunity": 84,
                                "risk": 49
                            }, {
                                "clientSales": 26785716,
                                "category": "World Large-Stock Growth",
                                "productPortfolio": "T. Rowe Price Global Stock Fund",
                                "opportunity": 50,
                                "risk": 38
                            }, {
                                "clientSales": 13932027,
                                "category": "Large Growth",
                                "productPortfolio": "T. Rowe Price Growth Stock Fund",
                                "opportunity": 74,
                                "risk": 51
                            }, {
                                "clientSales": 17009138,
                                "category": "Health",
                                "productPortfolio": "T. Rowe Price Health Sciences Fund",
                                "opportunity": 62,
                                "risk": 22
                            }, {
                                "clientSales": 65745364,
                                "category": "Bank Loan",
                                "productPortfolio": "T. Rowe Price Institutional Floating Rate Fund",
                                "opportunity": 71,
                                "risk": 27
                            }, {
                                "clientSales": 40727744,
                                "category": "Muni National Interm",
                                "productPortfolio": "T. Rowe Price Summit Municipal Intermediate Fund",
                                "opportunity": 62,
                                "risk": 28
                            }, {
                                "clientSales": 2404119,
                                "category": "Large Blend",
                                "productPortfolio": "T. Rowe Price U.S. Equity Research Fund",
                                "opportunity": 49,
                                "risk": 21
                            }, {
                                "clientSales": 54609484,
                                "category": "Ultrashort Bond",
                                "productPortfolio": "T. Rowe Price Ultra Short-Term Bond Fund",
                                "opportunity": 69,
                                "risk": 48
                            }],
                        "industrySalesData": null
                    }, {
                        "firmName": "Wells Fargo Advisors LLC (WBS)",
                        "clientSalesData": [{
                                "clientSales": 303060320,
                                "category": "Large Growth",
                                "productPortfolio": "T. Rowe Price Blue Chip Growth Fund",
                                "opportunity": 85,
                                "risk": 32
                            }, {
                                "clientSales": 21867826,
                                "category": "Allocation--50% to 70% Equity",
                                "productPortfolio": "T. Rowe Price Capital Appreciation Fund",
                                "opportunity": 49,
                                "risk": 41
                            }, {
                                "clientSales": 17761308,
                                "category": "Large Blend",
                                "productPortfolio": "T. Rowe Price Dividend Growth Fund",
                                "opportunity": 48,
                                "risk": 28
                            }, {
                                "clientSales": 15660490,
                                "category": "World Large-Stock Growth",
                                "productPortfolio": "T. Rowe Price Global Stock Fund",
                                "opportunity": 40,
                                "risk": 22
                            }, {
                                "clientSales": 5269259,
                                "category": "Large Growth",
                                "productPortfolio": "T. Rowe Price Growth Stock Fund",
                                "opportunity": 47,
                                "risk": 37
                            }, {
                                "clientSales": 12786605,
                                "category": "Health",
                                "productPortfolio": "T. Rowe Price Health Sciences Fund",
                                "opportunity": 49,
                                "risk": 25
                            }, {
                                "clientSales": 35000,
                                "category": "Bank Loan",
                                "productPortfolio": "T. Rowe Price Institutional Floating Rate Fund",
                                "opportunity": 30,
                                "risk": 15
                            }, {
                                "clientSales": 126936960,
                                "category": "Muni National Interm",
                                "productPortfolio": "T. Rowe Price Summit Municipal Intermediate Fund",
                                "opportunity": 73,
                                "risk": 26
                            }, {
                                "clientSales": 10013520,
                                "category": "Large Blend",
                                "productPortfolio": "T. Rowe Price U.S. Equity Research Fund",
                                "opportunity": 73,
                                "risk": 50
                            }, {
                                "clientSales": 0,
                                "category": "Ultrashort Bond",
                                "productPortfolio": "T. Rowe Price Ultra Short-Term Bond Fund",
                                "opportunity": 6,
                                "risk": 20
                            }],
                        "industrySalesData": null
                    }, {
                        "firmName": "J.P. Morgan Securities Llc (Chase)",
                        "clientSalesData": [{
                                "clientSales": 201048976,
                                "category": "Large Growth",
                                "productPortfolio": "T. Rowe Price Blue Chip Growth Fund",
                                "opportunity": 78,
                                "risk": 53
                            }, {
                                "clientSales": 231271,
                                "category": "Allocation--50% to 70% Equity",
                                "productPortfolio": "T. Rowe Price Capital Appreciation Fund",
                                "opportunity": 18,
                                "risk": 17
                            }, {
                                "clientSales": 3614248,
                                "category": "Large Blend",
                                "productPortfolio": "T. Rowe Price Dividend Growth Fund",
                                "opportunity": 29,
                                "risk": 30
                            }, {
                                "clientSales": 2504750,
                                "category": "World Large-Stock Growth",
                                "productPortfolio": "T. Rowe Price Global Stock Fund",
                                "opportunity": 30,
                                "risk": 21
                            }, {
                                "clientSales": 1962036,
                                "category": "Large Growth",
                                "productPortfolio": "T. Rowe Price Growth Stock Fund",
                                "opportunity": 31,
                                "risk": 23
                            }, {
                                "clientSales": 4843507,
                                "category": "Health",
                                "productPortfolio": "T. Rowe Price Health Sciences Fund",
                                "opportunity": 40,
                                "risk": 13
                            }, {
                                "clientSales": 2396300,
                                "category": "Bank Loan",
                                "productPortfolio": "T. Rowe Price Institutional Floating Rate Fund",
                                "opportunity": 47,
                                "risk": 25
                            }, {
                                "clientSales": 55971952,
                                "category": "Muni National Interm",
                                "productPortfolio": "T. Rowe Price Summit Municipal Intermediate Fund",
                                "opportunity": 69,
                                "risk": 4
                            }, {
                                "clientSales": 462978,
                                "category": "Large Blend",
                                "productPortfolio": "T. Rowe Price U.S. Equity Research Fund",
                                "opportunity": 53,
                                "risk": 31
                            }, {
                                "clientSales": 4226789,
                                "category": "Ultrashort Bond",
                                "productPortfolio": "T. Rowe Price Ultra Short-Term Bond Fund",
                                "opportunity": 38,
                                "risk": 22
                            }],
                        "industrySalesData": null
                    }, {
                        "firmName": "Charles Schwab Investment Mgmt Inc",
                        "clientSalesData": [{
                                "clientSales": 235070,
                                "category": "Large Growth",
                                "productPortfolio": "T. Rowe Price Blue Chip Growth Fund",
                                "opportunity": 18,
                                "risk": 32
                            }, {
                                "clientSales": 0,
                                "category": "Allocation--50% to 70% Equity",
                                "productPortfolio": "T. Rowe Price Capital Appreciation Fund",
                                "opportunity": 0,
                                "risk": 24
                            }, {
                                "clientSales": 54498,
                                "category": "Large Blend",
                                "productPortfolio": "T. Rowe Price Dividend Growth Fund",
                                "opportunity": 2,
                                "risk": 17
                            }, {
                                "clientSales": 13986,
                                "category": "World Large-Stock Growth",
                                "productPortfolio": "T. Rowe Price Global Stock Fund",
                                "opportunity": 0,
                                "risk": 17
                            }, {
                                "clientSales": 270,
                                "category": "Large Growth",
                                "productPortfolio": "T. Rowe Price Growth Stock Fund",
                                "opportunity": 1,
                                "risk": 30
                            }, {
                                "clientSales": 5100,
                                "category": "Health",
                                "productPortfolio": "T. Rowe Price Health Sciences Fund",
                                "opportunity": 1,
                                "risk": 19
                            }, {
                                "clientSales": 0,
                                "category": "Bank Loan",
                                "productPortfolio": "T. Rowe Price Institutional Floating Rate Fund",
                                "opportunity": 0,
                                "risk": 24
                            }, {
                                "clientSales": 200,
                                "category": "Muni National Interm",
                                "productPortfolio": "T. Rowe Price Summit Municipal Intermediate Fund",
                                "opportunity": 0,
                                "risk": 26
                            }, {
                                "clientSales": 926079296,
                                "category": "Large Blend",
                                "productPortfolio": "T. Rowe Price U.S. Equity Research Fund",
                                "opportunity": 38,
                                "risk": 48
                            }, {
                                "clientSales": 164971,
                                "category": "Ultrashort Bond",
                                "productPortfolio": "T. Rowe Price Ultra Short-Term Bond Fund",
                                "opportunity": 2,
                                "risk": 16
                            }],
                        "industrySalesData": null
                    }]
            };
            this.mockDataRankingsNew = {
                "statusCode": 200,
                "data": [{
                        "grossSalesRank": "4",
                        "netSalesRank": "4",
                        "aumRank": "4",
                    }]
            };
            this.mockDataRankingsTrends = {
                "statusCode": 200,
                "data": [{
                        // "date":"Q4 2020",
                        "grossSalesRank": ["4", "4", "2", "3", "1", "5", "2", "1"],
                        "netSalesRank": ["5", "4", "2", "3", "1", "5", "2", "1"],
                        "aumRank": ["4", "4", "2", "3", "1", "5", "2", "0"],
                    }]
            };
            this.managerRankMockData = {
                "statusCode": 200,
                "data": [{
                        'currentQuarter': '1',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '2',
                        'manager': "client",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '3',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '4',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '5',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    },
                    {
                        'currentQuarter': '6',
                        'manager': "manager",
                        'currentQuarterMinusOne': '4',
                        'currentQuarterMinusTwo': '3'
                    }]
            };
            this.mockDataKeySalesDrivers = {
                "statusCode": 200,
                "data": {
                    "keyDrivers": [{
                            "description": "1 Yr Return",
                            "descriptionUnit": "%",
                            "yourFund": 0.92,
                            "competitiveFunds": -1.32,
                            "difference": 2.24,
                            "percentDifference": null,
                            "percentile": 97,
                            "isKeyDriver": true,
                            "isLargestAdv": false
                        }, {
                            "description": "Net Expense",
                            "descriptionUnit": "bps",
                            "yourFund": 38,
                            "competitiveFunds": 59,
                            "difference": 4,
                            "percentDifference": 1.2,
                            "percentile": 52,
                            "isKeyDriver": true,
                            "isLargestAdv": false
                        }, {
                            "description": "Rating Overall",
                            "descriptionUnit": null,
                            "yourFund": 3.90,
                            "competitiveFunds": 4.47,
                            "difference": -1,
                            "percentDifference": 0.8,
                            "percentile": 69,
                            "isKeyDriver": true,
                            "isLargestAdv": false
                        }
                    ],
                    "largestAdvantage": [{
                            "description": "1 Yr Return",
                            "descriptionUnit": "%",
                            "yourFund": 0.92,
                            "competitiveFunds": -1.32,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 97,
                            "isKeyDriver": false,
                            "isLargestAdv": true
                        }, {
                            "description": "Avg Mgr Tenure",
                            "descriptionUnit": "Yrs",
                            "yourFund": 3.50,
                            "competitiveFunds": 10.50,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 52,
                            "isKeyDriver": false,
                            "isLargestAdv": true
                        }, {
                            "description": "Up Capture 1 Yr",
                            "descriptionUnit": "%",
                            "yourFund": 28.8,
                            "competitiveFunds": 31.89,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 69,
                            "isKeyDriver": false,
                            "isLargestAdv": true
                        }
                    ],
                    "analyticsMatchups": [{
                            "description": "Net Expense",
                            "descriptionUnit": "bps",
                            "yourFund": 38,
                            "competitiveFunds": 59,
                            "difference": 4,
                            "percentDifference": 1.2,
                            "percentile": 97,
                            "isKeyDriver": true,
                            "isLargestAdv": false
                        }, {
                            "description": "12 Mo. Yield",
                            "descriptionUnit": "%",
                            "yourFund": 3.34,
                            "competitiveFunds": 3.72,
                            "difference": -1.20,
                            "percentDifference": 3,
                            "percentile": 52,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        }, {
                            "description": "Rating Overall",
                            "descriptionUnit": null,
                            "yourFund": 3.90,
                            "competitiveFunds": 4.47,
                            "difference": -1,
                            "percentDifference": 0.8,
                            "percentile": 69,
                            "isKeyDriver": true,
                            "isLargestAdv": false
                        }, {
                            "description": "Rating 3 Yr",
                            "descriptionUnit": null,
                            "yourFund": 4.37,
                            "competitiveFunds": 4.78,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 75,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        }, {
                            "description": "1 Yr Return",
                            "descriptionUnit": "%",
                            "yourFund": 0.92,
                            "competitiveFunds": -1.32,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 86,
                            "isKeyDriver": true,
                            "isLargestAdv": true
                        }, {
                            "description": "3 Yr Return",
                            "descriptionUnit": "%",
                            "yourFund": 2.36,
                            "competitiveFunds": 2.71,
                            "difference": -0.35,
                            "percentDifference": null,
                            "percentile": 66,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "5 Yr Return",
                            "descriptionUnit": "%",
                            "yourFund": 2.84,
                            "competitiveFunds": 3.04,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 88,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "3 Yr Sharpe",
                            "descriptionUnit": null,
                            "yourFund": -1.36,
                            "competitiveFunds": -1.57,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 53,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "5 Yr Sharpe",
                            "descriptionUnit": null,
                            "yourFund": 1.01,
                            "competitiveFunds": 1.01,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 78,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "1 Yr Std Dev",
                            "descriptionUnit": null,
                            "yourFund": 1.71,
                            "competitiveFunds": 1.80,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 69,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "3 Yr Std Dev",
                            "descriptionUnit": null,
                            "yourFund": 2.31,
                            "competitiveFunds": 2.60,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 38,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "5 Yr Std Dev",
                            "descriptionUnit": null,
                            "yourFund": 2.39,
                            "competitiveFunds": 2.60,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 66,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "1 Yr Sortino",
                            "descriptionUnit": null,
                            "yourFund": -5.4,
                            "competitiveFunds": -1.7,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 53,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "3 Yr Sortino",
                            "descriptionUnit": null,
                            "yourFund": 0.83,
                            "competitiveFunds": 0.98,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 63,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "5 Yr Sortino",
                            "descriptionUnit": null,
                            "yourFund": 1.47,
                            "competitiveFunds": 1.51,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 81,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Alpha 1 Yr",
                            "descriptionUnit": null,
                            "yourFund": -3.19,
                            "competitiveFunds": -3.67,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 44,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Alpha 3 Yr",
                            "descriptionUnit": null,
                            "yourFund": 1.47,
                            "competitiveFunds": 1.51,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 87,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Alpha 5 Yr",
                            "descriptionUnit": null,
                            "yourFund": 1.18,
                            "competitiveFunds": 1.00,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 91,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Beta 1 Yr",
                            "descriptionUnit": null,
                            "yourFund": 0.04,
                            "competitiveFunds": 0.04,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 53,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Beta 3 Yr",
                            "descriptionUnit": null,
                            "yourFund": 0.01,
                            "competitiveFunds": 0.04,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 25,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Beta 5 Yr",
                            "descriptionUnit": null,
                            "yourFund": 0.02,
                            "competitiveFunds": 0.05,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 34,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Batting Avg 1 Yr",
                            "descriptionUnit": null,
                            "yourFund": 16.84,
                            "competitiveFunds": 14.84,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 100,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Batting Avg 3 Yr",
                            "descriptionUnit": null,
                            "yourFund": 25.56,
                            "competitiveFunds": 25.74,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 59,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Batting Avg 5 Yr",
                            "descriptionUnit": null,
                            "yourFund": 36.00,
                            "competitiveFunds": 37.50,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 78,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Avg Mgr Tenure",
                            "descriptionUnit": 'Yrs',
                            "yourFund": 3.50,
                            "competitiveFunds": 10.50,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 32,
                            "isKeyDriver": false,
                            "isLargestAdv": true
                        },
                        {
                            "description": "Up Capture 1 Yr",
                            "descriptionUnit": "%",
                            "yourFund": 28.83,
                            "competitiveFunds": 31.89,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 37,
                            "isKeyDriver": false,
                            "isLargestAdv": true
                        },
                        {
                            "description": "Up Capture 3 Yr",
                            "descriptionUnit": "%",
                            "yourFund": 73.58,
                            "competitiveFunds": 73.15,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 50,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Up Capture 5 Yr",
                            "descriptionUnit": "%",
                            "yourFund": 73.59,
                            "competitiveFunds": 73.18,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 61,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Down Capture 1 Yr",
                            "descriptionUnit": "%",
                            "yourFund": 79.28,
                            "competitiveFunds": 74.40,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 53,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Down Capture 3 Yr",
                            "descriptionUnit": "%",
                            "yourFund": 112.11,
                            "competitiveFunds": 116.76,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 89,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Down Capture 5 Yr",
                            "descriptionUnit": "%",
                            "yourFund": 127.23,
                            "competitiveFunds": 117.49,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 50,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Info Ratio 1 Yr",
                            "descriptionUnit": null,
                            "yourFund": -2.38,
                            "competitiveFunds": -2.24,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 37,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Info Ratio 3 Yr",
                            "descriptionUnit": null,
                            "yourFund": 0.95,
                            "competitiveFunds": 0.93,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 56,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Info Ratio 5 Yr",
                            "descriptionUnit": null,
                            "yourFund": -1.19,
                            "competitiveFunds": -1.04,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 50,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Tracking Error 1 Yr",
                            "descriptionUnit": null,
                            "yourFund": 6.84,
                            "competitiveFunds": 6.78,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 79,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Tracking Error 3 Yr",
                            "descriptionUnit": null,
                            "yourFund": 7.28,
                            "competitiveFunds": 7.94,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 33,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Tracking Error 5 Yr",
                            "descriptionUnit": null,
                            "yourFund": 6.82,
                            "competitiveFunds": 7.17,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 28,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "R Squared 1 Yr",
                            "descriptionUnit": null,
                            "yourFund": 2.01,
                            "competitiveFunds": 3.00,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 32,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "R Squared 3 Yr",
                            "descriptionUnit": null,
                            "yourFund": 9.32,
                            "competitiveFunds": 8.96,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 72,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "R Squared 5 Yr",
                            "descriptionUnit": null,
                            "yourFund": 5.56,
                            "competitiveFunds": 6.28,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 78,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "M Squared 1 Yr",
                            "descriptionUnit": null,
                            "yourFund": 2.01,
                            "competitiveFunds": 3.00,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 37,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "M Squared 3 Yr",
                            "descriptionUnit": null,
                            "yourFund": 9.32,
                            "competitiveFunds": 8.96,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 61,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "M Squared 5 Yr",
                            "descriptionUnit": null,
                            "yourFund": 5.56,
                            "competitiveFunds": 6.28,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 61,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Correlation 1 Yr",
                            "descriptionUnit": null,
                            "yourFund": 0.72,
                            "competitiveFunds": 0.73,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 32,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Correlation 3 Yr",
                            "descriptionUnit": null,
                            "yourFund": 0.73,
                            "competitiveFunds": 0.68,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 83,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        },
                        {
                            "description": "Correlation 5 Yr",
                            "descriptionUnit": null,
                            "yourFund": 0.79,
                            "competitiveFunds": 0.75,
                            "difference": null,
                            "percentDifference": null,
                            "percentile": 83,
                            "isKeyDriver": false,
                            "isLargestAdv": false
                        }
                    ]
                }
            };
            this.mockDataSalesTrendsEx = {
                "statusCode": 200,
                "data": [{
                        "industrySales": "$28,787,982,874",
                        "marketShare": "26%"
                    },
                    {
                        "industrySales": "$9,601,008,312",
                        "marketShare": "26%"
                    },
                    {
                        "industrySales": "$18,635,208,686",
                        "marketShare": "27%"
                    },
                    {
                        "industrySales": "$37,246,174,171",
                        "marketShare": "21%"
                    },
                    {
                        "industrySales": "$9,601,008,312",
                        "marketShare": "26%"
                    },
                    {
                        "industrySales": "$18,635,208,686",
                        "marketShare": "27%"
                    },
                    {
                        "industrySales": "$37,246,174,171",
                        "marketShare": "21%"
                    },
                    {
                        "industrySales": "$28,787,982,874",
                        "marketShare": "26%"
                    },
                ]
            };
            this.mockDataSalesTrends = {
                "statusCode": 200,
                "data": [{
                        "quarter": "2021-Q2",
                        "industry_sales": "3.3932078068E8",
                        "market_share": "0.5569",
                        "top3_sales": "3.3932078068E8",
                        "top3_percent": "1.0",
                        "top3_net_sales": "4267616.2",
                        "top3_aum": "7.04189022897E9",
                        "top3_aum_percent": "0.9762",
                        "top5_sales": "3.3932078068E8",
                        "top5_percent": "1.0",
                        "top5_aum": "7.06355038082E9",
                        "top5_aum_percent": "0.9792",
                        "top5_net_sales": "4267616.2",
                        "top10_sales": "3.3932078068E8",
                        "top10_percent": "1.0",
                        "top10_net_sales": "-4911129.39",
                        "top10_aum": "7.2130284566E9",
                        "top10_aum_percent": "1.0",
                        "top20_sales": "3.3932078068E8",
                        "top20_percent": "1.0",
                        "top20_net_sales": "-4911129.39",
                        "top20_aum": "7.2130284566E9",
                        "top20_aum_percent": "1.0",
                        "remainder_sales": "0.0",
                        "remainder_percent": "0.0",
                        "remainder_net_sales": "0.0",
                        "remainder_aum": "0.0",
                        "remainder_aum_percent": "0.0"
                    }, {
                        "quarter": "2021-Q1",
                        "industry_sales": "4.0656318716E8",
                        "market_share": "0.6346",
                        "top3_sales": "4.0656318716E8",
                        "top3_percent": "1.0",
                        "top3_net_sales": "2.407482887E7",
                        "top3_aum": "6.4154396777E9",
                        "top3_aum_percent": "0.9969",
                        "top5_sales": "4.0656318716E8",
                        "top5_percent": "1.0",
                        "top5_aum": "6.43490176846E9",
                        "top5_aum_percent": "0.9999",
                        "top5_net_sales": "2.407482887E7",
                        "top10_sales": "4.0656318716E8",
                        "top10_percent": "1.0",
                        "top10_net_sales": "2.329488887E7",
                        "top10_aum": "6.43490176846E9",
                        "top10_aum_percent": "0.9999",
                        "top20_sales": "4.0656318716E8",
                        "top20_percent": "1.0",
                        "top20_net_sales": "2.329488887E7",
                        "top20_aum": "6.43490176846E9",
                        "top20_aum_percent": "0.9999",
                        "remainder_sales": "0.0",
                        "remainder_percent": "0.0",
                        "remainder_net_sales": "0.0",
                        "remainder_aum": "0.0",
                        "remainder_aum_percent": "0.0"
                    }, {
                        "quarter": "2020-Q4",
                        "industry_sales": "4.1086210055E8",
                        "market_share": "0.677",
                        "top3_sales": "4.1086210055E8",
                        "top3_percent": "1.0",
                        "top3_net_sales": "1.1910151154E8",
                        "top3_aum": "6.17570306244E9",
                        "top3_aum_percent": "0.9774",
                        "top5_sales": "4.1086210055E8",
                        "top5_percent": "1.0",
                        "top5_aum": "6.19198170571E9",
                        "top5_aum_percent": "0.98",
                        "top5_net_sales": "1.1910151154E8",
                        "top10_sales": "4.1086210055E8",
                        "top10_percent": "1.0",
                        "top10_net_sales": "1.0933177814E8",
                        "top10_aum": "6.31797153236E9",
                        "top10_aum_percent": "1.0",
                        "top20_sales": "4.1086210055E8",
                        "top20_percent": "1.0",
                        "top20_net_sales": "1.0933177814E8",
                        "top20_aum": "6.31797153236E9",
                        "top20_aum_percent": "1.0",
                        "remainder_sales": "0.0",
                        "remainder_percent": "0.0",
                        "remainder_net_sales": "0.0",
                        "remainder_aum": "0.0",
                        "remainder_aum_percent": "0.0"
                    }, {
                        "quarter": "2020-Q3",
                        "industry_sales": "4.0103990521E8",
                        "market_share": "0.7007",
                        "top3_sales": "4.0103990521E8",
                        "top3_percent": "1.0",
                        "top3_net_sales": "9.163174124E7",
                        "top3_aum": "5.60113981606E9",
                        "top3_aum_percent": "0.9971",
                        "top5_sales": "4.0103990521E8",
                        "top5_percent": "1.0",
                        "top5_aum": "5.603230382E9",
                        "top5_aum_percent": "0.9974",
                        "top5_net_sales": "9.163174124E7",
                        "top10_sales": "4.0103990521E8",
                        "top10_percent": "1.0",
                        "top10_net_sales": "9.040732784E7",
                        "top10_aum": "5.61733493146E9",
                        "top10_aum_percent": "1.0",
                        "top20_sales": "4.0103990521E8",
                        "top20_percent": "1.0",
                        "top20_net_sales": "9.040732784E7",
                        "top20_aum": "5.61733493146E9",
                        "top20_aum_percent": "1.0",
                        "remainder_sales": "0.0",
                        "remainder_percent": "0.0",
                        "remainder_net_sales": "0.0",
                        "remainder_aum": "0.0",
                        "remainder_aum_percent": "0.0"
                    }, {
                        "quarter": "2020-Q2",
                        "industry_sales": "3.8516522212E8",
                        "market_share": "0.6529",
                        "top3_sales": "3.8516522212E8",
                        "top3_percent": "1.0",
                        "top3_net_sales": "1.8934864752E8",
                        "top3_aum": "4.82044762955E9",
                        "top3_aum_percent": "0.9766",
                        "top5_sales": "3.8516522212E8",
                        "top5_percent": "1.0",
                        "top5_aum": "4.82209552506E9",
                        "top5_aum_percent": "0.9769",
                        "top5_net_sales": "1.8934864752E8",
                        "top10_sales": "3.8516522212E8",
                        "top10_percent": "1.0",
                        "top10_net_sales": "1.8492315387E8",
                        "top10_aum": "4.92331815026E9",
                        "top10_aum_percent": "0.9974",
                        "top20_sales": "3.8516522212E8",
                        "top20_percent": "1.0",
                        "top20_net_sales": "1.8492315387E8",
                        "top20_aum": "4.92331815026E9",
                        "top20_aum_percent": "0.9974",
                        "remainder_sales": "0.0",
                        "remainder_percent": "0.0",
                        "remainder_net_sales": "0.0",
                        "remainder_aum": "0.0",
                        "remainder_aum_percent": "0.0"
                    }, {
                        "quarter": "2020-Q1",
                        "industry_sales": "3.9063832488E8",
                        "market_share": "0.6485",
                        "top3_sales": "3.906375655E8",
                        "top3_percent": "0.9999",
                        "top3_net_sales": "1.4256048955E8",
                        "top3_aum": "2.24347566832E9",
                        "top3_aum_percent": "0.6301",
                        "top5_sales": "3.9063832488E8",
                        "top5_percent": "1.0",
                        "top5_aum": "2.24473191542E9",
                        "top5_aum_percent": "0.6305",
                        "top5_net_sales": "1.8934864752E8",
                        "top10_sales": "3.9063832488E8",
                        "top10_percent": "1.0",
                        "top10_net_sales": "1.416028303E8",
                        "top10_aum": "2.24486189065E9",
                        "top10_aum_percent": "0.6305",
                        "top20_sales": "3.9063832488E8",
                        "top20_percent": "1.0",
                        "top20_net_sales": "1.416028303E8",
                        "top20_aum": "2.24486189065E9",
                        "top20_aum_percent": "0.6305",
                        "remainder_sales": "0.0",
                        "remainder_percent": "0.0",
                        "remainder_net_sales": "0.0",
                        "remainder_aum": "0.0",
                        "remainder_aum_percent": "0.0"
                    }, {
                        "quarter": "2019-Q4",
                        "industry_sales": "3.1563727964E8",
                        "market_share": "0.6294",
                        "top3_sales": "3.1563727964E8",
                        "top3_percent": "1.0",
                        "top3_net_sales": "1.6418194248E8",
                        "top3_aum": "2.46891284296E9",
                        "top3_aum_percent": "0.6221",
                        "top5_sales": "3.1563727964E8",
                        "top5_percent": "1.0",
                        "top5_aum": "2.47056062655E9",
                        "top5_aum_percent": "0.6225",
                        "top5_net_sales": "1.6418194248E8",
                        "top10_sales": "3.1563727964E8",
                        "top10_percent": "1.0",
                        "top10_net_sales": "1.6263822639E8",
                        "top10_aum": "2.47056062655E9",
                        "top10_aum_percent": "0.6225",
                        "top20_sales": "3.1563727964E8",
                        "top20_percent": "1.0",
                        "top20_net_sales": "1.6263822639E8",
                        "top20_aum": "2.47056062655E9",
                        "top20_aum_percent": "0.6225",
                        "remainder_sales": "0.0",
                        "remainder_percent": "0.0",
                        "remainder_net_sales": "0.0",
                        "remainder_aum": "0.0",
                        "remainder_aum_percent": "0.0"
                    }, {
                        "quarter": "2019-Q3",
                        "industry_sales": "3.3903658038E8",
                        "market_share": "0.6314",
                        "top3_sales": "3.3903658038E8",
                        "top3_percent": "1.0",
                        "top3_net_sales": "1.9444080818E8",
                        "top3_aum": "2.13815087185E9",
                        "top3_aum_percent": "0.6186",
                        "top5_sales": "3.3903658038E8",
                        "top5_percent": "1.0",
                        "top5_aum": "2.13959407432E9",
                        "top5_aum_percent": "0.619",
                        "top5_net_sales": "1.9444080818E8",
                        "top10_sales": "3.3903658038E8",
                        "top10_percent": "1.0",
                        "top10_net_sales": "1.93664338E8",
                        "top10_aum": "2.13959407432E9",
                        "top10_aum_percent": "0.619",
                        "top20_sales": "3.3903658038E8",
                        "top20_percent": "1.0",
                        "top20_net_sales": "1.93664338E8",
                        "top20_aum": "2.13959407432E9",
                        "top20_aum_percent": "0.619",
                        "remainder_sales": "0.0",
                        "remainder_percent": "0.0",
                        "remainder_net_sales": "0.0",
                        "remainder_aum": "0.0",
                        "remainder_aum_percent": "0.0"
                    }]
            };
            this.mockDataPlatformBreakdown = {
                "statusCode": 200,
                "data": {
                    "gross": [
                        {
                            "platform": "Brokerage",
                            "clientSales": 55.6,
                            "globalSales": 362.1,
                            "marketShare": 10.5,
                            "greenSpace": 320.4,
                            "rank": 5,
                            "previousRank": 10,
                            "products": 5
                        },
                        {
                            "platform": "Home Office",
                            "clientSales": 15.6,
                            "globalSales": 62.8,
                            "marketShare": 1.5,
                            "greenSpace": 20.6,
                            "rank": 2,
                            "previousRank": 20,
                            "products": 8
                        },
                        {
                            "platform": "Rep as Advisor",
                            "clientSales": 73.4,
                            "globalSales": 162.8,
                            "marketShare": 10.5,
                            "greenSpace": 60.6,
                            "rank": 1,
                            "previousRank": 2,
                            "products": 3
                        },
                        {
                            "platform": "Rep as PM",
                            "clientSales": 111.1,
                            "globalSales": 623.8,
                            "marketShare": 5.5,
                            "greenSpace": 50.7,
                            "rank": 4,
                            "previousRank": 6,
                            "products": 22
                        },
                        {
                            "platform": "Unified Managed Account",
                            "clientSales": 11.9,
                            "globalSales": 42.8,
                            "marketShare": 6.5,
                            "greenSpace": 70.4,
                            "rank": 3,
                            "previousRank": 12,
                            "products": 19
                        }
                    ],
                    "net": [
                        {
                            "platform": "Brokerage",
                            "clientSales": 5.6,
                            "globalSales": 662.1,
                            "rank": 5,
                            "previousRank": 10,
                            "products": 5
                        },
                        {
                            "platform": "Home Office",
                            "clientSales": -15.6,
                            "globalSales": 162.3,
                            "rank": 30,
                            "previousRank": 20,
                            "products": 8
                        },
                        {
                            "platform": "Rep as Advisor",
                            "clientSales": 23.4,
                            "globalSales": 162.8,
                            "rank": 1,
                            "previousRank": 2,
                            "products": 3
                        },
                        {
                            "platform": "Rep as PM",
                            "clientSales": 11.1,
                            "globalSales": 623.8,
                            "rank": 4,
                            "previousRank": 6,
                            "products": 22
                        },
                        {
                            "platform": "Unified Managed Account",
                            "clientSales": -111.9,
                            "globalSales": 42.8,
                            "rank": 20,
                            "previousRank": 12,
                            "products": 19
                        }
                    ],
                    "aum": [
                        {
                            "platform": "Brokerage",
                            "clientAum": 315.6,
                            "globalAum": 362.1,
                            "marketShare": 90.5,
                            "greenSpaceAum": 320.4,
                            "rank": 1,
                            "previousRank": 10,
                            "products": 5
                        },
                        {
                            "platform": "Home Office",
                            "clientAum": 315.6,
                            "globalAum": 462.8,
                            "marketShare": 1.5,
                            "greenSpaceAum": 20.6,
                            "rank": 2,
                            "previousRank": 20,
                            "products": 8
                        },
                        {
                            "platform": "Rep as Advisor",
                            "clientAum": 23.4,
                            "globalAum": 162.8,
                            "marketShare": 10.5,
                            "greenSpaceAum": 60.6,
                            "rank": 1,
                            "previousRank": 2,
                            "products": 3
                        },
                        {
                            "platform": "Rep as PM",
                            "clientAum": 11.1,
                            "globalAum": 623.8,
                            "marketShare": 5.5,
                            "greenSpaceAum": 50.7,
                            "rank": 4,
                            "previousRank": 6,
                            "products": 22
                        },
                        {
                            "platform": "Unified Managed Account",
                            "clientAum": 11.9,
                            "globalAum": 42.8,
                            "marketShare": 6.5,
                            "greenSpaceAum": 70.4,
                            "rank": 3,
                            "previousRank": 12,
                            "products": 19
                        }
                    ]
                }
            };
            this.platformGreenRedSpaceMockData = {
                "platforms": ["Brokerage", "Home Office", "Rep as Advisor", "Rep as PM", "Unified Managed Account"],
                "greenSpace": {
                    "salesWithoutAdvantages": [34016, 25211, 7899, 6817, 7986],
                    "salesWithAdvantages": [14889, 13322, 8274, 3532, 2512]
                },
                "redSpace": {
                    "salesWithoutAdvantages": [34016, 25211, 7899, 6817, 7986],
                    "salesWithAdvantages": [14889, 13322, 8274, 3532, 2512]
                }
            };
            this.optionsMockData = {
                options: [
                    {
                        "value": 1,
                        "formattedValue": "Client Sales"
                    },
                    {
                        "value": 2,
                        "formattedValue": "Expected Sales"
                    },
                    {
                        "value": 3,
                        "formattedValue": "Global Sales"
                    },
                    {
                        "value": 4,
                        "formattedValue": "Market Share"
                    },
                    {
                        "value": 5,
                        "formattedValue": "Sales Green Space"
                    },
                    {
                        "value": 6,
                        "formattedValue": "Client Net Sales"
                    },
                    {
                        "value": 7,
                        "formattedValue": "Global Net Sales"
                    },
                    {
                        "value": 8,
                        "formattedValue": "Client AUM"
                    },
                    {
                        "value": 9,
                        "formattedValue": "Industry AUM"
                    },
                    {
                        "value": 10,
                        "formattedValue": "AUM Green Space"
                    }
                ]
            };
            this.analyticsOptionsMockData = {
                options: [
                    {
                        "value": "dollarDifference",
                        "formattedValue": "Difference {Actual Sales - Expected Sales}"
                    },
                    {
                        "value": "marketShare",
                        "formattedValue": "Market Share"
                    },
                    {
                        "value": "clientSales",
                        "formattedValue": "Client Sales"
                    },
                    {
                        "value": "expectedSales",
                        "formattedValue": "Expected Sales"
                    },
                    {
                        "value": "globalSales",
                        "formattedValue": "Global Sales"
                    },
                    {
                        "value": "salesGreenSpace",
                        "formattedValue": "Sales Green Space"
                    },
                    {
                        "value": "aumGreenSpace",
                        "formattedValue": "AUM Green Space"
                    }
                ]
            };
            this.scatterplotMockData = {
                result: [
                    {
                        "name": "BD Field California North",
                        "x": 498502197.93,
                        "y": 14523619672.22,
                        "z": 7240056328501055000,
                        "data": {
                            "client_gross_sales": 1943001573.17,
                            "expected_sales": 498502197.93,
                            "global_gross_sales": 14523619672.22,
                            "market_share": 3.4323,
                            "sales_green_space": 89998570.63,
                            "client_net_sales": 3721020750.83,
                            "global_net_sales": 71339054447.54,
                            "client_aum": 1698941595.26,
                            "aum_industry": 7582538874.95,
                            "aum_green_space": 2640131542.35
                        }
                    },
                    {
                        "name": "RRB Team New England",
                        "x": 687146856.25,
                        "y": 7789872846.2,
                        "z": 5352786636853570000,
                        "data": {
                            "client_gross_sales": 2710221970.19,
                            "expected_sales": 687146856.25,
                            "global_gross_sales": 7789872846.2,
                            "market_share": 8.821,
                            "sales_green_space": 132503849.17,
                            "client_net_sales": 1705197899.59,
                            "global_net_sales": 26094069472.41,
                            "client_aum": 2710221970.19,
                            "aum_industry": 5610331433.89,
                            "aum_green_space": 2128821669.28
                        }
                    },
                    {
                        "name": "BD Field New Jersey South",
                        "x": 362417738.07,
                        "y": 10270304569.05,
                        "z": 3722140551205086700,
                        "data": {
                            "client_gross_sales": 1230559495.74,
                            "expected_sales": 362417738.07,
                            "global_gross_sales": 10270304569.05,
                            "market_share": 3.5287,
                            "sales_green_space": 92647641.93,
                            "client_net_sales": 2979863885.19,
                            "global_net_sales": 43724305597.31,
                            "client_aum": 1230559495.74,
                            "aum_industry": 6340488956.69,
                            "aum_green_space": 2002107644.18
                        }
                    },
                    {
                        "name": "BD Field Metro Seattle",
                        "x": 624252333.76,
                        "y": 12989121999.79,
                        "z": 8108489721862266000,
                        "data": {
                            "client_gross_sales": 1943001573.17,
                            "expected_sales": 624252333.76,
                            "global_gross_sales": 12989121999.79,
                            "market_share": 4.8059,
                            "sales_green_space": 165971499.69,
                            "client_net_sales": 3808100076.8,
                            "global_net_sales": 63105753546.95,
                            "client_aum": 1943001573.17,
                            "aum_industry": 7685978695.01,
                            "aum_green_space": 2100968826.86
                        }
                    },
                    {
                        "name": "RRB Team Southwest",
                        "x": 593676658.69,
                        "y": 11172577627.29,
                        "z": 6632898554724177000,
                        "data": {
                            "client_gross_sales": 1824777993.69,
                            "expected_sales": 593676658.69,
                            "global_gross_sales": 11172577627.29,
                            "market_share": 5.3136,
                            "sales_green_space": -97522103.06,
                            "client_net_sales": 1437374919.48,
                            "global_net_sales": 26452547371.98,
                            "client_aum": 1824777993.69,
                            "aum_industry": 6491155258.96,
                            "aum_green_space": 3690637884.25
                        }
                    },
                    {
                        "name": "BD Field Chicago West",
                        "x": 700609126.3,
                        "y": 15213946897.57,
                        "z": 10659030043481113000,
                        "data": {
                            "client_gross_sales": 1483775105.72,
                            "expected_sales": 700609126.3,
                            "global_gross_sales": 15213946897.57,
                            "market_share": 4.605,
                            "sales_green_space": 167809088.56,
                            "client_net_sales": 4085588165.02,
                            "global_net_sales": 84048509778.5,
                            "client_aum": 2385371918.92,
                            "aum_industry": 7841116447.55,
                            "aum_green_space": 2530852296.89
                        }
                    },
                    {
                        "name": "BD Field Southwest",
                        "x": 788036291.64,
                        "y": 12948223441.46,
                        "z": 10203669984134257000,
                        "data": {
                            "client_gross_sales": 1483775105.72,
                            "expected_sales": 788036291.64,
                            "global_gross_sales": 12948223441.46,
                            "market_share": 6.086,
                            "sales_green_space": 198553388.8,
                            "client_net_sales": 3613618400.77,
                            "global_net_sales": 55808202417.53,
                            "client_aum": 1483775105.72,
                            "aum_industry": 5768996339.76,
                            "aum_green_space": 2261457998.27
                        }
                    },
                    {
                        "name": "BD Field Heartland",
                        "x": 611860504.86,
                        "y": 14642681457.77,
                        "z": 8959278469255313000,
                        "data": {
                            "client_gross_sales": 2166305799.72,
                            "expected_sales": 611860504.86,
                            "global_gross_sales": 14642681457.77,
                            "market_share": 4.1786,
                            "sales_green_space": 35855560.38,
                            "client_net_sales": 2908387605.61,
                            "global_net_sales": 89814660197.66,
                            "client_aum": 2166305799.72,
                            "aum_industry": 6889889443.56,
                            "aum_green_space": 2134833884.49
                        }
                    },
                    {
                        "name": "BD Field Colorado",
                        "x": 581943143.96,
                        "y": 13454770263.17,
                        "z": 7829911308208667000,
                        "data": {
                            "client_gross_sales": 1903336045.01,
                            "expected_sales": 581943143.96,
                            "global_gross_sales": 13454770263.17,
                            "market_share": 4.3251,
                            "sales_green_space": 112256464.93,
                            "client_net_sales": 3573917437.67,
                            "global_net_sales": 59768151861.99,
                            "client_aum": 1903336045.01,
                            "aum_industry": 6689778484.96,
                            "aum_green_space": 2256818196.3
                        }
                    },
                    {
                        "name": "BD Field Texas South",
                        "x": 382647185.96,
                        "y": 13781460916.94,
                        "z": 5273437238284812000,
                        "data": {
                            "client_gross_sales": 1125543555.96,
                            "expected_sales": 382647185.96,
                            "global_gross_sales": 13781460916.94,
                            "market_share": 2.7765,
                            "sales_green_space": 107643609.42,
                            "client_net_sales": 4371789372.19,
                            "global_net_sales": 57091784462.79,
                            "client_aum": 1125543555.96,
                            "aum_industry": 6023488142.04,
                            "aum_green_space": 2585104091.9
                        }
                    },
                    {
                        "name": "RRB Team Southeast",
                        "x": 888455779.33,
                        "y": 10216382033.68,
                        "z": 9076803661666175000,
                        "data": {
                            "client_gross_sales": 1860552191.5,
                            "expected_sales": 888455779.33,
                            "global_gross_sales": 10216382033.68,
                            "market_share": 8.6963,
                            "sales_green_space": 173187510.02,
                            "client_net_sales": 1637772895.1,
                            "global_net_sales": 32236378569.36,
                            "client_aum": 2880672680.14,
                            "aum_industry": 6608088448.4,
                            "aum_green_space": 2854337058.51
                        }
                    },
                    {
                        "name": "RRB Team Mid-Atlantic",
                        "x": 970259552.25,
                        "y": 7630085879.37,
                        "z": 7403163708946584000,
                        "data": {
                            "client_gross_sales": 1860552191.5,
                            "expected_sales": 970259552.25,
                            "global_gross_sales": 7630085879.37,
                            "market_share": 12.7162,
                            "sales_green_space": 168874705.04,
                            "client_net_sales": 1190927639.46,
                            "global_net_sales": 29954849488.87,
                            "client_aum": 4016027249.47,
                            "aum_industry": 5012007563.49,
                            "aum_green_space": 1355971146.92
                        }
                    },
                    {
                        "name": "BD Field Texas North",
                        "x": 627698537.29,
                        "y": 15388480354.65,
                        "z": 9659326609729704000,
                        "data": {
                            "client_gross_sales": 1860552191.5,
                            "expected_sales": 627698537.29,
                            "global_gross_sales": 15388480354.65,
                            "market_share": 4.079,
                            "sales_green_space": 95206561.71,
                            "client_net_sales": 4327338668.99,
                            "global_net_sales": 72914123076.11,
                            "client_aum": 1860552191.5,
                            "aum_industry": 6802783462.6,
                            "aum_green_space": 2354460310.7
                        }
                    },
                    {
                        "name": "BD Field Michigan West",
                        "x": 554222722.33,
                        "y": 12515558592.72,
                        "z": 6936406954737903000,
                        "data": {
                            "client_gross_sales": 2059750644.35,
                            "expected_sales": 554222722.33,
                            "global_gross_sales": 12515558592.72,
                            "market_share": 4.4282,
                            "sales_green_space": 58386838.21,
                            "client_net_sales": 3186399183.78,
                            "global_net_sales": 70382605752.77,
                            "client_aum": 2059750644.35,
                            "aum_industry": 4920479410.57,
                            "aum_green_space": 1568308848.91
                        }
                    },
                    {
                        "name": "BD Field Metro Atlanta",
                        "x": 541000143.5,
                        "y": 13818174868.76,
                        "z": 7475634586907254000,
                        "data": {
                            "client_gross_sales": 1538189319.48,
                            "expected_sales": 541000143.5,
                            "global_gross_sales": 13818174868.76,
                            "market_share": 3.9151,
                            "sales_green_space": 174766573.71,
                            "client_net_sales": 4633263119.66,
                            "global_net_sales": 55675139027.37,
                            "client_aum": 1538189319.48,
                            "aum_industry": 7400021820.66,
                            "aum_green_space": 2878633550.73
                        }
                    },
                    {
                        "name": "BD Field New Jersey North",
                        "x": 441086790.91,
                        "y": 12147569931.92,
                        "z": 5358132638625401000,
                        "data": {
                            "client_gross_sales": 1439394776.2,
                            "expected_sales": 441086790.91,
                            "global_gross_sales": 12147569931.92,
                            "market_share": 3.631,
                            "sales_green_space": 112660873.52,
                            "client_net_sales": 3370076077.31,
                            "global_net_sales": 51948304164.68,
                            "client_aum": 1439394776.2,
                            "aum_industry": 6955648042.37,
                            "aum_green_space": 2843224137.09
                        }
                    },
                    {
                        "name": "RRB Team West",
                        "x": 788159542.79,
                        "y": 13962335103.13,
                        "z": 11004547651163707000,
                        "data": {
                            "client_gross_sales": 2378832526.19,
                            "expected_sales": 788159542.79,
                            "global_gross_sales": 13962335103.13,
                            "market_share": 5.6448,
                            "sales_green_space": 73793283.9,
                            "client_net_sales": 2449111473.04,
                            "global_net_sales": 34431596811.06,
                            "client_aum": 2378832526.19,
                            "aum_industry": 10206582753.03,
                            "aum_green_space": 5347232416.86
                        }
                    },
                    {
                        "name": "BD Field Pennsylvania West",
                        "x": 646373815.86,
                        "y": 13454933648.85,
                        "z": 8696916804750288000,
                        "data": {
                            "client_gross_sales": 2147409068.48,
                            "expected_sales": 646373815.86,
                            "global_gross_sales": 13454933648.85,
                            "market_share": 4.8039,
                            "sales_green_space": 190447553.78,
                            "client_net_sales": 3409944679.13,
                            "global_net_sales": 79105555954.34,
                            "client_aum": 2147409068.48,
                            "aum_industry": 6770095038.23,
                            "aum_green_space": 1914982400.37
                        }
                    },
                    {
                        "name": "BD Field Virginia",
                        "x": 624257348.4,
                        "y": 10680347619.36,
                        "z": 6667285484851926000,
                        "data": {
                            "client_gross_sales": 2220296218.33,
                            "expected_sales": 624257348.4,
                            "global_gross_sales": 10680347619.36,
                            "market_share": 5.8449,
                            "sales_green_space": 145064998.64,
                            "client_net_sales": 2719600125.43,
                            "global_net_sales": 58127925117.44,
                            "client_aum": 2220296218.33,
                            "aum_industry": 6074029680.93,
                            "aum_green_space": 1764654126.56
                        }
                    },
                    {
                        "name": "BD Field South Atlantic",
                        "x": 455741595.23,
                        "y": 11891912728.52,
                        "z": 5419639277231647000,
                        "data": {
                            "client_gross_sales": 1310340143.35,
                            "expected_sales": 455741595.23,
                            "global_gross_sales": 11891912728.52,
                            "market_share": 3.8323,
                            "sales_green_space": 88844896.71,
                            "client_net_sales": 3776382533.84,
                            "global_net_sales": 56455787791.14,
                            "client_aum": 1310340143.35,
                            "aum_industry": 5669777487.85,
                            "aum_green_space": 1919262232.06
                        }
                    },
                    {
                        "name": "BD Field Connecticut",
                        "x": 392741275.87,
                        "y": 11845873176.32,
                        "z": 4652363345062127000,
                        "data": {
                            "client_gross_sales": 1498764264.72,
                            "expected_sales": 392741275.87,
                            "global_gross_sales": 11845873176.32,
                            "market_share": 3.3154,
                            "sales_green_space": 56241299.33,
                            "client_net_sales": 3718820408.72,
                            "global_net_sales": 49644579701.82,
                            "client_aum": 1498764264.72,
                            "aum_industry": 7321588657.14,
                            "aum_green_space": 2446505661.91
                        }
                    },
                    {
                        "name": "BD Field Pacific Northwest",
                        "x": 688974756.31,
                        "y": 13865798943.85,
                        "z": 9553185448382510000,
                        "data": {
                            "client_gross_sales": 2457927247.77,
                            "expected_sales": 688974756.31,
                            "global_gross_sales": 13865798943.85,
                            "market_share": 4.9688,
                            "sales_green_space": 138922977.59,
                            "client_net_sales": 3092995826.78,
                            "global_net_sales": 74333341685.41,
                            "client_aum": 2457927247.77,
                            "aum_industry": 7356488221.97,
                            "aum_green_space": 2319789541.51
                        }
                    },
                    {
                        "name": "BD Field Metro Detroit",
                        "x": 500558684.76,
                        "y": 12056845964.49,
                        "z": 6035158958339028000,
                        "data": {
                            "client_gross_sales": 1742203441.91,
                            "expected_sales": 500558684.76,
                            "global_gross_sales": 12056845964.49,
                            "market_share": 4.1516,
                            "sales_green_space": 116017817.58,
                            "client_net_sales": 3433913012.91,
                            "global_net_sales": 54597247156.02,
                            "client_aum": 1742203441.91,
                            "aum_industry": 6233989485.02,
                            "aum_green_space": 2217269863.46
                        }
                    },
                    {
                        "name": "BD Field Metro NYC",
                        "x": 276813280.69,
                        "y": 20299997631.89,
                        "z": 5619308942482701000,
                        "data": {
                            "client_gross_sales": 941830001.67,
                            "expected_sales": 276813280.69,
                            "global_gross_sales": 20299997631.89,
                            "market_share": 1.3636,
                            "sales_green_space": 61321363.76,
                            "client_net_sales": 6961638752.81,
                            "global_net_sales": 51904722399.03,
                            "client_aum": 941830001.67,
                            "aum_industry": 10726901015.14,
                            "aum_green_space": 6755879378.48
                        }
                    },
                    {
                        "name": "RRB Team New York Metro",
                        "x": 743815078.03,
                        "y": 12985403943.97,
                        "z": 9658739247835113000,
                        "data": {
                            "client_gross_sales": 2965233636.26,
                            "expected_sales": 743815078.03,
                            "global_gross_sales": 12985403943.97,
                            "market_share": 5.728,
                            "sales_green_space": 117358200.41,
                            "client_net_sales": 3056136115.64,
                            "global_net_sales": 39520535205.58,
                            "client_aum": 2965233636.26,
                            "aum_industry": 7826794755.37,
                            "aum_green_space": 2753490802.24
                        }
                    },
                    {
                        "name": "BD Field Gulf Coast",
                        "x": 634551203.13,
                        "y": 12003160220.66,
                        "z": 7616619759381959000,
                        "data": {
                            "client_gross_sales": 1682134527.55,
                            "expected_sales": 634551203.13,
                            "global_gross_sales": 12003160220.66,
                            "market_share": 5.2865,
                            "sales_green_space": 116323994.95,
                            "client_net_sales": 3248898493.86,
                            "global_net_sales": 63408140377.95,
                            "client_aum": 1682134527.55,
                            "aum_industry": 6000521547.66,
                            "aum_green_space": 1891079710.31
                        }
                    },
                    {
                        "name": "BD Field Metro Chicago",
                        "x": 358305607.22,
                        "y": 10748559336.07,
                        "z": 3851269079650761700,
                        "data": {
                            "client_gross_sales": 1754327614.74,
                            "expected_sales": 358305607.22,
                            "global_gross_sales": 10748559336.07,
                            "market_share": 3.3335,
                            "sales_green_space": 44140483.46,
                            "client_net_sales": 3707574591.37,
                            "global_net_sales": 44490515438.65,
                            "client_aum": 1754327614.74,
                            "aum_industry": 7518054814.88,
                            "aum_green_space": 3093451410.41
                        }
                    },
                    {
                        "name": "RRB Team South-Central",
                        "x": 552255371.9,
                        "y": 8093527184.06,
                        "z": 4469693865015815000,
                        "data": {
                            "client_gross_sales": 1562768601.94,
                            "expected_sales": 552255371.9,
                            "global_gross_sales": 8093527184.06,
                            "market_share": 6.8234,
                            "sales_green_space": 77485001.81,
                            "client_net_sales": 1279056656.66,
                            "global_net_sales": 26380920679.69,
                            "client_aum": 1562768601.94,
                            "aum_industry": 5038101638.75,
                            "aum_green_space": 1489403577.93
                        }
                    },
                    {
                        "name": "BD Field Texas West",
                        "x": 523627455.66,
                        "y": 13454855804.15,
                        "z": 7045331910999248000,
                        "data": {
                            "client_gross_sales": 1498403828.42,
                            "expected_sales": 523627455.66,
                            "global_gross_sales": 13454855804.15,
                            "market_share": 3.8917,
                            "sales_green_space": 132443347.37,
                            "client_net_sales": 4115977846.27,
                            "global_net_sales": 73058561552.84,
                            "client_aum": 1498403828.42,
                            "aum_industry": 4960095145.71,
                            "aum_green_space": 1771376424.81
                        }
                    },
                    {
                        "name": "BD Field New York Upstate",
                        "x": 574578745.93,
                        "y": 9637683734.78,
                        "z": 5537608233999852000,
                        "data": {
                            "client_gross_sales": 1917248805.47,
                            "expected_sales": 574578745.93,
                            "global_gross_sales": 9637683734.78,
                            "market_share": 5.9617,
                            "sales_green_space": 91094735.55,
                            "client_net_sales": 1872548457,
                            "global_net_sales": 51705632561.66,
                            "client_aum": 1917248805.47,
                            "aum_industry": 5753414741.42,
                            "aum_green_space": 1602117001.97
                        }
                    },
                    {
                        "name": "BD Field Orange County",
                        "x": 463683715.86,
                        "y": 11653733842.39,
                        "z": 5403646611682830000,
                        "data": {
                            "client_gross_sales": 1340975786.01,
                            "expected_sales": 463683715.86,
                            "global_gross_sales": 11653733842.39,
                            "market_share": 3.9788,
                            "sales_green_space": 166227031.75,
                            "client_net_sales": 3446969337.6,
                            "global_net_sales": 48343278052.99,
                            "client_aum": 1340975786.01,
                            "aum_industry": 5625670051.43,
                            "aum_green_space": 2238219911.45
                        }
                    },
                    {
                        "name": "BD Field Metro DC",
                        "x": 442667139.14,
                        "y": 10348788914.68,
                        "z": 4581068782425141000,
                        "data": {
                            "client_gross_sales": 2368992860.88,
                            "expected_sales": 442667139.14,
                            "global_gross_sales": 10348788914.68,
                            "market_share": 4.2774,
                            "sales_green_space": 20223607.71,
                            "client_net_sales": 3412899205.65,
                            "global_net_sales": 47594931795.8,
                            "client_aum": 2368992860.88,
                            "aum_industry": 7701964045.15,
                            "aum_green_space": 2740642149.68
                        }
                    },
                    {
                        "name": "RRB Team Great Lakes",
                        "x": 1484689499.74,
                        "y": 16150408588.83,
                        "z": 23978342048346610000,
                        "data": {
                            "client_gross_sales": 1943001573.17,
                            "expected_sales": 1484689499.74,
                            "global_gross_sales": 16150408588.83,
                            "market_share": 9.1928,
                            "sales_green_space": 208152761.59,
                            "client_net_sales": 2615855826.52,
                            "global_net_sales": 52193390671.11,
                            "client_aum": 5776108016.37,
                            "aum_industry": 9371933494.68,
                            "aum_green_space": 3218334387.09
                        }
                    },
                    {
                        "name": "RRB Team Midwest",
                        "x": 856660884.67,
                        "y": 10813033391.04,
                        "z": 9263102750734578000,
                        "data": {
                            "client_gross_sales": 5776108016.37,
                            "expected_sales": 856660884.67,
                            "global_gross_sales": 10813033391.04,
                            "market_share": 7.9224,
                            "sales_green_space": -16326833.31,
                            "client_net_sales": 679066938.96,
                            "global_net_sales": 38812665229.7,
                            "client_aum": 4031203906.38,
                            "aum_industry": 8177334575.93,
                            "aum_green_space": 3077600022.92
                        }
                    },
                    {
                        "name": "BD Field Florida Central",
                        "x": 443524287.37,
                        "y": 12395211470.11,
                        "z": 5497577334080988000,
                        "data": {
                            "client_gross_sales": 4031203906.38,
                            "expected_sales": 443524287.37,
                            "global_gross_sales": 12395211470.11,
                            "market_share": 3.5781,
                            "sales_green_space": 42707359.52,
                            "client_net_sales": 3116905018.42,
                            "global_net_sales": 54125928403.9,
                            "client_aum": 1403423034.77,
                            "aum_industry": 6304111226.32,
                            "aum_green_space": 2180366173.07
                        }
                    },
                    {
                        "name": "BD Field West Central",
                        "x": 509074944.99,
                        "y": 12785261228.28,
                        "z": 6508656156469421000,
                        "data": {
                            "client_gross_sales": 4031203906.38,
                            "expected_sales": 509074944.99,
                            "global_gross_sales": 12785261228.28,
                            "market_share": 3.9817,
                            "sales_green_space": 66164679.37,
                            "client_net_sales": 3358147720.53,
                            "global_net_sales": 71490525306.3,
                            "client_aum": 1727249783.63,
                            "aum_industry": 4688322053.5,
                            "aum_green_space": 1519423029.53
                        }
                    },
                    {
                        "name": "UNKNOWN",
                        "x": 4449691312.96,
                        "y": 138474067232.33,
                        "z": 616166854033937800000,
                        "data": {
                            "client_gross_sales": 1727249783.63,
                            "expected_sales": 4449691312.96,
                            "global_gross_sales": 138474067232.33,
                            "market_share": 3.2133,
                            "sales_green_space": -203422890.81,
                            "client_net_sales": 27887666205.92,
                            "global_net_sales": 551694796105.63,
                            "client_aum": 11694535960.3,
                            "aum_industry": 88537514855.56,
                            "aum_green_space": 26478302694.89
                        }
                    },
                    {
                        "name": "BD Field Metro Boston",
                        "x": 457503251.42,
                        "y": 10220165485.87,
                        "z": 4675758939835990000,
                        "data": {
                            "client_gross_sales": 11694535960.3,
                            "expected_sales": 457503251.42,
                            "global_gross_sales": 10220165485.87,
                            "market_share": 4.4764,
                            "sales_green_space": 195184792.96,
                            "client_net_sales": 3410251369.26,
                            "global_net_sales": 39074447526.17,
                            "client_aum": 1777686323.5,
                            "aum_industry": 6595770492.66,
                            "aum_green_space": 2348617065.18
                        }
                    },
                    {
                        "name": "BD Field Twin Cities",
                        "x": 566084966.5,
                        "y": 12538897704.22,
                        "z": 7098081486840306000,
                        "data": {
                            "client_gross_sales": 1777686323.5,
                            "expected_sales": 566084966.5,
                            "global_gross_sales": 12538897704.22,
                            "market_share": 4.5146,
                            "sales_green_space": 101221157.61,
                            "client_net_sales": 2768276192.21,
                            "global_net_sales": 57023577950.08,
                            "client_aum": 2237212806.52,
                            "aum_industry": 7062264054.22,
                            "aum_green_space": 2139854132.6
                        }
                    },
                    {
                        "name": "BD Field New England North",
                        "x": 371858473.92,
                        "y": 9278037257.05,
                        "z": 3450116775379515400,
                        "data": {
                            "client_gross_sales": 2237212806.52,
                            "expected_sales": 371858473.92,
                            "global_gross_sales": 9278037257.05,
                            "market_share": 4.0079,
                            "sales_green_space": 79614317.58,
                            "client_net_sales": 2463944717.29,
                            "global_net_sales": 51179047978.44,
                            "client_aum": 1337919508.33,
                            "aum_industry": 5371142880.53,
                            "aum_green_space": 1567707972.71
                        }
                    },
                    {
                        "name": "BD Field Pennsylvania East",
                        "x": 979433371.02,
                        "y": 14262644472.83,
                        "z": 13969309955683658000,
                        "data": {
                            "client_gross_sales": 1777686323.5,
                            "expected_sales": 979433371.02,
                            "global_gross_sales": 14262644472.83,
                            "market_share": 6.8671,
                            "sales_green_space": 196706656.74,
                            "client_net_sales": 3327933468.49,
                            "global_net_sales": 70982712802.44,
                            "client_aum": 2707733919.46,
                            "aum_industry": 8078517550.55,
                            "aum_green_space": 2290963815.58
                        }
                    },
                    {
                        "name": "BD Field Metro San Francisco",
                        "x": 492369851.44,
                        "y": 15144402139.39,
                        "z": 7456647031519072000,
                        "data": {
                            "client_gross_sales": 1337919508.33,
                            "expected_sales": 492369851.44,
                            "global_gross_sales": 15144402139.39,
                            "market_share": 3.2511,
                            "sales_green_space": 119104131.39,
                            "client_net_sales": 3601820391.76,
                            "global_net_sales": 61175580307.97,
                            "client_aum": 1430031337.16,
                            "aum_industry": 8575267545.84,
                            "aum_green_space": 4065056563.52
                        }
                    },
                    {
                        "name": "BD Field Upper Plains",
                        "x": 705926177.12,
                        "y": 14005979654.92,
                        "z": 9887187674618173000,
                        "data": {
                            "client_gross_sales": 1430031337.16,
                            "expected_sales": 705926177.12,
                            "global_gross_sales": 14005979654.92,
                            "market_share": 5.0401,
                            "sales_green_space": 213479014.32,
                            "client_net_sales": 3837986591.67,
                            "global_net_sales": 81005912408.79,
                            "client_aum": 2316791438.6,
                            "aum_industry": 5650750194.02,
                            "aum_green_space": 1823357542.67
                        }
                    },
                    {
                        "name": "BD Field Wisconsin East",
                        "x": 784531871.32,
                        "y": 14336531437.58,
                        "z": 11247465836962648000,
                        "data": {
                            "client_gross_sales": 1777686323.5,
                            "expected_sales": 784531871.32,
                            "global_gross_sales": 14336531437.58,
                            "market_share": 5.4722,
                            "sales_green_space": 83153027.1,
                            "client_net_sales": 3075724380.35,
                            "global_net_sales": 77770008405.38,
                            "client_aum": 2998958980.99,
                            "aum_industry": 7668305327.81,
                            "aum_green_space": 2465656556.17
                        }
                    },
                    {
                        "name": "RRB Team Great Plains",
                        "x": 748779759.96,
                        "y": 9178138404.59,
                        "z": 6872404271468558000,
                        "data": {
                            "client_gross_sales": 2998958980.99,
                            "expected_sales": 748779759.96,
                            "global_gross_sales": 9178138404.59,
                            "market_share": 8.1582,
                            "sales_green_space": 47797448.49,
                            "client_net_sales": 331675996,
                            "global_net_sales": 30223415499.86,
                            "client_aum": 3085870322.01,
                            "aum_industry": 6132629981.07,
                            "aum_green_space": 2132078688.57
                        }
                    },
                    {
                        "name": "BD Field Mountain West",
                        "x": 498664839.24,
                        "y": 12104097552.48,
                        "z": 6035887860152716000,
                        "data": {
                            "client_gross_sales": 3085870322.01,
                            "expected_sales": 498664839.24,
                            "global_gross_sales": 12104097552.48,
                            "market_share": 4.1198,
                            "sales_green_space": 67403034.71,
                            "client_net_sales": 3348194600.46,
                            "global_net_sales": 58268425511.83,
                            "client_aum": 1753705826.54,
                            "aum_industry": 5698478054.45,
                            "aum_green_space": 1813632160.56
                        }
                    },
                    {
                        "name": "BD Field Ohio North",
                        "x": 655636788.54,
                        "y": 12378706040.78,
                        "z": 8115935074857697000,
                        "data": {
                            "client_gross_sales": 1777686323.5,
                            "expected_sales": 655636788.54,
                            "global_gross_sales": 12378706040.78,
                            "market_share": 5.2964,
                            "sales_green_space": 69816849.97,
                            "client_net_sales": 2998828939.49,
                            "global_net_sales": 69952361180.5,
                            "client_aum": 1815949763.24,
                            "aum_industry": 6298532521.04,
                            "aum_green_space": 1675302273.02
                        }
                    },
                    {
                        "name": "BD Field St. Louis",
                        "x": 658893368.17,
                        "y": 14090581963.66,
                        "z": 9284191009511390000,
                        "data": {
                            "client_gross_sales": 1815949763.24,
                            "expected_sales": 658893368.17,
                            "global_gross_sales": 14090581963.66,
                            "market_share": 4.6761,
                            "sales_green_space": 101429424.45,
                            "client_net_sales": 3323216446.54,
                            "global_net_sales": 86084856107.29,
                            "client_aum": 2129935641,
                            "aum_industry": 5610481636.87,
                            "aum_green_space": 1780428037.57
                        }
                    },
                    {
                        "name": "BD Field Long Island",
                        "x": 415989482.21,
                        "y": 11108779391.03,
                        "z": 4621135386859689000,
                        "data": {
                            "client_gross_sales": 1777686323.5,
                            "expected_sales": 415989482.21,
                            "global_gross_sales": 11108779391.03,
                            "market_share": 3.7446,
                            "sales_green_space": 47893666.23,
                            "client_net_sales": 2332840546.34,
                            "global_net_sales": 55204749031.78,
                            "client_aum": 1356814417.24,
                            "aum_industry": 6465905355.29,
                            "aum_green_space": 2127746258.14
                        }
                    },
                    {
                        "name": "BD Field South Central",
                        "x": 577119951.51,
                        "y": 13163919899.36,
                        "z": 7597160814000168000,
                        "data": {
                            "client_gross_sales": 1356814417.24,
                            "expected_sales": 577119951.51,
                            "global_gross_sales": 13163919899.36,
                            "market_share": 4.3841,
                            "sales_green_space": 155783584.97,
                            "client_net_sales": 3823191067.55,
                            "global_net_sales": 62459372378.38,
                            "client_aum": 1802214202.1,
                            "aum_industry": 6300973414.29,
                            "aum_green_space": 2042686270.32
                        }
                    },
                    {
                        "name": "BD Field Greater Baltimore",
                        "x": 689427564.7,
                        "y": 10154063543.43,
                        "z": 7000491300555998000,
                        "data": {
                            "client_gross_sales": 2537130899.02,
                            "expected_sales": 689427564.7,
                            "global_gross_sales": 10154063543.43,
                            "market_share": 6.7896,
                            "sales_green_space": 158163108.85,
                            "client_net_sales": 2402478166.34,
                            "global_net_sales": 50963305608.21,
                            "client_aum": 2537130899.02,
                            "aum_industry": 7271427040,
                            "aum_green_space": 1962022381.28
                        }
                    },
                    {
                        "name": "BD Field LA North",
                        "x": 370492750.75,
                        "y": 10361272499.93,
                        "z": 3838776349769395000,
                        "data": {
                            "client_gross_sales": 52363641586.71,
                            "expected_sales": 370492750.75,
                            "global_gross_sales": 10361272499.93,
                            "market_share": 3.5757,
                            "sales_green_space": 117444814.48,
                            "client_net_sales": 2460666959.66,
                            "global_net_sales": 52363641586.71,
                            "client_aum": 1104837772.44,
                            "aum_industry": 5883139969.97,
                            "aum_green_space": 1818544407.43
                        }
                    },
                    {
                        "name": "BD Field Metro LA",
                        "x": 290215941.44,
                        "y": 11504159005.59,
                        "z": 3338690336282756000,
                        "data": {
                            "client_gross_sales": 1777686323.5,
                            "expected_sales": 290215941.44,
                            "global_gross_sales": 11504159005.59,
                            "market_share": 2.5227,
                            "sales_green_space": 142842566.35,
                            "client_net_sales": 5375068117.51,
                            "global_net_sales": 32049692880.57,
                            "client_aum": 793619483.36,
                            "aum_industry": 4956300368.99,
                            "aum_green_space": 3115049241.98
                        }
                    },
                    {
                        "name": "BD Field San Diego",
                        "x": 448932327.93,
                        "y": 9687486861.66,
                        "z": 4349026028596313600,
                        "data": {
                            "client_gross_sales": 793619483.36,
                            "expected_sales": 448932327.93,
                            "global_gross_sales": 9687486861.66,
                            "market_share": 4.6341,
                            "sales_green_space": 132982136.61,
                            "client_net_sales": 2352161692.79,
                            "global_net_sales": 42915143854.44,
                            "client_aum": 1193453740.06,
                            "aum_industry": 5672409130.79,
                            "aum_green_space": 2076288253.05
                        }
                    },
                    {
                        "name": "BD Field New England South",
                        "x": 522763148.13,
                        "y": 9872493631.84,
                        "z": 5160975850874056000,
                        "data": {
                            "client_gross_sales": 1193453740.06,
                            "expected_sales": 522763148.13,
                            "global_gross_sales": 9872493631.84,
                            "market_share": 5.2951,
                            "sales_green_space": 65314855.22,
                            "client_net_sales": 2559582277.23,
                            "global_net_sales": 48522477781.93,
                            "client_aum": 1999880146.88,
                            "aum_industry": 6107203318.6,
                            "aum_green_space": 1828269566.19
                        }
                    },
                    {
                        "name": "BD Field Carolina West",
                        "x": 756209024.83,
                        "y": 13184035383.94,
                        "z": 9969886541013484000,
                        "data": {
                            "client_gross_sales": 1999880146.88,
                            "expected_sales": 756209024.83,
                            "global_gross_sales": 13184035383.94,
                            "market_share": 5.7357,
                            "sales_green_space": 126063987.87,
                            "client_net_sales": 3810190988.48,
                            "global_net_sales": 60521182807,
                            "client_aum": 2249300647.73,
                            "aum_industry": 6852776878.66,
                            "aum_green_space": 2415326987.44
                        }
                    },
                    {
                        "name": "BD Field Florida South",
                        "x": 423966732.17,
                        "y": 12885718122.87,
                        "z": 5463115804216941000,
                        "data": {
                            "client_gross_sales": 2195623930.67,
                            "expected_sales": 423966732.17,
                            "global_gross_sales": 12885718122.87,
                            "market_share": 3.2902,
                            "sales_green_space": 88908226.73,
                            "client_net_sales": 3873862059.94,
                            "global_net_sales": 49137246925.41,
                            "client_aum": 1173756505.48,
                            "aum_industry": 6905825058.2,
                            "aum_green_space": 3009276951.58
                        }
                    },
                    {
                        "name": "BD Field Ohio South",
                        "x": 659057352.27,
                        "y": 14192690211.66,
                        "z": 9353796832484985000,
                        "data": {
                            "client_gross_sales": 1777686323.5,
                            "expected_sales": 659057352.27,
                            "global_gross_sales": 14192690211.66,
                            "market_share": 4.6436,
                            "sales_green_space": 163946167.13,
                            "client_net_sales": 4119528237.6,
                            "global_net_sales": 68952845896.77,
                            "client_aum": 2195623930.67,
                            "aum_industry": 7378779660,
                            "aum_green_space": 2542452500.52
                        }
                    },
                    {
                        "name": "BD Field Carolina East",
                        "x": 401100913.54,
                        "y": 11173609436.74,
                        "z": 4481744952615579000,
                        "data": {
                            "client_gross_sales": 2195623930.67,
                            "expected_sales": 401100913.54,
                            "global_gross_sales": 11173609436.74,
                            "market_share": 3.5897,
                            "sales_green_space": 57398546.4,
                            "client_net_sales": 3344657624.39,
                            "global_net_sales": 53172440220.45,
                            "client_aum": 1527018285.7,
                            "aum_industry": 5822491957.23,
                            "aum_green_space": 1917716794.7
                        }
                    },
                    {
                        "name": "BD Field Mid-America",
                        "x": 619356204.63,
                        "y": 11507915644.44,
                        "z": 7127498956742560000,
                        "data": {
                            "client_gross_sales": 1527018285.7,
                            "expected_sales": 619356204.63,
                            "global_gross_sales": 11507915644.44,
                            "market_share": 5.382,
                            "sales_green_space": 91982231.81,
                            "client_net_sales": 2566552541.48,
                            "global_net_sales": 65380210102.11,
                            "client_aum": 2040057109.95,
                            "aum_industry": 4521082920.17,
                            "aum_green_space": 1568504055.98
                        }
                    },
                    {
                        "name": "BD Field Indiana",
                        "x": 635145469.09,
                        "y": 14252068326.3,
                        "z": 9052136622610545000,
                        "data": {
                            "client_gross_sales": 2040057109.95,
                            "expected_sales": 635145469.09,
                            "global_gross_sales": 14252068326.3,
                            "market_share": 4.4565,
                            "sales_green_space": 144418671.38,
                            "client_net_sales": 3296428620.28,
                            "global_net_sales": 81162507158.67,
                            "client_aum": 2202681499.74,
                            "aum_industry": 6186370065.6,
                            "aum_green_space": 2022114498.48
                        }
                    }
                ]
            };
            this.opportunitiesMockData = [
                { territory: "Territory1", percentDiff: 0.2, diffExpectedSales: -0.94, expectedSales: 1080787376, actualSales: 556542242, industryGrossSales: 14266361824, marketShare: 0.05, greenSpace: 3859138650, netSales: 143008412, industryNetSales: 3459805419 },
                { territory: "Territory4", percentDiff: 0.4, diffExpectedSales: -0.93, expectedSales: 1194654568, actualSales: 656542234, industryGrossSales: 24566546545, marketShare: 0.03, greenSpace: 4894646444, netSales: 216584444, industryNetSales: 5465486466 },
                { territory: "Territory2", percentDiff: 0.5, diffExpectedSales: -0.92, expectedSales: 2161564648, actualSales: 765654984, industryGrossSales: 38486835488, marketShare: 0.01, greenSpace: 5489654141, netSales: 354984641, industryNetSales: 2468486486 },
                { territory: "Territory3", percentDiff: 0.3, diffExpectedSales: -0.97, expectedSales: 1801651884, actualSales: 816564848, industryGrossSales: 48974641684, marketShare: 0.02, greenSpace: 6489466144, netSales: 564654894, industryNetSales: 4894646847 }
            ];
            this.analyticstableMockData = [
                { territory: "Territory abc", firm: "abc", category: "abc cat", percentDiff: 0.2, diffExpectedSales: -0.94, expectedSales: 1080787376, actualSales: 556542242, differenceActual: 122111, globalSales: 14266361824, marketShare: 0.05, greenSpace: 3859138650, netSales: 143008412, AUM: 3459805419 },
                { territory: "Territory bcd", firm: "bcd", category: "bcd cat", percentDiff: 0.4, diffExpectedSales: -0.93, expectedSales: 1194654568, actualSales: 656542234, differenceActual: 122112, globalSales: 24566546545, marketShare: 0.03, greenSpace: 4894646444, netSales: 216584444, AUM: 5465486466 },
                { territory: "Territory cde", firm: "cde", category: "cde cat", percentDiff: 0.5, diffExpectedSales: -0.92, expectedSales: 2161564648, actualSales: 765654984, differenceActual: 122113, globalSales: 38486835488, marketShare: 0.01, greenSpace: 5489654141, netSales: 354984641, AUM: 2468486486 },
                { territory: "Territory def", firm: "def", category: "def cat", percentDiff: 0.3, diffExpectedSales: -0.97, expectedSales: 1801651884, actualSales: 816564848, differenceActual: 122114, globalSales: 48974641684, marketShare: 0.02, greenSpace: 6489466144, netSales: 564654894, AUM: 4894646847 }
            ];
            this.mockDataAnalytics3 = ['BD Field LA North', 'BD Field Orange County', 'BD Field Long Island', 'BD Field Heartland', 'BD Field Texas North', 'BD Field San Diego', 'BD Field Texas West', 'BD Field Metro Boston', 'BD Field Michigan West', 'BD Field West Central', 'BD Field Florida South', 'BD Field New Jersey North', 'BD Field Mountain West', 'BD Field Colorado', 'BD Field Chicago West', 'BD Field Metro DC', 'BD Field Twin Cities', 'RRB Team West', 'BD Field Indiana', 'BD Field Pennsylvania West', 'BD Field Metro Detroit', 'BD Field Metro Atlanta', 'BD Field Mid-America', 'BD Field New England South', 'BD Field South Central', 'BD Field Ohio South', 'BD Field Metro Seattle', 'BD Field New England North', 'RRB Team Southwest', 'BD Field South Atlantic', 'BD Field New York Upstate', 'BD Field Pacific Northwest', 'BD Field Upper Plains', 'BD Field Wisconsin East', 'BD Field Gulf Coast', 'BD Field Virginia', 'BD Field Ohio North', 'BD Field St. Louis', 'BD Field Carolina West', 'RRB Team South-Central', 'RRB Team New York Metro', 'BD Field Greater Baltimore', 'RRB Team New England', 'BD Field Southwest', 'RRB Team Great Lakes', 'BD Field Pennsylvania East', 'RRB Team Midwest', 'RRB Team Great Plains', 'RRB Team Southeast', 'RRB Team Mid-Atlantic'];
            this.mockDataTable = [
                {
                    "line": {
                        "rank": 1,
                        "optionValue": "UNKNOWN",
                        "marketShare": 2.6034849168578855,
                        "marketShareChange": -0.38414419132030275,
                        "grossSales": 939551138.48,
                        "competitorSales": 35148660181.52,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 6.380936320777073,
                                "grossSales": 688433271.38,
                                "competitorSales": 10100473509.25,
                                "globalSales": 10788906780.63,
                                "netSales": 415412005.88
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 2.6873233641549663,
                                "grossSales": 274654123.87,
                                "competitorSales": 9945705938.99,
                                "globalSales": 10220360062.86,
                                "netSales": -50213362.01
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 4.7811796275749,
                                "grossSales": 491505377.59,
                                "competitorSales": 9788496962.32,
                                "globalSales": 10280002339.91,
                                "netSales": -351887973.3
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 3.185812605992421,
                                "grossSales": 332474664.8,
                                "competitorSales": 10103627702.76,
                                "globalSales": 10436102367.56,
                                "netSales": -67594123.29
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 2.5160872295018804,
                                "grossSales": 246502376.6,
                                "competitorSales": 9550549717.21,
                                "globalSales": 9797052093.81,
                                "netSales": -296798303.18
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 2.605195669284522,
                                "grossSales": 293197497.34,
                                "competitorSales": 10961139395.54,
                                "globalSales": 11254336892.88,
                                "netSales": -62010705.05
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 2.6999800832207037,
                                "grossSales": 347240898.23,
                                "competitorSales": 12513627979.58,
                                "globalSales": 12860868877.81,
                                "netSales": -6895354.52
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 3.023403797494555,
                                "grossSales": 383685143.97,
                                "competitorSales": 12306817669.05,
                                "globalSales": 12690502813.02,
                                "netSales": 64184282.67
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 3.2184927721960173,
                                "grossSales": 452446820.7,
                                "competitorSales": 13605276863.15,
                                "globalSales": 14057723683.85,
                                "netSales": 95332299.04
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 2.5626009012223148,
                                "grossSales": 335509647.92,
                                "competitorSales": 12757034249.96,
                                "globalSales": 13092543897.88,
                                "netSales": 42274760.88
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 2.2630238382080257,
                                "grossSales": 256224805.56,
                                "competitorSales": 11066007034.6,
                                "globalSales": 11322231840.16,
                                "netSales": 3236970.3
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 2.9795571540011077,
                                "grossSales": 347816685,
                                "competitorSales": 11325618896.96,
                                "globalSales": 11673435581.96,
                                "netSales": 11536611.77
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 2,
                        "optionValue": "BD Field Pennsylvania East",
                        "marketShare": 8.243399061864684,
                        "marketShareChange": 1.902637926456154,
                        "grossSales": 309947255.5,
                        "competitorSales": 3449997558.21,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 6.028300592222286,
                                "grossSales": 63465264.21,
                                "competitorSales": 989323382.26,
                                "globalSales": 1052788646.47,
                                "netSales": 8625428.82
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 5.543888426302062,
                                "grossSales": 57971620.26,
                                "competitorSales": 987713570.39,
                                "globalSales": 1045685190.65,
                                "netSales": 19670354.16
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 5.1426008502907194,
                                "grossSales": 48838747.33,
                                "competitorSales": 900850889.33,
                                "globalSales": 949689636.66,
                                "netSales": 11345830.55
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 4.652206557399293,
                                "grossSales": 45223271.48,
                                "competitorSales": 926858920.53,
                                "globalSales": 972082192.01,
                                "netSales": 662531.89
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 10.068136219749857,
                                "grossSales": 106892114.61,
                                "competitorSales": 954795096.18,
                                "globalSales": 1061687210.79,
                                "netSales": 39396078.65
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 6.645619164609186,
                                "grossSales": 73620321.57,
                                "competitorSales": 1034181972.64,
                                "globalSales": 1107802294.21,
                                "netSales": 22243757.88
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 5.16160838664179,
                                "grossSales": 71663905.81,
                                "competitorSales": 1316738709.07,
                                "globalSales": 1388402614.88,
                                "netSales": 18379751.32
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 6.671331980687421,
                                "grossSales": 91621865.39,
                                "competitorSales": 1281745037.28,
                                "globalSales": 1373366902.67,
                                "netSales": 30865192.75
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 7.103491626497008,
                                "grossSales": 110189004.86,
                                "competitorSales": 1441005965.92,
                                "globalSales": 1551194970.78,
                                "netSales": 52019349.02
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 9.051096367311034,
                                "grossSales": 130108294.85,
                                "competitorSales": 1307378276.61,
                                "globalSales": 1437486571.46,
                                "netSales": -47440844.97
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 9.972643011317743,
                                "grossSales": 117244158.24,
                                "competitorSales": 1058413669.95,
                                "globalSales": 1175657828.19,
                                "netSales": 23597661.26
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 5.458212400569039,
                                "grossSales": 62594802.41,
                                "competitorSales": 1084205611.65,
                                "globalSales": 1146800414.06,
                                "netSales": 17341565.41
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 3,
                        "optionValue": "RRB Team Great Lakes",
                        "marketShare": 8.208407896899082,
                        "marketShareChange": -0.2897134208743406,
                        "grossSales": 295964486.03,
                        "competitorSales": 3309661473.9300003,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 14.674961582255714,
                                "grossSales": 272022643.3,
                                "competitorSales": 1581628841.75,
                                "globalSales": 1853651485.05,
                                "netSales": 155475819.33
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 8.191085308293369,
                                "grossSales": 97261000.11,
                                "competitorSales": 1090139648.88,
                                "globalSales": 1187400648.99,
                                "netSales": 32911490.49
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 8.5527331700038,
                                "grossSales": 89793315.45,
                                "competitorSales": 960085286.69,
                                "globalSales": 1049878602.14,
                                "netSales": -11861815.27
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 9.501571362556016,
                                "grossSales": 109993560.84,
                                "competitorSales": 1047641914.84,
                                "globalSales": 1157635475.68,
                                "netSales": 27363787.55
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 8.197169703673955,
                                "grossSales": 87855253.16,
                                "competitorSales": 983920205.15,
                                "globalSales": 1071775458.31,
                                "netSales": 18981322.23
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 8.72948368479631,
                                "grossSales": 107106259.12,
                                "competitorSales": 1119842126.23,
                                "globalSales": 1226948385.35,
                                "netSales": 17507073.93
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 8.929337790547462,
                                "grossSales": 131451632.02,
                                "competitorSales": 1340680289.78,
                                "globalSales": 1472131921.8,
                                "netSales": 34296484.12
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 9.657089188683068,
                                "grossSales": 177397151.08,
                                "competitorSales": 1659565805.5,
                                "globalSales": 1836962956.58,
                                "netSales": -74312847.16
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 6.861191470180156,
                                "grossSales": 115844198.63,
                                "competitorSales": 1572553496.34,
                                "globalSales": 1688397694.97,
                                "netSales": -30123167.36
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 7.028224142673942,
                                "grossSales": 91801129.77,
                                "competitorSales": 1214377044.21,
                                "globalSales": 1306178173.98,
                                "netSales": 1618249.43
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 8.460740369366874,
                                "grossSales": 90200195,
                                "competitorSales": 975902664.35,
                                "globalSales": 1066102859.35,
                                "netSales": 15577954.19
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 9.240169461060152,
                                "grossSales": 113963161.26,
                                "competitorSales": 1119381765.37,
                                "globalSales": 1233344926.63,
                                "netSales": 20718410.11
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 4,
                        "optionValue": "BD Field Southwest",
                        "marketShare": 7.984381572013416,
                        "marketShareChange": 2.6781776853165464,
                        "grossSales": 277942667.21000004,
                        "competitorSales": 3203136796.53,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 4.794822840619248,
                                "grossSales": 48074639.97,
                                "competitorSales": 954561777.85,
                                "globalSales": 1002636417.82,
                                "netSales": 16262447.75
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 5.295540263636913,
                                "grossSales": 52096354.92,
                                "competitorSales": 931681547.36,
                                "globalSales": 983777902.28,
                                "netSales": 6053078.64
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 5.701916605669967,
                                "grossSales": 51586767.12,
                                "competitorSales": 853140023.67,
                                "globalSales": 904726790.79,
                                "netSales": 22273975.1
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 4.806044172283168,
                                "grossSales": 39520376.38,
                                "competitorSales": 782785348.73,
                                "globalSales": 822305725.11,
                                "netSales": 8056063.39
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 7.811228979584009,
                                "grossSales": 77783855.84,
                                "competitorSales": 918011505.47,
                                "globalSales": 995795361.31,
                                "netSales": 4695581.96
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 4.1941640759454355,
                                "grossSales": 43118155.54,
                                "competitorSales": 984933078.49,
                                "globalSales": 1028051234.03,
                                "netSales": 15366752.78
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 5.313843034317425,
                                "grossSales": 68441062.06,
                                "competitorSales": 1219535673.76,
                                "globalSales": 1287976735.82,
                                "netSales": 29058661.81
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 6.176608259983817,
                                "grossSales": 75202671.41,
                                "competitorSales": 1142337250.9,
                                "globalSales": 1217539922.31,
                                "netSales": 3786921.94
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 4.432593241993031,
                                "grossSales": 54269741.19,
                                "competitorSales": 1170064147.06,
                                "globalSales": 1224333888.25,
                                "netSales": 16164106.57
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 4.728828357846309,
                                "grossSales": 53654474.13,
                                "competitorSales": 1080970639.53,
                                "globalSales": 1134625113.66,
                                "netSales": 26454215.48
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 14.344818433715718,
                                "grossSales": 185161752.86,
                                "competitorSales": 1105630136.32,
                                "globalSales": 1290791889.18,
                                "netSales": 44596479.44
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.706340015789037,
                                "grossSales": 39126440.22,
                                "competitorSales": 1016536020.68,
                                "globalSales": 1055662460.9,
                                "netSales": 5785103.94
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 5,
                        "optionValue": "RRB Team Mid-Atlantic",
                        "marketShare": 12.78828552435803,
                        "marketShareChange": 0.6656306010220057,
                        "grossSales": 242639116.17000002,
                        "competitorSales": 1654715425.2799997,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 8.484287613501888,
                                "grossSales": 48642803.07,
                                "competitorSales": 524685274.5,
                                "globalSales": 573328077.57,
                                "netSales": -11086333.67
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 13.107207848244965,
                                "grossSales": 75200160.75,
                                "competitorSales": 498531190.89,
                                "globalSales": 573731351.64,
                                "netSales": 21462401.08
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 10.70638585958957,
                                "grossSales": 57224133.7,
                                "competitorSales": 477261867.93,
                                "globalSales": 534486001.63,
                                "netSales": -16645485.03
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 14.491832219371448,
                                "grossSales": 78405156.69,
                                "competitorSales": 462624821.46,
                                "globalSales": 541029978.15,
                                "netSales": 19376253.11
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 15.882740441496612,
                                "grossSales": 98459253.25,
                                "competitorSales": 521454253.57,
                                "globalSales": 619913506.82,
                                "netSales": 47675618.76
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 15.335402338778149,
                                "grossSales": 92195369.06,
                                "competitorSales": 508997654.92,
                                "globalSales": 601193023.98,
                                "netSales": 36986181.71
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 15.155937235456193,
                                "grossSales": 113250849.29,
                                "competitorSales": 633986669.12,
                                "globalSales": 747237518.41,
                                "netSales": 43945606.97
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 11.051597392440415,
                                "grossSales": 81099457.93,
                                "competitorSales": 652726205.91,
                                "globalSales": 733825663.84,
                                "netSales": 26452568.52
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 10.29018202364336,
                                "grossSales": 83143252.34,
                                "competitorSales": 724842963.54,
                                "globalSales": 807986215.88,
                                "netSales": 14731808.84
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 12.249126758694699,
                                "grossSales": 83027867.85,
                                "competitorSales": 594798964.1,
                                "globalSales": 677826831.95,
                                "netSales": 18989872.52
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 16.515430604886006,
                                "grossSales": 84192866.21,
                                "competitorSales": 425590185.92,
                                "globalSales": 509783052.13,
                                "netSales": 33712670.56
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 10.626128893941546,
                                "grossSales": 75418382.11,
                                "competitorSales": 634326275.26,
                                "globalSales": 709744657.37,
                                "netSales": -66726458.33
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 6,
                        "optionValue": "BD Field St. Louis",
                        "marketShare": 6.163758271632659,
                        "marketShareChange": 2.0167032479359293,
                        "grossSales": 230955601.07000002,
                        "competitorSales": 3516037562.71,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 3.889694940263962,
                                "grossSales": 39320956.63,
                                "competitorSales": 971579826.95,
                                "globalSales": 1010900783.58,
                                "netSales": -2751984.72
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 4.258014963982947,
                                "grossSales": 41089049.13,
                                "competitorSales": 923892273.8,
                                "globalSales": 964981322.93,
                                "netSales": -1008094.37
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 5.065503391120382,
                                "grossSales": 50363197.9,
                                "competitorSales": 943875558.08,
                                "globalSales": 994238755.98,
                                "netSales": 12444267.8
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 3.6580003119392557,
                                "grossSales": 37859657.12,
                                "competitorSales": 997122679.99,
                                "globalSales": 1034982337.11,
                                "netSales": -6892531.47
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 4.536681923530469,
                                "grossSales": 43712963.42,
                                "competitorSales": 919831850.98,
                                "globalSales": 963544814.4,
                                "netSales": -1490280.94
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 3.52797686185196,
                                "grossSales": 41656835.18,
                                "competitorSales": 1139100205.22,
                                "globalSales": 1180757040.4,
                                "netSales": 9120457.31
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 3.6711848111839855,
                                "grossSales": 49156419.26,
                                "competitorSales": 1289823277.71,
                                "globalSales": 1338979696.97,
                                "netSales": 493066.06
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 4.457584017737249,
                                "grossSales": 59199581.58,
                                "competitorSales": 1268864709.4,
                                "globalSales": 1328064290.98,
                                "netSales": 7329621.87
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 4.294243965337385,
                                "grossSales": 65579106.88,
                                "competitorSales": 1461560650.65,
                                "globalSales": 1527139757.53,
                                "netSales": 12812061.39
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 8.467462765750302,
                                "grossSales": 115224492.15,
                                "competitorSales": 1245566754.74,
                                "globalSales": 1360791246.89,
                                "netSales": 72352110.47
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 5.763049894007675,
                                "grossSales": 70123611.89,
                                "competitorSales": 1146655926.37,
                                "globalSales": 1216779538.26,
                                "netSales": -1180498.34
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.9000020748217614,
                                "grossSales": 45607497.03,
                                "competitorSales": 1123814881.6,
                                "globalSales": 1169422378.63,
                                "netSales": 201229.39
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 7,
                        "optionValue": "RRB Team Southeast",
                        "marketShare": 9.242872660260806,
                        "marketShareChange": 2.0751668150567806,
                        "grossSales": 227073880.82999998,
                        "competitorSales": 2229671864.53,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 7.4716535225961405,
                                "grossSales": 58925926.41,
                                "competitorSales": 729733855.95,
                                "globalSales": 788659782.36,
                                "netSales": -62040.13
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 11.846392382510913,
                                "grossSales": 108785770.53,
                                "competitorSales": 809517177.89,
                                "globalSales": 918302948.42,
                                "netSales": 54850410.79
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 11.841325817955383,
                                "grossSales": 87408905,
                                "competitorSales": 650759323.32,
                                "globalSales": 738168228.32,
                                "netSales": 40449491.78
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 7.536768385481453,
                                "grossSales": 44493812.07,
                                "competitorSales": 545862820.83,
                                "globalSales": 590356632.9,
                                "netSales": -6250215.9
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 7.697646686581636,
                                "grossSales": 49974357.7,
                                "competitorSales": 599241691.5,
                                "globalSales": 649216049.2,
                                "netSales": 9503859.51
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 9.582143800288227,
                                "grossSales": 78238423.8,
                                "competitorSales": 738263868.7,
                                "globalSales": 816502292.5,
                                "netSales": 15247538.94
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 6.757201625554686,
                                "grossSales": 79926858.95,
                                "competitorSales": 1102912774.66,
                                "globalSales": 1182839633.61,
                                "netSales": -969023.89
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 8.88037718028646,
                                "grossSales": 78413108.15,
                                "competitorSales": 804579883.68,
                                "globalSales": 882992991.83,
                                "netSales": -21991532.77
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 6.306798516354357,
                                "grossSales": 75214735.89,
                                "competitorSales": 1117382993.29,
                                "globalSales": 1192597729.18,
                                "netSales": 11118518.92
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 7.561629138169416,
                                "grossSales": 65193859.26,
                                "competitorSales": 796972984.27,
                                "globalSales": 862166843.53,
                                "netSales": 22671789.32
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 11.719523169462459,
                                "grossSales": 91543272.1,
                                "competitorSales": 689574447.25,
                                "globalSales": 781117719.35,
                                "netSales": 33064511.25
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 8.646601827460811,
                                "grossSales": 70336749.47,
                                "competitorSales": 743124433.01,
                                "globalSales": 813461182.48,
                                "netSales": 15554202.2
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 8,
                        "optionValue": "BD Field Carolina West",
                        "marketShare": 6.427521241084339,
                        "marketShareChange": 1.224746522129971,
                        "grossSales": 225639017,
                        "competitorSales": 3284874733.74,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 5.0311697859406515,
                                "grossSales": 48163012.06,
                                "competitorSales": 909129508.55,
                                "globalSales": 957292520.61,
                                "netSales": 5737663.4
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 5.544847762451571,
                                "grossSales": 55831500.26,
                                "competitorSales": 951076221.14,
                                "globalSales": 1006907721.4,
                                "netSales": 8932282.15
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 5.558904724650775,
                                "grossSales": 52454923.9,
                                "competitorSales": 891164844.71,
                                "globalSales": 943619768.61,
                                "netSales": 14993888.77
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 4.683588704815179,
                                "grossSales": 43531561.18,
                                "competitorSales": 885917285.07,
                                "globalSales": 929448846.25,
                                "netSales": -7916904.42
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 8.140085917144999,
                                "grossSales": 74395920.47,
                                "competitorSales": 839549229.83,
                                "globalSales": 913945150.3,
                                "netSales": 14331751.75
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 5.212449206677505,
                                "grossSales": 51999670.34,
                                "competitorSales": 945605644.9,
                                "globalSales": 997605315.24,
                                "netSales": 15096308.96
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 4.630356607122478,
                                "grossSales": 56353645.73,
                                "competitorSales": 1160693992.53,
                                "globalSales": 1217047638.26,
                                "netSales": 8215050.85
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 6.005131698245467,
                                "grossSales": 75616163.01,
                                "competitorSales": 1183576254.57,
                                "globalSales": 1259192417.58,
                                "netSales": 10326974.65
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 4.986226643682413,
                                "grossSales": 72223610.88,
                                "competitorSales": 1376238644.07,
                                "globalSales": 1448462254.95,
                                "netSales": 25875152.28
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 5.152376010581683,
                                "grossSales": 64513247.48,
                                "competitorSales": 1187593496.04,
                                "globalSales": 1252106743.52,
                                "netSales": 10080495.25
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 10.260612665101302,
                                "grossSales": 122360902.36,
                                "competitorSales": 1070169274.48,
                                "globalSales": 1192530176.84,
                                "netSales": 13675264.77
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.6368993166105112,
                                "grossSales": 38764867.16,
                                "competitorSales": 1027111963.22,
                                "globalSales": 1065876830.38,
                                "netSales": 6716059.46
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 9,
                        "optionValue": "RRB Team Midwest",
                        "marketShare": 8.271501836506186,
                        "marketShareChange": 1.0336775644232326,
                        "grossSales": 222793802.11,
                        "competitorSales": 2470717080.3599997,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 6.208845064333916,
                                "grossSales": 43196679.03,
                                "competitorSales": 652531408.6,
                                "globalSales": 695728087.63,
                                "netSales": -18431867.13
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 4.889490421292505,
                                "grossSales": 46733704.99,
                                "competitorSales": 909065385.78,
                                "globalSales": 955799090.77,
                                "netSales": -9778064.02
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 14.268896211970791,
                                "grossSales": 120079990.96,
                                "competitorSales": 721470674.04,
                                "globalSales": 841550665,
                                "netSales": 65079835.54
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 6.036672072672456,
                                "grossSales": 43562840.27,
                                "competitorSales": 678073845.4,
                                "globalSales": 721636685.67,
                                "netSales": -23181418.72
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 7.805285087555106,
                                "grossSales": 55720439.07,
                                "competitorSales": 658160456.31,
                                "globalSales": 713880895.38,
                                "netSales": -20591509.15
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 9.361904171013618,
                                "grossSales": 93622089.64,
                                "competitorSales": 906410467.09,
                                "globalSales": 1000032556.73,
                                "netSales": -16277825.11
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 6.30461485847964,
                                "grossSales": 69671303.75,
                                "competitorSales": 1035412913.35,
                                "globalSales": 1105084217.1,
                                "netSales": -12453869.4
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 8.688240262446033,
                                "grossSales": 90326180.68,
                                "competitorSales": 949311052.54,
                                "globalSales": 1039637233.22,
                                "netSales": 2288050.87
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 6.782229033146151,
                                "grossSales": 70953854.17,
                                "competitorSales": 975219222.9,
                                "globalSales": 1046173077.07,
                                "netSales": -12896730.14
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 8.038194150130145,
                                "grossSales": 79866607.5,
                                "competitorSales": 913722325.64,
                                "globalSales": 993588933.14,
                                "netSales": -2383402.04
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 8.428131850397987,
                                "grossSales": 68885906.44,
                                "competitorSales": 748447135.6,
                                "globalSales": 817333042.04,
                                "netSales": 12685692.73
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 8.389102509496146,
                                "grossSales": 74041288.17,
                                "competitorSales": 808547619.12,
                                "globalSales": 882588907.29,
                                "netSales": 19614273.26
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 10,
                        "optionValue": "RRB Team New York Metro",
                        "marketShare": 6.645277742148823,
                        "marketShareChange": 0.5516428225547685,
                        "grossSales": 215495531.32999998,
                        "competitorSales": 3027341558.2799997,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 4.440268343072458,
                                "grossSales": 49646345.59,
                                "competitorSales": 1068447016.21,
                                "globalSales": 1118093361.8,
                                "netSales": -7919736.47
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 5.741251776299889,
                                "grossSales": 46707951.8,
                                "competitorSales": 766842012.91,
                                "globalSales": 813549964.71,
                                "netSales": 6203344.36
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 4.58017592655687,
                                "grossSales": 40274569.27,
                                "competitorSales": 839049061.87,
                                "globalSales": 879323631.14,
                                "netSales": -1563147.91
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 4.569405661375858,
                                "grossSales": 40448552.1,
                                "competitorSales": 844755238.01,
                                "globalSales": 885203790.11,
                                "netSales": -1579871.13
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 5.599207078948356,
                                "grossSales": 47052248.21,
                                "competitorSales": 793285455.8,
                                "globalSales": 840337704.01,
                                "netSales": 10861407.98
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 5.213617313967342,
                                "grossSales": 77304033.77,
                                "competitorSales": 1405429145.8,
                                "globalSales": 1482733179.57,
                                "netSales": 29215033.57
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 6.7472798827989084,
                                "grossSales": 84186175.44,
                                "competitorSales": 1163519224.4,
                                "globalSales": 1247705399.84,
                                "netSales": 20638812.85
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 5.307744969355779,
                                "grossSales": 63613999.7,
                                "competitorSales": 1134898740.97,
                                "globalSales": 1198512740.67,
                                "netSales": 13440085.4
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 6.192563795399728,
                                "grossSales": 79085670.82,
                                "competitorSales": 1198021411.69,
                                "globalSales": 1277107082.51,
                                "netSales": 18867819.67
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 5.282866211756872,
                                "grossSales": 66030075.77,
                                "competitorSales": 1183861046.27,
                                "globalSales": 1249891122.04,
                                "netSales": -9404264.85
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 6.433336851969266,
                                "grossSales": 58990496.55,
                                "competitorSales": 857959725.51,
                                "globalSales": 916950222.06,
                                "netSales": -3858893.04
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 8.408486686638033,
                                "grossSales": 90474959.01,
                                "competitorSales": 985520786.5,
                                "globalSales": 1075995745.51,
                                "netSales": 42457609.98
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 11,
                        "optionValue": "BD Field Upper Plains",
                        "marketShare": 5.39795539505341,
                        "marketShareChange": -0.15457823246857405,
                        "grossSales": 212455762.47,
                        "competitorSales": 3723400444.5800004,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 4.780990972358563,
                                "grossSales": 41058728.77,
                                "competitorSales": 817732450.87,
                                "globalSales": 858791179.64,
                                "netSales": 8222229.28
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 4.254405402138995,
                                "grossSales": 37783174.33,
                                "competitorSales": 850312123.57,
                                "globalSales": 888095297.9,
                                "netSales": 3368092.13
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 4.071588131351546,
                                "grossSales": 42204179.39,
                                "competitorSales": 994349077.68,
                                "globalSales": 1036553257.07,
                                "netSales": -1037043.05
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 4.653564419159985,
                                "grossSales": 43549580.58,
                                "competitorSales": 892283184.53,
                                "globalSales": 935832765.11,
                                "netSales": 2459906.31
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 4.5041479290185364,
                                "grossSales": 45806499.5,
                                "competitorSales": 971178293.67,
                                "globalSales": 1016984793.17,
                                "netSales": 12376896.77
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 4.433402531499355,
                                "grossSales": 51881212.43,
                                "competitorSales": 1118353433.79,
                                "globalSales": 1170234646.22,
                                "netSales": 15573804.71
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 8.443300508571557,
                                "grossSales": 111876677.84,
                                "competitorSales": 1213158214.93,
                                "globalSales": 1325034892.77,
                                "netSales": 52175884.62
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 4.25457369134924,
                                "grossSales": 59391202.48,
                                "competitorSales": 1336546599.72,
                                "globalSales": 1395937802.2,
                                "netSales": 9408990.8
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 4.153383929536794,
                                "grossSales": 59919159.33,
                                "competitorSales": 1382739654.46,
                                "globalSales": 1442658813.79,
                                "netSales": 18662303.07
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 4.539970869182051,
                                "grossSales": 69870324.32,
                                "competitorSales": 1469133478.42,
                                "globalSales": 1539003802.74,
                                "netSales": 19745097.72
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 6.572925900315335,
                                "grossSales": 82290575.61,
                                "competitorSales": 1169672048.92,
                                "globalSales": 1251962624.53,
                                "netSales": 42413302.54
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 5.266433817898712,
                                "grossSales": 60294862.54,
                                "competitorSales": 1084594917.24,
                                "globalSales": 1144889779.78,
                                "netSales": 30109549.42
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 12,
                        "optionValue": "BD Field Wisconsin East",
                        "marketShare": 5.419111603236792,
                        "marketShareChange": -0.5951740712045535,
                        "grossSales": 211815779.76,
                        "competitorSales": 3696865112.3899994,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 5.353029398226259,
                                "grossSales": 57615373.34,
                                "competitorSales": 1018698038.26,
                                "globalSales": 1076313411.6,
                                "netSales": -17503582.72
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 5.821667706710257,
                                "grossSales": 57496444.34,
                                "competitorSales": 930131967.94,
                                "globalSales": 987628412.28,
                                "netSales": 7635802.93
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 5.097244263546534,
                                "grossSales": 52268430.2,
                                "competitorSales": 973156828.97,
                                "globalSales": 1025425259.17,
                                "netSales": -1023446.75
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 4.158815507144448,
                                "grossSales": 47838863.13,
                                "competitorSales": 1102461337.68,
                                "globalSales": 1150300200.81,
                                "netSales": -17041807.04
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 5.119216769613433,
                                "grossSales": 50978719.53,
                                "competitorSales": 944851733.14,
                                "globalSales": 995830452.67,
                                "netSales": 6877041.85
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 5.47425348239589,
                                "grossSales": 58435896.99,
                                "competitorSales": 1009031971.97,
                                "globalSales": 1067467868.96,
                                "netSales": 10092730.73
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 7.474753686060634,
                                "grossSales": 105706305.22,
                                "competitorSales": 1308471467.85,
                                "globalSales": 1414177773.07,
                                "netSales": 46618262.33
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 5.059259251682569,
                                "grossSales": 69498864.04,
                                "competitorSales": 1304197572.19,
                                "globalSales": 1373696436.23,
                                "netSales": 5980801.92
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 5.450756160731421,
                                "grossSales": 72877194.77,
                                "competitorSales": 1264133535.87,
                                "globalSales": 1337010730.64,
                                "netSales": 8324795.76
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 5.540456711434419,
                                "grossSales": 80608744.89,
                                "competitorSales": 1374302810.03,
                                "globalSales": 1454911554.92,
                                "netSales": 16630341.57
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 5.5174081196643225,
                                "grossSales": 68150230.12,
                                "competitorSales": 1167035361.41,
                                "globalSales": 1235185591.53,
                                "netSales": 4072308.08
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 5.1745975582316515,
                                "grossSales": 63056804.75,
                                "competitorSales": 1155526940.95,
                                "globalSales": 1218583745.7,
                                "netSales": 12489778.44
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 13,
                        "optionValue": "BD Field Greater Baltimore",
                        "marketShare": 7.635973964403608,
                        "marketShareChange": 1.150273478348602,
                        "grossSales": 198245643.31,
                        "competitorSales": 2397960737.6200004,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 5.113645516640545,
                                "grossSales": 37786179.21,
                                "competitorSales": 701142224.94,
                                "globalSales": 738928404.15,
                                "netSales": 4382109.98
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 6.479947596054397,
                                "grossSales": 49214539.35,
                                "competitorSales": 710275234.61,
                                "globalSales": 759489773.96,
                                "netSales": 9910756.52
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 5.890964443834055,
                                "grossSales": 39597374.33,
                                "competitorSales": 632573960.39,
                                "globalSales": 672171334.72,
                                "netSales": 3417787.45
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 5.9821456617024245,
                                "grossSales": 42683206.51,
                                "competitorSales": 670826776.76,
                                "globalSales": 713509983.27,
                                "netSales": 3408496.6
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 8.528938137909094,
                                "grossSales": 65263762.76,
                                "competitorSales": 699940084.48,
                                "globalSales": 765203847.24,
                                "netSales": 28308830.87
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 6.8934711158353865,
                                "grossSales": 53078566.77,
                                "competitorSales": 716904593.79,
                                "globalSales": 769983160.56,
                                "netSales": 14021226.68
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 4.922615683115319,
                                "grossSales": 50146768.59,
                                "competitorSales": 968554909.91,
                                "globalSales": 1018701678.5,
                                "netSales": 1612792.86
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 7.520534056447105,
                                "grossSales": 80599451.14,
                                "competitorSales": 991125648.9,
                                "globalSales": 1071725100.04,
                                "netSales": 22282447.65
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 6.946763141509918,
                                "grossSales": 72812072.73,
                                "competitorSales": 975331807.33,
                                "globalSales": 1048143880.06,
                                "netSales": 18218883.67
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 7.494219156340577,
                                "grossSales": 65796149.61,
                                "competitorSales": 812162557.46,
                                "globalSales": 877958707.07,
                                "netSales": 25358288.17
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 9.306552572971025,
                                "grossSales": 78145846.24,
                                "competitorSales": 761540446.05,
                                "globalSales": 839686292.29,
                                "netSales": 34279209.47
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 6.180973646139409,
                                "grossSales": 54303647.46,
                                "competitorSales": 824257734.11,
                                "globalSales": 878561381.57,
                                "netSales": -7037721.07
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 14,
                        "optionValue": "BD Field Pacific Northwest",
                        "marketShare": 5.359121505392521,
                        "marketShareChange": 0.4404851850572804,
                        "grossSales": 195356464.92000002,
                        "competitorSales": 3449951161.0299997,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 4.312926130392001,
                                "grossSales": 44416939.31,
                                "competitorSales": 985439310.65,
                                "globalSales": 1029856249.96,
                                "netSales": 916350.66
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 4.089020103653199,
                                "grossSales": 38375988.47,
                                "competitorSales": 900137090.39,
                                "globalSales": 938513078.86,
                                "netSales": 2905643.71
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 4.57219437738186,
                                "grossSales": 44020400.33,
                                "competitorSales": 918764571.1,
                                "globalSales": 962784971.43,
                                "netSales": 4459617.8
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 5.019718304257312,
                                "grossSales": 55180053.82,
                                "competitorSales": 1044085890.51,
                                "globalSales": 1099265944.33,
                                "netSales": 12752240.31
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 5.855335044903121,
                                "grossSales": 61222646.91,
                                "competitorSales": 984364777.9,
                                "globalSales": 1045587424.81,
                                "netSales": 22399400.09
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 4.689071217704468,
                                "grossSales": 53846292.09,
                                "competitorSales": 1094489691.52,
                                "globalSales": 1148335983.61,
                                "netSales": 11138124.74
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 5.077342521870082,
                                "grossSales": 68207002.17,
                                "competitorSales": 1275153267.03,
                                "globalSales": 1343360269.2,
                                "netSales": 11955963.62
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 4.722687029711571,
                                "grossSales": 60918225.06,
                                "competitorSales": 1228987810.99,
                                "globalSales": 1289906036.05,
                                "netSales": 10958680.54
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 4.947660539382299,
                                "grossSales": 67430743.23,
                                "competitorSales": 1295450616.42,
                                "globalSales": 1362881359.65,
                                "netSales": 14505756.33
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 5.161945576596147,
                                "grossSales": 68397931.59,
                                "competitorSales": 1256643771.68,
                                "globalSales": 1325041703.27,
                                "netSales": 12464991.77
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 6.038904559744346,
                                "grossSales": 69785302.31,
                                "competitorSales": 1085810081.25,
                                "globalSales": 1155595383.56,
                                "netSales": 14772053.06
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 4.908961727768856,
                                "grossSales": 57173231.02,
                                "competitorSales": 1107497308.1,
                                "globalSales": 1164670539.12,
                                "netSales": 19694154.96
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 15,
                        "optionValue": "BD Field Ohio North",
                        "marketShare": 5.892794015528295,
                        "marketShareChange": 0.5130984944284682,
                        "grossSales": 188629607.3,
                        "competitorSales": 3012391959.0899997,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 4.784000547454154,
                                "grossSales": 40672894.42,
                                "competitorSales": 809512928.44,
                                "globalSales": 850185822.86,
                                "netSales": 9368743.24
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 5.245086904263623,
                                "grossSales": 51582733.37,
                                "competitorSales": 931865859.79,
                                "globalSales": 983448593.16,
                                "netSales": 8347490.75
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 5.743750893305217,
                                "grossSales": 51413246.59,
                                "competitorSales": 843702985.73,
                                "globalSales": 895116232.32,
                                "netSales": 10798416.61
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 4.769280826490856,
                                "grossSales": 43198628.6,
                                "competitorSales": 862569561.02,
                                "globalSales": 905768189.62,
                                "netSales": -1524964.79
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 5.244959024200941,
                                "grossSales": 46287763.95,
                                "competitorSales": 836231312.68,
                                "globalSales": 882519076.63,
                                "netSales": 3820516.53
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 3.7125823067029264,
                                "grossSales": 37583568.25,
                                "competitorSales": 974745994.98,
                                "globalSales": 1012329563.23,
                                "netSales": 7733422.04
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 5.478144196304879,
                                "grossSales": 62724692.03,
                                "competitorSales": 1082274230.64,
                                "globalSales": 1144998922.67,
                                "netSales": -14965937.35
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 5.855286494096632,
                                "grossSales": 69370257.32,
                                "competitorSales": 1115375482.96,
                                "globalSales": 1184745740.28,
                                "netSales": 8606644.38
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 4.866884817294685,
                                "grossSales": 64173396.71,
                                "competitorSales": 1254398936.91,
                                "globalSales": 1318572333.62,
                                "netSales": 16340877.61
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 4.359890430706179,
                                "grossSales": 51307432.77,
                                "competitorSales": 1125498121.99,
                                "globalSales": 1176805554.76,
                                "netSales": 10011459.33
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 9.40341743492812,
                                "grossSales": 96017895.37,
                                "competitorSales": 925077850.24,
                                "globalSales": 1021095745.61,
                                "netSales": 8707088.62
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 4.117579971131446,
                                "grossSales": 41304279.16,
                                "competitorSales": 961815986.86,
                                "globalSales": 1003120266.02,
                                "netSales": 2573093
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 16,
                        "optionValue": "RRB Team Great Plains",
                        "marketShare": 8.615727483013176,
                        "marketShareChange": 0.10463421308802978,
                        "grossSales": 183936078.5,
                        "competitorSales": 1950951298.83,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 5.0380534738153235,
                                "grossSales": 35901391.29,
                                "competitorSales": 676703019.85,
                                "globalSales": 712604411.14,
                                "netSales": -15778416.54
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 9.558652287123452,
                                "grossSales": 69601241.16,
                                "competitorSales": 658547864.69,
                                "globalSales": 728149105.85,
                                "netSales": 20610032.41
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 10.315237048113572,
                                "grossSales": 71294630.71,
                                "competitorSales": 619863801.98,
                                "globalSales": 691158432.69,
                                "netSales": 18444523.12
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 6.783517836592812,
                                "grossSales": 42286532.29,
                                "competitorSales": 581085194.72,
                                "globalSales": 623371727.01,
                                "netSales": -11185619.36
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 7.795260132339579,
                                "grossSales": 55632410.83,
                                "competitorSales": 658037304.94,
                                "globalSales": 713669715.77,
                                "netSales": 13023040.74
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 6.862631063086173,
                                "grossSales": 58633775.14,
                                "competitorSales": 795758288.21,
                                "globalSales": 854392063.35,
                                "netSales": -24505164.03
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 8.706440806911713,
                                "grossSales": 89041293.54,
                                "competitorSales": 933664718.19,
                                "globalSales": 1022706011.73,
                                "netSales": 7926155.25
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 10.570105175866333,
                                "grossSales": 79370043.08,
                                "competitorSales": 671521662.91,
                                "globalSales": 750891705.99,
                                "netSales": 13697367.41
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 6.666156597068529,
                                "grossSales": 63082363.42,
                                "competitorSales": 883225490.31,
                                "globalSales": 946307853.73,
                                "netSales": -84321.07
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 8.507897673519738,
                                "grossSales": 69220503.99,
                                "competitorSales": 744382417.04,
                                "globalSales": 813602921.03,
                                "netSales": 23139689.41
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 8.642989156020874,
                                "grossSales": 54456658.38,
                                "competitorSales": 575610756.92,
                                "globalSales": 630067415.3,
                                "netSales": -770688.54
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 8.717799555812746,
                                "grossSales": 60258916.13,
                                "competitorSales": 630958124.87,
                                "globalSales": 691217041,
                                "netSales": 3280849.69
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 17,
                        "optionValue": "BD Field Gulf Coast",
                        "marketShare": 5.709374872283538,
                        "marketShareChange": -0.23691420703568244,
                        "grossSales": 183882855.85999998,
                        "competitorSales": 3036834998.08,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 3.84283351678818,
                                "grossSales": 34791594.04,
                                "competitorSales": 870571437.9,
                                "globalSales": 905363031.94,
                                "netSales": 2658312.99
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 5.676627244761895,
                                "grossSales": 53569768.57,
                                "competitorSales": 890120318.17,
                                "globalSales": 943690086.74,
                                "netSales": 8970197.06
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 3.5994733950545603,
                                "grossSales": 28812767.25,
                                "competitorSales": 771658970.91,
                                "globalSales": 800471738.16,
                                "netSales": -14070546.61
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 3.5259827352132747,
                                "grossSales": 30673243.82,
                                "competitorSales": 839247176.2,
                                "globalSales": 869920420.02,
                                "netSales": -8366670.91
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 5.955196559031613,
                                "grossSales": 49810476.2,
                                "competitorSales": 786609878.8,
                                "globalSales": 836420355,
                                "netSales": 12090510.61
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 4.821099853356182,
                                "grossSales": 43732025.87,
                                "competitorSales": 863364429.3,
                                "globalSales": 907096455.17,
                                "netSales": 19115824.15
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 5.28766723084796,
                                "grossSales": 61407419.39,
                                "competitorSales": 1099925484.31,
                                "globalSales": 1161332903.7,
                                "netSales": 11404239.25
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 8.128867271852362,
                                "grossSales": 89929460.25,
                                "competitorSales": 1016368099.33,
                                "globalSales": 1106297559.58,
                                "netSales": 31149794.44
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 4.628477882927071,
                                "grossSales": 57941591.88,
                                "competitorSales": 1193908224.53,
                                "globalSales": 1251849816.41,
                                "netSales": 11276613.2
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 3.7338574073087596,
                                "grossSales": 43782280.46,
                                "competitorSales": 1128792772.2,
                                "globalSales": 1172575052.66,
                                "netSales": -820605.24
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 8.71994779731224,
                                "grossSales": 89762580.74,
                                "competitorSales": 939630975.58,
                                "globalSales": 1029393556.32,
                                "netSales": 21222376.82
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 4.941156512167669,
                                "grossSales": 50337994.66,
                                "competitorSales": 968411250.3,
                                "globalSales": 1018749244.96,
                                "netSales": 21693949.19
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 18,
                        "optionValue": "BD Field Ohio South",
                        "marketShare": 4.950175653760699,
                        "marketShareChange": -0.23873735805967033,
                        "grossSales": 171988480.99,
                        "competitorSales": 3302402995.59,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 5.319018147348714,
                                "grossSales": 57219796.22,
                                "competitorSales": 1018538823.79,
                                "globalSales": 1075758620.01,
                                "netSales": 15257155.35
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 3.5146949398002154,
                                "grossSales": 42137685.69,
                                "competitorSales": 1156762543.54,
                                "globalSales": 1198900229.23,
                                "netSales": 4070654.15
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 3.879079017085468,
                                "grossSales": 39471309.63,
                                "competitorSales": 978072015.89,
                                "globalSales": 1017543325.52,
                                "netSales": 10017911.28
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 3.791456530304898,
                                "grossSales": 39246536.07,
                                "competitorSales": 995884310.25,
                                "globalSales": 1035130846.32,
                                "netSales": -11780506.79
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 4.620483131709886,
                                "grossSales": 46437427.46,
                                "competitorSales": 958596594.66,
                                "globalSales": 1005034022.12,
                                "netSales": 12684487.42
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 3.7522872863425696,
                                "grossSales": 44180378.27,
                                "competitorSales": 1133244879.94,
                                "globalSales": 1177425258.21,
                                "netSales": 4724107.5
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 4.800243052142643,
                                "grossSales": 69142204.36,
                                "competitorSales": 1371247451.1,
                                "globalSales": 1440389655.46,
                                "netSales": 19774234.34
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 5.729071677748332,
                                "grossSales": 77684767.37,
                                "competitorSales": 1278290017.72,
                                "globalSales": 1355974785.09,
                                "netSales": 34117222.21
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 5.066683560051881,
                                "grossSales": 71548766.21,
                                "competitorSales": 1340593226.91,
                                "globalSales": 1412141993.12,
                                "netSales": 33390545.93
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 5.1316804782680565,
                                "grossSales": 66567131.62,
                                "competitorSales": 1230612844.84,
                                "globalSales": 1297179976.46,
                                "netSales": 20099802.69
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 5.127043971614793,
                                "grossSales": 57378099.46,
                                "competitorSales": 1061748238.79,
                                "globalSales": 1119126338.25,
                                "netSales": 11752617.36
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 4.540584410529968,
                                "grossSales": 48043249.91,
                                "competitorSales": 1010041911.96,
                                "globalSales": 1058085161.87,
                                "netSales": 9837935.69
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 19,
                        "optionValue": "BD Field Metro Seattle",
                        "marketShare": 4.9812680197559756,
                        "marketShareChange": -0.20780409865376193,
                        "grossSales": 171655794.94,
                        "competitorSales": 3274370282.34,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 4.367007409440869,
                                "grossSales": 38999562.34,
                                "competitorSales": 854050498.8,
                                "globalSales": 893050061.14,
                                "netSales": 10036998.47
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 4.813261054457445,
                                "grossSales": 40826226.15,
                                "competitorSales": 807376804.77,
                                "globalSales": 848203030.92,
                                "netSales": 13496928.8
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 4.885215134076728,
                                "grossSales": 42665617.25,
                                "competitorSales": 830696477.95,
                                "globalSales": 873362095.2,
                                "netSales": 16804120.66
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 3.7028437979170428,
                                "grossSales": 37373973.74,
                                "competitorSales": 971957658.37,
                                "globalSales": 1009331632.11,
                                "netSales": -10358881.9
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 4.426366547109053,
                                "grossSales": 44174376.15,
                                "competitorSales": 953808409.05,
                                "globalSales": 997982785.2,
                                "netSales": -4801155.61
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 4.588521710161837,
                                "grossSales": 52002085.87,
                                "competitorSales": 1081305963.1,
                                "globalSales": 1133308048.97,
                                "netSales": 20326531.98
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 4.454132976027697,
                                "grossSales": 53110618.84,
                                "competitorSales": 1139278991.57,
                                "globalSales": 1192389610.41,
                                "netSales": 14137343.65
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 5.8654255411109215,
                                "grossSales": 75306923.93,
                                "competitorSales": 1208605443.59,
                                "globalSales": 1283912367.52,
                                "netSales": 21437696.95
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 5.195137640334947,
                                "grossSales": 68137154.55,
                                "competitorSales": 1243419136.49,
                                "globalSales": 1311556291.04,
                                "netSales": 16609113.6
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 5.246619039784156,
                                "grossSales": 61487524.07,
                                "competitorSales": 1110458134.72,
                                "globalSales": 1171945658.79,
                                "netSales": 30825261.56
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 4.34462342233395,
                                "grossSales": 48614074.53,
                                "competitorSales": 1070333871.11,
                                "globalSales": 1118947945.64,
                                "netSales": 15567933.11
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 5.328756466185255,
                                "grossSales": 61554196.34,
                                "competitorSales": 1093578276.51,
                                "globalSales": 1155132472.85,
                                "netSales": 21889608.42
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 20,
                        "optionValue": "BD Field South Central",
                        "marketShare": 4.932421424976264,
                        "marketShareChange": 0.4518250833366926,
                        "grossSales": 169661724.34,
                        "competitorSales": 3270063102.9199996,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 3.913159431159954,
                                "grossSales": 39807833.76,
                                "competitorSales": 977473328.95,
                                "globalSales": 1017281162.71,
                                "netSales": 6783929.55
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 3.8092039025580933,
                                "grossSales": 38792320.56,
                                "competitorSales": 979591613.52,
                                "globalSales": 1018383934.08,
                                "netSales": 1867216.94
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 4.315632097119856,
                                "grossSales": 39002351.73,
                                "competitorSales": 864743631.53,
                                "globalSales": 903745983.26,
                                "netSales": 9072091.54
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 3.6603798576857733,
                                "grossSales": 33972515.26,
                                "competitorSales": 894141958.67,
                                "globalSales": 928114473.93,
                                "netSales": 1596416.18
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 4.274938647852119,
                                "grossSales": 40443696.03,
                                "competitorSales": 905621250.43,
                                "globalSales": 946064946.46,
                                "netSales": 10940853.53
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 4.013488036627991,
                                "grossSales": 39394025.73,
                                "competitorSales": 942146852.69,
                                "globalSales": 981540878.42,
                                "netSales": 12408248.49
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 4.171076372487399,
                                "grossSales": 50284344.03,
                                "competitorSales": 1155264045.39,
                                "globalSales": 1205548389.42,
                                "netSales": 12966327.8
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 5.544184403949616,
                                "grossSales": 69573791.12,
                                "competitorSales": 1185322980.9,
                                "globalSales": 1254896772.02,
                                "netSales": 28676679.49
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 3.8258640847419008,
                                "grossSales": 56187348.95,
                                "competitorSales": 1412431182.85,
                                "globalSales": 1468618531.8,
                                "netSales": 22585811.21
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 3.9650200303448604,
                                "grossSales": 50195527.83,
                                "competitorSales": 1215763469.75,
                                "globalSales": 1265958997.58,
                                "netSales": 22254051.43
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 7.397308887090951,
                                "grossSales": 80357353.66,
                                "competitorSales": 1005947880.94,
                                "globalSales": 1086305234.6,
                                "netSales": 14788452.34
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.5963457459461257,
                                "grossSales": 39108842.85,
                                "competitorSales": 1048351752.23,
                                "globalSales": 1087460595.08,
                                "netSales": 11843506.47
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 21,
                        "optionValue": "BD Field Indiana",
                        "marketShare": 4.5032948787408476,
                        "marketShareChange": -0.07222503073981557,
                        "grossSales": 163601135.91,
                        "competitorSales": 3469319654.65,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 4.062983012280228,
                                "grossSales": 42424802.37,
                                "competitorSales": 1001753877.23,
                                "globalSales": 1044178679.6,
                                "netSales": 9058403.3
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 4.03873320003891,
                                "grossSales": 46126156.45,
                                "competitorSales": 1095968509.51,
                                "globalSales": 1142094665.96,
                                "netSales": 14683601.64
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 6.518390270155098,
                                "grossSales": 63933199.66,
                                "competitorSales": 916879501.18,
                                "globalSales": 980812700.84,
                                "netSales": 27876799.04
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 4.254276724633868,
                                "grossSales": 44746445.76,
                                "competitorSales": 1007052688.53,
                                "globalSales": 1051799134.29,
                                "netSales": 5270788.09
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 3.950956611633854,
                                "grossSales": 43120980.93,
                                "competitorSales": 1048285105.46,
                                "globalSales": 1091406086.39,
                                "netSales": 494552.22
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 3.563448338458198,
                                "grossSales": 41247967.61,
                                "competitorSales": 1116281585.01,
                                "globalSales": 1157529552.62,
                                "netSales": 4922046.29
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 4.859406162558332,
                                "grossSales": 65537898.8,
                                "competitorSales": 1283143331.12,
                                "globalSales": 1348681229.92,
                                "netSales": 17438629.01
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 5.270701759030088,
                                "grossSales": 68379555,
                                "competitorSales": 1228972450.98,
                                "globalSales": 1297352005.98,
                                "netSales": 21848118.97
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 3.7220201468479868,
                                "grossSales": 56027326.6,
                                "competitorSales": 1449266153.54,
                                "globalSales": 1505293480.14,
                                "netSales": 5685806.22
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 4.8306595801544265,
                                "grossSales": 61362557.44,
                                "competitorSales": 1208910299.13,
                                "globalSales": 1270272856.57,
                                "netSales": 20352689.5
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 4.739576334424886,
                                "grossSales": 58298982.05,
                                "competitorSales": 1171747290.79,
                                "globalSales": 1230046272.84,
                                "netSales": 10474900.2
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.8795278099261683,
                                "grossSales": 43939596.42,
                                "competitorSales": 1088662064.73,
                                "globalSales": 1132601661.15,
                                "netSales": 6312336.9
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 22,
                        "optionValue": "BD Field Chicago West",
                        "marketShare": 4.321753881440423,
                        "marketShareChange": 0.014522624312085064,
                        "grossSales": 162472207.01,
                        "competitorSales": 3596932226.17,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 4.582296400906138,
                                "grossSales": 45539172.98,
                                "competitorSales": 948267621.6,
                                "globalSales": 993806794.58,
                                "netSales": 14372683.41
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 4.224548004121623,
                                "grossSales": 47829350.52,
                                "competitorSales": 1084347404.8,
                                "globalSales": 1132176755.32,
                                "netSales": 15271869.02
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 5.250873527490366,
                                "grossSales": 60209080.03,
                                "competitorSales": 1086439753.06,
                                "globalSales": 1146648833.09,
                                "netSales": 21121578.94
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 5.832829332517268,
                                "grossSales": 68134383.32,
                                "competitorSales": 1099984542.09,
                                "globalSales": 1168118925.41,
                                "netSales": 18729877.79
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 4.321657081466584,
                                "grossSales": 49021045.15,
                                "competitorSales": 1085290267.06,
                                "globalSales": 1134311312.21,
                                "netSales": 3015227.13
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 5.361448935507421,
                                "grossSales": 72019263.49,
                                "competitorSales": 1271260591.57,
                                "globalSales": 1343279855.06,
                                "netSales": 24355949.56
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 3.7420586621771785,
                                "grossSales": 54688144.98,
                                "competitorSales": 1406757276.3,
                                "globalSales": 1461445421.28,
                                "netSales": 11541340.48
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 4.764670428448619,
                                "grossSales": 69550491.86,
                                "competitorSales": 1390162050.79,
                                "globalSales": 1459712542.65,
                                "netSales": 21812234.43
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 4.405209639622284,
                                "grossSales": 71145986.96,
                                "competitorSales": 1543896037.83,
                                "globalSales": 1615042024.79,
                                "netSales": 9731718.22
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 4.627279009438491,
                                "grossSales": 58578755.89,
                                "competitorSales": 1207365134.04,
                                "globalSales": 1265943889.93,
                                "netSales": 12397102.95
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 4.402699277176185,
                                "grossSales": 60210959.12,
                                "competitorSales": 1307380950.51,
                                "globalSales": 1367591909.63,
                                "netSales": 4518111.78
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.879892439986351,
                                "grossSales": 43682492,
                                "competitorSales": 1082186141.62,
                                "globalSales": 1125868633.62,
                                "netSales": 10941394.85
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 23,
                        "optionValue": "BD Field Virginia",
                        "marketShare": 5.889206900354412,
                        "marketShareChange": -0.43015672674301086,
                        "grossSales": 160234540.98,
                        "competitorSales": 2560582433.0400004,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 6.185793847721074,
                                "grossSales": 46116754.12,
                                "competitorSales": 699410097.49,
                                "globalSales": 745526851.61,
                                "netSales": 8229736.27
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 5.08135511411397,
                                "grossSales": 39609879.58,
                                "competitorSales": 739904220.31,
                                "globalSales": 779514099.89,
                                "netSales": 10234842.91
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 4.801533847134162,
                                "grossSales": 37905924.45,
                                "competitorSales": 751548563.57,
                                "globalSales": 789454488.02,
                                "netSales": 7080787.9
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 5.216704579317076,
                                "grossSales": 38694967.3,
                                "competitorSales": 703056203.61,
                                "globalSales": 741751170.91,
                                "netSales": -962441.04
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 6.563720335700442,
                                "grossSales": 50591881.19,
                                "competitorSales": 720188691.45,
                                "globalSales": 770780572.64,
                                "netSales": 21745012.26
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 5.191165669333111,
                                "grossSales": 46217746.21,
                                "competitorSales": 844097630.99,
                                "globalSales": 890315377.2,
                                "netSales": 11920678.63
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 4.994769297642451,
                                "grossSales": 49868185.04,
                                "competitorSales": 948539990.96,
                                "globalSales": 998408176,
                                "netSales": 9302501.64
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 8.449282468762517,
                                "grossSales": 91764657.79,
                                "competitorSales": 994299846.85,
                                "globalSales": 1086064504.64,
                                "netSales": 25447613.34
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 5.463589021789208,
                                "grossSales": 63252811.74,
                                "competitorSales": 1094462592.69,
                                "globalSales": 1157715404.43,
                                "netSales": 22609438.53
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 5.725787356405363,
                                "grossSales": 55873813.64,
                                "competitorSales": 919953791.58,
                                "globalSales": 975827605.22,
                                "netSales": 17787749.12
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 7.13295895938417,
                                "grossSales": 64291443.43,
                                "competitorSales": 837037777.67,
                                "globalSales": 901329221.1,
                                "netSales": 2630827.59
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 4.749457944557121,
                                "grossSales": 40069283.91,
                                "competitorSales": 803590863.79,
                                "globalSales": 843660147.7,
                                "netSales": 9038251.49
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 24,
                        "optionValue": "BD Field South Atlantic",
                        "marketShare": 5.238420462951175,
                        "marketShareChange": 1.6817048296631243,
                        "grossSales": 160142220.66,
                        "competitorSales": 2896928547,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 2.338939771812401,
                                "grossSales": 20457048.01,
                                "competitorSales": 854172057.73,
                                "globalSales": 874629105.74,
                                "netSales": -6748108.4
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 2.9166156337107023,
                                "grossSales": 27268209.85,
                                "competitorSales": 907658200.57,
                                "globalSales": 934926410.42,
                                "netSales": 2003996.48
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 3.5310310233242057,
                                "grossSales": 33892948.46,
                                "competitorSales": 925966883.87,
                                "globalSales": 959859832.33,
                                "netSales": 10761098.85
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 4.7444341424677425,
                                "grossSales": 38611454.25,
                                "competitorSales": 775214875.52,
                                "globalSales": 813826329.77,
                                "netSales": 10449200.73
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 3.0876293273151756,
                                "grossSales": 25364030.8,
                                "competitorSales": 796108630.3,
                                "globalSales": 821472661.1,
                                "netSales": 1643877.39
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 2.7127471128767526,
                                "grossSales": 24304287.32,
                                "competitorSales": 871624684.63,
                                "globalSales": 895928971.95,
                                "netSales": 2270169.3
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 3.122936881641248,
                                "grossSales": 33954269.4,
                                "competitorSales": 1053300154.46,
                                "globalSales": 1087254423.86,
                                "netSales": -1206983.5
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 4.272285091972395,
                                "grossSales": 51389746.35,
                                "competitorSales": 1151473481.26,
                                "globalSales": 1202863227.61,
                                "netSales": 18029248.77
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 3.24395117297699,
                                "grossSales": 40357380.13,
                                "competitorSales": 1203723617.95,
                                "globalSales": 1244080998.08,
                                "netSales": 8844922.41
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 3.2456740051589614,
                                "grossSales": 34128733.07,
                                "competitorSales": 1017385775.65,
                                "globalSales": 1051514508.72,
                                "netSales": 3899877.68
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 7.921626002178714,
                                "grossSales": 77628663.09,
                                "competitorSales": 902330035.65,
                                "globalSales": 979958698.74,
                                "netSales": 13902455.13
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 4.71772032009949,
                                "grossSales": 48384824.5,
                                "competitorSales": 977212735.7,
                                "globalSales": 1025597560.2,
                                "netSales": 24995141.87
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 25,
                        "optionValue": "BD Field Texas North",
                        "marketShare": 3.8257718120451005,
                        "marketShareChange": -0.03638543352106138,
                        "grossSales": 157632780.97000003,
                        "competitorSales": 3962654280.42,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 3.7305190273242257,
                                "grossSales": 45405468.7,
                                "competitorSales": 1171729958.5,
                                "globalSales": 1217135427.2,
                                "netSales": 5002410.96
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 4.949546023779134,
                                "grossSales": 54428073.19,
                                "competitorSales": 1045229813.18,
                                "globalSales": 1099657886.37,
                                "netSales": 15295324.69
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 4.0172547118536075,
                                "grossSales": 43521356.83,
                                "competitorSales": 1039839294.95,
                                "globalSales": 1083360651.78,
                                "netSales": 7168870.3
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 3.057491665192248,
                                "grossSales": 35682741.28,
                                "competitorSales": 1131376573.59,
                                "globalSales": 1167059314.87,
                                "netSales": -6642401.94
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 6.318500769273054,
                                "grossSales": 69902795.05,
                                "competitorSales": 1036416529.78,
                                "globalSales": 1106319324.83,
                                "netSales": 16510057.29
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 4.2598225684056805,
                                "grossSales": 54103801.52,
                                "competitorSales": 1215991387.92,
                                "globalSales": 1270095189.44,
                                "netSales": 15948251.69
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 3.294645789671912,
                                "grossSales": 47693314.05,
                                "competitorSales": 1399907341.52,
                                "globalSales": 1447600655.57,
                                "netSales": 7699453.28
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 4.839884357701243,
                                "grossSales": 63818032.64,
                                "competitorSales": 1254767865.77,
                                "globalSales": 1318585898.41,
                                "netSales": 13675115.29
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 3.5620458839990485,
                                "grossSales": 55510173.06,
                                "competitorSales": 1502868771.73,
                                "globalSales": 1558378944.79,
                                "netSales": 4894352.32
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 3.669216457020022,
                                "grossSales": 50015846.78,
                                "competitorSales": 1313104791.26,
                                "globalSales": 1363120638.04,
                                "netSales": 15821663.48
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 4.354098360984855,
                                "grossSales": 59841420.77,
                                "competitorSales": 1314528559.16,
                                "globalSales": 1374369979.93,
                                "netSales": -1955403.29
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.4549925006922386,
                                "grossSales": 47775513.42,
                                "competitorSales": 1335020930,
                                "globalSales": 1382796443.42,
                                "netSales": 1788867.64
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 26,
                        "optionValue": "BD Field Metro Atlanta",
                        "marketShare": 4.60936765900604,
                        "marketShareChange": 0.9262627319808914,
                        "grossSales": 156077863.29,
                        "competitorSales": 3230023546.63,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 3.647468690917481,
                                "grossSales": 40613120.21,
                                "competitorSales": 1072847299.92,
                                "globalSales": 1113460420.13,
                                "netSales": 12237817.62
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 3.599620618307877,
                                "grossSales": 43596564.84,
                                "competitorSales": 1167546760.05,
                                "globalSales": 1211143324.89,
                                "netSales": 18962082.74
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 3.4257438768476756,
                                "grossSales": 33907344.54,
                                "competitorSales": 955873145.74,
                                "globalSales": 989780490.28,
                                "netSales": 11311492.65
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 3.5494746361211575,
                                "grossSales": 29907244.36,
                                "competitorSales": 812675036.85,
                                "globalSales": 842582281.21,
                                "netSales": 6739521.49
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 4.7461675778402626,
                                "grossSales": 41609229.41,
                                "competitorSales": 835081884.58,
                                "globalSales": 876691113.99,
                                "netSales": 12615045.41
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 3.3457401250787373,
                                "grossSales": 35112540.06,
                                "competitorSales": 1014357494.89,
                                "globalSales": 1049470034.95,
                                "netSales": 13213326.17
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 3.209047728465981,
                                "grossSales": 44333583.72,
                                "competitorSales": 1337184781.58,
                                "globalSales": 1381518365.3,
                                "netSales": 1761917.2
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 3.6184581114252055,
                                "grossSales": 54035245.84,
                                "competitorSales": 1439287163.21,
                                "globalSales": 1493322409.05,
                                "netSales": 15931297.62
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 4.192876791794089,
                                "grossSales": 61807407.23,
                                "competitorSales": 1412297611.81,
                                "globalSales": 1474105019.04,
                                "netSales": 27999535.6
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 4.915677154191432,
                                "grossSales": 60835289.04,
                                "competitorSales": 1176741694.39,
                                "globalSales": 1237576983.43,
                                "netSales": 31280935.22
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 5.972811257957703,
                                "grossSales": 61998556.81,
                                "competitorSales": 976014434.6,
                                "globalSales": 1038012991.41,
                                "netSales": 12003825.82
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 2.993577228460069,
                                "grossSales": 33244017.44,
                                "competitorSales": 1077267417.64,
                                "globalSales": 1110511435.08,
                                "netSales": 10709776.17
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 27,
                        "optionValue": "BD Field Pennsylvania West",
                        "marketShare": 4.572719460191187,
                        "marketShareChange": -0.7973746868537495,
                        "grossSales": 154883438.2,
                        "competitorSales": 3232235311.3400006,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 5.8047833219015414,
                                "grossSales": 54163569.88,
                                "competitorSales": 878921557.96,
                                "globalSales": 933085127.84,
                                "netSales": 21059442.15
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 3.551117344290069,
                                "grossSales": 32909308.62,
                                "competitorSales": 893821785.55,
                                "globalSales": 926731094.17,
                                "netSales": -8024006.35
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 3.3863890935460828,
                                "grossSales": 40061991.21,
                                "competitorSales": 1142967781.9,
                                "globalSales": 1183029773.11,
                                "netSales": 10249231.35
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 5.028867205939575,
                                "grossSales": 49053204.05,
                                "competitorSales": 926379274.9,
                                "globalSales": 975432478.95,
                                "netSales": 16897387.61
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 5.335414962322966,
                                "grossSales": 56033645.66,
                                "competitorSales": 994187303.52,
                                "globalSales": 1050220949.18,
                                "netSales": 23390693.55
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 4.5356540713480245,
                                "grossSales": 50003345.04,
                                "competitorSales": 1052447244.3,
                                "globalSales": 1102450589.34,
                                "netSales": 18765427.62
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 5.635888715603641,
                                "grossSales": 72435728.63,
                                "competitorSales": 1212822591.49,
                                "globalSales": 1285258320.12,
                                "netSales": 29158764.85
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 5.558130237222681,
                                "grossSales": 72693580.37,
                                "competitorSales": 1235184739.63,
                                "globalSales": 1307878320,
                                "netSales": 26459889.72
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 4.9194304386102425,
                                "grossSales": 64136004.2,
                                "competitorSales": 1239592242.4,
                                "globalSales": 1303728246.6,
                                "netSales": 8393514.74
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 4.216449697350766,
                                "grossSales": 47822747.54,
                                "competitorSales": 1086371917.94,
                                "globalSales": 1134194665.48,
                                "netSales": 15865806.49
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 5.332356954324828,
                                "grossSales": 63739466.26,
                                "competitorSales": 1131594357.15,
                                "globalSales": 1195333823.41,
                                "netSales": 21707423.03
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 4.0962200591157645,
                                "grossSales": 43321224.4,
                                "competitorSales": 1014269036.25,
                                "globalSales": 1057590260.65,
                                "netSales": 6523979.02
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 28,
                        "optionValue": "RRB Team West",
                        "marketShare": 4.369764629503101,
                        "marketShareChange": -2.9205611520862274,
                        "grossSales": 154603193.23,
                        "competitorSales": 3383417875.14,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 5.480075114074098,
                                "grossSales": 62380294.33,
                                "competitorSales": 1075930641.77,
                                "globalSales": 1138310936.1,
                                "netSales": -12206987.95
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 4.316987634232515,
                                "grossSales": 47737315.57,
                                "competitorSales": 1058064220.47,
                                "globalSales": 1105801536.04,
                                "netSales": -1758679.2
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 5.008351516456942,
                                "grossSales": 42460340.88,
                                "competitorSales": 805330409.04,
                                "globalSales": 847790749.92,
                                "netSales": 1313227.95
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 4.789274251944904,
                                "grossSales": 40336352.6,
                                "competitorSales": 801886299.06,
                                "globalSales": 842222651.66,
                                "netSales": -134775170.2
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 3.942977314779998,
                                "grossSales": 36707127.2,
                                "competitorSales": 894242362.73,
                                "globalSales": 930949489.93,
                                "netSales": 318494.66
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 7.189698152591238,
                                "grossSales": 96576370.18,
                                "competitorSales": 1246684057.87,
                                "globalSales": 1343260428.05,
                                "netSales": 55464163.82
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 4.684180075251274,
                                "grossSales": 72116984.73,
                                "competitorSales": 1467469102.3,
                                "globalSales": 1539586087.03,
                                "netSales": 26170629.67
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 11.654118917007821,
                                "grossSales": 151900689,
                                "competitorSales": 1151507059.64,
                                "globalSales": 1303407748.64,
                                "netSales": 82708583.76
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 6.0700525527765,
                                "grossSales": 83340875.07,
                                "competitorSales": 1289643532.32,
                                "globalSales": 1372984407.39,
                                "netSales": 33189711.25
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 4.419144323744838,
                                "grossSales": 61377507.67,
                                "competitorSales": 1327522767.44,
                                "globalSales": 1388900275.11,
                                "netSales": 18307393.61
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 5.720906361446807,
                                "grossSales": 52887323.41,
                                "competitorSales": 871569748.05,
                                "globalSales": 924457071.46,
                                "netSales": 3114351.42
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.2938317214713466,
                                "grossSales": 40338362.15,
                                "competitorSales": 1184325359.65,
                                "globalSales": 1224663721.8,
                                "netSales": 1947565.11
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 29,
                        "optionValue": "BD Field Colorado",
                        "marketShare": 4.279446439622922,
                        "marketShareChange": -0.2057520819790426,
                        "grossSales": 154360322.89999998,
                        "competitorSales": 3452655796.54,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 3.933163404391525,
                                "grossSales": 37492337.2,
                                "competitorSales": 915743858.33,
                                "globalSales": 953236195.53,
                                "netSales": 8304108.54
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 4.263313819185554,
                                "grossSales": 40447278.45,
                                "competitorSales": 908281343.59,
                                "globalSales": 948728622.04,
                                "netSales": 3964317.96
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 4.819538219815589,
                                "grossSales": 50636405.17,
                                "competitorSales": 1000012077.33,
                                "globalSales": 1050648482.5,
                                "netSales": 7687424.99
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 4.774021547051567,
                                "grossSales": 42407764.33,
                                "competitorSales": 845894978.17,
                                "globalSales": 888302742.5,
                                "netSales": 1718313.92
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 4.043978094739916,
                                "grossSales": 35368719.13,
                                "competitorSales": 839233425.13,
                                "globalSales": 874602144.26,
                                "netSales": 5887984.18
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 3.7445529273311475,
                                "grossSales": 45303239.82,
                                "competitorSales": 1164540517.21,
                                "globalSales": 1209843757.03,
                                "netSales": -7652239.07
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 4.235444274675683,
                                "grossSales": 56376238.08,
                                "competitorSales": 1274682192.25,
                                "globalSales": 1331058430.33,
                                "netSales": 8806083.45
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 4.99114820277378,
                                "grossSales": 59766688.6,
                                "competitorSales": 1137687006.86,
                                "globalSales": 1197453695.46,
                                "netSales": 14404014.56
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 4.289045477564433,
                                "grossSales": 59784150.28,
                                "competitorSales": 1334095923.8,
                                "globalSales": 1393880074.08,
                                "netSales": 19124299.58
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 3.60195527367453,
                                "grossSales": 48272597.51,
                                "competitorSales": 1291904996.11,
                                "globalSales": 1340177593.62,
                                "netSales": 1528286.54
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 5.3619756051528755,
                                "grossSales": 58957660.19,
                                "competitorSales": 1040593410.75,
                                "globalSales": 1099551070.94,
                                "netSales": 30273251.36
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 4.037571465620273,
                                "grossSales": 47130065.2,
                                "competitorSales": 1120157389.68,
                                "globalSales": 1167287454.88,
                                "netSales": 18210618.92
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 30,
                        "optionValue": "RRB Team Southwest",
                        "marketShare": 5.1455720880159745,
                        "marketShareChange": -1.0813143322436254,
                        "grossSales": 148709881.99,
                        "competitorSales": 2741345479.13,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 4.320397413769073,
                                "grossSales": 33044988.07,
                                "competitorSales": 731814928.86,
                                "globalSales": 764859916.93,
                                "netSales": -5265865.3
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 4.533279145033142,
                                "grossSales": 32409227.04,
                                "competitorSales": 682508738.59,
                                "globalSales": 714917965.63,
                                "netSales": 3313115.71
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 6.238052431708221,
                                "grossSales": 43190752.55,
                                "competitorSales": 649184841,
                                "globalSales": 692375593.55,
                                "netSales": -12509054.64
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 3.4128293748613507,
                                "grossSales": 36551965.08,
                                "competitorSales": 1034464516.12,
                                "globalSales": 1071016481.2,
                                "netSales": -15560546.96
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 4.849325181185217,
                                "grossSales": 38880219.2,
                                "competitorSales": 762885340.9,
                                "globalSales": 801765560.1,
                                "netSales": -3246564.42
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 5.901804023916042,
                                "grossSales": 54102903.5,
                                "competitorSales": 862615158.99,
                                "globalSales": 916718062.49,
                                "netSales": 13681195.53
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 8.150101984955231,
                                "grossSales": 73166661.46,
                                "competitorSales": 824572552.05,
                                "globalSales": 897739213.51,
                                "netSales": 32290863.59
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 7.342929392012519,
                                "grossSales": 60782352.12,
                                "competitorSales": 766984726.59,
                                "globalSales": 827767078.71,
                                "netSales": 14222477.82
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 4.565590109911868,
                                "grossSales": 72837707.68,
                                "competitorSales": 1522524686.37,
                                "globalSales": 1595362394.05,
                                "netSales": 13445800.28
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 3.7406345322462307,
                                "grossSales": 48934946.54,
                                "competitorSales": 1259264133.54,
                                "globalSales": 1308199080.08,
                                "netSales": 3809518.65
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 5.97944103476363,
                                "grossSales": 45350791.25,
                                "competitorSales": 713094538.11,
                                "globalSales": 758445329.36,
                                "netSales": -36911780.32
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 6.609596834843984,
                                "grossSales": 54424144.2,
                                "competitorSales": 768986807.48,
                                "globalSales": 823410951.68,
                                "netSales": -104791263
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 31,
                        "optionValue": "BD Field Texas West",
                        "marketShare": 4.090318108798708,
                        "marketShareChange": -0.0883750025530583,
                        "grossSales": 147129401.39,
                        "competitorSales": 3449886710.23,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 3.497018629458319,
                                "grossSales": 34062594.88,
                                "competitorSales": 939984114.31,
                                "globalSales": 974046709.19,
                                "netSales": 8068093.07
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 3.5866537565690444,
                                "grossSales": 34930263.3,
                                "competitorSales": 938965341.65,
                                "globalSales": 973895604.95,
                                "netSales": 12169988.3
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 3.9865858685397817,
                                "grossSales": 38138283.25,
                                "competitorSales": 918527006.49,
                                "globalSales": 956665289.74,
                                "netSales": 9907034.06
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 3.454743221043894,
                                "grossSales": 31650017.77,
                                "competitorSales": 884482260.23,
                                "globalSales": 916132278,
                                "netSales": -12643094.46
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 4.002164430397794,
                                "grossSales": 37024411.43,
                                "competitorSales": 888085290.43,
                                "globalSales": 925109701.86,
                                "netSales": 6422677.37
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 2.9399597275489997,
                                "grossSales": 30668302.86,
                                "competitorSales": 1012485539.44,
                                "globalSales": 1043153842.3,
                                "netSales": 9541036.08
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 4.779357357804954,
                                "grossSales": 65312740.33,
                                "competitorSales": 1301246306.01,
                                "globalSales": 1366559046.34,
                                "netSales": 17890661.25
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 4.46212598179536,
                                "grossSales": 59608158.58,
                                "competitorSales": 1276260860.43,
                                "globalSales": 1335869019.01,
                                "netSales": 16964240.13
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 3.300864399991901,
                                "grossSales": 45103281.87,
                                "competitorSales": 1321304919.27,
                                "globalSales": 1366408201.14,
                                "netSales": 11232222.5
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 4.1640067556807905,
                                "grossSales": 53043883.89,
                                "competitorSales": 1220822538.58,
                                "globalSales": 1273866422.47,
                                "netSales": 24713548.5
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 4.468618190607064,
                                "grossSales": 54060193.33,
                                "competitorSales": 1155714081.94,
                                "globalSales": 1209774275.27,
                                "netSales": 18531292.31
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.5949531192282946,
                                "grossSales": 40025324.17,
                                "competitorSales": 1073350089.71,
                                "globalSales": 1113375413.88,
                                "netSales": 9645648.26
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 32,
                        "optionValue": "BD Field West Central",
                        "marketShare": 4.201633014176152,
                        "marketShareChange": 0.016016732665462996,
                        "grossSales": 145168935.51,
                        "competitorSales": 3309890919.08,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 3.833272052093274,
                                "grossSales": 32595314.08,
                                "competitorSales": 817730820.8,
                                "globalSales": 850326134.88,
                                "netSales": -4767706.87
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 3.9116738465523624,
                                "grossSales": 34171114.17,
                                "competitorSales": 839396455.89,
                                "globalSales": 873567570.06,
                                "netSales": -6791359.63
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 2.667033968208318,
                                "grossSales": 31773868.08,
                                "competitorSales": 1159582089.84,
                                "globalSales": 1191355957.92,
                                "netSales": -9878945.02
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 4.11918309613282,
                                "grossSales": 36079348.89,
                                "competitorSales": 839806671.42,
                                "globalSales": 875886020.31,
                                "netSales": -3673992.31
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 4.3631961482610535,
                                "grossSales": 39564091.23,
                                "competitorSales": 867204476.71,
                                "globalSales": 906768567.94,
                                "netSales": -1155306.06
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 3.764211947092927,
                                "grossSales": 37230027.33,
                                "competitorSales": 951822338.83,
                                "globalSales": 989052366.16,
                                "netSales": 12764122.02
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 3.9085510222945894,
                                "grossSales": 46146341.56,
                                "competitorSales": 1134504526.16,
                                "globalSales": 1180650867.72,
                                "netSales": 10322031.56
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 5.681548693993798,
                                "grossSales": 64265560.09,
                                "competitorSales": 1066861946.71,
                                "globalSales": 1131127506.8,
                                "netSales": 26798881.13
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 3.160451110297762,
                                "grossSales": 42080344.05,
                                "competitorSales": 1289386037.85,
                                "globalSales": 1331466381.9,
                                "netSales": 5624506.92
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 5.268921678163129,
                                "grossSales": 70355635.88,
                                "competitorSales": 1264939139.36,
                                "globalSales": 1335294775.24,
                                "netSales": 27675310.96
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 3.8527880981275677,
                                "grossSales": 41332795.94,
                                "competitorSales": 1031469416.05,
                                "globalSales": 1072802211.99,
                                "netSales": 1337729.29
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.1978692591480105,
                                "grossSales": 33480503.69,
                                "competitorSales": 1013482363.67,
                                "globalSales": 1046962867.36,
                                "netSales": 7909407.38
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 33,
                        "optionValue": "BD Field Metro Detroit",
                        "marketShare": 4.608127449696051,
                        "marketShareChange": 0.9381922002064944,
                        "grossSales": 143555887.87,
                        "competitorSales": 2971720098.6800003,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 4.869379459047017,
                                "grossSales": 38845199.5,
                                "competitorSales": 758899150.2,
                                "globalSales": 797744349.7,
                                "netSales": 12820886.21
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 3.737612505926159,
                                "grossSales": 32684677.56,
                                "competitorSales": 841795421.92,
                                "globalSales": 874480099.48,
                                "netSales": 11544992.73
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 3.8607879211884826,
                                "grossSales": 32403940.7,
                                "competitorSales": 806905064.65,
                                "globalSales": 839309005.35,
                                "netSales": 9246198.08
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 4.458976233869605,
                                "grossSales": 39606646.99,
                                "competitorSales": 848638656.7,
                                "globalSales": 888245303.69,
                                "netSales": 5181929.37
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 4.235683675430334,
                                "grossSales": 35886791.68,
                                "competitorSales": 811362305.04,
                                "globalSales": 847249096.72,
                                "netSales": 10246199.9
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 4.220404458890139,
                                "grossSales": 40549462.97,
                                "competitorSales": 920246199.27,
                                "globalSales": 960795662.24,
                                "netSales": 3681458.91
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 3.345510212674599,
                                "grossSales": 37371541.64,
                                "competitorSales": 1079693995.88,
                                "globalSales": 1117065537.52,
                                "netSales": -1043881.3
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 4.325886966736495,
                                "grossSales": 59427230.36,
                                "competitorSales": 1314331048.97,
                                "globalSales": 1373758279.33,
                                "netSales": 17462122.63
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 3.236509181573238,
                                "grossSales": 40227305.49,
                                "competitorSales": 1202695338.42,
                                "globalSales": 1242922643.91,
                                "netSales": 2512957.34
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 5.850934198022166,
                                "grossSales": 61940807.81,
                                "competitorSales": 996707362.1,
                                "globalSales": 1058648169.91,
                                "netSales": 8519065.22
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 4.8440118102569425,
                                "grossSales": 45132577.79,
                                "competitorSales": 886586409.65,
                                "globalSales": 931718987.44,
                                "netSales": 22873702.52
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.243151918004343,
                                "grossSales": 36482502.27,
                                "competitorSales": 1088426326.93,
                                "globalSales": 1124908829.2,
                                "netSales": 12972185.97
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 34,
                        "optionValue": "BD Field Mid-America",
                        "marketShare": 4.646308598790421,
                        "marketShareChange": -0.5479122754469001,
                        "grossSales": 141909187.16,
                        "competitorSales": 2912325893.07,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 5.580072923618881,
                                "grossSales": 48045527.26,
                                "competitorSales": 812974174.77,
                                "globalSales": 861019702.03,
                                "netSales": 14522536.38
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 7.698903759490017,
                                "grossSales": 71365843.89,
                                "competitorSales": 855595267.97,
                                "globalSales": 926961111.86,
                                "netSales": 35126239.95
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 4.799084722913286,
                                "grossSales": 39901548.35,
                                "competitorSales": 791539250.34,
                                "globalSales": 831440798.69,
                                "netSales": -11185201.06
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 5.233210565796878,
                                "grossSales": 44242239.33,
                                "competitorSales": 801170701.23,
                                "globalSales": 845412940.56,
                                "netSales": 27573.65
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 6.35914146432013,
                                "grossSales": 58107120,
                                "competitorSales": 855650190.26,
                                "globalSales": 913757310.26,
                                "netSales": 16471585.91
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 5.643272341709203,
                                "grossSales": 51721520.97,
                                "competitorSales": 864794958.09,
                                "globalSales": 916516479.06,
                                "netSales": 13680861.5
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 5.5801721256841175,
                                "grossSales": 59101541.05,
                                "competitorSales": 1000033190.26,
                                "globalSales": 1059134731.31,
                                "netSales": -893191.99
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 4.8780055316860045,
                                "grossSales": 47564491.88,
                                "competitorSales": 927516236.73,
                                "globalSales": 975080728.61,
                                "netSales": 7062855.21
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 5.104890786317726,
                                "grossSales": 57397184.74,
                                "competitorSales": 1066959577.09,
                                "globalSales": 1124356761.83,
                                "netSales": 4432697.52
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 4.2895578670573915,
                                "grossSales": 48748659.46,
                                "competitorSales": 1087700852.84,
                                "globalSales": 1136449512.3,
                                "netSales": -8001226.86
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 5.166519687206136,
                                "grossSales": 50089616.82,
                                "competitorSales": 919414417.86,
                                "globalSales": 969504034.68,
                                "netSales": 9688279.05
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 4.541996165672986,
                                "grossSales": 43070910.88,
                                "competitorSales": 905210622.37,
                                "globalSales": 948281533.25,
                                "netSales": 11049222.55
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 35,
                        "optionValue": "BD Field Twin Cities",
                        "marketShare": 4.341087472954682,
                        "marketShareChange": -0.3683637774275619,
                        "grossSales": 141488765.38,
                        "competitorSales": 3117804355.5599995,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 3.5089310988569737,
                                "grossSales": 32360473.15,
                                "competitorSales": 889871176.27,
                                "globalSales": 922231649.42,
                                "netSales": 869327.65
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 4.47389496043403,
                                "grossSales": 37896929.17,
                                "competitorSales": 809170994.98,
                                "globalSales": 847067924.15,
                                "netSales": 5983766.29
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 4.112194787928939,
                                "grossSales": 35213029.01,
                                "competitorSales": 821094388.95,
                                "globalSales": 856307417.96,
                                "netSales": -4420912.9
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 5.720871467601798,
                                "grossSales": 52942524.02,
                                "competitorSales": 872485084.69,
                                "globalSales": 925427608.71,
                                "netSales": 3358610.46
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 4.615555168254191,
                                "grossSales": 44654007.47,
                                "competitorSales": 922813736.76,
                                "globalSales": 967467744.23,
                                "netSales": 13201638.37
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 4.45468137891946,
                                "grossSales": 47079566.47,
                                "competitorSales": 1009776411.89,
                                "globalSales": 1056855978.36,
                                "netSales": 6901710.59
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 4.368416091569715,
                                "grossSales": 47376070.25,
                                "competitorSales": 1037137612.9,
                                "globalSales": 1084513683.15,
                                "netSales": 6780230.26
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 4.211977803531,
                                "grossSales": 53857411.77,
                                "competitorSales": 1224815323.04,
                                "globalSales": 1278672734.81,
                                "netSales": 13513042.86
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 5.459576634108776,
                                "grossSales": 73216189.81,
                                "competitorSales": 1267843652.68,
                                "globalSales": 1341059842.49,
                                "netSales": 22508137.08
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 4.094359636264563,
                                "grossSales": 48641532.8,
                                "competitorSales": 1139371663.92,
                                "globalSales": 1188013196.72,
                                "netSales": 9253888.26
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 4.077439593857961,
                                "grossSales": 41650422.14,
                                "competitorSales": 979834291.03,
                                "globalSales": 1021484713.17,
                                "netSales": 6799136.12
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 4.876837872864099,
                                "grossSales": 51196810.44,
                                "competitorSales": 998598400.61,
                                "globalSales": 1049795211.05,
                                "netSales": 16472582.57
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 36,
                        "optionValue": "RRB Team New England",
                        "marketShare": 7.854300151003882,
                        "marketShareChange": -2.442574451418798,
                        "grossSales": 141152373.35,
                        "competitorSales": 1655982579.94,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 7.524096515217278,
                                "grossSales": 42561972.71,
                                "competitorSales": 523113555.56,
                                "globalSales": 565675528.27,
                                "netSales": 16428901.8
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 4.509143623154082,
                                "grossSales": 29720465.07,
                                "competitorSales": 629395046.74,
                                "globalSales": 659115511.81,
                                "netSales": 6479865.35
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 7.993605173697422,
                                "grossSales": 55742023.14,
                                "competitorSales": 641590681.3,
                                "globalSales": 697332704.44,
                                "netSales": 26920640.44
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 9.351931553345274,
                                "grossSales": 48262332.07,
                                "competitorSales": 467805731.46,
                                "globalSales": 516068063.53,
                                "netSales": 8675834.28
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 15.653489507855623,
                                "grossSales": 82595740.54,
                                "competitorSales": 445054918.43,
                                "globalSales": 527650658.97,
                                "netSales": 18034694.66
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 7.233135069961302,
                                "grossSales": 57992003.41,
                                "competitorSales": 743762738.47,
                                "globalSales": 801754741.88,
                                "netSales": 4132568.69
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 7.170549721216098,
                                "grossSales": 60138029.35,
                                "competitorSales": 778542848.52,
                                "globalSales": 838680877.87,
                                "netSales": 5985437.45
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 12.92890849884189,
                                "grossSales": 89018260.89,
                                "competitorSales": 599502822.68,
                                "globalSales": 688521083.57,
                                "netSales": 36871934.86
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 11.45711695513212,
                                "grossSales": 79963655.72,
                                "competitorSales": 617975066.85,
                                "globalSales": 697938722.57,
                                "netSales": 30036537.91
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 6.265966306898029,
                                "grossSales": 44619505.48,
                                "competitorSales": 667473463.02,
                                "globalSales": 712092968.5,
                                "netSales": -23704787.8
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 9.73297672683806,
                                "grossSales": 53725387.03,
                                "competitorSales": 498267991.13,
                                "globalSales": 551993378.16,
                                "netSales": 5254339.55
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 8.03068994226141,
                                "grossSales": 42807480.84,
                                "competitorSales": 490241125.79,
                                "globalSales": 533048606.63,
                                "netSales": -2612118.02
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 37,
                        "optionValue": "BD Field Heartland",
                        "marketShare": 3.7954319611482243,
                        "marketShareChange": -0.761212981359987,
                        "grossSales": 141099506.21,
                        "competitorSales": 3576514395.2999997,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 3.789342664565502,
                                "grossSales": 38796037.62,
                                "competitorSales": 985023686.65,
                                "globalSales": 1023819724.27,
                                "netSales": 282018.11
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 3.7586382052362173,
                                "grossSales": 38126153.66,
                                "competitorSales": 976234675.4,
                                "globalSales": 1014360829.06,
                                "netSales": -3986989.06
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 3.6662850165534264,
                                "grossSales": 39423092.7,
                                "competitorSales": 1035864085.52,
                                "globalSales": 1075287178.22,
                                "netSales": -7604220.06
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 5.669255377156902,
                                "grossSales": 59627977.93,
                                "competitorSales": 992149971.08,
                                "globalSales": 1051777949.01,
                                "netSales": 13849265.06
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 4.2202193397333865,
                                "grossSales": 47058314.92,
                                "competitorSales": 1068009674.01,
                                "globalSales": 1115067988.93,
                                "netSales": -12001931.86
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 3.824375870051057,
                                "grossSales": 49520895.02,
                                "competitorSales": 1245354313.45,
                                "globalSales": 1294875208.47,
                                "netSales": 10751326.84
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 5.535106883625382,
                                "grossSales": 83862371.89,
                                "competitorSales": 1431237040.88,
                                "globalSales": 1515099412.77,
                                "netSales": 35842064.42
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 4.536134181486715,
                                "grossSales": 59338652.02,
                                "competitorSales": 1248793992.34,
                                "globalSales": 1308132644.36,
                                "netSales": 10893017.45
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 3.603158853346365,
                                "grossSales": 55007502.89,
                                "competitorSales": 1471639118.28,
                                "globalSales": 1526646621.17,
                                "netSales": -23965281.8
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 3.662368034178925,
                                "grossSales": 50603345.88,
                                "competitorSales": 1331107760.37,
                                "globalSales": 1381711106.25,
                                "netSales": 1217629.21
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 4.4879997065217285,
                                "grossSales": 53521580.54,
                                "competitorSales": 1139027083.45,
                                "globalSales": 1192548663.99,
                                "netSales": 112071.13
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.233869435441656,
                                "grossSales": 36974579.79,
                                "competitorSales": 1106379551.48,
                                "globalSales": 1143354131.27,
                                "netSales": 10466590.94
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 38,
                        "optionValue": "BD Field Florida South",
                        "marketShare": 4.209327317019006,
                        "marketShareChange": 0.8143128660470595,
                        "grossSales": 139781856.66,
                        "competitorSales": 3180982867.3100004,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 2.6732586018202076,
                                "grossSales": 28735804.73,
                                "competitorSales": 1046199658.32,
                                "globalSales": 1074935463.05,
                                "netSales": 46125.99
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 2.59785935204848,
                                "grossSales": 26014033.67,
                                "competitorSales": 975350172.19,
                                "globalSales": 1001364205.86,
                                "netSales": 911515.68
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 2.6549639705492587,
                                "grossSales": 22492252.34,
                                "competitorSales": 824685057.39,
                                "globalSales": 847177309.73,
                                "netSales": -13315146.41
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 2.595156176308614,
                                "grossSales": 23692667.86,
                                "competitorSales": 889264636.07,
                                "globalSales": 912957303.93,
                                "netSales": 477702.77
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 3.161380131990284,
                                "grossSales": 29512578.16,
                                "competitorSales": 904022046.84,
                                "globalSales": 933534625,
                                "netSales": 9071819.28
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 2.553488410665576,
                                "grossSales": 27469640.94,
                                "competitorSales": 1048299523.52,
                                "globalSales": 1075769164.46,
                                "netSales": 4472411.21
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 3.1441583185067694,
                                "grossSales": 39016097.57,
                                "competitorSales": 1201891440.08,
                                "globalSales": 1240907537.65,
                                "netSales": 12381871.65
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 3.698869148734247,
                                "grossSales": 45667352.35,
                                "competitorSales": 1188962760.63,
                                "globalSales": 1234630112.98,
                                "netSales": 19734253.07
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 3.343667630645418,
                                "grossSales": 41584447.89,
                                "competitorSales": 1202093228.35,
                                "globalSales": 1243677676.24,
                                "netSales": 14805663.95
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 3.9745578065735594,
                                "grossSales": 47150737.99,
                                "competitorSales": 1139163319.69,
                                "globalSales": 1186314057.68,
                                "netSales": 12051373.53
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 4.110198737087813,
                                "grossSales": 43123573.92,
                                "competitorSales": 1006061068.44,
                                "globalSales": 1049184642.36,
                                "netSales": 7771964.35
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 4.56178887557188,
                                "grossSales": 49507544.75,
                                "competitorSales": 1035758479.18,
                                "globalSales": 1085266023.93,
                                "netSales": 20498671.66
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 39,
                        "optionValue": "BD Field Mountain West",
                        "marketShare": 4.2562863751568365,
                        "marketShareChange": -0.23766819461063182,
                        "grossSales": 138107145.03,
                        "competitorSales": 3106673230.56,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 3.8537665740809066,
                                "grossSales": 33742527.97,
                                "competitorSales": 841830170.1,
                                "globalSales": 875572698.07,
                                "netSales": -7489432.37
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 3.4511742893903268,
                                "grossSales": 28951300.95,
                                "competitorSales": 809931308.92,
                                "globalSales": 838882609.87,
                                "netSales": -1885591.69
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 3.4733833673556003,
                                "grossSales": 31070599.47,
                                "competitorSales": 863463524.29,
                                "globalSales": 894534123.76,
                                "netSales": -1296061.95
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 3.6001985297669563,
                                "grossSales": 33131801.5,
                                "competitorSales": 887145267.28,
                                "globalSales": 920277068.78,
                                "netSales": -5638994.91
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 4.133680214345995,
                                "grossSales": 36529692.23,
                                "competitorSales": 847179020.97,
                                "globalSales": 883708713.2,
                                "netSales": 6762595.2
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 4.23101996571293,
                                "grossSales": 43202792.18,
                                "competitorSales": 977893599,
                                "globalSales": 1021096391.18,
                                "netSales": 13282574.19
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 4.171458256619518,
                                "grossSales": 46741139.34,
                                "competitorSales": 1073757651.84,
                                "globalSales": 1120498791.18,
                                "netSales": 3458998.93
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 4.583060994947365,
                                "grossSales": 50114015.49,
                                "competitorSales": 1043347658.82,
                                "globalSales": 1093461674.31,
                                "netSales": 11240213.79
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 4.711840736078204,
                                "grossSales": 57073825.08,
                                "competitorSales": 1154211281.46,
                                "globalSales": 1211285106.54,
                                "netSales": 13483083.22
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 3.968092598292482,
                                "grossSales": 49900070.92,
                                "competitorSales": 1207632854.13,
                                "globalSales": 1257532925.05,
                                "netSales": 12758403.05
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 4.406406166425709,
                                "grossSales": 44556235.19,
                                "competitorSales": 966613264.56,
                                "globalSales": 1011169499.75,
                                "netSales": 11902291.7
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 4.472064847348585,
                                "grossSales": 43650838.92,
                                "competitorSales": 932427111.87,
                                "globalSales": 976077950.79,
                                "netSales": 10824955.55
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 40,
                        "optionValue": "BD Field New York Upstate",
                        "marketShare": 5.352559195659288,
                        "marketShareChange": -0.5455704361084379,
                        "grossSales": 134926651.26,
                        "competitorSales": 2385861000.55,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 5.836999309394524,
                                "grossSales": 40450274.62,
                                "competitorSales": 652547488.03,
                                "globalSales": 692997762.65,
                                "netSales": -12351264.08
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 6.167520521034181,
                                "grossSales": 43660841.33,
                                "competitorSales": 664254781.83,
                                "globalSales": 707915623.16,
                                "netSales": 16733791.24
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 5.260805155749212,
                                "grossSales": 35301831.02,
                                "competitorSales": 635732924.59,
                                "globalSales": 671034755.61,
                                "netSales": -1782377.1
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 4.985551838089384,
                                "grossSales": 32290564.29,
                                "competitorSales": 615392286.85,
                                "globalSales": 647682851.14,
                                "netSales": 1537393.97
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 6.843069035153354,
                                "grossSales": 49398153.19,
                                "competitorSales": 672473172.91,
                                "globalSales": 721871326.1,
                                "netSales": 559296.47
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 8.462516524223933,
                                "grossSales": 71844444.74,
                                "competitorSales": 777128133.74,
                                "globalSales": 848972578.48,
                                "netSales": 24402125.49
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 6.6580315098211855,
                                "grossSales": 65159974.37,
                                "competitorSales": 913507282.97,
                                "globalSales": 978667257.34,
                                "netSales": 28813346.93
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 5.345754023984261,
                                "grossSales": 46413831.4,
                                "competitorSales": 821823487.26,
                                "globalSales": 868237318.66,
                                "netSales": 4127124.1
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 5.628508915185059,
                                "grossSales": 55132179.71,
                                "competitorSales": 924384430.12,
                                "globalSales": 979516609.83,
                                "netSales": -10735554.58
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 5.048723094857658,
                                "grossSales": 43431618.61,
                                "competitorSales": 816817949.33,
                                "globalSales": 860249567.94,
                                "netSales": 7506729.04
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 4.49375249330429,
                                "grossSales": 36583690.47,
                                "competitorSales": 777517453.83,
                                "globalSales": 814101144.3,
                                "netSales": 11634536.82
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 6.487351817123625,
                                "grossSales": 54911342.18,
                                "competitorSales": 791525597.39,
                                "globalSales": 846436939.57,
                                "netSales": 20649587.25
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 41,
                        "optionValue": "BD Field Michigan West",
                        "marketShare": 4.173653826163736,
                        "marketShareChange": -0.21853060868872465,
                        "grossSales": 130116476.3,
                        "competitorSales": 2987451048.93,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 4.022561682954725,
                                "grossSales": 37121240.95,
                                "competitorSales": 885704656.47,
                                "globalSales": 922825897.42,
                                "netSales": 4685361.62
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 4.0456184661659,
                                "grossSales": 36368388.23,
                                "competitorSales": 862589052.62,
                                "globalSales": 898957440.85,
                                "netSales": 547364.4
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 5.909341090297538,
                                "grossSales": 58269042.43,
                                "competitorSales": 927780697.12,
                                "globalSales": 986049739.55,
                                "netSales": 11855004.06
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 4.692879802753483,
                                "grossSales": 44237174.51,
                                "competitorSales": 898407350.16,
                                "globalSales": 942644524.67,
                                "netSales": -5584505.09
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 4.634146940194368,
                                "grossSales": 43431307.02,
                                "competitorSales": 893770460.22,
                                "globalSales": 937201767.24,
                                "netSales": 8467860.13
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 4.185670017304998,
                                "grossSales": 44721406.97,
                                "competitorSales": 1023719410.99,
                                "globalSales": 1068440817.96,
                                "netSales": 9317430.89
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 4.078600950770897,
                                "grossSales": 48497050.26,
                                "competitorSales": 1140563876.4,
                                "globalSales": 1189060926.66,
                                "netSales": -21526784.55
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 4.742577178893279,
                                "grossSales": 58333130,
                                "competitorSales": 1171654865.97,
                                "globalSales": 1229987995.97,
                                "netSales": 16278953.04
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 4.344664024757454,
                                "grossSales": 53127505.66,
                                "competitorSales": 1169694451.51,
                                "globalSales": 1222821957.17,
                                "netSales": 8157504.55
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 4.1038412829156945,
                                "grossSales": 44838898.4,
                                "competitorSales": 1047769107.34,
                                "globalSales": 1092608005.74,
                                "netSales": 9044065.16
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 4.081284399977719,
                                "grossSales": 41597271.93,
                                "competitorSales": 977622852.26,
                                "globalSales": 1019220124.19,
                                "netSales": 6456813.67
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 4.34310380742028,
                                "grossSales": 43680305.97,
                                "competitorSales": 962059089.33,
                                "globalSales": 1005739395.3,
                                "netSales": 10687770.33
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 42,
                        "optionValue": "RRB Team South-Central",
                        "marketShare": 6.536953714485473,
                        "marketShareChange": -2.1680869238255456,
                        "grossSales": 127407606.9,
                        "competitorSales": 1821628786.27,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 5.3727176848819935,
                                "grossSales": 27832178.68,
                                "competitorSales": 490195760.11,
                                "globalSales": 518027938.79,
                                "netSales": 3971067.54
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 5.8660687593480105,
                                "grossSales": 40365956.52,
                                "competitorSales": 647760251.61,
                                "globalSales": 688126208.13,
                                "netSales": 8174088.7
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 6.553286902338691,
                                "grossSales": 31650097.34,
                                "competitorSales": 451315135.4,
                                "globalSales": 482965232.74,
                                "netSales": 7174675.95
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 4.858189596843553,
                                "grossSales": 27531852.56,
                                "competitorSales": 539178277.03,
                                "globalSales": 566710129.59,
                                "netSales": -11270796.06
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 5.261914871503379,
                                "grossSales": 36948492.54,
                                "competitorSales": 665238704.37,
                                "globalSales": 702187196.91,
                                "netSales": 13136102.24
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 6.2067343780353115,
                                "grossSales": 41898213.19,
                                "competitorSales": 633146192.42,
                                "globalSales": 675044405.61,
                                "netSales": -30062691.39
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 6.887712897720897,
                                "grossSales": 50340112.56,
                                "competitorSales": 680528222.22,
                                "globalSales": 730868334.78,
                                "netSales": -13166777.13
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 6.213271272424422,
                                "grossSales": 46178165.37,
                                "competitorSales": 697040074.19,
                                "globalSales": 743218239.56,
                                "netSales": 13584749.88
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 11.770714595523875,
                                "grossSales": 122102696.24,
                                "competitorSales": 915240408.54,
                                "globalSales": 1037343104.78,
                                "netSales": 84240532.87
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 6.566696449082119,
                                "grossSales": 52230621.78,
                                "competitorSales": 743155950.22,
                                "globalSales": 795386572,
                                "netSales": 8207903.98
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 5.13510244418089,
                                "grossSales": 28427572.47,
                                "competitorSales": 525165520.93,
                                "globalSales": 553593093.4,
                                "netSales": -2254783.65
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 7.790832180773235,
                                "grossSales": 46749412.65,
                                "competitorSales": 553307315.12,
                                "globalSales": 600056727.77,
                                "netSales": -4249071.12
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 43,
                        "optionValue": "BD Field New Jersey North",
                        "marketShare": 4.229411156246269,
                        "marketShareChange": 0.38428379767938203,
                        "grossSales": 126298705.95,
                        "competitorSales": 2859902003.42,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 2.782937607782281,
                                "grossSales": 26745256.85,
                                "competitorSales": 934298813.1,
                                "globalSales": 961044069.95,
                                "netSales": 4082783.96
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 3.4885804424440336,
                                "grossSales": 30824376.13,
                                "competitorSales": 852754966.2,
                                "globalSales": 883579342.33,
                                "netSales": 6062929.73
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 2.5151631978975417,
                                "grossSales": 23606285.2,
                                "competitorSales": 914952501.75,
                                "globalSales": 938558786.95,
                                "netSales": 413989.47
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 3.1534245047292497,
                                "grossSales": 26050549.65,
                                "competitorSales": 800052932.8,
                                "globalSales": 826103482.45,
                                "netSales": 2104098.8
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 3.815595428906608,
                                "grossSales": 31094813.18,
                                "competitorSales": 783845181.36,
                                "globalSales": 814939994.54,
                                "netSales": 5708611.47
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 3.307735523327287,
                                "grossSales": 34976101.9,
                                "competitorSales": 1022427117.11,
                                "globalSales": 1057403219.01,
                                "netSales": 5156443.81
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 3.4122267018089563,
                                "grossSales": 42109898.88,
                                "competitorSales": 1191978646.81,
                                "globalSales": 1234088545.69,
                                "netSales": 10959901.59
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 4.790779676958124,
                                "grossSales": 56875961.31,
                                "competitorSales": 1130320385.53,
                                "globalSales": 1187196346.84,
                                "netSales": 21489680.85
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 3.377540490108244,
                                "grossSales": 42504841.86,
                                "competitorSales": 1215950592.93,
                                "globalSales": 1258455434.79,
                                "netSales": 18031654.42
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 4.314386032563559,
                                "grossSales": 45644624.78,
                                "competitorSales": 1012318766.43,
                                "globalSales": 1057963391.21,
                                "netSales": 6469433.15
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 4.88871683903361,
                                "grossSales": 48995827.55,
                                "competitorSales": 953226824.39,
                                "globalSales": 1002222651.94,
                                "netSales": 16572819.65
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.4187637382925335,
                                "grossSales": 31658253.62,
                                "competitorSales": 894356412.6,
                                "globalSales": 926014666.22,
                                "netSales": 15608526.62
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 44,
                        "optionValue": "BD Field New England North",
                        "marketShare": 5.000824675076338,
                        "marketShareChange": 1.4159668535429861,
                        "grossSales": 125018716.37,
                        "competitorSales": 2374943279.76,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 3.1719021901329523,
                                "grossSales": 20053505.66,
                                "competitorSales": 612169824.63,
                                "globalSales": 632223330.29,
                                "netSales": 241467.56
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 3.8451894515960574,
                                "grossSales": 24737138.11,
                                "competitorSales": 618589762.2,
                                "globalSales": 643326900.31,
                                "netSales": 3869504.56
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 3.4550286321711274,
                                "grossSales": 21006794.19,
                                "competitorSales": 586999576.42,
                                "globalSales": 608006370.61,
                                "netSales": -170351.42
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 3.093331320484677,
                                "grossSales": 19048665.59,
                                "competitorSales": 596749114.1,
                                "globalSales": 615797779.69,
                                "netSales": -12006920.82
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 3.6723990941123366,
                                "grossSales": 24093950.62,
                                "competitorSales": 631988081.93,
                                "globalSales": 656082032.55,
                                "netSales": 1726749.83
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 4.614995824371278,
                                "grossSales": 35988790.97,
                                "competitorSales": 743834037.47,
                                "globalSales": 779822828.44,
                                "netSales": 9249913.34
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 3.470457990659787,
                                "grossSales": 34137632.79,
                                "competitorSales": 949525989.76,
                                "globalSales": 983663622.55,
                                "netSales": 3222436.25
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 3.79381051654353,
                                "grossSales": 31705117.81,
                                "competitorSales": 804001295.88,
                                "globalSales": 835706413.69,
                                "netSales": 5374810.14
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 3.5241881268296305,
                                "grossSales": 36068161.81,
                                "competitorSales": 987377820.98,
                                "globalSales": 1023445982.79,
                                "netSales": 3386927.6
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 6.367292622347061,
                                "grossSales": 54379611.44,
                                "competitorSales": 799666443.38,
                                "globalSales": 854046054.82,
                                "netSales": 32961161.49
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 4.504483664985404,
                                "grossSales": 35480998,
                                "competitorSales": 752200801.71,
                                "globalSales": 787681799.71,
                                "netSales": 16897488.26
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 4.096563539695005,
                                "grossSales": 35158106.93,
                                "competitorSales": 823076034.67,
                                "globalSales": 858234141.6,
                                "netSales": 14861130.79
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 45,
                        "optionValue": "BD Field Texas South",
                        "marketShare": 3.416890779861318,
                        "marketShareChange": 0.9654889891805718,
                        "grossSales": 121769366.14999999,
                        "competitorSales": 3441978321.3,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 2.869545005347614,
                                "grossSales": 29616968.02,
                                "competitorSales": 1002496763.07,
                                "globalSales": 1032113731.09,
                                "netSales": 2155488.06
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 2.728798923329794,
                                "grossSales": 29297203.23,
                                "competitorSales": 1044332772.93,
                                "globalSales": 1073629976.16,
                                "netSales": 9259115.52
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 2.3041009943223565,
                                "grossSales": 21966058.58,
                                "competitorSales": 931380111.32,
                                "globalSales": 953346169.9,
                                "netSales": 825124.12
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 2.7215424453846713,
                                "grossSales": 25180275.05,
                                "competitorSales": 900040461.18,
                                "globalSales": 925220736.23,
                                "netSales": 787952.27
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 2.426708694005397,
                                "grossSales": 22287990.1,
                                "competitorSales": 896157233.88,
                                "globalSales": 918445223.98,
                                "netSales": 3194951.4
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 2.6614292550768543,
                                "grossSales": 28364137.22,
                                "competitorSales": 1037384169.48,
                                "globalSales": 1065748306.7,
                                "netSales": 6259466.8
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 2.8803590094711793,
                                "grossSales": 40870838.67,
                                "competitorSales": 1378078623.38,
                                "globalSales": 1418949462.05,
                                "netSales": 7483981.4
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 2.8132740090958253,
                                "grossSales": 33220196.86,
                                "competitorSales": 1147617387.84,
                                "globalSales": 1180837584.7,
                                "netSales": 10941316.44
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 1.8233145535067392,
                                "grossSales": 30074152.08,
                                "competitorSales": 1619347886.6,
                                "globalSales": 1649422038.68,
                                "netSales": 5458483.6
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 4.9340571743976565,
                                "grossSales": 67034288.68,
                                "competitorSales": 1291569519.72,
                                "globalSales": 1358603808.4,
                                "netSales": 46205687.38
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 2.4961453897417676,
                                "grossSales": 27776283.67,
                                "competitorSales": 1084990776.46,
                                "globalSales": 1112767060.13,
                                "netSales": 6555200.06
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 2.4679024063009085,
                                "grossSales": 26958793.8,
                                "competitorSales": 1065418025.12,
                                "globalSales": 1092376818.92,
                                "netSales": 8516842.37
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 46,
                        "optionValue": "BD Field Metro DC",
                        "marketShare": 4.323830747076664,
                        "marketShareChange": 0.052895771302214456,
                        "grossSales": 118733267.11000001,
                        "competitorSales": 2627286964.8399997,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 3.9867256496694057,
                                "grossSales": 28038558.88,
                                "competitorSales": 675259368.89,
                                "globalSales": 703297927.77,
                                "netSales": -1633895.64
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 3.539382984465641,
                                "grossSales": 25172415.93,
                                "competitorSales": 686036742.29,
                                "globalSales": 711209158.22,
                                "netSales": -4252218.23
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 4.094364621654516,
                                "grossSales": 27493370.94,
                                "competitorSales": 643999607.35,
                                "globalSales": 671492978.29,
                                "netSales": -1373347.5
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 4.311570593365557,
                                "grossSales": 29018948.16,
                                "competitorSales": 644029249.28,
                                "globalSales": 673048197.44,
                                "netSales": -4748045.08
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 4.1667882863367405,
                                "grossSales": 30695415.08,
                                "competitorSales": 705973044.43,
                                "globalSales": 736668459.51,
                                "netSales": -1647074.59
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 5.158484282395457,
                                "grossSales": 47110440.66,
                                "competitorSales": 866150860.16,
                                "globalSales": 913261300.82,
                                "netSales": 2291247.26
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 4.941904070549017,
                                "grossSales": 43533760.61,
                                "competitorSales": 837376916.5,
                                "globalSales": 880910677.11,
                                "netSales": -4567545.37
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 4.4906695336532865,
                                "grossSales": 43760527.75,
                                "competitorSales": 930716160.46,
                                "globalSales": 974476688.21,
                                "netSales": 4931931.3
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 3.669330028568887,
                                "grossSales": 49110434.02,
                                "competitorSales": 1289292861.34,
                                "globalSales": 1338403295.36,
                                "netSales": 11185059.7
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 4.605099027460187,
                                "grossSales": 49596704.88,
                                "competitorSales": 1027398699.22,
                                "globalSales": 1076995404.1,
                                "netSales": 14487580.68
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 4.425731064027475,
                                "grossSales": 37295191.45,
                                "competitorSales": 805394771.19,
                                "globalSales": 842689962.64,
                                "netSales": 1493257.45
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.853325343099013,
                                "grossSales": 31841370.78,
                                "competitorSales": 794493494.43,
                                "globalSales": 826334865.21,
                                "netSales": 4056657.73
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 47,
                        "optionValue": "BD Field California North",
                        "marketShare": 3.24964838711426,
                        "marketShareChange": -0.15090006825144942,
                        "grossSales": 118563267.65,
                        "competitorSales": 3529932000.9500003,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 3.700903562736635,
                                "grossSales": 44455810.71,
                                "competitorSales": 1156759242.76,
                                "globalSales": 1201215053.47,
                                "netSales": 1197183.21
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 3.2574401076621884,
                                "grossSales": 34392731.96,
                                "competitorSales": 1021428121.94,
                                "globalSales": 1055820853.9,
                                "netSales": 1181498.09
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 3.2200945479852026,
                                "grossSales": 34484769.32,
                                "competitorSales": 1036439354.37,
                                "globalSales": 1070924123.69,
                                "netSales": 4582247.7
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 3.708716529308372,
                                "grossSales": 34045315.04,
                                "competitorSales": 883935737.73,
                                "globalSales": 917981052.77,
                                "netSales": -1396669.56
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 3.7101702789023197,
                                "grossSales": 36966114.47,
                                "competitorSales": 959379381.59,
                                "globalSales": 996345496.06,
                                "netSales": 8705507.77
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 3.743178481282478,
                                "grossSales": 44210745.89,
                                "competitorSales": 1136890986.53,
                                "globalSales": 1181101732.42,
                                "netSales": 20750991.97
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 3.2676825473410185,
                                "grossSales": 47254413.05,
                                "competitorSales": 1398859533.62,
                                "globalSales": 1446113946.67,
                                "netSales": 1959059.01
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 3.432784696843129,
                                "grossSales": 48568947.8,
                                "competitorSales": 1366286689.51,
                                "globalSales": 1414855637.31,
                                "netSales": 9025674.74
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 3.4926610400701765,
                                "grossSales": 55560082.04,
                                "competitorSales": 1535206425.29,
                                "globalSales": 1590766507.33,
                                "netSales": 10005115.06
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 2.5803199156193157,
                                "grossSales": 32840778.96,
                                "competitorSales": 1239899812.67,
                                "globalSales": 1272740591.63,
                                "netSales": 3426399.3
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 4.134184068716858,
                                "grossSales": 45967830.5,
                                "competitorSales": 1065928247.08,
                                "globalSales": 1111896077.58,
                                "netSales": 18929518.98
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.1454988880233548,
                                "grossSales": 39754658.19,
                                "competitorSales": 1224103941.2,
                                "globalSales": 1263858599.39,
                                "netSales": 11632044.36
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 48,
                        "optionValue": "BD Field New England South",
                        "marketShare": 4.908742122444739,
                        "marketShareChange": -0.9929044823789699,
                        "grossSales": 115515818.60000001,
                        "competitorSales": 2237751387.5099998,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 5.831177313853078,
                                "grossSales": 38416085.98,
                                "competitorSales": 620388884.48,
                                "globalSales": 658804970.46,
                                "netSales": 8356738.85
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 4.706552954652374,
                                "grossSales": 33511865.39,
                                "competitorSales": 678513808.45,
                                "globalSales": 712025673.84,
                                "netSales": 1904689.13
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 4.784303851474354,
                                "grossSales": 38501975.33,
                                "competitorSales": 766254087.94,
                                "globalSales": 804756063.27,
                                "netSales": 6153283.84
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 5.871846015666921,
                                "grossSales": 43105559.78,
                                "competitorSales": 691000199.55,
                                "globalSales": 734105759.33,
                                "netSales": 11247226.96
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 4.561862046343994,
                                "grossSales": 33495839.13,
                                "competitorSales": 700762207.03,
                                "globalSales": 734258046.16,
                                "netSales": 8585234.13
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 4.898128993542315,
                                "grossSales": 41434883.55,
                                "competitorSales": 804497994.18,
                                "globalSales": 845932877.73,
                                "netSales": -16815891.44
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 5.033004674770341,
                                "grossSales": 52320754.18,
                                "competitorSales": 987232307.28,
                                "globalSales": 1039553061.46,
                                "netSales": 16986873.3
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 5.946599723238885,
                                "grossSales": 58514367.52,
                                "competitorSales": 925482710.53,
                                "globalSales": 983997078.05,
                                "netSales": 6688129.54
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 6.7554661579660005,
                                "grossSales": 67945998.67,
                                "competitorSales": 937846896.76,
                                "globalSales": 1005792895.43,
                                "netSales": 33165255.26
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 4.998218445961466,
                                "grossSales": 41796070.92,
                                "competitorSales": 794423301.48,
                                "globalSales": 836219372.4,
                                "netSales": 11084425.58
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 4.710417512951339,
                                "grossSales": 35655949.73,
                                "competitorSales": 721303483.95,
                                "globalSales": 756959433.68,
                                "netSales": -26216930.72
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 5.007811979303678,
                                "grossSales": 38063797.95,
                                "competitorSales": 722024602.08,
                                "globalSales": 760088400.03,
                                "netSales": 4175820.79
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 49,
                        "optionValue": "BD Field Orange County",
                        "marketShare": 3.714236962619179,
                        "marketShareChange": -0.3795965138690014,
                        "grossSales": 112701352.02000001,
                        "competitorSales": 2921605644.39,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 2.903406704156218,
                                "grossSales": 26799089.39,
                                "competitorSales": 896223143.48,
                                "globalSales": 923022232.87,
                                "netSales": 5693059.9
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 3.804305245375203,
                                "grossSales": 33599233.68,
                                "competitorSales": 849590508.28,
                                "globalSales": 883189741.96,
                                "netSales": 15245665.7
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 3.671540150947228,
                                "grossSales": 27605617.34,
                                "competitorSales": 724275506.25,
                                "globalSales": 751881123.59,
                                "netSales": 7504814.01
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 3.5166907687771145,
                                "grossSales": 27904373.95,
                                "competitorSales": 765579494.4,
                                "globalSales": 793483868.35,
                                "netSales": 1365803.97
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 3.7633447522266383,
                                "grossSales": 30723436.07,
                                "competitorSales": 785662999.21,
                                "globalSales": 816386435.28,
                                "netSales": 12274536.6
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 6.459149531589933,
                                "grossSales": 60391430.5,
                                "competitorSales": 874583525.64,
                                "globalSales": 934974956.14,
                                "netSales": 40697974.54
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 4.021753890925345,
                                "grossSales": 42894039.48,
                                "competitorSales": 1023656541.27,
                                "globalSales": 1066550580.75,
                                "netSales": 13504498.88
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 4.436758883871799,
                                "grossSales": 50574467.2,
                                "competitorSales": 1089322212.42,
                                "globalSales": 1139896679.62,
                                "netSales": 11588698.05
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 3.854128799399429,
                                "grossSales": 50490676.23,
                                "competitorSales": 1259550551.19,
                                "globalSales": 1310041227.42,
                                "netSales": 17283152.18
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 3.9639008517918817,
                                "grossSales": 43914018.99,
                                "competitorSales": 1063934553.21,
                                "globalSales": 1107848572.2,
                                "netSales": 17984700.9
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 3.7682640381147645,
                                "grossSales": 34990733.43,
                                "competitorSales": 893573005.1,
                                "globalSales": 928563738.53,
                                "netSales": 13645782.28
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.3867902179446756,
                                "grossSales": 33796599.6,
                                "competitorSales": 964098086.08,
                                "globalSales": 997894685.68,
                                "netSales": 9438344.74
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 50,
                        "optionValue": "BD Field Metro Boston",
                        "marketShare": 4.168354355408391,
                        "marketShareChange": -1.5315762157218105,
                        "grossSales": 112271834.63,
                        "competitorSales": 2581161234.09,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 3.4408665579134343,
                                "grossSales": 25312886.57,
                                "competitorSales": 710341523.27,
                                "globalSales": 735654409.84,
                                "netSales": 3838925.62
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 4.236150080408582,
                                "grossSales": 30431060.06,
                                "competitorSales": 687934896.82,
                                "globalSales": 718365956.88,
                                "netSales": 17980939
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 4.958332549940335,
                                "grossSales": 34593945.8,
                                "competitorSales": 663099188.97,
                                "globalSales": 697693134.77,
                                "netSales": 18233870.6
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 3.2435424215787907,
                                "grossSales": 26542923.27,
                                "competitorSales": 791788389.23,
                                "globalSales": 818331312.5,
                                "netSales": 561256.39
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 3.878690664757861,
                                "grossSales": 27932702.24,
                                "competitorSales": 692225326.7,
                                "globalSales": 720158028.94,
                                "netSales": 12169913.13
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 3.6026935722388456,
                                "grossSales": 31209186.78,
                                "competitorSales": 835064509.67,
                                "globalSales": 866273696.45,
                                "netSales": 10542633.47
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 3.5635568793733556,
                                "grossSales": 38036598.57,
                                "competitorSales": 1029340739.79,
                                "globalSales": 1067377338.36,
                                "netSales": 13639522.45
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 7.344538526693639,
                                "grossSales": 65512766.3,
                                "competitorSales": 826480189.58,
                                "globalSales": 891992955.88,
                                "netSales": 35656256.77
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 6.505822475929623,
                                "grossSales": 65659347.2,
                                "competitorSales": 943580413.69,
                                "globalSales": 1009239760.89,
                                "netSales": 40189850.84
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 4.612186614596041,
                                "grossSales": 48643372.54,
                                "competitorSales": 1006027147.21,
                                "globalSales": 1054670519.75,
                                "netSales": 21202585.84
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 3.776745153054887,
                                "grossSales": 33532316.32,
                                "competitorSales": 854330511.62,
                                "globalSales": 887862827.94,
                                "netSales": 12951654.43
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 4.008011313243996,
                                "grossSales": 30096145.77,
                                "competitorSales": 720803575.26,
                                "globalSales": 750899721.03,
                                "netSales": 8217384.42
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 51,
                        "optionValue": "BD Field Metro San Francisco",
                        "marketShare": 3.1373896821300296,
                        "marketShareChange": -0.6350110509631106,
                        "grossSales": 108994849.59,
                        "competitorSales": 3365066731.31,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 2.4124366833408946,
                                "grossSales": 28993355.01,
                                "competitorSales": 1172835286.14,
                                "globalSales": 1201828641.15,
                                "netSales": -3782932.22
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 2.664430229748986,
                                "grossSales": 29624525.01,
                                "competitorSales": 1082227633.07,
                                "globalSales": 1111852158.08,
                                "netSales": 3809772.63
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 2.994068362228776,
                                "grossSales": 33143287.91,
                                "competitorSales": 1073821680.83,
                                "globalSales": 1106964968.74,
                                "netSales": 7875008.05
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 3.987940055782218,
                                "grossSales": 42371694.41,
                                "competitorSales": 1020124075.77,
                                "globalSales": 1062495770.18,
                                "netSales": 10781932.58
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 3.472330519462795,
                                "grossSales": 40196522.96,
                                "competitorSales": 1117427232.46,
                                "globalSales": 1157623755.42,
                                "netSales": 17635787.87
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 2.4895408213291574,
                                "grossSales": 35734779.24,
                                "competitorSales": 1399661617.31,
                                "globalSales": 1435396396.55,
                                "netSales": 4086099.64
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 4.393745356184716,
                                "grossSales": 63356906.1,
                                "competitorSales": 1378622566.17,
                                "globalSales": 1441979472.27,
                                "netSales": 33924700.32
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 2.921736317684492,
                                "grossSales": 47150394.65,
                                "competitorSales": 1566629547.25,
                                "globalSales": 1613779941.9,
                                "netSales": 6852343.09
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 4.082341547914105,
                                "grossSales": 62803536.56,
                                "competitorSales": 1475615917.64,
                                "globalSales": 1538419454.2,
                                "netSales": 26535729.22
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 3.423711352545728,
                                "grossSales": 42081419.26,
                                "competitorSales": 1187035609.8,
                                "globalSales": 1229117029.06,
                                "netSales": 12380839.2
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 3.0471464846787493,
                                "grossSales": 31507893.19,
                                "competitorSales": 1002505185.88,
                                "globalSales": 1034013079.07,
                                "netSales": -5194755.34
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 2.9238266521399434,
                                "grossSales": 35405537.14,
                                "competitorSales": 1175525935.63,
                                "globalSales": 1210931472.77,
                                "netSales": 4199606.35
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 52,
                        "optionValue": "BD Field Florida Central",
                        "marketShare": 3.3641921068614287,
                        "marketShareChange": -0.9910852053714954,
                        "grossSales": 108068997.72999999,
                        "competitorSales": 3104262352.48,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 3.432685170382874,
                                "grossSales": 33326501.27,
                                "competitorSales": 937531576.76,
                                "globalSales": 970858078.03,
                                "netSales": 74792.69
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 3.3487761612247042,
                                "grossSales": 31425047.79,
                                "competitorSales": 906978902.7,
                                "globalSales": 938403950.49,
                                "netSales": -4100453.53
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 3.4761148848712438,
                                "grossSales": 30440924.62,
                                "competitorSales": 845275949.77,
                                "globalSales": 875716874.39,
                                "netSales": 939719.72
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 2.9373235974743084,
                                "grossSales": 26067505.11,
                                "competitorSales": 861390217.71,
                                "globalSales": 887457722.82,
                                "netSales": -4799451.49
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 2.8757083053578953,
                                "grossSales": 24011468.82,
                                "competitorSales": 810964344.8,
                                "globalSales": 834975813.62,
                                "netSales": 456434.2
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 2.907786244426172,
                                "grossSales": 27010419.54,
                                "competitorSales": 901889343.7,
                                "globalSales": 928899763.24,
                                "netSales": -2584053.06
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 3.9846805128583065,
                                "grossSales": 47440317.96,
                                "competitorSales": 1143127352.57,
                                "globalSales": 1190567670.53,
                                "netSales": -2558223.56
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 5.201786786794662,
                                "grossSales": 68001855.28,
                                "competitorSales": 1239276933.09,
                                "globalSales": 1307278788.37,
                                "netSales": 27911642.61
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 3.8224096277464716,
                                "grossSales": 47731249.25,
                                "competitorSales": 1200990209.16,
                                "globalSales": 1248721458.41,
                                "netSales": 15651356.88
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 3.245782979832093,
                                "grossSales": 37284676.35,
                                "competitorSales": 1111426638.66,
                                "globalSales": 1148711315.01,
                                "netSales": 6638375.51
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 3.300141487147565,
                                "grossSales": 32682259.97,
                                "competitorSales": 957646794.02,
                                "globalSales": 990329053.99,
                                "netSales": 1080333.92
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.550021576352457,
                                "grossSales": 38102061.41,
                                "competitorSales": 1035188919.8,
                                "globalSales": 1073290981.21,
                                "netSales": 3996885.63
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 53,
                        "optionValue": "BD Field Long Island",
                        "marketShare": 3.7801534194159547,
                        "marketShareChange": 0.014733421678971403,
                        "grossSales": 103774884.72,
                        "competitorSales": 2641481013.8100004,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 3.2676152886086904,
                                "grossSales": 25928889.56,
                                "competitorSales": 767582196.35,
                                "globalSales": 793511085.91,
                                "netSales": -1469862.07
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 3.5348599093403306,
                                "grossSales": 26863131.87,
                                "competitorSales": 733085849.39,
                                "globalSales": 759948981.26,
                                "netSales": 5540150.28
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 2.9338614119306743,
                                "grossSales": 23815394.89,
                                "competitorSales": 787926931.9,
                                "globalSales": 811742326.79,
                                "netSales": -1615436.47
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 3.1203500850927997,
                                "grossSales": 24514168.62,
                                "competitorSales": 761108211.93,
                                "globalSales": 785622380.55,
                                "netSales": 2309764.39
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 3.807815981716594,
                                "grossSales": 29103841.84,
                                "competitorSales": 735214654.11,
                                "globalSales": 764318495.95,
                                "netSales": 8622278.4
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 5.187685037023682,
                                "grossSales": 52848254.36,
                                "competitorSales": 965876937.76,
                                "globalSales": 1018725192.12,
                                "netSales": 15704444.92
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 3.078866137141369,
                                "grossSales": 36960695.01,
                                "competitorSales": 1163503806,
                                "globalSales": 1200464501.01,
                                "netSales": -28921358.41
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 3.6974843976398755,
                                "grossSales": 41934455.55,
                                "competitorSales": 1092200297.71,
                                "globalSales": 1134134753.26,
                                "netSales": 6372663.05
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 4.588420691190389,
                                "grossSales": 50245765.79,
                                "competitorSales": 1044810009.86,
                                "globalSales": 1095055775.65,
                                "netSales": 18965305.56
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 2.8514307357620625,
                                "grossSales": 29748762.46,
                                "competitorSales": 1013543718.29,
                                "globalSales": 1043292480.75,
                                "netSales": -6626899.68
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 3.7159000124898847,
                                "grossSales": 32843976.62,
                                "competitorSales": 851032782.97,
                                "globalSales": 883876759.59,
                                "netSales": 10721246.76
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 5.033958838922352,
                                "grossSales": 41182145.64,
                                "competitorSales": 776904512.55,
                                "globalSales": 818086658.19,
                                "netSales": 18291369.5
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 54,
                        "optionValue": "BD Field Connecticut",
                        "marketShare": 3.3561301585710908,
                        "marketShareChange": 0.04696440562772031,
                        "grossSales": 99101736.22,
                        "competitorSales": 2853755618.46,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 3.5726857005187678,
                                "grossSales": 30308779.69,
                                "competitorSales": 818038436.68,
                                "globalSales": 848347216.37,
                                "netSales": 7728420.63
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 3.379249641009665,
                                "grossSales": 27958920.46,
                                "competitorSales": 799411751.44,
                                "globalSales": 827370671.9,
                                "netSales": -1052432.93
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 3.328054809816762,
                                "grossSales": 25755595.4,
                                "competitorSales": 748137770.9,
                                "globalSales": 773893366.3,
                                "netSales": 138414.22
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 2.933215011798103,
                                "grossSales": 24239163.51,
                                "competitorSales": 802129289.28,
                                "globalSales": 826368452.79,
                                "netSales": -5860213.86
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 3.758419672169417,
                                "grossSales": 31281210.44,
                                "competitorSales": 801015690.08,
                                "globalSales": 832296900.52,
                                "netSales": 12149033.91
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 2.898236946425644,
                                "grossSales": 29897787.13,
                                "competitorSales": 1001687541.56,
                                "globalSales": 1031585328.69,
                                "netSales": 8263449.49
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 3.0563253496816856,
                                "grossSales": 37434606.57,
                                "competitorSales": 1187389398.96,
                                "globalSales": 1224824005.53,
                                "netSales": -545471.96
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 4.104105999519033,
                                "grossSales": 48593371.38,
                                "competitorSales": 1135425057.62,
                                "globalSales": 1184018429,
                                "netSales": 15164575.77
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 2.839379598728208,
                                "grossSales": 38170105.07,
                                "competitorSales": 1306141345.47,
                                "globalSales": 1344311450.54,
                                "netSales": 8161355.19
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 3.6668572364247316,
                                "grossSales": 39906877.24,
                                "competitorSales": 1048405938.53,
                                "globalSales": 1088312815.77,
                                "netSales": 14869833.5
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 3.352824599038772,
                                "grossSales": 28098768.41,
                                "competitorSales": 809963813.75,
                                "globalSales": 838062582.16,
                                "netSales": 2238267.09
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.029385014078086,
                                "grossSales": 31096090.57,
                                "competitorSales": 995385866.18,
                                "globalSales": 1026481956.75,
                                "netSales": -5013931.72
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 55,
                        "optionValue": "BD Field San Diego",
                        "marketShare": 3.9891662739486806,
                        "marketShareChange": -0.8130351401848035,
                        "grossSales": 98018359.05000001,
                        "competitorSales": 2359095541.9199996,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 4.616213144664784,
                                "grossSales": 36550299.26,
                                "competitorSales": 755230715.06,
                                "globalSales": 791781014.32,
                                "netSales": 5303525.98
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 3.7586072361038996,
                                "grossSales": 27985107.43,
                                "competitorSales": 716575461.74,
                                "globalSales": 744560569.17,
                                "netSales": 9818335.78
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 5.550586448318842,
                                "grossSales": 41192774.5,
                                "competitorSales": 700940960.08,
                                "globalSales": 742133734.58,
                                "netSales": 22974003.55
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 7.066927775157369,
                                "grossSales": 47534069.85,
                                "competitorSales": 625093008.88,
                                "globalSales": 672627078.73,
                                "netSales": 28464259.83
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 4.262178011652002,
                                "grossSales": 28694714.94,
                                "competitorSales": 644545934.83,
                                "globalSales": 673240649.77,
                                "netSales": 11565457.64
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 4.317802737868708,
                                "grossSales": 37543028.64,
                                "competitorSales": 831950806.98,
                                "globalSales": 869493835.62,
                                "netSales": 2868594.28
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 4.959814046194204,
                                "grossSales": 40312655.31,
                                "competitorSales": 772472963.96,
                                "globalSales": 812785619.27,
                                "netSales": 12752475.66
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 5.12120179061335,
                                "grossSales": 46874518.8,
                                "competitorSales": 868428582.24,
                                "globalSales": 915303101.04,
                                "netSales": 728829.07
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 4.38563300214103,
                                "grossSales": 44226800.15,
                                "competitorSales": 964220558.04,
                                "globalSales": 1008447358.19,
                                "netSales": 9825913.95
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 4.284465267596381,
                                "grossSales": 38293585.89,
                                "competitorSales": 855483898.54,
                                "globalSales": 893777484.43,
                                "netSales": 11895212.89
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 3.9147943281585857,
                                "grossSales": 29034240.79,
                                "competitorSales": 712620067.36,
                                "globalSales": 741654308.15,
                                "netSales": 10178895.28
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.735085875258363,
                                "grossSales": 30690532.37,
                                "competitorSales": 790991576.02,
                                "globalSales": 821682108.39,
                                "netSales": 6606632.7
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 56,
                        "optionValue": "BD Field LA North",
                        "marketShare": 3.6550624514698837,
                        "marketShareChange": -0.6863856235281176,
                        "grossSales": 96099929.57000001,
                        "competitorSales": 2533128184.75,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 2.586874324065606,
                                "grossSales": 22673133.15,
                                "competitorSales": 853795156.75,
                                "globalSales": 876468289.9,
                                "netSales": 7574003.72
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 2.7105911809806047,
                                "grossSales": 21153593.94,
                                "competitorSales": 759251584.4,
                                "globalSales": 780405178.34,
                                "netSales": 6703593.67
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 3.026019294806468,
                                "grossSales": 23952146.74,
                                "competitorSales": 767587642.22,
                                "globalSales": 791539788.96,
                                "netSales": -3436958.26
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 2.4705574260261414,
                                "grossSales": 18704728.7,
                                "competitorSales": 738400874.39,
                                "globalSales": 757105603.09,
                                "netSales": -6802112.51
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 3.5829279723632124,
                                "grossSales": 25730196.13,
                                "competitorSales": 692403026.99,
                                "globalSales": 718133223.12,
                                "netSales": 8439831.88
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 3.997551019377467,
                                "grossSales": 36736771.2,
                                "competitorSales": 882245151.03,
                                "globalSales": 918981922.23,
                                "netSales": 22922219.12
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 4.195838230591488,
                                "grossSales": 37121560.06,
                                "competitorSales": 847601778.16,
                                "globalSales": 884723338.22,
                                "netSales": 12123757.09
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 3.524992946762315,
                                "grossSales": 32666743.78,
                                "competitorSales": 894051246.11,
                                "globalSales": 926717989.89,
                                "netSales": 7257621.4
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 5.162852067410558,
                                "grossSales": 55653947.48,
                                "competitorSales": 1022315104.38,
                                "globalSales": 1077969051.86,
                                "netSales": 30098514.87
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 3.3165981163777745,
                                "grossSales": 31401146.32,
                                "competitorSales": 915386653.05,
                                "globalSales": 946787799.37,
                                "netSales": 6816071.32
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 3.7193818770074714,
                                "grossSales": 31635239.88,
                                "competitorSales": 818915763.65,
                                "globalSales": 850551003.53,
                                "netSales": 10199472.82
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.9745123439032928,
                                "grossSales": 33063543.37,
                                "competitorSales": 798825768.05,
                                "globalSales": 831889311.42,
                                "netSales": 15548799.36
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 57,
                        "optionValue": "BD Field Carolina East",
                        "marketShare": 3.383979927721922,
                        "marketShareChange": -0.21609248634083444,
                        "grossSales": 93119030.33,
                        "competitorSales": 2658641686.9,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 4.211528249043308,
                                "grossSales": 31761778.98,
                                "competitorSales": 722401011.86,
                                "globalSales": 754162790.84,
                                "netSales": 8439084.83
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 3.817980942035341,
                                "grossSales": 32694152.04,
                                "competitorSales": 823626309.91,
                                "globalSales": 856320461.95,
                                "netSales": 6106972.84
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 2.815395312326753,
                                "grossSales": 26045907.31,
                                "competitorSales": 899078432.99,
                                "globalSales": 925124340.3,
                                "netSales": -4492489.96
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 4.1870416643034964,
                                "grossSales": 31356160.83,
                                "competitorSales": 717529647.91,
                                "globalSales": 748885808.74,
                                "netSales": 2321187.45
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 3.952754688541704,
                                "grossSales": 27606347.13,
                                "competitorSales": 670801454.65,
                                "globalSales": 698407801.78,
                                "netSales": 6149975.82
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 3.454903311052844,
                                "grossSales": 30648279.77,
                                "competitorSales": 856446871.98,
                                "globalSales": 887095151.75,
                                "netSales": 6518611.57
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 3.4147303451417423,
                                "grossSales": 40256096.81,
                                "competitorSales": 1138639240.19,
                                "globalSales": 1178895337,
                                "netSales": 5976405.81
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 3.818240912768346,
                                "grossSales": 42073448.38,
                                "competitorSales": 1059833145.29,
                                "globalSales": 1101906593.67,
                                "netSales": 14470945.76
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 3.5828406773220753,
                                "grossSales": 45539711.96,
                                "competitorSales": 1225510721.52,
                                "globalSales": 1271050433.48,
                                "netSales": 2726536.1
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 3.7319211104041106,
                                "grossSales": 35790294.86,
                                "competitorSales": 923241094.1,
                                "globalSales": 959031388.96,
                                "netSales": 6842692.43
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 3.1780019548740372,
                                "grossSales": 29031776.6,
                                "competitorSales": 884491154.23,
                                "globalSales": 913522930.83,
                                "netSales": 6086781.87
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.218465988463315,
                                "grossSales": 28296958.87,
                                "competitorSales": 850909438.57,
                                "globalSales": 879206397.44,
                                "netSales": -3748158.12
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 58,
                        "optionValue": "BD Field Metro Chicago",
                        "marketShare": 3.41562738856755,
                        "marketShareChange": -0.14495019629174077,
                        "grossSales": 86492933.87,
                        "competitorSales": 2445777833.12,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 3.5051869841209804,
                                "grossSales": 24706079.26,
                                "competitorSales": 680137324.87,
                                "globalSales": 704843404.13,
                                "netSales": 36036.03
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 4.325452448108087,
                                "grossSales": 35037410.22,
                                "competitorSales": 774991381.92,
                                "globalSales": 810028792.14,
                                "netSales": 10958783.09
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 2.97901338765994,
                                "grossSales": 20330755.98,
                                "competitorSales": 662135327.06,
                                "globalSales": 682466083.04,
                                "netSales": -3173872.01
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 2.0306330875168,
                                "grossSales": 16068025.32,
                                "competitorSales": 775213541.93,
                                "globalSales": 791281567.25,
                                "netSales": -11566428.46
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 3.554327127877567,
                                "grossSales": 26971541.23,
                                "competitorSales": 731865230.39,
                                "globalSales": 758836771.62,
                                "netSales": 11076668.72
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 2.606739439920946,
                                "grossSales": 28469570.68,
                                "competitorSales": 1063682956.88,
                                "globalSales": 1092152527.56,
                                "netSales": 9554723.02
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 3.243504192443776,
                                "grossSales": 36207731.38,
                                "competitorSales": 1080107501.52,
                                "globalSales": 1116315232.9,
                                "netSales": 2469382.97
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 3.6308354785643546,
                                "grossSales": 39444465.93,
                                "competitorSales": 1046929900.6,
                                "globalSales": 1086374366.53,
                                "netSales": 11718643.39
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 3.797059603254053,
                                "grossSales": 44577093.35,
                                "competitorSales": 1129412730.56,
                                "globalSales": 1173989823.91,
                                "netSales": -1518609.13
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 2.9598081099246962,
                                "grossSales": 27647384.29,
                                "competitorSales": 906446423.93,
                                "globalSales": 934093808.22,
                                "netSales": -1668107.46
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 4.330678612135336,
                                "grossSales": 35347878.95,
                                "competitorSales": 780872443.91,
                                "globalSales": 816220322.86,
                                "netSales": 10484291.89
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.0049838508825553,
                                "grossSales": 23497670.63,
                                "competitorSales": 758458965.28,
                                "globalSales": 781956635.91,
                                "netSales": 5768971.41
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 59,
                        "optionValue": "BD Field New Jersey South",
                        "marketShare": 3.099774578330924,
                        "marketShareChange": -0.24055508187934915,
                        "grossSales": 77465355.38,
                        "competitorSales": 2421598799.85,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 3.32164468320633,
                                "grossSales": 25829083.56,
                                "competitorSales": 751770148.85,
                                "globalSales": 777599232.41,
                                "netSales": 6103418.54
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 4.60344728330337,
                                "grossSales": 36510418.9,
                                "competitorSales": 756599975.4,
                                "globalSales": 793110394.3,
                                "netSales": 21445230.2
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 4.971303324007121,
                                "grossSales": 37988844.22,
                                "competitorSales": 726173825.89,
                                "globalSales": 764162670.11,
                                "netSales": 9229633.65
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 3.185276017330379,
                                "grossSales": 22332135.38,
                                "competitorSales": 678773051.69,
                                "globalSales": 701105187.07,
                                "netSales": 885576.16
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 3.492850274756255,
                                "grossSales": 24992631.25,
                                "competitorSales": 690544230.74,
                                "globalSales": 715536861.99,
                                "netSales": -1446670.52
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 3.6585825125096427,
                                "grossSales": 34799817.72,
                                "competitorSales": 916383259.36,
                                "globalSales": 951183077.08,
                                "netSales": 15332397.9
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 3.115699204163032,
                                "grossSales": 35160695.85,
                                "competitorSales": 1093340277.64,
                                "globalSales": 1128500973.49,
                                "netSales": 16437392.69
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 3.18606696292023,
                                "grossSales": 30684915.84,
                                "competitorSales": 932412099.92,
                                "globalSales": 963097015.76,
                                "netSales": -7943077.03
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 3.751883668947041,
                                "grossSales": 36653839.97,
                                "competitorSales": 940291161.64,
                                "globalSales": 976945001.61,
                                "netSales": 11262464.04
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 3.725731544060423,
                                "grossSales": 33611349.99,
                                "competitorSales": 868529601.19,
                                "globalSales": 902140951.18,
                                "netSales": 19024730.41
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 2.4564220781655344,
                                "grossSales": 19456165.37,
                                "competitorSales": 772596859.35,
                                "globalSales": 792053024.72,
                                "netSales": 1847557.9
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 3.031276427747584,
                                "grossSales": 24397840.02,
                                "competitorSales": 780472339.31,
                                "globalSales": 804870179.33,
                                "netSales": 468987.99
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 60,
                        "optionValue": "BD Field Metro LA",
                        "marketShare": 2.3002531067064638,
                        "marketShareChange": -1.6171864348253302,
                        "grossSales": 68311439.6,
                        "competitorSales": 2901424342.9900002,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 2.0152055156176036,
                                "grossSales": 17686012.05,
                                "competitorSales": 859942195.74,
                                "globalSales": 877628207.79,
                                "netSales": 2026286.84
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 1.8567012544178085,
                                "grossSales": 17366485.07,
                                "competitorSales": 917974352.81,
                                "globalSales": 935340837.88,
                                "netSales": 2778013.12
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 1.4694861477180652,
                                "grossSales": 16093043.78,
                                "competitorSales": 1079054658.36,
                                "globalSales": 1095147702.14,
                                "netSales": 5976479.87
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 1.6670322086499354,
                                "grossSales": 13504660.88,
                                "competitorSales": 796597316.15,
                                "globalSales": 810101977.03,
                                "netSales": 4181293.64
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 2.1407320569967307,
                                "grossSales": 13651064.85,
                                "competitorSales": 624031021.77,
                                "globalSales": 637682086.62,
                                "netSales": 4585434.74
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 1.9474048434946878,
                                "grossSales": 19857104.14,
                                "competitorSales": 999812956.06,
                                "globalSales": 1019670060.2,
                                "netSales": 9603828.78
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 2.2542048995632573,
                                "grossSales": 23391311.89,
                                "competitorSales": 1014283297.66,
                                "globalSales": 1037674609.55,
                                "netSales": 13531049.1
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 3.500937111994925,
                                "grossSales": 33332148.95,
                                "competitorSales": 918760044.76,
                                "globalSales": 952092193.71,
                                "netSales": 22570413.76
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 5.732914100261692,
                                "grossSales": 67022670.23,
                                "competitorSales": 1102062877.85,
                                "globalSales": 1169085548.08,
                                "netSales": 50755649.25
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 2.4574836046608644,
                                "grossSales": 21750597.88,
                                "competitorSales": 863325413.97,
                                "globalSales": 885076011.85,
                                "netSales": 4678231.33
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 2.2165771499809623,
                                "grossSales": 20935251.39,
                                "competitorSales": 923550321.34,
                                "globalSales": 944485572.73,
                                "netSales": 8446864.68
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 2.2475153686801153,
                                "grossSales": 25625590.33,
                                "competitorSales": 1114548607.68,
                                "globalSales": 1140174198.01,
                                "netSales": 13709021.24
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                },
                {
                    "line": {
                        "rank": 61,
                        "optionValue": "BD Field Metro NYC",
                        "marketShare": 1.2879642342626496,
                        "marketShareChange": -0.7223992505155035,
                        "grossSales": 59843193.34,
                        "competitorSales": 4586496491.26,
                        "salesTrend": [
                            {
                                "timeId": 24247,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 7,
                                "marketShare": 0.9545426464597304,
                                "grossSales": 16375136.87,
                                "competitorSales": 1699120439.02,
                                "globalSales": 1715495575.89,
                                "netSales": 3363987.39
                            },
                            {
                                "timeId": 24248,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 8,
                                "marketShare": 0.8891735825451388,
                                "grossSales": 13844111.73,
                                "competitorSales": 1543119792.93,
                                "globalSales": 1556963904.66,
                                "netSales": -2717848.34
                            },
                            {
                                "timeId": 24249,
                                "year": 2020,
                                "quarter": "2020/Q3",
                                "month": 9,
                                "marketShare": 0.97681303102154,
                                "grossSales": 13180858.26,
                                "competitorSales": 1336192854.15,
                                "globalSales": 1349373712.41,
                                "netSales": -10646312.39
                            },
                            {
                                "timeId": 24250,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 10,
                                "marketShare": 1.0834534252967005,
                                "grossSales": 14855524.24,
                                "competitorSales": 1356271641.28,
                                "globalSales": 1371127165.52,
                                "netSales": 3260978.85
                            },
                            {
                                "timeId": 24251,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 11,
                                "marketShare": 1.1641208297240335,
                                "grossSales": 16786976.03,
                                "competitorSales": 1425243404.44,
                                "globalSales": 1442030380.47,
                                "netSales": 912752.95
                            },
                            {
                                "timeId": 24252,
                                "year": 2020,
                                "quarter": "2020/Q4",
                                "month": 12,
                                "marketShare": 1.0072810231945137,
                                "grossSales": 23395120.11,
                                "competitorSales": 2299205978.42,
                                "globalSales": 2322601098.53,
                                "netSales": -2263677.63
                            },
                            {
                                "timeId": 24253,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 1,
                                "marketShare": 2.958715235319042,
                                "grossSales": 58436623.47,
                                "competitorSales": 1916630891.39,
                                "globalSales": 1975067514.86,
                                "netSales": 38728897.28
                            },
                            {
                                "timeId": 24254,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 2,
                                "marketShare": 1.2261587914843561,
                                "grossSales": 24439132.27,
                                "competitorSales": 1968706652.74,
                                "globalSales": 1993145785.01,
                                "netSales": 8819986
                            },
                            {
                                "timeId": 24255,
                                "year": 2021,
                                "quarter": "2021/Q1",
                                "month": 3,
                                "marketShare": 1.8495501412843716,
                                "grossSales": 35656604.37,
                                "competitorSales": 1892196205.57,
                                "globalSales": 1927852809.94,
                                "netSales": 18326460.77
                            },
                            {
                                "timeId": 24256,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 4,
                                "marketShare": 1.334818261224249,
                                "grossSales": 21496927.89,
                                "competitorSales": 1588979083.3,
                                "globalSales": 1610476011.19,
                                "netSales": 3104589.2
                            },
                            {
                                "timeId": 24257,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 5,
                                "marketShare": 1.331812784191442,
                                "grossSales": 20873308.46,
                                "competitorSales": 1546412176.99,
                                "globalSales": 1567285485.45,
                                "netSales": 1195667.07
                            },
                            {
                                "timeId": 24258,
                                "year": 2021,
                                "quarter": "2021/Q2",
                                "month": 6,
                                "marketShare": 1.1897873149179519,
                                "grossSales": 17472956.99,
                                "competitorSales": 1451105230.97,
                                "globalSales": 1468578187.96,
                                "netSales": -764117.39
                            }
                        ]
                    },
                    "strings": {
                        "templates.managementReport.butterfly.label": "Butterfly",
                        "templates.managementReport.butterfly.averageTemplate": "Average: {0}",
                        "templates.managementReport.close": "Close",
                        "templates.metrics.competitive": "Competitive Sales",
                        "templates.metrics.competitive.small": "Comp. Sales",
                        "templates.managementreport.filters.channels.topBarButton": "Channels",
                        "templates.managementreport.filters.channels.chartTitle": "Channels Overview",
                        "templates.managementreport.filters.channels.dimensionName": "Channel",
                        "templates.managementreport.filters.divisions.topBarButton": "Divisions",
                        "templates.managementreport.filters.divisions.chartTitle": "Divisions Overview",
                        "templates.managementreport.filters.divisions.dimensionName": "Division",
                        "templates.managementreport.filters.firms.topBarButton": "Firms",
                        "templates.managementreport.filters.firms.chartTitle": "Firms Overview",
                        "templates.managementreport.filters.firms.dimensionName": "Firm",
                        "templates.managementreport.filters.channels.noData": "There are no Channels for your filters",
                        "templates.managementreport.filters.divisions.noData": "There are no Divisions for your filters",
                        "templates.managementreport.filters.firms.noData": "There are no Firms for your filters",
                        "templates.managementreport.filters.products.noData": "There are no Products for your filters",
                        "templates.managementreport.filters.summary.noData": "There is no data for this report, please contact DST",
                        "templates.managementreport.filters.territories.noData": "There are no Territories for your filters",
                        "templates.managementreport.filters.products.topBarButton": "Products",
                        "templates.managementreport.filters.products.chartTitle": "Products Overview",
                        "templates.managementreport.filters.products.dimensionName": "Product",
                        "templates.managementreport.filters.summary.topBarButton": "Summary",
                        "templates.managementreport.filters.summary.chartTitle": "Market Share Summary",
                        "templates.managementreport.filters.territories.topBarButton": "Territories",
                        "templates.managementreport.filters.territories.chartTitle": "Territories Overview",
                        "templates.managementreport.filters.territories.dimensionName": "Territory",
                        "templates.managementReport.focusby.focusFirms": "Focus Firms",
                        "templates.managementReport.focusby.focusProducts": "Focus Products",
                        "templates.managementReport.geographical.label": "Map",
                        "templates.managementReport.geographical.legendOptionTitle": "{0}% Opacity",
                        "templates.managementReport.geographical.legendTitle": "{0} Growth",
                        "templates.managementReport.geographical.notConfigured": "Map not properly configured for your company, please contact DST.",
                        "templates.managementReport.geographical.zoomInTip": "To see the {0} data, please zoom in",
                        "templates.metrics.grossSales": "Client Sales",
                        "templates.metrics.sales.vs.competitor": "Gross Sales vs. Competitive Sales",
                        "templates.metrics.sales.vs.marketshare": "Gross Sales vs. MarketShare",
                        "templates.managementReport.heatmap.label": "Heatmap",
                        "templates.managementReport.summary.rankLastQuarterReference": " from {0}",
                        "templates.managementReport.listView": "List View",
                        "templates.metrics.marketshare.vs.competitor": "MarketShare vs. Competitive Sales",
                        "templates.metrics.marketShare": "Market Share",
                        "templates.managementReport.timeframe.mostRecent2Quarters": "Most Recent 2 Quarters",
                        "templates.managementReport.timeframe.mostRecentQuarter": "Most Recent Quarter",
                        "templates.metrics.netSales": "Net Sales",
                        "templates.generic.notAvailable": "N/A",
                        "templates.numbers.ordinalSuffixes": "[\"th\",\"st\",\"nd\",\"rd\",\"th\",\"th\",\"th\",\"th\",\"th\",\"th\"]",
                        "templates.managementReport.focusby.productsAvailable": "Products Available",
                        "templates.managementReport.rank.label": "Rank",
                        "templates.managementReport.rank.market.share.subtitle": "Compared to other Asset Managers",
                        "templates.managementReport.rank.market.share.title": "Market Share Rank",
                        "templates.managementReport.summary.rankOfCompaniesTemplate": "Rank out of {0}",
                        "templates.managementReport.summary.rankOfCompaniesTemplate.small": "out of {0}",
                        "templates.managementReport.timeframe.rolling12": "Rolling 12 months",
                        "templates.managementReport.scatterplot.label": "Scatter Plot",
                        "templates.managementReport.scatterplot.plotline.averageTemplate": "Average = {0}",
                        "templates.managementreport.summary.allproductsallfirms.title": "Overall",
                        "templates.managementreport.summary.channels.title": "Channels Overview",
                        "templates.managementreport.summary.firms.title": "Firms Overview",
                        "templates.managementreport.summary.focusFirms.title": "Focus Firms",
                        "templates.managementreport.summary.focusProducts.title": "Focus Products",
                        "templates.managementreport.summary.focusProductsAndFirms.title": "Focus Firms & Focus Products",
                        "templates.managementReport.summary.dataPeriodComparison": "Comparing {0} with {1}",
                        "templates.managementReport.summary.dataPeriodReference": "Showing data from {0}",
                        "templates.managementreport.summary.products.title": "Products Overview",
                        "templates.managementreport.summary.productsAvailable.title": "Products Available",
                        "templates.managementreport.summary.territories.title": "Territory Overview",
                        "templates.managementReport.timeframe.YTD": "YTD"
                    },
                    "rendered": false,
                    "lineContent": null,
                    "renderedLine": {},
                    "lineHtml": {
                        "0": {},
                        "length": 1
                    }
                }
            ];
        }
        MockData.prototype.getMockDataTable = function () {
            return this.mockDataTable;
        };
        MockData.prototype.getMockData = function () {
            return this.mockData;
        };
        MockData.prototype.getMockDataAnalytics1 = function () {
            return this.mockDataAnalytics1;
        };
        MockData.prototype.getMockDataAnalytics2 = function () {
            return this.mockDataAnalytics2;
        };
        MockData.prototype.getMockDataAnalytics3 = function () {
            return this.mockDataAnalytics3;
        };
        MockData.prototype.getRankingsMockDataNew = function () {
            return this.mockDataRankingsNew;
        };
        MockData.prototype.getRankingsTrendsMockData = function () {
            return this.mockDataRankingsTrends;
        };
        MockData.prototype.getManagerRankMockData = function () {
            return this.managerRankMockData;
        };
        MockData.prototype.getKeySalesDriversMockData = function () {
            return this.mockDataKeySalesDrivers;
        };
        MockData.prototype.getSalesTrendsMockData = function () {
            return this.mockDataSalesTrends;
        };
        MockData.prototype.getPlatformMockData = function () {
            return this.mockDataPlatformBreakdown;
        };
        MockData.prototype.getPlatformGreenRedSpaceMockData = function () {
            return this.platformGreenRedSpaceMockData;
        };
        MockData.prototype.getScatterPlotMockData = function () {
            return this.scatterplotMockData.result;
        };
        MockData.prototype.getOptionsMockData = function () {
            return this.optionsMockData.options;
        };
        MockData.prototype.getAnalyticsOptionsMockData = function () {
            return this.analyticsOptionsMockData.options;
        };
        MockData.prototype.getOpportunitiesMockData = function () {
            return this.opportunitiesMockData;
        };
        MockData.prototype.getAnalyticstableMockData = function () {
            return this.analyticstableMockData;
        };
        return MockData;
    }());
    CompInsights.MockData = MockData;
})(CompInsights || (CompInsights = {}));
///<reference path="00.data_types.ts" />
///<reference path="02.data_manager.ts" />
///<reference path="05.parser.ts" />
var CompInsights;
(function (CompInsights) {
    var Service = (function () {
        function Service() {
            this.dataManager = new CompInsights.DataManager();
            this.parser = new CompInsights.Parser();
            this.scatterplotParser = new CompInsights.scatterplotParser();
        }
        Service.prototype.getOpportunityScores = function (firmPageNumber, productPageNumber) {
            return this.dataManager.getOpportunityScores(firmPageNumber, productPageNumber);
        };
        Service.prototype.getProductsAndFirmsCount = function () {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.dataManager.getProductsAndFirmsCount().then(function (result) {
                deferred.resolveWith(window, [_this.parser.getProductsAndFirmsCount(result)]);
            });
            return promise;
        };
        Service.prototype.getSalesTrends = function (firmName, category, portfolio) {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.dataManager.getSalesTrends(firmName, category, portfolio).then(function (result) {
                deferred.resolveWith(window, [_this.parser.getSalesTrendsData(result)]);
            });
            return promise;
        };
        Service.prototype.getKeySalesDrivers = function (firmName, category, portfolio) {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.dataManager.getKeySalesDrivers(firmName, category, portfolio).then(function (result) {
                deferred.resolveWith(window, [_this.parser.getKeySalesDriversData(result)]);
            });
            return promise;
        };
        Service.prototype.getOpportunities = function (firmName, category, portfolio) {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.dataManager.getOpportunities(firmName, category, portfolio).then(function (result) {
                deferred.resolveWith(window, [_this.parser.getOpportunitiesData(result)]);
            });
            return promise;
        };
        Service.prototype.getPlatformBreakdown = function (firmName, category, portfolio) {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.dataManager.getPlatformBreakdown(firmName, category, portfolio).then(function (result) {
                deferred.resolveWith(window, [_this.parser.getPlatformBreakdownData(result)]);
            });
            return promise;
        };
        Service.prototype.getRanksByQuarter = function (productPortfolio, firmName) {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                productPortfolio: productPortfolio,
                firmName: firmName
            };
            this.dataManager.getRanksByQuarter(payload).then(function (result) {
                deferred.resolveWith(window, [_this.parser.getRanksByQuarter(result)]);
            });
            return promise;
        };
        Service.prototype.getQuarterInfo = function () {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.dataManager.getQuarterInfo().then(function (result) {
                deferred.resolveWith(window, [_this.parser.getQuarterInfo(result)]);
            });
            return promise;
        };
        Service.prototype.getAssetManagerRanksByType = function (productPortfolio, firmName, category) {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                productPortfolio: productPortfolio,
                firmName: firmName,
                category: category
            };
            this.dataManager.getAssetManagerRanksByType(payload).then(function (result) {
                deferred.resolveWith(window, [_this.parser.getAssetManagerRanksByType(result)]);
            });
            return promise;
        };
        Service.prototype.getPlatformCodes = function (productPortfolio, firmName) {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                productPortfolio: productPortfolio,
                firmName: firmName
            };
            this.dataManager.getPlatformCodes(payload).then(function (result) {
                deferred.resolveWith(window, [_this.parser.getPlatformCodes(result)]);
            });
            return promise;
        };
        Service.prototype.getCompInsightsTabInfo = function (productPortfolio, firmName, category) {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                productPortfolio: productPortfolio,
                firmName: firmName,
                category: category
            };
            this.dataManager.getCompInsightsTabInfo(payload).then(function (result) {
                deferred.resolveWith(window, [_this.parser.getTabsEnableInfo(result)]);
            });
            return promise;
        };
        Service.prototype.getScatterPlotData = function (firmName, productPortfolio, xAxis, yAxis) {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                productPortfolio: productPortfolio,
                firmName: firmName
            };
            this.dataManager.getScatterPlotTerritoryData(payload).then(function (result) {
                deferred.resolveWith(window, [_this.scatterplotParser.parser(result, xAxis, yAxis)]);
            });
            return promise;
        };
        Service.prototype.getScatterPlotOfficeData = function (firmName, productPortfolio, territory, xAxis, yAxis) {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            var payload = {
                firmName: firmName,
                productPortfolio: productPortfolio,
                territory: territory
            };
            this.dataManager.getScatterPlotOfficeData(payload).then(function (result) {
                deferred.resolveWith(window, [_this.scatterplotParser.parser(result, xAxis, yAxis)]);
            });
            return promise;
        };
        Service.prototype.getPDFLogoData = function () {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.dataManager.getPDFLogoData().then(function (result) {
                deferred.resolveWith(window, [_this.parser.getProductFamilyNames(result)]);
            }).fail(function (error) {
                //console.log(error);
            });
            return promise;
        };
        Service.prototype.getAnalyticsData = function (firmName, category, portfolio) {
            var _this = this;
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.dataManager.getAnalyticsData(firmName, category, portfolio).then(function (result) {
                deferred.resolveWith(window, [_this.parser.getAnalyticsParser(result)]);
            });
            return promise;
        };
        Service.prototype.getZippedExcelFile = function (firmName, category, territories, exportCategory, exportType, exportNumber) {
            var deferred = jQuery.Deferred();
            var promise = deferred.promise();
            this.dataManager.getZippedExcelFile(firmName, category, territories, exportCategory, exportType, exportNumber).then(function (result) {
                deferred.resolveWith(window, [result]);
            });
            return promise;
        };
        return Service;
    }());
    CompInsights.Service = Service;
})(CompInsights || (CompInsights = {}));
///<reference path="00.data_types.ts" />
var CompInsights;
(function (CompInsights) {
    (function (DataPositionEnum) {
        DataPositionEnum[DataPositionEnum["DIMENSION"] = 0] = "DIMENSION";
        DataPositionEnum[DataPositionEnum["CLIENT_GROSS_SALES"] = 1] = "CLIENT_GROSS_SALES";
        DataPositionEnum[DataPositionEnum["CLIENT_NET_SALES"] = 2] = "CLIENT_NET_SALES";
        DataPositionEnum[DataPositionEnum["GLOBAL_GROSS_SALES"] = 3] = "GLOBAL_GROSS_SALES";
        DataPositionEnum[DataPositionEnum["GLOBAL_NET_SALES"] = 4] = "GLOBAL_NET_SALES";
        DataPositionEnum[DataPositionEnum["MARKET_SHARE"] = 5] = "MARKET_SHARE";
        DataPositionEnum[DataPositionEnum["CLIENT_AUM"] = 6] = "CLIENT_AUM";
        DataPositionEnum[DataPositionEnum["AUM_INDUSTRY"] = 7] = "AUM_INDUSTRY";
        DataPositionEnum[DataPositionEnum["EXPECTED_SALES"] = 8] = "EXPECTED_SALES";
        DataPositionEnum[DataPositionEnum["AUM_GREEN_SPACE"] = 9] = "AUM_GREEN_SPACE";
        DataPositionEnum[DataPositionEnum["SALES_GREEN_SPACE"] = 10] = "SALES_GREEN_SPACE";
    })(CompInsights.DataPositionEnum || (CompInsights.DataPositionEnum = {}));
    var DataPositionEnum = CompInsights.DataPositionEnum;
    (function (ContentDataPosition) {
        ContentDataPosition[ContentDataPosition["TERRITORY_NAME"] = 0] = "TERRITORY_NAME";
        ContentDataPosition[ContentDataPosition["PERCENT_DIFFERENCE"] = 1] = "PERCENT_DIFFERENCE";
        ContentDataPosition[ContentDataPosition["DOLLAR_DIFFERENCE"] = 2] = "DOLLAR_DIFFERENCE";
        ContentDataPosition[ContentDataPosition["EXPECTED_SALES"] = 3] = "EXPECTED_SALES";
        ContentDataPosition[ContentDataPosition["ACTUAL_SALES"] = 4] = "ACTUAL_SALES";
        ContentDataPosition[ContentDataPosition["GLOBAL_SALES"] = 5] = "GLOBAL_SALES";
        ContentDataPosition[ContentDataPosition["MARKET_SHARE"] = 6] = "MARKET_SHARE";
        ContentDataPosition[ContentDataPosition["SALES_GREEN_SPACE"] = 7] = "SALES_GREEN_SPACE";
        ContentDataPosition[ContentDataPosition["AUM_GREEN_SPACE"] = 8] = "AUM_GREEN_SPACE";
        ContentDataPosition[ContentDataPosition["CLIENT_SALES"] = 9] = "CLIENT_SALES";
    })(CompInsights.ContentDataPosition || (CompInsights.ContentDataPosition = {}));
    var ContentDataPosition = CompInsights.ContentDataPosition;
    var Parser = (function () {
        function Parser() {
        }
        Parser.prototype.getCompetitiveDataList = function (results) {
            var competitiveDataList = [];
            if (results.statusCode == 200) {
                var rows = results.data;
                rows.forEach(function (row) {
                    competitiveDataList.push(row);
                });
            }
            return competitiveDataList;
        };
        Parser.prototype.getKeySalesDriversData = function (results) {
            if (results.statusCode == 200) {
                var data = results.data;
                if (data === 'null' || data === undefined || data.length === 0)
                    return null;
                var keySalesDriversDataList_1 = [];
                data.forEach(function (row) {
                    var keySalesDriversData = {
                        platform: row.platform,
                        keyDrivers: row.keyDrivers,
                        largestAdvantage: row.largestAdvantage,
                        analyticsMatchups: row.analyticsMatchups
                    };
                    keySalesDriversDataList_1.push(keySalesDriversData);
                });
                return keySalesDriversDataList_1;
            }
            return null;
        };
        Parser.prototype.getOpportunitiesData = function (results) {
            if (results.statusCode == 200) {
                var data = results.data;
                if (data === 'null' || data === undefined || data.length === 0)
                    return null;
                var opportunitiesDataList_1 = [];
                data.forEach(function (row) {
                    var opportunitiesData = {
                        opp_morningstar_product_category: row.morningstar_product_category,
                        opp_assigned_territory_name: row.assigned_territory_name,
                        opp_market_share_diff: row.diff_marketshare,
                        opp_percent_diff_expected_sales: row.percent_diff_expected_sales,
                        opp_expected_sales: row.expected_sales,
                        opp_actual_sales: row.actual_sales,
                        opp_industry_gross_sales: row.industry_gross_sales,
                        opp_market_share: row.market_share,
                        opp_sales_green_sapce: row.sales_green_sapce,
                        opp_net_sales: row.net_sales,
                        opp_industry_net_sales: row.industry_net_sales
                    };
                    opportunitiesDataList_1.push(opportunitiesData);
                });
                return opportunitiesDataList_1;
            }
            return null;
        };
        Parser.prototype.getAnalyticsParser = function (data) {
            var result = new Array();
            data.rows
                .forEach(function (line) {
                var obj = {
                    territoryName: line[ContentDataPosition.TERRITORY_NAME],
                    percentDifference: Number(line[ContentDataPosition.PERCENT_DIFFERENCE]),
                    dollarDifference: Number(line[ContentDataPosition.DOLLAR_DIFFERENCE]),
                    expectedSales: Number(line[ContentDataPosition.EXPECTED_SALES]),
                    actualSales: Number(line[ContentDataPosition.ACTUAL_SALES]),
                    globalSales: Number(line[ContentDataPosition.GLOBAL_SALES]),
                    marketShare: Number(line[ContentDataPosition.MARKET_SHARE]),
                    salesGreenSpace: Number(line[ContentDataPosition.SALES_GREEN_SPACE]),
                    aumGreenSpace: Number(line[ContentDataPosition.AUM_GREEN_SPACE]),
                    clientSales: Number(line[ContentDataPosition.CLIENT_SALES])
                };
                result.push(obj);
            });
            return result;
        };
        Parser.prototype.displayQuarterStr = function (origQuarter) {
            var newQuarter;
            var strArr = origQuarter.split("-");
            if (strArr.length > 1) {
                newQuarter = strArr[1] + " " + strArr[0];
            }
            else {
                newQuarter = origQuarter;
            }
            return newQuarter;
        };
        Parser.prototype.getSalesTrendsData = function (results) {
            var _this = this;
            var salesTrendsData = {
                quarters: [],
                marketShareData: [],
                salesConcentrationDataList: []
            };
            if (results.statusCode == 200) {
                var rows = results.data;
                var marketShareData_1 = [];
                salesTrendsData.salesConcentrationDataList = [];
                salesTrendsData.quarters = [];
                var topThreeDataList_1 = {
                    label: 'Top 3',
                    salesDataList: []
                };
                var topFiveDataList_1 = {
                    label: 'Top 5',
                    salesDataList: []
                };
                var topTenDataList_1 = {
                    label: 'Top 10',
                    salesDataList: []
                };
                var topTwentyDataList_1 = {
                    label: 'Top 20',
                    salesDataList: []
                };
                var allDataList_1 = {
                    label: 'All',
                    salesDataList: []
                };
                rows.forEach(function (row) {
                    var quarterStr = _this.displayQuarterStr(row.quarter);
                    salesTrendsData.quarters.push(quarterStr);
                    var m = {
                        quarter: row.quarter,
                        industrySales: row.industry_sales,
                        marketShare: row.market_share * 100
                    };
                    marketShareData_1.push(m);
                    var topThree = {
                        quarter: quarterStr,
                        totalSales: row.top3_sales,
                        percentTotalSales: row.top3_percent * 100,
                        totalAum: row.top3_aum,
                        percentAum: row.top3_aum_percent * 100,
                        netSales: row.top3_net_sales
                    };
                    topThreeDataList_1.salesDataList.push(topThree);
                    var topFive = {
                        quarter: quarterStr,
                        totalSales: row.top5_sales,
                        percentTotalSales: row.top5_percent * 100,
                        totalAum: row.top5_aum,
                        percentAum: row.top5_aum_percent * 100,
                        netSales: row.top5_net_sales
                    };
                    topFiveDataList_1.salesDataList.push(topFive);
                    var topTen = {
                        quarter: quarterStr,
                        totalSales: row.top10_sales,
                        percentTotalSales: row.top10_percent * 100,
                        totalAum: row.top10_aum,
                        percentAum: row.top10_aum_percent * 100,
                        netSales: row.top10_net_sales
                    };
                    topTenDataList_1.salesDataList.push(topTen);
                    var topTwenty = {
                        quarter: quarterStr,
                        totalSales: row.top20_sales,
                        percentTotalSales: row.top20_percent * 100,
                        totalAum: row.top20_aum,
                        percentAum: row.top20_aum_percent * 100,
                        netSales: row.top20_net_sales
                    };
                    topTwentyDataList_1.salesDataList.push(topTwenty);
                    var all = {
                        quarter: quarterStr,
                        totalSales: row.all_sales,
                        percentTotalSales: row.all_percent * 100,
                        totalAum: row.all_aum,
                        percentAum: row.all_aum_percent * 100,
                        netSales: row.all_net_sales
                    };
                    allDataList_1.salesDataList.push(all);
                });
                salesTrendsData.marketShareData = marketShareData_1;
                salesTrendsData.salesConcentrationDataList.push(topThreeDataList_1);
                salesTrendsData.salesConcentrationDataList.push(topFiveDataList_1);
                salesTrendsData.salesConcentrationDataList.push(topTenDataList_1);
                salesTrendsData.salesConcentrationDataList.push(topTwentyDataList_1);
                salesTrendsData.salesConcentrationDataList.push(allDataList_1);
            }
            return salesTrendsData;
        };
        Parser.prototype.getProductsAndFirmsCount = function (result) {
            var columns = result.cols;
            var rows = result.rows;
            var productCountIndex = columns.indexOf(Parser.PRODUCT_COUNT_INDEX);
            var firmCountIndex = columns.indexOf(Parser.FIRM_COUNT_INDEX);
            var result = {
                productCount: 0,
                firmCount: 0
            };
            rows.forEach(function (row) {
                result.productCount = row[productCountIndex];
                result.firmCount = row[firmCountIndex];
            });
            return result;
        };
        Parser.prototype.getRanksByQuarter = function (result) {
            var columns = result.cols;
            var rows = result.rows;
            var quarterIndex = columns.indexOf(Parser.QUARTER);
            var grossSalesRankIndex = columns.indexOf(Parser.GROSS_SALES_RANK);
            var netSalesRankIndex = columns.indexOf(Parser.NET_SALES_RANK);
            var aumRankIndex = columns.indexOf(Parser.AUM_RANK);
            var results = [];
            rows.forEach(function (row) {
                var quarterArr = row[quarterIndex].split('-');
                var ranks = {
                    quarter: quarterArr[1] + ' ' + quarterArr[0],
                    grossSalesRank: row[grossSalesRankIndex] === null ? '--' : row[grossSalesRankIndex],
                    netSalesRank: row[netSalesRankIndex] === null ? '--' : row[netSalesRankIndex],
                    aumRank: row[aumRankIndex] === null ? '--' : row[aumRankIndex]
                };
                results.push(ranks);
            });
            return results;
        };
        Parser.prototype.getQuarterInfo = function (result) {
            var columns = result.cols;
            var rows = result.rows;
            var quarterIndex = columns.indexOf(Parser.QUARTER);
            var results = [];
            rows.forEach(function (row) {
                var quarterArr = row[quarterIndex].split('-');
                var quarter = quarterArr[1] + ' ' + quarterArr[0];
                results.push(quarter);
            });
            return results;
        };
        Parser.prototype.getAssetManagerRanksByType = function (result) {
            var columns = result.cols;
            var rows = result.rows;
            var grossSalesRanks = [];
            var netSalesRanks = [];
            var aumRanks = [];
            rows.forEach(function (row) {
                var ranks = {
                    currentQuarterRank: row[1] === null ? '--' : row[1],
                    assetManager: row[0],
                    prevQuarterRank: row[2] === null ? '--' : row[2],
                    prevPrevQuarterRank: row[3] === null ? '--' : row[3],
                    rankType: 'gross_sales_rank'
                };
                grossSalesRanks.push(ranks);
                ranks = {
                    currentQuarterRank: row[4] === null ? '--' : row[4],
                    assetManager: row[0],
                    prevQuarterRank: row[5] === null ? '--' : row[5],
                    prevPrevQuarterRank: row[6] === null ? '--' : row[6],
                    rankType: 'net_sales_rank'
                };
                netSalesRanks.push(ranks);
                ranks = {
                    currentQuarterRank: row[7] === null ? '--' : row[7],
                    assetManager: row[0],
                    prevQuarterRank: row[8] === null ? '--' : row[8],
                    prevPrevQuarterRank: row[9] === null ? '--' : row[9],
                    rankType: 'aum_rank'
                };
                aumRanks.push(ranks);
            });
            grossSalesRanks = grossSalesRanks.sort(function (ranks1, ranks2) { return ranks1.currentQuarterRank - ranks2.currentQuarterRank; });
            netSalesRanks = netSalesRanks.sort(function (ranks1, ranks2) { return ranks1.currentQuarterRank - ranks2.currentQuarterRank; });
            aumRanks = aumRanks.sort(function (ranks1, ranks2) { return ranks1.currentQuarterRank - ranks2.currentQuarterRank; });
            var results = {
                grossSalesRank: grossSalesRanks,
                netSalesRank: netSalesRanks,
                aumRank: aumRanks
            };
            return results;
        };
        Parser.prototype.getPlatformBreakdownData = function (results) {
            var _this = this;
            if (results.statusCode == 200) {
                var rows = results.data;
                var platformData_1 = {
                    gross: [],
                    net: [],
                    aum: []
                };
                rows.forEach(function (row) {
                    var platformtype = _this.getPlatformTypeByAbbr(row.dst_platform_type);
                    var platformGrossSalesObj = {
                        platform: platformtype,
                        clientSales: _this.isEmptyOrNull(row.client_gross_sales) ? 0 : Math.round(parseFloat(row.client_gross_sales)),
                        globalSales: _this.isEmptyOrNull(row.global_gross_sales) ? 0 : Math.round(parseFloat(row.global_gross_sales)),
                        marketShare: _this.isEmptyOrNull(row.sales_market_share) ? 0 : parseFloat(row.sales_market_share),
                        greenSpace: _this.isEmptyOrNull(row.sales_green_space) ? 0 : Math.round(parseFloat(row.sales_green_space)),
                        competitiveSales: _this.isEmptyOrNull(row.competitive_sales) ? 0 : Math.round(parseFloat(row.competitive_sales)),
                        rank: _this.isEmptyOrNull(row.rank_gross_current) ? 0 : parseInt(row.rank_gross_current),
                        previousRank: _this.isEmptyOrNull(row.rank_gross_previous) ? 0 : parseInt(row.rank_gross_previous),
                        products: _this.isEmptyOrNull(row.sales_products) ? 0 : parseInt(row.sales_products)
                    };
                    platformData_1.gross.push(platformGrossSalesObj);
                    var platformNetSalesObj = {
                        platform: platformtype,
                        clientSales: _this.isEmptyOrNull(row.client_gross_net) ? 0 : Math.round(parseFloat(row.client_gross_net)),
                        globalSales: _this.isEmptyOrNull(row.global_gross_net) ? 0 : Math.round(parseFloat(row.global_gross_net)),
                        rank: _this.isEmptyOrNull(row.rank_net_current) ? 0 : parseInt(row.rank_net_current),
                        previousRank: _this.isEmptyOrNull(row.rank_net_previous) ? 0 : parseInt(row.rank_net_previous),
                        products: _this.isEmptyOrNull(row.sales_products) ? 0 : parseInt(row.sales_products)
                    };
                    platformData_1.net.push(platformNetSalesObj);
                    var platformAUMObj = {
                        platform: platformtype,
                        clientAum: _this.isEmptyOrNull(row.client_gross_aum) ? 0 : Math.round(parseFloat(row.client_gross_aum)),
                        globalAum: _this.isEmptyOrNull(row.global_gross_aum) ? 0 : Math.round(parseFloat(row.global_gross_aum)),
                        marketShare: _this.isEmptyOrNull(row.aum_market_share) ? 0 : parseFloat(row.aum_market_share),
                        greenSpaceAum: _this.isEmptyOrNull(row.aum_green_space) ? 0 : Math.round(parseFloat(row.aum_green_space)),
                        redSpace: _this.isEmptyOrNull(row.red_space) ? 0 : Math.round(parseFloat(row.red_space)),
                        competitiveAum: _this.isEmptyOrNull(row.competitive_aum) ? 0 : Math.round(parseFloat(row.competitive_aum)),
                        rank: _this.isEmptyOrNull(row.rank_aum_current) ? 0 : parseInt(row.rank_aum_current),
                        previousRank: _this.isEmptyOrNull(row.rank_aum_previous) ? 0 : parseInt(row.rank_aum_previous),
                        products: _this.isEmptyOrNull(row.aum_products) ? 0 : parseInt(row.aum_products)
                    };
                    platformData_1.aum.push(platformAUMObj);
                });
                return platformData_1;
            }
            return null;
        };
        Parser.prototype.getTabsEnableInfo = function (data) {
            var rows = data.rows;
            var results = {
                platformCodes: 0,
                whatIf: 0,
                keySalesDrivers: 0,
                territory: 0,
                rankings: 0
            };
            if (rows.length > 0) {
                results.platformCodes = parseInt(rows[0][0], 10);
                results.whatIf = parseInt(rows[0][1], 10);
                results.territory = parseInt(rows[0][2], 10);
                results.keySalesDrivers = parseInt(rows[0][3], 10);
                results.rankings = parseInt(rows[0][4], 10);
            }
            return results;
        };
        Parser.prototype.getPlatformTypeByAbbr = function (abbr) {
            for (var i = 0; i < Parser.platformMetadata.length; i++) {
                if (abbr.toUpperCase() === Parser.platformMetadata[i].typeAbbr.toUpperCase()) {
                    return Parser.platformMetadata[i].type;
                }
            }
            return abbr;
        };
        Parser.prototype.getAbbrByAPlatformType = function (type) {
            for (var i = 0; i < Parser.platformMetadata.length; i++) {
                if (type.toUpperCase() === Parser.platformMetadata[i].type.toUpperCase()) {
                    return Parser.platformMetadata[i].typeAbbr;
                }
            }
            return type;
        };
        Parser.prototype.isEmptyOrNull = function (str) {
            if ((str === 'null') || (str === undefined) || (str.length === 0)) {
                return true;
            }
            else {
                return false;
            }
        };
        Parser.prototype.getPlatformCodes = function (result) {
            var columns = result.cols;
            var rows = result.rows;
            var platformCodeIndex = columns.indexOf(Parser.PLATFORM_CODE);
            var results = [];
            rows.forEach(function (row) {
                results.push(row[platformCodeIndex]);
            });
            return results;
        };
        Parser.prototype.getProductFamilyNames = function (result) {
            var columns = result.cols;
            var rows = result.rows;
            var productFamilyNameIndex = columns.indexOf(Parser.PRODUCT_FAMILY_LOGO_NAME);
            var results = [];
            rows.forEach(function (row) {
                results.push(row[productFamilyNameIndex]);
            });
            return results;
        };
        Parser.QUARTER = "quarter";
        Parser.GROSS_SALES_RANK = "gross_sales_rank";
        Parser.NET_SALES_RANK = 'net_sales_rank';
        Parser.AUM_RANK = 'aum_rank';
        Parser.platformMetadata = [{ typeAbbr: "ALL", type: "All" }, {
                typeAbbr: "BRK",
                type: "Brokerage"
            }, { typeAbbr: "RPM", type: "Rep as PM" },
            { typeAbbr: "UMA", type: "Unified Managed Account " }, {
                typeAbbr: "RPA",
                type: "Rep as Advisor "
            }, { typeAbbr: "HOME", type: "Home Office" }];
        Parser.PLATFORM_CODE = 'platform_code';
        Parser.PRODUCT_FAMILY_LOGO_NAME = "product_family_logo_name";
        Parser.PRODUCT_COUNT_INDEX = "product_count";
        Parser.FIRM_COUNT_INDEX = "firm_count";
        return Parser;
    }());
    CompInsights.Parser = Parser;
    var scatterplotParser = (function () {
        function scatterplotParser() {
        }
        scatterplotParser.prototype.parser = function (data, xAxis, yAxis) {
            var result = new Array();
            data.rows
                .forEach(function (line) {
                var dimension = line[DataPositionEnum.DIMENSION];
                var client_gross_sales = line[DataPositionEnum.CLIENT_GROSS_SALES];
                var client_net_sales = line[DataPositionEnum.CLIENT_NET_SALES];
                var global_gross_sales = line[DataPositionEnum.GLOBAL_GROSS_SALES];
                var global_net_sales = line[DataPositionEnum.GLOBAL_NET_SALES];
                var market_share = line[DataPositionEnum.MARKET_SHARE];
                var client_aum = line[DataPositionEnum.CLIENT_AUM];
                var aum_industry = line[DataPositionEnum.AUM_INDUSTRY];
                var expected_sales = line[DataPositionEnum.EXPECTED_SALES];
                var aum_green_space = line[DataPositionEnum.AUM_GREEN_SPACE];
                var sales_green_space = line[DataPositionEnum.SALES_GREEN_SPACE];
                var xData = line[xAxis.getPositionData()] === null ? 0 : line[xAxis.getPositionData()];
                var yData = line[yAxis.getPositionData()] === null ? 0 : line[yAxis.getPositionData()];
                var obj = {
                    name: dimension,
                    x: xData,
                    y: yData,
                    z: xData * yData,
                    firmName: "",
                    data: {
                        client_gross_sales: Number(client_gross_sales),
                        client_net_sales: Number(client_net_sales),
                        global_gross_sales: Number(global_gross_sales),
                        global_net_sales: Number(global_net_sales),
                        market_share: Number(market_share),
                        client_aum: Number(client_aum),
                        aum_industry: Number(aum_industry),
                        expected_sales: Number(expected_sales),
                        aum_green_space: Number(aum_green_space),
                        sales_green_space: Number(sales_green_space)
                    }
                };
                result.push(obj);
            });
            return result;
        };
        return scatterplotParser;
    }());
    CompInsights.scatterplotParser = scatterplotParser;
})(CompInsights || (CompInsights = {}));
///<reference path="../../libs/jquery.d.ts"/>
///<reference path="00.data_types.ts" />
///<reference path="01.strings.ts" />
///<reference path="02.data_manager.ts" />
///<reference path="03.data.ts" />
///<reference path="04.service.ts" />
///<reference path="05.parser.ts" />
var CompInsights;
(function (CompInsights) {
    var Rankings = (function () {
        function Rankings(wrapper, service) {
            this.wrapper = wrapper.find('#rankingTab');
            this.service = service;
        }
        Rankings.prototype.buildRankingsTab = function (productPortfolio, firmName, category, clientSalesZero) {
            var _this = this;
            if (clientSalesZero === void 0) { clientSalesZero = false; }
            $("#tabWheel").show();
            jQuery("#rankingTab").html("");
            this.productPortfolio = productPortfolio;
            this.firmName = firmName;
            this.category = category;
            $.when(this.service.getRanksByQuarter(productPortfolio, firmName), this.service.getAssetManagerRanksByType(productPortfolio, firmName, category), this.service.getQuarterInfo())
                .then(function (ranksByQuarter, assetManagerRanks, quarterInfo) {
                _this.quarterInfo = quarterInfo;
                _this.buildRanksByQuarter(ranksByQuarter);
                _this.buildAssetManagerRanksByType(assetManagerRanks);
                _this.ranksByQuarter = ranksByQuarter;
                _this.assetManagerRanks = assetManagerRanks;
                $("#tabWheel").hide();
            });
        };
        Rankings.prototype.buildRanksByQuarter = function (ranksByQuarter) {
            var latestQuarterRanks = ranksByQuarter[0];
            this.quarters = ranksByQuarter.map(function (rank) { return rank.quarter; });
            this.rankingTrendsHeaders = [CompInsights.Strings.RANKING_TRENDS].concat(this.quarters);
            var grossSalesRankArr = [CompInsights.Strings.GROSSALESRANK].concat(ranksByQuarter.map(function (rank) { return rank.grossSalesRank; }));
            var neSalesRankArr = [CompInsights.Strings.NETSALESRANK].concat(ranksByQuarter.map(function (rank) { return rank.netSalesRank; }));
            var aumRankArr = [CompInsights.Strings.AUMRANK].concat(ranksByQuarter.map(function (rank) { return rank.aumRank; }));
            this.rankingTrendsArray = [grossSalesRankArr, neSalesRankArr, aumRankArr];
            var rankingTrendsTableWrapper = $('<div />', { 'class': 'comp-insights-rankings-trends-wrapper', 'id': 'rankingTrendsTable' });
            var rankingTrendsTable = $('<table />', { 'class': 'full-width' });
            var rankingTrendsTableHeaderTr = $('<tr />', { 'class': 'comp-insights-rankings-trends-row' });
            this.rankingTrendsHeaders.forEach(function (quarter) {
                var rankingTrendsTableTd = $('<th />', { 'class': 'comp-insights-rankings-trends-cell', 'text': quarter });
                rankingTrendsTableHeaderTr.append(rankingTrendsTableTd);
            });
            rankingTrendsTable.append(rankingTrendsTableHeaderTr);
            this.rankingTrendsArray.forEach(function (ranks) {
                var rankingTrendsTableTr = $('<tr />', { 'class': 'comp-insights-rankings-trends-row' });
                ranks.forEach(function (rank) {
                    var rankingTrendsTableTd = $('<td />', { 'class': 'comp-insights-rankings-trends-cell', 'text': rank });
                    rankingTrendsTableTr.append(rankingTrendsTableTd);
                });
                rankingTrendsTable.append(rankingTrendsTableTr);
            });
            rankingTrendsTableWrapper.append(rankingTrendsTable);
            var ranksWrapper = $('<div />', { 'class': 'comp-insights-rank-box border' });
            CompInsights.Strings.HEADERS.forEach(function (e, index) {
                var ranksHeader = $('<div />', { 'class': 'comp-insights-rank-box-header' });
                var ranksHeaderText = $('<div />', { 'class': 'comp-insights-rank-box-header-text', 'text': e.label });
                var ranksHeaderDiv = $('<div />', { 'class': 'comp-insights-rank-box-header-rank', 'text': latestQuarterRanks[e.value] });
                ranksHeader.append(ranksHeaderText, ranksHeaderDiv);
                ranksWrapper.append(ranksHeader);
            });
            this.wrapper.append(rankingTrendsTableWrapper, ranksWrapper);
        };
        Rankings.prototype.buildAssetManagerRanksByType = function (assetManagerRanks) {
            var _this = this;
            var assetManagerRankWrapper = $('<div />', { 'class': 'comp-insights-rank-box' });
            CompInsights.Strings.HEADERS.forEach(function (e, index) {
                var assetManagerRankBoxHeader = $('<div />)', { 'class': 'comp-insights-rank-box-header' });
                var assetManagerRankBoxHeaderText = $('<div />)', { 'class': 'comp-insights-rank-box-header-text', 'text': e.label });
                var assetManagerRankingWrapper = $('<div />)', { 'class': 'comp-insights-rankings-trends-wrapper border', 'id': e.value });
                assetManagerRankBoxHeader.append(assetManagerRankBoxHeaderText, assetManagerRankingWrapper);
                assetManagerRankWrapper.append(assetManagerRankBoxHeader);
                var assetManagerTable = $('<table />', { 'class': 'full-width' });
                var assetManagerTableHeaderTr = $('<tr />', { 'class': 'comp-insights-manager-rankings-row' });
                _this.rankingHeaders = [_this.quarterInfo[0] + ' Rank', CompInsights.Strings.PRODUCT].concat(_this.quarterInfo.slice(1, 3).map(function (quarter) { return quarter + ' Rank'; }));
                _this.rankingHeaders.forEach(function (header) {
                    var assetManagerTableTh = $('<th />', { 'class': 'comp-insights-manager-rankings-cell', 'html': header });
                    assetManagerTableHeaderTr.append(assetManagerTableTh);
                    assetManagerTable.append(assetManagerTableHeaderTr);
                });
                assetManagerRanks[e.value].forEach(function (ranks) {
                    var assetManagerTableTr = $('<tr />', { 'class': 'comp-insights-manager-rankings-row slim' });
                    if (ranks.assetManager !== 'Product') {
                        assetManagerTableTr.addClass('highlight-asset-manager');
                    }
                    var currentQuarterTd = $('<td />', { 'class': 'comp-insights-manager-rankings-cell' });
                    var currentQuarterRank = $('<div />', { 'class': 'comp-insights-manager-rankings-cell-icon badge', 'text': ranks.currentQuarterRank });
                    currentQuarterTd.append(currentQuarterRank);
                    var assetManagerTd = $('<td />', { 'class': 'comp-insights-manager-rankings-cell capitalize', 'text': ranks.assetManager });
                    var prevQuarterTd = $('<td />', { 'class': 'comp-insights-manager-rankings-cell', 'text': ranks.prevQuarterRank });
                    var prevPrevQuarterTd = $('<td />', { 'class': 'comp-insights-manager-rankings-cell', 'text': ranks.prevPrevQuarterRank });
                    assetManagerTableTr.append(currentQuarterTd, assetManagerTd, prevQuarterTd, prevPrevQuarterTd);
                    assetManagerTable.append(assetManagerTableTr);
                });
                assetManagerRankingWrapper.append(assetManagerTable);
            });
            this.wrapper.append(assetManagerRankWrapper);
        };
        Rankings.prototype.getRanksData = function () {
            return {
                ranksByQuarter: this.ranksByQuarter,
                assetManagerRanks: this.assetManagerRanks,
                rankingTrendsHeaders: this.rankingTrendsHeaders,
                rankingTrendsArray: this.rankingTrendsArray,
                rankingHeaders: this.rankingHeaders
            };
        };
        return Rankings;
    }());
    CompInsights.Rankings = Rankings;
})(CompInsights || (CompInsights = {}));
var PaginatedMenu;
(function (PaginatedMenu) {
    var Pagination = (function () {
        function Pagination(total, activePage) {
            this.total = total;
            this.numberOfPages = Math.ceil(this.total / Pagination.LINES_PER_PAGE);
            if (activePage) {
                this.currentPage = activePage;
            }
            else {
                this.currentPage = 0;
            }
            this.arrowClickHandlers = new ListenersCollection();
            if (this.isPaginationNecessary()) {
                this.build();
            }
        }
        Pagination.prototype.build = function () {
            var _this = this;
            this.wrapper = jQuery('<div/>', { 'class': 'comp-grid-pagination' });
            this.pages = new Array();
            for (var i = 0; i < this.numberOfPages; i++) {
                var pagination = jQuery('<div/>', { 'class': 'comp-grid-pagination-item hide', 'text': i + 1 });
                if (i >= Pagination.MIN_LIMIT && i <= Pagination.MAX_LIMIT) {
                    pagination.removeClass('hide');
                }
                this.pages.push(pagination);
            }
            var leftDoubleArrow = jQuery('<div/>', { 'class': 'comp-grid-pagination-double-arrow-left' }).append(jQuery('<i/>', { 'class': 'fa fa-angle-double-left' }));
            var rightDoubleArrow = jQuery('<div/>', { 'class': 'comp-grid-pagination-double-arrow-right' }).append(jQuery('<i/>', { 'class': 'fa fa-angle-double-right' }));
            var leftArrow = jQuery('<div/>', { 'class': 'comp-grid-pagination-arrow-left' }).append(jQuery('<i/>', { 'class': 'fa fa-chevron-left' }));
            var rightArrow = jQuery('<div/>', { 'class': 'comp-grid-pagination-arrow-right' }).append(jQuery('<i/>', { 'class': 'fa fa-chevron-right' }));
            var productPaginationCountWrapper = jQuery('<div/>', { 'id': 'product-pagination-count-wrapper' });
            this.disableArrows(leftDoubleArrow, leftArrow, rightArrow, rightDoubleArrow);
            leftDoubleArrow.click(function () {
                if (Pagination.MIN_LIMIT === 0) {
                    return;
                }
                Pagination.MAX_LIMIT -= Pagination.STEP_VELUE;
                Pagination.MIN_LIMIT -= Pagination.STEP_VELUE;
                if (Pagination.MIN_LIMIT < 0) {
                    Pagination.MIN_LIMIT = 0;
                    Pagination.MAX_LIMIT = 4;
                }
                _this.currentPage = Pagination.MIN_LIMIT;
                _this.refreshPagination();
                _this.disableArrows(leftDoubleArrow, leftArrow, rightArrow, rightDoubleArrow);
                _this.arrowClickHandlers.execute(window, []);
            });
            leftArrow.click(function () {
                if (_this.currentPage === 0) {
                    return;
                }
                else {
                    if (_this.currentPage == Pagination.MIN_LIMIT) {
                        Pagination.MAX_LIMIT--;
                        Pagination.MIN_LIMIT--;
                    }
                    _this.currentPage--;
                    _this.refreshPagination();
                }
                _this.disableArrows(leftDoubleArrow, leftArrow, rightArrow, rightDoubleArrow);
                _this.arrowClickHandlers.execute(window, []);
            });
            rightArrow.click(function () {
                if (_this.currentPage === (_this.numberOfPages - 1)) {
                    return;
                }
                else {
                    if (_this.currentPage == Pagination.MAX_LIMIT) {
                        Pagination.MAX_LIMIT++;
                        Pagination.MIN_LIMIT++;
                    }
                    _this.currentPage++;
                    _this.refreshPagination();
                }
                _this.disableArrows(leftDoubleArrow, leftArrow, rightArrow, rightDoubleArrow);
                _this.arrowClickHandlers.execute(window, []);
            });
            rightDoubleArrow.click(function () {
                if (Pagination.MAX_LIMIT === (_this.numberOfPages - 1)) {
                    return;
                }
                Pagination.MAX_LIMIT += Pagination.STEP_VELUE;
                Pagination.MIN_LIMIT += Pagination.STEP_VELUE;
                if (Pagination.MAX_LIMIT > (_this.numberOfPages - 1)) {
                    Pagination.MAX_LIMIT = (_this.numberOfPages - 1);
                    Pagination.MIN_LIMIT = Pagination.MAX_LIMIT - 4;
                }
                _this.currentPage = Pagination.MIN_LIMIT;
                _this.refreshPagination();
                _this.disableArrows(leftDoubleArrow, leftArrow, rightArrow, rightDoubleArrow);
                _this.arrowClickHandlers.execute(window, []);
            });
            // Appeding elements...
            this.wrapper.append(leftDoubleArrow);
            this.wrapper.append(leftArrow);
            this.pages.forEach(function (page, index) {
                page.click(function () {
                    if (_this.currentPage === index) {
                        return;
                    }
                    _this.currentPage = index;
                    _this.refreshPagination();
                    _this.disableArrows(leftDoubleArrow, leftArrow, rightArrow, rightDoubleArrow);
                    _this.arrowClickHandlers.execute(window, []);
                });
                _this.wrapper.append(page);
            });
            this.wrapper.append(rightArrow);
            this.wrapper.append(rightDoubleArrow);
            this.wrapper.append(productPaginationCountWrapper);
            // CSS for actived page...
            this.pages[this.currentPage].addClass(Pagination.ACTIVE_CLASS);
        };
        Pagination.prototype.isPaginationNecessary = function () {
            return this.total > Pagination.LINES_PER_PAGE;
        };
        Pagination.prototype.refreshPagination = function () {
            this.pages.forEach(function (page, index) {
                page.removeClass(Pagination.ACTIVE_CLASS);
                page.addClass(Pagination.HIDE_CLASS);
                if (index >= Pagination.MIN_LIMIT && index <= Pagination.MAX_LIMIT) {
                    page.removeClass('hide');
                }
            });
            this.pages[this.currentPage].addClass(Pagination.ACTIVE_CLASS);
        };
        Pagination.prototype.disableArrows = function (leftDoubleArrow, leftArrow, rightArrow, rightDoubleArrow) {
            leftDoubleArrow.removeClass(Pagination.DISABLED_CLASS);
            rightDoubleArrow.removeClass(Pagination.DISABLED_CLASS);
            leftArrow.removeClass(Pagination.DISABLED_CLASS);
            rightArrow.removeClass(Pagination.DISABLED_CLASS);
            if (this.currentPage === 0) {
                leftArrow.addClass(Pagination.DISABLED_CLASS);
            }
            if (this.currentPage === this.numberOfPages - 1) {
                rightArrow.addClass(Pagination.DISABLED_CLASS);
            }
            if (Pagination.MAX_LIMIT === this.numberOfPages - 1) {
                rightDoubleArrow.addClass(Pagination.DISABLED_CLASS);
            }
            if (Pagination.MIN_LIMIT === 0) {
                leftDoubleArrow.addClass(Pagination.DISABLED_CLASS);
            }
        };
        Pagination.prototype.getCurrentPagination = function () {
            return this.currentPage;
        };
        Pagination.prototype.getNumOfPages = function () {
            return this.numberOfPages;
        };
        Pagination.prototype.html = function () {
            return this.wrapper;
        };
        Pagination.prototype.arrowClicked = function (handler) {
            this.arrowClickHandlers.addEventListener(handler);
        };
        Pagination.LINES_PER_PAGE = 10;
        Pagination.ACTIVE_CLASS = 'active';
        Pagination.DISABLED_CLASS = 'disabled';
        Pagination.HIDE_CLASS = 'hide';
        Pagination.MIN_LIMIT = 0;
        Pagination.MAX_LIMIT = 4;
        Pagination.STEP_VELUE = 5;
        return Pagination;
    }());
    PaginatedMenu.Pagination = Pagination;
    var FirmPagination = (function () {
        function FirmPagination(total, activePage) {
            this.total = total;
            this.numberOfPages = Math.ceil(this.total / Pagination.LINES_PER_PAGE);
            if (activePage) {
                this.currentPage = activePage;
            }
            else {
                this.currentPage = 0;
            }
            this.arrowClickHandlers = new ListenersCollection();
            if (this.isPaginationNecessary()) {
                this.build();
            }
        }
        FirmPagination.prototype.build = function () {
            var _this = this;
            this.wrapper = jQuery('<div/>', { 'class': 'comp-grid-pagination' });
            this.pages = new Array();
            for (var i = 0; i < this.numberOfPages; i++) {
                var pagination = jQuery('<div/>', { 'class': 'comp-grid-pagination-item', 'text': i + 1 });
                this.pages.push(pagination);
            }
            var upArrow = jQuery('<div/>', { 'class': 'comp-grid-pagination-arrow-left' }).append(jQuery('<i/>', { 'class': 'fa fa-chevron-up' }));
            var downArrow = jQuery('<div/>', { 'class': 'comp-grid-pagination-arrow-right' }).append(jQuery('<i/>', { 'class': 'fa fa-chevron-down' }));
            this.disableArrows(upArrow, downArrow);
            upArrow.click(function () {
                if (_this.currentPage !== 0) {
                    _this.currentPage--;
                }
                else {
                    return;
                }
                _this.disableArrows(upArrow, downArrow);
                _this.arrowClickHandlers.execute(window, []);
            });
            downArrow.click(function () {
                if (_this.currentPage !== (_this.numberOfPages - 1)) {
                    _this.currentPage++;
                }
                else {
                    return;
                }
                _this.disableArrows(upArrow, downArrow);
                _this.arrowClickHandlers.execute(window, []);
            });
            // Appeding elements...
            this.wrapper.append(upArrow);
            this.wrapper.append(downArrow);
        };
        FirmPagination.prototype.isPaginationNecessary = function () {
            return this.total > Pagination.LINES_PER_PAGE;
        };
        FirmPagination.prototype.disableArrows = function (leftArrow, rightArrow) {
            leftArrow.removeClass(FirmPagination.DISABLED_CLASS);
            rightArrow.removeClass(FirmPagination.DISABLED_CLASS);
            if (this.currentPage === 0) {
                leftArrow.addClass(FirmPagination.DISABLED_CLASS);
            }
            if (this.currentPage === this.numberOfPages - 1) {
                rightArrow.addClass(FirmPagination.DISABLED_CLASS);
            }
        };
        FirmPagination.prototype.getCurrentPagination = function () {
            return this.currentPage;
        };
        FirmPagination.prototype.getNumOfPages = function () {
            return this.numberOfPages;
        };
        FirmPagination.prototype.html = function () {
            return this.wrapper;
        };
        FirmPagination.prototype.arrowClicked = function (handler) {
            this.arrowClickHandlers.addEventListener(handler);
        };
        FirmPagination.LINES_PER_PAGE = 10;
        FirmPagination.ACTIVE_CLASS = 'active';
        FirmPagination.DISABLED_CLASS = 'disabled';
        return FirmPagination;
    }());
    PaginatedMenu.FirmPagination = FirmPagination;
})(PaginatedMenu || (PaginatedMenu = {}));
///<reference path="../../libs/jquery.d.ts"/>
///<reference path="00.data_types.ts" />
///<reference path="01.strings.ts" />
///<reference path="02.data_manager.ts" />
///<reference path="03.data.ts" />
///<reference path="04.service.ts" />
///<reference path="05.parser.ts" />
var CompInsights;
(function (CompInsights) {
    var MainGrid = (function () {
        function MainGrid(wrapper, service) {
            this.fillSize = 10;
            this.isClient = true;
            this.isOpportunity = true;
            this.columnSize = 10;
            this.wrapper = wrapper;
            this.service = service;
        }
        MainGrid.prototype.setDataList = function (dataList) {
            this.dataList = dataList;
        };
        MainGrid.prototype.generateMainTableHtml = function (isOpportunity, isClient) {
            var _this = this;
            if (isOpportunity === void 0) { isOpportunity = true; }
            if (isClient === void 0) { isClient = true; }
            if ((this.dataList === null) || (this.dataList.length < 1))
                return;
            this.isClient = isClient;
            this.isOpportunity = isOpportunity;
            var html = '<table class="table table-condensed main-grid-table">';
            var firstLine = this.dataList[0];
            var firstLineSalesData;
            if (this.isClient) {
                firstLineSalesData = firstLine.clientSalesData;
            }
            else {
                firstLineSalesData = firstLine.industrySalesData;
            }
            this.columnSize = firstLineSalesData.length;
            this.fillSize = MainGrid.MAX_COLUMN_SIZE - this.columnSize;
            html += '<thead><tr class="comp-insights-border"><th class="comp-insights-table-head-fonts comp-insights-first-column comp-insights-border"></th>';
            firstLineSalesData.forEach(function (parameter) {
                html += '<th class="comp-insights-table-head-fonts comp-insights-mid-column comp-insights-border">' + parameter.productPortfolio + '</th>';
            });
            if (this.fillSize > 0) {
                for (var i = 0; i < this.fillSize; i++) {
                    html += '<th class="comp-insights-mid-column comp-insights-border"></th>';
                }
            }
            html += '</tr></thead>';
            html += ' <tbody>';
            var rowNumber = 0;
            var columnNumber = 0;
            this.dataList.forEach(function (row) {
                html += '<tr class="comp-insights-border">' + '<td class="comp-insights-border comp-insights-company-td"><div class="comp-insights-company"><div class="truncate-text">' + row.firmName + '</div><div class="tooltiptext">' + row.firmName + '</div></div></td>';
                var salesData;
                if (_this.isClient) {
                    salesData = row.clientSalesData;
                }
                else {
                    salesData = row.industrySalesData;
                }
                salesData.forEach(function (parameter) {
                    var value = parameter.opportunity;
                    if (!_this.isOpportunity) {
                        value = parameter.risk;
                    }
                    var idContent = "td_" + rowNumber + "_" + columnNumber;
                    if (value !== 0)
                        html += '<td id="' + idContent + '" style="vertical-align: middle;" class="comp-insights-border comp-insights-opportunity-risk ';
                    if (value > MainGrid.HIGH_BOUNDARY) {
                        if (_this.isOpportunity) {
                            if (parameter.clientSales === 0) {
                                html += 'background-color-opportunity-highest"><div class="comp-insights-zero-block-first" style="vertical-align: top;"><span class="comp-insights-zero-white">$0</span></div>';
                                html += '<div class="comp-insights-zero-block-second"><span class="comp-insights-table-fonts">' + value + '</span></div>' + '</td>';
                            }
                            else {
                                html += 'background-color-opportunity-highest">' + value + '</td>';
                            }
                        }
                        else {
                            if (parameter.clientSales === 0) {
                                html += 'background-color-risk-highest">';
                                html += '<div class="comp-insights-zero-block-first" style="vertical-align: top;"><span class="comp-insights-zero-white">$0</span></div>';
                                html += '<div class="comp-insights-zero-block-second"><span class="comp-insights-table-fonts">' + value + '</span></div>' + '</td>';
                            }
                            else {
                                html += 'background-color-risk-highest">' + value + '</td>';
                            }
                        }
                    }
                    else if (value <= MainGrid.LOWEST_BOUNDARY) {
                        if (value === 0) {
                            html += '<td class="comp-insights-border background-color-opportunity-zero"></td>';
                        }
                        else if (_this.isOpportunity) {
                            if (parameter.clientSales === 0) {
                                html += 'background-color-opportunity-lowest">';
                                html += '<div class="comp-insights-zero-block-first"><span class="comp-insights-zero-white">$0</span></div>';
                                html += '<div class="comp-insights-zero-block-second"><span class="comp-insights-table-fonts">' + value + '</span></div>' + '</td>';
                            }
                            else {
                                html += 'background-color-opportunity-lowest">' + value + '</td>';
                            }
                        }
                        else {
                            if (parameter.clientSales === 0) {
                                html += 'background-color-risk-lowest">';
                                html += '<div class="comp-insights-zero-block-first"><span class="comp-insights-zero-white">$0</span></div>';
                                html += '<div class="comp-insights-zero-block-second"><span class="comp-insights-table-fonts">' + value + '</span></div>' + '</td>';
                            }
                            else {
                                html += 'background-color-risk-lowest">' + value + '</td>';
                            }
                        }
                    }
                    else if (value <= MainGrid.HIGH_BOUNDARY && value > MainGrid.LOW_BOUNDARY) {
                        if (_this.isOpportunity) {
                            if (parameter.clientSales === 0) {
                                html += 'background-color-opportunity-high">';
                                html += '<div class="comp-insights-zero-block-first"><span class="comp-insights-zero-white">$0</span></div>';
                                html += '<div class="comp-insights-zero-block-second"><span class="comp-insights-table-fonts">' + value + '</span></div>' + '</td>';
                            }
                            else {
                                html += 'background-color-opportunity-high">' + value + '</td>';
                            }
                        }
                        else {
                            if (parameter.clientSales === 0) {
                                html += 'background-color-risk-high">';
                                html += '<div class="comp-insights-zero-block-first"><span class="comp-insights-zero-white">$0</span></div>';
                                html += '<div class="comp-insights-zero-block-second"><span class="comp-insights-table-fonts">' + value + '</span></div>' + '</td>';
                            }
                            else {
                                html += 'background-color-risk-high">' + value + '</td>';
                            }
                        }
                    }
                    else {
                        if (_this.isOpportunity) {
                            if (parameter.clientSales === 0) {
                                html += 'background-color-opportunity-low">';
                                html += '<div class="comp-insights-zero-block-first"><span class="comp-insights-zero-white">$0</span></div>';
                                html += '<div class="comp-insights-zero-block-second"><span class="comp-insights-table-fonts">' + value + '</span></div>' + '</td>';
                            }
                            else {
                                html += 'background-color-opportunity-low">' + value + '</td>';
                            }
                        }
                        else {
                            if (parameter.clientSales === 0) {
                                html += 'background-color-risk-low"><div style="padding-bottom:-30px;">';
                                html += '<div class="comp-insights-zero-block-first"><span class="comp-insights-zero-white">$0</span></div>';
                                html += '<div class="comp-insights-zero-block-second"><span class="comp-insights-table-fonts">' + value + '</span></div>' + '</td>';
                            }
                            else {
                                html += 'background-color-risk-low">' + value + '</td>';
                            }
                        }
                    }
                    columnNumber++;
                });
                if (_this.fillSize > 0) {
                    html += '<td class="comp-insights-border"></td>';
                }
                html += '</tr>';
                rowNumber++;
                columnNumber = 0;
            });
            html += '</tbody></table>';
            jQuery(".comp-main-grid-wrapper").html(html);
        };
        MainGrid.prototype.generateFirstBlock = function (rowNumber, columnNumber, isOpportunity, isClient) {
            if (isOpportunity === void 0) { isOpportunity = true; }
            if (isClient === void 0) { isClient = true; }
            var oneLine = this.dataList[rowNumber];
            var oneLineSalesData;
            if (this.isClient) {
                oneLineSalesData = oneLine.clientSalesData;
            }
            else {
                oneLineSalesData = oneLine.industrySalesData;
            }
            var value = oneLineSalesData[columnNumber].opportunity;
            if (!this.isOpportunity) {
                value = oneLineSalesData[columnNumber].risk;
            }
            jQuery("#highlighted-zero-block").html("");
            jQuery("#highlighted-first-block").html("");
            var numberHtml = '<div class="comp-insights-zero-block ';
            var labelHtml = '<div class="comp-insights-first-block ';
            if (value > MainGrid.HIGH_BOUNDARY) {
                if (this.isOpportunity) {
                    numberHtml += 'background-color-opportunity-highest">' + value + '</div>';
                    labelHtml += 'background-color-opportunity-highest">' + CompInsights.Strings.HIGHEST + ' ' + CompInsights.Strings.OPPORTUNITY + '</div>';
                }
                else {
                    numberHtml += 'background-color-risk-highest">' + value + '</div>';
                    labelHtml += 'background-color-risk-highest">' + CompInsights.Strings.HIGHEST + ' ' + CompInsights.Strings.RISK + '</div>';
                }
            }
            else if ((value <= MainGrid.HIGH_BOUNDARY) && (value > MainGrid.LOW_BOUNDARY)) {
                if (this.isOpportunity) {
                    numberHtml += 'background-color-opportunity-high">' + value + '</div>';
                    labelHtml += 'background-color-opportunity-high">' + CompInsights.Strings.HIGH + ' ' + CompInsights.Strings.OPPORTUNITY + '</div>';
                }
                else {
                    numberHtml += 'background-color-risk-high">' + value + '</div>';
                    labelHtml += 'background-color-risk-high">' + CompInsights.Strings.HIGH + ' ' + CompInsights.Strings.RISK + '</div>';
                }
            }
            else if (value <= MainGrid.LOWEST_BOUNDARY) {
                if (this.isOpportunity) {
                    numberHtml += 'background-color-opportunity-lowest">' + value + '</div>';
                    labelHtml += 'background-color-opportunity-lowest">' + CompInsights.Strings.LOWEST + ' ' + CompInsights.Strings.OPPORTUNITY + '</div>';
                }
                else {
                    numberHtml += 'background-color-risk-lowest">' + value + '</div>';
                    labelHtml += 'background-color-risk-lowest">' + CompInsights.Strings.LOWEST + ' ' + CompInsights.Strings.RISK + '</div>';
                }
            }
            else {
                if (this.isOpportunity) {
                    numberHtml += 'background-color-opportunity-low">' + value + '</div>';
                    labelHtml += 'background-color-opportunity-low">' + CompInsights.Strings.LOW + ' ' + CompInsights.Strings.OPPORTUNITY + '</div>';
                }
                else {
                    numberHtml += 'background-color-risk-low">' + value + '</div>';
                    labelHtml += 'background-color-risk-low">' + CompInsights.Strings.LOW + ' ' + CompInsights.Strings.RISK + '</div>';
                }
            }
            jQuery("#highlighted-zero-block").html(numberHtml);
            jQuery("#highlighted-first-block").html(labelHtml);
        };
        MainGrid.LOWEST_BOUNDARY = 25;
        MainGrid.LOW_BOUNDARY = 50;
        MainGrid.HIGH_BOUNDARY = 75;
        MainGrid.HIGHEST_BOUNDARY = 10;
        MainGrid.MAX_COLUMN_SIZE = 10;
        MainGrid.MAX_ROW_SIZE = 10;
        return MainGrid;
    }());
    CompInsights.MainGrid = MainGrid;
})(CompInsights || (CompInsights = {}));
///<reference path="../../libs/jquery.d.ts"/>
///<reference path="00.data_types.ts" />
///<reference path="01.strings.ts" />
///<reference path="02.data_manager.ts" />
///<reference path="03.data.ts" />
///<reference path="04.service.ts" />
///<reference path="05.parser.ts" />
var CompInsights;
(function (CompInsights) {
    var SalesTrends = (function () {
        function SalesTrends(wrapper, service) {
            this.quarters = [];
            this.wrapper = wrapper;
            this.service = service;
        }
        SalesTrends.prototype.updateSalesTrends = function (firmName, category, portfolio) {
            var _this = this;
            $("#tabWheel").show();
            jQuery("#trendsTab").html("");
            this.service.getSalesTrends(firmName, category, portfolio).then(function (result) {
                _this.salesTrendsData = result;
                _this.quarters = _this.salesTrendsData.quarters;
                $("#tabWheel").hide();
                _this.generateSalesTrendsTabHtml();
            });
        };
        SalesTrends.prototype.generateSalesTrendsTabHtml = function () {
            var headers = [{ label: "Industry Sales", value: 'industrySales' }, { label: "Market Share", value: 'marketShare' }];
            var marketShareData = this.salesTrendsData.marketShareData;
            var html = "";
            /* var salesTrendsTable = '<div class="ci-sales-trend-table-unit">&nbsp;($ Millions)</div><div class="comp-insights-rankings-trends-wrapper" id="salesTrendsTable">';*/
            var salesTrendsTable = '<table class="table table-condensed ci-table ci-sales-trend-table"><thead><tr><th class="ci-table-first-column">Sales Trends (3 Months)</th>';
            // salesTrendsTable += '<table class="table table-condensed ci-table ci-sales-trend-table"><thead><tr><th class="ci-table-first-column">Sales Trends</th>';
            var salesTrendsHeaders = [];
            this.quarters.forEach(function (q) {
                salesTrendsHeaders.push(q);
            });
            salesTrendsHeaders.forEach(function (e) {
                salesTrendsTable += "<th>" + e + "</th>";
            });
            salesTrendsTable += '</tr></thead><tbody>';
            headers.forEach(function (header, index) {
                salesTrendsTable += '<tr>';
                salesTrendsTable += "<td class=\"ci-table-first-column\">" + header.label + "</td>";
                marketShareData.forEach(function (shareData) {
                    if (index === 0) {
                        value = new LabelBuilder.SalesLabelBuilder(true, false).build(shareData.industrySales, true);
                        salesTrendsTable += '<td>' + value + '</td>';
                    }
                    else {
                        var value = shareData.marketShare.toFixed(2) + '%';
                        salesTrendsTable += '<td>' + value + '</td>';
                    }
                });
                salesTrendsTable += '</tr>';
            });
            for (var i = 0; i < 9; i++) {
                salesTrendsTable += '<td>&nbsp;</td>';
            }
            salesTrendsTable += '</tbody></table></div>';
            html = salesTrendsTable + html;
            html += this.generateSalesTrendsTabSubtableHtml();
            jQuery("#trendsTab").html(html);
        };
        SalesTrends.prototype.generateSalesTrendsTabSubtableHtml = function () {
            var headers = [{ label: "Total Sales", value: 'totalSales' }, { label: "% Total Sales", value: 'percentTotalSales' }, { label: "Net Sales", value: 'netSales' }, { label: "Total AUM", value: 'totalAum' }, { label: "% AUM", value: 'percentAum' }];
            var salesTrendsTableData = this.salesTrendsData.salesConcentrationDataList;
            var html = "";
            var salesTrendsTable = '<div class="comp-insights-rankings-trends-wrapper" id="salesConcentrationTrendsTable">';
            salesTrendsTable += '<table class="table table-condensed ci-table ci-sales-trend-table"><thead><tr><th class="ci-table-first-column">Sales Concentration Trends (3 Months)</th>';
            // salesTrendsTable +='<table class="table table-condensed ci-table ci-sales-trend-table"><thead><tr><th class="ci-table-first-column">Sales Concentration Trends</th>';
            var salesTrendsTableHeaders = []; //,'Q4 2020','Q3 2020','Q2 2020','Q1 2020','Q4 2019','Q3 2019','Q2 2019','Q1 2019']
            this.quarters.forEach(function (q) {
                salesTrendsTableHeaders.push(q);
            });
            salesTrendsTableHeaders.forEach(function (e, index) {
                salesTrendsTable += "<th>" + e + "</th>";
            });
            salesTrendsTable += '</tr></thead><tbody>';
            salesTrendsTableData.forEach(function (data) {
                // salesTrendsTable += `<tr><td class="light-blue-highlight-indent ci-table-first-column">${data.label} (3 Months)</td>`
                salesTrendsTable += "<tr><td class=\"light-blue-highlight-indent ci-table-first-column\">" + data.label + "</td>";
                for (var i = 0; i < 8; i++) {
                    salesTrendsTable += '<td class="light-blue-highlight-indent">&nbsp;</td>';
                }
                salesTrendsTable += '</tr>';
                headers.forEach(function (header, index) {
                    salesTrendsTable += '<tr>';
                    salesTrendsTable += "<td class=\"ci-table-first-column\">" + header.label + "</td>";
                    data.salesDataList.forEach(function (salesConcentration) {
                        var value = '';
                        var isNegative = false;
                        if (index === 0) {
                            value = new LabelBuilder.SalesLabelBuilder(true, false).build(salesConcentration.totalSales, true);
                            isNegative = salesConcentration.totalSales < 0;
                        }
                        else if (index === 1) {
                            value = salesConcentration.percentTotalSales.toFixed(2) + '%';
                            isNegative = salesConcentration.percentTotalSales < 0;
                        }
                        else if (index === 2) {
                            value = new LabelBuilder.SalesLabelBuilder(true, false).build(salesConcentration.netSales, true);
                            isNegative = salesConcentration.netSales < 0;
                        }
                        else if (index === 3) {
                            value = new LabelBuilder.SalesLabelBuilder(true, false).build(salesConcentration.totalAum, true);
                            isNegative = salesConcentration.totalAum < 0;
                        }
                        else if (index === 4) {
                            value = salesConcentration.percentAum.toFixed(2) + '%';
                            isNegative = salesConcentration.percentAum < 0;
                        }
                        if (isNegative) {
                            salesTrendsTable += '<td class="ci-red-cell">' + value + '</td>';
                        }
                        else {
                            salesTrendsTable += '<td>' + value + '</td>';
                        }
                    });
                    salesTrendsTable += '</tr>';
                });
                salesTrendsTable += '<tr>';
                for (var i = 0; i < 9; i++) {
                    salesTrendsTable += '<td>&nbsp;</td>';
                }
                salesTrendsTable += '</tr>';
            });
            salesTrendsTable += '</tbody></table></div>';
            html = salesTrendsTable + html;
            return html;
        };
        return SalesTrends;
    }());
    CompInsights.SalesTrends = SalesTrends;
})(CompInsights || (CompInsights = {}));
///<reference path="../../libs/jquery.d.ts"/>
///<reference path="00.data_types.ts" />
///<reference path="01.strings.ts" />
///<reference path="02.data_manager.ts" />
///<reference path="03.data.ts" />
///<reference path="04.service.ts" />
///<reference path="05.parser.ts" />
var CompInsights;
(function (CompInsights) {
    var KeySalesDrivers = (function () {
        function KeySalesDrivers(wrapper, service, mockDataManager) {
            //private mockDataManager: MockData;
            this.parser = new CompInsights.Parser();
            this.analyticsMatchupsData = [];
            this.keySalesDriversDataList = [];
            this.keySalesDriversData = null;
            this.platformTypeList = [];
            this.sortIds = ['portalOrder', 'yourFund', 'competitiveFunds', 'difference', 'percentDifference', 'percentile'];
            this.firmName = '';
            this.category = '';
            this.productPortfolio = '';
            this.wrapper = wrapper;
            this.service = service;
            //this.mockDataManager = mockDataManager;
        }
        KeySalesDrivers.prototype.initializeEvents = function () {
            var _this = this;
            jQuery("#platform-dropdown").change(function () {
                _this.checkDropDownButtons();
            });
        };
        KeySalesDrivers.prototype.checkDropDownButtons = function () {
            var platform_type_val = jQuery("#platform-dropdown").val();
            var platform_type_val_finalForm = this.parser.getAbbrByAPlatformType(platform_type_val);
            this.getCurrentKeySalesDriversData(platform_type_val_finalForm);
            this.generateKeySalesDriversTabTablesHtml();
        };
        KeySalesDrivers.prototype.getCurrentKeySalesDriversData = function (platform) {
            for (var i = 0; i < this.keySalesDriversDataList.length; i++) {
                if (platform === this.keySalesDriversDataList[i].platform) {
                    this.keySalesDriversData = this.keySalesDriversDataList[i];
                    this.analyticsMatchupsData = this.keySalesDriversData.analyticsMatchups;
                    return;
                }
            }
        };
        KeySalesDrivers.prototype.generateKeySalesDriversTdHtml = function (value, isPercentile, isDifference, unit, displayPercent, negativeGreen, coloring) {
            if (isPercentile === void 0) { isPercentile = false; }
            if (isDifference === void 0) { isDifference = false; }
            if (unit === void 0) { unit = null; }
            if (displayPercent === void 0) { displayPercent = false; }
            if (negativeGreen === void 0) { negativeGreen = false; }
            if (coloring === void 0) { coloring = false; }
            var html = '';
            if (value !== null) {
                if (isPercentile) {
                    html += '<td class="comp-insights-key-drivers-percentile-td"><span>' + value.toFixed(2) + '</span>';
                    if (value < 21) {
                        html += '<span class="comp-insights-drivers-percentile-lowest comp-insights-drivers-percentile-bar"></span>';
                    }
                    else if (value < 41) {
                        html += '<span class="comp-insights-drivers-percentile-low comp-insights-drivers-percentile-bar"></span>';
                    }
                    else if (value < 61) {
                        html += '<span class="comp-insights-drivers-percentile-middle comp-insights-drivers-percentile-bar"></span>';
                    }
                    else if (value < 81) {
                        html += '<span class="comp-insights-drivers-percentile-high comp-insights-drivers-percentile-bar"></span>';
                    }
                    else if (value <= 100) {
                        html += '<span class="comp-insights-drivers-percentile-highest comp-insights-drivers-percentile-bar"></span>';
                    }
                    html += '</td>';
                }
                else if (isDifference) {
                    var valueStr = (unit !== null) ? Math.abs(value).toFixed(2) + ' ' + unit.toUpperCase() : Math.abs(value).toFixed(2);
                    if (unit === '%') {
                        valueStr = Math.abs(value).toFixed(2) + '%';
                    }
                    if (unit === 'bps') {
                        valueStr = Math.abs(value * 100).toFixed(0) + ' BPS';
                    }
                    html += '<td class="comp-insights-key-drivers-td ';
                    if (!negativeGreen) {
                        if (value < 0) {
                            html += 'comp-insights-key-drivers-difference-nagative"><span>' + valueStr;
                        }
                        else {
                            html += 'comp-insights-key-drivers-difference-positive"><span>' + valueStr;
                        }
                    }
                    else {
                        if (value <= 0) {
                            html += 'comp-insights-key-drivers-difference-positive"><span>' + valueStr;
                        }
                        else {
                            html += 'comp-insights-key-drivers-difference-nagative"><span>' + valueStr;
                        }
                    }
                    html += '</span></td>';
                }
                else if (displayPercent) {
                    html += '<td class="comp-insights-key-drivers-td ';
                    if (coloring) {
                        if (!negativeGreen) {
                            if (value < 0) {
                                html += 'comp-insights-key-drivers-difference-nagative"><span>' + Math.abs(value).toFixed(2) + '%';
                            }
                            else {
                                html += 'comp-insights-key-drivers-difference-positive"><span>' + value.toFixed(2) + '%';
                            }
                        }
                        else {
                            if (value <= 0) {
                                html += 'comp-insights-key-drivers-difference-positive"><span>' + Math.abs(value).toFixed(2) + '%';
                            }
                            else {
                                html += 'comp-insights-key-drivers-difference-nagative"><span>' + value.toFixed(2) + '%';
                            }
                        }
                    }
                    else {
                        html += '"><span>' + Math.abs(value).toFixed(2) + '%';
                    }
                    html += '</span></td>';
                }
                else {
                    html += '<td class="comp-insights-key-drivers-td"><span>';
                    if (unit !== null) {
                        if (unit === 'bps') {
                            html += Math.abs(value * 100).toFixed(0);
                        }
                        else {
                            html += value.toFixed(2);
                        }
                        if (unit === '%') {
                            html += '%';
                        }
                        else {
                            html += ' ' + unit.toUpperCase();
                        }
                    }
                    else {
                        html += value.toFixed(2);
                    }
                    html += '</span></td>';
                }
            }
            else {
                html += '<td class="comp-insights-key-drivers-td"></td>';
            }
            return html;
        };
        KeySalesDrivers.prototype.generatePercentileHtml = function () {
            var html = '<div><table class="table table-condensed comp-insights-border comp-insights-drivers-percentile-table"><tbody><tr class="comp-insights-border comp-insights-key-drivers-percentile-font"><td>Percentiles</td>';
            html += '<td class="comp-insights-drivers-percentile-lowest comp-insights-border">1 - 20</td>';
            html += '<td class="comp-insights-drivers-percentile-low comp-insights-border">21 - 40</td>';
            html += '<td class="comp-insights-drivers-percentile-middle comp-insights-border">41 - 60</td>';
            html += '<td class="comp-insights-drivers-percentile-high comp-insights-border">61 - 80</td>';
            html += '<td class="comp-insights-drivers-percentile-highest comp-insights-border">81 - 100</td>';
            html += '</tr></tbody></table></div>';
            return html;
        };
        KeySalesDrivers.prototype.initSortEvents = function () {
            var _this = this;
            for (var i = 0; i < this.sortIds.length; i++) {
                jQuery('#' + this.sortIds[i]).click(function (e) {
                    _this.sortFunctions(e);
                });
            }
        };
        KeySalesDrivers.prototype.sortFunctions = function (e) {
            var id = e.currentTarget.id;
            if (!id)
                return;
            var reverseSort = false;
            var origClass = jQuery('#' + id).attr('class');
            var newClass = '';
            var classArr = origClass.split(' ');
            if (classArr[1] === 'fa-sort') {
                if (id === 'portalOrder') {
                    // low -> high -> low
                    newClass = 'fa fa-sort-up ' + classArr[2];
                }
                else {
                    //high -> low -> high
                    newClass = 'fa fa-sort-down ' + classArr[2];
                    reverseSort = true;
                }
            }
            else if (classArr[1] === "fa-sort-up") {
                newClass = 'fa fa-sort-down ' + classArr[2];
                reverseSort = true;
            }
            else {
                newClass = 'fa fa-sort-up ' + classArr[2];
            }
            jQuery('#' + id).attr('class', newClass);
            for (var i = 0; i < this.sortIds.length; i++) {
                if (id !== this.sortIds[i]) {
                    if (i !== (this.sortIds.length - 1)) {
                        jQuery('#' + this.sortIds[i]).attr('class', 'fa fa-sort comp-insights-key-drivers-sort');
                    }
                    else {
                        jQuery('#' + this.sortIds[i]).attr('class', 'fa fa-sort comp-insights-key-drivers-sort-last');
                    }
                }
            }
            this.analyticsMatchupsData.sort(this.compareMatchups(id));
            if (reverseSort) {
                this.analyticsMatchupsData.reverse();
            }
            jQuery("#matchups").html(this.generateMatchupsHtml());
        };
        KeySalesDrivers.prototype.compareMatchups = function (propertyName) {
            return function (a, b) {
                var aa = a[propertyName];
                var bb = b[propertyName];
                if (typeof aa === "number") {
                    return aa - bb;
                }
                if (typeof aa === "string") {
                    return aa.localeCompare(bb);
                }
                return 0;
            };
        };
        KeySalesDrivers.prototype.initiateKeySalesDrivers = function (firmName, category, portfolio) {
            var _this = this;
            $("#tabWheel").show();
            jQuery("#driversTab").html("");
            this.service.getKeySalesDrivers(firmName, category, portfolio).then(function (result) {
                _this.keySalesDriversDataList = result;
                $("#tabWheel").hide();
                _this.getCurrentKeySalesDriversData('ALL');
                _this.platformTypeList = [];
                for (var i = 0; i < _this.keySalesDriversDataList.length; i++) {
                    _this.platformTypeList.push(_this.keySalesDriversDataList[i].platform);
                }
                _this.platformTypeList.sort();
                _this.generateKeySalesDriversTabTopHtml();
                _this.gneratePlatformOptions();
                _this.generateKeySalesDriversTabTablesHtml();
                _this.initializeEvents();
                if (_this.platformTypeList.length > 1) {
                    $("#comp-insights-view-by-platform-wrapper").show();
                    $("#key-sales-drivers-title").hide();
                }
                else {
                    $("#comp-insights-view-by-platform-wrapper").hide();
                    $("#key-sales-drivers-title").show();
                }
            });
        };
        KeySalesDrivers.prototype.gneratePlatformOptions = function () {
            var product_val = this.wrapper.find("#platform-dropdown");
            product_val.empty();
            for (var i = 0; i < this.platformTypeList.length; i++) {
                var optionItem = jQuery('<option/>', { 'value': this.platformTypeList[i], 'text': this.parser.getPlatformTypeByAbbr(this.platformTypeList[i]) });
                if (this.platformTypeList[i] === 'ALL')
                    optionItem.prop('selected', true);
                product_val.append(optionItem);
            }
        };
        KeySalesDrivers.prototype.generateKeySalesDriversTabTopHtml = function () {
            var html1 = '';
            if (this.keySalesDriversData === null) {
                html1 = '<div class="comp-insights-key-sales-drivers-headers">No Data for ' + CompInsights.Strings.KEY_DRIVERS + ' !' + '</div>';
                jQuery("#driversTab").html(html1);
                return;
            }
            this.analyticsMatchupsData = this.keySalesDriversData.analyticsMatchups;
            html1 = '<div class="comp-insights-key-sales-drivers-headers"></div>';
            html1 += '<div id="key-sales-drivers-title" class="comp-insights-key-sales-drivers-headers-title">Key Sales Drivers</div>';
            html1 += '<div id="comp-insights-view-by-platform-wrapper"><div class="comp-insights-view-title">View by platform</div>';
            html1 += '<div class="dropdown-wrapper comp-insights-dropdown-title"><div class="select-wrapper"><select id="platform-dropdown" class="pointer-dropdown"></select></div></div></div>';
            html1 += this.generatePercentileHtml();
            //html += '<div><span class="comp-insights-key-sales-drivers-headers">' + Strings.KEY_SALES_DRIVERS + '<span>' + '</div>';
            html1 += '<br><div id = "tablesSection"></div>';
            jQuery("#driversTab").html(html1);
        };
        KeySalesDrivers.prototype.generateKeySalesDriversTabTablesHtml = function () {
            var _this = this;
            var html = '';
            var keyDriversHtml = '';
            if (this.keySalesDriversData.keyDrivers.length != 0) {
                keyDriversHtml += '<table class="table table-condensed"><tr class="comp-insights-key-drivers-header">';
                keyDriversHtml += '<th class="comp-insights-key-drivers-description-td"><div>&nbsp;</div><div><span>' + CompInsights.Strings.KEY_DRIVERS + "</span></div></th>";
                keyDriversHtml += '<th class="comp-insights-key-drivers-td"><div>&nbsp;</div><div><span>' + CompInsights.Strings.YOUR_FUND + '</span></div></th>';
                keyDriversHtml += '<th class="comp-insights-key-drivers-td"><div><span>' + CompInsights.Strings.COMPETITIVE + '</span></div><div><span>' + CompInsights.Strings.FUNDS + '</span></div></th>';
                keyDriversHtml += '<th class="comp-insights-key-drivers-td"><div>&nbsp;</div><div><span>' + CompInsights.Strings.DIFFERENCE + "</span></div></th>";
                keyDriversHtml += '<th class="comp-insights-key-drivers-td"><div><span>' + CompInsights.Strings.PERCENT + '</span></div><div><span>' + CompInsights.Strings.DIFFERENCE + "</span></div></th>";
                keyDriversHtml += '<th class="comp-insights-key-drivers-td"><div>&nbsp;</div><div><span class="comp-insights-key-drivers-percentile-td-header">' + CompInsights.Strings.PERCENTILE + "</span></div></th>" + "</tr>";
                keyDriversHtml += "<tbody>";
                if (this.keySalesDriversData.keyDrivers !== null) {
                    this.keySalesDriversData.keyDrivers.forEach(function (row) {
                        var descStr = row.descriptionUnit ? row.description + ' (' + row.descriptionUnit + ')' : row.description;
                        keyDriversHtml += '<tr class="comp-insights-key-drivers-line"><td class="comp-insights-key-drivers-description-td"><span>' + descStr + '</span>';
                        keyDriversHtml += '<span class="comp-insights-key-drivers-box">' + CompInsights.Strings.KEY_DRIVERS + '</span></td>';
                        keyDriversHtml += _this.generateKeySalesDriversTdHtml(row.yourFund, false, false, row.descriptionUnit, false) + _this.generateKeySalesDriversTdHtml(row.competitiveFunds, false, false, row.descriptionUnit);
                        keyDriversHtml += _this.generateDifferenceColumn(row);
                        keyDriversHtml += _this.generatePercentDifferenceColumn(row);
                        keyDriversHtml += _this.generateKeySalesDriversTdHtml(row.percentile, true, false, null, false) + '</tr>';
                    });
                }
                keyDriversHtml += '</tbody></table>';
            }
            else {
                keyDriversHtml += '<br><br><div>&nbsp;' + CompInsights.Strings.NO_KEY_SALES_DRIVERS_DATA_NOTE + '</div>';
            }
            keyDriversHtml += '<div style="height:20px;"></div>';
            var largestAdvantageHtml = '<table class="table table-condensed"><tr class="comp-insights-key-drivers-header">';
            largestAdvantageHtml += '<th class="comp-insights-key-drivers-description-td"><div>&nbsp;</div><div><span>' + CompInsights.Strings.LARGEST_ADVANTAGE + "</span></div></th>";
            largestAdvantageHtml += '<th class="comp-insights-key-drivers-td"><div>&nbsp;</div><div><span>' + CompInsights.Strings.YOUR_FUND + '</span></div></th>';
            largestAdvantageHtml += '<th class="comp-insights-key-drivers-td"><div><span>' + CompInsights.Strings.COMPETITIVE + '</span></div><div><span>' + CompInsights.Strings.FUNDS + '</span></div></th>';
            largestAdvantageHtml += '<th class="comp-insights-key-drivers-td"><div>&nbsp;</div><div><span>' + CompInsights.Strings.DIFFERENCE + "</span></div></th>";
            largestAdvantageHtml += '<th class="comp-insights-key-drivers-td"><div><span>' + CompInsights.Strings.PERCENT + '</span></div><div><span>' + CompInsights.Strings.DIFFERENCE + "</span></div></th>";
            largestAdvantageHtml += '<th class="comp-insights-key-drivers-td"><div>&nbsp;</div><div><span class="comp-insights-key-drivers-percentile-td-header">' + CompInsights.Strings.PERCENTILE + "</span></div></th>" + "</tr>";
            largestAdvantageHtml += "<tbody>";
            this.keySalesDriversData.largestAdvantage.forEach(function (row) {
                var descStr = row.descriptionUnit ? row.description + ' (' + row.descriptionUnit + ')' : row.description;
                largestAdvantageHtml += '<tr class="comp-insights-key-drivers-line"><td class="comp-insights-key-drivers-description-td"><span>' + descStr + '</span>';
                largestAdvantageHtml += '<span class="comp-insights-largest-advantage-box">' + CompInsights.Strings.LARGEST_ADVANTAGE + '</span></td>';
                largestAdvantageHtml += _this.generateKeySalesDriversTdHtml(row.yourFund, false, false, null, false) + _this.generateKeySalesDriversTdHtml(row.competitiveFunds, false, false, row.descriptionUnit);
                largestAdvantageHtml += _this.generateDifferenceColumn(row);
                largestAdvantageHtml += _this.generatePercentDifferenceColumn(row);
                largestAdvantageHtml += _this.generateKeySalesDriversTdHtml(row.percentile, true, false, null, false) + '</tr>';
            });
            largestAdvantageHtml += '</tbody></table>';
            largestAdvantageHtml += '<div style="height:40px;"></div>';
            var analyticsMatchupsHtml = '<div class="comp-insights-key-analytics-headers">' + CompInsights.Strings.ANALYTICS_MATCHUPS + '</div><table class="table table-condensed"><tr class="comp-insights-key-drivers-header">';
            analyticsMatchupsHtml += '<th class="comp-insights-key-drivers-description-td"><div>&nbsp;</div><div><span>' + CompInsights.Strings.METRIC + '</span><span class="fa fa-sort comp-insights-key-drivers-sort" id="portalOrder"></span></div></th>';
            analyticsMatchupsHtml += '<th class="comp-insights-key-drivers-td"><div>&nbsp;</div><div><span>' + CompInsights.Strings.YOUR_FUND + '</span><span class="fa fa-sort comp-insights-key-drivers-sort" id="yourFund"></span></div></th>';
            analyticsMatchupsHtml += '<th class="comp-insights-key-drivers-td"><div>' + CompInsights.Strings.COMPETITIVE + '</div><div><span>' + CompInsights.Strings.FUNDS + '</span><span class="fa fa-sort comp-insights-key-drivers-sort" id="competitiveFunds"></span></div></th>';
            analyticsMatchupsHtml += '<th class="comp-insights-key-drivers-td"><div>&nbsp;</div><div><span>' + CompInsights.Strings.DIFFERENCE + '</span><span class="fa fa-sort comp-insights-key-drivers-sort" id="difference"></span></div></th>';
            analyticsMatchupsHtml += '<th class="comp-insights-key-drivers-td"><div>' + CompInsights.Strings.PERCENT + '</div><div><span>' + CompInsights.Strings.DIFFERENCE + '</span><span class="fa fa-sort comp-insights-key-drivers-sort" id="percentDifference"></span></div></th>';
            analyticsMatchupsHtml += '<th class="comp-insights-key-drivers-td"><div>&nbsp;</div><div>' + CompInsights.Strings.PERCENTILE + '<span class="fa fa-sort comp-insights-key-drivers-sort-last" id="percentile"></span></div></th>' + '</tr>';
            analyticsMatchupsHtml += '<tbody id="matchups">';
            analyticsMatchupsHtml += this.generateMatchupsHtml();
            analyticsMatchupsHtml += '</tbody></table>';
            analyticsMatchupsHtml += '<div style="height: 40px;"></div>';
            html += keyDriversHtml + largestAdvantageHtml + analyticsMatchupsHtml;
            jQuery("#tablesSection").html(html);
            this.initSortEvents();
        };
        KeySalesDrivers.prototype.generateMatchupsHtml = function () {
            var _this = this;
            var analyticsMatchupsHtml = '';
            this.analyticsMatchupsData.forEach(function (row) {
                var descStr = row.descriptionUnit ? row.description + ' (' + row.descriptionUnit + ')' : row.description;
                analyticsMatchupsHtml += '<tr class="comp-insights-key-drivers-line"><td class="comp-insights-key-drivers-description-td"><span>' + descStr + '</span>';
                if (row.isKeyDriver === true) {
                    analyticsMatchupsHtml += '<span class="comp-insights-key-drivers-box">' + CompInsights.Strings.KEY_DRIVERS + '</span>';
                }
                if (row.isLargestAdv === true) {
                    analyticsMatchupsHtml += '<span class="comp-insights-largest-advantage-box">' + CompInsights.Strings.LARGEST_ADVANTAGE + '</span>';
                }
                analyticsMatchupsHtml += '</td>';
                analyticsMatchupsHtml += _this.generateKeySalesDriversTdHtml(row.yourFund, false, false, row.descriptionUnit, false) + _this.generateKeySalesDriversTdHtml(row.competitiveFunds, false, false, row.descriptionUnit);
                analyticsMatchupsHtml += _this.generateDifferenceColumn(row);
                analyticsMatchupsHtml += _this.generateKeySalesDriversTdHtml(row.percentDifference, false, false, null, true, false, false);
                analyticsMatchupsHtml += _this.generateKeySalesDriversTdHtml(row.percentile, true, false, null, false) + '</tr>';
            });
            return analyticsMatchupsHtml;
        };
        KeySalesDrivers.prototype.generateDifferenceColumn = function (row) {
            var html = '';
            if (row.description.toUpperCase() === 'NET EXPENSE') {
                html += this.generateKeySalesDriversTdHtml(row.difference, false, true, row.descriptionUnit, false, true);
            }
            else {
                html += this.generateKeySalesDriversTdHtml(row.difference, false, true, row.descriptionUnit, false, row.isNegativeBetter);
            }
            return html;
        };
        KeySalesDrivers.prototype.generatePercentDifferenceColumn = function (row) {
            var html = '';
            if (row.difference < 0) {
                row.percentDifference = -Math.abs(row.percentDifference);
            }
            else {
                row.percentDifference = Math.abs(row.percentDifference);
            }
            if (row.description.toUpperCase() === 'NET EXPENSE') {
                html += this.generateKeySalesDriversTdHtml(row.percentDifference, false, false, null, true, true, true);
            }
            else {
                html += this.generateKeySalesDriversTdHtml(row.percentDifference, false, false, null, true, row.isNegativeBetter, true);
            }
            return html;
        };
        return KeySalesDrivers;
    }());
    CompInsights.KeySalesDrivers = KeySalesDrivers;
})(CompInsights || (CompInsights = {}));
var CompInsights;
(function (CompInsights) {
    var Platform = (function () {
        //private mockDataManager: MockData;
        function Platform(wrapper, service) {
            this.tabDataList = [{ tabId: "gross", updated: false }, { tabId: "net", updated: false }, { tabId: "aum", updated: false }];
            this.wrapper = wrapper;
            this.service = service;
            //this.mockDataManager = new MockData();
        }
        Platform.prototype.updatePlatform = function (firmName, category, portfolio) {
            var _this = this;
            $("#tabWheel").show();
            jQuery("#platformTab").html("");
            this.service.getPlatformBreakdown(firmName, category, portfolio).then(function (result) {
                $("#tabWheel").hide();
                _this.platformData = result;
                _this.grossData = _this.platformData.gross;
                _this.netData = _this.platformData.net;
                _this.aumData = _this.platformData.aum;
                _this.createChartData();
                _this.generatePlatformTabHtml();
            });
        };
        Platform.prototype.createChartData = function () {
            if (this.grossData !== undefined) {
                this.grossChartData = {
                    platformType: [],
                    client: [],
                    global: [],
                    greenSpace: [],
                    redSpace: [],
                    competitive: []
                };
                for (var i = 0; i < this.grossData.length; i++) {
                    this.grossChartData.platformType.push(this.grossData[i].platform);
                    this.grossChartData.client.push(this.grossData[i].clientSales);
                    this.grossChartData.global.push(this.grossData[i].globalSales);
                    this.grossChartData.greenSpace.push(this.grossData[i].greenSpace);
                    this.grossChartData.competitive.push(this.grossData[i].competitiveSales);
                }
            }
            if (this.netData !== undefined) {
                this.netChartData = {
                    platformType: [],
                    client: [],
                    global: [],
                    greenSpace: [],
                    redSpace: [],
                    competitive: []
                };
                for (var i = 0; i < this.netData.length; i++) {
                    this.netChartData.platformType.push(this.netData[i].platform);
                    this.netChartData.client.push(this.netData[i].clientSales);
                    this.netChartData.global.push(this.netData[i].globalSales);
                }
            }
            if (this.aumData !== undefined) {
                this.aumChartData = {
                    platformType: [],
                    client: [],
                    global: [],
                    greenSpace: [],
                    redSpace: [],
                    competitive: []
                };
                for (var i = 0; i < this.aumData.length; i++) {
                    this.aumChartData.platformType.push(this.aumData[i].platform);
                    this.aumChartData.client.push(this.aumData[i].clientAum);
                    this.aumChartData.global.push(this.aumData[i].globalAum);
                    this.aumChartData.greenSpace.push(this.aumData[i].greenSpaceAum);
                    this.aumChartData.redSpace.push(this.aumData[i].redSpace);
                    this.aumChartData.competitive.push(this.aumData[i].competitiveAum);
                }
            }
        };
        Platform.prototype.generatePlatformTabHtml = function () {
            var html = '';
            if (this.platformData === null || this.platformData.gross === null || this.platformData.gross.length === 0) {
                html = '<div class="comp-insights-key-sales-drivers-headers">No Data for ' + CompInsights.Strings.PLATFORM_BREAKDOWN + ' !' + '</div>';
                jQuery("#platformTab").html(html);
                return;
            }
            html += '<div class="comp-insights-platform-title">' + CompInsights.Strings.PLATFORM_TITLE + '</div>';
            html += '<div class="comp-insights-platform-tab-header">';
            html += '<a id="gross" class="active-tab-header">Gross Sales</a>';
            html += '<a id="net" class="inactive-tab-header">Net Sales</a>';
            html += '<a id="aum" class="inactive-tab-header">AUM</a>';
            html += '</div>';
            html += '<div style="height: 60px;"></div>';
            html += '<div id="grossTab">Gross Tab Contents</div>';
            html += '<div id="netTab">Net Tab Contents</div>';
            html += '<div id="aumTab">AUM Tab Contents</div>';
            jQuery("#platformTab").html(html);
            this.generateGrossTabHtml();
            this.generateNetTabHtml();
            this.generateAumTabHtml();
            this.initializePlatformTabsEvents();
            this.showHideTab("gross", true);
            this.showHideTab("net", false);
            this.showHideTab("aum", false);
            var greenRedSpaceWrapper = $('<div />', { 'class': 'green-red-space-wrapper', 'id': 'greenRedSpaceSection' });
            this.wrapper.find('#platformTab').append(greenRedSpaceWrapper);
            this.buildGreenRedSpace();
        };
        Platform.prototype.generateGrossTabHtml = function () {
            if (this.grossData === undefined || this.grossData.length === 0)
                return;
            var html = '<table class="table table-condensed ci-table ci-platform-table-a">';
            html += '<thead><tr><th>' + CompInsights.Strings.PLATFORM_TYPE + '</th>';
            html += '<th>' + CompInsights.Strings.PLATFORM_CLIENT + ' ' + CompInsights.Strings.PLATFORM_GROSS + ' ' + CompInsights.Strings.PLATFORM_SALES_TH + '</th>';
            html += '<th>' + CompInsights.Strings.PLATFORM_GLOBAL + ' ' + CompInsights.Strings.PLATFORM_SALES_TH + '</th>';
            html += '<th>' + CompInsights.Strings.PLATFORM_MARKET_SHARE + '</th>';
            html += '<th>' + CompInsights.Strings.PLATFORM_SALES_GREEN_SPACE + ' ' +
                '<span class="comp-insights-default-info-wrapper" >' +
                '<span class="glyphicon glyphicon-info-sign comp-insights-default-info-icon"> </span>' +
                '<div class="comp-insights-default-info-msg">' +
                '<p>' + CompInsights.Strings.INFO_SALES_GREEN_SPACE + '</p>' +
                '</div>' +
                '</span>' +
                '</th>';
            html += '<th>' + CompInsights.Strings.PLATFORM_RANK + '</th>';
            html += '<th>' + CompInsights.Strings.PLATFORM_PREVIOUS_RANK + '</th>';
            html += '<th>' + CompInsights.Strings.PLATFORM_PRODUCTS + '</th>';
            html += '</tr></thead>';
            html += '<tbody>';
            this.grossData.forEach(function (row) {
                var ls = [row.platform, row.clientSales, row.globalSales, row.marketShare, row.greenSpace, row.rank, row.previousRank, row.products];
                html += '<tr>';
                html += '<td>' + row.platform + '</td>';
                html += '<td>' + new LabelBuilder.SalesLabelBuilder(true, false).build(row.clientSales, true) + '</td>';
                html += '<td>' + new LabelBuilder.SalesLabelBuilder(true, false).build(row.globalSales, true) + '</td>';
                html += '<td>' + new LabelBuilder.PercentLabelBuilder(true, false).build(row.marketShare) + '</td>';
                html += '<td>' + new LabelBuilder.SalesLabelBuilder(true, false).build(row.greenSpace, true) + '</td>';
                html += '<td>' + row.rank + '</td>';
                html += '<td>' + row.previousRank + '</td>';
                html += '<td>' + row.products + '</td>';
                html += '</tr>';
            });
            html += '</tbody></table>';
            jQuery("#grossTab").html(html);
            this.generateChart('gross');
        };
        Platform.prototype.generateNetTabHtml = function () {
            if (this.netData === undefined || this.netData.length === 0)
                return;
            var html = '<table class="table table-condensed ci-table ci-platform-table-b">';
            html += '<thead><tr><th>' + CompInsights.Strings.PLATFORM_TYPE + '</th>';
            html += '<th>' + CompInsights.Strings.PLATFORM_CLIENT + ' ' + CompInsights.Strings.PLATFORM_NET + ' ' + CompInsights.Strings.PLATFORM_SALES_TH + '</th>';
            html += '<th>' + CompInsights.Strings.PLATFORM_GLOBAL + ' ' + CompInsights.Strings.PLATFORM_NET + ' ' + CompInsights.Strings.PLATFORM_SALES_TH + '</th>';
            html += '<th>' + CompInsights.Strings.PLATFORM_RANK + '</th>';
            html += '<th>' + CompInsights.Strings.PLATFORM_PREVIOUS_RANK + '</th>';
            html += '<th>' + CompInsights.Strings.PLATFORM_PRODUCTS + '</th>';
            html += '</tr></thead>';
            html += '<tbody>';
            // this.netData.forEach((row: PlatformNetSalesObj) => {
            //     html += '<tr><td style="text-align: left;">' + row.platform + '</td>' + '<td>' + row.clientSales + '</td>' + '<td>' + row.globalSales + '</td>';
            //     html += '<td>' + row.rank + '</td>' + '<td>' + row.previousRank + '</td>' + '<td>' + row.products + '</td></tr>';
            // });
            this.netData.forEach(function (row) {
                var ls = [row.platform, row.clientSales, row.globalSales, row.rank, row.previousRank, row.products];
                html += '<tr>';
                html += '<td>' + row.platform + '</td>';
                html += '<td>' + new LabelBuilder.SalesLabelBuilder(true, false).build(row.clientSales, true) + '</td>';
                html += '<td>' + new LabelBuilder.SalesLabelBuilder(true, false).build(row.globalSales, true) + '</td>';
                html += '<td>' + row.rank + '</td>';
                html += '<td>' + row.previousRank + '</td>';
                html += '<td>' + row.products + '</td>';
                html += '</tr>';
            });
            html += '</tbody></table>';
            jQuery("#netTab").html(html);
            this.generateChart('net');
        };
        Platform.prototype.generateAumTabHtml = function () {
            if (this.aumData === undefined || this.aumData.length === 0)
                return;
            var html = '<table class="table table-condensed ci-table ci-platform-table-a">';
            html += '<thead><tr><th>' + CompInsights.Strings.PLATFORM_TYPE + '</th>';
            html += '<th>' + CompInsights.Strings.PLATFORM_CLIENT + ' ' + CompInsights.Strings.PLATFORM_AUM + '</th>';
            html += '<th>' + CompInsights.Strings.PLATFORM_GLOBAL + ' ' + CompInsights.Strings.PLATFORM_AUM + '</th>';
            html += '<th>' + CompInsights.Strings.PLATFORM_MARKET_SHARE + '</th>';
            html += '<th>' + CompInsights.Strings.PLATFORM_AUM_GREEN_SPACE + ' ' +
                '<span class="comp-insights-default-info-wrapper" >' +
                '<span class="glyphicon glyphicon-info-sign comp-insights-default-info-icon"> </span>' +
                '<div class="comp-insights-default-info-msg">' +
                '<p>' + CompInsights.Strings.INFO_AUM_GREEN_SPACE + '</p>' +
                '</div>' +
                '</span>' +
                '</th>';
            html += '<th>' + CompInsights.Strings.PLATFORM_RANK + '</th>';
            html += '<th>' + CompInsights.Strings.PLATFORM_PREVIOUS_RANK + '</th>';
            html += '<th>' + CompInsights.Strings.PLATFORM_PRODUCTS + '</th>';
            html += '</tr></thead>';
            html += '<tbody>';
            // this.aumData.forEach((row: PlatformAUMObj) => {
            //     html += '<tr><td style="text-align: left;">' + row.platform + '</td>' + '<td>' + row.clientAum + '</td>' + '<td>' + row.globalAum + '</td>' + '<td>' + (row.marketShare * 100).toFixed(2) + '</td>';
            //     html += '<td>' + row.greenSpaceAum + '</td>' + '<td>' + row.rank + '</td>' + '<td>' + row.previousRank + '</td>' + '<td>' + row.products + '</td></tr>';
            // });
            this.aumData.forEach(function (row) {
                var ls = [row.platform, row.clientAum, row.globalAum, row.marketShare, row.greenSpaceAum, row.rank, row.previousRank, row.products];
                html += '<tr>';
                html += '<td>' + row.platform + '</td>';
                html += '<td>' + new LabelBuilder.SalesLabelBuilder(true, false, 2).build(row.clientAum, true) + '</td>';
                html += '<td>' + new LabelBuilder.SalesLabelBuilder(true, false, 2).build(row.globalAum, true) + '</td>';
                html += '<td>' + new LabelBuilder.PercentLabelBuilder(true, false).build(row.marketShare) + '</td>';
                html += '<td>' + new LabelBuilder.SalesLabelBuilder(true, false, 2).build(row.greenSpaceAum, true) + '</td>';
                html += '<td>' + row.rank + '</td>';
                html += '<td>' + row.previousRank + '</td>';
                html += '<td>' + row.products + '</td>';
                html += '</tr>';
            });
            html += '</tbody></table>';
            jQuery("#aumTab").html(html);
            this.generateChart('aum');
        };
        Platform.prototype.getGsRsIntervalValues = function (data1, data2) {
            var maxValue1 = Math.max.apply(Math, data1);
            var maxValue2 = Math.max.apply(Math, data2);
            var max = Math.abs(maxValue1 + maxValue2);
            var interval = 1;
            var k = Math.round(Math.log10(Math.abs(max)));
            var n = Math.pow(10, k);
            interval = Math.ceil(max / n) * Math.pow(10, k - 1);
            return interval;
        };
        Platform.prototype.getIntervalValue = function (data) {
            var minValue = Math.min.apply(Math, data);
            var maxValue = Math.max.apply(Math, data);
            var max = Math.abs(maxValue - minValue);
            var interval = 1;
            var k = Math.round(Math.log10(Math.abs(max)));
            var n = Math.pow(10, k);
            interval = Math.ceil(max / n) * Math.pow(10, k - 1);
            return interval;
        };
        Platform.prototype.generateChart = function (name) {
            var chartId;
            var tabName;
            var chartData;
            var chartTitle = '';
            var globalTitle = CompInsights.Strings.PLATFORM_GLOBAL;
            var clientTitle = CompInsights.Strings.PLATFORM_CLIENT;
            if (name === 'gross') {
                chartId = 'platform_gross_chart';
                tabName = 'grossTab';
                chartData = this.grossChartData;
                chartTitle = CompInsights.Strings.PLATFORM_GROSS + ' ' + CompInsights.Strings.PLATFORM_CHART_TITLE;
                globalTitle += ' ' + CompInsights.Strings.PLATFORM_SALES;
                clientTitle += ' ' + CompInsights.Strings.PLATFORM_GROSS + ' ' + CompInsights.Strings.PLATFORM_SALES;
            }
            else if (name === 'net') {
                chartId = 'platform_net_chart';
                tabName = 'netTab';
                chartData = this.netChartData;
                chartTitle = CompInsights.Strings.PLATFORM_NET + ' ' + CompInsights.Strings.PLATFORM_CHART_TITLE;
                globalTitle += ' ' + CompInsights.Strings.PLATFORM_NET + ' ' + CompInsights.Strings.PLATFORM_SALES;
                clientTitle += ' ' + CompInsights.Strings.PLATFORM_NET + ' ' + CompInsights.Strings.PLATFORM_SALES;
            }
            else if (name === 'aum') {
                chartId = 'platform_aum_chart';
                tabName = 'aumTab';
                chartData = this.aumChartData;
                chartTitle = CompInsights.Strings.PLATFORM_AUM_CHART_TITLE;
                globalTitle += ' ' + CompInsights.Strings.PLATFORM_AUM;
                clientTitle += ' ' + CompInsights.Strings.PLATFORM_AUM;
            }
            else {
                return;
            }
            if (chartData === undefined || chartData.client.length === 0 || chartData.global.length === 0)
                return;
            var intervalValue = this.getIntervalValue(chartData.global);
            var chartHeight = 150 + chartData.client.length * 70;
            var chartWrapper = $('<div/>', { 'id': chartId, 'class': 'comp_insights_platform_chart' });
            jQuery("#" + tabName).append(chartWrapper);
            var formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
            new Highcharts.Chart({
                chart: {
                    renderTo: chartWrapper.get(0),
                    type: 'bar',
                    zoomType: 'xy',
                    style: {
                        fontFamily: '\'Open Sans\',sans-serif !important',
                        fontSize: '15px',
                        fontWeight: '600'
                    },
                    height: chartHeight,
                    width: 1200
                },
                title: {
                    text: chartTitle,
                    style: {
                        fontSize: '18px',
                        fontWeight: '600'
                    }
                },
                tooltip: {
                    formatter: function () {
                        return this.x.replace('<br />', '') + '<br>' + this.series.name + ': ' + formatter.format(this.y);
                    }
                },
                credits: {
                    enabled: false
                },
                xAxis: {
                    categories: chartData.platformType,
                    gridLineWidth: 0,
                    lineWidth: 2,
                    lineColor: '#B7B7B7',
                    title: {
                        text: ''
                    },
                    labels: {
                        style: {
                            fontSize: '16px',
                            color: '#333 !important'
                        }
                    },
                },
                yAxis: {
                    title: {
                        text: ' ',
                        align: 'high',
                        style: {
                            fontSize: '15px',
                            color: '#333 !important',
                            fontWeight: '500'
                        }
                    },
                    gridLineWidth: 1,
                    lineWidth: 2,
                    lineColor: '#B7B7B7',
                    tickInterval: intervalValue,
                    labels: {
                        style: {
                            fontSize: '16px',
                            color: '#333 !important',
                            textOutline: 'none'
                        },
                        formatter: function () {
                            return new LabelBuilder.SalesLabelBuilder(true, false).build(this.value);
                        }
                    }
                },
                legend: {
                    //layout: 'vertical',
                    align: 'center',
                    itemStyle: {
                        cursor: 'default',
                        color: '#333 !important',
                        fontSize: '15px',
                        fontWeight: '500'
                    },
                    symbolRadius: 0,
                    symbolWidth: 15,
                    symbolHeight: 15
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true,
                            formatter: function () {
                                return formatter.format(this.y);
                            },
                            style: {
                                textOutline: 'none !important',
                                color: 'rgb(0, 0, 0) !important'
                            }
                        }
                    }
                },
                series: [{
                        data: chartData.global,
                        name: globalTitle
                    }, {
                        data: chartData.client,
                        name: clientTitle
                    }]
            });
        };
        Platform.prototype.initializePlatformTabsEvents = function () {
            var _this = this;
            jQuery("#gross").click(function () {
                _this.changePlatformTab("gross");
            });
            jQuery("#net").click(function () {
                _this.changePlatformTab("net");
            });
            jQuery("#aum").click(function () {
                _this.changePlatformTab("aum");
            });
            this.currentTab = "gross";
        };
        Platform.prototype.showHideTab = function (name, show) {
            var tabName = "#" + name + "Tab";
            if (show) {
                jQuery(tabName).show();
            }
            else {
                jQuery(tabName).hide();
            }
        };
        Platform.prototype.changePlatformTab = function (name) {
            this.currentTab = name;
            for (var i = 0; i < this.tabDataList.length; i++) {
                if (this.tabDataList[i].tabId === this.currentTab) {
                    jQuery("#" + this.tabDataList[i].tabId).attr("class", "active-tab-header");
                    this.showHideTab(this.tabDataList[i].tabId, true);
                }
                else {
                    jQuery("#" + this.tabDataList[i].tabId).attr("class", "inactive-tab-header");
                    this.showHideTab(this.tabDataList[i].tabId, false);
                }
            }
            this.buildGreenRedSpace();
        };
        Platform.prototype.buildGreenRedSpace = function () {
            var greenRedSpaceWrapper = this.wrapper.find("#greenRedSpaceSection");
            greenRedSpaceWrapper.empty();
            if (this.currentTab === 'net') {
                return;
            }
            var bShowRedspace = (this.currentTab === 'aum');
            var greenRedSpaceTabs = $('<ul />', { 'class': 'nav nav-tabs' });
            var greenSpaceTab = $('<li />', { 'class': 'comp-insights-green-red-tabs active' });
            if (this.currentTab === 'aum') {
                greenSpaceTab.append($('<a />', { 'data-toggle': 'tab', 'href': '#green-space-chart', 'html': 'AUM Green Space <span class="comp-insights-default-info-wrapper" ><span class="glyphicon glyphicon-info-sign comp-insight-green-red-space-info-icon"></span>' + ("<div class=\"comp-insights-default-info-msg\"> <p>  " + CompInsights.Strings.INFO_AUM_GREEN_SPACE + "  </p> </div></span>") }));
            }
            else {
                greenSpaceTab.append($('<a />', { 'data-toggle': 'tab', 'href': '#green-space-chart', 'html': 'Sales Green Space <span class="comp-insights-default-info-wrapper" ><span class="glyphicon glyphicon-info-sign comp-insight-green-red-space-info-icon"></span>' + ("<div class=\"comp-insights-default-info-msg\"> <p>  " + CompInsights.Strings.INFO_SALES_GREEN_SPACE + "  </p> </div></span>") }));
            }
            greenRedSpaceTabs.append(greenSpaceTab);
            if (bShowRedspace) {
                var redSpaceTab = $('<li />', { 'class': 'comp-insights-green-red-tabs' });
                redSpaceTab.append($('<a />', { 'data-toggle': 'tab', 'href': '#red-space-chart', 'html': 'AUM Red Space <span class="comp-insights-default-info-wrapper" ><span class="glyphicon glyphicon-info-sign comp-insight-green-red-space-info-icon"></span>'
                        + ("<div class=\"comp-insights-default-info-msg\">\n                <p>  " + CompInsights.Strings.INFO_RED_SPACE_MSG + " </p> \n                <ul>   \n                <li>  " + CompInsights.Strings.INFO_RED_SPACE_1 + " </li>\n                <li>  " + CompInsights.Strings.INFO_RED_SPACE_2 + " </li>\n                <li>  " + CompInsights.Strings.INFO_RED_SPACE_3 + " </li>\n                <li>  " + CompInsights.Strings.INFO_RED_SPACE_4 + " </li>\n                </ul> </div></span>") }));
                greenRedSpaceTabs.append(redSpaceTab);
            }
            var greenRedSpaceTabContent = $('<div />', { 'class': 'tab-content' });
            var greenSpaceContent = $('<div />', { 'id': 'green-space-chart', 'class': 'tab-pane fade in active' });
            greenRedSpaceTabContent.append(greenSpaceContent);
            if (bShowRedspace) {
                var redSpaceContent = $('<div />', { 'id': 'red-space-chart', 'class': 'tab-pane fade' });
                greenRedSpaceTabContent.append(redSpaceContent);
            }
            greenRedSpaceWrapper.append(greenRedSpaceTabs, greenRedSpaceTabContent);
            this.wrapper.find('#platformTab').append(greenRedSpaceWrapper);
            this.buildGreenRedSpaceChart(this.wrapper.find("#green-space-chart"), 'green');
            if (bShowRedspace)
                this.buildGreenRedSpaceChart(this.wrapper.find("#red-space-chart"), 'red');
        };
        Platform.prototype.buildGreenRedSpaceChart = function (chartWrapper, type) {
            var formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
            var colorCode = '#43A047';
            var salesWithAdv;
            var salesWithoutAdv;
            var platformTypes = this.grossChartData.platformType;
            var chartHeight = 80 + platformTypes.length * 60;
            var withoutAdvLabel = "";
            var withAdvLabel = "";
            if (type === 'red') {
                colorCode = '#D32F2F';
            }
            if (this.currentTab === 'aum') {
                withoutAdvLabel = CompInsights.Strings.COMP_ASSETS_WITHOUT_ADV_LABEL;
                salesWithoutAdv = this.aumChartData.competitive;
                if (type === 'red') {
                    salesWithAdv = this.aumChartData.redSpace;
                    withAdvLabel = CompInsights.Strings.RED_SPACE_COMP_ASSETS_WITH_ADV_LABEL;
                }
                else if (type === "green") {
                    salesWithAdv = this.aumChartData.greenSpace;
                    withAdvLabel = CompInsights.Strings.GREEN_SPACE_COMP_ASSETS_WITH_ADV_LABEL;
                }
                platformTypes = this.aumChartData.platformType;
            }
            else {
                salesWithAdv = this.grossChartData.greenSpace;
                salesWithoutAdv = this.grossChartData.competitive;
                withoutAdvLabel = CompInsights.Strings.COMP_SALES_WITHOUT_ADV_LABEL;
                withAdvLabel = CompInsights.Strings.GREEN_SPACE_COMP_SALES_WITH_ADV_LABEL;
            }
            var intervalValue = this.getGsRsIntervalValues(salesWithAdv, salesWithoutAdv);
            new Highcharts.Chart({
                chart: {
                    renderTo: chartWrapper.get(0),
                    type: 'bar',
                    style: {
                        fontFamily: '\'Open Sans\',sans-serif !important',
                        fontSize: '15px',
                        fontWeight: '600'
                    },
                    height: chartHeight,
                    width: 1200
                },
                title: {
                    text: ''
                },
                credits: {
                    enabled: false
                },
                tooltip: {
                    formatter: function () {
                        return this.x + '<br>' + this.series.name + ': ' + formatter.format(this.y);
                    }
                },
                xAxis: {
                    categories: platformTypes,
                    title: {
                        text: ''
                    },
                    gridLineWidth: 1,
                    lineWidth: 2,
                    lineColor: '#B7B7B7',
                    labels: {
                        style: {
                            fontSize: '16px',
                            color: '#333 !important'
                        }
                    }
                },
                yAxis: {
                    title: {
                        text: ' ',
                        align: 'high',
                        style: {
                            fontSize: '15px',
                            color: '#333 !important',
                            fontWeight: '500'
                        }
                    },
                    gridLineWidth: 0,
                    lineWidth: 2,
                    lineColor: '#B7B7B7',
                    tickInterval: intervalValue,
                    labels: {
                        style: {
                            fontSize: '16px',
                            color: '#333 !important',
                            textOutline: 'none'
                        },
                        formatter: function () {
                            return new LabelBuilder.SalesLabelBuilder(true, false).build(this.value);
                        }
                    },
                    stackLabels: {
                        enabled: true,
                        style: {
                            color: '#000',
                            fontSize: '11px'
                        },
                        formatter: function () {
                            return formatter.format(this.total);
                        }
                    }
                },
                legend: {
                    reversed: true,
                    itemStyle: {
                        cursor: 'default',
                        color: '#333 !important',
                        fontSize: '15px',
                        fontWeight: '500'
                    },
                    symbolRadius: 0,
                    symbolWidth: 15,
                    symbolHeight: 15,
                    margin: 0
                },
                plotOptions: {
                    series: {
                        stacking: 'normal',
                        dataLabels: {
                            enabled: true,
                            align: 'right',
                            style: {
                                fontSize: '11px',
                                textOutline: 'none'
                            },
                            formatter: function () {
                                return formatter.format(this.y);
                            }
                        }
                    }
                },
                series: [{
                        color: colorCode,
                        data: salesWithAdv,
                        name: withAdvLabel
                    }, {
                        color: '#37474F',
                        data: salesWithoutAdv,
                        name: withoutAdvLabel
                    }]
            });
        };
        return Platform;
    }());
    CompInsights.Platform = Platform;
})(CompInsights || (CompInsights = {}));
///<reference path="../../libs/jquery.d.ts"/>
///<reference path="00.data_types.ts" />
///<reference path="01.strings.ts" />
///<reference path="02.data_manager.ts" />
///<reference path="03.data.ts" />
///<reference path="04.service.ts" />
///<reference path="05.parser.ts" />
var CompInsights;
(function (CompInsights) {
    var Scatterplot = (function () {
        function Scatterplot(wrapper, service) {
            this.sortList = ['address', 'expected_sales', 'sales_green_space', 'client_gross_sales', 'global_gross_sales', 'market_share', 'client_net_sales', 'global_net_sales', 'client_aum', 'aum_industry', 'aum_green_space'];
            this.salesData = [];
            this.tooltipClone = null;
            this.tooltipContentClone = null;
            this.wrapper = wrapper;
            this.service = service;
            this.mockDataManager = new CompInsights.MockData();
            this.browserManager = new BrowserDetector.BrowserDetectorManager();
            this.chart = null;
        }
        Scatterplot.prototype.updateScatterplotTables = function (firmName, category, portfolio) {
            var _this = this;
            $("#tabWheel").show();
            Scatterplot.firmName = firmName;
            Scatterplot.portfolio = portfolio;
            this.xAxis = new CompInsights.AxisParameter('XAxis', CompInsights.AnalysisEnum.CLIENT_SALES);
            this.yAxis = new CompInsights.AxisParameter('YAxis', CompInsights.AnalysisEnum.EXPECTED_SALES);
            this.emptyWrappers();
            this.service.getScatterPlotData(firmName, portfolio, this.xAxis, this.yAxis).then(function (result) {
                _this.scatterplotData = result;
                _this.initialize();
                _this.salesData.splice(0, _this.salesData.length);
                result.forEach(function (row) {
                    row.data["address"] = row.name;
                    _this.salesData.push(row.data);
                });
                _this.generateFilterHtml();
                _this.generateTableHtml();
                _this.setFilterOptions();
                _this.update(_this.scatterplotData, false);
                _this.triggerChangeEvent();
                $("#tabWheel").hide();
            });
        };
        Scatterplot.prototype.setAxisValues = function () {
            var xEnumValue = CompInsights.AnalysisEnum[jQuery("#ws-parameter-scatterplot-filter-x-axis select").val().toUpperCase().replaceAll(' ', '_')];
            var yEnumValue = CompInsights.AnalysisEnum[jQuery("#ws-parameter-scatterplot-filter-y-axis select").val().toUpperCase().replaceAll(' ', '_')];
            this.xAxis = new CompInsights.AxisParameter('XAxis', parseInt(xEnumValue));
            this.yAxis = new CompInsights.AxisParameter('YAxis', parseInt(yEnumValue));
        };
        Scatterplot.prototype.refreshChart = function () {
            var _this = this;
            this.setAxisValues();
            $("#scatterplot-highcharts-wrapper").empty();
            $("#tabWheel").show();
            this.service.getScatterPlotData(Scatterplot.firmName, Scatterplot.portfolio, this.xAxis, this.yAxis).then(function (result) {
                _this.scatterplotData = result;
                _this.initialize();
                _this.update(_this.scatterplotData, false);
                $("#tabWheel").hide();
            });
        };
        Scatterplot.prototype.emptyWrappers = function () {
            $("#scatterplot-filter-wrapper").empty();
            $(".comp-insight-table-wrapper").empty();
            $("#scatterplot-highcharts-wrapper").empty();
        };
        Scatterplot.prototype.generateFilterHtml = function () {
            var filterWrapper = jQuery("#scatterplot-filter-wrapper");
            if (filterWrapper.children().length === 0) {
                var wrapper = jQuery('<div/>', {
                    'id': 'scatterplot-wrapper',
                    'class': 'top-controls open-sans top-controls-non-mobile hidden-xs enabled'
                });
                wrapper.append(this.generateAxisFilters("x-axis", "X Axis: "));
                wrapper.append(this.generateAxisFilters("y-axis", "Y Axis: "));
                filterWrapper.append(wrapper);
                this.generateButtonHtml();
            }
        };
        Scatterplot.prototype.generateChartButtonHtml = function () {
            var filterWrapper = jQuery("#scatterplot-filter-wrapper");
            var btnGroupWrapper = jQuery('<div/>', {
                'class': 'scatterplot-btn-group'
            });
            var btnWrapper = jQuery('<button/>', {
                'type': 'button',
                'id': 'scatterplot-chart-button',
                'class': 'btn btn-default btn-lg-custom btn-sm-xs-custom vertical-composed',
                'title': 'Chart Visualization'
            });
            filterWrapper.append(btnGroupWrapper);
            btnGroupWrapper.append(btnWrapper);
            var chatDiv = jQuery('<div/>', {
                'class': 'visualization-chart'
            });
            var chatIcon = jQuery('<div/>', {
                'class': 'visualization-icon fa-lg fa fa-bar-chart-o keep-selected'
            });
            var chatText = jQuery('<div/>', {
                'class': 'visualization-label action-label open-sans opaque-65',
                'text': 'Chart'
            });
            btnWrapper.append(chatDiv);
            chatDiv.append(chatIcon);
            chatIcon.append(chatText);
        };
        Scatterplot.prototype.generateButtonHtml = function () {
            this.generateChartButtonHtml();
            var btnGroupWrapper = jQuery(".scatterplot-btn-group");
            var btnWrapper = jQuery('<button/>', {
                'type': 'button',
                'id': 'scatterplot-table-button',
                'class': 'btn btn-default btn-lg-custom btn-sm-xs-custom vertical-composed',
                'title': 'Table Visualization'
            });
            btnGroupWrapper.append(btnWrapper);
            var tableDiv = jQuery('<div/>', {
                'class': 'visualization-table'
            });
            var tableIcon = jQuery('<div/>', {
                'class': 'visualization-icon fa fa-table fa-lg'
            });
            var tableText = jQuery('<div/>', {
                'class': 'visualization-label action-label open-sans opaque-65',
                'text': 'Table'
            });
            btnWrapper.append(tableDiv);
            tableDiv.append(tableIcon);
            tableIcon.append(tableText);
        };
        Scatterplot.prototype.triggerButton = function () {
            $("#scatterplot-table-button").click(function (e) {
                $(".comp-insight-table-wrapper").removeClass('display-none');
                $(".comp-insight-chart-wrapper").addClass('display-none');
                $("#scatterplot-chart-button .visualization-icon").removeClass('keep-selected');
                $("#scatterplot-table-button .visualization-icon").addClass('keep-selected');
                $("#ws-parameter-scatterplot-filter-x-axis select").prop("disabled", true).addClass('keep-disabled');
                $("#ws-parameter-scatterplot-filter-y-axis select").prop("disabled", true).addClass('keep-disabled');
                $(".ws-scatterplot-filter-parameter-wrapper").addClass('display-none');
            });
            $("#scatterplot-chart-button").click(function (e) {
                $(".comp-insight-table-wrapper").addClass('display-none');
                $(".comp-insight-chart-wrapper").removeClass('display-none');
                $("#scatterplot-chart-button .visualization-icon").addClass('keep-selected');
                $("#scatterplot-table-button .visualization-icon").removeClass('keep-selected');
                $("#ws-parameter-scatterplot-filter-x-axis select").prop("disabled", false).removeClass('keep-disabled');
                $("#ws-parameter-scatterplot-filter-y-axis select").prop("disabled", false).removeClass('keep-disabled');
                $(".ws-scatterplot-filter-parameter-wrapper").removeClass('display-none');
            });
        };
        Scatterplot.prototype.generateTableHtml = function () {
            var _this = this;
            var wrapper = jQuery(".comp-insight-table-wrapper");
            wrapper.html("");
            var tableWrapper = $("<div>", {
                'id': "scatterplot-table-wrapper", 'class': "comp-insight-scatterplot-table-wrapper"
            });
            var scatterplotTable = $("<table>", {
                'class': 'table table-condensed ci-table scatterplot-table'
            });
            wrapper.append(tableWrapper);
            var thead = $('<thead>');
            var tableHeader = $('<tr>', { 'class': 'comp-insight-territory-tr' });
            tableHeader.append($('<th>', { 'class': 'ci-table-first-column ci-scatterplot-header-first-column' }).append('<span> ' + CompInsights.Strings.TERRITORY + '</span>').append('<span class="fa fa-sort " id="' + this.sortList[0] + '"></span>'));
            tableHeader.append($('<th>', { 'class': 'ci-scatterplot-header-middle-column' }).append('<span> ' + CompInsights.Strings.EXPECTED_SALES_HEADER + '</span>').append('<span class="fa fa-sort " id="' + this.sortList[1] + '"></span>'));
            tableHeader.append($('<th>', { 'class': 'ci-scatterplot-header-other-column' }).append('<span>' + CompInsights.Strings.SALES_GREEN_SPACE_HEADER + '</span>').append('<span class="fa fa-sort " id="' + this.sortList[2] + '"></span>'));
            tableHeader.append($('<th>', { 'class': 'ci-scatterplot-header-middle-column' }).append('<span>' + CompInsights.Strings.CLIENT_GROSS_SALES_HEADER + '</span>').append('<span class="fa fa-sort " id="' + this.sortList[3] + '"></span>'));
            tableHeader.append($('<th>', { 'class': 'ci-scatterplot-header-other-column' }).append('<span>' + CompInsights.Strings.GLOBAL_GROSS_SALES_HEADER + '</span>').append('<span class="fa fa-sort " id="' + this.sortList[4] + '"></span>'));
            tableHeader.append($('<th>', { 'class': 'ci-scatterplot-header-small-column' }).append('<span>' + CompInsights.Strings.MARKET_SHARE_HEADER + '</span>').append('<span class="fa fa-sort " id="' + this.sortList[5] + '"></span>'));
            tableHeader.append($('<th>', { 'class': 'ci-scatterplot-header-other-column' }).append('<span>' + CompInsights.Strings.CLIENT_NET_SALES_HEADER + '</span>').append('<span class="fa fa-sort " id="' + this.sortList[6] + '"></span>'));
            tableHeader.append($('<th>', { 'class': 'ci-scatterplot-header-other-column' }).append('<span>' + CompInsights.Strings.GLOBAL_NET_SALES_HEADER + '</span>').append('<span class="fa fa-sort " id="' + this.sortList[7] + '"></span>'));
            tableHeader.append($('<th>', { 'class': 'ci-scatterplot-header-other-column' }).append('<span>' + CompInsights.Strings.CLIENT_AUM_HEADER + '</span>').append('<span class="fa fa-sort " id="' + this.sortList[8] + '"></span>'));
            tableHeader.append($('<th>', { 'class': 'ci-scatterplot-header-other-column' }).append('<span>' + CompInsights.Strings.INDUSTRY_AUM_HEADER + '</span>').append('<span class="fa fa-sort " id="' + this.sortList[9] + '"></span>'));
            tableHeader.append($('<th>', { 'class': 'ci-scatterplot-header-other-column' }).append('<span>' + CompInsights.Strings.AUM_GREEN_SPACE_HEADER + '</span>').append('<span class="fa fa-sort " id="' + this.sortList[10] + '"></span>'));
            tableHeader.append($('<th>', { 'class': 'ci-table-header-dummy-column' }).append('<span></span>'));
            tableHeader.appendTo(thead);
            thead.appendTo(scatterplotTable);
            var tbody = $('<tbody>', { 'class': 'comp-insight-territory-tbody' });
            this.salesData.forEach(function (row) {
                var tableRow = $('<tr>');
                tableRow.append($('<td>', { 'class': 'ci-table-first-column ci-scatterplot-table-first-column' }).text(row.address));
                tableRow.append(_this.generateTdHtml(row.expected_sales));
                tableRow.append(_this.generateTdHtml(row.sales_green_space));
                tableRow.append(_this.generateTdHtml(row.client_gross_sales));
                tableRow.append(_this.generateTdHtml(row.global_gross_sales));
                tableRow.append(_this.generateTdHtml(row.market_share, 'percentage'));
                tableRow.append(_this.generateTdHtml(row.client_net_sales));
                tableRow.append(_this.generateTdHtml(row.global_net_sales));
                tableRow.append(_this.generateTdHtml(row.client_aum));
                tableRow.append(_this.generateTdHtml(row.aum_industry));
                tableRow.append(_this.generateTdHtml(row.aum_green_space));
                tableRow.appendTo(tbody);
            });
            scatterplotTable.append(tbody);
            tableWrapper.append(scatterplotTable);
            this.initSortEvents();
        };
        Scatterplot.prototype.formatter = function (value, digits) {
            var sequence = [
                { value: 1, symbol: "" },
                { value: 1E3, symbol: "k" },
                { value: 1E6, symbol: "M" },
                { value: 1E9, symbol: "B" },
                { value: 1E12, symbol: "T" },
                { value: 1E15, symbol: "P" },
                { value: 1E18, symbol: "E" }
            ];
            var regx = /\.0+$|(\.[0-9]*[1-9])0+$/;
            var i;
            for (i = sequence.length - 1; i > 0; i--) {
                if (value >= sequence[i].value) {
                    break;
                }
            }
            return (value / sequence[i].value).toFixed(digits).replace(regx, "$1") + sequence[i].symbol;
        };
        Scatterplot.prototype.generateTdHtml = function (value, dataType) {
            var tableRow;
            if (value !== null) {
                var formattedValue = '';
                var formattedColor = '';
                if (dataType == 'percentage') {
                    formattedValue = this.formatPercentage(value);
                }
                else {
                    formattedValue = new LabelBuilder.SalesLabelBuilder(true, false).build(value, true);
                }
                if (value < 0) {
                    formattedColor = 'ci-red-cell';
                }
                if (dataType == 'percentage') {
                    tableRow = $('<td>', { 'class': 'ci-scatterplot-table-small-column ' + formattedColor }).append('<span>' + formattedValue + '</span>');
                }
                else {
                    tableRow = $('<td>', { 'class': 'ci-scatterplot-table-other-column ' + formattedColor }).append('<span>' + formattedValue + '</span>');
                }
            }
            return tableRow;
        };
        Scatterplot.prototype.formatDollarValue = function (value) {
            var formattedValue = '';
            if (value >= 0) {
                formattedValue = '$' + this.formatter(value, 2);
            }
            else if (value < 0) {
                var positiveValue = value.toString().replace('-', '');
                formattedValue = '($' + this.formatter(parseInt(positiveValue), 2) + ')';
            }
            return formattedValue;
        };
        Scatterplot.prototype.formatPercentage = function (value) {
            var formattedValue = '';
            if (value >= 0) {
                formattedValue = (Math.abs(value).toFixed(2)).toString() + '%';
            }
            else if (value < 0) {
                formattedValue = ('(' + (Math.abs(value).toFixed(2)).toString() + '%' + ')').replace('-', '');
            }
            return formattedValue;
        };
        Scatterplot.prototype.initSortEvents = function () {
            var _this = this;
            for (var i = 0; i < this.sortList.length; i++) {
                jQuery('#' + this.sortList[i]).off().on('click', function (e) {
                    _this.sortFunctions(e);
                });
            }
        };
        Scatterplot.prototype.sortFunctions = function (e) {
            var id = e.currentTarget.id;
            if (!id)
                return;
            var modifiedClass;
            var reverseSort = false;
            var classAttribute = jQuery('#' + id).attr('class');
            var classArray = classAttribute.split(' ');
            if (classArray[1] === 'fa-sort') {
                if (id === 'address') {
                    // low -> high -> low
                    modifiedClass = 'fa fa-sort-up ' + classArray[2];
                }
                else {
                    //high -> low -> high
                    modifiedClass = 'fa fa-sort-down ' + classArray[2];
                    reverseSort = true;
                }
            }
            else if (classArray[1] === "fa-sort-up") {
                modifiedClass = 'fa fa-sort-down ' + classArray[2];
                reverseSort = true;
            }
            else {
                modifiedClass = 'fa fa-sort-up ' + classArray[2];
            }
            this.salesData.sort(this.compareValues(id));
            if (reverseSort) {
                this.salesData.reverse();
            }
            this.generateTableHtml();
            jQuery('#' + id).attr('class', modifiedClass);
            for (var i = 0; i < this.sortList.length; i++) {
                if (id !== this.sortList[i]) {
                    jQuery('#' + this.sortList[i]).attr('class', 'fa fa-sort ');
                }
            }
        };
        Scatterplot.prototype.compareValues = function (propertyName) {
            return function (a, b) {
                var aa = a[propertyName];
                var bb = b[propertyName];
                if (typeof aa === "number") {
                    return aa - bb;
                }
                if (typeof aa === "string") {
                    return aa.localeCompare(bb);
                }
                return 0;
            };
        };
        Scatterplot.prototype.setFilterOptions = function () {
            jQuery("#ws-parameter-scatterplot-filter-x-axis").find('select').val("Client Sales");
            jQuery("#ws-parameter-scatterplot-filter-x-axis").find('select').find('option[value="Expected Sales"]').attr('disabled', 'disabled');
            jQuery("#ws-parameter-scatterplot-filter-y-axis").find('select').val("Expected Sales");
            jQuery("#ws-parameter-scatterplot-filter-y-axis").find('select').find('option[value="Client Sales"]').attr('disabled', 'disabled');
        };
        Scatterplot.prototype.triggerChangeEvent = function () {
            this.triggerFilterEvent();
            this.triggerButton();
            this.triggerExpectedSalesSort();
            $("#scatterplot-chart-button").click();
        };
        Scatterplot.prototype.triggerExpectedSalesSort = function () {
            if ($("#expected_sales").hasClass("fa-sort")) {
                $("#expected_sales").trigger('click');
            }
        };
        Scatterplot.prototype.addTooltipListener = function () {
            var self = this;
            $(document).on('click', '.comp-insight-scatterplot-tooltip-link', function (e) {
                e.preventDefault();
                var action = $(e.currentTarget).attr('id');
                switch (action) {
                    case 'scatterplot-link-office':
                        self.viewOfficeData(e);
                        break;
                    case 'scatterplot-link-territory':
                        self.refreshChart();
                        break;
                    case 'scatterplot-link-close':
                        self.closeTooltip();
                        break;
                }
            });
        };
        Scatterplot.prototype.closeTooltip = function () {
            // Removing hover tooltip...
            if (this.chart.tooltip) {
                this.chart.tooltip.hide();
            }
            // Removing cloned tooltip...
            if (this.tooltipClone) {
                this.chart.container.firstChild.removeChild(this.tooltipClone);
                this.tooltipClone = null;
            }
            // Removing cloned content tooltip...
            if (this.tooltipContentClone) {
                this.tooltipContentClone.remove();
                this.tooltipContentClone = null;
            }
        };
        Scatterplot.prototype.viewOfficeData = function (e) {
            var _this = this;
            this.setAxisValues();
            $("#scatterplot-highcharts-wrapper").empty();
            $("#tabWheel").show();
            var territoryDimension = $(e.currentTarget).prev().children().first().children().last().text();
            this.service.getScatterPlotOfficeData(Scatterplot.firmName, Scatterplot.portfolio, territoryDimension, this.xAxis, this.yAxis).then(function (result) {
                _this.scatterplotData = result;
                _this.initialize();
                _this.update(_this.scatterplotData, true, territoryDimension);
                $("#tabWheel").hide();
            });
        };
        Scatterplot.prototype.triggerFilterEvent = function () {
            var _this = this;
            jQuery(".ws-filter-list-parameter-dropdown select").change(function () {
                jQuery(".ws-filter-list-parameter-dropdown select").not(this).find('option[value=' + '"' + jQuery(this).val() + '"]')
                    .attr('disabled', 'disabled').siblings().removeAttr('disabled');
                _this.refreshChart();
            });
        };
        Scatterplot.prototype.generateAxisFilters = function (axis, text) {
            var wrapper = jQuery('<div/>', {
                'id': 'ws-parameter-scatterplot-filter-' + axis,
                'class': 'ws-filter-list-parameter-wrapper ws-scatterplot-filter-parameter-wrapper'
            });
            var div = jQuery('<div/>', { 'class': 'ws-filter-list-parameter-label', 'text': text });
            wrapper.append(div);
            var xdropDownWrapper = jQuery('<div/>', { 'class': 'filter-control ws-filter-list-parameter-dropdown' });
            var selectWrapper = jQuery('<select/>', { 'class': 'form-control dropdown-formatter' });
            selectWrapper.append(this.createSelectOptions());
            xdropDownWrapper.append(selectWrapper);
            wrapper.append(xdropDownWrapper);
            return wrapper;
        };
        Scatterplot.prototype.createSelectOptions = function () {
            var values = this.mockDataManager.getOptionsMockData();
            return values.map(function (option) {
                return jQuery('<option/>', {
                    'text': option.formattedValue || option.value,
                    'value': option.formattedValue
                });
            });
        };
        Scatterplot.prototype.initialHeight = function () {
            return Math.min(Math.max(Scatterplot.MIN_HEIGHT, this.getTopWindowHeight() - Scatterplot.TOP_WINDOW_PADDING), Scatterplot.MAX_HEIGHT);
        };
        Scatterplot.prototype.getTopWindowHeight = function () {
            return $("#scatterplot-highcharts-wrapper").height();
        };
        Scatterplot.prototype.removeClonedTooltip = function () {
            // Removing cloned tooltip...
            if (this.tooltipClone) {
                this.chart.container.firstChild.removeChild(this.tooltipClone);
                this.tooltipClone = null;
            }
            // Removing cloned content tooltip...
            if (this.tooltipContentClone) {
                this.tooltipContentClone.remove();
                this.tooltipContentClone = null;
            }
        };
        Scatterplot.prototype.axisFormatter = function (axisLabel) {
            var defaultLabel = axisLabel.axis.defaultLabelFormatter.call(axisLabel);
            Scatterplot.NUMERIC_SYMBOLS.forEach(function (symbol) {
                defaultLabel = defaultLabel.replace(symbol, '');
            });
            var splited = defaultLabel.split(' ');
            if (splited.length > 1) {
                var pattern = '0.{0}a';
                var decimals = '';
                var count = 0;
                splited.forEach(function (current) {
                    if (count !== 0) {
                        var size = Math.min(current.length, 3);
                        for (var i = 0; i < size; i++) {
                            decimals += '0';
                        }
                    }
                    count++;
                });
                var regex = String.format(pattern, decimals);
                return this.formatDollarValue(axisLabel.value);
            }
            else {
                return axisLabel.axis.defaultLabelFormatter.call(axisLabel);
            }
        };
        Scatterplot.prototype.formattedValuesForChart = function (value, axis) {
            var formattedValue = '';
            var dataType;
            if (axis === 'x-axis') {
                dataType = jQuery('#ws-parameter-scatterplot-filter-x-axis select').find(":selected").text() === 'Market Share' ? 'percentage' : 'dollar';
            }
            else {
                dataType = jQuery('#ws-parameter-scatterplot-filter-y-axis select').find(":selected").text() === 'Market Share' ? 'percentage' : 'dollar';
            }
            if (dataType == 'percentage') {
                var tempValue = value / 100;
                formattedValue = new LabelBuilder.PercentLabelBuilder(true, true).build(tempValue);
            }
            else {
                formattedValue = new LabelBuilder.SalesLabelBuilder(true, true).build(value, true);
            }
            return formattedValue;
        };
        Scatterplot.prototype.update = function (data, officeView, territory_name) {
            var xAxisName = this.xAxis.getKeyLabel();
            var yAxisName = this.yAxis.getKeyLabel();
            var xValues = data.map(function (current) {
                return current.x;
            });
            var xAccum = xValues.reduce(function (current, next) {
                return current + next;
            }, 0);
            var xAverage = xAccum === 0 ? 0 : xAccum / xValues.length;
            var yValues = data.map(function (current) {
                return current.y;
            });
            var yAccum = yValues.reduce(function (current, next) {
                return current + next;
            }, 0);
            var yAverage = yAccum === 0 ? 0 : yAccum / yValues.length;
            // Updating yAxis...
            this.chart.yAxis.first().update({
                title: {
                    text: yAxisName
                },
                plotLines: [{
                        color: '#6E6464',
                        dashStyle: 'ShortDot',
                        width: 2,
                        zIndex: 2,
                        value: yAverage,
                        label: {
                            text: "Average: " + this.formattedValuesForChart(yAverage, 'y-axis'),
                            align: 'right',
                            x: -10,
                            style: {
                                color: '#6E6464',
                                fontSize: '14px'
                            }
                        }
                    }]
            });
            // Updating xAxis...
            this.chart.xAxis.first().update({
                title: {
                    text: xAxisName
                },
                plotLines: [{
                        color: '#6E6464',
                        dashStyle: 'ShortDot',
                        width: 2,
                        zIndex: 2,
                        value: xAverage,
                        label: {
                            text: "Average: " + this.formattedValuesForChart(xAverage, 'x-axis'),
                            style: {
                                color: '#6E6464',
                                fontSize: '14px'
                            }
                        }
                    }]
            });
            // Updating tooltip...
            var self = this;
            this.chart.tooltip.options.formatter = function () {
                var wrapper = jQuery('<div/>', { 'class': 'comp-insight-scatterplot-tooltip-wrapper' });
                var tooltipList = jQuery('<ul/>', { 'class': 'list-unstyled comp-insight-scatterplot-tooltip-dimensions' });
                // Close button (only for Desktop)
                if (EnvironmentUtilities.BrowserDetector.isDesktop()) {
                    var closeButton = jQuery('<i/>', {
                        href: '#',
                        class: 'fa fa-times pull-right comp-insight-scatterplot-tooltip-link',
                        id: 'scatterplot-link-close'
                    });
                    wrapper.append(closeButton);
                }
                var territoryDimension;
                if (typeof territory_name !== 'undefined') {
                    territoryDimension = self.createdDimensionItem(CompInsights.Strings.TERRITORY, territory_name, false);
                }
                else {
                    territoryDimension = self.createdDimensionItem(CompInsights.Strings.TERRITORY, this.point.name, false);
                }
                tooltipList.append(territoryDimension);
                if (officeView) {
                    var officeDimension = self.createdDimensionItem(CompInsights.Strings.OFFICE, this.point.name, false);
                    tooltipList.append(officeDimension);
                }
                // Sales...
                var expectedSales = self.formatDollarValue(this.point.data.expected_sales);
                var salesGreenSpace = self.formatDollarValue(this.point.data.sales_green_space);
                var clientGrossSales = self.formatDollarValue(this.point.data.client_gross_sales);
                var globalGrossSales = self.formatDollarValue(this.point.data.global_gross_sales);
                var marketShare = self.formatPercentage(this.point.data.market_share);
                var clientNetSales = self.formatDollarValue(this.point.data.client_net_sales);
                var globalNetSales = self.formatDollarValue(this.point.data.global_net_sales);
                var clientAum = self.formatDollarValue(this.point.data.client_aum);
                var aumIndustry = self.formatDollarValue(this.point.data.aum_industry);
                var aumGreenSpace = self.formatDollarValue(this.point.data.aum_green_space);
                var expectedSalesItem = self.createdDimensionItem(CompInsights.Strings.SCATTERPLOT_EXPECTED_SALES, expectedSales, false);
                var salesGreenSpaceItem = self.createdDimensionItem(CompInsights.Strings.SALES_GREEN_SPACE_LABEL, salesGreenSpace, false);
                var clientGrossSalesItem = self.createdDimensionItem(CompInsights.Strings.CLIENT_GROSS_SALES_LABEL, clientGrossSales, false);
                var globalGrossSalesItem = self.createdDimensionItem(CompInsights.Strings.GLOBAL_GROSS_SALES_LABEL, globalGrossSales, false);
                var marketShareItem = self.createdDimensionItem(CompInsights.Strings.MARKET_SHARE_HEADER, marketShare, false);
                var clientNetSalesItem = self.createdDimensionItem(CompInsights.Strings.CLIENT_NET_SALES_LABEL, clientNetSales, false);
                var globalNetSalesItem = self.createdDimensionItem(CompInsights.Strings.GLOBAL_NET_SALES_LABEL, globalNetSales, false);
                var clientAumItem = self.createdDimensionItem(CompInsights.Strings.CLIENT_AUM_LABEL, clientAum, false);
                var aumIndustryItem = self.createdDimensionItem(CompInsights.Strings.INDUSTRY_AUM_LABEL, aumIndustry, false);
                var aumGreenSpaceItem = self.createdDimensionItem(CompInsights.Strings.AUM_GREEN_SPACE_LABEL, aumGreenSpace, false);
                tooltipList.append(clientGrossSalesItem, expectedSalesItem, globalGrossSalesItem, marketShareItem, salesGreenSpaceItem, clientNetSalesItem, globalNetSalesItem, clientAumItem, aumIndustryItem, aumGreenSpaceItem);
                wrapper.append(tooltipList);
                var link;
                if (officeView) {
                    link = self.createLink("Territory");
                    wrapper.append(link);
                }
                else {
                    link = self.createLink("Office");
                    wrapper.append(link);
                }
                wrapper.append('<br/>');
                return wrapper.outerHTML();
            };
            this.chart.series.first().update({ data: data });
            this.chart.zoomOut();
        };
        Scatterplot.prototype.createLink = function (name) {
            var id = 'scatterplot-link-' + name.toLowerCase();
            return jQuery('<a/>', {
                'href': '#',
                'text': name.toUpperCase(),
                'id': id,
                'class': 'comp-insight-scatterplot-tooltip-link'
            });
        };
        Scatterplot.prototype.createdDimensionItem = function (name, value, hasLink) {
            var item = jQuery('<li>');
            item.append(jQuery('<span/>', { 'class': 'semi-bold', text: name }));
            item.append(': ');
            var itemValue = jQuery('<span/>', {
                'class': 'comp-insight-tooltip-value text-overflow',
                text: value === null ? CompInsights.Strings.NOT_AVAILABLE : value
            });
            item.append(itemValue);
            if (hasLink) {
                itemValue.addClass('btn-link');
                itemValue.attr('click-action', 'office-link');
                itemValue.attr('data-office-name', value);
            }
            return item;
        };
        Scatterplot.prototype.initialize = function () {
            var height = this.initialHeight();
            Highcharts.setOptions({
                lang: {
                    numericSymbols: Scatterplot.NUMERIC_SYMBOLS,
                }
            });
            this.tooltipClone = null;
            this.tooltipContentClone = null;
            var self = this;
            // Overwrite Highcharts.Point onMouseOver
            if (EnvironmentUtilities.BrowserDetector.isDesktop()) {
                Highcharts.Point.prototype.onMouseOver = function (e, byProximity) {
                    var point = this, series = point.series, chart = series.chart, tooltip = chart.tooltip, hoverPoint = chart.hoverPoint;
                    // Including condition to open highcharts tooltip,
                    // only if cloned tooltip is not appearing
                    if (!self.tooltipClone && !self.tooltipContentClone) {
                        if (chart.hoverSeries !== series) {
                            series.onMouseOver();
                        }
                        if (hoverPoint && hoverPoint !== point) {
                            hoverPoint.onMouseOut();
                        }
                        if (point.series) {
                            // trigger the event
                            point.firePointEvent('mouseOver');
                            // update the tooltip
                            if (tooltip && (!tooltip.shared || series.noSharedTooltip)) {
                                tooltip.refresh(point, e);
                            }
                            // hover this
                            point.setState('hover');
                            if (!byProximity) {
                                chart.hoverPoint = point;
                            }
                        }
                    }
                };
            }
            this.chart = new Highcharts.Chart({
                chart: {
                    renderTo: this.wrapper.find("#scatterplot-highcharts-wrapper").get(0),
                    type: 'bubble',
                    zoomType: 'xy',
                    height: height,
                    plotBorderWidth: 1,
                    style: {
                        cursor: 'crosshair'
                    },
                    resetZoomButton: {
                        theme: {
                            fill: 'white',
                            stroke: '#000000',
                            r: 0,
                            states: {
                                hover: {
                                    fill: '#97BBCD',
                                    style: {
                                        color: '#000000'
                                    }
                                }
                            }
                        }
                    },
                    events: {
                        redraw: function () {
                            self.removeClonedTooltip();
                        },
                        click: function () {
                        }
                    }
                },
                credits: {
                    enabled: false
                },
                noData: {
                    useHTML: true,
                    style: {
                        fontFamily: '\'Open Sans\',sans-serif',
                        fontWeight: '500',
                        fontSize: '14px'
                    }
                },
                lang: {
                    noData: CompInsights.Strings.REVIEW_FILTERS_TITLE + '<br>' +
                        CompInsights.Strings.REVIEW_FILTERS_SUBTITLE
                },
                legend: {
                    enabled: false
                },
                title: {
                    text: ''
                },
                colors: [
                    '#97BBCD'
                ],
                xAxis: {
                    gridLineWidth: 1,
                    title: {
                        text: '',
                        style: {
                            fontFamily: '\'Open Sans\',sans-serif',
                            fontSize: '13px'
                        }
                    },
                    labels: {
                        style: {
                            fontFamily: '\'Open Sans\',sans-serif',
                            fontSize: '13px'
                        },
                        formatter: function () {
                            return self.axisFormatter(this);
                        }
                    }
                },
                yAxis: {
                    startOnTick: false,
                    endOnTick: false,
                    maxPadding: 0.2,
                    title: {
                        text: '',
                        style: {
                            fontFamily: '\'Open Sans\',sans-serif',
                            fontSize: '13px'
                        }
                    },
                    labels: {
                        style: {
                            fontFamily: '\'Open Sans\',sans-serif',
                            fontSize: '13px'
                        },
                        formatter: function () {
                            return self.axisFormatter(this);
                        }
                    }
                },
                tooltip: {
                    backgroundColor: '#FFFFFF',
                    borderColor: '#707070',
                    borderRadius: 5,
                    borderWidth: 2,
                    useHTML: true,
                    hideDelay: 0,
                    animation: false,
                    style: {
                        pointerEvents: 'all'
                    }
                },
                plotOptions: {
                    series: {
                        stickyTracking: true,
                        dataLabels: {
                            enabled: true,
                            format: '{point.name}',
                            verticalAlign: 'top',
                            y: 14,
                            style: {
                                fontFamily: '\'Open Sans\',sans-serif',
                                fontWeight: '500',
                                fontSize: '13px',
                                color: '#6E6464'
                            },
                        },
                        marker: {
                            symbol: 'diamond',
                            fillOpacity: 1,
                            states: {
                                hover: {
                                    lineColor: '#000000',
                                    lineWidth: 1
                                }
                            }
                        },
                        turboThreshold: 1000,
                        point: {
                            events: {
                                click: function (e) {
                                    if (!EnvironmentUtilities.BrowserDetector.isDesktop()) {
                                        return;
                                    }
                                    // Removing cloned tooltip...
                                    self.removeClonedTooltip();
                                    // Cloning...
                                    self.tooltipClone = this.series.chart.tooltip.label.element.cloneNode(true);
                                    self.tooltipContentClone = self.wrapper.find('.highcharts-tooltip').clone(true, true);
                                    // Appeding...
                                    self.chart.container.firstChild.appendChild(self.tooltipClone);
                                    $(self.chart.container).append(self.tooltipContentClone);
                                }
                            }
                        }
                    },
                    bubble: {
                        minSize: 22,
                        maxSize: 22
                    }
                },
                series: [{
                        data: []
                    }]
            });
            this.addTooltipListener();
        };
        Scatterplot.MIN_HEIGHT = 500;
        Scatterplot.MAX_HEIGHT = 600;
        Scatterplot.TOP_WINDOW_PADDING = 265;
        Scatterplot.NUMERIC_SYMBOLS = ['k', 'M', 'B', 'T', 'P', 'E'];
        return Scatterplot;
    }());
    CompInsights.Scatterplot = Scatterplot;
})(CompInsights || (CompInsights = {}));
///<reference path="../../libs/jquery.d.ts"/>
///<reference path="00.data_types.ts" />
///<reference path="01.strings.ts" />
///<reference path="02.data_manager.ts" />
///<reference path="03.data.ts" />
///<reference path="04.service.ts" />
///<reference path="05.parser.ts" />
var CompInsights;
(function (CompInsights) {
    var Opportunities = (function () {
        function Opportunities(wrapper, service) {
            this.sortIds = ['opp_assigned_territory_name', 'opp_market_share_diff', 'opp_percent_diff_expected_sales', 'opp_expected_sales', 'opp_actual_sales', 'opp_industry_gross_sales', 'opp_market_share', 'opp_sales_green_sapce', 'opp_net_sales', 'opp_industry_net_sales'];
            this.firmName = '';
            this.category = [];
            this.productPortfolio = '';
            this.opportunitiesDataList = [];
            this.wrapper = wrapper;
            this.service = service;
        }
        Opportunities.prototype.initializeEvents = function () {
            var _this = this;
            /* listen for select-all checkbox status */
            jQuery('#checkbox-select-all').click(function (event) {
                if (this.checked) {
                    jQuery('.oppocheckbox').each(function () {
                        this.checked = true;
                    });
                }
                else {
                    jQuery('.oppocheckbox').each(function () {
                        this.checked = false;
                    });
                }
            });
            var childCheckboxStatuses = [];
            jQuery('.oppocheckbox').change(function () {
                childCheckboxStatuses = [];
                jQuery('.oppocheckbox').each(function () {
                    if ($(this).attr('name') === 'checkbox')
                        childCheckboxStatuses.push(Boolean(this.checked));
                });
                var allselected = true;
                var allunselected = true;
                for (var i = 0; i < childCheckboxStatuses.length; i++) {
                    if (childCheckboxStatuses[i] === true) {
                        allunselected = false;
                    }
                    else {
                        allselected = false;
                    }
                }
                if (allselected) {
                    jQuery('#checkbox-select-all').prop('checked', true);
                }
                else if (allunselected) {
                    jQuery('#checkbox-select-all').prop('checked', false);
                }
            });
            /* listen for any checkbox status to update the export button */
            jQuery('.oppocheckbox').change(function () {
                var exportReady = false;
                jQuery('.oppocheckbox').each(function () {
                    if (this.checked) {
                        exportReady = true;
                    }
                });
                if (exportReady) {
                    var btn = jQuery("#opportunities-tab-export-button");
                    btn.removeAttr("disabled");
                    btn.html(CompInsights.Strings.EXPORT_BUTTON_READY_TEXT);
                }
                else {
                    var btn = jQuery("#opportunities-tab-export-button");
                    btn.attr('disabled', 'true');
                    btn.html(CompInsights.Strings.EXPORT_BUTTON_UNREADY_TEXT);
                }
            });
            jQuery("#opportunities-tab-export-button").click(function () {
                jQuery("#export-dialog").modal({ 'backdrop': 'static', 'show': true });
            });
            // to download zipped excel file
            jQuery("#export-opp").click(function (e) {
                var territories = [];
                jQuery('.oppocheckbox').each(function () {
                    if (this.checked && this.name != "mastercheckbox") {
                        var territory = this.id.substring(this.id.indexOf('-') + 1);
                        territories.push(territory);
                    }
                });
                var exportCategory = $('#opportunities-select-category').find(":selected").text();
                var exportType = $('#opportunities-select-dataset').find(":selected").text();
                var exportNumber = $('#opportunities-select-records').find(":selected").text();
                $("#exportWheel").show();
                _this.service.getZippedExcelFile(_this.firmName, _this.morningStarCategory, territories, exportCategory, exportType, exportNumber).then(function (result) {
                    var fileName = 'OppZippedExcelFile';
                    var url = '/downloadZippedExcelFile/' + result.token + '/' + fileName;
                    Utilities.openTab(url);
                    $("#exportWheel").hide();
                });
                e.stopImmediatePropagation();
            });
        };
        Opportunities.prototype.generateTdHtml = function (value, dataType) {
            if (dataType === void 0) { dataType = 'dollarValue'; }
            var html = '';
            if (value !== null) {
                var finalStr = '';
                var finalColor = '';
                if (dataType == 'dollarValue') {
                    finalStr = new LabelBuilder.SalesLabelBuilder(true, false).build(value, true);
                }
                else if (dataType == 'percentage') {
                    finalStr = new LabelBuilder.PercentLabelBuilder(true, false).build(value);
                    if (value < 0) {
                        finalStr = '(' + (Math.abs(value * 100)).toFixed(2) + '%)';
                    }
                    else {
                        finalStr = (value * 100).toFixed(2) + '%';
                    }
                }
                else if (dataType == 'percentNoDecimal') {
                    if (value < 0) {
                        finalStr = '(' + (Math.abs(value * 100)).toFixed(0) + '%)';
                    }
                    else {
                        finalStr = (value * 100).toFixed(0) + '%';
                    }
                }
                if (value < 0) {
                    finalColor = 'ci-red-cell';
                }
                html += '<td class="ci-opp-main-table-other-column ' + finalColor + '"><span>' + finalStr + '</span></td>';
            }
            else {
                html += '<td class="ci-opp-main-table-other-column"></td>';
            }
            return html;
        };
        Opportunities.prototype.initSortEvents = function () {
            var _this = this;
            for (var i = 0; i < this.sortIds.length; i++) {
                jQuery('#' + this.sortIds[i]).click(function (e) {
                    _this.sortFunctions(e);
                });
            }
        };
        Opportunities.prototype.sortFunctions = function (e) {
            var id = e.currentTarget.id;
            if (!id)
                return;
            var reverseSort = false;
            var origClass = jQuery('#' + id).attr('class');
            var newClass = '';
            var classArr = origClass.split(' ');
            if (classArr[1] === 'fa-sort') {
                if (id === 'territory') {
                    // low -> high -> low
                    newClass = 'fa fa-sort-up';
                }
                else {
                    //high -> low -> high
                    newClass = 'fa fa-sort-down';
                    reverseSort = true;
                }
            }
            else if (classArr[1] === "fa-sort-up") {
                newClass = 'fa fa-sort-down';
                reverseSort = true;
            }
            else {
                newClass = 'fa fa-sort-up';
            }
            this.opportunitiesDataList.sort(this.compareValues(id));
            if (reverseSort) {
                this.opportunitiesDataList.reverse();
            }
            this.generateOpportunitiesTabTablesHtml();
            jQuery('#' + id).attr('class', newClass);
            for (var i = 0; i < this.sortIds.length; i++) {
                if (id !== this.sortIds[i]) {
                    jQuery('#' + this.sortIds[i]).attr('class', 'fa fa-sort');
                }
            }
        };
        Opportunities.prototype.compareValues = function (propertyName) {
            return function (a, b) {
                var aa = a[propertyName];
                var bb = b[propertyName];
                if (typeof aa === "number") {
                    return aa - bb;
                }
                if (typeof aa === "string") {
                    return aa.localeCompare(bb);
                }
                return 0;
            };
        };
        Opportunities.prototype.initiateOpportunities = function (firmName, category, portfolio) {
            var _this = this;
            jQuery("#opportunitiesTab").html("");
            this.firmName = firmName;
            this.morningStarCategory = category;
            this.portfolio = portfolio;
            $("#tabWheel").show();
            this.service.getOpportunities(firmName, category, portfolio).then(function (result) {
                _this.opportunitiesDataList = result;
                if (_this.opportunitiesDataList !== null) {
                    _this.generatePage();
                    _this.generateButton();
                    _this.generateOpportunitiesTabTablesHtml();
                    _this.generateDropdownOptions();
                    $("#opp_industry_gross_sales").trigger('click');
                }
                $("#tabWheel").hide();
            });
        };
        Opportunities.prototype.generateDropdownOptions = function () {
            var category_dropdown = this.wrapper.find("#opportunities-select-category");
            category_dropdown.empty();
            for (var i = 0; i < this.category.length; i++) {
                var optionItem = jQuery('<option/>', { 'value': this.category[i], 'text': this.category[i] });
                category_dropdown.append(optionItem);
            }
        };
        Opportunities.prototype.generatePage = function () {
            var opportunities_button_section = '<div id="opportunities_button_section"></div>';
            var opportunities_table_section = '<div id="opportunities_table_section"></div>';
            jQuery("#opportunitiesTab").append(opportunities_button_section);
            jQuery("#opportunitiesTab").append(opportunities_table_section);
        };
        Opportunities.prototype.generateButton = function () {
            jQuery("#opportunities_button_section").empty();
            var html = '<button class="export-button-oppo" id="opportunities-tab-export-button" disabled>Select Territories to export</button>';
            jQuery("#opportunities_button_section").html(html);
        };
        // public generateSummaryTable(): void{
        //     let summary = jQuery('<table/>',{class: "table table-condensed opp-summary-table"});
        //     let tr = jQuery('<tr/>');
        //     tr.append(jQuery('<td/>',{class: 'opp-summary-td', text:'Average Market Share = ' + (Math.round(this.summaryTableContent[0]*1000)/10).toString() + '%'}));
        //     summary.append(tr);
        //     tr = jQuery('<tr/>');
        //     tr.append(jQuery('<td/>',{class: 'opp-summary-td', text:'Average Actual Sales = $' + Number((Math.round(this.summaryTableContent[1]/1000000)).toString()).toLocaleString('en', {minimumFractionDigits: 0})+'M'}));
        //     summary.append(tr);
        //     tr = jQuery('<tr/>');
        //     tr.append(jQuery('<td/>',{class: 'opp-summary-td', text:'Average Expected Sales = $' + Number((Math.round(this.summaryTableContent[2]/1000000)).toString()).toLocaleString('en', {minimumFractionDigits: 0})+'M'}));
        //     summary.append(tr);
        //     jQuery("#opportunities_button_section").append(summary);
        // }
        Opportunities.prototype.generateOpportunitiesTabTablesHtml = function () {
            var _this = this;
            var html_body = '<tbody class="comp-insight-territory-tbody">';
            this.category = [];
            this.summaryTableContent = [0, 0, 0];
            this.opportunitiesDataList.forEach(function (row) {
                _this.summaryTableContent[0] += row.opp_market_share;
                _this.summaryTableContent[1] += row.opp_actual_sales;
                _this.summaryTableContent[2] += row.opp_expected_sales;
            });
            for (var j = 0; j < 3; j++) {
                this.summaryTableContent[j] /= this.opportunitiesDataList.length;
            }
            this.opportunitiesDataList.forEach(function (row) {
                var includeMorningStar = false;
                var category = row.opp_morningstar_product_category;
                for (var i = 0; i < _this.category.length; i++) {
                    if (_this.category[i] === category) {
                        includeMorningStar = true;
                    }
                }
                if (!includeMorningStar && (category != null)) {
                    _this.category.push(category);
                }
                var checkbox_id = 'checkbox-' + row.opp_assigned_territory_name;
                html_body += '<tr ><td class="ci-table-checkbox-column"><div><span>' + '<input type="checkbox" id="' + checkbox_id + '" name="checkbox" value="checkbox" class="oppocheckbox">' + "</span></div></td>";
                html_body += '<td class="ci-table-first-column ci-opp-main-table-first-column"><div><span>' + row.opp_assigned_territory_name + "</span></div></td>";
                html_body += _this.generateTdHtml(row.opp_market_share_diff, 'percentage');
                html_body += _this.generateTdHtml(row.opp_percent_diff_expected_sales, 'percentNoDecimal');
                html_body += _this.generateTdHtml(row.opp_expected_sales);
                html_body += _this.generateTdHtml(row.opp_actual_sales);
                html_body += _this.generateTdHtml(row.opp_industry_gross_sales);
                html_body += _this.generateTdHtml(row.opp_market_share, 'percentage');
                html_body += _this.generateTdHtml(row.opp_sales_green_sapce);
                html_body += _this.generateTdHtml(row.opp_net_sales);
                html_body += _this.generateTdHtml(row.opp_industry_net_sales);
                html_body += '</tr>';
            });
            html_body += '</tbody>';
            var html_header = '';
            // html += '<table class="table table-condensed"><tr class="comp-insights-opp-header">';
            html_header += '<table class="table table-condensed ci-table"><thead><tr class="comp-insight-territory-tr">';
            html_header += '<th class="ci-table-checkbox-column"><input type="checkbox" id="checkbox-select-all" name="mastercheckbox" value="checkbox" class="oppocheckbox"></th>';
            html_header += '<th class="ci-table-first-column ci-opp-main-table-first-column">' + CompInsights.Strings.TERRITORY + '<span class="fa fa-sort" id="' + this.sortIds[0] + '"></span></th>';
            var headercolumns = [CompInsights.Strings.MARKET_SHARE_DIFF, CompInsights.Strings.DIFF_EXPECTED_SALES, CompInsights.Strings.EXPECTED_SALES, CompInsights.Strings.ACTUAL_SALES, CompInsights.Strings.INDUSTRY_GROSS_SALES, CompInsights.Strings.MARKET_SHARE_LABEL, CompInsights.Strings.GREEN_SPACE, CompInsights.Strings.NET_SALES, CompInsights.Strings.INDUSTRY_NET_SALES];
            for (var i = 1; i <= 9; i++) {
                var headerText = headercolumns[i - 1];
                if (i == 3) {
                    headerText = ('<div class="ci-table-averages expected-sales-averages">Avg = ' + new LabelBuilder.SalesLabelBuilder(true, false).build(this.summaryTableContent[2], true)) + '</div>' + headerText;
                }
                else if (i == 4) {
                    headerText = ('<div class="ci-table-averages actual-sales-averages">Avg = ' + new LabelBuilder.SalesLabelBuilder(true, false).build(this.summaryTableContent[1], true)) + '</div>' + headerText;
                }
                else if (i == 6) {
                    headerText = ('<div class="ci-table-averages market-share-averages">Avg = ' + new LabelBuilder.PercentLabelBuilder(true, false).build(this.summaryTableContent[0])) + '</div>' + headerText;
                }
                if (i < 7) {
                    html_header += '<th class="ci-opp-main-table-other-column">' + headerText + '<span class="fa fa-sort" id="' + this.sortIds[i] + '"></span></th>';
                }
                else {
                    if (i == 8) {
                        html_header += '<th class="ci-opp-main-table-small-column">' + headerText + '<span class="fa fa-sort" id="' + this.sortIds[i] + '"></span></th>';
                    }
                    else {
                        html_header += '<th class="ci-opp-main-table-last-column">' + headerText + '<span class="fa fa-sort" id="' + this.sortIds[i] + '"></span></th>';
                    }
                }
            }
            html_header += '<th class="ci-table-header-dummy-column"><span></span></th>';
            html_header += "</thead>";
            jQuery("#opportunities_table_section").html((html_header + html_body));
            this.initSortEvents();
            this.initializeEvents();
        };
        return Opportunities;
    }());
    CompInsights.Opportunities = Opportunities;
})(CompInsights || (CompInsights = {}));
var CompInsights;
(function (CompInsights) {
    (function (AnalysisEnum) {
        AnalysisEnum[AnalysisEnum["CLIENT_SALES"] = 1] = "CLIENT_SALES";
        AnalysisEnum[AnalysisEnum["CLIENT_NET_SALES"] = 2] = "CLIENT_NET_SALES";
        AnalysisEnum[AnalysisEnum["GLOBAL_SALES"] = 3] = "GLOBAL_SALES";
        AnalysisEnum[AnalysisEnum["GLOBAL_NET_SALES"] = 4] = "GLOBAL_NET_SALES";
        AnalysisEnum[AnalysisEnum["MARKET_SHARE"] = 5] = "MARKET_SHARE";
        AnalysisEnum[AnalysisEnum["CLIENT_AUM"] = 6] = "CLIENT_AUM";
        AnalysisEnum[AnalysisEnum["INDUSTRY_AUM"] = 7] = "INDUSTRY_AUM";
        AnalysisEnum[AnalysisEnum["EXPECTED_SALES"] = 8] = "EXPECTED_SALES";
        AnalysisEnum[AnalysisEnum["AUM_GREEN_SPACE"] = 9] = "AUM_GREEN_SPACE";
        AnalysisEnum[AnalysisEnum["SALES_GREEN_SPACE"] = 10] = "SALES_GREEN_SPACE";
    })(CompInsights.AnalysisEnum || (CompInsights.AnalysisEnum = {}));
    var AnalysisEnum = CompInsights.AnalysisEnum;
    var TargetMatrixNumberParameter = (function () {
        function TargetMatrixNumberParameter(name, currentValue) {
            this.name = name;
            this.setValue(currentValue);
        }
        TargetMatrixNumberParameter.prototype.getName = function () {
            return this.name;
        };
        TargetMatrixNumberParameter.prototype.setValue = function (value) {
            // Just in case things don't come in quite as expected
            value = Number(value);
            if (this.getValue() === value) {
                return false;
            }
            this.currentValue = value;
            return true;
        };
        TargetMatrixNumberParameter.prototype.getValue = function () {
            return this.currentValue;
        };
        TargetMatrixNumberParameter.prototype.getPositionValue = function () {
            return this.currentValue - 1;
        };
        return TargetMatrixNumberParameter;
    }());
    var TargetMatrixStringParameter = (function () {
        function TargetMatrixStringParameter(name, currentValue) {
            this.name = name;
            this.setValue(currentValue);
        }
        TargetMatrixStringParameter.prototype.getName = function () {
            return this.name;
        };
        TargetMatrixStringParameter.prototype.setValue = function (value) {
            if (this.getValue() === value) {
                return false;
            }
            this.currentValue = value;
            return true;
        };
        TargetMatrixStringParameter.prototype.getValue = function () {
            return this.currentValue;
        };
        return TargetMatrixStringParameter;
    }());
    var AxisParameter = (function (_super) {
        __extends(AxisParameter, _super);
        function AxisParameter(name, defaultValue) {
            _super.call(this, name, defaultValue);
            this.labelBuilder = new LabelBuilder.SalesBuilderWithNumeral(true, false);
            this.marketShare = new LabelBuilder.MarketShareLabelBuilder(true, false, 2, true);
            this.axisValues = {
                'value': this.value,
                'keyLabel': this.keyLabel,
                'formatter': this.formatter,
                'positionData': this.positionData
            };
            this.valuesMap = [{
                    'value': AnalysisEnum.CLIENT_SALES,
                    'keyLabel': AxisParameter.CLIENT_GROSS_SALES_OPTION,
                    'formatter': this.labelBuilder,
                    'positionData': CompInsights.DataPositionEnum.CLIENT_GROSS_SALES
                }, {
                    'value': AnalysisEnum.CLIENT_NET_SALES,
                    'keyLabel': AxisParameter.CLIENT_NET_SALES_OPTION,
                    'formatter': this.labelBuilder,
                    'positionData': CompInsights.DataPositionEnum.CLIENT_NET_SALES
                }, {
                    'value': AnalysisEnum.GLOBAL_SALES,
                    'keyLabel': AxisParameter.GLOBAL_GROSS_SALES_OPTION,
                    'formatter': this.labelBuilder,
                    'positionData': CompInsights.DataPositionEnum.GLOBAL_GROSS_SALES
                }, {
                    'value': AnalysisEnum.GLOBAL_NET_SALES,
                    'keyLabel': AxisParameter.GLOBAL_NET_SALES_OPTION,
                    'formatter': this.labelBuilder,
                    'positionData': CompInsights.DataPositionEnum.GLOBAL_NET_SALES
                }, {
                    'value': AnalysisEnum.MARKET_SHARE,
                    'keyLabel': AxisParameter.MARKET_SHARE_OPTION,
                    'formatter': this.marketShare,
                    'positionData': CompInsights.DataPositionEnum.MARKET_SHARE
                }, {
                    'value': AnalysisEnum.CLIENT_AUM,
                    'keyLabel': AxisParameter.CLIENT_AUM_OPTION,
                    'formatter': this.labelBuilder,
                    'positionData': CompInsights.DataPositionEnum.CLIENT_AUM
                }, {
                    'value': AnalysisEnum.INDUSTRY_AUM,
                    'keyLabel': AxisParameter.INDUSTRY_AUM_OPTION,
                    'formatter': this.labelBuilder,
                    'positionData': CompInsights.DataPositionEnum.AUM_INDUSTRY
                }, {
                    'value': AnalysisEnum.EXPECTED_SALES,
                    'keyLabel': AxisParameter.EXPECTED_SALES,
                    'formatter': this.labelBuilder,
                    'positionData': CompInsights.DataPositionEnum.EXPECTED_SALES
                }, {
                    'value': AnalysisEnum.AUM_GREEN_SPACE,
                    'keyLabel': AxisParameter.AUM_GREEN_SPACE_OPTION,
                    'formatter': this.labelBuilder,
                    'positionData': CompInsights.DataPositionEnum.AUM_GREEN_SPACE
                }, {
                    'value': AnalysisEnum.SALES_GREEN_SPACE,
                    'keyLabel': AxisParameter.SALES_GREEN_SPACE_OPTION,
                    'formatter': this.labelBuilder,
                    'positionData': CompInsights.DataPositionEnum.SALES_GREEN_SPACE
                }];
        }
        AxisParameter.prototype.asJson = function () {
            return {
                allowablevalues: AxisParameter.ALLOWABLEVALUES,
                allowablevaluestype: AxisParameter.ALLOWABLEVALUES_TYPE,
                datatype: AxisParameter.DATA_TYPE,
                datestepsize: AxisParameter.DATE_STEPSIZE,
                maxvalue: AxisParameter.MAX_VALUE,
                minvalue: AxisParameter.MIN_VALUE,
                name: this.getName(),
                stepsize: AxisParameter.STEP_SIZE,
                value: this.getValue()
            };
        };
        AxisParameter.prototype.getAxisValue = function () {
            var _this = this;
            return this.valuesMap.single(function (currentAxis) {
                return _this.getValue() === currentAxis.value;
            });
        };
        AxisParameter.prototype.getKeyLabel = function () {
            return this.valuesMap[this.getPositionValue()].keyLabel;
        };
        AxisParameter.prototype.getFormatter = function () {
            return this.valuesMap[this.getPositionValue()].formatter;
        };
        AxisParameter.prototype.getPositionData = function () {
            return this.valuesMap[this.getPositionValue()].positionData;
        };
        AxisParameter.ALLOWABLEVALUES_TYPE = 'list';
        AxisParameter.DATA_TYPE = 'string';
        AxisParameter.DATE_STEPSIZE = null;
        AxisParameter.DEFAULT_VALUE = AnalysisEnum.CLIENT_NET_SALES;
        AxisParameter.MAX_VALUE = null;
        AxisParameter.MIN_VALUE = null;
        AxisParameter.STEP_SIZE = null;
        AxisParameter.CLIENT_NET_SALES_OPTION = 'Client Net Sales';
        AxisParameter.CLIENT_GROSS_SALES_OPTION = 'Client Sales';
        AxisParameter.GLOBAL_NET_SALES_OPTION = 'Global Net Sales';
        AxisParameter.GLOBAL_GROSS_SALES_OPTION = 'Global Sales';
        AxisParameter.MARKET_SHARE_OPTION = 'Market Share';
        AxisParameter.INDUSTRY_AUM_OPTION = 'Industry AUM';
        AxisParameter.CLIENT_AUM_OPTION = 'Client AUM';
        AxisParameter.SALES_GREEN_SPACE_OPTION = 'Sales Green Space';
        AxisParameter.AUM_GREEN_SPACE_OPTION = 'AUM Green Space';
        AxisParameter.EXPECTED_SALES = 'Expected Sales';
        AxisParameter.ALLOWABLEVALUES = [
            { 'value': AnalysisEnum.CLIENT_SALES, 'formattedValue': AxisParameter.CLIENT_GROSS_SALES_OPTION },
            { 'value': AnalysisEnum.GLOBAL_SALES, 'formattedValue': AxisParameter.GLOBAL_GROSS_SALES_OPTION },
            { 'value': AnalysisEnum.CLIENT_NET_SALES, 'formattedValue': AxisParameter.CLIENT_NET_SALES_OPTION },
            { 'value': AnalysisEnum.GLOBAL_NET_SALES, 'formattedValue': AxisParameter.GLOBAL_NET_SALES_OPTION },
            { 'value': AnalysisEnum.MARKET_SHARE, 'formattedValue': AxisParameter.MARKET_SHARE_OPTION },
            { 'value': AnalysisEnum.INDUSTRY_AUM, 'formattedValue': AxisParameter.INDUSTRY_AUM_OPTION },
            { 'value': AnalysisEnum.CLIENT_AUM, 'formattedValue': AxisParameter.CLIENT_AUM_OPTION },
            { 'value': AnalysisEnum.SALES_GREEN_SPACE, 'formattedValue': AxisParameter.SALES_GREEN_SPACE_OPTION },
            { 'value': AnalysisEnum.AUM_GREEN_SPACE, 'formattedValue': AxisParameter.AUM_GREEN_SPACE_OPTION },
            { 'value': AnalysisEnum.EXPECTED_SALES, 'formattedValue': AxisParameter.EXPECTED_SALES }
        ];
        return AxisParameter;
    }(TargetMatrixNumberParameter));
    CompInsights.AxisParameter = AxisParameter;
})(CompInsights || (CompInsights = {}));
/// <reference path="../../libs/jquery.d.ts"/>
/// <reference path="../../utils/04.array_extension.ts"/>
var CompInsights;
(function (CompInsights) {
    var Analytics = (function () {
        function Analytics(wrapper, service) {
            this.analyticsData = [];
            this.sortIdsList = ['analytic_territoryName', 'analytic_percentDifference', 'analytic_dollarDifference', 'analytic_expectedSales', 'analytic_actualSales', 'analytic_globalSales', 'analytic_marketShare', 'analytic_salesGreenSpace', 'analytic_aumGreenSpace'];
            this.wrapper = wrapper;
            this.service = service;
            this.mockDataManager = new CompInsights.MockData();
            this.browserManager = new BrowserDetector.BrowserDetectorManager();
        }
        Analytics.prototype.updateAnalyticsTab = function (firmName, category, portfolio) {
            var _this = this;
            $("#tabWheel").show();
            this.cleanWrappers();
            Analytics.firmName = firmName;
            Analytics.portfolio = portfolio;
            Analytics.category = category;
            this.service.getAnalyticsData(firmName, category, portfolio).then(function (result) {
                _this.analyticContentData = result;
                _this.analyticsData.splice(0, _this.analyticsData.length);
                result.forEach(function (row) {
                    row["firmName"] = firmName;
                    row["category"] = category;
                    _this.analyticsData.push(row);
                });
                _this.generateFilterHtml();
                _this.setDefaultOptions();
                _this.generateAnalyticTableHtml();
                _this.createButterflyChar();
                _this.triggerChangeEvent();
                $("#tabWheel").hide();
            });
        };
        Analytics.prototype.setDefaultOptions = function () {
            $("#ws-parameter-analytics-filter select option:contains('Difference {Actual Sales - Expected Sales}')").attr('selected', 'selected');
        };
        Analytics.prototype.triggerChangeEvent = function () {
            this.triggerFilterChangeEvent();
            this.showVisualization();
            this.triggerPercentDifferenceSort();
            $("#analytics-chart-button").click();
        };
        Analytics.prototype.triggerPercentDifferenceSort = function () {
            if ($("#analytic_percentDifference").hasClass("fa-sort")) {
                for (var i = 0; i < 2; i++) {
                    $("#analytic_percentDifference").trigger('click');
                }
            }
        };
        Analytics.prototype.showVisualization = function () {
            $("#analytics-table-button").click(function (e) {
                $(".comp-insight-analytics-table-wrapper").removeClass('display-none');
                $(".comp-insight-analytics-charts-wrapper").addClass('display-none');
                $("#analytics-chart-button .visualization-icon").removeClass('keep-selected');
                $("#analytics-table-button .visualization-icon").addClass('keep-selected');
                $(".ws-analytics-filter-parameter-wrapper").addClass('display-none');
            });
            $("#analytics-chart-button").click(function (e) {
                $(".comp-insight-analytics-table-wrapper").addClass('display-none');
                $(".comp-insight-analytics-charts-wrapper").removeClass('display-none');
                $("#analytics-chart-button .visualization-icon").addClass('keep-selected');
                $("#analytics-table-button .visualization-icon").removeClass('keep-selected');
                $(".ws-analytics-filter-parameter-wrapper").removeClass('display-none');
            });
        };
        Analytics.prototype.triggerFilterChangeEvent = function () {
            var _this = this;
            jQuery(".ws-analytics-filter-dropdown select").change(function () {
                _this.refreshChart();
            });
        };
        Analytics.prototype.createButterflyChar = function () {
            var series = this.getOrderedSeries();
            this.updateChartHeight(series.data.length);
            this.initialize();
            this.refreshAveragePlotline(series.average);
            this.chart.xAxis[0].setCategories(series.categories);
            this.chart.series[0].update({ data: series.data });
        };
        Analytics.prototype.updateChartHeight = function (lineCount) {
            var chart_height = lineCount === 1 ? 300 : Math.max(lineCount * 25, 500);
            this.wrapper.find("#analytics-highCharts-wrapper").height(chart_height);
        };
        Analytics.prototype.refreshChart = function () {
            $("#analytics-highCharts-wrapper").empty();
            this.createButterflyChar();
        };
        Analytics.prototype.getOrderedData = function () {
            var orderedData = new Array();
            var activeOption = jQuery('#ws-parameter-analytics-filter select').find(":selected").val();
            this.analyticContentData.forEach(function (line) {
                orderedData.push({
                    dimensionValue: line.territoryName,
                    value: line[activeOption]
                });
            });
            orderedData.sort(function (current, next) {
                return current.value - next.value;
            });
            return orderedData;
        };
        Analytics.prototype.getOrderedSeries = function () {
            var orderedData = this.getOrderedData();
            var values = orderedData.map(function (line) {
                return line.value;
            });
            var average = values.avg();
            var min = values.min();
            var max = values.max();
            var positiveData = new Array(), negativeData = new Array(), categories = new Array();
            orderedData.forEach(function (rawLine) {
                categories.push(rawLine.dimensionValue);
                var value = rawLine.value;
                var isAboveAverage = value > average;
                var range = isAboveAverage ? max : min;
                var targetColor = (isAboveAverage) ? Analytics.BLUE_COLOR : Analytics.RED_COLOR;
                var colorComponent = (value - average) / (range - average);
                var y = Math.abs(value - average);
                if (!isAboveAverage) {
                    y = -y;
                }
                var target = (isAboveAverage) ? positiveData : negativeData;
                target.push({
                    color: '#' + ColorUtils.calcColorGradient(Analytics.WHITE_COLOR, targetColor, colorComponent),
                    y: y
                });
            });
            return {
                data: negativeData.concat(positiveData),
                categories: categories,
                average: average
            };
        };
        Analytics.prototype.cleanWrappers = function () {
            $("#analytics-wrapper").empty();
            $(".comp-insight-analytics-table-wrapper").empty();
            $("#analytics-highCharts-wrapper").empty();
        };
        Analytics.prototype.generateIconsHtml = function () {
            this.generateChartButtonHtml();
            this.generateTableButtonHtml();
        };
        Analytics.prototype.generateTableButtonHtml = function () {
            var btnGroupWrapper = jQuery(".analytics-btn-group");
            var btnWrapper = jQuery('<button/>', {
                'type': 'button',
                'id': 'analytics-table-button',
                'class': 'btn btn-default btn-lg-custom btn-sm-xs-custom vertical-composed',
                'title': 'Table Visualization'
            });
            btnGroupWrapper.append(btnWrapper);
            var tableDiv = jQuery('<div/>', {
                'class': 'visualization-table'
            });
            var tableIcon = jQuery('<div/>', {
                'class': 'visualization-icon fa fa-table fa-lg'
            });
            var tableText = jQuery('<div/>', {
                'class': 'visualization-label action-label open-sans opaque-65',
                'text': 'Table'
            });
            btnWrapper.append(tableDiv);
            tableDiv.append(tableIcon);
            tableIcon.append(tableText);
        };
        Analytics.prototype.generateChartButtonHtml = function () {
            var filterWrapper = jQuery("#analytics-wrapper");
            var btnGroupWrapper = jQuery('<div/>', {
                'class': 'analytics-btn-group'
            });
            var btnWrapper = jQuery('<button/>', {
                'type': 'button',
                'id': 'analytics-chart-button',
                'class': 'btn btn-default btn-lg-custom btn-sm-xs-custom vertical-composed',
                'title': 'Chart Visualization'
            });
            filterWrapper.append(btnGroupWrapper);
            btnGroupWrapper.append(btnWrapper);
            var chatDiv = jQuery('<div/>', {
                'class': 'visualization-chart'
            });
            var chatIcon = jQuery('<div/>', {
                'class': 'visualization-icon fa-lg fa fa-bar-chart-o keep-selected'
            });
            var chatText = jQuery('<div/>', {
                'class': 'visualization-label action-label open-sans opaque-65',
                'text': 'Chart'
            });
            btnWrapper.append(chatDiv);
            chatDiv.append(chatIcon);
            chatIcon.append(chatText);
        };
        Analytics.prototype.generateFilterHtml = function () {
            var filterWrapper = jQuery("#analytics-wrapper");
            if (filterWrapper.children().length === 0) {
                var wrapper = jQuery('<div/>', {
                    'id': 'analytics-filter-wrapper',
                    'class': 'top-controls open-sans top-controls-non-mobile hidden-xs enabled'
                });
                var subWrapper = jQuery('<div/>', {
                    'id': 'ws-parameter-analytics-filter',
                    'class': 'ws-filter-list-parameter-wrapper ws-analytics-filter-parameter-wrapper'
                });
                var div = jQuery('<div/>', { 'class': 'ws-filter-list-drop-down-label', 'text': 'View by' });
                subWrapper.append(div);
                wrapper.append(subWrapper);
                var xdropDownWrapper = jQuery('<div/>', { 'class': 'filter-control ws-analytics-filter-dropdown' });
                var selectWrapper = jQuery('<select/>', { 'class': 'form-control dropdown-formatter' });
                selectWrapper.append(this.createSelectOptions());
                xdropDownWrapper.append(selectWrapper);
                subWrapper.append(xdropDownWrapper);
                filterWrapper.append(wrapper);
                this.generateIconsHtml();
            }
        };
        Analytics.prototype.createSelectOptions = function () {
            var values = this.mockDataManager.getAnalyticsOptionsMockData();
            values.sort(function (curr, next) {
                return curr.formattedValue > next.formattedValue ? 1 : -1;
            });
            return values.map(function (option) {
                return jQuery('<option/>', {
                    'text': option.formattedValue || option.value,
                    'value': option.value
                });
            });
        };
        Analytics.prototype.generateAnalyticTableHtml = function () {
            var _this = this;
            var wrapper = jQuery(".comp-insight-analytics-table-wrapper");
            wrapper.html("");
            var tableWrapper = $("<div>", {
                'id': "analytics-table-wrapper", 'class': "analytics-table-wrapper"
            });
            var analyticTable = $("<table>", {
                'class': 'table analytics-table table-condensed ci-table'
            });
            wrapper.append(tableWrapper);
            var thead = $('<thead>');
            var tableHeader = $('<tr>', { 'class': 'comp-insight-territory-tr' });
            tableHeader.append($('<th>', { 'class': 'comp-insights-analytics-territory-header' }).append('<span> ' + CompInsights.Strings.TERRITORY + '</span>').append('<span class="fa fa-sort comp-insights-analytics-sort" id="' + this.sortIdsList[0] + '"></span>'));
            tableHeader.append($('<th>', { 'class': 'comp-insights-analytics-header' }).append('<span> ' + CompInsights.Strings.DIFF_EXPECTED_SALES_ANALYTICS_HEADER + '</span>').append('<span class="fa fa-sort comp-insights-analytics-sort" id="' + this.sortIdsList[1] + '"></span>'));
            tableHeader.append($('<th>', { 'class': 'comp-insights-analytics-header' }).append('<span> ' + CompInsights.Strings.DOLLAR_DIFFERENCE_HEADER + '</span>').append('<span class="fa fa-sort comp-insights-analytics-sort" id="' + this.sortIdsList[2] + '"></span>'));
            tableHeader.append($('<th>', { 'class': 'comp-insights-analytics-header' }).append('<span> ' + CompInsights.Strings.EXPECTED_SALES_ANALYTICS_HEADER + '</span>').append('<span class="fa fa-sort comp-insights-analytics-sort" id="' + this.sortIdsList[3] + '"></span>'));
            tableHeader.append($('<th>', { 'class': 'comp-insights-analytics-header' }).append('<span> ' + CompInsights.Strings.ACTUAL_SALES_ANALYTICS_HEADER + '</span>').append('<span class="fa fa-sort comp-insights-analytics-sort" id="' + this.sortIdsList[4] + '"></span>'));
            tableHeader.append($('<th>', { 'class': 'comp-insights-analytics-header' }).append('<span> ' + CompInsights.Strings.GLOBAL_GROSS_SALES_ANALYTICS_HEADER + '</span>').append('<span class="fa fa-sort comp-insights-analytics-sort" id="' + this.sortIdsList[5] + '"></span>'));
            tableHeader.append($('<th>', { 'class': 'comp-insights-analytics-header' }).append('<span> ' + CompInsights.Strings.MARKET_SHARE_ANALYTICS_HEADER + '</span>').append('<span class="fa fa-sort comp-insights-analytics-sort" id="' + this.sortIdsList[6] + '"></span>'));
            tableHeader.append($('<th>', { 'class': 'comp-insights-analytics-header' }).append('<span> ' + CompInsights.Strings.SALES_GREEN_SPACE_ANALYTICS_HEADER + '</span>').append('<span class="fa fa-sort comp-insights-analytics-sort" id="' + this.sortIdsList[7] + '"></span>'));
            tableHeader.append($('<th>', { 'class': 'comp-insights-analytics-header' }).append('<span> ' + CompInsights.Strings.AUM_GREEN_SPACE_ANALYTICS_HEADER + '</span>').append('<span class="fa fa-sort comp-insights-analytics-sort" id="' + this.sortIdsList[8] + '"></span>'));
            tableHeader.append($('<th>', { 'class': 'ci-table-header-dummy-column' }).append('<span></span>'));
            tableHeader.appendTo(thead);
            thead.appendTo(analyticTable);
            var tbody = $('<tbody>', { 'class': 'comp-insight-territory-tbody' });
            this.analyticsData.forEach(function (row) {
                var tableRow = $('<tr>');
                tableRow.append($('<td>', { 'class': 'comp-insights-analytics-td-territory' }).text(row.territoryName));
                tableRow.append(_this.generateTdHtml(row.percentDifference, 'percentage'));
                tableRow.append(_this.generateTdHtml(row.dollarDifference));
                tableRow.append(_this.generateTdHtml(row.expectedSales));
                tableRow.append(_this.generateTdHtml(row.actualSales));
                tableRow.append(_this.generateTdHtml(row.globalSales));
                tableRow.append(_this.generateTdHtml(row.marketShare, 'percentage'));
                tableRow.append(_this.generateTdHtml(row.salesGreenSpace));
                tableRow.append(_this.generateTdHtml(row.aumGreenSpace));
                tableRow.appendTo(tbody);
            });
            tbody.appendTo(analyticTable);
            tableWrapper.append(analyticTable);
            this.initSortEvents();
        };
        Analytics.prototype.initSortEvents = function () {
            var _this = this;
            for (var i = 0; i < this.sortIdsList.length; i++) {
                jQuery('#' + this.sortIdsList[i]).off().on('click', function (e) {
                    _this.sortFunctions(e);
                });
            }
        };
        Analytics.prototype.sortFunctions = function (e) {
            var id = e.currentTarget.id;
            var sortedId = (e.currentTarget.id).split('_');
            var currentId = sortedId[1];
            if (!currentId)
                return;
            var reverseSort = false;
            var origClass = jQuery('#' + id).attr('class');
            var newClass = '';
            var classArr = origClass.split(' ');
            if (classArr[1] === 'fa-sort') {
                if (currentId === 'territoryName') {
                    // low -> high -> low
                    newClass = 'fa fa-sort-up ' + classArr[2];
                }
                else {
                    //high -> low -> high
                    newClass = 'fa fa-sort-down ' + classArr[2];
                    reverseSort = true;
                }
            }
            else if (classArr[1] === "fa-sort-up") {
                newClass = 'fa fa-sort-down ' + classArr[2];
                reverseSort = true;
            }
            else {
                newClass = 'fa fa-sort-up ' + classArr[2];
            }
            this.analyticsData.sort(this.compareValues(currentId));
            if (reverseSort) {
                this.analyticsData.reverse();
            }
            this.generateAnalyticTableHtml();
            jQuery('#' + id).attr('class', newClass);
            for (var i = 0; i < this.sortIdsList.length; i++) {
                if (id !== this.sortIdsList[i]) {
                    jQuery('#' + this.sortIdsList[i]).attr('class', 'fa fa-sort comp-insights-analytics-sort');
                }
            }
        };
        Analytics.prototype.compareValues = function (propertyName) {
            return function (a, b) {
                var aa = a[propertyName];
                var bb = b[propertyName];
                if (typeof aa === "number") {
                    return aa - bb;
                }
                if (typeof aa === "string") {
                    return aa.localeCompare(bb);
                }
                return 0;
            };
        };
        Analytics.prototype.generateTdHtml = function (value, dataType) {
            var tableRow;
            if (value !== null) {
                var formattedColor = '';
                var formattedValue = this.formattedValues(value, dataType);
                if (value < 0) {
                    formattedColor = 'ci-red-cell';
                }
                tableRow = $('<td>', { 'class': 'comp-insights-analytics-td ' + formattedColor }).text(formattedValue);
            }
            return tableRow;
        };
        Analytics.prototype.formattedValues = function (value, dataType) {
            var formattedValue = '';
            if (dataType == 'percentage') {
                var tempValue = value / 100;
                formattedValue = new LabelBuilder.PercentLabelBuilder(true, false).build(tempValue);
            }
            else {
                formattedValue = new LabelBuilder.SalesLabelBuilder(true, false).build(value, true);
            }
            return formattedValue;
        };
        Analytics.prototype.formattedValuesForChart = function (value, formatAxis) {
            var formattedValue = '';
            var dataType = jQuery('#ws-parameter-analytics-filter select').find(":selected").text() === 'Market Share' ? 'percentage' : 'dollar';
            if (dataType == 'percentage') {
                var tempValue = value / 100;
                formattedValue = new LabelBuilder.PercentLabelBuilder(true, true).build(tempValue);
            }
            else {
                if (formatAxis == 'true') {
                    formattedValue = new LabelBuilder.SalesLabelBuilder(true, true).build(value, true);
                }
                else {
                    formattedValue = new LabelBuilder.SalesLabelBuilder(true, true).build(value, true, true);
                }
            }
            return formattedValue;
        };
        Analytics.prototype.refreshAveragePlotline = function (average) {
            // Apply label
            var averageText = "Average: " + this.formattedValuesForChart(average);
            var xAxis = this.chart.yAxis[0];
            xAxis.removePlotLine('base-plotline');
            xAxis.addPlotLine({
                color: '#707070',
                dashStyle: 'dot',
                width: 1,
                value: 0,
                label: {
                    align: 'right',
                    x: -10,
                    text: averageText,
                    rotation: 270
                },
                zIndex: 3,
                id: 'base-plotline'
            });
        };
        Analytics.prototype.initialize = function () {
            var butterFly = this;
            this.chart = new Highcharts.Chart({
                chart: {
                    renderTo: this.wrapper.find("#analytics-highCharts-wrapper").get(0),
                    type: 'bar',
                    style: {
                        fontWeight: "normal",
                        fontFamily: "Open Sans",
                        fontSize: "11px !important",
                    }
                },
                credits: { enabled: false },
                legend: { enabled: false },
                title: ' ',
                xAxis: {
                    categories: [],
                    reversed: false,
                    labels: {
                        step: 1
                    }
                },
                yAxis: {
                    gridLineWidth: 0,
                    minorGridLineWidth: 0,
                    title: { text: null },
                    labels: {
                        style: {
                            color: 'rgb(0, 0, 0) !important'
                        },
                        formatter: function () {
                            return butterFly.formattedValuesForChart(this.value);
                        }
                    },
                    plotLines: [{
                            id: 'base-plotline'
                        }]
                },
                plotOptions: {
                    series: { stacking: 'normal' },
                    bar: {
                        dataLabels: {
                            enabled: true,
                            inside: false,
                            formatter: function () {
                                return butterFly.formattedValuesForChart(this.total, 'true');
                            },
                            style: {
                                fontWeight: "normal",
                                textOutline: 'none !important',
                                color: 'rgb(0, 0, 0) !important'
                            }
                        }
                    }
                },
                tooltip: {
                    formatter: function () {
                        var getLabel = jQuery('#ws-parameter-analytics-filter select').find(":selected").text();
                        var template = '{0}<br/>{1}: <b>{2}</b>';
                        return String.format(template, this.x, getLabel, butterFly.formattedValuesForChart(this.y, 'true'));
                    },
                    enabled: true
                },
                series: [{}]
            });
        };
        Analytics.LINE_HEIGHT = 30;
        Analytics.WHITE_COLOR = 'EEEEEE';
        Analytics.BLUE_COLOR = '97BBCD';
        Analytics.RED_COLOR = 'EA8D6F';
        return Analytics;
    }());
    CompInsights.Analytics = Analytics;
})(CompInsights || (CompInsights = {}));
///<reference path="../../libs/jquery.d.ts"/>
///<reference path="00.data_types.ts" />
///<reference path="01.strings.ts" />
///<reference path="02.data_manager.ts" />
///<reference path="03.data.ts" />
///<reference path="04.service.ts" />
///<reference path="05.parser.ts" />
///<reference path="06.ranking.ts" />
///<reference path="11.main_grid.ts" />
///<reference path="17.sales_trends.ts" />
///<reference path="18.key_sales_drivers.ts" />
///<reference path="19.platform.ts" />
///<reference path="20.scatterplot.ts" />
///<reference path="21.opportunities.ts" />
///<reference path="23.analytics.ts" />
///<reference path="10.pagination.ts" />
///<reference path="../12.bi_what-if-scenarios/00.data_type.ts" />
///<reference path="../12.bi_what-if-scenarios/99.product_page.ts" />
var CompInsights;
(function (CompInsights) {
    var ProductPage = (function () {
        function ProductPage(wrapper) {
            this.service = new CompInsights.Service();
            this.bShowGrid = true;
            this.isClient = true;
            this.isOpportunity = true;
            this.mockDataManager = new CompInsights.MockData();
            this.dataManager = new CompInsights.DataManager();
            this.parser = new CompInsights.Parser();
            this.rowSize = 10;
            this.columnSize = 10;
            this.platform = 'ALL';
            this.firmName = '';
            this.fillSize = 0;
            this.currentAnalyticsTab = "ranking";
            this.marketShareDataList = [];
            this.marketShareHeaders = [CompInsights.Strings.TERRITORY, CompInsights.Strings.PERCENT_DIFF_PDF, CompInsights.Strings.DIFF_EXPECTED_SALES_PDF, CompInsights.Strings.EXPECTED_SALES_PDF, CompInsights.Strings.ACTUAL_SALES_PDF,
                CompInsights.Strings.INDUSTRY_GROSS_SALES_PDF, CompInsights.Strings.MARKET_SHARE_PDF, CompInsights.Strings.GREEN_SPACE_PDF, CompInsights.Strings.NET_SALES_PDF, CompInsights.Strings.INDUSTRY_NET_SALES_PDF];
            this.tableOfContents = ['rankings_toc', 'sales_trends_toc', 'key_sales_drivers_toc', 'territory_opportunities_toc', 'client_10_by_10_toc', 'methodologies_and_assumptions_toc'];
            this.opportunityArray = [];
            this.tabDataList = [{ tabId: "ranking", updated: false },
                { tabId: "trends", updated: false }, { tabId: "drivers", updated: false },
                { tabId: "whatif", updated: false }, { tabId: "platform", updated: false },
                { tabId: "opportunities", updated: false }, { tabId: "analytics", updated: false },
                { tabId: "scatterplot", updated: false }];
            this.keySalesDriverDataList = [];
            this.rankingsDataList = [];
            this.summaryTableContent = [0, 0, 0];
            this.wrapper = wrapper;
            this.rankingsModel = new CompInsights.Rankings(this.wrapper, this.service);
            this.salesTrendsModel = new CompInsights.SalesTrends(this.wrapper, this.service);
            this.keySalesDriversModel = new CompInsights.KeySalesDrivers(this.wrapper, this.service, this.mockDataManager);
            this.OpportunitiesModel = new CompInsights.Opportunities(this.wrapper, this.service);
            this.mainGridModel = new CompInsights.MainGrid(this.wrapper, this.service);
            this.platformModel = new CompInsights.Platform(this.wrapper, this.service);
            this.scatterplot = new CompInsights.Scatterplot(this.wrapper, this.service);
            this.analytics = new CompInsights.Analytics(this.wrapper, this.service);
            this.firmDropdown = this.wrapper.find("#firm-dropdown");
            this.intiInfoIcon();
            this.initTabData();
            this.stylizeParentWrapper();
            this.initData();
        }
        ProductPage.prototype.intiInfoIcon = function () {
            var infoIcon = $('<span>', { 'class': 'glyphicon glyphicon-info-sign opportunity-risk-score-info-icon' });
            var infoMsg = $('<div>', { 'class': 'opportunity-risk-score-info-msg' });
            CompInsights.Strings.COMP_INSIGHT_ICON_MSGS.forEach(function (msg) {
                infoMsg.append($('<p>', { 'text': msg }));
            });
            var infoTable = $('<table>', { 'class': 'table table-condensed ci-table popup-table' });
            var thead = $('<thead>');
            var tr = $('<tr>');
            tr.append($('<th>', {
                class: 'ci-table-first-column ci-green-cell ci-popup-first-column',
                text: CompInsights.Strings.OPPORTUNITY_SCORE_METRICS
            }));
            tr.append($('<th>', { class: 'ci-green-cell', text: 'Weightings' }));
            tr.append($('<th>', { class: 'ci-table-first-column ci-red-cell', text: CompInsights.Strings.RISK_SCORE_METRICS }));
            tr.append($('<th>', { class: 'ci-red-cell', text: 'Weightings' }));
            thead.append(tr);
            infoTable.append(thead);
            var table_rows = [
                [CompInsights.Strings.SALES_GREEN_SPACE_LABEL, CompInsights.Strings.LABEL_20_PERCENT, CompInsights.Strings.SCATTERPLOT_CLIENT_SALES, CompInsights.Strings.LABEL_20_PERCENT],
                [CompInsights.Strings.AUM_GREEN_SPACE_LABEL, CompInsights.Strings.LABEL_20_PERCENT, CompInsights.Strings.SALES_MARKET_SHARE, CompInsights.Strings.LABEL_15_PERCENT],
                [CompInsights.Strings.COMPETITIVE_SALES, CompInsights.Strings.LABEL_20_PERCENT, CompInsights.Strings.AUM_MARKET_SHARE, CompInsights.Strings.LABEL_15_PERCENT],
                [CompInsights.Strings.COMPETITIVE_ASSETS, CompInsights.Strings.LABEL_20_PERCENT, CompInsights.Strings.RED_SPACE, CompInsights.Strings.LABEL_25_PERCENT],
                [CompInsights.Strings.MARKET_SHARE_LOWER_IS_BETTER, CompInsights.Strings.LABEL_20_PERCENT, CompInsights.Strings.SALES_GREEN_SPACE_LOWER_IS_BETTER, CompInsights.Strings.LABEL_15_PERCENT],
                ['', '', CompInsights.Strings.NEW_MANAGER_RECEPTIVITY, CompInsights.Strings.LABEL_10_PERCENT]
            ];
            this.methodologiesTableData = table_rows;
            var tbody = $('<tbody>');
            table_rows.forEach(function (table_row) {
                tr = $('<tr>');
                tr.append($('<td>', { class: 'ci-table-first-column', text: table_row[0] }));
                tr.append($('<td>', { text: table_row[1] }));
                tr.append($('<td>', { class: 'ci-table-first-column', text: table_row[2] }));
                tr.append($('<td>', { text: table_row[3] }));
                tbody.append(tr);
            });
            infoTable.append(tbody);
            infoMsg.append(infoTable);
            $("#comp-insights-info-wrapper").append(infoIcon, infoMsg);
        };
        ProductPage.prototype.initData = function () {
            this.initializeProductPageEvents();
            this.initializePagination();
            this.hideMainTable();
            this.hideShowAnalyticsTabs(false);
        };
        ProductPage.prototype.setObsoluteValue = function () {
            var thHeight = $('.comp-main-grid-wrapper th').height();
            var tbodyHeight = $('.comp-main-grid-wrapper tbody').height();
            $('.comp-firm-pagination-wrapper').css('top', thHeight + 20);
            $('.comp-grid-pagination-arrow-right').css('top', tbodyHeight + 25);
        };
        ProductPage.prototype.stylizeParentWrapper = function () {
            var contentDiv = this.wrapper.parent();
            contentDiv.addClass("adjust-content-div");
        };
        ProductPage.prototype.initializePagination = function () {
            var _this = this;
            this.service.getProductsAndFirmsCount().then(function (result) {
                _this.productPagination = new PaginatedMenu.Pagination(result.productCount, 0);
                _this.productPagination.arrowClicked(function () {
                    _this.refreshPagination(true);
                });
                _this.firmPagination = new PaginatedMenu.FirmPagination(result.firmCount, 0);
                _this.firmPagination.arrowClicked(function () {
                    _this.refreshPagination(true);
                });
                jQuery(".comp-product-pagination-wrapper").append(_this.productPagination.html());
                jQuery(".comp-firm-pagination-wrapper").append(_this.firmPagination.html());
                _this.refreshPagination();
            });
        };
        ProductPage.prototype.refreshPagination = function (isArrowClicked) {
            if (isArrowClicked === void 0) { isArrowClicked = false; }
            var productPageNumber = this.productPagination.getCurrentPagination();
            var productNumOfPages = this.productPagination.getNumOfPages();
            var firmPageNumber = this.firmPagination.getCurrentPagination();
            var firmNumOfPages = this.firmPagination.getNumOfPages();
            $("#product-pagination-count-wrapper").text((productPageNumber + 1) + ' of ' + productNumOfPages);
            $("#firm-pagination-count-wrapper").text((firmPageNumber + 1) + ' of ' + firmNumOfPages);
            $("#gridWheel, .comp-grid-mask").show();
            $('.main-grid-table').addClass('fade-main-grid');
            this.getOpportunityScores(firmPageNumber, productPageNumber, isArrowClicked);
        };
        ProductPage.prototype.initTabData = function () {
            $("#tabWheel").hide();
            this.currentAnalyticsTab = this.tabDataList[0].tabId;
            for (var i = 0; i < this.tabDataList.length; i++) {
                jQuery("#" + this.tabDataList[i].tabId + "Tab").hide();
            }
        };
        ProductPage.prototype.hideMainTable = function () {
            jQuery("#mainTable").hide();
            jQuery("#commentTable").hide();
            jQuery("#show-hide-grid").hide();
            jQuery("#highlighted-blocks").hide();
        };
        ProductPage.prototype.showMainTable = function () {
            jQuery("#mainTable").show();
            jQuery("#commentTable").show();
            jQuery("#show-hide-grid").show();
            jQuery("#hideGrid").show();
            jQuery("#showGrid").hide();
            jQuery("#show-margin-block").hide();
            jQuery("#highlighted-blocks, #analyticsTabs").hide();
        };
        ProductPage.prototype.getOpportunityScores = function (firmPageNumber, productPageNumber, isArrowClicked) {
            var _this = this;
            this.service.getOpportunityScores(firmPageNumber, productPageNumber).then(function (result) {
                _this.dataList = _this.parser.getCompetitiveDataList(result);
                _this.getMatrixData(result.data);
                _this.matrixData = result.data;
                _this.getDataUrl();
                if (_this.dataList.length > 0) {
                    _this.mainGridModel.setDataList(_this.dataList);
                    _this.updateMainTableHtml();
                    if (!isArrowClicked) {
                        _this.updateCurrentParameters(0, 0);
                        _this.updateShowHideBlocks(0, 0);
                    }
                    _this.showMainTable();
                }
                $("#mainWheel, #gridWheel, .comp-grid-mask").hide();
                $('.main-grid-table').removeClass('fade-main-grid');
                _this.setObsoluteValue();
            });
        };
        ProductPage.prototype.getMatrixData = function (data) {
            var _this = this;
            this.opportunityArray = [];
            data.forEach(function (item, index) {
                if (index === 0) {
                    item.clientSalesData.forEach(function (row) {
                        _this.opportunityArray.push(row.productPortfolio);
                    });
                    return false;
                }
            });
        };
        ProductPage.prototype.updateCurrentParameters = function (rowNumber, columnNumber) {
            this.firmName = this.dataList[rowNumber].firmName;
            if (this.isClient) {
                this.currentParameter = this.dataList[rowNumber].clientSalesData[columnNumber];
            }
            else {
                this.currentParameter = this.dataList[rowNumber].industrySalesData[columnNumber];
            }
        };
        ProductPage.prototype.updateShowHideBlocks = function (rowNumber, columnNumber) {
            var oneLine = this.dataList[rowNumber];
            var productName = oneLine.clientSalesData[columnNumber].productPortfolio;
            var clientSales = oneLine.clientSalesData[columnNumber].clientSales;
            var category = oneLine.clientSalesData[columnNumber].category;
            if (!this.isClient) {
                productName = oneLine.industrySalesData[columnNumber].productPortfolio;
                clientSales = oneLine.industrySalesData[columnNumber].clientSales;
                category = oneLine.industrySalesData[columnNumber].category;
            }
            this.mainGridModel.generateFirstBlock(rowNumber, columnNumber, this.isOpportunity, this.isClient);
            this.selectedProduct = productName;
            this.selectedFirm = oneLine.firmName;
            this.selectedCategory = category;
            jQuery("#highlighted-second-block").html("");
            var secondBlockHtml = '<div class="comp-insights-show-hide-fonts">' + CompInsights.Strings.FIRM + '</div>';
            secondBlockHtml += '<div class="comp-insights-big-fonts" id="comp-insights-firmname" >' + oneLine.firmName + '</div>';
            jQuery("#highlighted-second-block").html(secondBlockHtml);
            jQuery("#highlighted-third-block").html("");
            var thirdBlockHtml = '<div class="comp-insights-show-hide-fonts">' + CompInsights.Strings.PRODUCT + '</div>';
            thirdBlockHtml += '<div class="comp-insights-big-fonts" id="selected_product" value="' + this.selectedCategory + '">' + productName + '</div>';
            jQuery("#highlighted-third-block").html(thirdBlockHtml);
            jQuery("#highlighted-fourth-block").html("");
            var fourthBlockHtml = '<div class="comp-insights-show-hide-fonts">' + CompInsights.Strings.CATEGORY_LABEL + '</div>';
            fourthBlockHtml += '<div class="comp-insights-big-fonts" id="selected_product" value="' + this.selectedCategory + '">' + category + '</div>';
            jQuery("#highlighted-fourth-block").html(fourthBlockHtml);
        };
        ProductPage.prototype.updateMainTableHtml = function () {
            jQuery(".comp-main-grid-wrapper").html("");
            this.mainGridModel.generateMainTableHtml(this.isOpportunity, this.isClient);
            this.initializeMainTableEvents();
        };
        ProductPage.prototype.updateRankingTabHtml = function () {
            this.rankingsModel.buildRankingsTab(this.selectedProduct, this.selectedFirm, this.selectedCategory);
        };
        ProductPage.prototype.updateSalesTrendsTabHtml = function () {
            this.salesTrendsModel.updateSalesTrends(this.firmName, this.currentParameter.category, this.currentParameter.productPortfolio);
        };
        ProductPage.prototype.updateKeySalesDriversTabHtml = function () {
            this.keySalesDriversModel.initiateKeySalesDrivers(this.firmName, this.currentParameter.category, this.currentParameter.productPortfolio);
            this.keySalesDriversModel.firmName = this.firmName;
            this.keySalesDriversModel.category = this.currentParameter.category;
            this.keySalesDriversModel.productPortfolio = this.currentParameter.productPortfolio;
        };
        ProductPage.prototype.updatePlatformTabHtml = function () {
            this.platformModel.updatePlatform(this.firmName, this.currentParameter.category, this.currentParameter.productPortfolio);
        };
        ProductPage.prototype.updateScatterplotTabHtml = function () {
            this.scatterplot.updateScatterplotTables(this.firmName, this.currentParameter.category, this.currentParameter.productPortfolio);
        };
        ProductPage.prototype.updateAnalyticsTabHtml = function () {
            this.analytics.updateAnalyticsTab(this.firmName, this.currentParameter.category, this.currentParameter.productPortfolio);
        };
        ProductPage.prototype.updateOpportunitiesTabHtml = function () {
            this.OpportunitiesModel.initiateOpportunities(this.firmName, this.currentParameter.category, this.currentParameter.productPortfolio);
        };
        ProductPage.prototype.scrollFunction = function () {
            if (jQuery("#highlighted-blocks").is(":visible")) {
                var pos = jQuery('#highlighted-blocks').offset();
                if (window.scrollY < pos.top) {
                    jQuery("#toTopBtn").hide();
                }
                else {
                    jQuery("#toTopBtn").show();
                }
            }
            else {
                jQuery("#toTopBtn").hide();
            }
        };
        ProductPage.prototype.topFunction = function (e) {
            e.preventDefault();
            jQuery('html, body').animate({ scrollTop: 0 });
        };
        ProductPage.prototype.initializeProductPageEvents = function () {
            var _this = this;
            jQuery("#opportunity-risk-dropdown, #client-industry-dropdown").change(function () {
                _this.checkDropDownButtons();
                jQuery("#highlighted-blocks, #analyticsTabs").hide();
            });
            jQuery("#showGrid, #hideGrid").click(function () {
                _this.hideShowGrid();
            });
            jQuery("#toTopBtn").click(function (e) {
                _this.topFunction(e);
            });
            this.initializeAnalyticsTabsEvents();
            jQuery(window).scroll(function () {
                _this.scrollFunction();
            });
            jQuery("#toTopBtn").hide();
        };
        ProductPage.prototype.hideShowGrid = function () {
            this.bShowGrid = !this.bShowGrid;
            if (this.bShowGrid) {
                jQuery("#hideGrid").show();
                jQuery("#showGrid").hide();
                if (jQuery("#analyticsTabs").is(":visible")) {
                    jQuery("#highlighted-blocks").show();
                }
                else {
                    jQuery("#highlighted-blocks").hide();
                }
                jQuery("#mainTable").show();
                jQuery("#commentBars").show();
            }
            else {
                jQuery("#hideGrid").hide();
                jQuery("#showGrid").show();
                jQuery("#highlighted-blocks").show();
                jQuery("#mainTable").hide();
                jQuery("#commentBars").hide();
            }
            this.hideShowCommentTable();
        };
        ProductPage.prototype.hideShowCommentTable = function () {
            if (this.bShowGrid) {
                jQuery("#clientSalesZero, #lowestNumberRange, #lowNumberRange, #highNumberRange, #highestNumberRange, #lowestCommentName, #lowCommentName, #highCommentName, #highestCommentName").show();
            }
            else {
                jQuery("#clientSalesZero, #lowestNumberRange, #lowNumberRange, #highNumberRange, #highestNumberRange, #lowestCommentName, #lowCommentName, #highCommentName, #highestCommentName").hide();
            }
        };
        ProductPage.prototype.checkDropDownButtons = function () {
            var client_val = jQuery("#client-industry-dropdown").val();
            var opportunity_val = jQuery("#opportunity-risk-dropdown").val();
            this.isClient = (client_val === "client");
            this.isOpportunity = (opportunity_val === "opportunity");
            this.updateMainTableHtml();
            this.updateCommentTable();
            // this.updateShowHideBlocks(0, 0);
        };
        ProductPage.prototype.updateCommentTable = function () {
            if (this.isOpportunity) {
                jQuery("#lowestCommentName").text("Lowest Opportunity");
                jQuery("#lowCommentName").text("Low Opportunity");
                jQuery("#highCommentName").text("High Opportunity");
                jQuery("#highestCommentName").text("Highest Opportunity");
                jQuery("#highCommentName").attr("class", "comp-insights-foot-color-opportunity-high");
                jQuery("#highestCommentName").attr("class", "comp-insights-foot-color-opportunity-highest");
                jQuery("#highNumberRange").attr("class", "background-color-opportunity-high comp-insights-foot-padding");
                jQuery("#highestNumberRange").attr("class", "background-color-opportunity-highest comp-insights-foot-padding");
            }
            else {
                jQuery("#lowestCommentName").text("Lowest Risk");
                jQuery("#lowCommentName").text("Low Risk");
                jQuery("#highCommentName").text("High Risk");
                jQuery("#highestCommentName").text("Highest Risk");
                jQuery("#highCommentName").attr("class", "comp-insights-foot-color-risk-high");
                jQuery("#highestCommentName").attr("class", "comp-insights-foot-color-risk-highest");
                jQuery("#highNumberRange").attr("class", "background-color-risk-high comp-insights-foot-padding");
                jQuery("#highestNumberRange").attr("class", "background-color-risk-highest comp-insights-foot-padding");
            }
        };
        ProductPage.prototype.initializeMainTableEvents = function () {
            var _this = this;
            for (var i = 0; i < this.rowSize; i++) {
                for (var j = 0; j < this.columnSize; j++) {
                    var idContent = "#td_" + i + "_" + j;
                    jQuery(idContent).click(function (e) {
                        _this.mainTableTdEvents(e);
                        // new BiWhatIfScenarios.ProductPage($(".what-if-scenario-outer-wrapper")).resetWhatIfPage();      
                        BiWhatIfScenarios.ProductPage.getInstance($(".what-if-scenario-outer-wrapper")).resetWhatIfPage();
                    });
                }
            }
        };
        ProductPage.prototype.mainTableTdEvents = function (e) {
            var _this = this;
            var id = e.currentTarget.id;
            if (!id)
                return;
            var numArr = id.split("_");
            var rowNumber = 0;
            var columnNumber = 0;
            if (numArr.length >= 3) {
                rowNumber = parseInt(numArr[1], 10);
                columnNumber = parseInt(numArr[2], 10);
            }
            this.updateCurrentParameters(rowNumber, columnNumber);
            this.updateShowHideBlocks(rowNumber, columnNumber);
            var hasPlatform = false;
            var hasWhatif = false;
            var hasKeySalesDrivers = false;
            var hasTerritory = false;
            var hasRankings = false;
            this.service.getCompInsightsTabInfo(this.selectedProduct, this.selectedFirm, this.selectedCategory).then(function (results) {
                var tabsAvailable = _this.tabDataList;
                if (results.rankings > 0) {
                    hasRankings = true;
                }
                if (results.platformCodes > 0) {
                    hasPlatform = true;
                }
                if (results.whatIf > 0) {
                    hasWhatif = true;
                }
                if (results.territory > 0) {
                    hasTerritory = true;
                }
                if (results.keySalesDrivers > 0) {
                    hasKeySalesDrivers = true;
                    _this.keySalesDriverData();
                }
                if (!hasPlatform) {
                    jQuery("#platform").hide();
                    tabsAvailable = tabsAvailable.filter(function (tab) {
                        if (tab.tabId !== 'platform') {
                            return tab;
                        }
                    });
                    if (_this.currentAnalyticsTab === "platform") {
                        _this.currentAnalyticsTab = "ranking";
                    }
                }
                else {
                    jQuery("#platform").show();
                }
                if (!hasWhatif) {
                    jQuery("#whatif").hide();
                    tabsAvailable = tabsAvailable.filter(function (tab) {
                        if (tab.tabId !== 'whatif') {
                            return tab;
                        }
                    });
                    if (_this.currentAnalyticsTab === "whatif") {
                        _this.currentAnalyticsTab = "ranking";
                    }
                }
                else {
                    jQuery("#whatif").show();
                }
                if (!hasKeySalesDrivers) {
                    jQuery("#drivers").hide();
                    tabsAvailable = tabsAvailable.filter(function (tab) {
                        if (tab.tabId !== 'drivers') {
                            return tab;
                        }
                    });
                    if (_this.currentAnalyticsTab === "drivers") {
                        _this.currentAnalyticsTab = "ranking";
                    }
                    _this.keySalesDriverDataList = [];
                }
                else {
                    jQuery("#drivers").show();
                }
                if (!hasTerritory) {
                    jQuery("#opportunities").hide();
                    jQuery("#analytics").hide();
                    jQuery("#scatterplot").hide();
                    tabsAvailable = tabsAvailable.filter(function (tab) {
                        if (tab.tabId.indexOf(['opportunities', 'analytics', 'scatterplot']) === -1) {
                            return tab;
                        }
                    });
                    if ((_this.currentAnalyticsTab === "analytics") || (_this.currentAnalyticsTab === "opportunities") || (_this.currentAnalyticsTab === "scatterplot")) {
                        _this.currentAnalyticsTab = "ranking";
                    }
                }
                else {
                    jQuery("#opportunities").show();
                    jQuery("#analytics").show();
                    jQuery("#scatterplot").show();
                }
                if (!hasRankings) {
                    jQuery('#ranking').hide();
                    tabsAvailable = tabsAvailable.filter(function (tab) {
                        if (tab.tabId !== 'ranking') {
                            return tab;
                        }
                    });
                    _this.currentAnalyticsTab = tabsAvailable[0].tabId;
                }
                else {
                    jQuery('#ranking').show();
                }
                for (var i = 0; i < _this.tabDataList.length; i++) {
                    _this.tabDataList[i].updated = false;
                }
                _this.changeAnalyticsTab(_this.currentAnalyticsTab);
                jQuery("#highlighted-blocks").show();
                _this.hideShowAnalyticsTabs(true);
                var pos = jQuery('#highlighted-blocks').offset();
                e.preventDefault();
                jQuery('html, body').animate({ scrollTop: pos.top });
                _this.marketShareData();
                _this.salesTrendsData();
                _this.rankingsTabData();
                $(".comp-insights-download-img").click(function (e) {
                    e.stopImmediatePropagation();
                    _this.downloadCompInsightPDF();
                });
            });
        };
        ProductPage.prototype.rankingsTabData = function () {
            var _this = this;
            this.service.getRanksByQuarter(this.selectedProduct, this.selectedFirm).then(function (result) {
                _this.rankingsDataList = result;
            });
        };
        ProductPage.prototype.salesTrendsData = function () {
            var _this = this;
            this.service.getSalesTrends(this.selectedFirm, this.selectedCategory, this.selectedProduct).then(function (result) {
                _this.salesTrendsDataList = {
                    marketShareData: result.marketShareData,
                    salesConcentrationDataList: result.salesConcentrationDataList,
                    quarters: result.quarters
                };
            });
        };
        ProductPage.prototype.marketShareData = function () {
            var _this = this;
            this.service.getOpportunities(this.selectedFirm, this.selectedCategory, this.selectedProduct).then(function (result) {
                if (result !== null) {
                    result.map(function (item) {
                        delete item.opp_morningstar_product_category;
                        return item;
                    });
                    _this.marketShareDataList = result;
                    _this.calculateNarketshareAvgs();
                    _this.marketShareDataList.sort(_this.compareValues("opp_industry_gross_sales"));
                    _this.marketShareDataList.reverse();
                }
                else {
                    _this.marketShareDataList = [];
                }
            });
        };
        ProductPage.prototype.keySalesDriverData = function () {
            var _this = this;
            this.service.getKeySalesDrivers(this.selectedFirm, this.selectedCategory, this.selectedProduct).then(function (result) {
                if (result !== null) {
                    _this.keySalesDriverDataList = result.filter(function (driver) {
                        if (driver.platform === 'ALL')
                            return driver;
                    });
                }
                else {
                    _this.keySalesDriverDataList = [];
                }
            });
        };
        ProductPage.prototype.compareValues = function (propertyName) {
            return function (a, b) {
                var aa = a[propertyName];
                var bb = b[propertyName];
                if (typeof aa === "number") {
                    return aa - bb;
                }
                if (typeof aa === "string") {
                    return aa.localeCompare(bb);
                }
                return 0;
            };
        };
        ProductPage.prototype.getAverageValue = function (value, isPercent) {
            var data;
            var formattedValue = '';
            if (isPercent) {
                formattedValue = new LabelBuilder.PercentLabelBuilder(true, false).build(value);
            }
            else {
                //formattedValue = new LabelBuilder.CompInsightLabelBuilder().build(value);
                formattedValue = new LabelBuilder.SalesLabelBuilder(true, false).build(value, true);
            }
            data = { text: 'Avg = ' + formattedValue, style: 'avgStyle' };
            return data;
        };
        ProductPage.prototype.calculateNarketshareAvgs = function () {
            var _this = this;
            for (var j = 0; j < 3; j++) {
                this.summaryTableContent[j] = 0;
            }
            this.marketShareDataList.forEach(function (row) {
                _this.summaryTableContent[0] += row.opp_market_share;
                _this.summaryTableContent[1] += row.opp_actual_sales;
                _this.summaryTableContent[2] += row.opp_expected_sales;
            });
            for (var j = 0; j < 3; j++) {
                this.summaryTableContent[j] /= this.marketShareDataList.length;
            }
        };
        ProductPage.prototype.buildMarketShareTable = function (startRow, endRow, marketShareDataList) {
            var _this = this;
            var marketShareHeader = [];
            var expectedSalesAverage = this.summaryTableContent[2]; //$(".expected-sales-averages").text().split("=");
            var actualSalesAverage = this.summaryTableContent[1]; //$(".actual-sales-averages").text().split("=");
            var marketShareAverage = this.summaryTableContent[0]; //$(".market-share-averages").text().split("=");
            this.marketShareHeaders.forEach(function (data, index) {
                var header = { text: data, bold: true, fontSize: 9, alignment: 'center' };
                if (index === 0) {
                    header.alignment = 'left';
                }
                if (index === 3) {
                    header.text = [_this.getAverageValue(expectedSalesAverage, false), { text: '\n Expected Sales' }];
                }
                if (index === 4) {
                    header.text = [_this.getAverageValue(actualSalesAverage, false), { text: '\n Actual Sales' }];
                }
                if (index === 6) {
                    header.text = [_this.getAverageValue(marketShareAverage, true), { text: '\n Market Share' }];
                }
                marketShareHeader.push(header);
            });
            var tableData = {
                table: {
                    headerRows: 2,
                    widths: [120, 75, 65, 70, 70, 60, 60, 60, 60, 60],
                    body: [marketShareHeader]
                },
                layout: {
                    hLineWidth: function (i) {
                        return (i === 0) ? 0 : 1;
                    },
                    vLineWidth: function () {
                        return 0;
                    },
                    hLineColor: function () {
                        return '#E7E7E7';
                    },
                    vLineColor: function () {
                        return 'white';
                    },
                    paddingTop: function () {
                        return 5;
                    },
                    paddingBottom: function () {
                        return 5;
                    }
                },
                margin: [0, 15, 0, 0]
            };
            for (var i = startRow; i < endRow; i++) {
                var oppData = marketShareDataList[i];
                var marketArr = [];
                for (var key in oppData) {
                    if (key == 'opp_assigned_territory_name') {
                        var row = { text: oppData[key], bold: false, fontSize: 9, alignment: 'left' };
                        marketArr.push(row);
                    }
                    else {
                        var row = {
                            text: [this.formatText(oppData[key], key)]
                        };
                        marketArr.push(row);
                    }
                }
                tableData.table.body.push(marketArr);
            }
            return tableData;
        };
        ProductPage.prototype.formatText = function (value, key) {
            var formattedValue = '';
            var data;
            if (key == 'opp_market_share' || key == 'opp_market_share_diff' ||
                key == 'opp_percent_diff_expected_sales') {
                formattedValue = new LabelBuilder.PercentLabelBuilder(true, false).build(value);
            }
            else {
                //formattedValue = new LabelBuilder.CompInsightLabelBuilder().build(value);
                formattedValue = new LabelBuilder.SalesLabelBuilder(true, false).build(value, true);
            }
            if (value < 0) {
                data = { text: formattedValue, style: 'negValueFont' };
            }
            else {
                data = { text: formattedValue, style: 'posValueStyle' };
            }
            return data;
        };
        //Market share PDF Slide
        ProductPage.prototype.getMarketSharePDFContent = function () {
            var marketShareDataList = this.marketShareDataList;
            var totalRows = marketShareDataList.length;
            var rowsPerPage = 17;
            var startRow = 0;
            var endRow = Math.min(17, totalRows);
            var totalPages = Math.ceil((totalRows) / rowsPerPage);
            if (this.marketShareDataList.length !== 0) {
                var stackData = {
                    stack: [
                        {
                            text: 'Territory Opportunities',
                            fontSize: 1,
                            color: '#FFFFFF',
                            pageBreak: 'before',
                            id: 'territory_opportunities_toc'
                        },
                        [{
                                columns: [
                                    {
                                        text: 'Market Share (1 of ' + totalPages + ')',
                                        style: 'tabPageNumber',
                                        width: 250,
                                        margin: [0, 0, 0, 10]
                                    },
                                    {
                                        text: 'Territory Opportunities',
                                        style: 'tabHeader',
                                        alignment: 'right',
                                        margin: [0, 0, 30, 10]
                                    }
                                ]
                            },
                            this.buildMarketShareTable(startRow, endRow, marketShareDataList)
                        ]
                    ]
                };
                for (var i = 2; i <= totalPages; i++) {
                    startRow = startRow + rowsPerPage;
                    endRow = endRow + rowsPerPage;
                    if (endRow > totalRows)
                        endRow = totalRows;
                    if (i === 2) {
                        var pageData = [{
                                columns: [
                                    {
                                        text: 'Market Share (' + i + ' of ' + totalPages + ')',
                                        style: 'tabPageNumber',
                                        width: 250,
                                        margin: [0, 0, 0, 10]
                                    },
                                    {
                                        text: 'Territory Opportunities',
                                        style: 'tabHeader',
                                        alignment: 'right',
                                        margin: [0, 0, 30, 10]
                                    }
                                ]
                            },
                            this.buildMarketShareTable(startRow, endRow, marketShareDataList)
                        ];
                        stackData.stack.push(pageData);
                    }
                    else {
                        var pageData = [{
                                columns: [
                                    {
                                        text: 'Market Share (' + i + ' of ' + totalPages + ')',
                                        style: 'tabPageNumber',
                                        width: 250,
                                        margin: [0, 0, 0, 10]
                                    },
                                    {
                                        text: 'Territory Opportunities',
                                        style: 'tabHeader',
                                        alignment: 'right',
                                        margin: [0, 0, 0, 10]
                                    }
                                ]
                            },
                            this.buildMarketShareTable(startRow, endRow, marketShareDataList)
                        ];
                        stackData.stack.push(pageData);
                    }
                }
                return stackData;
            }
        };
        ProductPage.prototype.getTableOfContents = function () {
            var tableData = {
                table: {
                    widths: ['auto', 'auto'],
                    body: this.tableOfContentsBody()
                },
                layout: {
                    defaultBorder: false,
                    paddingLeft: function (i, node) {
                        return 15;
                    },
                    paddingRight: function (i, node) {
                        return 1;
                    },
                    paddingTop: function (i, node) {
                        return 10;
                    },
                    paddingBottom: function (i, node) {
                        return 5;
                    },
                },
                absolutePosition: { x: 70, y: 224 }
            };
            return tableData;
        };
        ProductPage.prototype.tableOfContentsBody = function () {
            var _this = this;
            var body = [];
            this.tableOfContents.forEach(function (item) {
                if (!((item === 'territory_opportunities_toc' && _this.marketShareDataList.length === 0) ||
                    (item === 'key_sales_drivers_toc' && _this.keySalesDriverDataList.length === 0) ||
                    (item === 'rankings_toc' && _this.rankingsDataList.length === 0))) {
                    var row = [{ pageReference: item, style: 'tocNumberStyle' }, {
                            textReference: item,
                            style: 'tocTextStyle'
                        }];
                    body.push(row);
                }
            });
            return body;
        };
        //Client 10x10 PDF Slide
        ProductPage.prototype.getClient10by10Content = function () {
            var stackData = {
                stack: [
                    {
                        text: 'Client 10x10',
                        style: 'tabPageNumber',
                        pageBreak: 'before',
                        id: 'client_10_by_10_toc'
                    },
                    [this.getOpportunitiesMatrix()],
                    [this.getOpportunityMatrixInfo()],
                    [this.getClientSalesInfo()],
                    {
                        text: 'Client 10x10',
                        style: 'tabPageNumber',
                        pageBreak: 'before'
                    },
                    [this.getRiskMatrix()],
                    [this.getRiskMatrixInfo()],
                    [this.getClientSalesInfo()]
                ]
            };
            return stackData;
        };
        ProductPage.prototype.getClientSalesInfo = function () {
            var tableData = {
                table: {
                    widths: [5, 75],
                    body: [
                        [
                            {
                                text: '$0',
                                fillColor: '#676767',
                                color: 'white',
                                alignment: 'center',
                                bold: true,
                                fontSize: 7,
                                noWrap: true,
                            },
                            {
                                text: 'Client Sales = $0',
                                alignment: 'left',
                                fontSize: 7,
                                noWrap: true,
                                margin: [2, 0, 0, 0]
                            }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: function (i) {
                        return (i === 0) ? 0 : 2;
                    },
                    vLineWidth: function () {
                        return 2;
                    },
                    hLineColor: function () {
                        return 'white';
                    },
                    vLineColor: function () {
                        return 'white';
                    },
                    paddingTop: function () {
                        return 2;
                    },
                    paddingBottom: function () {
                        return 2;
                    }
                },
                absolutePosition: { x: 200, y: 462 }
            };
            return tableData;
        };
        ProductPage.prototype.getRiskMatrixInfo = function () {
            var tableData = {
                table: {
                    widths: [75, 75, 75, 75],
                    body: [
                        [{ text: '1 - 25', fillColor: '#EEE', alignment: 'center', fontSize: 7 }, {
                                text: '26 - 50',
                                alignment: 'center',
                                fillColor: '#DDD',
                                fontSize: 7
                            },
                            {
                                text: '51 - 75',
                                fillColor: '#e57373',
                                alignment: 'center',
                                bold: 'true',
                                color: '#FFFFFF',
                                fontSize: 7
                            }, {
                                text: '76 - 100',
                                fillColor: '#c62828',
                                bold: 'true',
                                alignment: 'center',
                                color: '#FFFFFF',
                                fontSize: 7
                            }],
                        [{
                                text: 'Lowest Risk',
                                alignment: 'center',
                                noWrap: true,
                                fontSize: 7
                            }, { text: 'Low Risk', alignment: 'center', noWrap: true, fontSize: 7 },
                            {
                                text: 'High Risk',
                                alignment: 'center',
                                noWrap: true,
                                fontSize: 7,
                                color: '#e57373'
                            }, { text: 'Highest Risk', alignment: 'center', noWrap: true, color: '#c62828', fontSize: 7 }]
                    ]
                },
                layout: {
                    hLineWidth: function (i) {
                        return (i === 0) ? 0 : 2;
                    },
                    vLineWidth: function () {
                        return 2;
                    },
                    hLineColor: function () {
                        return 'white';
                    },
                    vLineColor: function () {
                        return 'white';
                    },
                    paddingTop: function () {
                        return 5;
                    },
                    paddingBottom: function () {
                        return 5;
                    }
                },
                absolutePosition: { x: 468, y: 462 }
            };
            return tableData;
        };
        ProductPage.prototype.getRiskMatrix = function () {
            var _this = this;
            var opportunityMatrixHeader = [];
            opportunityMatrixHeader.push({ text: '', bold: false, fontSize: 9, alignment: 'center' });
            this.opportunityArray.forEach(function (data, index) {
                var header = { text: data, bold: false, fontSize: 9, alignment: 'center' };
                opportunityMatrixHeader.push(header);
            });
            var tableData = {
                table: {
                    widths: [150, 51, 51, 51, 51, 51, 51, 51, 51, 51, 51],
                    body: [opportunityMatrixHeader]
                },
                layout: {
                    hLineWidth: function (i) {
                        return (i === 0) ? 0 : 2;
                    },
                    vLineWidth: function () {
                        return 2;
                    },
                    hLineColor: function () {
                        return 'white';
                    },
                    vLineColor: function () {
                        return 'white';
                    }
                },
                margin: [0, 15, 10, 0]
            };
            var rowElementList = [];
            this.matrixData.forEach(function (row) {
                var firm = { text: row.firmName, alignment: 'left', noWrap: true, style: 'matrixStyle' };
                rowElementList.push(firm);
                var salesData = row.clientSalesData;
                salesData.forEach(function (parameter) {
                    if (parameter.clientSales === 0 && parameter.risk !== 0) {
                        var value = parameter.risk > 75 ? true : (parameter.risk <= 75 && parameter.risk > 50) ? true : false;
                        var row_1 = {
                            columns: [{
                                    stack: [
                                        {
                                            table: {
                                                widths: 'auto',
                                                body: [
                                                    [{
                                                            border: [false, false, false, false],
                                                            fillColor: '#FFFFFF',
                                                            text: '$0',
                                                            fontSize: 7
                                                        }]
                                                ]
                                            },
                                            relativePosition: { x: -5, y: -5 }
                                        },
                                        {
                                            text: parameter.risk,
                                            bold: value,
                                            fontSize: 9,
                                            alignment: 'center',
                                            margin: [0, 5, 0, 5]
                                        }
                                    ]
                                }]
                        };
                        _this.setRiskTileColor(row_1, parameter.risk);
                        rowElementList.push(row_1);
                    }
                    else {
                        var risk = {
                            text: parameter.risk,
                            bold: true,
                            fontSize: 9,
                            alignment: 'center',
                            margin: [0, 5, 0, 5]
                        };
                        _this.setRiskTileColor(risk, parameter.risk);
                        rowElementList.push(risk);
                    }
                });
                tableData.table.body.push(rowElementList);
                rowElementList = [];
            });
            return tableData;
        };
        ProductPage.prototype.setRiskTileColor = function (risk, value) {
            if (value > 75) {
                risk['fillColor'] = '#c62828';
                risk['color'] = '#FFFFFF';
            }
            else if (value <= 75 && value > 50) {
                risk['fillColor'] = '#e57373';
                risk['color'] = '#FFFFFF';
            }
            else if (value <= 50 && value > 25) {
                risk['fillColor'] = '#DDD';
                risk['bold'] = false;
            }
            else if (value <= 25 && value >= 1) {
                risk['fillColor'] = '#EEE';
                risk['bold'] = false;
            }
            else if (value == 0) {
                risk['fillColor'] = '#AAA';
                risk['text'] = '';
            }
        };
        ProductPage.prototype.getOpportunityMatrixInfo = function () {
            var tableData = {
                table: {
                    widths: [75, 75, 75, 75],
                    body: [
                        [{ text: '1 - 25', fillColor: '#EEE', alignment: 'center', fontSize: 7 }, {
                                text: '26 - 50',
                                alignment: 'center',
                                fillColor: '#DDD',
                                fontSize: 7
                            },
                            {
                                text: '51 - 75',
                                fillColor: '#66BB6A',
                                alignment: 'center',
                                bold: 'true',
                                color: '#FFFFFF',
                                fontSize: 7
                            }, {
                                text: '76 - 100',
                                fillColor: '#388E3C',
                                bold: 'true',
                                alignment: 'center',
                                color: '#FFFFFF',
                                fontSize: 7
                            }],
                        [{
                                text: 'Lowest Opportunity',
                                alignment: 'center',
                                noWrap: true,
                                fontSize: 7
                            }, { text: 'Low Opportunity', alignment: 'center', noWrap: true, fontSize: 7 },
                            {
                                text: 'High Opportunity',
                                alignment: 'center',
                                noWrap: true,
                                fontSize: 7,
                                color: '#66BB6A'
                            }, {
                                text: 'Highest Opportunity',
                                alignment: 'center',
                                color: '#388E3C',
                                noWrap: true,
                                fontSize: 7
                            }]
                    ]
                },
                layout: {
                    hLineWidth: function (i) {
                        return (i === 0) ? 0 : 2;
                    },
                    vLineWidth: function () {
                        return 2;
                    },
                    hLineColor: function () {
                        return 'white';
                    },
                    vLineColor: function () {
                        return 'white';
                    },
                    paddingTop: function () {
                        return 5;
                    },
                    paddingBottom: function () {
                        return 5;
                    }
                },
                absolutePosition: { x: 470, y: 462 }
            };
            return tableData;
        };
        ProductPage.prototype.getOpportunitiesMatrix = function () {
            var _this = this;
            var opportunityMatrixHeader = [];
            opportunityMatrixHeader.push({ text: '', bold: false, fontSize: 9, alignment: 'center' });
            this.opportunityArray.forEach(function (data, index) {
                var header = { text: data, bold: false, fontSize: 9, alignment: 'center' };
                opportunityMatrixHeader.push(header);
            });
            var tableData = {
                table: {
                    widths: [150, 51, 51, 51, 51, 51, 51, 51, 51, 51, 51],
                    body: [opportunityMatrixHeader]
                },
                layout: {
                    hLineWidth: function (i) {
                        return (i === 0) ? 0 : 2;
                    },
                    vLineWidth: function () {
                        return 2;
                    },
                    hLineColor: function () {
                        return 'white';
                    },
                    vLineColor: function () {
                        return 'white';
                    }
                },
                margin: [0, 15, 10, 0]
            };
            var rowElementList = [];
            this.matrixData.forEach(function (row) {
                var firm = { text: row.firmName, alignment: 'left', noWrap: true, style: 'matrixStyle' };
                rowElementList.push(firm);
                var salesData = row.clientSalesData;
                salesData.forEach(function (parameter) {
                    if (parameter.clientSales === 0 && parameter.opportunity !== 0) {
                        var value = parameter.opportunity > 75 ? true : (parameter.opportunity <= 75 && parameter.opportunity > 50) ? true : false;
                        var row_2 = {
                            columns: [{
                                    stack: [
                                        {
                                            table: {
                                                widths: 'auto',
                                                body: [
                                                    [{
                                                            border: [false, false, false, false],
                                                            fillColor: '#FFFFFF',
                                                            text: '$0',
                                                            fontSize: 7
                                                        }]
                                                ]
                                            },
                                            relativePosition: { x: -5, y: -5 }
                                        },
                                        {
                                            text: parameter.opportunity,
                                            bold: value,
                                            fontSize: 9,
                                            alignment: 'center',
                                            margin: [0, 5, 0, 5]
                                        }
                                    ]
                                }]
                        };
                        _this.setOpportunityTileColor(row_2, parameter.opportunity);
                        rowElementList.push(row_2);
                    }
                    else {
                        var opportunity = {
                            text: parameter.opportunity,
                            bold: true,
                            fontSize: 9,
                            alignment: 'center',
                            margin: [0, 5, 0, 5]
                        };
                        _this.setOpportunityTileColor(opportunity, parameter.opportunity);
                        rowElementList.push(opportunity);
                    }
                });
                tableData.table.body.push(rowElementList);
                rowElementList = [];
            });
            return tableData;
        };
        ProductPage.prototype.setOpportunityTileColor = function (opportunity, value) {
            if (value > 75) {
                opportunity['fillColor'] = '#388E3C';
                opportunity['color'] = '#FFFFFF';
            }
            else if (value <= 75 && value > 50) {
                opportunity['fillColor'] = '#66BB6A';
                opportunity['color'] = '#FFFFFF';
            }
            else if (value <= 50 && value > 25) {
                opportunity['fillColor'] = '#DDD';
                opportunity['bold'] = false;
            }
            else if (value <= 25 && value >= 1) {
                opportunity['fillColor'] = '#EEE';
                opportunity['bold'] = false;
            }
            else if (value == 0) {
                opportunity['fillColor'] = '#AAA';
                opportunity['text'] = '';
            }
        };
        ProductPage.prototype.getRiskValue = function (value) {
            if (value > 75) {
                return 'Highest Risk';
            }
            else if (value <= 75 && value > 50) {
                return 'High Risk';
            }
            else if (value <= 50 && value > 25) {
                return 'Low Risk';
            }
            else if (value <= 25 && value >= 1) {
                return 'Lowest Risk';
            }
        };
        ProductPage.prototype.getOpportunityRiskData = function (currentPage, pageCount) {
            var score;
            var color;
            var backgroundColor;
            var rating;
            var value = this.getOpportunityRiskValue();
            if (currentPage === pageCount - 1) {
                score = this.getOpportunityRiskValue();
                rating = this.getRiskValue(this.getOpportunityRiskValue());
                backgroundColor = value > 75 ? '#c62828' : (value <= 75 && value > 50) ? '#e57373' : (value <= 50 && value > 25) ? '#DDD' : (value <= 25 && value >= 1) ? '#EEE' : '#AAA';
                color = value > 75 ? '#FFFFFF' : (value <= 75 && value > 50) ? '#FFFFFF' : '#000000';
            }
            else {
                score = $(".comp-insights-zero-block").text();
                rating = $(".comp-insights-first-block").text();
                color = this.getHexCodeValue($(".comp-insights-first-block").css("color"));
                backgroundColor = this.getHexCodeValue($(".comp-insights-first-block").css("background-color"));
            }
            var tableData = {
                table: {
                    headerRows: 0,
                    widths: [20, 1, 114],
                    body: [
                        [{
                                text: score,
                                bold: false,
                                fontSize: 11,
                                color: color,
                                alignment: 'center',
                                fillColor: backgroundColor,
                                fillOpacity: 1.0
                            },
                            {
                                text: ''
                            },
                            {
                                text: rating,
                                bold: false,
                                fontSize: 11,
                                color: color,
                                alignment: 'center',
                                fillColor: backgroundColor,
                                fillOpacity: 1.0
                            }
                        ]
                    ]
                },
                layout: {
                    defaultBorder: false,
                    paddingLeft: function (i, node) {
                        return 1;
                    },
                    paddingRight: function (i, node) {
                        return 1;
                    },
                    paddingTop: function (i, node) {
                        return 5;
                    },
                    paddingBottom: function (i, node) {
                        return 5;
                    },
                },
                absolutePosition: { x: 40, y: 25 }
            };
            return tableData;
        };
        ProductPage.prototype.getOpportunityRiskValue = function () {
            var firmName = this.firmName;
            var productName = this.selectedProduct;
            var matrixObj;
            var matrixProductObj;
            matrixObj = this.matrixData.filter(function (item) { return item.firmName.indexOf(firmName) !== -1; });
            matrixProductObj = matrixObj[0].clientSalesData.filter(function (item) { return item.productPortfolio.indexOf(productName) !== -1; });
            return matrixProductObj[0].risk;
        };
        //Generate logo data uri
        ProductPage.prototype.getDataUrl = function () {
            var _this = this;
            this.service.getPDFLogoData().then(function (result) {
                var base_image = new Image();
                base_image.src = "/assets/img/logos/" + result[0] + ".png";
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');
                // Draw the image
                base_image.onload = function () {
                    // Set width and height
                    canvas.width = base_image.width;
                    canvas.height = base_image.height;
                    ctx.drawImage(base_image, 0, 0);
                    _this.logoDataUri = canvas.toDataURL('image/jpeg');
                };
            });
        };
        ProductPage.prototype.downloadCompInsightPDF = function () {
            var current_user = $($("#user-options-dropdown span")[0]).text();
            var current_date = this.getCurrentDate();
            var firmName = this.firmName.toUpperCase();
            var productName = this.selectedProduct.toUpperCase();
            var latestQuarter = $(".comp-insights-rankings-trends-row th:nth-child(2)").text();
            var _this = this;
            var docDefinition = {
                pageOrientation: 'landscape',
                pageMargins: [40, 80, 40, 60],
                background: function (currentPage) {
                    if (currentPage != 1 && currentPage != 2) {
                        return {
                            canvas: [
                                {
                                    type: 'rect',
                                    x: 0, y: 0, w: 850, h: 70,
                                    color: '#F7F9F9'
                                }
                            ]
                        };
                    }
                },
                footer: function (currentPage, pageCount) {
                    if (currentPage != 1 && currentPage != 2) {
                        return {
                            margin: [40, 10, 40, 0],
                            style: 'headerText',
                            columns: [{
                                    width: '50%',
                                    alignment: 'left',
                                    text: current_user.toUpperCase()
                                },
                                {
                                    width: '50%',
                                    alignment: 'right',
                                    text: currentPage.toString()
                                }]
                        };
                    }
                },
                header: function (currentPage, pageCount) {
                    if (currentPage != 1 && currentPage != 2 && currentPage != pageCount) {
                        return [
                            _this.getOpportunityRiskData(currentPage, pageCount),
                            { text: 'FIRM', absolutePosition: { x: 200, y: 25 }, style: 'headerText' },
                            { text: firmName, absolutePosition: { x: 230, y: 25 }, style: 'headerBold' },
                            { text: 'PRODUCT', absolutePosition: { x: 200, y: 40 }, style: 'headerText' },
                            { text: productName, absolutePosition: { x: 255, y: 40 }, style: 'headerBold' },
                            { text: 'COMPETITIVE INSIGHTS', absolutePosition: { x: 673, y: 25 }, style: 'headerBold' },
                            {
                                text: "GENERATED  " + current_date + "  |  " + "DATA AS OF " + latestQuarter,
                                absolutePosition: { x: 555, y: 40 },
                                style: 'headerText'
                            }
                        ];
                    }
                },
                content: [
                    [{
                            image: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAkACQAAD/4REGRXhpZgAATU0AKgAAAAgABQESAAMAAAABAAEAAAE7AAIAAAAQAAAIVodpAAQAAAABAAAIZpydAAEAAAAgAAAQ3uocAAcAAAgMAAAASgAAAAAc6gAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEJsYW5leSwgRGlhbmEgSgAABZADAAIAAAAUAAAQtJAEAAIAAAAUAAAQyJKRAAIAAAADMzQAAJKSAAIAAAADMzQAAOocAAcAAAgMAAAIqAAAAAAc6gAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADIwMjI6MDU6MjAgMTI6MzA6MzgAMjAyMjowNToyMCAxMjozMDozOAAAAEIAbABhAG4AZQB5ACwAIABEAGkAYQBuAGEAIABKAAAA/+ELImh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8APD94cGFja2V0IGJlZ2luPSfvu78nIGlkPSdXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQnPz4NCjx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iPjxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+PHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9InV1aWQ6ZmFmNWJkZDUtYmEzZC0xMWRhLWFkMzEtZDMzZDc1MTgyZjFiIiB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iLz48cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0idXVpZDpmYWY1YmRkNS1iYTNkLTExZGEtYWQzMS1kMzNkNzUxODJmMWIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyI+PHhtcDpDcmVhdGVEYXRlPjIwMjItMDUtMjBUMTI6MzA6MzguMzQ0PC94bXA6Q3JlYXRlRGF0ZT48L3JkZjpEZXNjcmlwdGlvbj48cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0idXVpZDpmYWY1YmRkNS1iYTNkLTExZGEtYWQzMS1kMzNkNzUxODJmMWIiIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyI+PGRjOmNyZWF0b3I+PHJkZjpTZXEgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj48cmRmOmxpPkJsYW5leSwgRGlhbmEgSjwvcmRmOmxpPjwvcmRmOlNlcT4NCgkJCTwvZGM6Y3JlYXRvcj48L3JkZjpEZXNjcmlwdGlvbj48L3JkZjpSREY+PC94OnhtcG1ldGE+DQogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgIDw/eHBhY2tldCBlbmQ9J3cnPz7/2wBDAAIBAQIBAQICAgICAgICAwUDAwMDAwYEBAMFBwYHBwcGBwcICQsJCAgKCAcHCg0KCgsMDAwMBwkODw0MDgsMDAz/2wBDAQICAgMDAwYDAwYMCAcIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wAARCAMuBB4DASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD9+o+MfT/CnU2Pqf8APc06gAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKGOBRRQA2Pqf89zTqbH1P+e5p1ABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUANj6n/Pc06mx9T/nuadQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFADY+p/z3NOpsfU/wCe5p1ABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUANj6n/AD3NOpsfU/57mnUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQA2Pqf89zTqbH1P+e5p1ABRRRQAUUUUAFFBOKaz4HX9KAHUU0tgU3zSfQfrQFySiml8HtQH+bFF77AOoo3UZoAKKBUcsjRj+H8aTdgJKKjSVmP8NPB5prUNOgtFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFBOKTdS5kAtFNVsmnA5p3AKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAGx9T/nuadTY+p/z3NOoAKKKKACiiigAooooAKKKKADFFFFABRRRQAUdaKKADGKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAGx9T/nuadTY+p/z3NOoAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigBsfU/57mnU2Pqf89zTqACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAbH1P+e5p1Nj6n/Pc06gAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAGx9T/AJ7mnU2Pqf8APc06gAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAGx9T/nuadTY+p/z3NOoAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigBsfU/57mnU2Pqf89zTqACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAbH1P+e5p1Nj6n/Pc06gAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAGx9T/AJ7mnU2Pqf8APc06gAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAGx9T/nuadTY+p/z3NOoAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigBsfU/57mnU2Pqf89zTqACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAbH1P+e5p1Nj6n/Pc06gAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAGx9T/AJ7mnU2Pqf8APc06gAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKT+P8KWk/j/CgBaKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAbH1P+e5p1Nj6n/Pc06gAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAGx9T/AJ7mnU2Pqf8APc06gAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAGx9T/nuadTY+p/z3NOoAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKCcCkVsmgBaKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKbNKsSbmKqPegB1FUbjX7aAf6wM2ei1RufFLKMxxr7E1SpSYbG5QRmuXn8QXU//AC0VR6KcGq0t3Jcf6yRm74LZrT6uzP2iOrkuoYj80ir9TUL61axn/XL+HNcvRWn1fuHtDom8S2qNxub6JTW8U26j5Ulb/gOK5+in7CCJ9obr+LI8f6mT88U3/hLE/wCeL/i9YlFL2dMPam4nixCf9S34Nmnf8JXGOsUgrBop+zpvQPaG+viqBj8ySflmnr4mtWPIkH1Sudpsv3aPq8A9odMviWzJ/wBcq/UYqaPWLeb7k0P4tiuM/j/ClpPDxtoV7Q7qN9/IwR6g5pxGa4MSGM5UsPocVPDq1zD924kHtuzWf1dh7Q7TYKULiuVi8VXkX8UT/wC91q3b+Mef3kJH+0tEqE0rlKdzforMh8R2s5/1uw+jVfgmEw3KysvtWbjYokoooqQGx9T/AJ7mnU2Pqf8APc06gAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACio7m5jtY90jbVzise88U7WKwqu3sx7U0ruwG1NJ5S7jgDPJPas+48QQxHEfmTe46Viz3Mly26SRpG/QVHW8aeupnKRfutfnmOIyIxnt96qUkrSvubcW9TTaK25IrYzCmv0p1NfpVANooooAKKKKACiiigAooooAKKKKACmy/dp1Nl+7QBB/H+FLSfx/hS0AFFFFABRRRQAU6OdrdtysynpkU2ijTqBpWnie5hOC0ci+h61p2PieGc7XjaNsZwelc1RWc6cGroqO53UfU/57mnU2Pqf89zTq4zYKKKKACiiigAooooAKKKM0AFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUE4FZuo6/FaHbH+9k9f7tCV9ANCaZbdNzttWsfUfEvGLcd8Fqzbm8lvn3yNu9Pao63jTsRzDpJ3uH3M3me9NoorUQUUUVeopbBRRRTICmv0p1NfpQA2iiigAooooAKKKKACiiigAooooAKbL92nU2X7tAEH8f4UtJ/H+FLQAUUUUAFFFFABRRRQAUUUVM/hKjud1H1P+e5p1Nj6n/Pc06uE2CiiigAooooAKKKKACjFFFABR1oooAKMUUUAGKMUUUAFGKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACoru5S1i3SNtGfzqvqGrpZfLjc3pWHc3Ul5MXdvoK0p0XPUGT6hrst4xWP93F/OqPT+Hjrmg9aK25eXQzCiiiqAKKKKACiiir1FLYKKKKZAU1+lOpr9KAG0UUUAFFFFABRRRQAUUUUAFFFFABTZfu06my/doAg/j/ClpP4/wpaACiiigAooooAKKKKACiiipqfCVHc7qPqf89zTqbH1P+e5p1cJsFFFFABQaKD1oYBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUMNwoYZqG8vY7KPc7d8Aepo30AkeRYk3McAVl32ub8rEPl9aq32ovfn+7Hnhfeq9dFOn1ZPMBJzz161GfvVJUZ+9W+pJGetFB60UncAoooqQCiiigAoooq9RS2CiiimQFNfpTqa/SgBtFFFABRRRQAUUUUAFFFFABRRRQAU2X7tOpsv3aAIP4/wpaT+P8KWgAooooAKKKKACiiigAoooqanwlR3O6j6n/Pc06mx9T/nuadXCbBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFDDcKbIQFyxwBzWXqGtGT5Ih8ucZotfQCxqOrLZDaq7n/l71jzTNPLudtzfyoKkLz1ptdEKdlczCiiitACoz96pKjP3qvUCM9aKD1opO4BRRRUgFFFFABRRRV6ilsFFFFMgKa/SnU1+lADaKKKACiiigAooooAKKKKACiiigApsv3adTZfu0AQfx/hS0n8f4UtABRRRQAUUUUAFFFFABRRRU1PhKjud1H1P+e5p1Nj6n/Pc06uE2CiiigAoNFBoAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAqO4uFto9zHA6fWo7zUI7NMt16AeprFu7xryTc3I7f7PtVRjdgyTUdQkvW/uxg8L71Voorq2MwooooAKKKKACoz96pKjP3qvUCM9aKD1opO4BRRRUgFFFFABRRRV6ilsFFFFMgKa/SnU1+lADaKKKACiiigAooooAKKKKACiiigApsv3adTZfu0AQfx/hS0n8f4UtABRRRQAUUUUAFFFFABRRRU1PhKjud1H1P+e5p1Nj6n/Pc06uE2CiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAEYbqqalqa2KbVXc2cfT3pupaoLUbU+939hWPI5lcsfmP96tKdPqxPYJpmnl3O25v5U2iiuggKKKKACiiigAooooAKjP3qkqM/eq9QIz1ooPWik7gFFFFSAUUUUAFFFFXqKWwUUUUyApr9KdTX6UANooooAKKKKACiiigAooooAKKKKACmy/dp1Nl+7QBB/H+FLSfx/hS0AFFFFABRRRQAUUUUAFFFFTU+EqO53UfU/57mnU2Pqf89zTq4TYKKKKACg9aKD1oAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooJwKp3msRwfKvzNmjcC1I6xrljgVm3ms/NsiX5emaqXF7JdHDt7gUxOtaxhrqRcZMTu569aZTn602txBRRRQAUUUUAFFFFABRRRQAVGfvVJUZ+9V6gRnrRQetFJ3AKKKKkAooooAKKKKvUUtgooopkBTX6U6mv0oAbRRRQAUUUUAFFFFABRRRQAUUUUAFNl+7TqbL92gCD+P8AClpP4/wpaACiiigAooooAKKKKACiiipqfCVHc7qPqf8APc06mx9T/nuadXCbBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRQTigAoprSYFN37qAJKCcVW/j/AAparlAm30b6hop8oE4bNLVeilygWKKr7ttHn46UcoFiioUuTnnFOSYMakCSikDA0tABRRRQAUUUUAFFFFABRRRQAUUUH8qACio3uo4+rCmSahGq/Kd1AE9BqhNqbdkqpNqE0h68elX7NgzWmu44Blm21Ul1rJxGu41m7iz80tPkIux95dyXB+ZuM5xUFOfpTa2hsIKcnWm05OtUBG/Wm05+tNoAKKKKACiiigAooooAKKKKACoz96pKjP3qvUCM9aKD1opO4BRRRUgFFFFABRRRV6ilsFFFFMgKa/SnU1+lADaKKKACiiigAooooAKKKKACiiigApsv3adTZfu0AQfx/hS0n8f4UtABRRRQAUUUUAFFFFABRRRU1PhKjud1H1P+e5p1Nj6n/Pc06uE2CiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACmP96n0x/vUAJRRRQBF/H+FLSfx/hS1oAUUUUClsFFFFBAU1+lOpr9KAG0UUUFy2CjcV+7RRQQHmvTkmdTTaKAHS3bKv41H9teh+lQnrQMm+2vR9teoaKprQp7EwvX9ajmvXb+PvTajPWpW5I4Tu38dDuzD5mzTaK0KlsFAooFBA0/eb6VE/3qlP3m+lRP8AeoASiiigBr9KbTn6U2tACnJ1ptOTrQBG/Wm05+tNoAKKKKACiiigAooooAKKKKACoz96pKjP3qvUCM9aKD1opO4BRRRUgFFFFABRRRV6ilsFFFFMgKa/SnU1+lADaKKKACiiigAooooAKKKKACiiigApsv3adTZfu0AQfx/hS0n8f4UtABRRRQAUUUUAFFFFABRRRU1PhKjud1H1P+e5p1Nj6n/Pc06uE2CiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACmP96n0x/vUAJRRRQBF/H+FLSfx/hS1oAUUUUClsFFFFBAU1+lOpr9KAG0UUUFy2CiiiggKKKKAGv0qE9amfpUJ61oAUUUUFy2Coz1qSoz1oICiiiguWwUCigUEDT95vpUT/eqU/eb6VE/3qAEooooAa/Sm05+lNrQApydabTk60ARv1ptOfrTaACiiigAooooAKKKKACiiigAqM/eqSoz96r1AjPWig9aKTuAUUUVIBRRRQAUUUVeopbBRRRTICmv0p1NfpQA2iiigAooooAKKKKACiiigAooooAKbL92nU2X7tAEH8f4UtJ/H+FLQAUUUUAFFFFABRRRQAUUUVNT4So7ndR9T/nuadTY+p/z3NOrhNgooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigApj/ep9Mf71ACUUUUARfx/hS0n8f4UtaAFFFFApbBRRRQQFNfpTqa/SgBtFFFBctgooooICiiigBr9KhPWpn6VCetaAFFFFBctgqM9akqM9aCAooooLlsFAooFBA0/eb6VE/3qlP3m+lRP96gBKKKKAGv0ptOfpTa0AKcnWm05OtAEb9abTn602gAooooAKKKKACiiigAooooAKjP3qkqM/eq9QIz1ooPWik7gFFFFSAUUUUAFFFFXqKWwUUUUyApr9KdTX6UANooooAKKKKACiiigAooooAKKKKACmy/dp1Nl+7QBB/H+FLSfx/hS0AFFFFABRRRQAUUUUAFFFFTU+EqO53UfU/57mnU2Pqf89zTq4TYKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKY/3qfTH+9QAlFFFAEX8f4UtJ/H+FLWgBRRRQKWwUUUUEBTX6U6mv0oAbRRRQXLYKKKKCAooooAa/SoT1qZ+lQnrWgBRRRQXLYKjPWpKjPWggKKKKC5bBQKKBQQNP3m+lRP8AeqU/eb6VE/3qAEooooAa/Sm05+lNrQApydabTk60ARv1ptOfrTaACiiigAooooAKKKKACiiigAqM/eqSoz96r1AjPWig9aKTuAUUUVIBRRRQAUUUVeopbBRRRTICmv0p1NfpQA2iiigAooooAKKKKACiiigAooooAKbL92nU2X7tAEH8f4UtJ/H+FLQAUUUUAFFFFABRRRQAUUUVNT4So7ndR9T/AJ7mnU2Pqf8APc06uE2CiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACmP8Aep9Mf71ACUUUUARfx/hS0n8f4UtaAFFFFApbBRRRQQFNfpTqa/SgBtFFFBctgooooICiiigBr9KhPWpn6VCetaAFFFFBctgqM9akqM9aCAooooLlsFAooFBA0/eb6VE/3qlP3m+lRP8AeoASiiigBr9KbTn6U2tACnJ1ptOTrQBG/Wm05+tNoAKKKKACiiigAooooAKKKKACoz96pKjP3qvUCM9aKD1opO4BRRRUgFFFFABRRRV6ilsFFFFMgKa/SnU1+lADaKKKACiiigAooooAKKKKACiiigApsv3adTZfu0AQfx/hS0n8f4UtABRRRQAUUUUAFFFFABRRRU1PhKjud1H1P+e5p1Nj6n/Pc06uE2CiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACmP96n0x/vUAJRRRQBF/H+FLSfx/hS1oAUUUUClsFFFFBAU1+lOpr9KAG0UUUFy2CiiiggKKKKAGv0qE9amfpUJ61oAUUUUFy2Coz1qSoz1oICiiiguWwUCigUEDT95vpUT/eqU/eb6VE/3qAEooooAa/Sm05+lNrQApydabTk60ARv1ptOfrTaACiiigAooooAKKKKACiiigAqM/eqSoz96r1AjPWig9aKTuAUUUVIBRRRQAUUUVeopbBRRRTICmv0p1NfpQA2iiigAooooAKKKKACiiigAooooAKbL92nU2X7tAEH8f4UtJ/H+FLQAUUUUAFFFFABRRRQAUUUVNT4So7ndR9T/nuadTY+p/z3NOrhNgooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigApj/ep9Mf71ACUUUUARfx/hS0n8f4UtaAFFFFApbBRRRQQFNfpTqa/SgBtFFFBctgooooICiiigBr9KhPWpn6VCetaAFFFFBctgqM9akqM9aCAooooLlsFAooFBA0/eb6VE/3qlP3m+lRP96gBKKKKAGv0ptOfpTa0AKcnWm05OtAEb9abTn602gAooooAKKKKACiiigAooooAKjP3qkqM/eq9QIz1ooPWik7gFFFFSAUUUUAFFFFXqKWwUUUUyApr9KdTX6UANooooAKKKKACiiigAooooAKKKKACmy/dp1Nl+7QBB/H+FLSfx/hS0AFFFFABRRRQAUUUUAFFFFTU+EqO53UfU/57mnU2Pqf89zTq4TYKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKY/3qfTH+9QAlFFFAEX8f4UtJ/H+FLWgBRRRQKWwUUUUEBTX6U6mv0oAbRRRQXLYKKKKCAooooAa/SoT1qZ+lQnrWgBRRRQXLYKjPWpKjPWggKKKKC5bBQKKBQQNP3m+lRP8AeqU/eb6VE/3qAEooooAa/Sm05+lNrQApydabTk60ARv1ptOfrTaACiiigAooooAKKKKACiiigAqM/eqSoz96r1AjPWig9aKTuAUUUVIBRRRQAUUUVeopbBRRRTICmv0p1NfpQA2iiigAooooAKKKKACiiigAooooAKbL92nU2X7tAEH8f4UtJ/H+FLQAUUUUAFFFFABRRRQAUUUVNT4So7ndR9T/AJ7mnU2Pqf8APc06uE2CiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACmP8Aep9Mf71ACUUUUARfx/hS0n8f4UtaAFFFFApbBRRRQQFNfpTqa/SgBtFFFBctgooooICiiigBr9KhPWpn6VCetaAFFFFBctgqM9akqM9aCAooooLlsFAooFBA0/eb6VE/3qlP3m+lRP8AeoASiiigBr9KbTn6U2tACnJ1ptOTrQBG/Wm05+tNoAKKKKACiiigAooooAKKKKACoz96pKjP3qvUCM9aKD1opO4BRRRUgFFFFABRRRV6ilsFFFFMgKa/SnU1+lADaKKKACiiigAooooAKKKKACiiigApsv3adTZfu0AQfx/hS0n8f4UtABRRRQAUUUUAFFFFABRRRU1PhKjud1H1P+e5p1Nj6n/Pc06uE2CiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACmP96n0x/vUAJRRRQBF/H+FLSfx/hS1oAUUUUClsFFFFBAU1+lOpr9KAG0UUUFy2CiiiggKKKKAGv0qE9amfpUJ61oAUUUUFy2Coz1qSoz1oICiiiguWwUCigUEDT95vpUT/eqU/eb6VE/3qAEooooAa/Sm05+lNrQApydabTk60ARv1ptOfrTaACiiigAooooAKKKKACiiigAqM/eqSoz96r1AjPWig9aKTuAUUUVIBRRRQAUUUVeopbBRRRTICmv0p1NfpQA2iiigAooooAKKKKACiiigAooooAKbL92nU2X7tAEH8f4UtJ/H+FLQAUUUUAFFFFABRRRQAUUUVNT4So7ndR9T/nuadTY+p/z3NOrhNgooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigApj/ep9Mf71ACUUUUARfx/hS0n8f4UtaAFFFFApbBRRRQQFNfpTqa/SgBtFFFBctgooooICiiigBr9KhPWpn6VCetaAFFFFBctgqM9akqM9aCAooooLlsFAooFBA0/eb6VE/3qlP3m+lRP96gBKKKKAGv0ptOfpTa0AKcnWm05OtAEb9abTn602gAooooAKKKKACiiigAooooAKjP3qkqM/eq9QIz1ooPWik7gFFFFSAUUUUAFFFFXqKWwUUUUyApr9KdTX6UANooooAKKKKACiiigAooooAKKKKACmy/dp1Nl+7QBB/H+FLSfx/hS0AFFFFABRRRQAUUUUAFFFFTU+EqO53UfU/57mnU2Pqf89zTq4TYKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKY/3qfTH+9QAlFFFAEX8f4UtJ/H+FLWgBRRRQKWwUUUUEBTX6U6mv0oAbRRRQXLYKKKKCAooooAa/SoT1qZ+lQnrWgBRRRQXLYKjPWpKjPWggKKKKC5bBQKKBQQNP3m+lRP8AeqU/eb6VE/3qAEooooAa/Sm05+lNrQApydabTk60ARv1ptOfrTaACiiigAooooAKKKKACiiigAqM/eqSoz96r1AjPWig9aKTuAUUUVIBRRRQAUUUVeopbBRRRTICmv0p1NfpQA2iiigAooooAKKKKACiiigAooooAKbL92nU2X7tAEH8f4UtJ/H+FLQAUUUUAFFFFABRRRQAUUUVNT4So7ndR9T/AJ7mnU2Pqf8APc06uE2CiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACmP8Aep9Mf71ACUUUUARfx/hS0n8f4UtaAFFFFApbBRRRQQFNfpTqa/SgBtFFFBctgooooICiiigBr9KhPWpn6VCetaAFFFFBctgqM9akqM9aCAooooLlsFAooFBA0/eb6VE/3qlP3m+lRP8AeoASiiigBr9KbTn6U2tACnJ1ptOTrQBG/Wm05+tNoAKKKKACiiigAooooAKKKKACoz96pKjP3qvUCM9aKD1opO4BRRRUgFFFFABRRRV6ilsFFFFMgKa/SnU1+lADaKKKACiiigAooooAKKKKACiiigApsv3adTZfu0AQfx/hS0n8f4UtABRRRQAUUUUAFFFFABRRRU1PhKjud1H1P+e5p1Nj6n/Pc06uE2CiiigAooooAKKKKACiiigAooooAKKKKACiiii4BRRRQAUUUE4oAKKM0Z5pcyAKKKKdwCiignFFwCik3ClBzRcAoooJxRcAopNwpQc0XAKKKKACiiigAoooJxRcAopNwpQc0XAKKKKACiiigAooooAKKKKACiiigApj/ep9Mf71ACUUUUARfx/hS0n8f4UtaAFFFFApbBRRRQQFNfpTqa/SgBtFFFBctgooooICiiigBr9KhPWpn6VCetaAFFFFBctgqM9akqM9aCAooooLlsFAooFBA0/eb6VE/wB6pT95vpUT/eoASiiigBr9KbTn6U2tACnJ1ptOTrQBG/Wm05+tNoAKKKKACiiigAooooAKKKKACoz96pKjP3qvUCM9aKD1opO4BRRRUgFFFFABRRRV6ilsFFFFMgKa/SnU1+lADaKKKACiiigAooooAKKKKACiiigApsv3adTZfu0AQfx/hS0n8f4UtABRRRQAUUUUAFFFFABRRRU1PhKjud1H1P8AnuadTY+p/wA9zTq4TYKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKY/wB6n0x/vUAJRRRQBF/H+FLSfx/hS1oAUUUUClsFFFFBAU1+lOpr9KAG0UUUFy2CiiiggKKKKAGv0qE9amfpUJ61oAUUUUFy2Coz1qSoz1oICiiiguWwUCigUEDT95vpUT/eqU/eb6VE/wB6gBKKKKAGv0ptOfpTa0AKcnWm05OtAEb9abTn602gAooooAKKKKACiiigAooooAKjP3qkqM/eq9QIz1ooPWik7gFFFFSAUUUUAFFFFXqKWwUUUUyApr9KdTX6UANooooAKKKKACiiigAooooAKKKKACmy/dp1Nl+7QBB/H+FLSfx/hS0AFFFFABRRRQAUUUUAFFFFTU+EqO53UfU/57mnU2Pqf89zTq4TYKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKY/3qfTH+9QAlFFFAEX8f4UtJ/H+FLWgBRRRQKWwUUUUEBTX6U6mv0oAbRRRQXLYKKKKCAooooAa/SoT1qZ+lQnrWgBRRRQXLYKjPWpKjPWggKKKKC5bBQKKBQQNP3m+lRP96pT95vpUT/eoASiiigBr9KbTn6U2tACnJ1ptOTrQBG/Wm05+tNoAKKKKACiiigAooooAKKKKACoz96pKjP3qvUCM9aKD1opO4BRRRUgFFFFABRRRV6ilsFFFFMgKa/SnU1+lADaKKKACiiigAooooAKKKKACiiigApsv3adTZfu0AQfx/hS0n8f4UtABRRRQAUUUUAFFFFABRRRU1PhKjud1H1P+e5p1Nj6n/Pc06uE2CiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACmP96n0x/vUAJRRRQBF/H+FLSfx/hS1oAUUUUClsFFFFBAU1+lOpr9KAG0UUUFy2CiiiggKKKKAGv0qE9amfpUJ61oAUUUUFy2Coz1qSoz1oICiiiguWwUCigUEDT95vpUT/eqU/eb6VE/3qAEooooAa/Sm05+lNrQApydabTk60ARv1ptOfrTaACiiigAooooAKKKKACiiigAqM/eqSoz96r1AjPWig9aKTuAUUUVIBRRRQAUUUVeopbBRRRTICmv0p1NfpQA2iiigAooooAKKKKACiiigAooooAKbL92nU2X7tAEH8f4UtJ/H+FLQAUUUUAFFFFABRRRQAUUUVNT4So7ndR9T/nuadTY+p/z3NOrhNgooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigApj/ep9Mf71ACUUUUARfx/hS0n8f4UtaAFFFFApbBRRRQQFNfpTqa/SgBtFFFBctgooooICiiigBr9KhPWpn6VCetaAFFFFBctgqM9akqM9aCAooooLlsFAooFBA0/eb6VE/wB6pT95vpUT/eoASiiigBr9KbTn6U2tACnJ1ptOTrQBG/Wm05+tNoAKKKKACiiigAooooAKKKKACoz96pKjP3qvUCM9aKD1opO4BRRRUgFFFFABRRRV6ilsFFFFMgKa/SnU1+lADaKKKACiiigAooooAKKKKACiiigApsv3adTZfu0AQfx/hS0n8f4UtABRRRQAUUUUAFFFFABRRRU1PhKjud1H1P8AnuadTY+p/wA9zTq4TYKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKY/wB6n0x/vUAJRRRQBF/H+FLSfx/hS1oAUUUUClsFFFFBAU1+lOpr9KAG0UUUFy2CiiiggKKKKAGv0qE9amfpUJ61oAUUUUFy2Coz1qSoz1oICiiiguWwUCigUEDT95vpUT/eqU/eb6VE/wB6gBKKKKAGv0ptOfpTa0AKcnWm05OtAEb9abTn602gAooooAKKKKACiiigAooooAKjP3qkqM/eq9QIz1ooPWik7gFFFFSAUUUUAFFFFXqKWwUUUUyApr9KdTX6UANooooAKKKKACiiigAooooAKKKKACmy/dp1Nl+7QBB/H+FLSfx/hS0AFFFFABRRRQAUUUUAFFFFTU+EqO53UfU/57mnU2Pqf89zTq4TYKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKY/3qfQRmgCOinMuBTaAIv4/wAKWk/j/ClrQAooooFLYKKKKCApr9KdTX6UANooooLlsFFFFBAUUUUANfpUJ61M/SoT1rQAooooLlsFRnrUlRnrQQFFFFBctgoFFAoIGn7zfSon+9Up+830qJ/vUAJRRRQA1+lNpz9KbWgBTk602nJ1oAjfrTac/Wm0AFFFFABRRRQAUUUUAFFFFABUZ+9UlRn71XqBGetFB60UncAoooqQCiiigAoooq9RS2CiiimQFNfpTqa/SgBtFFFABRRRQAUUUUAFFFFABRRRQAU2X7tOpsv3aAIP4/wpaT+P8KWgAooooAKKKKACiiigAoooqanwlR3P/9k=",
                            width: 800,
                            height: 555
                        }, {
                            svg: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 170.1 85.8" style="enable-background:new 0 0 170.1 85.8;" xml:space="preserve"><style type="text/css">.st3{fill:#0075C9;} .st4{clip-path:url(#SVGID_4_);fill:#FEFEFE;} 	.st5{clip-path:url(#SVGID_4_);fill:#0075C9;}</style><g>	<g>		<path class="st3" d="M59.4,47.7c-5.9-2-11.1-3.4-11.1-6.8c0-3.2,2.9-5,7.2-5c3.2,0,6.1,1.4,7.8,4.1h10			c-2.2-7.1-8.9-12.2-17.5-12.2c-9.8,0-17,6.2-17,13.4c0,8.1,6.8,10.9,12.4,12.9c6.6,2.4,13.2,3.9,13.2,8.3c0,3-2.9,5.4-7.5,5.4			c-4.2,0-7.5-2.1-9.3-4.9H37.3c2.7,8,9.3,13.2,18.8,13.2c10.6,0,17.8-5.9,17.8-14.2C73.9,52.9,66.2,50.1,59.4,47.7L59.4,47.7z"/>		<path class="st3" d="M24.1,47.7c-5.9-2-11.1-3.4-11.1-6.8c0-3.2,2.9-5,7.2-5c3.2,0,6.1,1.4,7.8,4.1h10			c-2.2-7.1-8.9-12.2-17.5-12.2c-9.8,0-17,6.2-17,13.4c0,8.1,6.8,10.9,12.4,12.9C22.4,56.6,29,58,29,62.5c0,3-2.9,5.4-7.5,5.4			c-4.2,0-7.5-2.1-9.3-4.9H2c2.7,8,9.3,13.2,18.8,13.2c10.6,0,17.8-5.9,17.8-14.2C38.6,52.9,30.9,50.1,24.1,47.7L24.1,47.7z"/>		<path class="st3" d="M147.8,63c-2.6,2.5-6.3,4-10.3,4c-8.3,0-14.5-5.8-14.5-15c0-8.8,5.8-15.1,14.5-15.1c3.3,0,6.6,1.1,9.1,3h12			c-4.1-7.4-11.9-12.2-21.1-12.2c-13.4,0-24.1,10.2-24.1,24.2c0,14,10.8,24.2,24.1,24.2c9.6,0,17.8-5.2,21.7-13.2H147.8L147.8,63z"			/>		<path class="st3" d="M85.8,60.3c0,2.7,2.2,4.6,5.2,4.6c2.1,0,4.1-1,5.8-2.7l0,0l-7-7C87,56.4,85.8,58.3,85.8,60.3L85.8,60.3z"/>		<path class="st3" d="M96.6,45.2c0-2.2-1.5-3.5-3.5-3.5c-2.2,0-3.7,1.6-3.7,3.8c0,1.6,0.6,2.7,2.3,4.6C94.9,49,96.6,47.5,96.6,45.2			L96.6,45.2z"/>		<g>			<defs>				<rect id="SVGID_3_" x="2" y="0.4" width="157.2" height="85"/>			</defs>			<clipPath id="SVGID_4_">				<use xlink:href="#SVGID_3_"  style="overflow:visible;"/>			</clipPath>			<polygon class="st4" points="89.9,55.1 89.9,55.1 89.9,55.1 89.9,55.1 			"/>			<path class="st5" d="M105.2,70.5l-5.2-5.2l0,0c-2.7,2.5-5.8,4-9.5,4c-5.8,0-10.1-3.5-10.1-8.9c0-4,2.3-6.9,6.6-8.7				c-1.8-2.3-2.6-4.2-2.6-6.5c0-4.2,3.4-7.8,8.9-7.8c4.9,0,8.2,3.3,8.2,7.5c0,4.1-2.7,6.6-6.8,8.1l2,2.1h8.5V70.5L105.2,70.5z				 M73.9,0.4v85h40v-85H73.9L73.9,0.4z"/>		</g>	</g></g></svg>',
                            width: 85,
                            height: 34,
                            absolutePosition: { x: 47, y: 42 }
                        }, {
                            text: '|',
                            style: 'coverPageText',
                            absolutePosition: { x: 133, y: 52 }
                        }, {
                            text: ' Distribution Intelligence ',
                            style: 'coverPageText',
                            absolutePosition: { x: 155, y: 53 }
                        }, {
                            text: '®',
                            style: 'coverPageText',
                            fontSize: 11,
                            absolutePosition: { x: 326, y: 53 }
                        }, {
                            text: 'ANALYTICS',
                            alignment: 'right',
                            color: '#666776',
                            bold: true,
                            absolutePosition: { x: 0, y: 56 }
                        }, {
                            text: 'Competitive Insights',
                            fontSize: 38,
                            color: '#161533',
                            absolutePosition: { x: 55, y: 154 }
                        }, {
                            text: 'Better intelligence from competitive data comparisons \n to drive sales growth for national accounts',
                            color: '#494D60',
                            fontSize: 19,
                            absolutePosition: { x: 58, y: 211 }
                        }, {
                            text: current_user,
                            style: 'coverPageText',
                            absolutePosition: { x: 58, y: 316 }
                        }, {
                            text: 'Report Generated',
                            style: 'coverPageText',
                            absolutePosition: { x: 58, y: 344 }
                        }, {
                            text: current_date,
                            style: 'coverPageBold',
                            absolutePosition: { x: 195, y: 344 }
                        }, {
                            text: 'Firm',
                            style: 'coverPageText',
                            absolutePosition: { x: 58, y: 372 }
                        }, {
                            text: this.selectedFirm,
                            style: 'coverPageBold',
                            absolutePosition: { x: 100, y: 372 }
                        }, {
                            text: 'Product',
                            style: 'coverPageText',
                            absolutePosition: { x: 58, y: 394 }
                        }, {
                            text: this.selectedProduct,
                            style: 'coverPageBold',
                            absolutePosition: { x: 122, y: 394 }
                        }, {
                            image: this.logoDataUri,
                            width: 150,
                            absolutePosition: { x: 58, y: 458 }
                        }],
                    [{
                            image: "data:image/jpeg;base64,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",
                            width: 800,
                            height: 555,
                            alignment: 'right'
                        }, {
                            canvas: [
                                {
                                    type: 'line',
                                    x1: 0, y1: 100,
                                    x2: 850, y2: 100,
                                    lineWidth: 1,
                                    lineColor: '#72757B'
                                }
                            ], absolutePosition: { x: 0, y: 0 }
                        }, {
                            svg: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 170.1 85.8" style="enable-background:new 0 0 170.1 85.8;" xml:space="preserve"><style type="text/css">.st3{fill:#0075C9;} .st4{clip-path:url(#SVGID_4_);fill:#FEFEFE;} 	.st5{clip-path:url(#SVGID_4_);fill:#0075C9;}</style><g>	<g>		<path class="st3" d="M59.4,47.7c-5.9-2-11.1-3.4-11.1-6.8c0-3.2,2.9-5,7.2-5c3.2,0,6.1,1.4,7.8,4.1h10			c-2.2-7.1-8.9-12.2-17.5-12.2c-9.8,0-17,6.2-17,13.4c0,8.1,6.8,10.9,12.4,12.9c6.6,2.4,13.2,3.9,13.2,8.3c0,3-2.9,5.4-7.5,5.4			c-4.2,0-7.5-2.1-9.3-4.9H37.3c2.7,8,9.3,13.2,18.8,13.2c10.6,0,17.8-5.9,17.8-14.2C73.9,52.9,66.2,50.1,59.4,47.7L59.4,47.7z"/>		<path class="st3" d="M24.1,47.7c-5.9-2-11.1-3.4-11.1-6.8c0-3.2,2.9-5,7.2-5c3.2,0,6.1,1.4,7.8,4.1h10			c-2.2-7.1-8.9-12.2-17.5-12.2c-9.8,0-17,6.2-17,13.4c0,8.1,6.8,10.9,12.4,12.9C22.4,56.6,29,58,29,62.5c0,3-2.9,5.4-7.5,5.4			c-4.2,0-7.5-2.1-9.3-4.9H2c2.7,8,9.3,13.2,18.8,13.2c10.6,0,17.8-5.9,17.8-14.2C38.6,52.9,30.9,50.1,24.1,47.7L24.1,47.7z"/>		<path class="st3" d="M147.8,63c-2.6,2.5-6.3,4-10.3,4c-8.3,0-14.5-5.8-14.5-15c0-8.8,5.8-15.1,14.5-15.1c3.3,0,6.6,1.1,9.1,3h12			c-4.1-7.4-11.9-12.2-21.1-12.2c-13.4,0-24.1,10.2-24.1,24.2c0,14,10.8,24.2,24.1,24.2c9.6,0,17.8-5.2,21.7-13.2H147.8L147.8,63z"			/>		<path class="st3" d="M85.8,60.3c0,2.7,2.2,4.6,5.2,4.6c2.1,0,4.1-1,5.8-2.7l0,0l-7-7C87,56.4,85.8,58.3,85.8,60.3L85.8,60.3z"/>		<path class="st3" d="M96.6,45.2c0-2.2-1.5-3.5-3.5-3.5c-2.2,0-3.7,1.6-3.7,3.8c0,1.6,0.6,2.7,2.3,4.6C94.9,49,96.6,47.5,96.6,45.2			L96.6,45.2z"/>		<g>			<defs>				<rect id="SVGID_3_" x="2" y="0.4" width="157.2" height="85"/>			</defs>			<clipPath id="SVGID_4_">				<use xlink:href="#SVGID_3_"  style="overflow:visible;"/>			</clipPath>			<polygon class="st4" points="89.9,55.1 89.9,55.1 89.9,55.1 89.9,55.1 			"/>			<path class="st5" d="M105.2,70.5l-5.2-5.2l0,0c-2.7,2.5-5.8,4-9.5,4c-5.8,0-10.1-3.5-10.1-8.9c0-4,2.3-6.9,6.6-8.7				c-1.8-2.3-2.6-4.2-2.6-6.5c0-4.2,3.4-7.8,8.9-7.8c4.9,0,8.2,3.3,8.2,7.5c0,4.1-2.7,6.6-6.8,8.1l2,2.1h8.5V70.5L105.2,70.5z				 M73.9,0.4v85h40v-85H73.9L73.9,0.4z"/>		</g>	</g></g></svg>',
                            width: 85,
                            height: 34,
                            absolutePosition: { x: 47, y: 42 }
                        }, {
                            text: '|',
                            style: 'coverPageText',
                            absolutePosition: { x: 133, y: 52 }
                        }, {
                            text: ' Distribution Intelligence ',
                            style: 'coverPageText',
                            absolutePosition: { x: 155, y: 53 }
                        }, {
                            text: '®',
                            style: 'coverPageText',
                            fontSize: 11,
                            absolutePosition: { x: 326, y: 53 }
                        }, {
                            text: 'ANALYTICS',
                            alignment: 'right',
                            color: '#666776',
                            bold: true,
                            absolutePosition: { x: 0, y: 56 }
                        }, [{ text: 'Table of Contents', color: '#494D60', fontSize: 20, absolutePosition: { x: 110, y: 186 } },
                            [this.getTableOfContents()]
                        ]
                    ],
                    [this.getRanksPDFContent()],
                    [this.getSalesTrendsPDFContent()],
                    [this.getKeySalesDriverPDFContent()],
                    /*{text: 'Platform Breakdown', style: 'coverPageText', pageBreak: 'before', id: 'platform_breakdown_toc'},*/
                    [this.getMarketSharePDFContent()],
                    [this.getClient10by10Content()],
                    this.getMethodologiesAssumptionsPDF()
                ],
                styles: {
                    coverPageText: {
                        fontSize: 16,
                        color: '#72757B'
                    },
                    coverPageBold: {
                        color: '#423F3F',
                        fontSize: 16,
                        bold: true
                    },
                    headerText: {
                        color: '#72757B',
                        fontSize: 11,
                        fontWeight: 500
                    },
                    headerBold: {
                        color: '#423F3F',
                        bold: true,
                        fontSize: 11,
                        fontWeight: 500
                    },
                    headerFont: {
                        color: '#423F3F',
                        fontSize: 11,
                        fontWeight: 500
                    },
                    tocTextStyle: {
                        fontSize: 15,
                        color: '#72757B'
                    },
                    tocNumberStyle: {
                        color: '#72757B',
                        fontSize: 18,
                        bold: true,
                        alignment: 'right'
                    },
                    tabPageHeader: {
                        fontSize: 25,
                        color: '#72757B',
                        fontWeight: 500
                    },
                    tabPageNumber: {
                        fontSize: 18,
                        color: '#72757B'
                    },
                    tabHeader: {
                        fontSize: 14,
                        bold: true,
                        color: '#72757B'
                    },
                    tabSubHeader: {
                        fontSize: 11,
                        bold: true
                    },
                    avgStyle: {
                        italics: true,
                        color: '#006400'
                    },
                    negValueFont: {
                        bold: false,
                        fontSize: 9,
                        alignment: 'center',
                        color: '#FF0000'
                    },
                    posValueStyle: {
                        bold: false,
                        fontSize: 9,
                        alignment: 'center',
                    },
                    matrixStyle: {
                        bold: false,
                        fontSize: 9,
                        margin: [0, 5, 0, 5]
                    }
                }
            };
            var pdf = pdfMake.createPdf(docDefinition).download('CompInsights.pdf');
        };
        // Rankings PDF
        ProductPage.prototype.getRanksPDFContent = function () {
            var ranksData = this.rankingsModel.getRanksData();
            if (ranksData.ranksByQuarter) {
                var latestRanksData = ranksData.ranksByQuarter[0];
                var totalRows = ranksData.assetManagerRanks.grossSalesRank.length;
                var rowsPerPage = 15;
                var startRow = Math.min(7, totalRows - 1);
                var endRow = Math.min(22, totalRows - 1);
                var totalPages = Math.ceil((totalRows - 7) / rowsPerPage) + 1;
                var stackData = {
                    stack: [
                        { columns: this.getRankingPageHeader(1, totalPages, 'rankings_toc') },
                        {
                            canvas: [
                                { type: 'rect', x: 0, y: 8, w: 720, h: 50, r: 3, lineColor: '#E7E7E7' },
                                { type: 'ellipse', x: 108, y: 43, r1: 10, r2: 10, color: '#0188D1', fillOpacity: 1.0 },
                                { type: 'ellipse', x: 361, y: 43, r1: 10, r2: 10, color: '#0188D1', fillOpacity: 1.0 },
                                { type: 'ellipse', x: 614, y: 43, r1: 10, r2: 10, color: '#0188D1', fillOpacity: 1.0 }
                            ]
                        },
                        {
                            table: {
                                headerRows: 0,
                                widths: ['*', '*', '*'],
                                body: [
                                    [
                                        { text: 'Gross Sales Rank', style: 'tabSubHeader', alignment: 'center' },
                                        { text: 'Net Sales Rank', style: 'tabSubHeader', alignment: 'center' },
                                        { text: 'AUM Rank', style: 'tabSubHeader', alignment: 'center' }
                                    ],
                                    [{ text: '' }, { text: '' }, { text: '' }],
                                    [
                                        { text: latestRanksData.grossSalesRank, fontSize: 10, color: 'white', alignment: 'center' },
                                        { text: latestRanksData.netSalesRank, fontSize: 10, color: 'white', alignment: 'center' },
                                        { text: latestRanksData.aumRank, fontSize: 10, color: 'white', alignment: 'center' }
                                    ],
                                ]
                            },
                            layout: { defaultBorder: false },
                            absolutePosition: { x: 40, y: 120 }
                        },
                        {
                            columns: [
                                {
                                    stack: [
                                        this.buildRankingTrendsTable(ranksData),
                                        { columns: this.buildRanksTables(0, startRow, ranksData) }
                                    ]
                                }
                            ],
                            margin: [0, 20, 28, 0]
                        },
                        this.getRanksTablesColumn(2, totalPages, startRow, endRow, ranksData)
                    ],
                    margin: [20, 0, 10, 0]
                };
                for (var i = 3; i <= totalPages; i++) {
                    startRow = endRow;
                    endRow = startRow + rowsPerPage;
                    if (endRow > totalRows)
                        endRow = totalRows;
                    var pageData = this.getRanksTablesColumn(i, totalPages, startRow, endRow, ranksData);
                    stackData.stack.push(pageData);
                }
                return stackData;
            }
        };
        ProductPage.prototype.getRanksTablesColumn = function (currentpage, totalPages, startRow, endRow, ranksData) {
            if (currentpage <= totalPages) {
                var margins = startRow > 7 ? [0, 20, 55, 0] : [0, 20, 28, 0];
                return {
                    columns: [
                        {
                            stack: [
                                { columns: this.getRankingPageHeader(currentpage, totalPages) },
                                { columns: this.buildRanksTables(startRow, endRow, ranksData) }
                            ]
                        }
                    ],
                    margin: margins
                };
            }
        };
        ProductPage.prototype.getRankingPageHeader = function (currentPage, totalPages, id) {
            var rankHeader = { text: 'Rankings ', style: 'tabPageHeader', pageBreak: 'before' };
            if (id) {
                rankHeader['id'] = id;
            }
            var statsHeader = { text: 'Stats & Analytics', style: 'tabHeader', alignment: 'right', margin: [0, 30, 10, 0] };
            if (currentPage > 3) {
                statsHeader.margin = [0, 30, 28, 0];
            }
            return [
                {
                    text: [rankHeader, {
                            text: '(' + currentPage + ' of ' + totalPages + ')',
                            style: 'tabPageNumber'
                        }]
                }, statsHeader
            ];
        };
        ProductPage.prototype.buildRanksTables = function (startRow, endRow, ranksData) {
            return [this.ranksTable(ranksData.rankingHeaders, ranksData.assetManagerRanks.grossSalesRank, 'Gross Sales Rank', startRow, endRow),
                this.ranksTable(ranksData.rankingHeaders, ranksData.assetManagerRanks.netSalesRank, 'Net Sales Rank', startRow, endRow),
                this.ranksTable(ranksData.rankingHeaders, ranksData.assetManagerRanks.aumRank, 'AUM Rank', startRow, endRow)];
        };
        ProductPage.prototype.buildRankingTrendsTable = function (ranksData) {
            var ranksHeader = [];
            ranksData.rankingTrendsHeaders.forEach(function (quarter, index) {
                var header = { text: quarter, bold: true, fontSize: 10, alignment: 'center' };
                if (index === 0) {
                    header.alignment = 'left';
                }
                ranksHeader.push(header);
            });
            var tableData = {
                table: {
                    headerRows: 1,
                    widths: [100, '*', '*', '*', '*', '*', '*', '*', '*'],
                    body: [ranksHeader]
                },
                layout: {
                    hLineWidth: function (i) {
                        return (i === 0) ? 0 : 1;
                    },
                    vLineWidth: function () {
                        return 0;
                    },
                    hLineColor: function () {
                        return '#E7E7E7';
                    },
                    vLineColor: function () {
                        return 'white';
                    },
                    paddingTop: function () {
                        return 5;
                    },
                    paddingBottom: function () {
                        return 5;
                    }
                },
                margin: [0, 0, 12, 0]
            };
            ranksData.rankingTrendsArray.forEach(function (ranks) {
                var ranksArr = [];
                ranks.forEach(function (rank, index) {
                    if (index == 0) {
                        var row = { text: rank, bold: true, fontSize: 10, alignment: 'left' };
                        ranksArr.push(row);
                    }
                    else {
                        var row = { text: rank, bold: false, fontSize: 9, alignment: 'center' };
                        ranksArr.push(row);
                    }
                });
                tableData.table.body.push(ranksArr);
            });
            return tableData;
        };
        ProductPage.prototype.ranksTable = function (rankingHeaders, rankValues, rankType, startRow, endRow) {
            var tableData = {
                table: {
                    headerRows: 2,
                    widths: [45, 65, 45, 45],
                    body: [
                        [{
                                text: rankType,
                                colSpan: 4,
                                fontSize: 10,
                                alignment: 'center',
                                border: [false, true, false, false]
                            }, {}, {}, {}],
                        this.getRankTableHeaders(rankingHeaders)
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return (i === 0) ? 0 : 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 0;
                    },
                    hLineColor: function () {
                        return '#E7E7E7';
                    },
                    vLineColor: function () {
                        return '#E7E7E7';
                    },
                    paddingTop: function () {
                        return 3;
                    },
                    paddingBottom: function (i, node) {
                        return (i === 0) ? 6 : 3;
                    }
                },
                margin: [0, 15, 0, 0]
            };
            for (var i = startRow; i < endRow; i++) {
                var rank = rankValues[i];
                var rankRow = void 0;
                var canvasEle = { type: 'ellipse', x: 22, y: 7, r1: 7, r2: 7, color: '#425560', fillOpacity: 1.0 };
                if (rank.currentQuarterRank > 99) {
                    canvasEle.r1 = 9;
                }
                if (rank.assetManager !== 'Product') {
                    canvasEle.color = '#0188D1';
                    rankRow = [
                        {
                            columns: [{
                                    stack: [
                                        { canvas: [canvasEle] },
                                        {
                                            columns: [{
                                                    text: rank.currentQuarterRank,
                                                    fontSize: 9,
                                                    alignment: 'center',
                                                    color: 'white'
                                                }], relativePosition: { x: 0, y: -12 }
                                        }
                                    ],
                                }],
                            fillColor: '#F2F9FD'
                        },
                        { text: rank.assetManager, fontSize: 9, alignment: 'center', fillColor: '#F2F9FD' },
                        { text: rank.prevQuarterRank, fontSize: 9, alignment: 'center', fillColor: '#F2F9FD' },
                        { text: rank.prevPrevQuarterRank, fontSize: 9, alignment: 'center', fillColor: '#F2F9FD' }
                    ];
                }
                else {
                    rankRow = [
                        {
                            columns: [{
                                    stack: [
                                        { canvas: [canvasEle] },
                                        {
                                            columns: [{
                                                    text: rank.currentQuarterRank,
                                                    fontSize: 9,
                                                    alignment: 'center',
                                                    color: 'white'
                                                }], relativePosition: { x: 0, y: -12 }
                                        }
                                    ]
                                }],
                        },
                        { text: rank.assetManager, fontSize: 9, alignment: 'center' },
                        { text: rank.prevQuarterRank, fontSize: 9, alignment: 'center' },
                        { text: rank.prevPrevQuarterRank, fontSize: 9, alignment: 'center' }
                    ];
                }
                tableData.table.body.push(rankRow);
            }
            return tableData;
        };
        ProductPage.prototype.getRankTableHeaders = function (rankHeaders) {
            var headers = [];
            rankHeaders.forEach(function (header) {
                var row = {
                    text: header,
                    bold: true,
                    fontSize: 10,
                    alignment: 'center',
                    fillColor: '#F6FBFB',
                    fillOpacity: 1.0,
                    verticalAlign: 'middle'
                };
                if (header === 'Product') {
                    row['margin'] = [0, 7, 0, 0];
                }
                headers.push(row);
            });
            return headers;
        };
        // Sales Trends PDF
        ProductPage.prototype.getSalesTrendsPDFContent = function () {
            var stackData = {
                stack: [
                    { text: 'Sales Trends', color: 'white', fontSize: 2, pageBreak: 'before', id: 'sales_trends_toc' },
                    {
                        columns: [
                            { text: 'Sales Trends (1 of 2)', style: 'tabPageNumber', width: 548 },
                            { text: 'Stats & Analytics', style: 'tabHeader', alignment: 'right', width: 208, margin: [0, 0, 0, 0] }
                        ]
                    },
                    { text: '($ Millions)', fontSize: 10, bold: true, margin: [0, 12, 0, 2] },
                    this.buildSalesTrendsTableContent(),
                    this.buildsalesConcentrationTableContent(0, 1),
                    {
                        columns: [
                            { text: 'Sales Trends (2 of 2)', pageBreak: 'before', style: 'tabPageNumber', width: 548, margin: [0, 0, 0, 5] },
                            { text: 'Stats & Analytics', style: 'tabHeader', alignment: 'right', width: 208, margin: [0, 20, 0, 0] }
                        ]
                    },
                    this.buildsalesConcentrationTableContent(2, 4)
                ],
                margin: [0, 0, 10, 0]
            };
            return stackData;
        };
        ProductPage.prototype.buildSalesTrendsTableContent = function () {
            var marketShareData = this.salesTrendsDataList.marketShareData;
            var tableData = this.buildSalesTrendsTableLayout('Sales Trends (3 Months)');
            tableData['margin'] = [0, 0, 0, 20];
            var headers = CompInsights.Strings.SALES_TRENDS_HEADER;
            headers.forEach(function (header, index) {
                var dataHeaders = [{ text: header.label, bold: true, fontSize: 10, alignment: 'left' }];
                marketShareData.forEach(function (shareData) {
                    var value;
                    if (index === 0) {
                        value = new LabelBuilder.CompInsightLabelBuilder().build(shareData.industrySales);
                    }
                    else {
                        value = shareData.marketShare.toFixed(2) + '%';
                    }
                    dataHeaders.push({ text: value, bold: false, fontSize: 9, alignment: 'center' });
                });
                tableData.table.body.push(dataHeaders);
            });
            return tableData;
        };
        ProductPage.prototype.buildsalesConcentrationTableContent = function (startIndex, endIndex) {
            var salesConcentrationDataList = this.salesTrendsDataList.salesConcentrationDataList;
            var tableData = this.buildSalesTrendsTableLayout('Sales Concentration Trends (3 Months)');
            var headers = CompInsights.Strings.SALES_CONCENTRATION_TRENDS_HEADER;
            var noOfQuarters = this.salesTrendsDataList.quarters.length + 1;
            var _loop_5 = function(i) {
                var data = salesConcentrationDataList[i];
                var dataLabel = { text: data.label, bold: true, fontSize: 10, alignment: 'left', fillColor: '#F6FBFB', colSpan: noOfQuarters };
                tableData.table.body.push([dataLabel, {}, {}, {}, {}, {}, {}, {}, {}].slice(0, noOfQuarters));
                headers.forEach(function (header, index) {
                    var rowValue = [{ text: header.label, bold: true, fontSize: 10, alignment: 'left' }];
                    data.salesDataList.forEach(function (salesConcentration) {
                        var value = '', isNegative = false;
                        if (index === 0) {
                            value = new LabelBuilder.CompInsightLabelBuilder().build(salesConcentration.totalSales);
                            isNegative = salesConcentration.totalSales < 0;
                        }
                        else if (index === 1) {
                            value = salesConcentration.percentTotalSales.toFixed(2) + '%';
                            isNegative = salesConcentration.percentTotalSales < 0;
                        }
                        else if (index === 2) {
                            value = new LabelBuilder.CompInsightLabelBuilder().build(salesConcentration.netSales);
                            isNegative = salesConcentration.netSales < 0;
                        }
                        else if (index === 3) {
                            value = new LabelBuilder.CompInsightLabelBuilder().build(salesConcentration.totalAum);
                            isNegative = salesConcentration.totalAum < 0;
                        }
                        else if (index === 4) {
                            value = salesConcentration.percentAum.toFixed(2) + '%';
                            isNegative = salesConcentration.percentAum < 0;
                        }
                        var salesRow = { text: value, bold: false, fontSize: 9, alignment: 'center' };
                        if (isNegative) {
                            salesRow['color'] = 'red';
                        }
                        rowValue.push(salesRow);
                    });
                    tableData.table.body.push(rowValue);
                });
                if (i !== endIndex) {
                    var emptyRow = { text: 'Empty Row', color: 'white', colSpan: noOfQuarters };
                    if (startIndex !== 0) {
                        emptyRow['fontSize'] = 3;
                    }
                    tableData.table.body.push([emptyRow, {}, {}, {}, {}, {}, {}, {}, {}].slice(0, noOfQuarters));
                }
            };
            for (var i = startIndex; i <= endIndex; i++) {
                _loop_5(i);
            }
            return tableData;
        };
        ProductPage.prototype.buildQuartersHeader = function (type) {
            var salesTrendsHeader = [{ text: type, bold: true, fontSize: 10, alignment: 'left' }];
            this.salesTrendsDataList.quarters.forEach(function (quarter, index) {
                var header = { text: quarter, bold: true, fontSize: 10, alignment: 'center' };
                salesTrendsHeader.push(header);
            });
            return salesTrendsHeader;
        };
        ProductPage.prototype.buildSalesTrendsTableLayout = function (type) {
            var widths = [180, 62, 62, 62, 62, 62, 62, 62, 62];
            widths = widths.slice(0, this.salesTrendsDataList.quarters.length + 1);
            var tableData = {
                table: {
                    headerRows: 1,
                    widths: widths,
                    body: [this.buildQuartersHeader(type)]
                },
                layout: {
                    hLineWidth: function (i) { return (i === 0) ? 0 : (i === 1) ? 2 : 1; },
                    vLineWidth: function () { return 0; },
                    hLineColor: function () { return '#E7E7E7'; },
                    vLineColor: function () { return 'white'; },
                    paddingTop: function () { return 4; },
                    paddingBottom: function () { return 4; },
                    paddingLeft: function (i) { return (i === 0) ? 1 : 5; }
                }
            };
            return tableData;
        };
        //Key Sales Drivers PDF
        ProductPage.prototype.getKeySalesDriverPageHeader = function (currentPage, totalPages, id) {
            var rankHeader = { text: 'Key Sales Drivers ', style: 'tabPageNumber', pageBreak: 'before', width: 530 };
            if (id) {
                rankHeader['id'] = id;
            }
            var statsHeader = {
                text: 'Stats & Analytics',
                style: 'tabHeader',
                alignment: 'right',
                margin: [0, 30, 6, 0]
            };
            return [
                {
                    text: [rankHeader, {
                            text: '(' + currentPage + ' of ' + totalPages + ')',
                            style: 'tabPageNumber'
                        }]
                }, statsHeader
            ];
        };
        ProductPage.prototype.getKeySalesDriverLegendInfo = function () {
            var tableData = {
                table: {
                    headerRows: 0,
                    widths: [80, 60, 60, 60, 60, 60],
                    body: [
                        [{ text: 'Percentiles', alignment: 'left', fontSize: 10, bold: true },
                            { text: '1 - 20', fillColor: '#c62828', alignment: 'center', fontSize: 10, color: '#FFF', bold: true },
                            { text: '21 - 40', fillColor: '#e57373', alignment: 'center', fontSize: 10, color: '#FFF', bold: true },
                            { text: '41 - 60', fillColor: '#9e9e9e', alignment: 'center', fontSize: 10, color: '#FFF', bold: true },
                            { text: '61 - 80', fillColor: '#66bb6a', alignment: 'center', fontSize: 10, color: '#FFF', bold: true },
                            { text: '81 - 100', fillColor: '#388e3c', alignment: 'center', fontSize: 10, color: '#FFF', bold: true }],
                    ]
                },
                layout: {
                    hLineWidth: function (i) { return (i === 0) ? 0 : 2; },
                    vLineWidth: function () { return 2; },
                    hLineColor: function () { return 'white'; },
                    vLineColor: function () { return 'white'; },
                    paddingTop: function () { return 5; },
                    paddingBottom: function () { return 5; }
                },
                absolutePosition: { x: 355, y: 120 }
            };
            return tableData;
        };
        ProductPage.prototype.buildKeySalesDriverTableLayout = function (type) {
            var tableData = {
                table: {
                    headerRows: 1,
                    widths: [250, 90, 100, 90, 90, 110],
                    body: [[{ text: type, fontSize: 11, bold: true, alignment: 'left', margin: [0, 14, 0, 0] },
                            { text: CompInsights.Strings.YOUR_FUND, fontSize: 11, bold: true, alignment: 'right', margin: [0, 14, 0, 0] },
                            { text: CompInsights.Strings.COMPETITIVE + '\n' + CompInsights.Strings.FUNDS, fontSize: 11, bold: true, alignment: 'right' },
                            { text: CompInsights.Strings.DIFFERENCE, fontSize: 11, bold: true, alignment: 'right', margin: [0, 14, 0, 0] },
                            { text: CompInsights.Strings.PERCENT + '\n' + CompInsights.Strings.DIFFERENCE, fontSize: 11, bold: true, alignment: 'right' },
                            { text: CompInsights.Strings.PERCENTILE, fontSize: 11, bold: true, alignment: 'right', margin: [0, 14, 0, 0] }]]
                },
                layout: {
                    hLineWidth: function (i) { return (i === 0) ? 0 : (i === 1) ? 2 : 1; },
                    vLineWidth: function () { return 0; },
                    hLineColor: function () { return '#E7E7E7'; },
                    vLineColor: function () { return 'white'; },
                    paddingTop: function () { return 4; },
                    paddingBottom: function (i) { return (i === 0) ? 4 : 1; },
                    paddingLeft: function (i) { return (i === 0) ? 1 : 3; },
                    paddingRight: function () { return 1; }
                }
            };
            return tableData;
        };
        ProductPage.prototype.formatFund = function (value, unit) {
            var formattedValue;
            if (unit !== null) {
                if (unit === 'bps') {
                    formattedValue = Math.abs(value * 100).toFixed(0);
                }
                else {
                    formattedValue = value.toFixed(2);
                }
                if (unit === '%') {
                    formattedValue += '%';
                }
                else {
                    formattedValue += ' ' + unit.toUpperCase();
                }
            }
            else {
                formattedValue = value.toFixed(2);
            }
            return { text: formattedValue, fontSize: 10, bold: false, alignment: 'right' };
        };
        ProductPage.prototype.formatDifference = function (value, unit, driver) {
            var isNegativeBetter = driver.description.toUpperCase() === 'NET EXPENSE' ? true : driver.isNegativeBetter;
            var formattedValue = (unit !== null) ? Math.abs(value).toFixed(2) + ' ' + unit.toUpperCase() : Math.abs(value).toFixed(2);
            if (unit === '%') {
                formattedValue = Math.abs(value).toFixed(2) + '%';
            }
            if (unit === 'bps') {
                formattedValue = Math.abs(value * 100).toFixed(0) + ' BPS';
            }
            var differenceObj = { text: formattedValue, fontSize: 10, bold: false, alignment: 'right' };
            if (!isNegativeBetter) {
                if (value < 0) {
                    differenceObj['color'] = '#c62828';
                }
                else {
                    differenceObj['color'] = '#388e3c';
                }
            }
            else {
                if (value <= 0) {
                    differenceObj['color'] = '#388e3c';
                }
                else {
                    differenceObj['color'] = '#c62828';
                }
            }
            return differenceObj;
        };
        ProductPage.prototype.formatPercentDifference = function (driver, isMetric) {
            driver.percentDifference = driver.difference < 0 ? -Math.abs(driver.percentDifference) : Math.abs(driver.percentDifference);
            var isNegativeBetter = driver.description.toUpperCase() === 'NET EXPENSE' ? true : driver.isNegativeBetter;
            var percentDifference = driver.percentDifference;
            var formattedValue, color;
            if (isMetric) {
                formattedValue = Math.abs(percentDifference).toFixed(2) + '%';
                color = '#000';
            }
            else {
                if (!isNegativeBetter) {
                    if (percentDifference < 0) {
                        formattedValue = Math.abs(percentDifference).toFixed(2) + '%';
                        color = '#c62828';
                    }
                    else {
                        formattedValue = percentDifference.toFixed(2) + '%';
                        color = '#388e3c';
                    }
                }
                else {
                    if (percentDifference <= 0) {
                        formattedValue = Math.abs(percentDifference).toFixed(2) + '%';
                        color = '#388e3c';
                    }
                    else {
                        formattedValue = percentDifference.toFixed(2) + '%';
                        color = '#c62828';
                    }
                }
            }
            return { text: formattedValue, color: color, fontSize: 10, bold: false, alignment: 'right' };
        };
        ProductPage.prototype.buildPercentileColumn = function (value) {
            var canvasEle = { type: 'rect', x: 5, y: -4, w: 45, h: 18 };
            if (value < 21) {
                canvasEle['color'] = '#c62828';
            }
            else if (value < 41) {
                canvasEle['color'] = '#e57373';
            }
            else if (value < 61) {
                canvasEle['color'] = '#9e9e9e';
            }
            else if (value < 81) {
                canvasEle['color'] = '#66bb6a';
            }
            else if (value <= 100) {
                canvasEle['color'] = '#388e3c';
            }
            var percentile = {
                columns: [{ text: value.toFixed(2), fontSize: 10, bold: false },
                    { canvas: [canvasEle] }],
                alignment: 'right'
            };
            return percentile;
        };
        ProductPage.prototype.buildKeySalesDriversCanvas = function (isHavingDriver, canvasEle, type) {
            var canvas;
            if (isHavingDriver) {
                canvas = {
                    stack: [
                        { canvas: [canvasEle] },
                        {
                            columns: [{ text: type, fontSize: 9, bold: false, alignment: 'left', color: '#FFF' }],
                            relativePosition: { x: 10, y: -12 }
                        }
                    ], width: 'auto'
                };
            }
            else {
                canvas = { text: '', width: 'auto' };
            }
            return canvas;
        };
        ProductPage.prototype.buildKeyDriversTable = function () {
            var _this = this;
            if (this.keySalesDriverDataList[0].keyDrivers.length > 0) {
                var tableData_1 = this.buildKeySalesDriverTableLayout(CompInsights.Strings.KEY_DRIVERS);
                tableData_1['margin'] = [0, 55, 0, 0];
                this.keySalesDriverDataList[0].keyDrivers.forEach(function (row) {
                    var descStr = row.descriptionUnit ? row.description + ' (' + row.descriptionUnit + ')' : row.description;
                    var canvasEle = { type: 'rect', x: 5, y: 0, w: 55, h: 12, r: 6, color: '#425560' };
                    var driverRow = [
                        {
                            columns: [{ text: descStr, fontSize: 10, bold: false, alignment: 'left', width: 'auto' },
                                _this.buildKeySalesDriversCanvas(true, canvasEle, CompInsights.Strings.KEY_DRIVERS)]
                        },
                        _this.formatFund(row.yourFund, row.descriptionUnit),
                        _this.formatFund(row.competitiveFunds, row.descriptionUnit),
                        _this.formatDifference(row.difference, row.descriptionUnit, row),
                        _this.formatPercentDifference(row, false),
                        _this.buildPercentileColumn(row.percentile)];
                    tableData_1.table.body.push(driverRow);
                });
                return tableData_1;
            }
            else {
                return { text: CompInsights.Strings.NO_KEY_SALES_DRIVERS_DATA_NOTE, fontSize: 11, margin: [0, 55, 0, 0] };
            }
        };
        ProductPage.prototype.buildLargestAdvantageTable = function () {
            var _this = this;
            var tableData = this.buildKeySalesDriverTableLayout(CompInsights.Strings.LARGEST_ADVANTAGE);
            tableData['margin'] = [0, 10, 0, 30];
            this.keySalesDriverDataList[0].largestAdvantage.forEach(function (row) {
                var descStr = row.descriptionUnit ? row.description + ' (' + row.descriptionUnit + ')' : row.description;
                var canvasEle = { type: 'rect', x: 5, y: 0, w: 85, h: 12, r: 6, color: '#0288d1' };
                tableData.table.body.push([
                    {
                        columns: [{ text: descStr, fontSize: 10, bold: false, alignment: 'left', width: 'auto' },
                            _this.buildKeySalesDriversCanvas(true, canvasEle, CompInsights.Strings.LARGEST_ADVANTAGE)]
                    },
                    _this.formatFund(row.yourFund, row.descriptionUnit),
                    _this.formatFund(row.competitiveFunds, row.descriptionUnit),
                    _this.formatDifference(row.difference, row.descriptionUnit, row),
                    _this.formatPercentDifference(row, false),
                    _this.buildPercentileColumn(row.percentile)]);
            });
            return tableData;
        };
        ProductPage.prototype.buildMetricTable = function (startIndex, endIndex) {
            var tableData = this.buildKeySalesDriverTableLayout(CompInsights.Strings.METRIC);
            var metrics = this.keySalesDriverDataList[0].analyticsMatchups;
            for (var i = startIndex; i < endIndex; i++) {
                var row = metrics[i];
                var descStr = row.descriptionUnit ? row.description + ' (' + row.descriptionUnit + ')' : row.description;
                var canvasEleKD = { type: 'rect', x: 5, y: 0, w: 55, h: 12, r: 6, color: '#425560' };
                var canvasEleLA = { type: 'rect', x: 5, y: 0, w: 85, h: 12, r: 6, color: '#0288d1' };
                tableData.table.body.push([
                    {
                        columns: [
                            { text: descStr, fontSize: 10, bold: false, alignment: 'left', width: 'auto' },
                            this.buildKeySalesDriversCanvas(row.isKeyDriver, canvasEleKD, CompInsights.Strings.KEY_DRIVERS),
                            this.buildKeySalesDriversCanvas(row.isLargestAdv, canvasEleLA, CompInsights.Strings.LARGEST_ADVANTAGE)
                        ]
                    },
                    this.formatFund(row.yourFund, row.descriptionUnit),
                    this.formatFund(row.competitiveFunds, row.descriptionUnit),
                    this.formatDifference(row.difference, row.descriptionUnit, row),
                    this.formatPercentDifference(row, true),
                    this.buildPercentileColumn(row.percentile)]);
            }
            return tableData;
        };
        ProductPage.prototype.getFirstPageRows = function () {
            var keyDriversLength = this.keySalesDriverDataList[0].keyDrivers.length;
            var startRow;
            switch (keyDriversLength) {
                case 0:
                    startRow = 8;
                    break;
                case 1:
                    startRow = 6;
                    break;
                case 2:
                    startRow = 5;
                    break;
                case 3:
                    startRow = 4;
                    break;
            }
            return startRow;
        };
        ProductPage.prototype.getKeySalesDriverPDFContent = function () {
            if (this.keySalesDriverDataList.length !== 0) {
                var totalRows = this.keySalesDriverDataList[0].analyticsMatchups.length;
                var rowsPerPage = 16;
                var startRow = Math.min(this.getFirstPageRows(), totalRows - 1);
                var endRow = Math.min(rowsPerPage + startRow, totalRows - 1);
                var totalPages = Math.ceil((totalRows - 4) / rowsPerPage) + 1;
                var stackData = {
                    stack: [
                        { columns: this.getKeySalesDriverPageHeader(1, totalPages, 'key_sales_drivers_toc') },
                        this.getKeySalesDriverLegendInfo(),
                        this.buildKeyDriversTable(),
                        this.buildLargestAdvantageTable(),
                        { text: CompInsights.Strings.ANALYTICS_MATCHUPS, fontSize: 11, bold: true, margin: [1, 0, 0, 0] },
                        this.buildMetricTable(0, startRow),
                    ],
                    margin: [0, 0, 10, 0]
                };
                for (var i = 2; i <= totalPages; i++) {
                    if (i !== 2) {
                        startRow = endRow;
                        endRow = startRow + rowsPerPage;
                        if (endRow > totalRows)
                            endRow = totalRows;
                    }
                    if (i <= totalPages) {
                        stackData.stack.push({ columns: this.getKeySalesDriverPageHeader(i, totalPages) });
                        stackData.stack.push(this.getKeySalesDriverLegendInfo());
                        stackData.stack.push({ text: CompInsights.Strings.ANALYTICS_MATCHUPS, fontSize: 11, bold: true, margin: [1, 52, 0, 0] });
                        stackData.stack.push(this.buildMetricTable(startRow, endRow));
                    }
                }
                return stackData;
            }
        };
        // Methodologies & Assumptions PDF
        ProductPage.prototype.getMethodologiesAssumptionsPDF = function () {
            var stackData = {
                stack: [
                    {
                        svg: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 170.1 85.8" style="enable-background:new 0 0 170.1 85.8;" xml:space="preserve"><style type="text/css">.st3{fill:#0075C9;} .st4{clip-path:url(#SVGID_4_);fill:#FEFEFE;} 	.st5{clip-path:url(#SVGID_4_);fill:#0075C9;}</style><g>	<g>		<path class="st3" d="M59.4,47.7c-5.9-2-11.1-3.4-11.1-6.8c0-3.2,2.9-5,7.2-5c3.2,0,6.1,1.4,7.8,4.1h10			c-2.2-7.1-8.9-12.2-17.5-12.2c-9.8,0-17,6.2-17,13.4c0,8.1,6.8,10.9,12.4,12.9c6.6,2.4,13.2,3.9,13.2,8.3c0,3-2.9,5.4-7.5,5.4			c-4.2,0-7.5-2.1-9.3-4.9H37.3c2.7,8,9.3,13.2,18.8,13.2c10.6,0,17.8-5.9,17.8-14.2C73.9,52.9,66.2,50.1,59.4,47.7L59.4,47.7z"/>		<path class="st3" d="M24.1,47.7c-5.9-2-11.1-3.4-11.1-6.8c0-3.2,2.9-5,7.2-5c3.2,0,6.1,1.4,7.8,4.1h10			c-2.2-7.1-8.9-12.2-17.5-12.2c-9.8,0-17,6.2-17,13.4c0,8.1,6.8,10.9,12.4,12.9C22.4,56.6,29,58,29,62.5c0,3-2.9,5.4-7.5,5.4			c-4.2,0-7.5-2.1-9.3-4.9H2c2.7,8,9.3,13.2,18.8,13.2c10.6,0,17.8-5.9,17.8-14.2C38.6,52.9,30.9,50.1,24.1,47.7L24.1,47.7z"/>		<path class="st3" d="M147.8,63c-2.6,2.5-6.3,4-10.3,4c-8.3,0-14.5-5.8-14.5-15c0-8.8,5.8-15.1,14.5-15.1c3.3,0,6.6,1.1,9.1,3h12			c-4.1-7.4-11.9-12.2-21.1-12.2c-13.4,0-24.1,10.2-24.1,24.2c0,14,10.8,24.2,24.1,24.2c9.6,0,17.8-5.2,21.7-13.2H147.8L147.8,63z"			/>		<path class="st3" d="M85.8,60.3c0,2.7,2.2,4.6,5.2,4.6c2.1,0,4.1-1,5.8-2.7l0,0l-7-7C87,56.4,85.8,58.3,85.8,60.3L85.8,60.3z"/>		<path class="st3" d="M96.6,45.2c0-2.2-1.5-3.5-3.5-3.5c-2.2,0-3.7,1.6-3.7,3.8c0,1.6,0.6,2.7,2.3,4.6C94.9,49,96.6,47.5,96.6,45.2			L96.6,45.2z"/>		<g>			<defs>				<rect id="SVGID_3_" x="2" y="0.4" width="157.2" height="85"/>			</defs>			<clipPath id="SVGID_4_">				<use xlink:href="#SVGID_3_"  style="overflow:visible;"/>			</clipPath>			<polygon class="st4" points="89.9,55.1 89.9,55.1 89.9,55.1 89.9,55.1 			"/>			<path class="st5" d="M105.2,70.5l-5.2-5.2l0,0c-2.7,2.5-5.8,4-9.5,4c-5.8,0-10.1-3.5-10.1-8.9c0-4,2.3-6.9,6.6-8.7				c-1.8-2.3-2.6-4.2-2.6-6.5c0-4.2,3.4-7.8,8.9-7.8c4.9,0,8.2,3.3,8.2,7.5c0,4.1-2.7,6.6-6.8,8.1l2,2.1h8.5V70.5L105.2,70.5z				 M73.9,0.4v85h40v-85H73.9L73.9,0.4z"/>		</g>	</g></g></svg>',
                        width: 85,
                        height: 34,
                        pageBreak: 'before',
                        absolutePosition: { x: 47, y: 22 }
                    },
                    { text: '|', style: 'coverPageText', absolutePosition: { x: 133, y: 32 } },
                    { text: ' Distribution Intelligence ', style: 'coverPageText', absolutePosition: { x: 155, y: 33 } },
                    { text: '®', style: 'coverPageText', fontSize: 11, absolutePosition: { x: 326, y: 33 } },
                    { text: 'ANALYTICS', alignment: 'right', color: '#666776', bold: true, absolutePosition: { x: 0, y: 16 } },
                    { text: 'Competitive Insights', alignment: 'right', color: '#666776', bold: true, fontSize: 14, absolutePosition: { x: 0, y: 36 } },
                    { text: 'Methodologies & Assumptions', style: 'tabPageNumber', id: 'methodologies_and_assumptions_toc' },
                    { text: '\n' + CompInsights.Strings.COMP_INSIGHT_ICON_MSG_P1, fontSize: 11 },
                    { text: '\n' + CompInsights.Strings.COMP_INSIGHT_ICON_MSG_P2, fontSize: 11 },
                    { text: '\n' + CompInsights.Strings.COMP_INSIGHT_ICON_MSG_P3, fontSize: 11, margin: [0, 0, 0, 5] },
                    this.buildMethodologiesAssumptionsTableLayout(),
                    { text: '\n' + CompInsights.Strings.COMP_INSIGHT_METHODOLOGIES_MSG_P4, fontSize: 11 },
                    { text: '\n\n' + CompInsights.Strings.COMP_INSIGHT_METHODOLOGIES_MSG_P5, fontSize: 8 },
                    {
                        text: ['\n A product of ', {
                                text: 'SS&C Technologies',
                                color: '#337ab7',
                                decoration: 'underline',
                                fontSize: 10
                            }, ' Copyright ©2022. All rights reserved'], fontSize: 10
                    }
                ],
                margin: [20, 0, 10, 0]
            };
            return stackData;
        };
        ProductPage.prototype.buildMethodologiesAssumptionsTableLayout = function () {
            var methodologies = [{ text: CompInsights.Strings.OPPORTUNITY_SCORE_METRICS, fontSize: 10, color: 'green', bold: true, alignment: 'left' },
                { text: 'Weightings', fontSize: 10, color: 'green', bold: true, alignment: 'center' },
                { text: CompInsights.Strings.RISK_SCORE_METRICS, fontSize: 10, color: 'red', bold: true, alignment: 'left' },
                { text: 'Weightings', fontSize: 10, color: 'red', bold: true, alignment: 'center' }];
            var tableData = {
                table: {
                    headerRows: 0,
                    widths: [180, 70, 180, 70],
                    body: [methodologies]
                },
                layout: {
                    paddingTop: function () { return 5; },
                    paddingBottom: function () { return 5; }
                }
            };
            this.methodologiesTableData.forEach(function (row) {
                tableData.table.body.push([{ text: row[0], fontSize: 10, color: '#000', bold: false, alignment: 'left' },
                    { text: row[1], fontSize: 10, color: '#000', bold: false, alignment: 'center' },
                    { text: row[2], fontSize: 10, color: '#000', bold: false, alignment: 'left' },
                    { text: row[3], fontSize: 10, color: '#000', bold: false, alignment: 'center' }]);
            });
            return tableData;
        };
        ProductPage.prototype.getCurrentDate = function () {
            var date = new Date();
            var current_month = (date.getMonth() + 1).toString();
            var current_date = date.getDate().toString();
            current_month = current_month.length == 1 ? '0' + current_month : current_month;
            current_date = current_date.length == 1 ? '0' + current_date : current_date;
            return current_month + '/' + current_date + '/' + date.getFullYear();
        };
        ProductPage.prototype.getHexCodeValue = function (rgb) {
            if (rgb.search("rgb") == -1) {
                return rgb;
            }
            else if (rgb == 'rgba(0, 0, 0, 0)') {
                return 'transparent';
            }
            else {
                rgb = rgb.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+))?\)$/);
                return "#" + this.hexCode(rgb[1]) + this.hexCode(rgb[2]) + this.hexCode(rgb[3]);
            }
        };
        ProductPage.prototype.hexCode = function (x) {
            return ("0" + parseInt(x).toString(16)).slice(-2);
        };
        ProductPage.prototype.updateAnalyticsTabs = function () {
            if (this.currentAnalyticsTab === "ranking") {
                this.updateRankingTabHtml();
            }
            else if (this.currentAnalyticsTab === "trends") {
                this.updateSalesTrendsTabHtml();
            }
            else if (this.currentAnalyticsTab === "drivers") {
                this.updateKeySalesDriversTabHtml();
            }
            else if (this.currentAnalyticsTab === "platform") {
                this.updatePlatformTabHtml();
            }
            else if (this.currentAnalyticsTab === "scatterplot") {
                this.updateScatterplotTabHtml();
            }
            else if (this.currentAnalyticsTab === "analytics") {
                this.updateAnalyticsTabHtml();
            }
            else if (this.currentAnalyticsTab === "opportunities") {
                this.updateOpportunitiesTabHtml();
            }
        };
        ProductPage.prototype.initializeAnalyticsTabsEvents = function () {
            var _this = this;
            jQuery("#ranking").click(function () {
                _this.changeAnalyticsTab("ranking");
            });
            jQuery("#trends").click(function () {
                _this.changeAnalyticsTab("trends");
            });
            jQuery("#drivers").click(function () {
                _this.changeAnalyticsTab("drivers");
            });
            jQuery("#whatif").click(function () {
                _this.changeAnalyticsTab("whatif");
            });
            jQuery("#platform").click(function () {
                _this.changeAnalyticsTab("platform");
            });
            jQuery("#opportunities").click(function () {
                _this.changeAnalyticsTab("opportunities");
            });
            jQuery("#analytics").click(function () {
                _this.changeAnalyticsTab("analytics");
            });
            jQuery("#scatterplot").click(function () {
                _this.changeAnalyticsTab("scatterplot");
            });
        };
        ProductPage.prototype.changeAnalyticsTab = function (tabId) {
            this.currentAnalyticsTab = tabId;
            jQuery(".comp-insights-topnav .active-tab-header").parent('div').parent('div').removeClass('active-tab');
            jQuery(".comp-insights-topnav .active-tab-header").parent('div').siblings('div').removeClass('active-header');
            for (var i = 0; i < this.tabDataList.length; i++) {
                if (this.tabDataList[i].tabId === this.currentAnalyticsTab) {
                    jQuery("#" + this.currentAnalyticsTab).attr("class", "active-tab-header");
                    if (this.tabDataList[i].updated === false) {
                        this.updateAnalyticsTabs();
                        this.tabDataList[i].updated = true;
                    }
                    jQuery("#" + this.currentAnalyticsTab + "Tab").show();
                }
                else {
                    jQuery("#" + this.tabDataList[i].tabId).attr("class", "inactive-tab-header");
                    jQuery("#" + this.tabDataList[i].tabId + "Tab").hide();
                }
            }
            jQuery(".comp-insights-topnav .active-tab-header").parent('div').parent('div').addClass('active-tab');
            jQuery(".comp-insights-topnav .active-tab-header").parent('div').siblings('div').addClass('active-header');
        };
        ProductPage.prototype.hideShowAnalyticsTabs = function (bShow) {
            if (bShow) {
                jQuery("#analyticsTabs").show();
            }
            else {
                jQuery("#analyticsTabs").hide();
            }
        };
        return ProductPage;
    }());
    CompInsights.ProductPage = ProductPage;
})(CompInsights || (CompInsights = {}));
$(document).ready(function () {
    var wrapper = $(".comp-insights-outer-wrapper");
    if (wrapper.isEmpty()) {
        return;
    }
    new CompInsights.ProductPage(wrapper);
});
(function (pocWrapper) {
    if (pocWrapper.isEmpty()) {
        return;
    }
})($('.poc'));
